export const TranslateDB = {
  "bg": {
    "ab-test": {
      "campaign-30": {
        "button-text-a": "Първи стъпки",
        "button-text-b": "Първи стъпки"
      }
    },
    "anti-bribery": {
      "definitions": {
        "associated-person-employees": "<b>Свързани лица</b> — служители, доставчици, посредници, физически лица или организации, предоставящи услуги от името на Noda.",
        "bribe-a-financial": "<b>Подкуп</b> — финансова или друга облага за подтикване към действие, което е неправомерно, незаконно или е в нарушение на установеното доверие.",
        "bribery-the-offering": "<b>Подкупничество</b>  — предлагането, обещаването, даването, получаването или искането на финансова или друга облага като подтик към действие, което е неправомерно, незаконно или е в нарушение на установеното доверие.",
        "title": "Определения"
      },
      "employee-responsibilities": {
        "act-with-integrity": "да постъпват почтено и осъществяват бизнес начинанията си по честен, справедлив и прозрачен начин;",
        "all-nodas-employees": "Всички служители на Noda трябва:",
        "avoid-using-their": "да избягват да използват позицията си в компанията за обслужване на собствени или чужди лични интереси, включително такива на роднини; и",
        "comply-with-nodas": "да спазват изискванията на АВС декларацията на Noda;",
        "implement-appropriate-due": "да спазват надлежните процедури при подбора на доставчици, бизнес партньори или посредници с цел смекчаване на рисковете от подкупничество и да гарантират познаването на изискванията на Закона срещу подкупите на Обединеното кралство от 2010 г.;",
        "refuse-to-engage": "да отказват съвместна работа с физически или юридически лица, които не спазват принципите на Noda и биха могли да уронят репутацията на компанията;",
        "report-any-instances": "да докладват на правния отдел на Noda за всеки случай, в който им е предложена финансова или друга облага, която може да представлява подкуп, или ако считат, че са получили подарък или почерпка, излизащи извън допустимите норми;",
        "report-to-noda": "да докладват на правния отдел на Noda за всеки случай, в който колега е получил финансова или друга облага, за която не е съобщил по реда, определен в ABC декларацията;",
        "title": "Отговорности на служителите",
        "uphold-nodas-principles": "да се ръководят от принципите на Noda дори в трудни ситуации."
      },
      "key-prohibitions": {
        "bribing-a-public": "2. Изрично се забранява подкупването на държавни служители в която и да е страна. Това включва: ",
        "engaging-in-bribery": "1. Изрично се забранява участието в подкупничество, било то пряко или чрез трето лице. Подкупничество означава:",
        "facilitation-payments-are": "3. Забраняват се стимулиращи плащания, освен в случаи на действителен риск за здравето или живота.",
        "in-order-to": "с цел придобиване или задържане на бизнес възможности или друго предимство в бизнеса.",
        "offering-promising": "предлагане, обещаване или предоставяне, както и изискване, поискване или приемане на ценни вещи или други облаги;",
        "offering-promising-or": "предлагане, обещаване или предоставяне на ценни вещи или други облаги;",
        "political-donations-and": "4. Забраняват се политически дарения или лобиране.",
        "the-key-areas": "Нашата ABC декларация обхваща следните основни теми:",
        "title": "Основни забрани и изисквания",
        "to-improperly-influence": "за оказване на неправомерно влияние върху бизнес решение или всякакво друго действие, бездействие или решение от страна на дадено лице.",
        "to-influence-a": "за оказване на влияние върху държавен служител в изпълнение на служебните му задължения;"
      },
      "last-update-at": "Последна редакция: 1 юни 2024 г.",
      "noda-is-dedicated": "В Noda сме отдадени на превенцията на подкупничеството и корупцията, като проявяваме нулева толерантност към действия, противоречащи на приложимите закони срещу подкупите и корупцията, както в Обединеното кралство, така и в глобален мащаб. Този ангажимент включва спазването на нормативни актове като Закона срещу подкупите на Обединеното кралство от 2010 г. и приложимите закони в други юрисдикции, в които осъществяваме дейността си.",
      "principles": {
        "by-any-individual": "от който и да е служител, посредник или друго свързано лице или дружество, действащо от името на Noda;",
        "facilitation-payments-will": "6. Стимулиращи плащания няма да бъдат приемани дори такива да се считат за обичайна практика в дадена страна.",
        "in-any-form": "под каквато и да е форма, включително подаръци или развлечения, предоставени на съпруга/та или други роднини на компетентното лице;",
        "in-order-to-gain-commercial": "целящи придобиване на търговско, договорно или нормативно предимство за Noda по начин, който е неетичен; или",
        "in-order-to-gain-personal": "целящи придобиване на лично предимство, било то парично или друго, за съответното лице или друго, свързано с него лице.",
        "noda-is-dedicated": "1. В Noda се ангажираме да осъществяваме дейността си отговорно, независимо от нейното местоположението или замесени страни. Ние поставяме етичните и прозрачни практики на първо място, като неизменно действаме с почтеност във всички обстоятелства.",
        "noda-maintains-a": "2. Noda води политика на нулева толерантност по отношение на подкупите и корупцията. Ние категорично се въздържаме от предлагане, обещаване, плащане, искане или приемане на подкупи, било то пряко или чрез трети лица, като начин за придобиване на нови бизнес възможности, запазване на текущите такива или спечелване на всякакъв вид бизнес предимство.",
        "noda-strictly-prohibits": "5. Noda строго забранява предлагането, даването, искането или приемането на каквато и да е форма на подкуп, независимо дали паричен или:",
        "noda-will-not": "7. Noda няма пряко или косвено да подкрепя никоя политическа партия.",
        "title": "Принципи за борба с подкупите и корупцията",
        "to-or-from-any": "за или от физическо или юридическо лице, незасимо дали държавен служител, или орган, частно лице, или дружество и независимо от неговото местоположение;",
        "under-the-law": "4. Съгласно закона действия по отношение на подкупи и корупция могат да бъдат извършени от различни лица, свързани с Noda, в това число служители, упълномощени представители, директори, физически лица, действащи от името на Noda, както и всяко друго физическо лице или организация, упълномощени да действат от тяхно име.",
        "we-mandate-that": "3. Задължаваме всички служители и свързани лица да спазват изцяло всички приложими закони срещу подкупите, включително Закона срещу подкупите на Обедиеното кралство от 2010 г. (Закона срещу подкупите), както и да се придържат към професионалните регламенти, приложими за нашата дейност."
      },
      "steps-taken": {
        "accurate-records": {
          "text": "За множество тежки нарушения, свързани с подкупи и корупция, се установява, че произтичат от неправилно съхранение на информация. Затова е изключително важно да поддържаме точни архиви, документация и финансови отчети в рамките на Noda. Всякакви грешни, подвеждащи или неточни данни в тях могат да представляват сериозен риск за репутацията и авторитета на Noda.",
          "title": "2. Точност в счетоводните и други архиви"
        },
        "compliance-statement": "Тази „Декларацията за борба с подкупите и корупцията“ е изготвена в съответствие със задълженията на Noda съгласно Закона за борба с подкупите на Обединеното кралство от 2010 г.",
        "internal-control": {
          "text": "Noda поддържа ефективна система за вътрешен контрол и проследяване на трансакциите. След като чрез процедурата за оценка на риска се установят и отбележат рискове, свързани с подкупи и корупция, се разработват протоколи като елемент от цялостна програма за контрол и проследяване за непрестанно смекчаване на тези рискове.",
          "title": "3. Ефективно проследяване и вътрешен контрол"
        },
        "noda-implements": "Noda прилага следните мерки за предотвратяване на подкупите и корупцията:",
        "risk-assessment": {
          "text": "Ефективната оценка на риска е от основно значение за успешното изпълнение на нашата Декларация за борба с подкупите и корупцията (ABC декларация). Разпознаването на рисковете ни помага да набележим конкретни области, в които е възможно да се сблъскаме с рискове по отношение на подкупи и корупция. Това на свой ред спомага тези рискове да бъдат ефективно преценяваии смекчавани и съответно осигурява защита на Noda.",
          "title": "1. Оценка на риска"
        },
        "title": "Предприети стъпки за предотвратяване на подкупите или корупцията"
      },
      "subtitle": "Предназначение на декларацията",
      "the-anti-bribery": "Декларацията за борба с подкупите и корупцията („ABC декларация“) предоставя изчерпателни насоки за предотвратяване на подкупничеството и докладването на опасения и подозрителни действия.",
      "title": "Декларация за борба с подкупите и корупцията"
    },
    "articles": {
      "back-to-articles": "Назад към Статии",
      "case-info": {
        "payer-location": "Местоположение на платеца",
        "product-used": "Използван продукт"
      },
      "defaultBanner": {
        "buttonText": "Резервирайте демо",
        "text": "Предложете на потребителите си по-лесен и евтин начин за плащане и увеличете реализациите!",
        "title": "Научете повече за отвореното банкиране с Noda"
      },
      "defaultBannerHero": {
        "buttonText": "Резервирайте демо",
        "text": "Добавете 2000+ банки за незабавни плащания и изплащания и мащабирайте глобално с лекота!",
        "title": "Приемайте онлайн плащания с Noda"
      },
      "main": {
        "banner": {
          "button": "Започнете да използвате Noda",
          "text": "Нашите продукти правят използването на плащанията по-лесно, по-бързо и по-достъпно",
          "title": "Надеждно решение за плащане за вашия бизнес"
        },
        "title": "Статии"
      },
      "single-article": {
        "tables-banner": {
          "button": "Опитайте Noda",
          "title": "Опитайте Noda — напълно нов начин за приемане на плащания онлайн"
        }
      }
    },
    "bank-payouts": {
      "control-data": {
        "items": {
          "item-1": {
            "text-1": "Noda работи в тясно сътрудничество с търговци и банки, за да разбере специфичните за отрасъла трудности, свързани с паричните потоци C2B и B2C. Това ни позволява да предоставим цялостно решение, съобразено с вашите бизнес нужди.",
            "title-1": "Разбиране на предизвикателствата пред отрасъла"
          },
          "item-2": {
            "text-2": "С богат опит в областта на отвореното банкиране в ЕС и Обединеното кралство, Noda създава първокласни решения за банкови плащания, съобразени с уникалните нужди на вашите клиенти.",
            "title-2": "Експертен опит в областта на банкирането"
          }
        },
        "text": "Правете безпроблемни плащания с Noda. Плащайте лесно на своите партньори, доставчици и потребители на платформата, като използвате нашите модерни технологии и експертен опит",
        "title": "Пълен контрол върху вашите B2C плащания"
      },
      "netting-data": {
        "items": {
          "text-1": "Нетирането на баланса гарантира плавно прехвърляне на средства без забавяния и помага за поддържане на стабилен паричен поток за вашия бизнес",
          "text-2": "Използвайте съществуващия баланс за изплащане на средства, като премахнете необходимостта от допълнителни банкови преводи и допълнителни разходи",
          "title-1": "Избягвайте недостига на парични средства",
          "title-2": "Ефективност на разходите"
        },
        "subtitle": "Нетиране на баланса",
        "text": "Управлявайте безпроблемно баланса си за плащане, като използвате средствата за плащане. Възползвайте се от този рентабилен метод на плащане и незабавната наличност на средствата",
        "title": "Използвайте баланса си за плащане, за да извършвате плащания"
      },
      "payments-data": {
        "balance": "Текущ баланс",
        "text": "Бързи и удобни банкови плащания за търговци",
        "title": "Банкови плащания",
        "title-colored": "за транзакции чрез Swift"
      },
      "recipient-data": {
        "subtitle": "Удовлетворяващ опит",
        "text": "Опциите за банково плащане на Noda предлагат безплатно получаване на средства за физически лица, за разлика от някои системи за карти и портфейли, които могат да начисляват такси за същата услуга. Това предимство се дължи на задължението на банките да предоставят безплатни междубанкови преводи за своите клиенти",
        "title": "Безплатно за получателя"
      },
      "routing-data": {
        "items": {
          "item-1": {
            "text-1": "С ефективното маршрутизиране на Noda вашите средства ще достигнат до местоназначението си със светкавична скорост",
            "title-1": "Доставка на средства по SWIFT"
          },
          "item-2": {
            "text-2": "Намалете до минимум допълнителните банкови преводи и свързаните с тях такси с нашето усъвършенствано маршрутизиране на плащанията",
            "title-2": "Намалени разходи"
          }
        },
        "text": "Оптимизираме доставката на средства, за да гарантираме максимална бързина и ефективност на разходите, като избягваме неефективни банкови маршрути",
        "title": "Маршрутизиране"
      },
      "single-report-data": {
        "subtitle": "Пари със скоростта на светлината",
        "text": "Забравете за забавените плащания. Използваме схемите за незабавни плащания FPS и SEPA, за да превеждаме пари на получателите ви в реално време",
        "title": "Незабавна доставка на средствата"
      },
      "title": "Безпроблемно плащайте на доставчици, притежатели на портфейли, стриймъри и други. Банковите плащания от бизнеса към клиента (B2C) на Noda опростяват масовите плащания на физически лица, като осигуряват бързи и лесни транзакции."
    },
    "bank-sign": {
      "hero": "Клиентите ви могат да влизат във вашия уеб сайт или приложение лесно, като използват банковата си сметка. Нашата модерна технология използва важна банкова информация, осигурявайки безпроблемно и сигурно влизане за вашите клиенти",
      "payments-data": {
        "text": "Сигурно влизане с едно кликване с идентификационните данни на банката",
        "title": "Влизане чрез банка"
      },
      "payouts-data": {
        "items": {
          "item-1": {
            "text-1": "С избора си да влязат чрез банкова сметка клиентите ви дават съгласието си Noda да има достъп до техните данни. Това гарантира, че информацията, която получавате при влизане в системата, е надеждна и проверена, което осигурява допълнителна прозрачност.",
            "title-1": "Най-надеждни данни"
          },
          "item-2": {
            "text-2": "Когато използват своите банкови данни за влизане, клиентите ви ползват познатия интерфейс на тяхното надеждно банково приложение или уебсайт. Това елиминира риска от загуба на клиенти поради трудности при регистрацията",
            "title-2": "Интуитивен потребителски интерфейс"
          }
        },
        "text": "Клиентите ви се съгласяват да се свържат чрез банковото си приложение или уеб интерфейс. Нашите интеграции се придържат към най-високите стандарти за сигурност и съответствие при банкиране",
        "title": "Бързо и надеждно"
      },
      "recipient-data": {
        "subtitle": "Разширено привличане на клиенти",
        "text": "Безпроблемното влизане и първоначалното плащане превръщат потребителите в клиенти само с няколко кликвания. Няма нужда от ръчно въвеждане на данни - цялата необходима информация и разрешението за плащане ще бъдат получени по сигурен начин, тъй като клиентите дават съответното съгласие",
        "title": "Pay & Go"
      },
      "risk-data": {
        "items": {
          "item-1": {
            "text-1": "Защитата на средствата е предизвикателна задача, а банковата индустрия е известна със строгите си стандарти за сигурност. Ето защо функцията за влизане чрез банка предлага на вашия бизнес най-добрите мерки за сигурност за защита на клиентите.",
            "title-1": "Надеждна сигурност"
          },
          "item-2": {
            "text-2": "Благодарение на тази функция клиентът ви никога няма да забрави данните си за вход, тъй като достъпът му до парите му е винаги защитен. Това гарантира, че няма да загубите клиенти поради проблеми с влизането в акаунта",
            "title-2": "Свързаност с клиента"
          }
        },
        "text": "Възможността за неоторизиран достъп до банковата сметка е почти нулева поради строгата защита и последващото наказателно преследване. В малко вероятния случай на кражба клиентът научава за атаката незабавно и реагира бързо.",
        "title": "Минимален риск от кражба на сметка"
      },
      "single-report-data": {
        "subtitle": "Пълно придържане към регулаторните стандарти",
        "text": "С банковите данни, събрани чрез Noda, можете законно да изпълните повечето от изискванията и политиките за мониторинг, внедряване и идентификация",
        "title": "Данни, съобразени със законодателството"
      },
      "title-1": "Сигурно",
      "title-2": "Вход чрез банка"
    },
    "banking": {
      "banking": "Банков опит",
      "banks-count": "2000+ банки",
      "c2b": "C2B сметка",
      "easy-onboarding-1": "Лесно внедряване",
      "easy-onboarding-2": "С личен мениджър",
      "experience": "Насладете се на безпроблемни транзакции с нашата авангардна услуга за отворено банкиране, свързваща бизнеса ви с всички големи банки в Обединеното кралство и ЕС",
      "experience-data": {
        "easy-to-apply": {
          "text": "Гъвкаво решение за събиране на средства, с възможност да използвате нашата банкова сметка Noda C2B или да изберете от нашата мрежа от доверени банкови партньори",
          "title": "Лесно прилагане"
        },
        "enhance-customer-experience": {
          "text": "Наслаждавайте се на събиране на вземания с ниски или нулеви такси с множество възможности, предоставяни чрез нашата банкова мрежа\n",
          "title": "Подобряване на опита на клиентите"
        }
      },
      "features-to-integrations": "от функции до интеграции",
      "first-steps": "ПЪРВИ СТЪПКИ",
      "hero": "Подобрете опита на клиентите и улеснете потока на транзакциите със силата и сигурността на нашата платформа за отворено банкиране",
      "hero-title-1": "Отворено банкиране",
      "hero-title-2": "с Noda",
      "how-data": {
        "authorise-the-transaction": {
          "text": "От предефиниране на бъдещето с иновативни стартъпи до трансформиране на нашия свят с емблематични марки, Noda подпомага хиляди бизнеси",
          "title": "Потвърдете транзакцията"
        },
        "choose-your-bank": {
          "text": "Изберете от селекция основни банки във вашата област",
          "title": "Изберете вашата банка"
        },
        "payment-is-done": {
          "text": "Нода е движещата сила зад безпроблемните транзакции за хиляди фирми, от авангардни стартъпи до лидери в индустрията",
          "title": "Плащането е извършено"
        },
        "sign-into-your-account": {
          "text": "Noda задвижва хиляди бизнеси с голямо въздействие, от стартъпи от следващо поколение до водещи марки, които променят света",
          "title": "Влезте в сметката си"
        }
      },
      "hub-data": {
        "1": {
          "text": "Лесна и ефективна обработка при възстановявания на средства",
          "title": "Възстановяване на средства"
        },
        "2": {
          "text": "Множество потребителски роли за по-добро управление",
          "title": "Множество роли"
        },
        "3": {
          "text": "Сигурно, бързо и ефективно управление на транзакциите",
          "title": "Транзакции"
        },
        "4": {
          "text": "Подробно финансово отчитане с възможност за персонализиране",
          "title": "Докладване"
        }
      },
      "hub-description": "С Noda Hub можете без усилие да се включите, да конфигурирате предпочитанията си за транзакции, да наблюдавате транзакциите и отчетите и да анализирате трафика на плащанията в рамките на една платформа",
      "info-data": {
        "subtitle": "Характеристики и интеграции",
        "text": "Дайте възможност на клиентите си сигурно да се удостоверяват и да плащат във вашата екосистема с безпроблемна пълна интеграция",
        "title": "Как работи нашето решение за отворено банкиране"
      },
      "manage-everything": "Управлявайте всичко необходимо на едно място",
      "management": "Управление",
      "manager-guidance": "Насладете се на лесно интегриране с процеса на насочване на Noda Hub и получете персонализирана поддръжка от вашия специален мениджър",
      "manager-help": "Сбогувайте се с трудностите при самостоятелното интегриране - вашият личен мениджър е тук, за да ви помогне, ако срещнете пречки.",
      "payments-data": {
        "text": "Бързи, сигурни и регулирани банкови преводи",
        "title": "Плащания с отворено банкиране"
      },
      "payments-feature-description": "Оптимизирайте плащанията си с функцията Trusted Payments на Noda, която осигурява транзакции с доверени платци още преди средствата да пристигнат.",
      "special-features": "Специални функции",
      "trusted-payments-1": "Доверени плащания",
      "trusted-payments-2": "за ускоряване на поръчката"
    },
    "banner": {
      "text1": "Стабилен растеж или бърза трансформация?",
      "text2": "Усещате кога е време да издигнете бизнеса си на по-високо ниво.",
      "title": "Свеж поглед върху плащанията – прегледайте всички продукти на Noda"
    },
    "block-with-screen": {
      "detailed-and-customizable": "Подробно и персонализирано финансово отчитане",
      "easy-and-efficient": "Лесна и ефективна обработка на възстановяването",
      "multi-roles": "Множество роли",
      "multiple-user": "Множество потребителски роли за по-добър контрол",
      "refunds": "Възстановявания",
      "reporting": "Докладване",
      "reporting-v2": {
        "subtitle": "пълна прозрачност",
        "text": "С помощта на нашия административен център можете да проследявате всички комисиони, като осигурявате ясна и прозрачна отчетност. Безпроблемно контролирайте изплащанията и изплащанията, като получавате пълна видимост и управлявате операциите си с лекота.",
        "title": "Подробен мониторинг и отчитане"
      },
      "secure-fast": "Сигурно, бързо и ефективно управление на транзакциите",
      "tagTitle": "РАЗВИТЕ ВАШИЯ БИЗНЕС С NODA",
      "text": "С помощта на Noda Hub можете безпроблемно да се присъединявате, да конфигурирате транзакционни предпочитания, да наблюдавате транзакциите и отчетите и да анализирате трафика на плащанията - всичко това в рамките на една платформа.",
      "title": " — Управление на всичко необходимо на едно място",
      "transactions": "Транзакции"
    },
    "card-payments": {
      "active-subscriptions-title": "Активни абонаменти",
      "available-funds": {
        "pending": "В процес на обработка: €35,00",
        "title": "Налични средства"
      },
      "controls": {
        "desktop": "Настолен",
        "diff-user": "Различен потребител",
        "uk": {
          "text-1": "Обединеното кралство",
          "text-2": "Лондон"
        }
      },
      "hero-data": "Насладете се на безпроблемни и безстресови плащания с карти с авангардната технология на Noda и интелигентното маршрутизиране",
      "hood-data": {
        "text-1": "Noda гарантира, че плащанията по вашите онлайн карти се обработват ефективно и надеждно, като оптимизираното маршрутизиране се основава на географското местоположение, вида карта и други фактори",
        "text-2": "Увеличете приходите и реализациите си с внимателно разработения процес на плащане на Noda, който намалява проблемите и опростява плащанията за клиентите",
        "text-3": "Сбогувайте се с прекомерните разходи за картови плащания - интелигентното маршрутизиране на Noda ви гарантира, че винаги получавате най-добрата сделка",
        "text-4": "След като събира и внимателно анализира данните на клиентите, моделът с изкуствен интелект на Noda предвижда потенциални нива на риск в реално време и блокира подозрителни трансакции, като намалява броя на обратните плащания и измамите, без да прави компромис с процента на оторизация",
        "title-1": "Интелигентно маршрутизиране",
        "title-2": "Увеличете максимално реализациите",
        "title-3": "Оптимизирайте разходите",
        "title-4": "Прогнозиране на риска чрез модел на изкуствен интелект"
      },
      "how-data": {
        "items": {
          "text-1": "Мощният, управляван от изкуствен интелект модел за анализ на риска на Noda оценява над 50 параметъра, за да осигури по-интелигентни и по-безопасни решения за плащане с карта, гарантирайки вашето спокойствие",
          "text-2": "След внимателен анализ на плащането и събиране на необходимите данни, базираният на изкуствен интелект модел на Noda прогнозира потенциалните нива на риск в реално време",
          "text-3": "Устойчивият, управляван от изкуствен интелект модел за анализ на риска на Noda работи в тандем с нашия екип от специалисти, за да оцени над 50 параметъра и да предостави по-интелигентни и по-безопасни решения за плащане с карта, гарантирайки високи нива на транзакции",
          "title-1": "Наблюдение",
          "title-2": "Оценка на риска",
          "title-3": "Разрешение за плащане"
        }
      },
      "info-data": {
        "subtitle": "Безопасността на първо място",
        "text": "Защитете бизнеса и клиентите си с нашите базирани на изкуствен интелект възможности за оценка на риска и динамични реакции за сигурни и надеждни плащания с карти",
        "title": "Оценка на риска и реакция"
      },
      "key-features": {
        "text": "Подобрете обработката на картови плащания с технологията на Noda за маршрутизиране и възстановяване на приемане, задвижвана от изкуствен интелект. Нашият усъвършенстван софтуер анализира транзакциите, насочва ги към идеалната приемаща банка и подобрява процента на приетите плащания с карта",
        "title": "Интелигентно маршрутизиране и възстановяване на приемането с изкуствен интелект"
      },
      "monetization": {
        "subtitle": "Непрекъснато осигуряване на приходи",
        "text": "Приемайте плащания с карта автоматично на редовни интервали, като например месечно или годишно, без всеки път да въвеждате информацията",
        "title-1": "Пълна поддръжка на ",
        "title-2": "периодични плащания"
      },
      "payments-data": {
        "icon": "header/product-payments.svg",
        "text": "Безпроблемни плащания с карти за търговци",
        "title": "Плащания с карти"
      },
      "preference-data-1": {
        "data": {
          "items": {
            "text-1": "Плащането се оторизира незабавно в една комуникация между обслужващия и излъчващия сървър, като средствата се отписват незабавно от сметката на клиента. Този метод е по-бърз и осигурява по-опростено плащане, но може да е по-податлив на измама",
            "text-2": "Плащането се оторизира в първата комуникация между сървърите и се таксува във втората. Парите на клиента се запазват в картата му и се удържат едва след втората комуникация. Макар че този процес на плащане в две стъпки е по-сигурен, той може да доведе до по-дълъг период за плащане",
            "title-1": "Една стъпка на обработка",
            "title-2": "Две стъпки на обработка"
          }
        },
        "subtitle": "Задайте предпочитанията си",
        "text": "Утвърденият опит на Noda в областта на плащанията с карти предлага както системи с един, така и системи с две стъпки на обработка, за да отговори на вашите бизнес нужди",
        "title": "Незабавни и отложени плащания"
      },
      "preference-data-2": {
        "data": {
          "items": {
            "text-1": "Защитете бизнеса си чрез токенизация, която осигурява по-висока сигурност и ограничава риска от нарушаване на сигурността на данните и измами, като същевременно улеснява работата на клиентите.",
            "text-2": "Позволете на клиентите си да съхраняват и управляват данните за картата си сигурно, опростявайки бъдещите транзакции, без да е необходимо отново да въвеждат информацията",
            "title-1": "Токенизация",
            "title-2": "Управление на картите"
          }
        },
        "text": "Рационализирането на повтарящите се плащания е в центъра на вниманието на Noda за улесняване на транзакциите",
        "title": "По-бързо плащане с едно кликване"
      },
      "refunds-data": {
        "subtitle": "Поддръжка след покупка",
        "text": "Подобрете опита на клиентите си с безпроблемно възстановяване на средства както чрез API, така и чрез потребителския интерфейс",
        "title": "Лесно възстановяване на средства"
      },
      "single-report-data": {
        "subtitle": "Знания, базирани на данни",
        "text": "Проследявайте и наблюдавайте трафика на плащанията, анализирайте моделите на плащане и генерирайте изчерпателна хронология на плащанията и отчети за ефективността в рамките на едно табло за управление",
        "title": "Единна система за отчитане"
      },
      "subscription-data": {
        "date-1": "Срок 27 септември",
        "date-2": "Срок 23 октомври",
        "date-3": "Срок 31 декември",
        "title-1": "Netflix",
        "title-2": "Music Premium",
        "title-3": "Приложение за библиотека"
      },
      "title-1": "за Вашите",
      "title-2": "Бизнес нужди"
    },
    "card-payouts": {
      "card-payouts-title": {
        "1": "Плащания с карта:",
        "2": "за ефективни транзакции"
      },
      "hero-data": "Безпроблемно нареждане на плащанията към доставчици, собственици на портфейли или стриймъри - нашите лесни и бързи плащания с карти",
      "netting-data": {
        "list": {
          "1": "Оптимизиран процес на сетълмент",
          "2": "Светкавична доставка",
          "3": "Маршрутизиране на трансфери, управлявано от AI"
        },
        "subtitle": "Нетиране на баланса",
        "text": "Насладете се на светкавични плащания с карти чрез нашите глобални и локализирани маршрути за плащания с карти, като доставяте средства на бенефициентите си в реално време",
        "title": "Незабавна доставка на средствата"
      },
      "payments-data": {
        "text": "Безпроблемни плащания с карти за търговците",
        "title": "Картови плащания"
      },
      "payouts-data": {
        "items": {
          "credit": {
            "text": "Благодарение на огромния опит на Noda в глобалната индустрия за картови разплащания, ние предлагаме най-съвременни решения за плащане с карти, съобразени с вашите бизнес нужди.",
            "title": "Експертиза в областта на плащанията"
          },
          "group": {
            "text": "В Noda си сътрудничим с търговци и приемащи плащания компании, за да разберем специфичните за отрасъла сложности в паричните потоци B2C и C2B.",
            "title": "Разбиране на предизвикателствата пред отрасъла"
          }
        },
        "text": "Оптимизирайте масовите плащания към физически лица с Noda. Плащайте лесно на доставчиците си, потребители на платформата и др.",
        "title": "По-бързи B2C плащания с карти с Noda"
      },
      "routing-data": {
        "items": {
          "airline": {
            "text": "С ефективното маршрутизиране на Noda вашите средства ще достигнат до местоназначението си със светкавична скорост",
            "title": "Доставка на средства по SWIFT"
          },
          "map": {
            "text": "Намалете до минимум допълнителните банкови преводи и свързаните с тях такси с нашето усъвършенствано маршрутизиране на плащанията",
            "title": "Намалени разходи"
          }
        },
        "text": "Оптимизираме доставката на средства, за да гарантираме максимална бързина и ефективност на разходите, като избягваме неефективни банкови маршрути",
        "title": "Маршрутизиране"
      },
      "transfers-data": {
        "items": {
          "approval": {
            "text": "Нетирането на баланса гарантира плавно прехвърляне на средства без забавяния и помага за поддържане на стабилен паричен поток за вашия бизнес",
            "title": "Избягвайте недостиг на парични средства"
          },
          "wallet": {
            "text": "Използвайте съществуващия баланс за изплащане на средства, като премахнете необходимостта от допълнителни банкови преводи и допълнителни разходи",
            "title": "Ефективност на разходите"
          }
        },
        "subtitle": "Избягвайте допълнителните трансфери",
        "text": "Управлявайте баланса си безпроблемно, като използвате средствата за плащане. Възползвайте се от този рентабилен метод на плащане и незабавната наличност на средствата",
        "title": "Използвайте баланса си за плащане, за да извършвате плащания"
      }
    },
    "checkout": {
      "ai-routing": {
        "text": "Подобрете обработката на картови плащания с технологията на Noda за маршрутизиране и възстановяване на приемане, задвижвана от изкуствен интелект. Нашият усъвършенстван софтуер анализира транзакциите, насочва ги към идеалната приемаща банка и повишава степента на приемане на плащанията с карти",
        "title": "Интелигентно маршрутизиране и възстановяване на приемането с изкуствен интелект"
      },
      "checkout-hero-title": {
        "colored": "Плащане",
        "default": "Безпроблемно"
      },
      "convenience": {
        "text": "Рационализирането на повтарящите се плащания е приоритет за Noda, осигурявайки безпроблемни транзакции. Клиентите могат да съхраняват и управляват данните за своите карти сигурно, опростявайки бъдещите транзакции, без да е необходимо да въвеждат отново информацията",
        "title": "По-бързо плащане с плащания с едно кликване",
        "title-1": "Удобство преди всичко"
      },
      "experience-list": {
        "brush": {
          "text": "Персонализирайте интерфейса си за плащане, за да съответства на вашата уникална марка, цвят и дизайн",
          "title": "Персонализиране на потребителския интерфейс"
        },
        "task": {
          "text": "По-бързо и безпроблемно извършване на онлайн плащания с ясни указания и лесни за разбиране насоки",
          "title": "Интуитивен потребителски интерфейс"
        }
      },
      "hero": "Отключете силата на безпроблемните плащания с лесния за използване интерфейс на Noda Checkout и изчерпателния набор от функции за плащане",
      "hood-data": {
        "amount": "Сума",
        "bank": "Банка",
        "card-issuer": "Издател на картата",
        "card-type": "Вид на картата",
        "country": "Държава",
        "currency": "Валута",
        "date-time": "Дата и час",
        "geolocation": "Геолокация",
        "metadata": "Метаданни",
        "store": "Магазин"
      },
      "how-data": {
        "observation": {
          "text": "Мощният, управляван от изкуствен интелект модел за анализ на риска на Noda оценява над 50 параметъра, за да осигури по-интелигентни и по-безопасни решения за плащане с карта, гарантирайки вашето спокойствие",
          "title": "Наблюдение"
        },
        "payment-resolution": {
          "text": "Устойчивият, управляван от изкуствен интелект модел за анализ на риска на Noda работи в тандем с нашия екип от специалисти, за да оцени над 50 параметъра и да предостави по-интелигентни и по-безопасни решения за плащане с карта, гарантирайки високи нива на транзакции",
          "title": "Разрешение за плащане"
        },
        "risk-estimation": {
          "text": "След внимателен анализ на плащането и събиране на необходимите данни, базираният на изкуствен интелект модел на Noda прогнозира потенциалните нива на риск в реално време",
          "title": "Оценка на риска"
        }
      },
      "info-data": {
        "subtitle": "Безопасността на първо място",
        "text": "Защитете бизнеса и клиентите си с нашите задвижвани от изкуствен интелект възможности за оценка на риска и динамични реакции за безопасни и надеждни плащания с карти",
        "title": "Оценка на риска и реакция"
      },
      "localised-checkout": {
        "text": "Осигурете персонализирано изживяване при плащане за вашите клиенти в световен мащаб. Noda предлага усъвършенствана локализация на 10 езика, съвместимост с различни устройства и методи за плащане, оптимизирани за конкретни региони",
        "title": "Локализирано плащане в световен мащаб"
      },
      "localization-list": {
        "chart": {
          "text": "Noda надхвърля обикновената езикова адаптация, като адаптира методите на плащане и прилага най-добрите местни практики за всяка държава",
          "title": "Прецизна локализация"
        },
        "mobile": {
          "text": "Подобрете клиентския опит чрез оптимизиран процес на плащане, който може да се адаптира към всяко устройство и софтуер",
          "title": "На различни екрани и платформи"
        }
      },
      "payment-methods": {
        "text": "Независимо дали става въпрос за банкови преводи, кредитни и дебитни карти или мобилни портфейли, Noda предлага всичко. С десетки интегрирани методи на плащане търговците могат да оптимизират своите платежни потоци и да предложат на клиентите гъвкавостта, от която се нуждаят, за да завършат покупките си",
        "title": "Неограничени методи на плащане"
      },
      "payments-data": {
        "text": "Оптимизирано изживяване при плащане за клиентите",
        "title": "Формуляр за разплащателна операция"
      },
      "personal-touch": {
        "text": "Noda интелигентно прогнозира и запомня оптималния поток на плащане на всеки клиент, включително предпочитания от него метод на плащане, и позволява безпроблемни и лесни покупки за клиентите",
        "title": "Удовлетворява нуждите на всички ваши клиенти",
        "title-1": "Личен досег"
      },
      "refunds-data": {
        "subtitle": "Поддръжка след покупката",
        "text": "Подобрете опита на клиентите си с безпроблемно възстановяване на средства както чрез API, така и чрез потребителския интерфейс",
        "title": "Безпроблемно възстановяване на средства"
      },
      "single-report-data": {
        "subtitle": "Знания, базирани на данни",
        "text": "Проследявайте и наблюдавайте трафика на плащанията, анализирайте моделите на плащане и генерирайте изчерпателна хронология на плащанията и отчети за ефективността в рамките на едно табло за управление",
        "title": "Единна система за отчитане"
      },
      "tailored-experience": {
        "text": "Персонализираният процес на плащане на Noda съответства на инфраструктурата на търговеца, което води до по-безпроблемно и познато плащане за вашите клиенти",
        "title": "Персонализирано изживяване при плащане за вашите клиенти"
      }
    },
    "common": {
      "about": {
        "company": {
          "subtext": "Научете повече за нашата история и ръководство",
          "subtitle": "Компания"
        },
        "legal-privacy": {
          "subtext": "Преглед на нашата правна документация",
          "subtitle": "Правни въпроси и поверителност"
        },
        "mission": {
          "subtext": "Открийте мисията, визията и това, което ни прави уникални",
          "subtitle": "Кои сме ние"
        },
        "partnership": {
          "subtext": "Станете наш партньор",
          "subtitle": "Партньорство"
        },
        "risk-policies": {
          "subtext": "Запознайте се с нашата политика за спазване на рисковете",
          "subtitle": "Рискове и AML/CFT-политики"
        },
        "security": {
          "subtext": "Научете повече за усилията и политиките за сигурност на Noda",
          "subtitle": "Сигурност и работа с данни"
        },
        "ux-approach": {
          "subtext": "Разгледайте какво означава UX за Noda",
          "subtitle": "UX подход"
        },
        "white-label": {
          "footer": "White Label партньори",
          "subtext": "Изградете своя собствена платформа за плащане с Noda",
          "title": "За White Label партньори"
        },
        "why-open-banking": {
          "subtext": "Развенчайте митовете за отвореното банкиране",
          "subtitle": "Защо отворено банкиране?"
        }
      },
      "automated-data": {
        "item-1": "Точно: намаляване на риска от грешка",
        "item-2": "Ефективно: премахване на закъсненията",
        "item-3": "Сигурно: проверка на всичко, което има значение"
      },
      "automated-payouts-text": "Чрез автоматизиране на процеса на преглед и валидиране, Noda помага да се гарантира, че всички плащания се обработват бързо, точно и сигурно, осигурявайки лесна работа както за търговците, така и за получателите",
      "automated-payouts-title": "Автоматизиран преглед и валидиране на плащанията",
      "banner-market": {
        "button": "Напред към пазарите",
        "text": "Стабилен растеж или бърза трансформация?<br/>Вие знаете кога е време да изведете бизнеса си на ново ниво.",
        "title": "Ново отношение към плащанията&nbsp;– <br />разгледайте всички продукти на Noda"
      },
      "best-conditions-v2": {
        "additional": {
          "btn": "Contact Sales Team",
          "details": {
            "option-1": "Безплатно за първите 3 месеца за малки и средни предприятия",
            "option-2": "Незабавно превеждане на пари по сметката ви",
            "option-3": "Почти нулеви рискове от измами",
            "option-4": "90% коефициент на приемане"
          },
          "offer": "За да получите персонализирана ценова оферта, моля, свържете се с нашия екип за продажби",
          "subtitle": "Възползвайте се от бързи и сигурни плащания с плана за електронна търговия на Noda",
          "title": "За компании от всякакъв вид и големина"
        },
        "btn": "без такси за настройка",
        "description": "Увеличете максимално печалбите си с достъпни цени и",
        "subtitle": "Планове с възможност за мащабиране, за да отговорят на нуждите на вашия бизнес",
        "title": "Най-добрите условия за всеки бизнес"
      },
      "call-to-action": {
        "contact-btn": "Контакти за Продажби",
        "contact-team-btn": "Връзка с нашия екип",
        "contact-team-btn-2": "Връзка с отдел „Продажби“",
        "explore": "Разглеждане на документи",
        "get-notified": "Получавайте известия",
        "get-started": "Първи стъпки",
        "learn-more": "Научете повече",
        "read-less": "Прочетете по-малко",
        "read-more": "Прочетете повече",
        "sign-up": "Регистрирайте се за 10 минути",
        "start": "Начало",
        "start-using-noda": "Първи стъпки",
        "try-noda": "Опитайте Noda",
        "use-cases-btn": "Повече За Отворено Банкиране",
        "withdraw": "Теглене към банкова сметка"
      },
      "contact": {
        "all-rights": " Noda. Всички права запазени",
        "careers": "Кариери",
        "client-support": "Поддръжка на клиенти",
        "contact-us": "Свържете се с нас",
        "cookie": "Политика за бисквитките",
        "follow": "Следвайте ни",
        "hr": "Екип по човешки ресурси",
        "marketing": "Маркетинг",
        "naudapay-limited": "NAUDAPAY LIMITED, (фирмен номер: 11741664) с регистриран адрес: 162 Buckingham Palace Road, London, SW1W 9TR, UK е оторизирана платежна институция и се регулира от Financial Conduct Authority (FCA) (референтен номер: 832969) съгласно Директивата за платежните услуги ((ЕС) 2015/2366)",
        "partnership": "Партньорство",
        "policy": "Политика за поверителност",
        "public-relations": "Връзки с обществеността",
        "support": "Получаване на поддръжка",
        "terms": "Условия за ползване"
      },
      "currency": {
        "subtitle": "Възможности",
        "text": "Разширете бизнеса си на международно ниво с предлагането на Noda за плащания в над 100 световни валути.",
        "title": "Разнообразие на валути"
      },
      "developers": {
        "bank-payouts-api": "API за банкови разплащания",
        "card-payments-api": "API за плащания с карти",
        "card-payouts-api": "API за картови разплащания",
        "login-to-hub": {
          "subtitle": "Пълен контрол на всички функции",
          "title": "Влизане в хъба"
        },
        "noda-plugins": {
          "subtitle": "Плъгини за платформи за електронни магазини",
          "title": "Плъгини на Noda"
        },
        "ob-payments-api": "API за плащания в OB",
        "open-banking-demo": {
          "subtitle": "Проверете как работят продуктите на Noda",
          "title": "Noda Demo"
        },
        "pay-and-go": "Pay & Go",
        "tech-documentation": {
          "subtitle": "Пълен контрол на всички функции",
          "title": "Техническа документация"
        }
      },
      "discover-more-title": "Разгледайте още функции",
      "discover-title": "Разгледайте",
      "extensive-product-suite-v2": {
        "description": "Насладете се на лекотата от незабавните транзакции, като средствата бързо се отразяват в сметката ви, едва за няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "description-v2": "Открийте нови възможности за вашия бизнес с екосистемата за платежни услуги Noda. Получавайте и изпращайте плащания с лекота. Повишете ефективността на вашата дейност с нашите лесни за използване услуги за данни за плащане и решения за плащане без код.",
        "subtitle": "Функции и интеграции",
        "title": "Обширен набор от продукти"
      },
      "features": {
        "info": {
          "1": {
            "text": "Бърз и лесен процес на настройка. Автоматизирано внедряване и управление на API ключовете, предлагано в Noda Hub",
            "title": "Лесно внедряване"
          },
          "2": {
            "text": "Безопасно, бързо и ефективно управление на транзакциите",
            "title": "Сигурни транзакции"
          },
          "3": {
            "text": "Безпроблемна интеграция с всеки технологичен пакет по ваш избор",
            "title": "Безпроблемна интеграция"
          },
          "4": {
            "text": "Персонализирано преживяване при внедряването с личния ви мениджър на сметката",
            "title": "Личен мениджър"
          },
          "5": {
            "text": "В Noda Hub се предлагат задълбочени отчети и анализи",
            "title": "Анализи"
          },
          "6": {
            "text": "Лесна и оптимизирана обработка на плащанията за възстановяване на средства",
            "title": "Възстановяване на средства"
          },
          "7": {
            "text": "Безпроблемна свързаност с водещи банки в Обединеното кралство и ЕС в рамките на екосистемата",
            "title": "Доверени банки"
          },
          "8": {
            "text": "Поддръжка на различни потребителски роли в Noda Hub",
            "title": "Множество роли"
          },
          "9": {
            "text": "За търговците се предлагат сметки от клиента към бизнеса (C2B).",
            "title": "Сметки C2B"
          },
          "10": {
            "text": "Разширени функции за сигурност, включително глобални и локални черни списъци",
            "title": "Черни списъци"
          }
        },
        "subtitle": "Научете за покритието на Noda",
        "text": "Представяме десетте най-добри функции, пригодени за вашия бизнес",
        "title": "Основни функции"
      },
      "footer": {
        "features-release": "Всяка година пускаме стотици функции и подобрения, за да ви помогнем да изпреварите промените в индустрията и да изградите стабилна основа за бизнеса си",
        "how-to-integrate": "Как се интегрира",
        "lets-get-in-touch": "Да се свържем",
        "stay-connected": "Останете във връзка",
        "stay-connected-text": "Свържете се с нашия екип, за да научите повече за партньорство и сътрудничество",
        "total-balance": "Общ баланс",
        "ultimate-provider": "Най-ефективният доставчик на отворено банкиране"
      },
      "geo-v2": {
        "button": "Вижте списък с поддържани банки",
        "subtitle": "Местоположения",
        "text": "Възползвайте се от глобалното ни покритие, което гарантира висок коефициент на приемане във всяко кътче на света",
        "title": "Пълно географско покритие",
        "title-v2": "Обширно покритие в цял свят"
      },
      "get-started": "Първи стъпки",
      "header": {
        "about": "За нас",
        "articles": "Статии",
        "case-studies": "Казуси от практиката",
        "developers": "Програмисти",
        "events": "Събития",
        "glossary": "Речник",
        "marketplace": "Пазари",
        "newsroom": "Нюзрум",
        "other": "Друго",
        "pricing": "Цени",
        "products": "Продукти",
        "resources": "Ресурси",
        "use-cases": "Употреби"
      },
      "hero-v2": {
        "new": "Ново",
        "personal-onboarding-assistant": "Личен асистент за присъединяване за всяка компания"
      },
      "how-to-start": {
        "subtitle-1": "Лесно Начало",
        "text": "Noda предлага лесно включване с индивидуализираното ръководство на посветен мениджър. Нашият екип е тук, за да помогне с всякакви препятствия. За да започнете да използвате Noda, просто попълнете формуляра, и нашите търговски представители ще се свържат с вас скоро.",
        "title-1": "Как да започнете"
      },
      "identification-text": "Noda осигурява безпроблемни процедури за KYC, използвайки своята авангардна технология за отворено банкиране, спестявайки на клиентите си неудобството да подават документи и селфита",
      "kyc-title": "Съвременни процедури за KYC при поискване",
      "more-title": "Още функции",
      "not-verified": "80% потвърдено",
      "offer-for-smbs": {
        "from": "От",
        "per-transaction": "на транзакция",
        "title": "Безплатно за първите 3 месеца за МСП"
      },
      "payee-identification-title": "Идентифициране на получателя при отворено банкиране",
      "personal-manager": "Вашият личен мениджър",
      "post-payment-support": "Noda предлага цялостна поддръжка след плащане, фокусирана върху сътрудничеството и напредъка",
      "products": {
        "financial-data": {
          "know-your-whales": {
            "subtext": "Предсказващи финансови анализи за търговците",
            "subtext-2": "Финансови сведения и прогнози за търговците",
            "subtitle": "Обогатяване на данни"
          },
          "sign-in-via-bank": {
            "subtext": "Сигурно влизане с едно кликване с идентификационните данни на банката",
            "subtitle": "Влизане чрез банка"
          },
          "title": "Финансови данни",
          "virtual-ibans": {
            "subtext": "Глобални банкови преводи с виртуален IBAN номер",
            "subtitle": "Виртуални IBAN номера"
          }
        },
        "noda-go": {
          "pay-and-go-hard": "Pay & Go Hard",
          "pay-and-go-light": "Pay & Go Light"
        },
        "pay-ins": {
          "card-payments": {
            "subtext": "Лесна обработка на картови плащания за търговци",
            "subtitle": "Плащания с карти"
          },
          "checkout-form": {
            "subtext": "Оптимизирано изживяване при плащане за клиентите",
            "subtitle": "Формуляр за разплащателна операция"
          },
          "instant-payment-links": {
            "subtext": "Гъвкаво плащане за различни видове медии",
            "subtitle": "Връзки за незабавно плащане"
          },
          "merchant-of-record": {
            "subtext": "Универсално решение за обработка на всички плащания и правни задължения",
            "subtitle": "Merchant of Record"
          },
          "no-code-payment": {
            "subtext": "Потребителски страници за плащане чрез AI builder",
            "subtitle": "Страница За Плащане Без Код"
          },
          "open-banking-payments": {
            "subtext": "Бързи, сигурни и регулирани банкови преводи",
            "subtitle": "Плащания с отворено банкиране"
          },
          "title": "Входящи плащания"
        },
        "pay-outs": {
          "bank-payouts": {
            "subtext": "Удобни и бързи плащания по банков път за търговците",
            "subtitle": "Банкови плащания"
          },
          "card-payouts": {
            "subtext": "Безпроблемни плащания с карти за търговците",
            "subtitle": "Картови плащания"
          },
          "title": "Изходящи плащания"
        }
      },
      "resources": {
        "articles": "Статии",
        "glossary": "Речник"
      },
      "subscribe": {
        "title-1": "Получавайте последните новини от Noda",
        "title-2": "Останете информирани с Noda, като се абонирате за нашия бюлетин"
      },
      "tech-friendly-v2": {
        "acceptance-rate": {
          "option-1": "Над 90%",
          "option-2": "коефициент на приемане"
        },
        "api-key-management": {
          "description": "Лесно управление на API ключовете"
        },
        "description": "Noda предлага безпроблемна интеграция със своите API компоненти и видимите за крайния потребител компоненти, за да осигури  безпроблемно сливане с вашата платформа. Направете бърза и ефективна настройка и започнете да предлагате по-добри решения за плащане на клиентите си в рамките на едва няколко часа, а не седмици.",
        "gateway": {
          "description": "Сигурен и надежден портал"
        },
        "subtitle": "Технологична пригодност",
        "tech-platforms-support": {
          "description": "Поддържат се всички видове технологични платформи"
        },
        "title": "Безпроблемна интеграция за по-добри плащания: стартирайте едва за часове, а не&nbsp;за цели седмици"
      },
      "transaction-control": {
        "part-title-1": "Контролни транзакции в нашата",
        "part-title-2": "Многофункционално табло за управление",
        "text-1": "С Noda Hub можете без усилие да се включите, да конфигурирате предпочитанията си за транзакции, да наблюдавате транзакциите и отчетите и да анализирате трафика на плащанията в рамките на една платформа",
        "text-2": "Консолидирани функции за безпроблемно управление на плащанията",
        "title-2": "Наблюдавайте с увереност"
      },
      "use-cases": {
        "ecommerce": {
          "subtext": "Платежен портал за електронна търговия",
          "subtitle": "Електронна търговия"
        },
        "educational-platforms": {
          "subtext": "Платежен портал за образователни платформи",
          "subtitle": "Образователни платформи"
        },
        "marketplaces": {
          "subtext": "Платежен портал за пазари",
          "subtitle": "Пазари"
        },
        "online-gaming": {
          "subtext": "Платежен портал за онлайн игри",
          "subtitle": "Онлайн игри"
        },
        "retail": {
          "subtext": "Платежен портал за търговия на дребно",
          "subtitle": "Търговия на дребно"
        },
        "saas": {
          "subtext": "Плащане шлюз за SaaS",
          "subtitle": "SaaS"
        },
        "travel": {
          "subtext": "Платежни решения за бизнеси в туризма",
          "subtitle": "Пътуване и Туризъм"
        }
      },
      "verified": "100% потвърдено"
    },
    "company": {
      "articles": {
        "title": "Последни от Noda"
      },
      "hero": {
        "part-1": "Вашите плащания, ",
        "part-2": "Нашият приоритет",
        "text": "Ние сме Noda - водещ световен доставчик на разплащания - даваме възможност на онлайн търговците да приемат плащания онлайн и да получават директни банкови плащания незабавно като алтернатива на картите, без обратни такси"
      },
      "leadership": {
        "ceo": {
          "name": "Игор Локтев",
          "role": "CEO/Co-Founder",
          "text": "Игор има над 20 години опит в областта на ИТ и финансите. С магистърската си степен по компютърни науки, магистърската степен по бизнес администрация и текущото докторантско обучение по квантови изчисления, той е отличен в областта на продуктовото инженерство, анализа на данни и оптимизацията на системи.\n\nИгор се ангажира да стимулира растежа на Noda и да ръководи иновациите във финтех сектора.\n\nИнтересите му към спорта, музиката и динамичната област на компютърните науки също играят важна роля в професионалния му подход."
        },
        "clo": {
          "name": "Елина Седленице",
          "role": "Chief Legal Officer (CLO)",
          "text": "Елина идва в екипа с богат опит, като може да се похвали с 15 години работа в правната сфера с фокус върху сливания и придобивания, финтех, рисков капитал, защита на данните, банково дело и финанси.\n\nТя се ангажира с предоставянето на иновативни и ориентирани към резултатите правни решения, предназначени да насърчават растежа на бизнеса, да намаляват рисковете и да защитават интересите на компанията.\n\nСлед като получава солидна образователна основа от Висшето училище по право в Рига, през 2019 г. тя придобива магистърска степен по международно и европейско право, а през 2020 г. – магистърска степен по технологично право. Елина е базирана в Рига и съчетава всеобхватния си правен опит с далновидно мислене, за да се ориентира в сложността на днешния глобален и технологичен пейзаж.\n\nЕлина обогатява професионалния си опит с разнообразни интереси. Тя се наслаждава на изкуството да свири на пиано, на радостта от пътуването и на завладяващия свят на четенето."
        },
        "coo": {
          "name": "Анастасия Тенка",
          "role": "Chief Operations Officer (COO)",
          "text": "Анастасия е професионалист, ориентиран към успеха, с над 10 години опит в сферата на продажбите, маркетинга, бранд мениджмънта и управлението на проекти, както и в администрацията и оперативната дейност на компанията.\n\nТя играе решаваща роля в управлението на всички оперативни аспекти на Noda, като се посвещава на разработването и изпълнението на стратегически бизнес инициативи. Участието ѝ в Noda се простира до изготвяне и прилагане на бизнес стратегии, които водят до успех, изграждане на стабилни и трайни бизнес отношения, усъвършенстване на процесите за постигане на максимална ефективност и надзор на финансовите дейности на организацията.\n\nМногостранният опит на Анастасия и нейният стратегически подход към бизнес операциите я правят безценен актив за нашия екип и ключов архитект на продължаващия растеж и иновации на Noda."
        },
        "cro-cco": {
          "name": "Ласма Гаваран",
          "role": "Chief Risk & Compliance Officer (CRO & CCO)/MLRO",
          "text": "Ласма има почти десетгодишен опит в сектора на финтех технологиите, като специализира в областта на риска и нормативното съответствие. Професионалният ѝ път е подкрепен от двойно образование – бакалавърски степени по бизнес мениджмънт и по право.\n\nЛасма е не само член на Международната асоциация на сертифицираните специалисти по противодействие на изпирането на пари (ACAMS), но и притежава сертификат Advanced Certified Anti-Money Laundering Specialist – Risk Management (CAMS-RM), което я превръща в експерт в областта на риска и съответствието.\n\nНейният интерес се простира до разбирането на това как напредъкът в технологиите, като например този в сферата на новите поколения, включително и изкуствения интелект, може да подобри и да въведе иновации в различни аспекти на професионалната среда и как може да бъде приложен и интегриран в Noda."
        },
        "cro": {
          "name": "Михаил Бистров",
          "role": "Chief Revenue Officer at Noda",
          "text": "Начело на стратегиите за генериране на приходи на Noda е Михаил Бистров, нашият главен директор по приходите, с богат 18-годишен опит в областта на продажбите и маркетинга от различни международни компании. Опитът му се простира от управление на регионалната дистрибуция на Apple до ръководство на ATL и BTL кампании за уважавани марки като Nestle, JTI и Diageo Group.\n\nМихаил е с магистърска степен по финансов мениджмънт и асоциирана диплома по маркетинг и реклама и има задълбочени познания за динамиката на пазара. Неговият експертен опит е от съществено значение за подготовката на рекламни формати за олимпийските обекти и за ангажирането на сегмента „Връзки с правителството“ (GR).\n\nИзвън професионалната си сфера Михаил е запален пътешественик, което засилва глобалната му бизнес перспектива, и е посветен на опазването на китовете, демонстрирайки ангажираността си с екологични каузи."
        },
        "cso": {
          "name": "Владимир Михайлин",
          "role": "Chief Solutions Officer",
          "text": "Владимир въплъщава смесица от академична отличност и професионална експертиза със задкулисие в инженерството на компютърни системи и мрежи. С неговия обширен опит в IT сектора, той се отличава с интегрирането на напредничави технологични решения в нашите бизнес процеси, което подобрява както оперативната ефективност, така и удовлетвореността на клиентите.\n\nПосветен на насърчаването на технологичната иновация, Владимир ръководи нашия екип в разработването на сложни IT стратегии и решения, които надхвърлят изискванията на глобалния пазар. Неговото ръководство гарантира, че нашата компания остава в челните редици на технологичната индустрия.\n\nОсвен професионалните си постижения, разнообразните интереси на Владимир, като планинско туризъм и музика, насърчават устойчивостта и стратегическото мислене, което обогатява както неговата работа, така и личния му живот."
        },
        "cto": {
          "name": "Андрей Бацека",
          "role": "Chief Technical Officer (CTO)",
          "text": "Андрей допринася за нашия екип с 13-годишния си опит в програмирането и разработката, подкрепен от бакалавърска степен по компютърни науки. Експертните му познания обхващат различни области, което го прави многофункционален и квалифициран член на нашия технически отдел.\n\nВ Noda Андрей играе ключова роля в ръководенето на ключови технологични инициативи и нововъведения, като използва дълбоките си познания в областта на програмирането на преден план в нашите проекти. Ангажиментът му за непрекъснато учене и развитие се проявява в големия му интерес към машинното обучение и невронните мрежи, които той активно интегрира в работата си.\n\nВ допълнение към професионалните му занимания, страстта на Андрей към свиренето на различни музикални инструменти, както и любовта му към плуването и колоезденето, отразяват неговата динамична и всестранно развита личност. Тези хобита не само обогатяват живота му, но и вдъхновяват творческия и цялостен подход към техническата му работа."
        },
        "cxd": {
          "name": "Владислав Головач",
          "role": "Chief Experience Designer (CXD)",
          "text": "Владислав внася в екипа на Noda 20-годишен опит в областта на ергономията и ползваемостта, като се справя отлично с UX проекти, които са предизвикателство и изискват задълбочени проучвания.\n\nКариерата му на автор и пионер в областта на дизайна на потребителски интерфейси и UX се характеризира със способността му да създава интуитивни и същевременно елегантни интерфейси, да трансформира сложни идеи в достъпни системи и да превръща проучванията на потребителите в практически приложими подобрения.\n\nВладислав е базиран в Падуа, Италия и съчетава любовта си към дизайна със страстта си към създаването на смислени потребителски изживявания."
        },
        "strategy-advisor": {
          "name": "Ласма Кухтарска",
          "role": "Co-Founder, Strategy Advisor",
          "text": "Ласма Кухтарска е изтъкнат професионалист с богат опит в областта на финансите и бизнес развитието. През 2020 г. тя разработва концепцията за създаването на Noda, като е движещата сила на нашата иновативна платформа. Като съосновател и главен директор по стратегията Ласма играе ключова роля в оформянето и прилагането на новаторски стратегии, които подпомагат растежа на Noda.\n\nЛасма получава образованието си в престижното Стокхолмско училище по икономика и допълнително в областта на науката за данни за бизнеса от Харвардското бизнес училище. Преди да стане съосновател на Noda, Ласма ръководи финансови анализи в Централната банка на Латвия и допринася с уменията си за SEB Group – една от най-големите банки в Швеция и балтийските държави."
        },
        "title": "Лидерство\nна Noda"
      },
      "noda-timeline": {
        "events": {
          "option-1": "Бета-версията на нашите плащания с отворено банкиране стартира на живо",
          "option-2": "Първият търговец се активира",
          "option-3": "Започва масово разпространение",
          "option-4": "Свързани преобладаващата част от банките в ЕС и Обединеното кралство",
          "option-5": "Стартиране на плащания B2C",
          "option-6": "Установени компании в Канада, Австралия и Бразилия",
          "option-7": "Стартирани нови услуги: AIS Data Services, Платежни връзки, генерирани от AI",
          "option-8": "Придобити лицензи в Бразилия и Австралия, стартирани плащания в Бразилия"
        },
        "month": {
          "1": "Април, 2021",
          "2": "Август, 2021",
          "3": "Декември, 2021",
          "4": "Юли, 2022",
          "5": "Октомври, 2022",
          "6": "Май, 2023",
          "7": "Декември, 2023",
          "8": "Май, 2024"
        },
        "subtitle": "Хронология на Noda",
        "title": "Noda расте заедно с вашия бизнес"
      },
      "our-story": {
        "description1": "Noda сте ВИЕ. Опитваме се да бъдем хора, преди да бъдем доставчик на платежни услуги. Тъй като сме проектирани от хора за хора, ние предоставяме едно от най-добрите потребителски изживявания, които се предлагат на пазара в момента.",
        "description2": "Добавките на Noda са изпълнени с топлина и са наистина предназначени да покрият всички нужди на клиентите по най-удобния и спестяващ време начин. Никой не обича да прекарва цяла вечност в опити да плати за стоки или услуги онлайн. Само по себе си плащането не е най-приятното преживяване. Нека го направим поне по-малко времеемко.",
        "description3": "Бихме искали нашите потребители да прекарват време с приятелите и семейството си, наслаждавайки се на ценните моменти в живота, вместо например да прекарват векове в планиране как да преведат пари за хотел или кола под наем или да уреждат разходи между приятели, за да платят за пътуване.",
        "subtitle": "Нашата история",
        "title": "Noda си ти"
      }
    },
    "contact-form-v2": {
      "about": "За нас",
      "address": "NAUDAPAY LIMITED, фирмен номер: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Разкажете ни за вашия бизнес и нашите експерти по плащанията ще ви помогнат да намерите перфектната настройка за вашите нужди.",
      "form": {
        "btn": "Изпратете",
        "controls": {
          "comment": "По избор: Споделете вашия бизнес модел и нуждите от плащане. Това ни помага да адаптираме вашето решение и да ускорим процеса на настройка.",
          "company": "Име на фирмата",
          "email": "Служебен имейл",
          "first-name": "Собствено име",
          "last-name": "Фамилия",
          "phone": "Служебен телефон *",
          "select-country": "Изберете държава",
          "website": "Продуктов уебсайт"
        },
        "labels": {
          "business": "Разкажете ни повече за вашия бизнес",
          "comment": "Описание на бизнес модела",
          "contact": "Въведете информацията си за контакт",
          "details": "Вашата информация за контакт"
        }
      },
      "header": "Свържете се с нас",
      "modal": {
        "back": "Върнете се на пазара",
        "description": "Скоро ще се свържем с вас.",
        "explore": "Разгледайте Noda",
        "header": "🙌 Всичко е готово!"
      },
      "privacy": "Политика за поверителност",
      "rights": "Noda. Всички права запазени",
      "showcase": {
        "payment": "Изберете необходимите решения за плащане",
        "recommended": "Може също да се интересувате",
        "related": "Свързани решения",
        "selected": "Избраните от вас продукти"
      },
      "terms": "Условия за ползване",
      "visit-website": "Посетете пълния уебсайт"
    },
    "contact-form": {
      "about": "За нас",
      "address": "NAUDAPAY LIMITED, фирмен номер: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Попълнете формуляра, моля",
      "form": {
        "controls": {
          "comment": "Моля, обяснете бизнес модела си. Накратко очертайте обхвата на вашия проект. Включете основните характеристики и функции, които искате да обслужва платформата на Noda.",
          "company": "Име на компанията",
          "company-size": "Размер на компанията",
          "country": "Държава",
          "email": "Служебен имейл",
          "first-name": "Собствено име",
          "last-name": "Фамилия",
          "phone": "Служебен телефон",
          "volume": "Обем на плащанията",
          "website": "Уебсайт на компанията"
        },
        "labels": {
          "business": "Въведете информация за вашия бизнес",
          "comment": "Описание на бизнес модела",
          "contact": "Въведете информацията си за контакт",
          "details": "Въведете вашите данни",
          "volume": "Уведомете ни вашия обем"
        },
        "volume": {
          "option-1": "По-малко от $50 000",
          "option-2": "$50,000 до $100,000",
          "option-3": "$100,000 до $1,000,000",
          "option-4": "$1,000,000 до $10,000,000",
          "option-5": "Повече от $10,000,000"
        }
      },
      "header": "Свържете се с нашия екип по продажбите",
      "modal": {
        "back": "Върнете се на пазара",
        "description": "Благодарим ви, че се свързахте, ние ще се свържем с вас скоро.",
        "header": "Подаването е получено!"
      },
      "powered": "Задвижвано от",
      "privacy": "Политика за поверителност",
      "rights": "Noda. Всички права запазени",
      "showcase": {
        "recommended": "Може също да се интересувате",
        "selected": "Избраните от вас продукти"
      },
      "terms": "Условия за ползване"
    },
    "contact-us": {
      "contact-us-hero": {
        "1": "Връзки с обществеността",
        "2": "Маркетинг",
        "3": "Поддръжка на клиенти",
        "4": "Кариери",
        "5": "Партньорство",
        "6": "Екип продажби"
      },
      "contact-us-locations": {
        "london": {
          "text": "162 Buckingham Palace Road, London, SW1W 9TR, UK",
          "title": "Лондон, Обединено кралство"
        },
        "madrid": {
          "text": "Calle Huertas 11, 28012, Madrid, Spain",
          "title": "Мадрид, Испания"
        },
        "ontario": {
          "text": "1907 Baseline Road, Unit 104, Ottawa, Ontario, K2COC7, Canada",
          "title": "Онтарио, Канада"
        },
        "riga": {
          "text": "Riga, Pils iela 18-23, Latvija, LV-1050",
          "title": "Рига, Латвия"
        },
        "vilnius": {
          "text": "Lithuania, Vilnius, Žalgirio g.90-100, LT-09303",
          "title": "Вилнюс, Литва"
        }
      },
      "hero-text": "Свържете се с нас и ни кажете с какво можем да ви помогнем — Noda винаги е отворена за диалог",
      "hero-title": "Наши местоположения",
      "locations-text": "Noda е глобална компания с различни локации по целия свят"
    },
    "cookies": {
      "last-update": "Последна акутализация: <data>13 септември 2024 г.</data>",
      "section-1": {
        "list": {
          "item-1": "Задължителните бисквитки се използват за подсигуряване на работата на уебсайта. Тези бисквитки се използват въз основа на законния интерес на Noda за подсигуряване функционирането на уебсайта и предоставянето на услуги. Използването на тези бисквитки не изисква Вашето съгласие.",
          "item-2": "Бисквитките за предпочитания и ефективност помагат да се изпълняват определени функции, които искате да използвате, докато сте на нашия уебсайт, например свързани с използване на съобщения и формуляри за контакт, регистрация, избор на език и използване на функции, свързани с местоположението. Използването на тези бисквитки не изисква Вашето съгласие.",
          "item-3": "Статистическите бисквитки се използват за събиране и анализиране на информация за Вашите действия на уебсайта и за подобряване на неговата функционалност. Тези бисквитки помагат да се предостави информация за показатели като брой посетители, степен на отпадане, източник на трафик и друга свързана информация. Използването на тези бисквитки изисква съгласие.",
          "item-4": "Маркетинговите, насочващите или промоционалните бисквитки се използват за събиране на информация за уебсайтовете, които посещавате, и за сегментиране на посетителите на уебсайта за маркетингови цели. Тези бисквитки се използват и за предоставяне на посетителите на подходящи реклами и маркетингови кампании. Използването на тези бисквитки изисква Вашето съгласие. Ако не разрешите използването на тези бисквитки, в някои случаи ще се сблъскате с по-лошо насочени реклами."
        },
        "text-1": "Бисквитката представлява данни (текстов файл), които посещаван от потребител уебсайт изисква от браузъра Ви да съхрани на Вашето устройство, за да запамети информация за Вас, като предпочитанията Ви за език или информация за вход. Тези бисквитки се задават от нас и се наричат бисквитки на първа страна. Ние също използваме бисквитки на трети страни. Това са бисквитки от домейн, различен от домейна на уебсайта, който посещавате. По-специално ние използваме бисквитки за следните цели:",
        "text-2": "Бисквитките се получават от Noda и нейните партньори, за да осигурят работата на уебсайта, да събират и анализират Вашите дейности на уебсайта. Бисквитките могат да събират различни типове информация като IP адрес, вид на използваното устройство, използвания браузър, посетените уебсайтове или друга информация.",
        "title": "1. Какво представляват бисквитките?"
      },
      "section-2": {
        "title": "2. Задължителни бисквитки"
      },
      "section-3": {
        "title": "3. Бисквитки за предпочитания и ефективност"
      },
      "section-4": {
        "title": "4. Статистически бисквитки"
      },
      "section-5": {
        "title": "5. Маркетингови, насочващи или промоционални бисквитки"
      },
      "section-6": {
        "text-1": "Ако искате да ограничите, блокирате или изтриете бисквитките, тази възможност се предоставя чрез промяна на настройките на Вашия браузър или на настройките на бисквитките на нашата уебстраница. Ако изтриете задължителните бисквитки и бисквитките за ефективност, уебсайтът или някои от неговите части няма да функционират.",
        "text-2": "За по-обща информация относно бисквитките и как да ги управлявате моля, прочетете информацията на <a href=\"https://www.aboutcookies.org/\" target=\"_blank\" rel=\"nofollow\">www.aboutcookies.org</a>.",
        "title": "6. Как се ограничават и изтриват бисквитките?"
      },
      "table": {
        "head-1": "Бисквитки",
        "head-2": "Цел",
        "head-3": "Доставчик",
        "head-4": "Продължителност на действие"
      },
      "text": "Уебсайтът е създаден и поддържан от NaudaPay Limited (наричан по-долу „Noda“) <a href=\"https://noda.live/\">www.noda.live</a> и използва различни типове бисквитки за различни цели.",
      "title": "Политика за бисквитките"
    },
    "demo": {
      "breadcrumbs": {
        "demo": "Noda Demo",
        "home": "Начало",
        "pay-and-go": "Pay&Go",
        "payment-flow": "Поток на плащанията"
      },
      "payment-flow": {
        "amount-label": "Вижте как работи Noda, като дарите за благотворителност",
        "amount-placeholder": "Вашата сума",
        "choose-country": "Изберете вашата държава",
        "countries": {
          "at": "Австрия",
          "be": "Белгия",
          "bg": "България",
          "br": "Бразилия",
          "ca": "Канада",
          "cz": "Чехия",
          "de": "Германия",
          "dk": "Дания",
          "ee": "Естония",
          "es": "Испания",
          "fi": "Финландия",
          "fr": "Франция",
          "gb": "Великобритания",
          "gr": "Гърция",
          "hu": "Унгария",
          "ie": "Ирландия",
          "it": "Италия",
          "lt": "Литва",
          "lu": "Люксембург",
          "lv": "Латвия",
          "nl": "Холандия",
          "no": "Норвегия",
          "pl": "Полша",
          "pt": "Португалия",
          "ro": "Румъния",
          "se": "Швеция",
          "si": "Словения"
        },
        "country-select-label": "държава",
        "donate": "Дарете сега",
        "funds": {
          "br": {
            "description": "Вашето дарение ще финансира глобалните усилия на Plant-for-the-Planet за възстановяване на горските екосистеми, справяне с климатичната криза и защита на биоразнообразието.",
            "title": "Plant-for-the-Planet"
          },
          "default": {
            "description": "Вашето дарение ще финансира борбата на Каритас Европа срещу бедността и социалното изключване, като насърчава човешкото развитие, социалната справедливост и устойчивите социални системи в Европа и по света.",
            "title": "Caritas Europa"
          },
          "gb": {
            "description": "Вашето дарение ще финансира изследванията на Британската сърдечна фондация за сърдечни и кръвоносни заболявания, като ще помогне за намаляване на рисковите фактори и подобряване на здравето на сърцето.",
            "title": "British Heart Foundation"
          },
          "ro": {
            "description": "Вашето дарение ще подпомогне мисията на асоциация Save a Heart да спасява човешки животи и да подобрява здравословното състояние чрез предоставяне на критични медицински грижи, финансиране на животоспасяващи лечения и насърчаване на превенцията на сърдечните заболявания и информираността за тях в Румъния и извън нея.",
            "title": "Save a Heart Association"
          }
        },
        "main-title": "Опитайте с плащането на Noda",
        "result": {
          "button": "Контакти за Продажби",
          "cancel": "Отидете на началната страница",
          "subtitle": "{fund} получи плащането ви 🙌",
          "title": "Благодарим ви за вашето дарение за благотворителност с Noda"
        }
      },
      "solutions": {
        "common": {
          "coming-soon": "Очаквайте скоро",
          "no-docs-required": "Не се изискват реални документи за демонстрация",
          "see-more": "Вижте повече",
          "try-demo": "Опитайте Демо",
          "with-verification": "С проверка на самоличността",
          "without-verification": "Без проверка на самоличността"
        },
        "description": "Вижте как продуктите на Noda опростяват плащанията и ускоряват растежа на приходите ви.",
        "main-title": "Разгледайте решенията на Noda",
        "pay-and-go": {
          "description": "Плащане, KYC и регистрация. Всичко в едно.",
          "hard": "От клиентите ще се изисква да преминат автоматична проверка без документ чрез GBG. Ако проверката на KYC без документ е неуспешна, клиентът ще бъде помолен да премине KYC с пълен документ чрез Sumsub. ",
          "light": "Ако вашият продукт не изисква проверка на самоличността на клиента, потребителите могат да направят незабавно плащане и регистрация чрез Pay & Go Light."
        },
        "payment-flow": {
          "description": "Сигурни директни плащания от сметка към сметка чрез банка."
        }
      }
    },
    "documents-page": {
      "nav": {
        "cookies": {
          "subtitle-1": "Какво представляват бисквитките?",
          "subtitle-2": "Задължителни бисквитки",
          "subtitle-3": "Бисквитки за предпочитания и ефективност",
          "subtitle-4": "Статистически бисквитки",
          "subtitle-5": "Маркетингови, насочващи или промоционални бисквитки",
          "subtitle-6": "Как се ограничават и изтриват бисквитките?",
          "title": "Политика за бисквитките"
        },
        "policy": {
          "subtitle-1": "Отговорности",
          "subtitle-2": "Кога събираме данни за Вас",
          "subtitle-3": "Данни, които събираме, цели, правни основания и срокове за съхранение ",
          "subtitle-4": "Получатели и източници на данните Ви",
          "subtitle-5": "Международни прехвърляния на личните Ви данни",
          "subtitle-6": "Вашите права",
          "subtitle-7": "Данни за контакт",
          "subtitle-8": "Промени в Политиката за поверителност",
          "title": "Политика за поверителност"
        },
        "privacy-for-candidates": {
          "subtitle-1": "Защо Noda се нуждае от данните Ви?",
          "subtitle-2": "Как Noda обработва данните Ви?",
          "subtitle-3": "Източници и получатели на данните",
          "subtitle-4": "Международни прехвърляния",
          "subtitle-5": "Права за защита на данните",
          "subtitle-6": "Информация за контакт",
          "title": "Декларация за поверителност за кандидати за работа или сътрудничество"
        },
        "terms": {
          "subtitle-1": "Споразумението",
          "subtitle-2": "Услугата, която предоставяме",
          "subtitle-3": "Достъп до услугата и съобщаване за подозрителни дейности",
          "subtitle-4": "Нашият достъп до Вашите данни",
          "subtitle-5": "Прекратяване и временно преустановяване",
          "subtitle-6": "Обезщетение и отговорност",
          "subtitle-7": "Жалби",
          "subtitle-8": "Общи разпоредби",
          "title": "Условия за ползване"
        }
      },
      "title": "Правни документи"
    },
    "ecommerce": {
      "faq": {
        "currencies": {
          "content": "Noda поддържа различни световни валути, включително EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON и SEK.",
          "title": "Кои валути са налични?"
        },
        "how-long": {
          "content": "Нашето въвеждане в експлоатация може да стане само за един ден. Екипът за поддръжка на Noda е тук, за да ви помогне при всякакви пречки, като ви гарантира, че можете да започнете да приемате плащания бързо.",
          "title": "Колко време отнема да започнете да приемате плащания с Noda?"
        },
        "how-to-start": {
          "content": "Първо, трябва да сте се включили в програмата Noda. Просто попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Ние предлагаме лесно включване в системата с персоналните насоки на специален мениджър. Нашият процесор се интегрира гладко с API и фронт-енд компоненти, като осигурява безпроблемно сливане с вашата платформа.",
          "title": "Как да започнете да приемате плащания онлайн с Noda?"
        },
        "needs": {
          "content": "За да започнете да използвате Noda, попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Noda предлага лесно въвеждане в експлоатация с помощта на специален мениджър, който гарантира, че ще бъдете подкрепени на всяка стъпка от пътя.",
          "title": "Какво е необходимо, за да започна работа?"
        },
        "subtitle": "Трябва да знам",
        "title": "FAQs",
        "types": {
          "content": "Noda предлага решения за плащане за електронна търговия за всички типове и размери търговци, с налични мащабируеми планове за подпомагане на растежа на вашия бизнес.",
          "title": "Какви видове търговци поддържа Noda?"
        }
      },
      "hero": {
        "text": "Издигнете своя бизнес с електронна търговия. Нашата платформа за плащания „всичко в едно“ дава приоритет на разбирането, ефективността и растежа на клиентите",
        "title-1": "Решения за плащания ",
        "title-2": "за електронна търговия:",
        "title-gradient-1": "Вашите плащания ",
        "title-gradient-2": "са наш приоритет"
      },
      "how-does-it-work": {
        "content": "Noda е световна платформа за плащания в електронната търговия и доставчик на отворено банкиране. От управлението на транзакциите до финансовите анализи - Noda ви осигурява. Платформата ни използва технологии за изкуствен интелект и машинно обучение, за да предостави най-съвременни решения за платежни шлюзове за бизнеса с електронна търговия.\n\nОтвореното банкиране означава, че традиционните банки споделят данни с лицензирани финтех компании като Noda, за да оптимизират трансакциите. Нашата платежна екосистема свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява безпроблемните платежни услуги за електронна търговия.",
        "subtitle": "Технологии",
        "title": "Как работи"
      },
      "how-to-start": {
        "content": "Noda предлага лесно включване в системата с индивидуалните насоки на специален мениджър. Нашият екип е тук, за да ви помогне при всякакви препятствия. За да започнете да използвате Noda, просто попълнете формуляра и нашите търговски представители ще се свържат с вас скоро.",
        "subtitle": "Лесно включване",
        "title": "Как да започнете"
      },
      "payments": {
        "text": "Изпитайте ефективността на незабавните транзакции, като средствата бързо се отразяват в сметката ви в рамките на няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "title": "Набор от инструменти за електронна търговия"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Използвайте нашите прозрения, базирани на данни. Инструментите на Noda предлагат готови за използване анализи на поведението на клиентите, включително алгоритми за сегментиране и прогнозиране.",
            "title": "Анализ, задвижван от AI"
          },
          "banking": {
            "content": "Подобряване на преживяването на клиентите и улесняване на транзакциите с мощта и сигурността на отворените банкови плащания",
            "title": "Отворено банкиране"
          },
          "global-currencies": {
            "content": "Noda работи с различни валути, за да поддържа операциите ви за електронна търговия по целия свят.",
            "title": "Глобални валути"
          },
          "payment-processing": {
            "content": "Оптимизирайте внасянето и изплащането на суми с Noda. Използвайте интуитивен потребителски интерфейс, интелигентно маршрутизиране и разнообразни методи за плащане в електронната търговия.",
            "title": "Електронна търговия\nОбработка на плащания"
          },
          "scalable-plans": {
            "content": "Предлагаме платежни услуги за електронна търговия за всички размери на компанията, като разполагаме с мащабируеми планове, които да стимулират растежа на бизнеса ви.",
            "title": "Мащабируеми планове"
          },
          "security": {
            "content": "Noda осигурява сигурно преминаване на плащания в електронната търговия, като осигурява съответствие с PCI DSS, криптиране и предотвратяване на измами",
            "title": "Сигурност"
          }
        },
        "subtitle": "Какво предлагаме",
        "title-1": "Най-важни функции ",
        "title-2": "за електронна търговия"
      }
    },
    "educational-platforms": {
      "faq": {
        "countries": {
          "content": "Работим с 2000+ банки в 28 държави, включително Нидерландия, Португалия, Белгия, Германия, Полша, България, Франция, Ирландия, Италия, Австрия, Испания, Дания, Естония, Обединеното кралство, Люксембург, Румъния, Литва, Унгария, Латвия, Финландия, Швеция, Норвегия, Чешката република, Словакия, Гърция и Словения.",
          "title": "В кои държави работи Noda?"
        },
        "currencies": {
          "content": "Noda поддържа различни световни валути, включително EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON и SEK.",
          "title": "Какви валути поддържа Noda?"
        },
        "how-to-integrate": {
          "content": "Първо, трябва да сте се включили в програмата Noda. Просто попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Ние предлагаме лесно включване в системата с персоналните насоки на специален мениджър. Нашият процесор се интегрира безпроблемно с компонентите на API и front-end, като осигурява безпроблемно сливане с вашата образователна платформа.",
          "title": "Как мога да интегрирам Noda в работния си процес за плащане?"
        },
        "subtitle": "ОТГОВОРИ НА ВАШИТЕ ВЪПРОСИ",
        "title": "FAQs"
      },
      "hero": {
        "text": "Обучавайте с лекота, а ние се грижим за плащанията. Нашата универсална система за онлайн плащания за образователни платформи поставя на първо място разбирането на клиентите, ефективността и растежа",
        "title-1": "Шлюз за плащане",
        "title-gradient-1": "за Образователни",
        "title-gradient-2": "Платформи"
      },
      "how-does-it-work": {
        "content": "Платежният шлюз прехвърля финансови данни между обучаемите, търговците и техните банки. Мислете за него като за дигитален диригент, който старателно ръководи всеки етап от обработката на плащанията в образователния сектор.\n\nNoda е световна платформа за разплащания и доставчик на отворено банкиране. От сигурен гейтуей до управление на транзакциите и финансови анализи - Noda ви е осигурила. Платформата ни използва технологии за изкуствен интелект и машинно обучение, за да предостави най-съвременни решения за онлайн плащания за образователни предприятия.",
        "subtitle": "Технологии",
        "title": "Как работи образова&shy;телният шлюз за плащане?"
      },
      "how-to-start": {
        "content": "Noda предлага лесно включване в системата с индивидуалните насоки на специален мениджър. Платформата ни се интегрира безпроблемно с API и фронт-енд компоненти, като осигурява безпроблемно сливане с вашия интерфейс. За да започнете да използвате Noda, попълнете формуляра по-долу и нашите търговски представители ще се свържат с вас скоро. Нашият екип е тук, за да ви помогне при всякакви пречки",
        "subtitle": "Лесно включване",
        "title": "Как да започнете"
      },
      "open-banking": {
        "content": "Отвореното банкиране означава, че традиционните банки споделят данни с лицензирани финтех компании като Noda, за да оптимизират трансакциите. Нашата платежна екосистема свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява безпроблемните платежни услуги",
        "subtitle": "МНОГО ВЪЗМОЖНОСТИ",
        "title": "Какво е отворено банкиране?"
      },
      "payments": {
        "text": "Изпитайте ефективността на незабавните транзакции, като средствата бързо се отразяват в сметката ви в рамките на няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "title": "Набор от инструменти за образователни платформи"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Използвайте нашите прозрения, базирани на данни. Инструментите на Noda предлагат готови за използване анализи на поведението на клиентите, включително алгоритми за сегментиране и прогнозиране",
            "title": "Анализ, базиран на AI"
          },
          "banking": {
            "content": "Подобряване на преживяването на клиентите и опростяване на транзакциите с мощта и сигурността на отворените банкови плащания",
            "title": "Отворено банкиране"
          },
          "global-currencies": {
            "content": "Noda работи с широк набор от валути, за да поддържа вашите клиенти по целия свят",
            "title": "Глобални валути"
          },
          "payment-processing": {
            "content": "Оптимизирайте входящите и изходящите плащания, използвайте интуитивен потребителски интерфейс, интелигентно маршрутизиране и предлагайте различни популярни методи за плащане",
            "title": "Обработка на плащания за образователни платформи"
          },
          "scalable-plans": {
            "content": "Предлагаме решения за плащане за всички размери на компанията, като са налични мащабируеми планове, които да стимулират растежа на вашата образователна платформа",
            "title": "Мащабируеми планове"
          },
          "security": {
            "content": "Noda осигурява сигурно преминаване на плащанията, като гарантира съответствие с PCI DSS, криптиране и предотвратяване на измами",
            "title": "Сигурност"
          }
        },
        "subtitle": "КАКВО ПРЕДЛАГАМЕ",
        "title-1": "Топ характеристики",
        "title-2": "за образователни платформи"
      }
    },
    "financial": {
      "application-list": {
        "financial1": {
          "text": "Развлечения"
        },
        "financial2": {
          "text": "Търговия на дребно"
        },
        "financial3": {
          "text": "Стартъпи"
        },
        "financial4": {
          "text": "Магазини"
        },
        "financial5": {
          "text": "Запознанства"
        },
        "financial6": {
          "text": "Електронна търговия"
        },
        "financial7": {
          "text": "Гейминг"
        },
        "financial8": {
          "text": "Пътувания"
        }
      },
      "application": {
        "subtitle": "Приложение за данни",
        "text": "Data Enrichment на Noda може да рационализира обработката на плащанията за широк кръг от бизнеси, от традиционна електронна търговия до сложни абонаментни и допълващи бизнес модели",
        "title": "Приложимост в редица отрасли"
      },
      "buttons": {
        "DE-row": {
          "berlin": "Берлин",
          "mobile": "Мобилно"
        },
        "NL-row": {
          "amsterdam": "Амстердам",
          "desktop": "Настолен"
        },
        "UK-row": {
          "desktop": "Настолен",
          "london": "Лондон"
        }
      },
      "container-header-text": "Нашите инструменти предлагат цялостен поглед върху нуждите на клиентите, който можете да използвате, за да подобрите бизнеса си",
      "customer-segmentation": {
        "list": {
          "enhanced-engagement": "Подобрена ангажираност на клиентите",
          "marketing-insights": "Разширени маркетингови данни",
          "ready-for-use": "Готово за незабавна употреба"
        },
        "subtitle": "Клъстери от данни",
        "text": "Персонализирайте опита на клиентите си с нашата функция за сегментиране на клиентите, която категоризира потребителите в отделни групи или клъстери, за да предоставите прецизно насочени препоръки с висока стойност",
        "title": "Сегментиране на клиентите"
      },
      "data-usage": {
        "info": {
          "monthly-value": "Месечна стойност",
          "predicted-lifetime": {
            "label": "Предсказана животна стойност",
            "value": "2 месеца"
          },
          "predicted-spendings": "Предвидени разходи"
        },
        "subtitle": "Използване на данни",
        "text": "Data Enrichment на Noda използва усъвършенствани анализи, за да предскаже моделите на харчене на клиентите ви въз основа на тяхното финансово поведение и фактори на околната среда. Нашите инструменти предлагат цялостен поглед върху нуждите на клиентите, които можете да използвате, за да подобрите бизнеса си",
        "title": "Алгоритми за прогнозиране"
      },
      "diff-user": "Различен потребител",
      "financial-hero-title-1": "Обогатяване на данни:",
      "financial-hero-title-2": "Отключете отвореното банкиране",
      "financial-hero-title-3": "Анализи на потребителите с",
      "financial-info": "2 месеца",
      "header-title": "Увеличете възможностите си за растеж с допълнителни данни",
      "hero": "Получете ценна информация за потребителя веднага след извършването на първата транзакция. След като получим съгласието на потребителя да ни показва транзакциите си, това е подходящият момент да получим сигнали за действие.",
      "how-data": {
        "enrich-data": {
          "text": "След като потребителят ни даде съгласие, ние ще ви предадем обогатените данни.",
          "title": "Обогатяване на данните"
        },
        "instant-consent": {
          "text": "По време на плащането или влизането потребителите позволяват на Noda да чете данните за транзакцията.",
          "title": "Незабавно съгласие"
        },
        "payment-or-sign-in": {
          "text": "Инициирайте плащане или влизане чрез Noda на вашия уебсайт.",
          "title": "Плащане или влизане"
        }
      },
      "info-data": {
        "subtitle": "Какво виждат потребителите",
        "text": "Гарантираме спокойствието ви със сигурното управление на данни от финансовия комплект инструменти за изкуствен интелект при стриктното спазване на регулираните банкови стандарти.",
        "title": "Как става това"
      },
      "key-features-title": "Основни функции",
      "payments-data": {
        "text": "Прогнозиране на финансовата информация за търговците",
        "title": "Отключване на информация за потребителите с Noda"
      },
      "preferences-items": {
        "hood1": {
          "text": "Поставете потребителя на преден план с познания за отвореното банкиране.",
          "title": "Изградете персонализирани решения"
        },
        "hood2": {
          "text": "Получавайте сигнал, когато се включат потребители с висока платежоспособност.",
          "title": "Повишаване на ангажираността"
        },
        "hood3": {
          "text": "Сбогувайте се с прекомерните разходи за картови плащания.",
          "title": "Правете по-добър ремаркетинг с висока степен на увереност"
        },
        "hood4": {
          "text": "Насочете се само към потребители с висок потенциал за LTV.",
          "title": "Подобрете стратегията си за придобиване"
        }
      }
    },
    "gaming": {
      "case-study": {
        "subtitle": "Казус от практиката",
        "text": "През февруари 2023 г. Wargaming, всепризнат издател на онлайн игри, се обедини с Noda, за да въведе незабавни плащания по отворено банкиране в игрите. Това партньорство позволи на играчите на Wargaming да получат достъп до разнообразни възможности за онлайн разплащания, включително трансакции между сметки (A2A)",
        "title": "Wargaming <br/>& Noda"
      },
      "faq": {
        "countries": {
          "content": "Работим с 2000+ банки в 28 държави, включително Нидерландия, Португалия, Белгия, Германия, Полша, България, Франция, Ирландия, Италия, Австрия, Испания, Дания, Естония, Обединеното кралство, Люксембург, Румъния, Литва, Унгария, Латвия, Финландия, Швеция, Норвегия, Чешката република, Словакия, Гърция и Словения.",
          "title": "В кои държави работи Noda?"
        },
        "currencies": {
          "content": "Noda поддържа различни световни валути, включително EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON и SEK.",
          "title": "Какви валути поддържа Noda?"
        },
        "integration": {
          "content": "Първо, трябва да сте се включили в програмата Noda. Просто попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Ние предлагаме лесно включване в системата с персоналните насоки на специален мениджър. Нашият процесор се интегрира гладко с API и фронт-енд компоненти, като осигурява безпроблемно сливане с вашата платформа.",
          "title": "Как мога да интегрирам Noda в работния си процес за плащане?"
        },
        "subtitle": "Отговори на вашите въпроси",
        "title": "FAQs"
      },
      "hero": {
        "text": "Повишете нивото на своя бизнес с игри с плащанията на Noda. Нашата платформа \"всичко в едно\" дава приоритет на разбирането на клиентите, ефективността и растежа",
        "title-1": "Шлюз за плащане",
        "title-2": "за онлайн игри с Noda"
      },
      "how-does-it-work": {
        "subtitle": "Технологии",
        "text": "Шлюзът за плащане в игрите служи като посредник, който сигурно предава данни между играча, търговеца и банките. Представете си дигитален диригент, който старателно ръководи всяка стъпка от обработката на кредитни карти за онлайн игри.\n\nNoda е световна платежна платформа и доставчик на отворено банкиране. От сигурен гейтуей до управление на транзакциите и финансови анализи - Noda ви е осигурила. Платформата ни използва технологии за изкуствен интелект и машинно обучение, за да предоставя най-съвременни решения",
        "title": "Как работи шлюзът за плащане за игри?"
      },
      "how-to-start": {
        "subtitle": "Лесно включване",
        "text": "Noda предлага лесно включване в системата с индивидуалните насоки на специален мениджър. Нашият екип е тук, за да ви помогне при всякакви препятствия. Нашият процесор се интегрира безпроблемно с компонентите на API и front-end, като осигурява безпроблемно сливане с вашата платформа. За да започнете да използвате Noda, просто попълнете формуляра по-долу и нашите търговски представители ще се свържат с вас скоро",
        "title": "Как да започнете"
      },
      "open-banking": {
        "subtitle": "Много възможности",
        "text": "Отвореното банкиране означава, че традиционните банки споделят данни с лицензирани финтех компании като Noda, за да оптимизират трансакциите. Нашата платежна екосистема свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява безпроблемните платежни услуги",
        "title": "Какво е отворено банкиране?"
      },
      "payments": {
        "text": "Изпитайте ефективността на незабавните транзакции, като средствата бързо се отразяват в сметката ви в рамките на няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "title": "Набор от инструменти за онлайн игри"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Използвайте нашите прозрения, базирани на данни. Инструментите на Noda предлагат готови за използване анализи на поведението на клиентите, включително алгоритми за сегментиране и прогнозиране",
            "title": "Анализ, базиран на AI"
          },
          "banking": {
            "content": "Подобряване на преживяването на клиентите и улесняване на транзакциите с мощта и сигурността на отворените банкови плащания",
            "title": "Отворено банкиране"
          },
          "global-currencies": {
            "content": "Noda работи с широк набор от валути, за да поддържа вашите клиенти за онлайн игри по целия свят",
            "title": "Глобални валути"
          },
          "payment-processing": {
            "content": "Рационализирайте вноските и изплащанията, използвайте интуитивен UX, интелигентно маршрутизиране и предлагайте разнообразие от популярни методи на плащане",
            "title": "Обработка на плащания за онлайн игри"
          },
          "scalable-plans": {
            "content": "Предлагаме решения за разплащане с игри за всички размери компании, като разполагаме с мащабируеми планове, които да стимулират растежа на бизнеса ви",
            "title": "Мащабируеми планове"
          },
          "security": {
            "content": "Noda осигурява сигурно плащане на онлайн игри, като гарантира съответствие с PCI DSS, криптиране и предотвратяване на измами",
            "title": "Сигурност"
          }
        },
        "subtitle": "Какво предлагаме",
        "title-1": "Топ функции",
        "title-2": "за онлайн игри"
      }
    },
    "instant-payment-links": {
      "cx": {
        "subtitle": "изживяването е важно",
        "text": "Запознайте се с купувачи на сигурна страница за плащане.<br/>Позволете им да завършат покупката, като използват предпочитаното от тях приложение за банкиране.",
        "title": "Моментален опит за клиента"
      },
      "funds": {
        "receive-money": "Получавайте пари директно в банковата си сметка в реално време.",
        "settle-payments": "Или уреждайте плащанията с Noda vIBAN.",
        "subtitle": "изберете своя поток",
        "title": "Моментална наличност на средства"
      },
      "hero": {
        "text": "Сигурни, връзки за плащане без тромави интеграции",
        "title": "Връзки за незабавно плащане"
      },
      "info": {
        "checkout-anchor": "различни видове медии",
        "checkout-text-end": ", онлайн или лично",
        "checkout-text-start": "Позволете на вашите клиенти да правят покупки в ",
        "create-anchor": "в движение",
        "create-text": "Създавайте връзки за плащане, генерирайте QR кодове с възможност за сканиране за плащане ",
        "fees-anchor": "получавайте пари в реално време",
        "fees-text": "Ограничете трансакционните такси и ",
        "title": "Генератор на връзки за плащане за стимулиране на вашия бизнес всеки ден"
      },
      "key-features": {
        "commerce": "Многоканална търговия без интеграции",
        "coverage": "Широко географско покритие",
        "customer": "Изключително опростено изживяване за клиента",
        "fees": "Ниски трансакционни такси",
        "no-code": "Не се изисква код, нито технически опит",
        "security": "Сигурност на банково ниво",
        "subtitle": "силата за платежните връзки",
        "time": "Време за пускане на пазара: 5 мин за потребители на Noda",
        "title": "Основни функции",
        "transparency": "Прозрачност, лесно управление"
      },
      "product-block": {
        "text": "Моментална настройка. Моментално споделяне. Моментално платежно изживяване. Светът е вашето игрище. Името на играта е \"просто вземи си парите\".",
        "title": "Връзки за незабавно плащане"
      },
      "setup": {
        "subtitle": "как работи",
        "text": "Създаването на връзка за плащане отнема само няколко секунди: въведете цена и валута, добавете данни за плащане и натиснете „Генериране“. Готово!",
        "title": "Моментална настройка"
      },
      "sharing": {
        "description": "Покажете QR кода за плащане, който клиентите ви могат да сканират и да плащат в печатни медии, външни реклами, компютърни и телевизионни екрани.",
        "header": {
          "subtitle": "ангажирайте аудиторията си",
          "text": "Изпратете връзката за плащане на вашите клиенти.<br/>Използвайте всяка платформа, където си взаимодействате с аудиторията: уебсайтове, имейли, чатботове, социални мрежи, приложения за текстови съобщения и др.",
          "title": "Незабавно споделяне"
        }
      },
      "use-cases": {
        "automotive": {
          "item-1": "Пълни и разделени плащания",
          "item-2": "Депозити и вноски",
          "item-3": "Международни, мултивалутни плащания",
          "item-4": "Следпродажбено обслужване",
          "title": "Автомобили"
        },
        "e-commerce": {
          "item-1": "Многоканална търговия",
          "item-2": "Международни, мултивалутни плащания",
          "item-3": "Варианти за разсрочено плащане",
          "item-4": "Социална търговия",
          "title": "Електронна търговия"
        },
        "header": {
          "subtitle": "понятни стъпки",
          "text": "От онлайн до лично, от големи суми до микроплащания, международни или от врата до врата. Безпроблемното плащане е само на една връзка разстояние.",
          "title": "Употреби и браншове"
        },
        "retail": {
          "item-1": "Депозити и вноски",
          "item-2": "Плащания с едно щракване за завръщащи се клиенти",
          "item-3": "Многоканална търговия",
          "item-4": "Международни, мултивалутни плащания",
          "title": "Търговия на дребно с високи цени"
        },
        "sales": {
          "item-1": "Пълни и разделени плащания",
          "item-2": "Социална търговия",
          "item-3": "Кампании за бързо стартиране",
          "item-4": "Варианти за разсрочено плащане",
          "title": "Персонални продажби"
        },
        "services": {
          "item-1": "Депозити и вноски",
          "item-2": "Следпродажбено обслужване",
          "item-3": "Заеми, микрокредити",
          "item-4": "Кампании за бързо стартиране",
          "title": "Услуги"
        },
        "travel": {
          "item-1": "Депозити и вноски",
          "item-2": "Международни, мултивалутни плащания",
          "item-3": "Плащания с едно щракване за завръщащи се клиенти",
          "item-4": "Варианти за разсрочено плащане",
          "title": "Пътуване и хотелиерство"
        }
      }
    },
    "letters-plugin": {
      "buttonTitle": "Вижте всички",
      "title": "Научете повече за добавките за плащане"
    },
    "main-v2": {
      "boost-your-business": {
        "connected-banks": "свързани банки с над 30 000 клона",
        "countries-covered": "държави в обхвата",
        "description": "Стабилната екосистема за онлайн плащания на Noda свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява извършването на трансакциите без усилия",
        "integrated-networks": "интегрирани мрежи",
        "subtitle": "Разгърнете потенциала на отвореното банкиране",
        "subtitleV2": "Разгърнете потенциала\nна отвореното банкиране",
        "title": "Разширете бизнеса си с Noda"
      },
      "hero": {
        "online-payments": {
          "part-1": "Онлайн плащания ",
          "part-2": "с Noda. ",
          "part-3": "Вашите плащания са наши приоритет"
        },
        "text": "Подобрете бизнеса си с нашата цялостна платформа за онлайн плащания. Увеличете продажбите и спестете ценно време чрез рационализирани процеси. Нашите универсални решения поставят на първо място разбирането на клиентите, ефективността на операциите и растежа."
      },
      "reviews": {
        "title": "Какво казват нашите клиенти"
      },
      "what-is-noda": {
        "card-payments": {
          "button": "Научете Картовите Плащания",
          "description": "Основен приоритет за Noda е оптимизирането на повтарящите се плащания за улесняване на трансакциите",
          "subtitle": "Плащания с карти",
          "title": "По-бързо плащане с едно кликване"
        },
        "checkout": {
          "button": "Разгледайте Касата",
          "description": "Насладете се на силата да плащате с лекота с удобен за използване интерфейс и пълен набор от функции за плащане в Noda Checkout.",
          "subtitle": "Плащане",
          "title": "Унифицирана Разплащателна Операция за Вашите Плащания"
        },
        "delight-customers": {
          "description": "Възползвайте се от нискотарифни или нулеви такси за събиране на вземания с множеството възможности, предоставени чрез нашите онлайн услуги за плащания",
          "title": "Удовлетворени клиенти"
        },
        "easy-to-apply": {
          "description": "Гъвкаво решение за събиране на средства с възможност да използвате нашата банкова сметка Noda C2B или да изберете доверен банков партньор от нашата мрежа",
          "title": "Лесно приложение"
        },
        "open-banking": {
          "button": "Повече За Отворено Банкиране",
          "description": "Възползвайте се от силата на отвореното банкиране и приложните програмни интерфейси (API), за да подобрите преживяването на клиентите си и да улесните обработката на онлайн плащанията със сигурното и ефективно решение на Noda",
          "subtitle": "Отворено банкиране",
          "title": "Оптимизирайте плащанията си с Noda"
        },
        "text": "Нашето цялостно решение за онлайн плащания оптимизира трансакциите както за фирми, така и за частни лица, независимо дали събирате средства от клиенти, или изпращате пари на близки и приятели.",
        "title": "Какво е "
      }
    },
    "marketplace": {
      "cart": {
        "cta": "Начало",
        "in-your-package": "В пакета ви",
        "products": "Продукти",
        "recommended": "Може също да ви интересува"
      },
      "errors": {
        "email-pattern": "Форматът на имейла е неправилен",
        "oninvalid": "Стойността е невалидна",
        "required": "Стойността е задължителна"
      },
      "filters": {
        "all": "Всички продукти",
        "categories": "Категории",
        "header": "Филтри"
      },
      "header": "Нашите продукти",
      "hero": {
        "description": "Изберете правилните инструменти за плащане за вашия бизнес. Платформата за платежни услуги на Noda обединява обработка на плащания, фактуриране, услуги за обогатяване на данни и още - готови за комбиниране и персонализиране.",
        "description-2": "Готови ли сте за нов поглед върху плащанията? Започнете да изграждате своята платежна система днес.",
        "title": "Инструменти за плащане през банки и граници"
      },
      "product": {
        "add-to-package": "Добавете",
        "in-package": "Добавено",
        "read-more": "Прочетете повече",
        "remove": "Премахнете"
      },
      "request-a-product": {
        "cta": "Подаване на заявка",
        "description": "Не можете да намерите това, което търсите? Уведомете ни.",
        "form": {
          "back": "Върнете се на пазара",
          "labels": {
            "description": "Опишете идеята си",
            "email": "Вашият служебен имейл адрес",
            "organization": "Вашата организация"
          },
          "recommended": "Може също да ви интересува",
          "success": {
            "description": "Ние ще обработим вашата заявка възможно най-бързо. Приятен ден!",
            "header": "Благодарим ви за заявката"
          }
        },
        "header": "Заявка за продукт"
      }
    },
    "marketplaces": {
      "faq": {
        "countries": {
          "content": "Работим с 2000+ банки в 28 държави, включително Нидерландия, Португалия, Белгия, Германия, Полша, България, Франция, Ирландия, Италия, Австрия, Испания, Дания, Естония, Обединеното кралство, Люксембург, Румъния, Литва, Унгария, Латвия, Финландия, Швеция, Норвегия, Чешката република, Словакия, Гърция и Словения.",
          "title": "В кои държави работи Noda?"
        },
        "currencies": {
          "content": "Noda е процесор за плащания на глобалния пазар, който поддържа различни валути, включително EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON и SEK.",
          "title": "Какви валути поддържа Noda?"
        },
        "how-to-integrate": {
          "content": "Първо, трябва да сте се включили в програмата Noda. Просто попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Ние предлагаме лесно включване в системата с персоналните насоки на специален мениджър. Нашата система за плащания на пазара се интегрира с API и фронт-енд компоненти, като безпроблемно се слива с вашата платформа.",
          "title": "Как мога да интегрирам Noda в работния си процес за плащане?"
        },
        "subtitle": "ОТГОВОРИ НА ВАШИТЕ ВЪПРОСИ",
        "title": "FAQs"
      },
      "hero": {
        "text": "Повишете нивото на своя пазар с шлюза за плащане на Noda. Съсредоточете се върху обявите, докато ние осигуряваме сигурни и безпроблемни транзакции. Нашата платформа \"всичко в едно\" дава приоритет на разбирането на клиентите, ефективността и растежа",
        "title-1": "Шлюз за плащане",
        "title-gradient-1": "за пазари с Noda"
      },
      "how-does-it-work": {
        "content": "Платежният шлюз предава по сигурен начин финансови данни между клиенти, търговци и банки. Мислете за него като за цифров проводник, който ръководи всеки етап от обработката на плащанията\n\nNoda е световна платежна платформа и доставчик на отворено банкиране. От сигурни плащания на онлайн пазари до финансови анализи - Noda ви е осигурила. Платформата ни използва технологии за изкуствен интелект и машинно обучение, за да предоставя най-съвременни решения",
        "subtitle": "Технологии",
        "title": "Как работи платежният шлюз Marketplace?"
      },
      "how-to-start": {
        "content": "Noda предлага лесно включване в системата с индивидуалните насоки на специален мениджър. Платформата ни за пазарни плащания се интегрира безпроблемно с приложни програмни интерфейси (API) и фронт-енд компоненти, осигурявайки безпроблемно сливане с вашия интерфейс. За да започнете да използвате Noda, попълнете формуляра по-долу и нашите търговски представители ще се свържат с вас скоро. Нашият екип е тук, за да ви помогне при всякакви пречки",
        "subtitle": "Лесно включване",
        "title": "Как да започнете"
      },
      "open-banking": {
        "content": "Отвореното банкиране означава, че традиционните банки споделят данни с лицензирани финтех компании като Noda, за да оптимизират трансакциите. Нашата платежна екосистема свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява безпроблемните плащания за пазарите",
        "subtitle": "МНОГО ВЪЗМОЖНОСТИ",
        "title": "Какво е отворено банкиране?"
      },
      "payments": {
        "text": "Изпитайте ефективността на незабавните транзакции, като средствата бързо се отразяват в сметката ви в рамките на няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "title": "Набор от инструменти за пазари"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Възползвайте се от нашите прозрения, базирани на данни. Инструментите на Noda предлагат готови за използване анализи на поведението на клиента, включително алгоритми за сегментиране и прогнозиране",
            "subtitle": "СЪВРЕМЕННИ ТЕХНОЛОГИИ",
            "title": "Анализ, базиран на AI"
          },
          "banking": {
            "content": "Подобряване на потребителското изживяване (UX) и опростяване на транзакциите с мощта и сигурността на отворените банкови плащания",
            "title": "Отворено банкиране"
          },
          "global-currencies": {
            "content": "Noda работи с множество валути, за да поддържа вашите клиенти на пазара по целия свят",
            "title": "Глобални валути"
          },
          "payment-processing": {
            "content": "Рационализирайте вноските и изплащанията, използвайте интуитивен UX, интелигентно маршрутизиране и предлагайте разнообразие от популярни пазарни опции за плащане",
            "subtitle": "ВСИЧКО ЗА ВАШИЯ БИЗНЕС",
            "title": "Обработка на плащания на пазара"
          },
          "scalable-plans": {
            "content": "Ние предлагаме решения за плащане за пазари от всякакъв размер, с налични мащабируеми планове, които да поддържат вашия растеж",
            "title": "Мащабируеми планове"
          },
          "security": {
            "content": "Noda е сигурен пазарен доставчик на плащания, гарантиращ съответствие с PCI DSS, криптиране и предотвратяване на измами",
            "title": "Сигурност"
          }
        },
        "subtitle": "НАШИТЕ ОФЕРТИ",
        "title-1": "Топ функции"
      }
    },
    "meta": {
      "about": {
        "aml-cft-policies": {
          "description": "Запознайте се с нашата декларация за политиката, регулаторна рамка, методологии и много други.",
          "title": "Политики на Нода за борба с изпирането на пари и финансирането на тероризма"
        },
        "company": {
          "description": "Запознайте се с историята на Noda и разберете как можем да подобрим вашите бизнес плащания. Запознайте се с нашия екип и продукти.",
          "title": "Компания | Noda"
        },
        "mission": {
          "description": "Научете повече за мисията и визията на Noda, включително за трите кита на нашата култура и историята на това, което сме.",
          "title": "Мисия и визия на Нода"
        },
        "partnership": {
          "description": "Разгледайте нашите възможности за партньорство, включително възможности за бял етикет, дистрибутор, франчайз и агент. Интегрирайте нашата технология за отворено банкиране.",
          "title": "Noda: Станете партньор на Noda в развитието на бизнеса"
        },
        "risk-appetite-policy": {
          "description": "Запознайте се с нашата политика за рисковете в отраслите, дейностите и юрисдикциите, които са забранени, ограничени или изискват специфично поведение.",
          "title": "Политиката на Нода за склонност към риск"
        },
        "security": {
          "description": "Сигурността на плащанията и данните винаги трябва да бъде приоритет. Предоставяме преглед на нашите функции за сигурност и нашия ангажимент за защита на личните данни.",
          "title": "Сигурност и работа с данни | Noda"
        },
        "ux-approach": {
          "description": "Открийте нашата CX философия и манифест за дизайн. Научете повече за нашите принципи на проектиране и какво кара нашия екип да произвежда отлична работа.",
          "title": "Подходът на Noda към клиентското изживяване (CX)"
        },
        "white-label": {
          "description": "Станете партньор с бял етикет на Noda и интегрирайте отвореното банкиране. Използвайте безпроблемни плащания, аналитични данни и персонализирано брандиране.",
          "title": "Noda: Развийте бизнеса си като White-Label партньор"
        },
        "why-open-banking": {
          "description": "Открийте защо отвореното банкиране трансформира плащанията. Научете как то е от полза както за търговците, така и за потребителите, като същевременно развенчаете разпространените митове.",
          "title": "Защо отвореното банкиране е бъдещето на плащанията"
        }
      },
      "articles": {
        "description": "Открийте всичко, което трябва да знаете за отвореното банкиране и решенията за онлайн плащания. Научете повече за цифровите плащания със статиите за финтех на Noda.",
        "title": "Статии | Финтех, Отворено банкиране, Цифрови плащания | Noda"
      },
      "bank-payouts": {
        "description": "Опростете масовите плащания с усъвършенстваните решения за банкови плащания на Noda. Насладете се на бързи, безпроблемни транзакции и ефективност на разходите. Прочетете, за да научите повече.",
        "title": "Оптимизирани банкови плащания за бързи и рентабилни транзакции | Noda"
      },
      "bank-sign": {
        "description": "Подобрете работата на клиентите си с влизането в системата на Noda чрез използване на банкова сметка. Осигурете си първокласна сигурност, спечелете повече клиенти и имайте достъп до надеждни данни.",
        "title": "Безпроблемно вписване чрез банка, сигурни плащания и съответствие на данните | Noda"
      },
      "card-payments": {
        "description": "Изпитайте безпроблемни плащания с технологията на Noda, задвижвана от изкуствен интелект. Оптимизирано маршрутизиране, приети картови плащания и лесна интеграция - съобразени с развитието на вашия бизнес. Научете повече.",
        "title": "Усъвършенстване на онлайн картовите плащания за бизнес успех | Noda"
      },
      "card-payouts": {
        "description": "Увеличете растежа на бизнеса си с ефективните решения на Noda за глобално изплащане на карти. Безпроблемна интеграция с API, сигурни транзакции и съобразени с вашите нужди.",
        "title": "Превключване, сигурни и ефективни решения за изплащане на карти | Noda"
      },
      "checkout": {
        "description": "Усъвършенствайте процеса на проверка на плащанията си с усъвършенстваната технология на Noda, управлявана от изкуствен интелект. Оптимизирайте плащането, осигурете сигурни транзакции и разширете дейността си в световен мащаб.",
        "title": "Безпроблемни и сигурни решения за проверка на плащанията | Noda"
      },
      "contact-form": {
        "description": "Разгледайте нашата интегрирана платформа за плащане. Разгледайте пазара за услуги на Noda, за да изградите своя перфектен технологичен стек за плащания. Отворено банкиране, карти, обогатяване на данни, липса на код.",
        "title": "Форма Noda"
      },
      "contact-us": {
        "description": "Повишете нивото на бизнеса си със силата на отвореното банкиране. Обърнете се към нас днес, за да оптимизирате плащанията с нашата универсална платформа.",
        "title": "Свържете се с нас | Noda"
      },
      "demo": {
        "description": "Разгледайте решенията на Noda. Вижте как продуктите на Noda опростяват плащанията и ускоряват растежа на приходите ви.",
        "title": "Noda Demo"
      },
      "events": {
        "description": "Открийте събития и конференции в Noda. Резервирайте мястото си сега, за да се свържете с лидери в платежната индустрия, да получите информация и да се включите във възможностите за професионално развитие!",
        "title": "Събития: Свържете се в мрежа, учете и растете с Noda"
      },
      "financial-ai-toolset": {
        "description": "Запознайте се с Financial AI Toolset - решение, което дава възможност на бизнеса да използва проницателни финансови анализи, базирани на изкуствен интелект, за вземане на решения, основани на данни.",
        "title": "Инструменти за финансов изкуствен интелект: Развийте бизнеса си с помощта на анализ на данни | Noda"
      },
      "glossary": {
        "description": "Запознайте се с речника на Noda за терминологията на финтех и отвореното банкиране от А до Я.",
        "title": "Речник на отвореното банкиране | Noda"
      },
      "instant-payment-links": {
        "description": "Създайте връзкa за плащане за секунди за безпроблемни онлайн транзакции. Изпратете на вашите клиенти връзки за плащане и получете плащане веднага.",
        "title": "Връзки за плащане – Незабавни плащания с лекота | Noda"
      },
      "legal": {
        "cookies": {
          "description": "Политиката за бисквитки на Noda обяснява как използваме бисквитки за функционалност, анализи и маркетинг. Разберете как да управлявате предпочитанията си.",
          "title": "Политика за бисквитките"
        },
        "policy": {
          "description": "Открийте как Noda събира, използва и защитава вашите лични данни съгласно GDPR и други разпоредби. Вашата поверителност е наш приоритет.",
          "title": "Политика за поверителност"
        },
        "privacy-notice-for-job-candidates-or-cooperation": {
          "description": "Това известие обяснява как Noda третира личните данни на потенциални служители, стажанти, които са кандидатствали или са били поканени да кандидатстват за свободни позиции в Noda или да си сътрудничат с Noda като индивидуални изпълнители.",
          "title": "Уведомление за поверителност за кандидати за работа или сътрудничество | Noda"
        },
        "terms": {
          "description": "Това споразумение очертава условията за използване за частни лица, иницииращи плащания чрез Noda. Научете за вашите права и използване на данни.",
          "title": "Условия за ползване"
        }
      },
      "main": {
        "description": "Възползвайте се от предимствата на API с платформата за онлайн плащане на Noda. Улеснете транзакциите и оптимизирайте бизнес процесите си без усилия.",
        "title": "Онлайн плащания с Noda | Сигурна и ефективна платформа за плащане"
      },
      "marketplace": {
        "description": "Разгледайте нашата интегрирана платформа за плащане. Разгледайте пазара за услуги на Noda, за да изградите своя перфектен технологичен стек за плащания. Отворено банкиране, карти, обогатяване на данни, липса на код.",
        "title": "Пазар за платежни услуги | Noda"
      },
      "mor": {
        "description": "Отключете търговията без граници за вашите цифрови иновации. От независими игри до корпоративен софтуер.",
        "title": "Merchant of Record"
      },
      "newsroom": {
        "description": "Вижте последните новини за Noda. Прочетете най-новите статии, прессъобщения и експертни прозрения, представящи отворените банкови разплащателни услуги на Noda.",
        "title": "Ние сме в новините | Нода"
      },
      "no-code": {
        "description": "Увеличете онлайн продажбите с управлявани от изкуствен интелект страници за плащане без код. Научете как Noda може да подпомогне целия ви поток от транзакции - от търговска сметка до ежедневна обработка на плащания.",
        "title": "Създаване на персонализирани страници за плащане с изкуствен интелект за няколко минути | Noda"
      },
      "open-banking": {
        "description": "Трансформирайте бизнеса си с отворените банкови плащания на Noda. Подобрете работата на клиентите и осигурете сигурни транзакции. Изпробвайте демо версия сега.",
        "title": "Отворена банкова платформа за сигурни и безпроблемни транзакции | Noda"
      },
      "plugins": {
        "description": "Издигнете нивото на бизнеса си с допълнителните програмни модули на Noda за отворено банкиране за платформата за електронна търговия, която използвате. Оптимизирайте плащанията с опростен потребителски опит, плавна интеграция, сигурност и ефективност на отвореното банкиране.",
        "magento": {
          "description": "Открийте приставката Magento на Noda. Научете как да интегрирате Noda като опция за плащане в Magento на вашия уебсайт за електронна търговия.",
          "title": "Шлюз за плащане на Magento с Noda"
        },
        "opencart": {
          "description": "Открийте приставката OpenCart на Noda. Научете как да интегрирате Noda като опция за плащане в OpenCart на вашия уебсайт за електронна търговия.",
          "title": "OpenCart Gateway за плащане с Noda"
        },
        "prestashop": {
          "description": "Открийте приставката PrestaShop на Noda. Научете как да интегрирате Noda като опция за плащане в PrestaShop на вашия уебсайт за електронна търговия.",
          "title": "PrestaShop шлюз за плащане с Noda"
        },
        "title": "Увеличете продажбите си с допълнителните програмни модули на Noda за отворено банкиране",
        "woocommerce": {
          "description": "Открийте плъгина за WordPress на Noda. Научете как да интегрирате Noda като метод за плащане в WooCommerce за вашия бизнес за електронна търговия.",
          "title": "Шлюз за плащане на WooCommerce с Noda"
        }
      },
      "pricing": {
        "description": "Noda предлага конкурентни и предвидими цени за вашия бизнес. Усъвършенствайте платежната си екосистема с нашето цялостно решение за отворено банкиране.",
        "title": "Ценообразуване | Noda"
      },
      "toc": {
        "title": "УСЛОВИЯ ЗА СЪТРУДНИЧЕСТВО"
      },
      "use-cases": {
        "ecommerce": {
          "description": "Открийте платежния шлюз на Noda за електронна търговия и рационализирайте онлайн транзакциите. Започнете да използвате Noda сега.",
          "title": "Решения за плащане в електронната търговия: Повишете нивото на бизнеса си с Noda"
        },
        "educational-platforms": {
          "description": "Открийте системите на Noda за онлайн разплащания в сферата на образованието, за да рационализирате транзакциите и да използвате отвореното банкиране. Научете повече...",
          "title": "Шлюз за плащане за образователни платформи | Noda"
        },
        "marketplaces": {
          "description": "Открийте решенията за плащане на онлайн пазара на Noda, за да рационализирате транзакциите и да използвате отвореното банкиране. Научете повече...",
          "title": "Платежен шлюз за пазари | Noda"
        },
        "online-gaming": {
          "description": "Открийте решенията на Noda за плащане на игри, за да рационализирате транзакциите и да използвате отворените банкови плащания. Научете повече...",
          "title": "Портал за плащане за онлайн игри | Noda"
        },
        "retail": {
          "description": "Открийте шлюза за плащания на дребно на Noda, за да оптимизирате транзакциите и да използвате отворените банкови плащания. Научете повече...",
          "title": "Платежен шлюз за търговия на дребно | Noda"
        },
        "saas": {
          "description": "Открийте платежния шлюз SaaS на Noda, за да рационализирате транзакциите и да използвате отворените банкови плащания. Научете повече...",
          "title": "Шлюз за плащане за SaaS | Noda"
        },
        "travel": {
          "description": "Открийте платежните решения на Noda за туристически бизнес и онлайн плащания. Научете повече...",
          "title": "Решения за плащане при пътуване: Повишете нивото на бизнеса си с Noda"
        }
      }
    },
    "mission": {
      "hero": {
        "desc-1": "Нашата <b>мисия</b> е да предоставим окончателния набор от инструменти за финансово управление, който интернет в 21-ви век заслужава.",
        "desc-2": "Стремим се да премахнем остатъците от наследените през миналия век системи, включително закъсненията във времето, изкривяванията на данните, дължащи се на безкрайните посредници, ръчната обработка, човешките грешки и присъщите на една кликирана финансова система предубеждения.",
        "extended-text": "Искаме да стимулираме трансформацията на финансовата система чрез отворено банкиране.\nНашата <b>визия е</b> плащанията да се извършват незабавно между сметките навсякъде по света, без допълнителни разходи. Смятаме, че анализът на финансовите данни не трябва да се ограничава до банките; вместо това физическите лица и предприятията трябва да имат контрол върху собствените си данни.",
        "extended-title": "Глобална финансова трансформация",
        "subtitle": "На какво се основаваме",
        "title": "Мисия и визия"
      },
      "products": {
        "subtitle": "Продукти",
        "text": "Предлагаме разнообразни платежни продукти, които са подходящи както за онлайн, така и за лични трансакции, така че клиентите ви да могат да се насладят на безпроблемно многоканално плащане.",
        "title": "Какво правим"
      },
      "secret": {
        "communication": {
          "text": "Обсъждаме нещата, споделяме идеи и открито обсъждаме какво работи добре и какво не. За нас е важно да бъдем ясни и откровени по отношение на всичко - от проектите до визията ни. В Noda всеки е в течение на събитията.",
          "title": "Комуникация"
        },
        "empathy": {
          "text": "Но не става въпрос само за техниката, а и за вас. Ние сме тук, за да изслушваме, разбираме и подкрепяме нашите клиенти. Независимо дали сте в бизнеса от години, или тепърва започвате, в Noda ще откриете гостоприемна атмосфера, в която вашите нужди са на първо място.",
          "title": "Емпатия"
        },
        "innovation": {
          "text": "Непрекъснато експериментираме и изпробваме идеи. Възприемаме нови технологии като блокчейн и изкуствен интелект. Искаме да ви предоставим авангардни решения, които правят плащанията по-приятни и по-лесни. И не се страхуваме да мислим нестандартно.",
          "title": "Иновации"
        },
        "subtitle": "Повече за нас",
        "title": "Нашият таен сос"
      },
      "welcome": {
        "desc-1": "Разработваме платформа, която дава възможност на онлайн бизнесите да управляват широк спектър от взаимодействия с клиенти, включително включване в системата, проверка на самоличността и богатството, оценка на риска, маршрутизиране, входящи и изходящи плащания и анализ на ефективността на взаимодействието.",
        "desc-2": "Мотивирани сме да развиваме нашия продукт и индустрията, а не да печелим от нашите клиенти. Гордеем се, че виждаме как нашите продуктови решения започват да оформят отворената банкова индустрия на пазарите, на които работим.",
        "desc-3": "Ние сме вашите партньори в областта на плащанията - пионери, създатели и винаги съюзници на.",
        "extended-subtitle": "Добре дошли в бъдещето на финтех.",
        "extended-title": "Добре дошли в Noda",
        "title": "Кои сме ние"
      },
      "whales": {
        "exploration": {
          "text": "Винаги се учим. Членовете на нашия екип са страстни и ентусиазирани, желаят да се самоусъвършенстват и да се развиват професионално. Ние в Noda подкрепяме този стремеж.",
          "title": "Проучване"
        },
        "passion": {
          "text": "В Noda страстта подхранва всичко, което правим. Ние се стремим към съвършенство, независимо дали въвеждаме иновации или общуваме с клиенти. Вярваме, че страстта превръща проектите в нещо забележително и вдъхновява другите да се присъединят към тях.",
          "title": "Страст"
        },
        "responsibility": {
          "text": "Не си губим времето в спорове или размяна на удари с пръст. В Noda винаги работим заедно, за да намерим конструктивни решения, като се уважаваме взаимно и споделяме отговорността както за победите, така и за неуспехите.",
          "title": "Отговорност"
        },
        "subtitle": "Култура на Noda",
        "title": "Три кита\nна нашия културен код Noda"
      }
    },
    "modern-slavery": {
      "intro-1": "Законът за борба със съвременното робство от 2015 г. (MSA) в Обединеното кралство е насочен към борбата с робството и призовава организациите активно да предотвратяват допускането на съвременно робство в своите дейности.",
      "intro-2": "В своята дейност Noda е отдадена на борбата с робството и предотвратяването на всякаква връзка, подпомагане или подкрепа на трафика на хора и робството. Тази декларация потвърждава нашия ангажимент да спазваме разпоредбите на Закона за борба със съвременното робство, подчертава нашата позиция против съвременното робство и описва стъпките, които предприемаме, за да осигурим ефективното прилагане на нашия подход.",
      "last-update-at": "Последна редакция: 1 юни 2024 г.",
      "note": "МОЛЯ, ОБЪРНЕТЕ ВНИМАНИЕ: Въпреки че в момента нямаме законово задължение да публикуваме тази декларация, в Noda вярваме, че отговорните действия трябва да се предприемат още преди да станат задължителни.",
      "sections": {
        "our-status": {
          "text-1": "В Noda прилагаме различни механизми за контрол, с които гарантираме, че няма да бъдем замесени в дейности, противоречащи на нашата позиция относно съвременното робство. По-долу са изброени някои от тези механизми.",
          "text-2": "Noda си сътрудничи с няколко доставчици, чиито професионални услуги са свързани с консултантска дейност, правни съвети и счетоводство, ако е необходимо. Освен това работим с доставчици, предоставящи хардуерно и софтуерно обслужване, което включва компютърно оборудване, софтуерни лицензи и облачни услуги за съхранение на данни. Местоположението на повечето ни доставчици съвпада с местата, където работят нашите офиси, а именно Обединеното кралство и ЕС.",
          "text-3": "Тъй като сме компания, използваща базирани в интернет платежни технологии, и мнозинството от нашите доставчици предоставят софтуерни и професионални услуги, нашият рисков профил по отношение на човешките права и съвременното робство е оценен като нисък. Независимо от това, всички доставчици са длъжни да спазват нашите вътрешни политики, които наред с други изисквания предвиждат всички доставчици да преминават през проверка и надлежна оценка, като степента на проверка варира в зависимост от категорията на риска, в която попадат.",
          "text-4": "Повечето от търговците, на които Noda предоставя услуги, са разположени в географски райони с нисък риск, като също преминават през проверка за потвърждаване на техния нискорисков статус.",
          "text-5": "Noda не разполага с информация за случаи на робство или трафик на хора в рамките на предприятията от групата или веригите за доставки. През последната финансова година не са установени или докладвани потенциални проблеми от такова естество чрез вътрешните канали за докладване, одитни процеси, канали за подаване на сигнали за нередности или по друг начин. Освен това в Noda не е получавана информация от субекти в рамките на групата Noda, която да посочва наличието на такива проблеми в рамките на вътрешната група доставчици или техните вериги за доставки.",
          "text-6": "Ние от Noda поемаме ангажимент да зачитаме всички международно признати човешки права по отношение на нашите служители, общностите, в които работим, и общностите в нашите глобални вериги за доставки. Ако узнаем, че която и да е страна, с която сме обвързани, е замесена в нарушения на човешките права или престъпления, свързани със съвременното робство, ние незабавно ще прекратим отношенията си с тази организация.",
          "text-7": "Можете да подавате сигнали до Noda относно човешките права или съвременното робство при опасения, свързани с някой от нашите търговци, доставчици или други страни, чрез <a href=\"mailto:legal@noda.live\" target=\"_blank\">Legal@noda.live</a>. Уверяваме ви, че ще разследваме такива сигнали своевременно и усърдно.",
          "title": "Нашето състояние, операции и верига за доставки"
        }
      },
      "subtitle": "Предназначение на декларацията",
      "title": "Декларация относно съвременното робство"
    },
    "mor": {
      "case": {
        "subtitle": "Казус от практиката",
        "text": "През февруари 2023 г. Wargaming, всепризнат издател на онлайн игри, се обедини с Noda, за да въведе незабавни плащания с отворено банкиране в игрите. Това партньорство позволи на играчите на Wargaming да получат достъп до разнообразни възможности за онлайн разплащания, включително трансакции между сметки (A2A)",
        "title": "Wargaming и Noda"
      },
      "cure": {
        "additional": {
          "text1": "Изчисляване на данъка върху продажбите, ДДС и GST",
          "text2": "Своевременно подаване на документи към данъчните органи в цял свят",
          "text3": "Навремменни актуализации, свързани със данъчното законодателство",
          "text4": "Съхранение на подробни записи за моментите, наречени „за всеки случай“."
        },
        "bold-text": "Какво поддържаме:",
        "subtitle": "Лек за данъчни проблеми",
        "text": "Край на кошмарите, предизвикани от данъците. Нашата интелигентна система обработва числата, попълва формулярите и ви държи наясно с целевите ви пазари. Ние сме в крак с непрекъснато променящите се данъчни закони по целия свят, като премахваме ненужните бариери, за да достигнете до аудиторията си.",
        "title": "Вашият партньор в глобално данъчно спазване"
      },
      "custom": {
        "subtitle": "как работи",
        "text": "Нека разчистим пътя ви към глобалните пазари, като превърнем сложните международни продажби в безпроблемни трансакции.",
        "title": "Ще се погрижим за неприятните неща зад кулисите: плащания, данъци, поддръжка."
      },
      "faq": {
        "offer": {
          "content": "Осигуряваме поддръжка 24/7 на множество езици, за да ви помогнем при всякакви проблеми – от проблеми с плащането до въпроси, свързани с акаунта. Нашият екип е винаги на разположение, за да ви помогне да се ориентирате в сложността на глобалната дигитална търговия.",
          "title": "Какъв вид поддръжка предлага Noda?"
        },
        "payment-security": {
          "content": "Използваме отворено банкиране за директни банкови преводи, което проверява притежателите на сметки в реално време. Този подход, съчетан с нашето усъвършенствано наблюдение на трансакциите, значително намалява риска от измами, като същевременно поддържа безпроблемно потребителско изживяване.",
          "title": "Как се справя Noda със сигурността на плащанията и предотвратяването на измами?"
        },
        "products": {
          "content": "Абсолютно! Ние сме специализирани в предоставянето на възможност за търговия без граници. Платформата ни работи с множество валути, локализира начините за плащане и урежда спазването на международните данъчни изисквания, като ви улеснява да достигнете до клиенти в световен мащаб.",
          "title": "Може ли Noda да ми помогне да продавам продуктите си в международен план?"
        },
        "services": {
          "content": "Не е необходимо. Можете да използвате нашите услуги със съществуващия си уебсайт, а ние предлагаме и безплатни инструменти за разпространение, включително интуитивен сайт и създател на магазини без нужда от писане на код, за да ви помогнем да започнете, ако все още нямате уебсайт.",
          "title": "Трябва ли да имам собствен уебсайт, за да използвам услугите на Noda?"
        },
        "subtitle": "Трябва да знаете",
        "tax-compliance": {
          "content": "Нашата интелигентна система автоматично изчислява, събира и превежда данъка върху продажбите, ДДС и данъка върху стоките и услугите (GST) за вашите трансакции по цял свят. Ние следим промените в данъчните закони и поддържаме подробни записи, за да сте винаги в съответствие с изискванията на всеки пазар, на който продавате.",
          "title": "Как помага Noda за спазването на данъчното законодателство?"
        },
        "title": "ЧЗВ"
      },
      "geo": {
        "btn-text": "Преглед на списъка с поддържани банки"
      },
      "hero-data": {
        "subtitle": "merchant of record",
        "text1": "Отключете търговията без граници за вашите цифрови иновации.",
        "text2": "От независими игри до корпоративен софтуер.",
        "title": "Съсредоточете се върху създаването на следващия шедьовър – ние се справяме със сложните задачи!"
      },
      "squad": {
        "additional": {
          "text1": "Денонощна поддръжка на множество езици",
          "text2": "Интелигентна информация, която направлява бизнес решенията ви",
          "text3": "Строги мерки за сигурност за защита на приходите ви",
          "text4": "Редовни технологични актуализации за поддържане на безпроблемна работа"
        },
        "subtitle": "Насоки и подкрепа",
        "text": "Нашата поддръжка е готова да се включи, когато имате нужда от нас. Независимо дали става въпрос за проблрм при плащане късно през нощта, или за въпрос относно вашия акаунт, ние сме на разположение.\n\n От самостоятелни творци до оживени студиа – ние сме тук, за да ви помогнем да успеете на световните пазари. Нашият набор от инструменти включва:",
        "title": "Вашият екип за поддръжка 24/7"
      }
    },
    "newsroom": {
      "title": "Нюзрум"
    },
    "no-code": {
      "features": {
        "custom-payment": "Потребителски страници за плащане в движение",
        "instant": "Незабавни и сигурни транзакции",
        "leverage-ai": "Използвайте AI, за да създадете цялостни брандирани страници за плащане с няколко кликвания.",
        "real-time": "Плащания в реално време, оторизация на платеца чрез банка, безпроблемно обслужване на клиентите.",
        "sell-anything": "Продавайте всичко без уебсайт",
        "tag-title": "КЛЮЧОВИ ФУНКЦИИ",
        "text": "Продавайте цифрови и физически стоки и услуги, без да се затруднявате с продължително разработване и настройка.",
        "title": "Кратък път за увеличаване\nна продажбите на продукти онлайн",
        "turn-any": "Превърнете всеки канал в своя онлайн пазар. Позволете на Noda да управлява целия поток от плащания."
      },
      "hero": {
        "text": "Създавайте персонализирани плащания с AI за минути",
        "title": "Страница За Плащане\nБез Код"
      },
      "how-it-works": {
        "ai-based": "Анализ, базиран на AI",
        "authorize": "Оторизирайте се директно в чата и преминете към функционалността за изграждане на страници.",
        "enter-your": "Въведете заявката си или качете съществуващо описание на продукта. Дайте на чатбота малко време, за да обработи заявката.",
        "make-necessary": "Направете необходимите корекции, одобрете версията, която ви харесва, и започнете да продавате!",
        "payment-page": "Страницата за плащане е готова",
        "preview": "Преглед",
        "tag-title": "как работи",
        "text-first": "Създайте персонализирани страници за плащане за минути с помощта на прост интерфейс за чат с изкуствен интелект.",
        "text-second": "Автоматично генериране на текст и изображения въз основа на данните за вашия продукт. Вграждайте връзки за плащане и QR кодове за напълно функционална страница за плащане.",
        "the-bot": "Ботът генерира пълна страница за плащане въз основа на въведените от вас данни: изображения, текст, функционалност за плащане, QR код.",
        "title": "Изграждане на страница за интелигентно плащане",
        "user-friendly": "Удобен за потребителя интерфейс"
      },
      "monetize": {
        "direct-sales": "Директни продажби",
        "donations": "Дарения",
        "event-tickets": "Билети за събития",
        "games": "Игри и стоки за игри",
        "lean": "Преминаване към нови бизнес модели. Изградете персонализирани страници за плащане и започнете да продавате веднага след като натиснете бутона \"Запази\".",
        "monetize": "Монетизирайте всичко",
        "online-courses": "Онлайн курсове",
        "online-retail": "Онлайн търговия на дребно",
        "tips": "Съвети",
        "travel-packages": "Туристически пакети"
      },
      "product-block": {
        "text": "Персонализирани страници за плащане в рамките на минути. Без разработка, без напред-назад с дизайнери и копирайтъри. Прост, красив и надежден начин вашите клиенти да плащат през различни канали и бизнес модели.",
        "title": "Страница За Плащане Без Код"
      },
      "sell": {
        "are-you": "Изграждате онлайн бизнес от нулата или проучвате нови източници на приходи за съществуващо предприятие?\n\nСвържете се директно с клиентите си, като стартирате продажби по имейл, чрез месинджъри, социални медии, потоци на живо – наистина навсякъде, където можете да споделите връзка към страницата за плащане.",
        "launch": "Стартирайте продажбите с лекота: без уебсайт, без интеграция на плащания, без обратна връзка с разработчици и дизайнери.\n\nПлатформата за разплащания на Noda ще поддържа целия ви поток от транзакции – от предоставянето на търговска сметка до ежедневната обработка на плащанията.",
        "reach": "Достигнете до клиентите си, където и да се намират",
        "secure": "Сигурни незабавни плащания",
        "tag-title": "ПРОДАЖБА БЕЗ УЕБСАЙТ"
      }
    },
    "partners": {
      "available": {
        "list": {
          "item1": {
            "text": "Интегрирайте нашата технология безпроблемно във вашите собствени решения като бял партньор",
            "title": "Бял етикет"
          },
          "item2": {
            "text": "Поканете фирми, използващи препоръчани връзки, като дистрибутор партньор",
            "title": "Дистрибутор"
          },
          "item3": {
            "text": "Работете под нашата марка като франчайз партньор",
            "title": "Франчайз"
          },
          "item4": {
            "text": "Привличане на клиенти от най-висок клас като агент",
            "title": "Агент"
          }
        },
        "subtitle": "разнообразие от опции",
        "title": "Налични партньорства"
      },
      "banking": {
        "item1": "държави",
        "item2": "интегрирани електронни платформи",
        "item3": "разработени цифрови продукти",
        "subtitle": "Изберете вашето перфектно партньорство",
        "text": "Разгледайте различни възможности за партньорство, съобразени с вашите нужди. Независимо дали искате да интегрирате нашата технология, да насочвате други фирми, да използвате нашата марка или да се свържете с клиенти с висока стойност, ние предлагаме идеалния начин за партньорство за вас.",
        "title": "Как работи"
      },
      "customisation": {
        "subtitle": "персонализиран интерфейс",
        "text": "Изборът е ваш, независимо дали искате да разработите свой собствен front-end или да използвате нашите вградени инструменти за потребителски интерфейси (UI). Оформете дизайна си така, че да представя напълно вашата марка и да създаде перфектното пътуване.",
        "title": "Персонали&shy;зиране на марката"
      },
      "hero": {
        "subtitle": "по-добри плащания",
        "text": "Интегрирайте безпроблемно транзакциите за отворено банкиране, получете достъп до аналитични данни и се възползвайте от нашия интуитивен потребителски интерфейс. Насладете се на безпроблемна интеграция на API и прозрачни отчети, за да постигнете успех при търговците.",
        "title": "Помогнете на търговците си да растат с отворено банкиране"
      },
      "reporting": {
        "subtitle": "пълна прозрачност",
        "text": "С помощта на нашия административен център можете да проследявате всички комисиони, като осигурявате ясна и прозрачна отчетност. Безпроблемно контролирайте изплащанията и изплащанията, като получавате пълна видимост и управлявате операциите си с лекота.",
        "title": "Подробен мониторинг и отчитане"
      },
      "technology": {
        "subtitle": "силата на технологиите",
        "text1": "Преди отвореното банкиране традиционните банки имаха монопол върху данните на клиентите. През 2018 г. директивата PSD2 на ЕС задължи банките да споделят информация с оторизирани доставчици от трети страни, като например Noda, със съгласието на клиентите.",
        "text2": "При отвореното банкиране се използват интерфейси за програмиране на приложения (API) за софтуерна комуникация за прехвърляне на данни. Когато потребителите изберат плащане чрез отворено банкиране, те се пренасочват към интерфейса на своята надеждна банка.",
        "text3": "Все повече потребители и търговци по света използват тази нова технология. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">Juniper Research</a> прогнозира, че общата стойност на плащанията чрез отворено банкиране ще нарасне от 57 млрд. долара през 2023 г. до 330 млрд. долара през 2027 г. Това, което някога се е смятало за иновативно, бързо се превръща в широко разпространен метод за плащане.",
        "title": "Отвореното банкиране трансформира платежните системи"
      }
    },
    "plugins": {
      "back-to-plugins": "Обратно към Plugins",
      "bigcommerce": {
        "benefits": {
          "list": {
            "text": "Нашият допълнителен програмен модул WordPress WooCommerce за плащания позволява безпроблемен потребителски опит за вашите клиенти. Това води до по-голяма удовлетвореност на клиентите и по-малко изоставени колички.",
            "text-1": "Нашият допълнителен програмен модул WordPress WooCommerce за плащания позволява безпроблемен потребителски опит за вашите клиенти. Това води до по-голяма удовлетвореност на клиентите и по-малко изоставени колички.",
            "title": "Интуитивен ПО (потребителски опит)",
            "title-1": "Интуитивен ПО (потребителски опит)"
          },
          "title": "Предимствата на Noda за WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Как мога да пробвам този допълнителен програмен модул?",
              "text": "Можете да активирате тестовия режим на допълнителния програмен модул, който ви позволява да симулирате стопански операции."
            },
            "2": {
              "summary": "Вашият допълнителен програмен модул поддържа ли абонаменти в WooCommerce?",
              "text": "Можете да активирате тестовия режим на допълнителния програмен модул, който ви позволява да симулирате стопански операции."
            },
            "3": {
              "summary": "Защо бутонът „Заявка за плащане“ не се показва на моя локален компютър?",
              "text": "Можете да активирате тестовия режим на допълнителния програмен модул, който ви позволява да симулирате стопански операции."
            }
          },
          "title": "Най-често задавани въпроси"
        },
        "hero": {
          "button": "Добавете Noda към WooCommerce",
          "logo": "bigcommerce",
          "text": "Открийте допълнителния програмен модул WordPress на Noda, който позволява отворени банкови плащания за WooCommerce. Инсталирайте и интегрирайте допълнителния програмен модул само с няколко лесни стъпки.",
          "title": "Портал за плащания WordPress WooCommerce с Noda"
        },
        "how": {
          "text": "Търговците, които инсталират допълнителния програмен модул, могат да добавят бутон Noda като метод за плащане на своя уебсайт.",
          "title": "Как работи?"
        },
        "inspiration": "Може да търсите и",
        "integration": {
          "after": "Интеграцията отнема време само за няколко кликвания и не изисква разработчици в екипа ви. С Noda търговците могат плавно да добавят плащания с отворено банкиране като една от възможностите за плащане в WooCommerce.",
          "before": "За да настроят допълнителния програмен модул WordPress WooCommerce за плащания с Noda, търговците трябва да следват следните лесни стъпки:",
          "button": {
            "text": "Изтегляне на ръководството"
          },
          "steps": {
            "1": "Инсталирайте архивния файл в панела на администратора на WooCommerce. Така ще настроите допълнителния програмен модул за вашия уебсайт.",
            "2": "Добавете клавиши API (приложния програмен интерфейс), които са достъпни чрез концентратора на Noda, след като сте приключили с регистрирането.",
            "3": "Сега WeCommerce и Noda са свързани."
          },
          "title": "Интегриране на Noda с WooCommerce"
        },
        "what-is-it": {
          "text": "WeCommerce е софтуер с отворен код, разработен за WordPress, който позволява на стопанските единици да създават уебсайтове за електронна търговия на програмния език PHP. Noda предлага допълнителен програмен модул , който улеснява плащанията с отворено банкиране чрез портала за плащания WooCommerce на WordPress",
          "title": "Какво представлява това?"
        }
      },
      "details": "FAQ",
      "faq": {
        "development-skills": {
          "content": "Не, нашите добавки са предназначени за лесна инсталация, без да изискват специализирани технически умения. Ръководствата стъпка по стъпка ще ви преведат през простия процес. Ако срещнете затруднения, нашият екип за поддръжка е готов да ви помогне.",
          "title": "Имам ли нужда от умения за разработка, за да инсталирам тези добавки?"
        },
        "how-secure": {
          "content": "Всички плъгини на Noda се придържат към строги стандарти за сигурност и регулаторни изисквания за отворено банкиране. Транзакциите са защитени с многофакторно удостоверяване и криптиране на данни, за да се защитят както търговците, така и клиентите.",
          "title": "Колко сигурни са тези добавки за плащане?"
        },
        "plugins-compatible": {
          "content": "Приставките на Noda са специално проектирани за отворени банкови плащания, позволявайки на вашите клиенти да плащат директно от своите банкови сметки. Това осигурява повишена сигурност и по-ниски транзакционни разходи в сравнение с традиционните методи на плащане.",
          "title": "Приставките на Noda съвместими ли са с всички методи на плащане?"
        },
        "subtitle": "FAQ",
        "title": "Най-често задавани въпроси",
        "troubleshooting": {
          "content": "Нашият екип за поддръжка е на разположение, за да ви помогне при инсталиране, конфигуриране и отстраняване на неизправности. Просто се свържете с нас чрез каналите за поддръжка, изброени на всяка страница с добавки, и ние ще се радваме да ви помогнем.",
          "title": "Какво ще стане, ако имам нужда от помощ при инсталиране или отстраняване на неизправности? "
        },
        "what-is-required": {
          "content": "За да използвате който и да е плъгин на Noda, ще трябва да създадете акаунт в Noda, да завършите процеса на включване и да получите API ключове. Специфичните изисквания за всяка платформа са описани подробно на страниците на отделните добавки.",
          "title": "Какво е необходимо за използване на плъгини на Noda? "
        }
      },
      "fqa": "fqa",
      "hero": {
        "button": "Свържете се с нашия екип",
        "subtitle": "Интегрирайте Noda за минути с нашите готови добавки. Рационализирайте плащанията с опростено потребителско изживяване, безпроблемна интеграция и подобрена сигурност на отвореното банкиране.",
        "title": "Безпроблемни отворени банкови плащания за вашата платформа за електронна търговия"
      },
      "info": {
        "bigcommerce": {
          "subtitle": "Очаквайте скоро",
          "text": "Допълнителният програмен модул BigCommerce на Noda опростява добавянето на плащания с отворено банкиране към вашия уебсайт с BigCommerce. Бърза инсталация за оптимизиран процес на плащания.",
          "title": "BigCommerce"
        },
        "magento": {
          "text": "Открийте допълнителния програмен модул Magento на Noda. научете как да интегрирате Noda като опция за плащане с Magento на вашия уебсайт за електронна търговия и издигнете нивото на вашия бизнес чрез плащания с отворено банкиране.",
          "title": "Magento"
        },
        "opencart": {
          "text": "Научете как да интегрирате Noda като опция за плащане с OpenCart на вашия уебсайт за електронна търговия. Опростете вашите плащания с отворено банкиране.",
          "title": "OpenCart"
        },
        "prestashop": {
          "text": "Интегрирайте плащания за отворено банкиране с допълнителния програмен модул на Noda за PrestaShop. Инсталирайте Noda като опция за плащане с PrestaShop на вашия уебсайт за електронна търговия с бърза и лесна настройка.",
          "title": "PrestaShop"
        },
        "step-title": "Стъпка",
        "woocommerce": {
          "text": "Открийте допълнителния програмен модул WordPress на Noda, който позволява плащания с отворено банкиране за WooCommerce. Инсталирайте и интегрирайте допълнителния програмен модул само в няколко лесни стъпки.",
          "title": "WooCommerce"
        }
      },
      "integration": {
        "btn-request": "Заявка за интеграция",
        "btn-view": "API Документация",
        "description": "Ние непрекъснато разширяваме нашите плъгини – свържете се с нас за персонализирани интеграции или проверете нашите API документи за опции за разработка.",
        "title": "Заявка за интеграция"
      },
      "magento": {
        "benefits": {
          "button": {
            "text": "Свържете се с нашия екип"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Интеграцията ни за електронна търговия с Magento осигурява плавно потребителско изживяване за вашите клиенти. Това води до по-голяма удовлетвореност на клиентите и ниско ниво на изоставяне на количката.",
              "title": "Потребителски опит ПО (потребителски опит)"
            },
            "2": {
              "icon": "map",
              "text": "Търговците могат да инсталират допълнителните програмни модули на Noda, без да разполагат с екип от разработчици или технически умения.",
              "title": "Плавна интеграция"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Функционалността на отвореното банкиране гарантира сигурността на клиентите и търговците. Многофакторната проверка е правно изискване съгласно европейския регламент.",
              "title": "Сигурност"
            },
            "4": {
              "icon": "all_match",
              "text": "Обработката на плащанията в Magento с отворено банкиране е по-бърза и по-достъпна за търговците, като осигурява по-бързо финализиране и получаване на средствата.",
              "title": "Ефективност"
            }
          },
          "title": "Предимствата на Noda за Magento"
        },
        "hero": {
          "button": "Добавете Noda към Magento",
          "logo": "magento",
          "text": "Открийте допълнителния програмен модул Magento на Noda. Научете се как да интегрирате Noda като възможност за плащане с Magento на вашия уебсайт за електронна търговия.",
          "title": "Портал за плащания Magento с Noda"
        },
        "how": {
          "text": "Търговците, които инсталират допълнителния програмен модул, могат да добавят Noda като един от методите за плащане с Magento, който клиентите могат да използват при окончателното плащане.",
          "title": "Как работи?"
        },
        "inspiration": "Може да търсите и",
        "integration": {
          "after": "Интеграцията отнема време само за няколко кликвания и не изисква напреднали технически умения. С Noda търговците могат плавно да добавят функционалност за отворено банкиране като решение за електронна търговия с Magento.",
          "before": "За да настроят интеграцията на Magento с Noda, търговците трябва да следват следните лесни стъпки:",
          "steps": {
            "1": "Инсталирайте архивния файл в панела на администратора на Magento. Така ще настроите допълнителния програмен модул за вашия уебсайт.",
            "2": "Добавете клавиши API (приложния програмен интерфейс), които са достъпни чрез концентратора на Noda, след като сте приключили с регистрирането.",
            "3": "Сега Magento и Noda са свързани"
          },
          "title": "Интеграция на портала Magento за плащане"
        },
        "meta": {
          "description": "Открийте допълнителния програмен модул Magento на Noda. Научете се как да интегрирате Noda като възможност за плащане с Magento на вашия уебсайт за електронна търговия.",
          "title": "Портал за плащания Magento с Noda"
        },
        "what-is-it": {
          "text": "Magento е платформа за електронна търговия, изградена на базата на технология с отворен код на програмния език PHP. Noda предлага допълнителен програмен модул, който позволява плащания с отворено банкиране за уебсайтове за електронна търговия.",
          "title": "Какво представлява това?"
        }
      },
      "opencart": {
        "benefits": {
          "button": {
            "text": "Свържете се с нашия екип"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Плащанията с отворено банкиране позволяват опростено потребителско изживяване за вашите клиенти, което води до по-малко изоставяне на количките и по-голяма удовлетвореност на клиентите.",
              "title": "Интуитивен ПО (потребителски опит)"
            },
            "2": {
              "icon": "map",
              "text": "С помощта на Noda търговците могат да инсталират допълнителния програмен модул, без да разполагат с екип от разработчици.",
              "title": "Лесна интеграция"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Функционалността на отвореното банкиране гарантира сигурността на клиентите и търговците. Многофакторната проверка е правно изискване в европейската нормативна уредба.",
              "title": "Сигурност"
            },
            "4": {
              "icon": "all_match",
              "text": "Обработката на плащанията в OpenCart с Noda е по-бърза и по-достъпна за търговците, като осигурява по-бързо финализиране на плащанията и получаване на средства.",
              "title": "Ефективност"
            }
          },
          "title": "Предимствата на Noda за OpenCart"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Какви са изискванията за допълнителния програмен модул OpenCart?",
              "text": "За да интегрирате успешно допълнителния програмен модул OpenCart на Noda, моля, уверете се, че разполагате най-малко с версия 7.0.3 на PHP. Поддържа се всяка версия на PHP между 7.0.3 и 8.2.x. Освен това ви е необходима версия на WordPress от поне 3. Можете лесно да откриете версията си, като проверите в долната част на панела за администратора на OpenCart. За да използвате допълнителния програмен модул на Noda в работен режим, трябва да бъдете регистрирани в Noda."
            },
            "2": {
              "summary": "Как да интегрирам този допълнителен програмен модул с Noda?",
              "text": "За да интегрирате допълнителния програмен модул OpenCart, инсталирайте архивния файл от панела на администратора на OpenCart и добавете клавишите на API (приложен програмен интерфейс), достъпни в NodaHub (концентратора), след като се регистрирате."
            },
            "3": {
              "summary": "Как да тествам този допълнителен програмен модул?",
              "text": "За да тествате този допълнителен програмен модул, активирайте тестовия режим с помощта на клавишите Sandbox (клавиши, дефинирани за симулация) в концентратора на Noda. Това ще ви позволи да извършите пробен опит."
            }
          },
          "title": "Най-често задавани въпроси"
        },
        "hero": {
          "button": "Добавете Noda към OpenCart",
          "logo": "opencart",
          "text": "Открийте допълнителния програмен модул OpenCart на Noda. Научете се как да интегрирате Noda като възможност за плащане с OpenCart на вашия уебсайт за електронна търговия.",
          "title": "Портал за плащане OpenCart с Noda"
        },
        "how": {
          "text": "Търговците, които са инсталирали допълнителния програмен модул, ще имат бутон Noda на своя уебсайт като опция за окончателно плащане за клиентите.",
          "title": "Как работи?"
        },
        "inspiration": "Може да търсите и",
        "integration": {
          "after": "Целият процес отнема време само за няколко кликвания и не изисква технически умения. С допълнителния програмен модул OpenCart за плащане на Noda, търговците могат плавно да добавят функционалността на отвореното банкиране към своя платежен арсенал.",
          "before": "За да настроят интеграцията на портала за плащане OpenCart, търговците трябва да следват следните лесни стъпки:",
          "steps": {
            "1": "Инсталирайте архивния файл в панела на администратора на OpenCart. Така ще настроите допълнителния програмен модул за вашия уебсайт.",
            "2": "Добавете клавиши API (приложния програмен интерфейс), които са достъпни чрез концентратора на Noda, след като сте приключили с регистрирането.",
            "3": "Сега OpenCart и Noda са свързани"
          },
          "title": "Интегриране на OpenCart с Noda"
        },
        "meta": {
          "description": "Открийте допълнителния програмен модул OpenCart на Noda. Научете се как да интегрирате Noda като възможност за плащане с OpenCart на вашия уебсайт за електронна търговия.",
          "title": "Портал за плащане OpenCart с Noda"
        },
        "what-is-it": {
          "text": "OpenCart е безплатна платформа за електронна търговия с отворен код за продажба на продукти онлайн. Тя е базирана на програмния език PHP и базата данни MySql. Допълнителният програмен модул на Noda за уебсайтове за електронна търговия позволява на търговците да добавят плащания чрез отворено банкиране като един от методите за плащане в OpenCart.",
          "title": "Какво представлява това?"
        }
      },
      "platforms": "Поддържани платформи за електронна търговия",
      "pre-footer": {
        "button": "Свържете се с нашия екип",
        "single-page-plugin": {
          "button": "Свържете се с нашия екип",
          "subtitle": "Как да се интегрираме",
          "text": "Свържете се с нас, за да научите повече за работата с партньори.",
          "title": "Готови ли сте да се свържете?"
        },
        "subtitle": "Как да се интегрираме",
        "text": "Свържете се с нас, за да научите повече за работата с партньори.",
        "title": "Готови ли сте да се свържете?"
      },
      "prestashop": {
        "benefits": {
          "button": {
            "text": "Свържете се с екипа ни"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Плащанията чрез отворено банкиране позволяват опростен потребителски опит за вашите клиенти. Това води до по-голяма удовлетвореност на клиентите и по-малко изоставени колички.",
              "title": "Опростеност"
            },
            "2": {
              "icon": "map",
              "text": "Търговците могат да инсталират допълнителните програмни модули на Noda, без да разполагат с екип от разработчици или технически умения.",
              "title": "Плавна интеграция"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Функционалността на отвореното банкиране гарантира сигурността на клиентите и търговците. Многофакторната проверка е правно изискване съгласно европейския регламент.",
              "title": "Сигурност"
            },
            "4": {
              "icon": "all_match",
              "text": "Плащанията с отворено банкиране са по-бързи и по-достъпни за търговците, като осигуряват по-бързо финализиране на плащанията и получаване на средства.",
              "title": "Ефективност"
            }
          },
          "title": "Предимствата на Noda за PrestaShop"
        },
        "hero": {
          "button": "Noda да PrestaShop",
          "logo": "prestashop",
          "text": "Открийте допълнителния програмен модул PrestaShop на Noda Научете как да интегрирате Noda с опцията за плащане PrestaShop на вашия уебсайт за електронна търговия.",
          "title": "Портал за плащания PrestaShop с Noda"
        },
        "how": {
          "text": "Търговците, които са инсталирали допълнителния програмен модул, ще имат бутон Noda, който се появява на техния уебсайт, когато клиентите извършват проверка.",
          "title": "Как работи?"
        },
        "inspiration": "Може да търсите и",
        "integration": {
          "after": "Интеграцията отнема време само за няколко кликвания и не изисква наличието на разработчици в екипа ви. С допълнителния програмен модул PrestaShop на Noda за плащания, търговците могат без усилия да повдигнат нивото на стратегията си за плащане с отворено банкиране.",
          "before": "За да изпълнят интеграцията на PrestaShop с Noda, търговците трябва да следват следните лесни стъпки:",
          "steps": {
            "1": "Инсталирайте архивния файл в панела на администратора на PrestaShop. Така ще настроите допълнителния програмен модул за вашия уебсайт.",
            "2": "Добавете API клавиши, които са достъпни чрез концентратора на Noda след приключване на процеса на регистриране.",
            "3": "Сега PrestaShop и Noda са свързани."
          },
          "title": "Интеграция на портала за плащания PrestaShop"
        },
        "what-is-it": {
          "text": "PrestaShop е платформа с отворен код, която позволява на търговците да създават и разработват собствени уебсайтове за електронна търговия на програмния език PHP. Допълнителният програмен модул на Noda позволява на търговците да добавят функционалността на отвореното банкиране като един от методите за плащане с PrestaShop.",
          "title": "Какво е това?"
        }
      },
      "section": {
        "subtitle": "Издигнете нивото на бизнеса си с допълнителните програмни модули на Noda за отворено банкиране за платформата за електронна търговия, която използвате. Оптимизирайте плащанията с опростен потребителски опит, плавна интеграция, сигурност и ефективност на отвореното банкиране.",
        "title": "Увеличете продажбите си с допълнителните програмни модули на Noda за отворено банкиране"
      },
      "soon": "Очаквайте скоро",
      "woocommerce": {
        "benefits": {
          "button": {
            "text": "Свържете се с екипа ни"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Допълнителният програмен модул WordPress WooCommerce за плащания позволява безпроблемен потребителски опит за вашите клиенти. Това води до по-голяма удовлетвореност на клиентите и по-малко изоставени колички.",
              "title": "Интуитивен ПО (потребителски опит)"
            },
            "2": {
              "icon": "map",
              "text": "Търговците могат да инсталират допълнителните програмни модули на Noda, без да разполагат с екип от разработчици или технически умения.",
              "title": "Лесна интеграция"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Плащанията с отворено банкиране гарантират сигурност за клиентите и търговците. Многофакторната проверка е правно изискване съгласно европейския регламент.",
              "title": "Сигурност"
            },
            "4": {
              "icon": "all_match",
              "text": "Обработката на плащанията в WooCommerce с отворено банкиране е по-бърза и по-достъпна за търговците, като осигурява по-бързо финализиране на плащанията и получаване на средства.",
              "title": "Ефективност"
            }
          },
          "title": "Предимства на Noda за WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Какви са изискванията за допълнителния програмен модул WooCommerce?",
              "text": "За да интегрирате успешно допълнителния програмен модул WooCommerce на Noda, моля, уверете се, че имате най-малко версия 7.0.3. Версия на PHP; версия 5.3 на WordPress и най-малко версия 4.5 на WooCommerce, за да гарантирате съвместимост. За да използвате допълнителния програмен модул в производствен режим, вие трябва да бъдете регистрирани с Noda."
            },
            "2": {
              "summary": "Как да интегрирам този допълнителен програмен модул с Noda?",
              "text": "За да интегрирате този допълнителен програмен модул WooCommerce, инсталирайте архивния файл от панела на администратора на WooCommerce и добавете достъпните API клавиши в NodaHub (концентратора) след регистриране."
            },
            "3": {
              "summary": "Как да тествам този допълнителен програмен модул?",
              "text": "За да тествате този допълнителен програмен модул, активирайте тестовия режим с помощта на клавишите Sandbox (клавиши, дефинирани за симулация) в концентратора на Noda. Това ще ви позволи да извършите пробен опит."
            },
            "4": {
              "summary": "Този допълнителен програмен модул поддържа ли абонаменти за WooCommerce?",
              "text": "Не, този допълнителен програмен модул не поддържа абонаменти за WooCommerce."
            }
          },
          "title": "Най-често задавани въпроси"
        },
        "hero": {
          "button": "Noda да WooCommerce",
          "logo": "woocommerce",
          "text": "Открийте допълнителния програмен модул WordPress на Noda. Научете как да интегрирате Noda като метод за плащане в WooCommerce за вашия бизнес за електронна търговия.",
          "title": "Портал за плащания WordPress WooCommerce с Noda"
        },
        "how": {
          "text": "Търговци, които инсталират допълнителния програмен модул, могат да добавят бутон Noda на своя уебсайт като метод за плащане.",
          "title": "Как работи?"
        },
        "inspiration": "Може да търсите и",
        "integration": {
          "after": "Интеграцията отнема време само за няколко кликвания и не изисква програмисти в екипа ви. С Noda, търговците могат без усилия да добавят плащания с отворено банкиране като една от техните опции за плащане в WooCommerce.",
          "before": "За да конфигурират допълнителния програмен модул WordPress WooCommerce за плащания с Noda, търговците трябва да следват тези лесни стъпки:",
          "steps": {
            "1": "Инсталирайте архивния файл в панела на администратора на WooCommerce. Така ще настроите допълнителния програмен модул за вашия уебсайт.",
            "2": "Добавете API клавиши, които са достъпни чрез концентратора на Noda след приключване на процеса на регистриране.",
            "3": "Сега WooCommerce и Noda са свързани."
          },
          "title": "Интеграция на Noda с WooCommerce"
        },
        "what-is-it": {
          "text": "WooCommerce е софтуер с отворен код, създаден за WordPress, който позволява на стопанските единици да създават уебсайтове за електронна търговия посредством програмния език PHP. Noda предлага допълнителен програмен модул, който улеснява плащанията с отворено банкиране като портал за плащане WordPress WooCommerce.",
          "title": "Какво е това?"
        }
      }
    },
    "policy": {
      "last-update": "Последна актуализация: <data>12 август 2024 г.</data>",
      "section-1": {
        "text-1": "С използването на нашата услуга Вие се съгласявате с Условията за ползване и настоящата Политика за поверителност.",
        "text-2": "Ваша отговорност по силата на споразумението между Вас и нас е да се запознаете внимателно с настоящата Политика за поверителност и да предоставите точни данни за себе си.",
        "text-3": "Наша отговорност е да Ви предоставим възможно най-ясната и актуална информация за това как обработваме данните Ви.",
        "title": "1. Отговорности"
      },
      "section-2": {
        "text": "Започваме да събираме личните Ви данни, когато започнете да използвате услугата или уебсайта ни. Събираме ги, за да можем да Ви предоставим услугата ни и за други цели, както е посочено в раздел 3 по-долу.",
        "title": "2. Кога събираме данни за Вас"
      },
      "section-3": {
        "header-1": "Цел на използването на личните данни",
        "header-2": "Категория на субекта на данни",
        "header-3": "Лични данни",
        "header-4": "Правно основание",
        "header-5": "Срок на съхранение",
        "t-body-10": {
          "legal": "Спазване на законово задължение",
          "personal": "Документи за самоличност, биометрични снимки и други биометрични идентификационни данни, източник на средства, информация от инструменти за съответствие, адрес, сметки за комунални услуги, хронология на трансакциите, регистрационни файлове, автобиографии, информация и документи за миграции, политически статус, данни за банкова сметка, свързани уебсайтове, свързана корпоративна структура, оценка на риска",
          "purpose": "Мониторинг на трансакции и съответствие",
          "subject": "Лица в структурата на партньори и бизнес клиенти, действителни собственици, платци на търговците",
          "term": "5 години след прекратяване на сътрудничество"
        },
        "t-body-11": {
          "legal": "Основателни причини за разработване на услугата",
          "personal": "Пълно име, имейл, IBAN, данни за трансакции, регистри, IP, данни за сесиите, местоположение, информация за операционната система, тип устройство, информация за влизанията, статистика за това как използвате услугата",
          "purpose": "Разработване и тестване на услугата и нови продукти",
          "subject": "Платци (физически лица), служители и индивидуални подизпълнители на Noda, представители на консултанти, партньори и търговци",
          "term": "До 5 години, след като данните са станали ненужни"
        },
        "t-body-12": {
          "legal": "Съгласие",
          "personal": "Пълно име, списък на трансакциите, парична сума, валута, час на плащане/дата, баланс по сметката, име на търговеца, вътрешни идентификатори, IBAN, среден оборот на платеца, както и бисквитки и други способи за проследяване. За повече информация моля, вижте нашата <a href=\"https://noda.live/about/legal-privacy/cookies\">Политика за бисквитките</a>. ",
          "purpose": "Продукт DE (Data Enrichment) за разработване на анализи. Това ще помогне на нас и нашите партньори (включително търговци) да Ви предоставим подходящи услуги, по-добро потребителско изживяване и по-целенасочени реклами, както и персонализирани услуги.",
          "subject": "Платци (физически лица)",
          "term": "<p>До 5 години.</p><p>Срокът за съхранение на бисквитките е вписан в <a href=\"https://noda.live/about/legal-privacy/cookies\">Политиката за бисквитките</a>.</p>"
        },
        "t-body-13": {
          "legal": "<p>Основателни причини за популяризиране на услугите на Noda</p><p>Съгласие</p>",
          "personal": "Пълно име, имейл адрес, комуникация",
          "purpose": "Изпращане на маркетингови имейли",
          "subject": "Лица за контакт на бизнес клиенти и партньори",
          "term": "Докато сътрудничеството е в ход и в продължение на 5 години след прекратяването му (или ако не е установено сътрудничество)"
        },
        "t-body-14": {
          "legal": "<p>Основателни причини за популяризиране на услугите на Noda</p><p>Съгласие</p>",
          "personal": "Пълно име, данни от социални медии, регистрационен номер, местоположение, бисквитки и подобни способи за проследяване (вижте <a href=\"https://noda.live/about/legal-privacy/cookies\">политика за бисквитките</a>), снимка, имейл адрес,  ",
          "purpose": "Провеждане на дигитални кампании",
          "subject": "Лица за контакт на бизнес клиенти и партньори",
          "term": "Докато сътрудничеството е в ход и в продължение на 5 години след прекратяването му (или ако не е установено сътрудничество)"
        },
        "t-body-15": {
          "legal": "Основателни причини за популяризиране на услугите на Noda",
          "personal": "Пълно име, имейл, телефонен номер, месторабота, описание на комуникацията",
          "purpose": "Развитие на бизнеса",
          "subject": "Лица за контакт на партньори, потенциални партньори, бизнес клиенти и потенциални бизнес клиенти",
          "term": "Докато сътрудничеството е в ход и в продължение на 5 години след прекратяването му (или ако не е установено сътрудничество)"
        },
        "t-body-16": {
          "legal": "Основателни причини за развитие на услугата в съответствие със състоянието на пазара",
          "personal": "Пълно име, прякор, имейл, пол, географско положение, IP, трудов статус, резултати от тестове и изследвания, видеозаписи",
          "purpose": "Извършване на проучвания и създаване на по-добро впечатление на потребителите",
          "subject": "Участници в изследвания, тестери",
          "term": "До 10 години"
        },
        "t-body-17": {
          "legal": "<p>Основателни причини за гарантиране на сигурността и конкурентното предимство на Noda</p><p>Спазване на правно задължение</p>",
          "personal": "Информация за устройството Ви и друга техническа информация: Вашия IP адрес, часова зона, геолокация, браузър/платформа, използвани за достъп до услугата",
          "purpose": "Осигуряване на сигурност и откриване на измами",
          "subject": "Всички потребители на нашата услуга, уебсайт и продукти",
          "term": "До 10 години"
        },
        "t-body-18": {
          "legal": "Сключване на договор",
          "personal": "Име, фамилия, имейл, телефон",
          "purpose": "Сключване на споразумения",
          "subject": "Представители на доставчици и клиенти",
          "term": "До 10 години след прекратяване"
        },
        "t-body-19": {
          "legal": "<p>Изпълнение на договор</p><p>Основателни причини за получаване на доходи</p>",
          "personal": "Име, фамилия, имейл, телефон, банкови данни и данни за плащане, информация от фактури, лични данни, договори и пълномощни",
          "purpose": "Плащане на фактури",
          "subject": "Представители на доставчици, консултанти и индивидуални доставчици на услуги",
          "term": "До 10 години след плащането на фактурата"
        },
        "t-body-1": {
          "legal": "Сключване и изпълнение на договор",
          "personal": "Пълно име, дата на раждане, адрес, имейл, телефон, финансови и банкови данни (включително, без изреждането да е изчерпателно, информация за банкова или платежна сметка, данни за трансакции, данни за заеми и инвестиции), информация за банка или друг доставчик на сметки и други данни, които могат да ни бъдат предоставени от доставчик на платежни сметки ",
          "purpose": "Иницииране и обработка на онлайн плащания",
          "subject": "Платци (физически лица)",
          "term": "Докато се използва услугата и до 10 години след прекратяване на предоставянето на услугата"
        },
        "t-body-20": {
          "legal": "Основателни причини за продължаване функционирането на бизнеса",
          "personal": "Име, фамилия, имейл, телефон",
          "purpose": "Използване на услуги на трети страни",
          "subject": "Представители на доставчици, консултанти и индивидуални доставчици на услуги",
          "term": "До 10 години след прекратяване на сътрудничеството"
        },
        "t-body-21": {
          "legal": "<p>Основателни причини за продължаване функционирането на бизнеса</p><p>Спазване на правно задължение</p>",
          "personal": "Име, фамилия, имейл, телефон, идентификационен код, адрес, информация за връзката със съответните дружества",
          "purpose": "Извършване на корпоративни сделки",
          "subject": "Представители и служители на съответните дружества и участващите дружества",
          "term": "Докато съществува съответното дружество и до 10 – 80 години след това в зависимост от местните изисквания"
        },
        "t-body-22": {
          "legal": "Законни интереси за защита на позицията на Noda",
          "personal": "Всички лични данни, необходими за разрешаването на съответния конфликт или съдебен спор",
          "purpose": "Разрешаване на конфликти",
          "subject": "Всички субекти на данни",
          "term": "Докато съществува съответен конфликт и до 10 години след разрешаването му"
        },
        "t-body-23": {
          "legal": "Спазване на правно задължение",
          "personal": "Всички лични данни, които се съдържат в документите, подлежащи на изискванията за архивиране",
          "purpose": "Архивиране и съхраняване на документи",
          "subject": "Всички субекти на данни",
          "term": "Въз основа на местните изисквания"
        },
        "t-body-2": {
          "legal": "Сключване и изпълнение на договор",
          "personal": "Пълно име, имейл, телефонен номер, комуникация",
          "purpose": "Иницииране и обработка на онлайн плащания",
          "subject": "Представители на бизнес клиенти, които използват платежни услуги на Noda",
          "term": "Докато се използва услугата и до 10 години след прекратяване на предоставянето на услугата"
        },
        "t-body-3": {
          "legal": "<p>Сключване и изпълнение на договор</p><p>Основателни причини на Noda да спазва изискванията на инфраструктурата за обработка на карти</p>",
          "personal": "Данни за трансакции, номер на карта, данни за срок на валидност, място на плащане, сума на трансакция, честота на трансакциите, закупени услуги или стоки, IP, имейл, допълнителна информация за покупката",
          "purpose": "Предоставяне на услуги за обработка на карти",
          "subject": "Платци (физически лица)",
          "term": "Докато се използва услугата и до 10 години след прекратяване на предоставянето на услугата"
        },
        "t-body-4": {
          "legal": "Сключване и изпълнение на договор",
          "personal": "Пълно име, имейл, телефон, представлявана банка или доставчик на платежни услуги",
          "purpose": "Предоставяне на услуги за обработка на карти",
          "subject": "Представители на партньори",
          "term": "Докато се използва услугата и до 10 години след прекратяване на предоставянето на услугата"
        },
        "t-body-5": {
          "legal": "<p>Сключване и изпълнение на договор</p><p>Спазване на правно задължение</p>",
          "personal": "Информация за банкова сметка, имейл и данни за съответствие, както е посочено по-долу",
          "purpose": "Присъединяване на търговци",
          "subject": "Представители на търговци, лица, свързани с корпоративната структура на търговци",
          "term": "Докато сътрудничеството е в сила и до 10 години след прекратяването му"
        },
        "t-body-6": {
          "legal": "<p>Основателни причини от предоставяне на възможност на крайните потребители да използват услугата</p><p>Спазване на правно задължение</p>",
          "personal": "Пълно име, дата на раждане, адрес, имейл, телефон, информация за трансакции, вътрешен референтен номер, IBAN, информация за използвания търговец, данни за плащания, регистрационни файлове, информация за списъци за отписване",
          "purpose": "Предоставяне на услуги за поддръжка на клиенти",
          "subject": "Платци (физически лица)",
          "term": "Докато се осъществява комуникацията и до 10 години след разрешаването на проблема"
        },
        "t-body-7": {
          "legal": "<p>Изпълнение на договор</p><p>Основателни причини за предоставяне на качествена услуга на клиентите</p>",
          "personal": "Всички лични данни, предоставени чрез канали за комуникация, включително чатбот",
          "purpose": "Предоставяне на услуги за бизнес поддръжка",
          "subject": "Представители на бизнес клиенти или партньори, които използват платежните услуги на Noda или си сътрудничат с Noda",
          "term": "Докато се осъществява комуникацията и до 10 години след разрешаването на проблема"
        },
        "t-body-8": {
          "legal": "Основателни причини за предоставяне на качествена услуга на клиентите",
          "personal": "Пълно име, имейл, телефон",
          "purpose": "Уведомления за актуализации",
          "subject": "Представители и лица за контакт на бизнес клиенти",
          "term": "До 10 години след изпращане на уведомлението"
        },
        "t-body-9": {
          "legal": "<p>Спазване на законово задължение<p></p>Основателни причини за установяване на партньорства с други фирми</p>",
          "personal": "Документи за самоличност, биометрични снимки и други биометрични идентификационни данни, източник на средства, информация от инструменти за съответствие, адрес, сметки за комунални услуги, хронология на трансакциите, регистрационни файлове, автобиографии, информация и документи за миграции, политически статус, данни за банкова сметка, свързани уебсайтове, свързана корпоративна структура, оценка на риска, информация за данъчни плащания",
          "purpose": "Проверки за спазване на задълженията на Noda за присъединяване на партньори и спазване на изискванията на партньорите, проверки за спазване на изискванията от страна на платците на търговците ",
          "subject": "Лица в корпоративната структура на Noda, лица в структурата на партньори и бизнес клиенти, действителни собственици, платци на търговци",
          "term": "От 5 до 10 години след прекратяване на сътрудничество"
        },
        "text": "В зависимост от начина, по който решите да използвате услугата, или от това дали сте се абонирали за нея, ние можем да използваме следните данни за Вас съгласно описанието по-долу:",
        "text-bottom": "Независимо дали предоставянето на лични данни е необходимо за спазване на законово задължение или за сключване/изпълнение на договор, но Вие не ни предоставите необходимата информация, ние имаме право да откажем предоставянето на съответната Услуга, сключването на договор или извършването на договор без никакви отрицателни правни последици.",
        "title": "3. Данни, които събираме, цели, правно основание и условия за съхранение"
      },
      "section-4": {
        "list-1": {
          "item-1": "Доставчици на платежни сметки и други подобни услуги (банки, издатели на карти и др. – „<b>партньори</b>“); ",
          "item-2": "Трети страни и услуги, които сте избрали да използвате във връзка с услугата (например сайтове за електронна търговия, чрез които използвате нашата услуга, или „<b>търговци</b>“);",
          "item-3": "Нашите доверени партньори за агрегиране на данни (лицензирани платформи за отворено банкиране);",
          "item-4": "Дружествата от нашата група;",
          "item-5": "Нашите доставчици на услуги, като счетоводство, одитори, услуги за съхранение и обработка на данни, доставчици на услуги за онлайн комуникация и сътрудничество, доставчици на правни услуги, доставчици на услуги за борба с прането на пари и проверка за санкции, услуги за мониторинг за борба с измамите, бази данни с корпоративни данни, доставчици на счетоводни услуги, разработчици и тестери, доставчици на маркетингови услуги, социални медии, платформи за електронна търговия и други.",
          "item-6": "Регулаторни, надзорни органи, съдилища и други упълномощени публични или подобни органи (като омбудсмани, финансови регулатори, регулатори на хазартната индустрия)."
        },
        "list-2": {
          "item-1": "Вие или Вашият работодател;",
          "item-2": "Търговци;",
          "item-3": "Платформа за електронна търговия, социални медии и търсачки;",
          "item-4": "Регулаторни, надзорни органи, съдилища и други упълномощени публични или подобни органи (като омбудсмани, финансови регулатори, регулатори на хазартната индустрия);",
          "item-5": "Доставчици на услуги за борба с прането на пари и проверка за санкции, услуги за мониторинг за борба с измамите;",
          "item-6": "Организатори на събития (като конференции, семинари и други);",
          "item-7": "Професионални асоциации;",
          "item-8": "Публични регистри и доставчици на услуги за съответствие."
        },
        "text-1": "За да можем ефективно да предоставяме нашата услуга, трябва да си партнираме с трети страни и затова може да обменяме Ваши данни с:",
        "text-2": "Получаваме Ваши лични данни и от:",
        "title": "4. Получатели и източници на данните Ви"
      },
      "section-5": {
        "text": "Когато Noda прехвърля личните Ви данни извън ЕС или ЕИП, ние разчитаме на гаранциите, предвидени в приложимите правни актове, например както е предвидено в Общия регламент относно защитата на данните (ОРЗД) на ЕС: решенията на Европейската комисия относно адекватността (член 45 от ОРЗД), стандартните договорни клаузи и други гаранции, предвидени в членове 46 и 49 от ОРЗД. Ако личните данни се прехвърлят в САЩ, Noda може да разчита на съответната действаща рамка за предаване на лични данни. В определени случаи, в зависимост от участващото юридическо лице на Noda, същата може да разчита и на Приложението за международно прехвърляне на данни на Обединеното кралство към Стандартните договорни клаузи на Комисията на ЕС.",
        "title": "5. Международни прехвърляния на личните Ви данни"
      },
      "section-6": {
        "list": {
          "item-1": "Право да знаете какви данни събираме за Вас и как ги обработваме. Можете също така да прочетете как използваме личните Ви данни в раздел 3.",
          "item-2": "Право да поискате изтриване на определени данни. Моля, имайте предвид, че при такова искане може да не сме в състояние да Ви предоставим услугата (изцяло или частично).",
          "item-3": "Ограничаване на обработката на данните Ви, възразяване срещу обработката на личните Ви данни и оттегляне на съгласието Ви, когато е приложимо, без това да засяга законосъобразността на обработката, основана на съгласието преди неговото оттегляне.",
          "item-4": "Право да не ни предоставяте никакви лични данни. В този случай може да не сме в състояние да Ви предоставим изцяло или частично услугата ни."
        },
        "text-1": "Имате следните права по отношение на личните си данни:",
        "text-2": "Ако не сте доволни от начина, по който обработваме личните Ви данни, винаги можете да подадете жалба до нас, като я изпратите писмено на адрес <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>. Ако смятате, че не сме в състояние да обработим искането Ви в съответствие с приложимото законодателство, можете да подадете жалба до съответния надзорен орган. Ако се намирате в ЕС, вижте списъка на надзорните органи <a href=\"https://www.edpb.europa.eu/about-edpb/about-edpb/members_en\" target=\"_blank\" rel=\"nofollow\">тук</a>. ",
        "title": "6. Вашите права"
      },
      "section-7": {
        "text-1": "Ако имате въпроси, коментари или оплаквания относно начина, по който използваме данните Ви, моля, изпратете ги на адрес <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "text-2": "Възможно е да има и други администратори на личните Ви данни, описани в настоящата Политика за поверителност, освен NAUDAPAY LIMITED.",
        "text-3": "За повече информация моля, свържете се с нас на адрес <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "title": "7. Данни за контакт"
      },
      "section-8": {
        "text": "Периодично можем да променяме Политиката за поверителност в съответствие с промените в приложимото законодателство и разпоредби или промените в нашите бизнес процедури. В този ред на мисли Ви препоръчваме периодично да проверявате тази страница за най-актуалната информация.",
        "title": "8. Промени в Политиката за поверителност"
      },
      "subtitle": "Относно използването на данни от наша страна и администратора",
      "text-1": "В Noda.live („ние“, „нас“, „нашия“, „Noda“) уважаваме Вашата поверителност и сигурността на данните Ви. Стремим се да предоставяме ясна информация за това как ще използваме данните Ви и как можете да контролирате това. По тази причина Ви препоръчваме да прочетете внимателно настоящата Политика за поверителност, преди да използвате предоставяните от нас услуги (наричани общо „<b>услуга</b>“).",
      "text-2": "В случай че имате допълнителни въпроси или притеснения, не се колебайте да се свържете с нас на адрес <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>. Ще ги разгледаме с удоволствие.",
      "text-3": "Настоящата Политика за поверителност, заедно с Условията за ползване, представляват цялото споразумение (наричано по-нататък „<b>споразумение</b>“) между Вас и Noda.",
      "text-4": "Основният администратор на личните Ви данни е NAUDAPAY LIMITED, регистрационен номер в Обединеното кралство: 11741664. В отделни случаи други дружества от нашата група също могат да бъдат администратори на личните Ви данни, описани в настоящата Политика за поверителност. Можете да намерите допълнителна информация и данни за контакт в края на настоящата Политика за поверителност.",
      "title": "Политика за поверителност"
    },
    "privacy-for-candidates": {
      "last-update": "Последна редакция: 1 юни 2024 г.",
      "section-1": {
        "text-1": "Noda използва личните Ви данни, за да намери подходящо лице за текуща или бъдеща отворена позиция в Noda или нейните компании от групата или за получаване на услуги, които предоставяте.",
        "text-2": "Ако сте индивидуален подизпълнител, Noda може да използва личните Ви данни, за да извърши проверка за съответствие в зависимост от изискванията на приложимото законодателство (например в областта на прането на пари). Ако не предоставите на Noda личните данни, необходими за такива проверки за съответствие, Noda може да няма възможността да работи с Вас като подзпълнител.",
        "text-3": "Ако Noda прецени, че сте подходящ кандидат за работа, стаж или сътрудничество, Noda ще се нуждае от личните Ви данни, за да Ви предостави предложение за работа, стаж или сътрудничество.",
        "text-4": "В случаите, когато подадете искане, жалба или има потенциален спор, Noda може да използва личните Ви данни, за да разреши проблема.",
        "title": "Защо Noda се нуждае от данните Ви?"
      },
      "section-2": {
        "text": "Този раздел описва личните данни, използвани за посочените цели, правните основания за използването им и сроковете за съхранение.",
        "title": "Как Noda обработва данните Ви?"
      },
      "section-3": {
        "list": {
          "item-1": "Компании от групата на Noda",
          "item-2": "Доставчици на услуги за съхранение на данни",
          "item-3": "Доставчици на електронни комуникационни услуги (като имейл услуги)",
          "item-4": "Служители за подбор на персонал и доставчици на подобни услуги, включително платформи за ЧР и набиране на персонал",
          "item-5": "LinkedIn и подобни социални платформи",
          "item-6": "Доставчици на услуги за съответствие",
          "item-7": "Други доставчици на външни услуги (като правни консултанти, организатори на събития и др.)",
          "item-8": "Регулаторни, правоприлагащи органи, съдилища, арбитражни организации и други подобни публични или частни организации"
        },
        "text-1": "Noda получава личните Ви данни от Вас, от профилите Ви в LinkedIn и подобни социални медии, от специалисти по набиране на персонал и референтни страни. В случаите, когато действате като индивидуален подизпълнител, Noda също може да получи личните Ви данни от различни доставчици на услуги за съответствие.",
        "text-2": "Noda може също така да сподели Вашите лични данни със следните получатели:",
        "title": "Източници и получатели на данните"
      },
      "section-4": {
        "text": "Noda обикновено не прехвърля лични данни извън Европейския съюз и Европейското икономическо пространство в рамките на процеса на набиране на персонал. Това обаче може да се случи, когато Вие или референтните страни се намирате извън споменатите територии. Също така такива прехвърляния могат да се извършват в случай на проверки за съответствие за индивидуални подизпълнители. Когато се извършват такива прехвърляния, ние разчитаме на гаранциите, предоставени от приложимите правни актове, например, както е предвидено в Общия регламент за защита на данните на ЕС (ОРЗД): решенията за адекватност на Европейската комисия (член 45 от ОРЗД), стандартни договорни клаузи и други гаранции, предвидени в членове 46 и 49 от ОРЗД. Ако личните данни се прехвърлят в САЩ, Noda може да разчита на съответната действаща рамка за прехвърляне на лични данни. В определени случаи, в зависимост от участващото юридическо лице на Noda, Noda може също да разчита на Приложението за международно прехвърляне на данни на Обединеното кралство към Стандартните договорни клаузи на Комисията на ЕС.",
        "title": "Международни прехвърляния"
      },
      "section-5": {
        "list": {
          "item-1": "осъществите достъп до личните си данни или да се издаде копие на същите;",
          "item-2": "коригирате личните си данни, ако има грешки;",
          "item-3": "изтриете личните си данни, когато законният интерес на Noda не е в сила. Не можете да поискате изтриване на използваните данни поради регулаторни изисквания;",
          "item-4": "възразите срещу използването на личните Ви данни, когато то се основава на законни интереси;",
          "item-5": "ограничите обработката на личните Ви данни;",
          "item-6": "подадате жалба до Noda, като използвате информацията за контакт, предоставена по-долу. Ако Noda не изпълни искането Ви, можете да подадете жалба и до надзорния орган за защита на данните."
        },
        "text": "Можете да поискате да:",
        "title": "Права за защита на данните"
      },
      "section-6": {
        "text-1": "Администраторът на Вашите лични данни е юридическо лице на Noda, с което Ви се предлага да сключите споразумение или което търси кандидат за работа или потенциален партньор за сътрудничество. За повече информация моля, свържете се с Noda на имейла по-долу.",
        "text-2": "Ако имате въпроси или искания по отношение на личните Ви данни, моля, свържете се с нас на: <a class=\"link highlighted\" href=\"mailto:dpo@noda.live\">dpo@noda.live</a>",
        "title": "Информация за контакт"
      },
      "subtitle": "Относно декларацията и Noda",
      "text-1": "В тази декларация се обяснява как Noda обработва личните данни на потенциални служители, стажанти, които са кандидатствали или са били поканени да кандидатстват за свободни позиции в Noda или да си сътрудничат с Noda като индивидуални подизпълнители.",
      "text-2": "Noda е администраторът на Вашите лични данни. Информацията и данните за контакт с Noda са налични в края на настоящата декларация.",
      "title": "Декларация за поверителност за кандидати за работа или сътрудничество"
    },
    "retail": {
      "faq": {
        "countries": {
          "content": "Работим с 2000+ банки в 28 държави, включително Нидерландия, Португалия, Белгия, Германия, Полша, България, Франция, Ирландия, Италия, Австрия, Испания, Дания, Естония, Обединеното кралство, Люксембург, Румъния, Литва, Унгария, Латвия, Финландия, Швеция, Норвегия, Чешката република, Словакия, Гърция и Словения.",
          "title": "В кои държави работи Noda?"
        },
        "currencies": {
          "content": "Noda поддържа различни световни валути, включително EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON и SEK.",
          "title": "Какви валути поддържа Noda?"
        },
        "integration": {
          "content": "Първо, трябва да сте се включили в програмата Noda. Просто попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Ние предлагаме лесно включване в системата с персоналните насоки на специален мениджър. Нашата система за разплащания на дребно се интегрира с API и фронт-енд компоненти, като плавно се влива във вашето пазарно пространство за търговия на дребно.",
          "title": "Как мога да интегрирам Noda в работния си процес за плащане?"
        },
        "subtitle": "Отговори на вашите въпроси",
        "title": "FAQs"
      },
      "hero": {
        "text": "Издигнете своя бизнес на дребно с платежния портал на Noda. Съсредоточете се върху стратегията, докато ние рационализираме транзакциите. Нашата платформа „всичко в едно“ дава приоритет на разбирането, ефективността и растежа на клиентите",
        "title-1": "Шлюз за плащане",
        "title-2": "за търговия на дребно с Noda"
      },
      "how-does-it-work": {
        "subtitle": "Технологии",
        "text-1": "Шлюзът за плащане сигурно предава финансови данни между клиенти, магазини и банки. Мислете за него като за дигитален диригент, ръководещ всяка стъпка от обработката на кредитни карти",
        "text-2": "Noda е световна платежна платформа и доставчик на отворено банкиране. От сигурни шлюзове до управление на транзакциите и финансови анализи - Noda ви осигурява. Платформата ни използва технологии за изкуствен интелект и машинно обучение, за да предостави най-съвременни решения за индустрията за търговия на дребно",
        "title": "Как работи шлюзът за плащане на дребно?"
      },
      "how-to-start": {
        "subtitle": "Лесно включване",
        "text": "Noda предлага лесно включване в системата с индивидуалните насоки на специален мениджър. Платформата ни се интегрира безпроблемно с API и фронт-енд компоненти, като осигурява безпроблемно сливане с вашата платформа за търговия на дребно. За да започнете да използвате Noda, попълнете формуляра по-долу и нашите търговски представители ще се свържат с вас скоро. Нашият екип е тук, за да ви помогне при всякакви пречки",
        "title": "Как да започнете"
      },
      "open-banking": {
        "subtitle": "Много възможности",
        "text": "Отвореното банкиране означава, че традиционните банки споделят данни с лицензирани финтех компании като Noda, за да оптимизират трансакциите. Нашата платежна екосистема свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява безпроблемното обслужване на плащания на дребно",
        "title": "Какво е отворено банкиране?"
      },
      "payment-processing": {
        "subtitle": "Най-добри оферти",
        "text": "Рационализирайте вноските и изплащанията, използвайте интуитивен UX, интелигентно маршрутизиране и предлагайте разнообразие от популярни методи на плащане",
        "title": "Обработка на плащания на дребно"
      },
      "payments": {
        "text": "Изпитайте ефективността на незабавните транзакции, като средствата бързо се отразяват в сметката ви в рамките на няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "title": "Набор от инструменти за търговия на дребно"
      },
      "scalable-plans": {
        "subtitle": "Повече ползи",
        "text": "Ние предлагаме решения за плащания на дребно за компании от всякакъв размер, с налични мащабируеми планове в подкрепа на растежа на вашия бизнес",
        "title": "Мащабиру&shy;еми планове"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Възползвайте се от нашите прозрения, базирани на данни. Инструментите на Noda предлагат готови за използване анализи на поведението на клиента, включително алгоритми за сегментиране и прогнозиране",
            "title": "Анализ, базиран на AI"
          },
          "banking": {
            "content": "Подобряване на преживяването на клиентите и улесняване на транзакциите с мощта и сигурността на отворените банкови плащания",
            "title": "Отворено банкиране"
          },
          "global-currencies": {
            "content": "Noda работи с множество валути, за да обслужва клиентите ви от цял свят",
            "title": "Глобални валути"
          },
          "security": {
            "content": "Noda осигурява защитен шлюз за търговия на дребно, гарантиращ съответствие с PCI DSS, криптиране и предотвратяване на измами",
            "title": "Безопасност"
          }
        },
        "subtitle": "Какво предлагаме",
        "title": "Топ функции за търговия на дребно"
      }
    },
    "saas": {
      "faq": {
        "countries": {
          "content": "Работим с 2000+ банки в 28 държави, включително Нидерландия, Португалия, Белгия, Германия, Полша, България, Франция, Ирландия, Италия, Австрия, Испания, Дания, Естония, Обединеното кралство, Люксембург, Румъния, Литва, Унгария, Латвия, Финландия, Швеция, Норвегия, Чешката република, Словакия, Гърция и Словения.",
          "title": "В кои държави работи Noda?"
        },
        "currencies": {
          "content": "Noda поддържа различни световни валути, включително EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON и SEK.",
          "title": "Какви валути поддържа Noda?"
        },
        "how-to-integrate": {
          "content": "Първо, трябва да сте се включили в програмата Noda. Просто попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Ние предлагаме лесно включване в системата с персоналните насоки на специален мениджър. Нашата SaaS система за плащания се интегрира безпроблемно с API и фронт-енд компонентите, като осигурява безпроблемно сливане с вашата платформа",
          "title": "Как мога да интегрирам Noda в работния си процес за плащане?"
        },
        "subtitle": "отговори на вашите въпроси",
        "title": "FAQs"
      },
      "hero": {
        "text": "Повишете нивото на бизнеса си със софтуер като услуга (SaaS). Погрижете се за клиентите, докато ние оптимизираме плащанията за SaaS. Нашата платформа \"всичко в едно\" дава приоритет на разбирането на клиентите, ефективността и растежа",
        "title-1": "Шлюз за плащане",
        "title-gradient-1": "за SaaS с Noda"
      },
      "how-to-start": {
        "subtitle": "Лесно включване",
        "text": "Noda предлага лесно включване в системата с индивидуалните насоки на специален мениджър. Платформата ни се интегрира безпроблемно с компонентите на API и front-end, като осигурява безпроблемно сливане с вашия софтуер. За да започнете да използвате Noda, попълнете формуляра по-долу и нашите търговски представители ще се свържат с вас скоро. Нашият екип е тук, за да ви помогне при всякакви пречки",
        "title": "Как да започнете"
      },
      "open-banking": {
        "subtitle": "Много възможности",
        "text": "Отвореното банкиране означава, че традиционните банки споделят данни с лицензирани финтех компании като Noda, за да оптимизират трансакциите. Нашата платежна екосистема свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява безпроблемното предоставяне на услуги за обработка на плащания чрез SaaS",
        "title": "Какво е отворено банкиране?"
      },
      "payments": {
        "text": "Изпитайте ефективността на незабавните транзакции, като средствата бързо се отразяват в сметката ви в рамките на няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "title": "Набор от инструменти за SaaS"
      },
      "technologies": {
        "text-1": "Платежният шлюз предава по сигурен начин финансови данни между клиенти, търговци и банки.\n      Мислете за него като за дигитален водач, който ръководи всяка стъпка от обработката на кредитни карти чрез SaaS",
        "text-2": "Noda е световна платежна платформа и доставчик на отворено банкиране. От сигурна обработка до\n      управление на транзакциите и финансови анализи, Noda се грижи за вас. Нашата платформа използва AI\n      и технологии за машинно обучение, за да предоставя най-съвременни решения",
        "title": "технологии",
        "title-1": "Как става SaaS плащането",
        "title-2": "Работа на портала?"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Използвайте нашите прозрения, базирани на данни. Инструментите на Noda предлагат готови за използване анализи на поведението на клиентите, включително алгоритми за сегментиране и прогнозиране",
            "title": "Анализ, базиран на AI"
          },
          "banking": {
            "content": "Подобряване на преживяването на клиентите и улесняване на транзакциите с мощта и сигурността на отворените банкови плащания",
            "title": "Отворено банкиране"
          },
          "global-currencies": {
            "content": "Noda работи с множество валути, за да поддържа вашите клиенти на SaaS от цял свят",
            "title": "Глобални валути"
          },
          "payment-processing": {
            "content": "Рационализирайте вноските и изплащанията, използвайте интуитивен UX, интелигентно маршрутизиране и предлагайте разнообразие от популярни методи на плащане",
            "title": "Обработка на плащания в SaaS"
          },
          "scalable-plans": {
            "content": "Предлагаме решения за плащане чрез SaaS за всички размери на компанията, като са налични мащабируеми планове, които да подпомогнат растежа на бизнеса ви",
            "title": "Мащабируеми планове"
          },
          "security": {
            "content": "Noda осигурява сигурен шлюз за плащане, гарантиращ съответствие с PCI DSS, криптиране и предотвратяване на измами",
            "title": "Сигурност"
          }
        },
        "subtitle": "нашите оферти",
        "title": "Топ функции"
      }
    },
    "security": {
      "faq": {
        "contact": {
          "complex-content": {
            "p1": "Ако срещнете някакви затруднения с услугите на Noda, предлагаме следните канали за поддръжка:",
            "p2": "<b>Групов чат в Skype/Telegram:</b> Създадохме специален групов чат, за да улесним безпроблемната комуникация. Ако имате въпроси относно интеграцията или срещате технически проблеми, не се колебайте да изпратите съобщение до групата и да ни отбележите на адрес",
            "p3": "<b>Личен мениджър:</b> За запитвания, които не са свързани с техническа поддръжка, можете да се свържете с личния си мениджър директно в груповия чат или чрез лично съобщение.",
            "p4": "<b>Поддръжка по имейл:</b> Търговците и техните клиенти могат да се свържат с нас на адрес",
            "p5": "Не забравяйте, че винаги сме готови да ви помогнем!"
          },
          "title": "Имам проблем с услугите на Noda; към кого мога да се обърна?"
        },
        "knowledge": {
          "complex-content": {
            "l1": "<b>Сигурност на ниво банка:</b> Отвореното банкиране използва строго тестван софтуер и системи за сигурност. Потребителите никога не са задължени да споделят своите данни за вход в банката или пароли с никого, освен със собствената си банка.",
            "l2": "<b>Регламент:</b> Само приложения и уебсайтове, регулирани от британския Орган за финансово поведение (FCA) или от еквивалентни институции в Европа, имат право да използват отворено банкиране.",
            "l3": "<b>Контрол върху данните:</b> Клиентите имат право да решават кога и за колко време да споделят данните си. Освен това те могат да отменят този достъп по всяко време чрез своите банки.",
            "p1": "Отвореното банкиране е проектирано със силен акцент върху сигурността, което гарантира, че е напълно безопасно за вашите клиенти. Ето някои от основните му характеристики за сигурност:"
          },
          "title": "Как да разбера, че отвореното банкиране е безопасно?"
        },
        "safe": {
          "content": "Да, Нода е в безопасност. Хиляди крайни потребители се доверяват на Noda, за да извършват сигурни плащания чрез предпочитаните от тях банки, където уверено съхраняват парите си. Noda никога не споделя данни на потребителите без тяхното изрично съгласие. Едновременно с това предприемаме всички мерки, за да гарантираме, че данните им са защитени на всяка стъпка.",
          "title": "Безопасна ли е Noda?"
        },
        "secure": {
          "content": "Да, Noda е сигурен. Както вече споменахме, Noda е проектирана не само да бъде безопасна, но и да следи непрекъснато нивата си на сигурност. Ние използваме многопластов подход, за да намалим значително рисковете от хакерски атаки и нарушения на сигурността на данните. Например, използваме водещи протоколи за криптиране, доставчици на облачна инфраструктура от най-висок клас, многофакторна автентикация и извършваме денонощно цялостно наблюдение на нашите услуги.",
          "title": "Сигурна ли е Noda?"
        },
        "test": {
          "complex-content": {
            "l1-1": "Номер на сметката",
            "l1-2": "Пълно име",
            "l2-1": "Информация за самоличност",
            "l2-2": "Салда по сметки",
            "l2-3": "История на транзакциите за 90 дни",
            "p1": "Noda е едновременно доставчик на услуги за иницииране на плащания (PISP) и доставчик на услуги за информация за сметка (AISP). В първия случай ние предоставяме на вашия клиент услуги по иницииране на плащане (PIS). Това по същество означава, че Noda ще улесни процеса на плащане за вашите клиенти, като прехвърли средства директно от свързаната(ите) с тях платежна(и) сметка(и) към избрания бенефициент след изричното им съгласие. В този случай Noda получава достъп до следните данни:",
            "p2": "Следователно тези данни могат да се използват като входни стойности за вътрешните алгоритми на Noda и могат да се споделят с търговците, за да се потвърди, че плащането е било успешно.",
            "p3": "Във втория случай Услугата за информация за сметките (AIS) дава възможност на Noda да получи достъп и да прегледа информацията за всички сметки за онлайн банкиране на едно място и да анализира финансовата информация на вашите клиенти с тяхно съгласие. В този случай Noda има достъп до следните данни:",
            "p4": "Следователно тези данни могат да се използват за подобряване на вътрешните алгоритми на Noda. Те могат да се споделят и с търговците в обобщен вид - например като стойност на оценка, показваща към коя категория на плащане се причислява потребителят (от 1 до 5)."
          },
          "title": "До какви данни има достъп и какви данни може да сподели Noda?"
        }
      },
      "hero": {
        "desc-1": "Сигурността на плащанията и данните винаги трябва да бъде приоритет. На тази страница ще намерите подробна информация за нашите мерки за сигурност и подхода ни към обработката и споделянето на вашите данни.",
        "desc-2": "Предоставяме преглед на нашите функции за сигурност и нашия ангажимент за защита на личните данни. Освен това предлагаме информация за нашето лицензиране и управлението на данни в различни лицензи.",
        "title": "Сигурност и работа с данни"
      },
      "strategy": {
        "alert": {
          "text": "Нашите автоматични системи за предупреждение ни позволяват да реагираме незабавно на заплахи, възникващи през нощта, през почивните дни, на официални празници или в други неработни часове.",
          "title": "Система за автоматични предупреждения"
        },
        "bug-bounty": {
          "text": "<p class=\"paragraph\">Нашата програма за награди за грешки приветства всички разработчици, които се определят като хакери. Ако вие или ваши колеги откриете някакви грешки, недостатъци или уязвимости в нашите системи за сигурност или имате предложения за подобряване на функционалността на крайните точки на Noda API, можете да участвате в нашата програма и да получите награда.</p><p class=\"paragraph\"> За да съобщите за проблем или да направите предложение, просто изпратете имейл до нашия екип по сигурността на адрес <a class=\"link\" href=\"mailto:security@noda.live\">security@noda.live</a>.</p>",
          "title": "Програма за възнаграждение за грешки"
        },
        "certification": {
          "text": "<p class=\"paragraph\">Noda редовно получава съответните сертификати и поддържа актуални лицензи за PCI DSS и PCI SSLC. Стандартът за сигурност на данните на индустрията за платежни карти (PCI DSS) е индустриалният еталон, насочен към намаляване на измамите при плащания чрез подобряване на контрола за защита на данните.</p><p class=\"paragraph\"> Междувременно стандартът PCI Secure Software Lifecycle Standard (PCI SLLC) гарантира, че доставчиците на платежен софтуер включват сигурността през целия жизнен цикъл на разработване на софтуера, като създават приложения, които са сигурни по замисъл и надеждни срещу атаки. Тези лицензи се администрират от Съвета за стандарти за сигурност на PCI (PCI SSC).</p>",
          "title": "Сертифициране"
        },
        "cloud": {
          "text": "<p class=\"paragraph\">Noda използва облачна инфраструктура за изграждане на нашите приложения и услуги. Съвременните доставчици на облачни услуги са едни от най-сигурните в световен мащаб, като инвестират милиони долари, за да гарантират най-високите стандарти за безопасност. Освен това те непрекъснато обновяват и усъвършенстват системите си, за да ги направят още по-непробиваеми и сигурни.</p><p class=\"paragraph\"> Работата с добре познати световни доставчици на сигурност на облачна инфраструктура е ключов фактор за изграждането на програмата за информационна сигурност на Noda.</p>",
          "title": "Използване на доставчици на облачна инфраструктура"
        },
        "encryption": {
          "text": "<p class=\"paragraph\">Noda криптира всички чувствителни данни едновременно на две нива. Използваме протокола за сигурност на транспортния слой (TLS), когато информацията се прехвърля между мрежовите сървъри, и прилагаме стандарта за усъвършенствано криптиране (AES), когато данните се съхраняват.</p><p class=\"paragraph\"> Използването на този подход за двуслойно криптиране ни позволява да сведем до минимум потенциалните проблеми с безопасността, тъй като чувствителните данни остават криптирани дори в редките случаи, когато един от компонентите е компрометиран.</p>",
          "title": "Подход за криптиране на данни"
        },
        "mfa": {
          "text": "<p class=\"paragraph\">В Noda разбираме, че постигането на максимална информационна сигурност изисква да се съсредоточим както върху външната, така и върху вътрешната среда. Ето защо прилагаме многофакторна автентификация (MFA) за нашите служители за достъп до всички критични вътрешни платформи.</p><p class=\"paragraph\"> MFA добавя допълнително ниво на автентификация, което помага за предотвратяване на неоторизиран достъп до данни чрез вътрешните системи.</p>",
          "title": "MFA"
        },
        "monitoring": {
          "text": "<p class=\"paragraph\">Всички компоненти на продуктите на Noda, включително Noda API, се наблюдават и проверяват непрекъснато от нашия екип за ИТ сигурност.</p><p class=\"paragraph\"> Този екип се състои от ИТ експерти, които редовно посещават професионални конференции и се занимават с непрекъснато обучение в своята област.</p>",
          "title": "Мониторинг на екипа за информационна сигурност"
        },
        "support": {
          "text": "Екипът за денонощна поддръжка на Noda бързо разрешава проблеми със свързаността на конкретни клиенти и също така събира предложения за подобряване на системите на Noda. Ние винаги сме тук и сме готови да помогнем.",
          "title": "Екип за техническа поддръжка 24/7"
        },
        "text": "Стратегията на Noda за изграждане на програма за информационна сигурност включва двоен подход. Първо, ние се фокусираме върху надеждната сигурност на нашите собствени системи и сървъри. Второ, прилагаме многопластов подход за сигурност, за да осигурим най-високо ниво на безопасност както за вашите данни, така и за данните на вашите клиенти. По-долу ще намерите основните характеристики на нашата програма за сигурност.",
        "title": "Noda Сигурност"
      }
    },
    "tabs": {
      "banner": {
        "account-balances": "Салда по сметки",
        "account-number": "Номер на сметката",
        "full-name": "Пълно име",
        "identity-information": "Информация за самоличността",
        "text": "Със съгласието на клиента Noda може да получи достъп до следните данни и да ги използва в своите алгоритми:",
        "title": "Видове данни, които клиентите ви могат да споделят с Noda",
        "transaction-history": "История на транзакциите за 90 дни"
      },
      "tab-step-text": {
        "after-the-confirmation": "След потвърждението Noda получава номера на сметката на потребителя, както и сумата и валутата на плащането.",
        "after-the-consent": "След получаване на съгласието Noda получава достъп до финансовата им сметка и някои от финансовите им данни.",
        "consequently-this-data": "Следователно тези данни могат да се използват като входни стойности за вътрешните алгоритми на Noda и могат да се споделят с търговците, за да се потвърди, че плащането е било успешно.",
        "consequently-this-data-form": "Следователно тези данни могат да се използват за подобряване на вътрешните алгоритми на Noda. Те могат да се споделят и с търговците в обобщен вид - например като стойност на оценка, показваща към коя категория на плащане се причислява потребителят (от 1 до 5).",
        "the-buyer-initiates": "Купувачът инициира плащането и извършва проверка за автентичност от избраната от него банка.",
        "when-the-authentication": "След като автентификацията от страна на банката приключи, тя изисква потвърждение на транзакцията.",
        "when-the-authentication-consent": "Когато удостоверяването на автентичността от страна на банката приключи, тя изисква от потребителите да дадат съгласието си Noda да получи достъп до техните финансови данни и данни за профила им."
      },
      "tab-title": {
        "automated-access": "Автоматизиран достъп до IBAN на потребителя чрез оторизация директно от банката",
        "insert-iban": "Въведете IBAN за ръчно плащане"
      },
      "tag-subtitle": "ТЕХНОЛОГИЧНО ПРИЯТЕЛСКИ",
      "text": "В Noda се грижим за вашите клиенти и обработваме техните данни с най-голямо внимание. Ето какво се случва, когато клиентите ви извършват плащане или се качват на борда чрез нашите услуги.",
      "title": "Noda обработва<br/>данните на вашите клиенти"
    },
    "terms": {
      "last-update": "Последна актуализация: <data>23 август 2024 г.</data>",
      "section-1": {
        "text-1": "Настоящите Условия за ползване служат като правно обвързващ договор между нейните потребители („Вие“, „потребител“, „клиент“) и Noda, поради което Ви препоръчваме да прочетете документа внимателно. Условията за ползване, заедно с Политиката за поверителност, представляват цялостното споразумение (наричано по-нататък „споразумението“) между Вас и Noda. Всички услуги, описани по-долу, са услугите, предоставяни от Noda, и ще бъдат наричани общо „услугата“. С използването на услугата, Вие потвърждавате, че приемате и се съгласявате да бъдете обвързани с условията в споразумението. Условията за ползване са винаги достъпни на нашия уебсайт <a href=\"https://noda.live\">https://noda.live.</a>",
        "text-2": "Noda Ви предоставя ограничен, отменяем, неизключителен, непрехвърляем лиценз за достъп и използване на услугата за Ваша индивидуална употреба, при спазване на другите условия на настоящите Условия за ползване. Всички права, права на собственост и интереси, свързани с услугата, които не са изрично предоставени в настоящия документ, са запазени от Noda.",
        "text-3": "Споразумението се сключва за неопределено време.",
        "text-4": "Периодично може да правим промени и корекции в Условията за ползване. Ако не сте съгласни с някоя от разпоредбите на споразумението, Ви предлагаме да спрете да използвате услугата и да прекратите безплатно настоящите Условия за ползване.",
        "text-5": "Настоящите Условия за ползване са изготвени на английски език и основната комуникация обикновено се осъществява на английски език.",
        "text-6": "По всяко време, докато споразумението е в сила, Вие имате право да получите при поискване настоящите Условия за ползване.",
        "title": "1. Споразумението"
      },
      "section-2": {
        "list-1": {
          "item-1": "референция, която Ви позволява да идентифицирате всяка разплащателна трансакция и, ако е необходимо, получателя;",
          "item-2": "сумата на разплащателната транскация във валутата, в която е дебитирана платежната Ви сметка, или във валутата, използвана за платежното нареждане;",
          "item-3": "когато е приложимо, обменния курс, използван при разплащателната трансакция, и сумата на разплащателната трансакция след конвертирането на валутата;",
          "item-4": "вальорът на задължаване на сметката или датата на получаване на платежното нареждане."
        },
        "list-2": {
          "item-1": "Услугата ще отговаря на изискванията Ви;",
          "item-2": "Услугата ще бъде непрекъсната, навременна, сигурна или без грешки;",
          "item-3": "Резултатите, които могат да бъдат получени от използването на услугата, ще бъдат точни или надеждни;",
          "item-4": "Качеството на всички продукти, услуги, информация или други материали, закупени или получени от Вас чрез услугата, ще отговори на очакванията Ви; или",
          "item-5": "Всички грешки в технологията ще бъдат коригирани."
        },
        "text-1": {
          "line-1": "В обхвата на настоящото споразумение между Вас и нас, Noda служи като доставчик на услуги за иницииране на плащане („PISP“) и доставчик на услуги за информация за сметка („AISP“) и ние ще Ви предоставяме услуги за иницииране на плащане („PIS“) и услуги за информация за сметка („AIS“). Това по същество означава, че ще улесним процеса на плащане за Вас, като инициираме трансакция директно от свързаната/ите Ви платежна/и сметка/и към избрания бенефициент, след Вашето изрично съгласие и ще Ви предоставим информация за свързаната/ите Ви платежна/и сметка/и.",
          "line-2": "След като изберете доставчик на платежна сметка или доставчик на банкова сметка (и двете наричани по-нататък поотделно „партньор“), с когото искате да се свържете и/или да извършите плащане, ще бъдете пренасочени към неговата официална страница (в приложението или в браузър), където ще трябва да преминете през процес на проверка.",
          "line-3": "Като доставчик на услуги по предоставяне на информация за сметка (AISP) ние ще Ви позволим да осъществявате достъп и да преглеждате информация за всички Ваши онлайн банкови сметки на едно място и да анализираме финансовата Ви информация, за да Ви помогнем да харчите, спестявате, заемате и проследявате потоците на средствата Ви по-ефективно.",
          "line-4": "Noda не предоставя никакви банкови и платежни услуги. Следователно избраният от Вас доставчик на платежни сметки носи цялата отговорност за изпълнението на плащанията и за евентуални недостатъци във функционалността на своите услуги. Въпреки това, ако преценим, че нямаме разрешения или по някаква причина предоставянето на нашите услуги на Вас би било незаконно, можем да решим да не Ви предоставяме услугата.",
          "line-5": "В рамките на настоящото споразумение и в границите, които ни разрешавате, ще споделяме информация за платежната ви сметка с други услуги и трети страни по Ваш избор. След като такъв партньор получи достъп до информацията Ви, той автоматично става отговорен за нея и информацията става обект на споразумението Ви със съответния партньор и неговата политика за поверителност.",
          "line-6": "Ние ще имаме достъп до всички платежни сметки, които сте свързали, само ако сте дали съгласието си за това и само в рамките на предоставяната от нас услуга.",
          "line-7": "Можете да поискате периодично, поне веднъж месечно, да Ви бъде предоставяна безплатно следната информация:"
        },
        "text-2": "Услугата се предоставя във вида, в който е, и според достъпността. Ние не даваме никакви гаранции, че: ",
        "text-3": "След като сте инициирали плащането, то ще бъде предадено незабавно. След като сте упълномощили плащането в банката си, няма да можете да го отмените. Средствата обикновено ще напуснат платежната Ви сметка в рамките на 2 (два) часа след успешното иницииране, въпреки че може да отнеме повече време в зависимост от това колко време е необходимо на банката Ви да изпълни платежното нареждане. Ние ще потвърдим успешното иницииране на платежното нареждане, но банката Ви (а не Noda) е тази, която отговаря за изпълнението му.",
        "title": "2. Услугата, която предоставяме"
      },
      "section-3": {
        "list": {
          "item-1": "Имате навършени поне 18 години и сте дееспособни и упълномощени да сключвате договори",
          "item-10": "Нямате право да декомпилирате или раздробявате услугата, нито да я използвате, ако това не е в съответствие с целите, посочени в споразумението;",
          "item-11": "Нямате право на достъп до услугата с цел улесняване на конкурентни продукти или услуги;",
          "item-12": "Всяко забранено използване води до незабавно прекратяване на Вашия лиценз за услугата.",
          "item-2": "Ще използвате услугата само като физическо лице и единствено за лични цели;",
          "item-3": "Няма да използвате услугата с измамна цел;",
          "item-4": "Няма да използвате услугите за никакви незаконни цели;",
          "item-5": "Вие се съгласявате с нашата <a href=\"https://noda.live/about/legal-privacy/policy\">Политика за поверителност;</a>",
          "item-6": "Вие носите отговорност за запазването на идентификационните си данни в безопасност;",
          "item-7": "Нямате право да разкривате идентификационните си данни на трета страна. Доколкото това е позволено от приложимото законодателство, Вие носите отговорност за всички разходи и адвокатски хонорари в разумен размер за това, че не сте опазили идентификационни данни и/или не сте уведомили незабавно Noda за неупълномощено използване на платежната Ви сметка или друга сметка или за компрометиране на информацията или паролата на платежната Ви сметка (или друга сметка);",
          "item-8": "Няма да използвате фалшива или открадната самоличност. Вие декларирате и гарантирате, че цялата информация, предоставена от Вас в рамките на настоящото споразумение, е вярна и точна;",
          "item-9": "Нямате право да препродавате или да прехвърляте по друг начин правата за използване на услугата;"
        },
        "text-1": "С използването на предоставяните от нас услуги Вие декларирате и се съгласявате, че:",
        "text-2": {
          "line-1": "В случай че разберете за загуба, кражба, присвояване или неразрешено използване на услугата ни или на част от нея, за измама с представяне под чужда самоличност, за неразрешена или неправилно инициирана или изпълнена разплащателна трансакция или за разрешен кредитен превод, извършен след неправилно прилагане на услугата за проверка на името и уникалния идентификатор, моля, свържете се с нас възможно най-скоро, но не по-късно от 5 работни дни на адрес <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>. Освен това обмислете възможността да уведомите полицията, особено в случай на измама с представяне под чужда самоличност, и други трансакции, извършени от Ваше име без Ваше разрешение. В случай на такива събития Вие също носите отговорност и сте длъжни да предприемете действия за запазване на сигурността на информацията Ви.",
          "line-2": "Ако не ни уведомите за неупълномощена или неправилно изпълнена трансакция, може да нямате право да получите обезщетение за такава неупълномощена или неправилно изпълнена трансакция.",
          "line-3": "В случай че преценим, че е налице действителна или предполагаема измама или сериозна заплаха за сигурността, ще се свържем с Вас, като използваме информацията за контакт, предоставена от Вас при използването на услугата ни."
        },
        "title": "3. Достъп до услугата и съобщаване за подозрителни дейности"
      },
      "section-4": {
        "text": {
          "line-1": "За да имате пълен достъп до услугата, трябва да изберете банките или други доставчици на платежни сметки, към които искате да се свържете или да ни упълномощите да извършваме плащания. След като изберете партньор, ние ще Ви пренасочим към неговата уебстраница, където ще бъдете преведени през защитен процес за достъп до информация от платежните Ви сметки (тук и на други места в споразумението „платежна сметка“ се отнася до сметка, създадена при партньор). Ще бъдете помолени да предоставите изричното си съгласие, за да ни дадете възможност за достъп до финансовите Ви данни.",
          "line-2": "За да получите достъп до услугата, трябва да ни предоставите информацията, посочена в Политиката за поверителност. Уникалният идентификатор, който се използва, за да се гарантира, че платежното нареждане е правилно инициирано и изпълнено, е Вашият имейл или IBAN, или идентификатор на плащането, или идентификатор на клиента, или референция за плащане в зависимост от всеки конкретен случай. В случай че ни предоставите неправилен или грешен идентификатор, може да начислим такса за възстановяване на средствата, включени в съответната разплащателна трансакция.",
          "line-3": "Вие се съгласявате, че предоставяте на Noda неизключителен, безвъзмезден лиценз за използване на информацията в платежните Ви сметки за всички цели, свързани с услугата или посочени в настоящото споразумение, с правото да използва, променя, показва, разпространява и създава нови материали, като използва или включва такава информация, за да Ви предоставя услугата. Гарантираме, че няма да използваме или да имаме достъп до данните Ви за други цели, освен ако законът не предвижда друго. За да опазим сигурността на данните Ви и да разполагаме с актуално съгласие от Ваша страна, може периодично да Ви молим да го подновите.",
          "line-4": "Вие се съгласявате, че когато извличаме Ваша информация, свързана с платежните Ви сметки, или Ваша информация, необходима като част от предоставянето на услугата, ние правим това като Ваш представител и от Ваше име, а не от името или за сметка на трета страна.",
          "line-5": "С използването на услугата Вие заявявате, че сте законният собственик на данните в платежните си сметки и че имате право да назначите и изрично назначавате нас и/или нашите доставчици от трети страни за Ваши представители и предоставяте ограничено пълномощно за достъп и извличане на тези данни от Ваше име.",
          "line-6": "За целите на съответствието и за да Ви предоставим услугата, с настоящото ни упълномощавате директно или чрез трета страна да получаваме, проверяваме и съхраняваме информация и документи, които ни помагат да проверим самоличността Ви и информацията за платежната Ви сметка. Когато се регистрирате за услугата и периодично след това, ние можем да поискаме от Вас да предоставите и/или потвърдите информация и документи, които ще ни позволят да Ви идентифицираме. "
        },
        "title": "4. Нашият достъп до Вашите данни"
      },
      "section-5": {
        "list": {
          "item-1": "незабавно временно или постоянно отнемане на правото Ви да използвате услугата;",
          "item-2": "изпращане на предупреждение към Вас;",
          "item-3": "започване на съдебно производство срещу Вас за възстановяване на всички разходи (включително, без изреждането да е изчерпателно, административни и съдебни разходи в разумен размер), произтичащи от нарушението;",
          "item-4": "предприемане на по-нататъшни правни действия срещу Вас; и/или",
          "item-5": "поискване за разкриване на такава информация пред правоприлагащи органи, ако основателно считаме, че това е необходимо."
        },
        "text-1": {
          "line-1": "Можете да оттеглите даденото ни съгласие по всяко време, като се свържете с нас на адрес <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>.",
          "line-2": "Можем да преценим и да определим по наше усмотрение дали е налице нарушение на настоящото споразумение при използването на услугата от Ваша страна. Когато е налице такова нарушение, можем да предприемем действия, които считаме за подходящи, включително всички или някои от следните действия:"
        },
        "text-2": {
          "line-1": "Описаните по-горе ответни реакции не са ограничени и можем да предприемем всякакви други действия, които считаме за подходящи и които не противоречат на приложимото законодателство.",
          "line-2": "Също така имаме право по всяко време да блокираме услугата по обективно обосновани причини, свързани със сигурността ѝ, или при съмнения за неупълномощено или измамно използване на същата.",
          "line-3": "Можем да решим да отхвърлим Вашата регистрация или да отменим съществуваща регистрация по каквато и да е друга причина по наше усмотрение."
        },
        "title": "5. Прекратяване и временно преустановяване"
      },
      "section-6": {
        "text": {
          "line-1": "Вие се съгласявате да защитавате и напълно да компенсирате Noda и дъщерните ни дружества от всички искове на трети страни, отговорности, щети, разходи и разноски (включително, без изреждането да е изчерпателно, адвокатски хонорари в разумен размер), причинени от или произтичащи от използване на услугата или нарушение на настоящото споразумение от Ваша страна или нарушение от Ваша страна или от страна на друг потребител на сметката Ви, на интелектуална собственост или друго право на когото и да било.",
          "line-2": "Няма да носим отговорност пред Вас за неизпълнение или забавяне на изпълнението на някое от задълженията ни по настоящото споразумение, доколкото това неизпълнение или забавяне е причинено или за което сте допринесли Вие или събитие или обстоятелство извън нашия разумен контрол, включително в случай на предоставяне на неправилен уникален идентификатор.",
          "line-3": "В НИКАКЪВ СЛУЧАЙ NODA, НЕЙНИТЕ СЛУЖИТЕЛИ, ДИРЕКТОРИ, АГЕНТИ, ФИЛИАЛИ, СЛУЖИТЕЛИ, РЕКЛАМОДАТЕЛИ ИЛИ ДОСТАВЧИЦИ НЕ НОСЯТ ОТГОВОРНОСТ ЗА КАКВИТО И ДА БИЛО КОСВЕНИ, СЛУЧАЙНИ, ПОСЛЕДВАЩИ ИЛИ НАКАЗАТЕЛНИ ЩЕТИ, ВКЛЮЧИТЕЛНО, БЕЗ ИЗРЕЖДАНЕТО ДА Е ИЗЧЕРПАТЕЛНО, ЛИШАВАНЕ НА ПОЛЗВАНЕ, ЗАГУБА НА ПЕЧАЛБА ИЛИ ЗАГУБА НА ДАННИ, НЕЗАВИСИМО ДАЛИ СТАВА ВЪПРОС ЗА ДЕЙСТВИЕ ПО ДОГОВОР, ДЕЛИКТ (ВКЛЮЧИТЕЛНО, БЕЗ ИЗРЕЖДАНЕТО ДА Е ИЗЧЕРПАТЕЛНО, НЕБРЕЖНОСТ), СПРАВЕДЛИВ ИСК ИЛИ ДРУГО, ИЛИ ЗА ЩЕТИ, ЧИЙТО ОБЩ РАЗМЕР НАДВИШАВА СУМАТА НА ПЛАЩАНЕТО, ИЗВЪРШЕНО ПОГРЕШНО ИЛИ БЕЗ РАЗРЕШЕНИЕ, КОЕТО Е ДОВЕЛО ДО ЗАГУБА НА СУМИТЕ, ПРЕХВЪРЛЕНИ В РАМКИТЕ НА СЪОТВЕТНОТО ПЛАЩАНЕ.",
          "line-4": "Ние носим отговорност пред Вас за правилното изпълнение на разплащателната трансакция, освен ако не можем да докажем на Вас и, когато е приложимо, на доставчика на платежни услуги на получателя, че същият е получил сумата по разплащателната трансакция, и освен ако имаме основателни причини да подозираме, че сте извършили измама."
        },
        "title": "6. Обезщетение и отговорност"
      },
      "section-7": {
        "text": {
          "line-1": "Молим Ви да отправяте своите притеснения и оплаквания директно към нас на адрес <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> и ние винаги ще полагаме максимални усилия да Ви съдействие. В случай че в крайна сметка не сте доволни от нашия отговор или от цялостното обслужване, имате право да подадете жалбата си до Финансовия омбудсман: <a target=\"_blank\" rel=\"nofollow\" href=\"https://www.financial-ombudsman.org.uk/\">https://www.financial-ombudsman.org.uk/</a>. Надзорният орган по отношение на нашата дейност в Обединеното кралство е Органът за контрол върху финансовата дейност: <a href=\"https://www.fca.org.uk/\" target=\"_blank\" rel=\"nofollow\">https://www.fca.org.uk/.",
          "line-2": "В различните държави има различни регулаторни органи и може да има други алтернативни решения за разрешаване на спорове. За повече информация моля, свържете се с нас на адрес <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>.",
          "line-3": "Ако жалбата Ви се отнася до начина, по който съхраняваме или обработваме личната Ви информация, моля, прегледайте нашата <a href=\"https://noda.live/about/legal-privacy/policy\">Политика за поверителност</a>."
        },
        "title": "7. Жалби"
      },
      "section-8": {
        "text": {
          "line-1": "Настоящото споразумение се урежда от законите на Обединеното кралство. Ако съд реши, че не можем да се позовем на част от настоящото споразумение, останалата част от споразумението ще продължи да се прилага, тъй като всяка от разпоредбите на настоящото споразумение действа отделно.",
          "line-2": "Ако някоя от разпоредбите на настоящото споразумение бъде обявена за невалидна по някаква причина, невалидността на тази разпоредба няма да засегне останалите разпоредби на споразумението, които ще останат да действат в пълна сила."
        },
        "title": "8. Общи разпоредби"
      },
      "subtitle": "Данни на дружеството",
      "text-1": "Ние сме Naudapay Limited, известна още като „Noda“ („Noda“, „Ние“, „Нас“, „Нашата“), дружество, регистрирано в Обединеното кралство под номер на дружеството 11741664, със седалище на адрес: 162 Buckingham Palace Road, London, SW1W 9TR, Обединеното кралство. Ние управляваме уебсайта <a href=\"https://noda.live\">https://noda.live</a> и услугите, предлагани чрез нашите приложения и решения под нашата марка Noda. Офисът за контакт в ЕС е в Испания (Calle Huertas 11, 28012, Madrid, Испания).",
      "text-2": "Naudapay Limited е регистрирана от Органа за контрол върху финансовата дейност съгласно правилата за платежните услуги от 2017 г. за предоставяне на платежни услуги. Референтен номер 832969.",
      "text-3": "Не се колебайте да ни потърсите на адрес <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> при въпроси или запитвания. Можете да се свържете с нас и в приложението чрез нашия инструмент за съдействие. ",
      "title": "Условия за ползване"
    },
    "travel": {
      "faq": {
        "countries": {
          "content": "Работим с 2000+ банки в 28 държави, включително Нидерландия, Португалия, Белгия, Германия, Полша, България, Франция, Ирландия, Италия, Австрия, Испания, Дания, Естония, Обединеното кралство, Люксембург, Румъния, Литва, Унгария, Латвия, Финландия, Швеция, Норвегия, Чешката република, Словакия, Гърция и Словения.",
          "title": "В кои държави работи Noda?"
        },
        "currencies": {
          "content": "Noda поддържа различни световни валути, включително EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON и SEK.",
          "title": "Какви валути поддържа Noda?"
        },
        "easy-to-start": {
          "content": "Да. Нашият екип за поддръжка е готов да ви помогне при всякакви пречки. Ние предлагаме гладка интеграция, за да можете да започнете да приемате плащания бързо и лесно.",
          "title": "Лесно ли е да започнете да приемате плащания онлайн с Noda?"
        },
        "how-to-integrate": {
          "content": "Първо, трябва да сте се включили в програмата Noda. Просто попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Ние предлагаме лесно включване в системата с персоналните насоки на специален мениджър. Нашият процесор се интегрира гладко с API и фронт-енд компоненти, като осигурява безпроблемно сливане с вашата платформа.",
          "title": "Как мога да интегрирам Noda в работния си процес за плащане?"
        },
        "kind-of-travel-business": {
          "content": "Noda предлага решения за разплащания в туристическата индустрия за всички видове и размери компании, като има налични мащабируеми планове, които да подпомогнат растежа на бизнеса ви.",
          "title": "С какви туристически фирми работите?"
        },
        "needs": {
          "content": "За да започнете да използвате Noda, попълнете формуляра и нашият екип по продажбите ще се свърже с вас скоро. Noda предлага лесно въвеждане в експлоатация с помощта на специален мениджър, който гарантира, че ще бъдете подкрепени на всяка стъпка от пътя.",
          "title": "Какво е необходимо, за да започна работа?"
        },
        "subtitle": "ОТГОВОРИ НА ВАШИТЕ ВЪПРОСИ",
        "title": "FAQs"
      },
      "hero": {
        "text": "Издигнете туристическия си бизнес. Нашата платформа за плащания „всичко в едно“ дава приоритет на разбирането, ефективността и растежа на клиентите",
        "title-1": "Плащане за пътуване",
        "title-2": "Решения с Noda:",
        "title-gradient-1": "Вашите плащания",
        "title-gradient-2": "са наш приоритет"
      },
      "how-does-it-work": {
        "content": "Noda е световна система за пътнически плащания и доставчик на отворено банкиране. От управлението на транзакциите до финансовите анализи - Noda ви е осигурила. Платформата ни използва най-съвременни технологии за изкуствен интелект и машинно обучение.\n\nОтвореното банкиране означава, че традиционните банки споделят данни с лицензирани финтех компании като Noda, за да оптимизират трансакциите. Нашата платежна екосистема свързва всички водещи банки в Обединеното кралство и ЕС, като улеснява безпроблемното предоставяне на търговски услуги за туристическите агенции.",
        "subtitle": "Технологии",
        "title": "Как работи"
      },
      "how-to-start": {
        "content": "Noda предлага лесно включване в системата с индивидуалните насоки на специален мениджър. Нашият екип е тук, за да ви помогне при всякакви препятствия. За да започнете да използвате Noda, просто попълнете формуляра и нашите търговски представители ще се свържат с вас скоро.",
        "subtitle": "Лесно включване",
        "title": "Как да започнете"
      },
      "payments": {
        "text": "Изпитайте ефективността на незабавните транзакции, като средствата бързо се отразяват в сметката ви в рамките на няколко минути. Нашите лесни за използване и опростени API безпроблемно пускат продуктите ви на пазара",
        "title": "Комплект инструменти за туристическата индустрия"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Използвайте нашите прозрения, базирани на данни. Инструментите на Noda предлагат готови за използване анализи на поведението на клиентите, включително алгоритми за сегментиране и прогнозиране.",
            "title": "Анализ, базиран на AI"
          },
          "banking": {
            "content": "Подобряване на преживяването на клиентите и улесняване на транзакциите с мощта и сигурността на отворените банкови плащания",
            "title": "Отворено банкиране"
          },
          "global-currencies": {
            "content": "Noda работи с различни световни валути, за да поддържа вашите туристически операции по целия свят",
            "title": "Глобални валути"
          },
          "payment-processing": {
            "content": "Рационализирайте вноските и изплащанията с Noda. Възползвайте се от интуитивен потребителски интерфейс, интелигентно маршрутизиране и разнообразие от методи на плащане",
            "title": "Обработка на плащане\n за туристическата индустрия"
          },
          "scalable-plans": {
            "content": "Ние предлагаме решения за туристическата индустрия за компании от всякакъв размер, с налични мащабируеми планове, които да стимулират растежа на вашия бизнес",
            "title": "Мащабируеми планове"
          },
          "security": {
            "content": "Noda предоставя сигурни шлюзове за плащания за туристически бизнес, като гарантира съответствие с PCI DSS, криптиране и предотвратяване на измами",
            "title": "Сигурност"
          }
        },
        "subtitle": "ОТВОРЕНО БАНКИРАНЕ И ПЛАЩАНИЯ",
        "title-1": "Топ функции"
      }
    },
    "ux-approach": {
      "about-design": {
        "comments": {
          "business": {
            "name": "Valērijs Sičovs",
            "position": "Chief Business Development Officer",
            "text": "Noda е виден европейски доставчик на отворено банкиране с богат опит в областта на технологиите за плащане, ориентирани към потребителите. Нашите решения с добавена стойност променят хода на платежните стратегии на търговците и всички можем да се съгласим, че популярността на плащанията чрез отворено банкиране в Европа е неоспорима.<br/>Разполагаме с авангардно технологично решение, но тясното сътрудничество с екипите за разработка и дизайн на Noda ни позволява да окажем още по-голямо влияние върху това как търговците могат да се възползват от добре оформеното потребителско изживяване и платежния процес. Касите на Noda, с цялата си елегантност, превръщат дори такова исторически скучно нещо като плащанията в най-съвременно състояние."
          },
          "compliance": {
            "name": "Lāsma Gavarāne",
            "position": "Chief Compliance Officer",
            "text": "Правилно изграденият дизайн сам по себе си е като проект за красота, който отговаря на функционалността на продукта. Дизайнерският подход на Noda е страхотен, защото не става въпрос само за това как изглеждат нещата, а по-скоро как работят безпроблемно заедно. Това е като да имаш суперсила, която прави всичко без усилие и вълнуващо, и точно това искаме да споделим със света!"
          },
          "experience": {
            "name": "Max Gulewicz",
            "position": "Chief Experience Officer",
            "text": "Отначало си мислех, че страхотният дизайн помага за решаването на конкретни проблеми; после, че страхотният дизайн трябва да отговаря на 100% на нуждите на крайната целева аудитория; после, че трябва да имаме предвид и бизнес ключовите показатели за ефективност на нашите клиенти. Но след 25 години интензивно проектиране осъзнах, че за да проектираш страхотно преживяване, което оставя най-вкусния послевкус, трябва не само да ОБИЧАШ това, което правиш, но и да си донякъде обсебен, може би дори да жертваш нещо за дизайна, за нечие друго щастие. Невероятно готино е да се чувстваш като творец, но още по-хубаво е да разбереш и видиш, че усилията ти не са напразни."
          },
          "hr": {
            "name": "Olga Ķerpe",
            "position": "HR Director",
            "text": "Лично за мен страхотният дизайн е свързан с естетиката, вниманието към детайлите и иновациите. А в нашия дизайн на Noda всичко това е съчетано перфектно. Работим наистина усилено, за да следваме винаги най-новите тенденции и да използваме най-новите инструменти и функции. Бих казал също, че тези характеристики отразяват цялостния ни подход и екипът ни прави всичко възможно да го демонстрира визуално пред света на FinTech."
          },
          "project": {
            "name": "Egor Mahaniuk",
            "position": "Head of Project Management Office",
            "text": "Представете си това: Noda е като елегантен спортен автомобил, проектиран да обръща внимание и да осигурява вълнуващо пътуване през цифровия пейзаж. Нашето потребителско изживяване е не просто интуитивно, а практически телепатично. Изработихме интерфейса по начин, който го прави достъпен за потребители от всички нива на умения. Но почакайте, има и още! Мащабируемостта и гъвкавостта са нашият хляб и масло. Благодарение на модулната ни архитектура обновяванията са толкова бързи, колкото и появата на нови технологии на пазара, което ни гарантира, че винаги сме в крак с новостите, без да се потим. Потребителският интерфейс на Noda не е просто поредният остарял дизайн; това е преживяване, което ще ви накара да си кажете: \"Защо всичко не може да бъде толкова забавно и лесно\"?"
          },
          "solutions": {
            "name": "Volodymyr Mykhailin",
            "position": "Chief Solutions Officer",
            "text": "Когато мислите за висококачествен UX дизайн, е важно той да е ориентиран към потребителите и същевременно да гарантира яснота, удобство и ефективност. Noda рязко признава този принцип и активно го въвежда в своите продукти. Потребителите не изпитват никакви проблеми с разбирането на начина на работа на продукта; не възникват въпроси за това какво трябва да направят след това и защо се е случило дадено събитие. Продуктите са проектирани по начин, който свежда до минимум бариерите пред взаимодействието между потребителите и технологията. Когато потребителите не губят време за преодоляване на пречките на интерфейса или за търсене на необходимата информация, тяхната удовлетвореност и лоялност към продукта се увеличават. Подобен подход към проектирането не само подобрява потребителското изживяване, но и повишава конкурентното предимство на компанията в рамките на нейното пазарно пространство."
          }
        },
        "subtitle": "Членове на екипа за дизайна",
        "title": "Помолихме нашия екип да сподели<br/> какво мисли за Noda Design "
      },
      "hero": {
        "subtitle": "Дизайн манифест",
        "text": "Ние сме екип от опитни дизайнери, създатели и изследователи, които превръщат отвореното банкиране в лесен, плавен и достъпен начин за извършване и получаване на плащания.",
        "title": "Опит на клиентите<br/>в Noda"
      },
      "principles": {
        "ecosystem": {
          "text": "И купувачите, и търговците трябва да се доверяват един на друг и на системата. Разполагаме със средствата за подобряване на това доверие.",
          "title": "Сигурен екосистема"
        },
        "interaction": {
          "text": "Вярваме, че ще създадем свят, в който няма да има грешни плащания.",
          "title": "Податливо на грешки взаимодействие"
        },
        "seconds": {
          "text": "Плащанията винаги са твърде бавни и ние сме твърдо решени да ги направим по-бързи.",
          "title": "Секунди за бръснене"
        },
        "solutions": {
          "text": "Платежната индустрия е склонна да бъде досадно скучна и като цяло празна. Надяваме се да променим това.",
          "title": "Елегантни решения"
        },
        "subtitle": "Дизайн на мазе",
        "title": "Нашите принципи"
      },
      "what-we-do": {
        "subtitle": "И накрая",
        "text-1": "Ние проектираме и разработваме цял набор от инструменти, процеси и конвенции, които ще захранват следващото поколение плащания.",
        "text-2": "Използвайки гъвкави и фокусирани върху изследванията процеси — докато използваме напълно нашия богат опит в електронната търговия и плащанията, ние изграждаме инструменти за търговци, които премахват триенето от плащанията.",
        "title": "Какво правим"
      }
    },
    "wargaming": {
      "subtitle": "Запознайте се с казус от практиката",
      "text": "През февруари 2023 г. Wargaming, водещ издател на мултиплатформени игри, влезе в партньорство с Noda, за да въведе незабавни плащания по отворено банкиране за игрите си. Това сътрудничество предостави на играчите на Wargaming разнообразни възможности за онлайн разплащания, включително трансакции между сметки (A2A), поддържани от инфраструктурата за отворено банкиране.",
      "title": "Как Wargaming използва Noda за подобряване на процеса на плащане"
    },
    "white-label": {
      "boost": {
        "tag-title": "РАЗВИТЕ ВАШИЯ БИЗНЕС С NODA",
        "text": "Нашият център за администриране предлага пълно проследяване на всички комисиони, което гарантира прозрачно отчитане. Лесно наблюдавайте плащанията и изплащанията, както за търговците, така и за себе си. Поемете контрола с пълна видимост и управлявайте бизнеса си без усилие.",
        "title": "Цялостно проследяване и отчитане"
      },
      "hero": {
        "button": "Първи стъпки",
        "tag-title": "ПО-ДОБРИ ПЛАЩАНИЯ",
        "text": "Използвайте нашата технологична платформа като партньор с бял етикет. Интегрирайте безпроблемно транзакциите за отворено банкиране, получавайте полезни анализи и използвайте нашия интуитивен потребителски интерфейс. Ние предлагаме интеграция чрез API, прозрачни отчети и персонализиране на марката.",
        "title": "Развийте бизнеса си с Noda"
      },
      "how-it-works": {
        "a-way-to-keep": "Начин за запазване на сериите от разходи за играчи, които използват бавни банки (без незабавна SEPA)",
        "accept-payments": "Приемане на плащания чрез връзки или QR кодове, които могат да се споделят в различни канали",
        "actionable": "Анализи за действие",
        "actionable-analytics-from": "Приложими анализи от историята на транзакциите и допълнителни данни, предоставени от самите банки",
        "ar": "AR над 90%",
        "buffet": "Бюфет",
        "checkout": "Плащане",
        "dedicated": "Специални и отделни сметки за по-голяма яснота",
        "easily-pay": "Лесно плащане и получаване на плащане с нашата усъвършенствана технология и интелигентно маршрутизиране",
        "effortless": "Безпроблемно и усъвършенствано плащане за фирми от всякакъв тип и размер",
        "expansive": "Разширен обхват с 2000+ банки в 28 държави",
        "great": "Страхотно покритие",
        "instead-of-long": "Вместо дълги формуляри за попълване, потребителите плащат първоначалния депозит и незабавно се регистрират",
        "intuitive": "Интуитивен интерфейс и обширни функции за проверка",
        "know": "Обогатяване на данни",
        "pay": "Pay & Go",
        "pay-by-link-qr": "Плащане чрез връзка и QR",
        "payins": "Плащания и изплащания",
        "payment": "Процент на приемане на плащанията, близък до 100%, което гарантира, че транзакциите ви винаги са одобрени",
        "provides-players": "Предоставя на играчите възможност да плащат по банков път, което повишава конверсията.",
        "round-the-clock": "Денонощна поддръжка, ние сме тук, за да ви помогнем винаги, когато имате нужда",
        "segregated-accounts": "Сегрегирани сметки",
        "simple-payment-process": "Опростен процес на плащане",
        "support": "Поддръжка 24/7",
        "tag-title": "Как работи",
        "title": "Интегриране на нашата технология",
        "trusted-payments": "Доверени плащания",
        "valuable": "Ценна информация за финансовото поведение на клиентите за вземане на добре информирани решения"
      },
      "open-banking": {
        "tag-title": "СИЛАТА НА ОТВОРЕНОТО БАНКИРАНЕ",
        "text-1": "Преди отвореното банкиране традиционните банки контролираха данните на клиентите. Европейският регламент PSD2, приложен през 2018 г., промени това, като задължи банките да споделят данни с лицензирани доставчици от трети страни, като Noda, със съгласието на клиентите.",
        "text-2": "Отвореното банкиране използва интерфейси за програмиране на приложения (API), които служат като софтуерен мост. Когато потребителят избере отворено банкиране, той се прехвърля към своя надежден интерфейс за онлайн банкиране. Това също така предотвратява потенциалната кражба на техните данни от киберпрестъпници.",
        "text-3": "Все повече потребители и търговци в световен мащаб избират тази нова технология. ",
        "text-4": " прогнозира, че общата стойност на транзакциите с отворено банкиране ще нарасне от 57 млрд. долара през 2023 г. до 330 млрд. долара през 2027 г. Плащанията с отворено банкиране вече не са иновативни, а се превръщат в нова норма.",
        "text-link": "Juniper Research",
        "title": "Приемането на отвореното банкиране е в подем"
      },
      "tailored-interface": {
        "tag-title": "ПОДГОТОВЕН ИНТЕРФЕЙС",
        "text": "Използвайте нашите вградени инструменти за персонализиране, за да персонализирате потребителските си интерфейси (UI), или създайте свой собствен преден край, за да контролирате изцяло дизайна. С нашата платформа изборът е ваш, за да адаптирате перфектното изживяване.",
        "title": "Персонали&shy;зирани за вашата марка"
      }
    },
    "why-open-banking": {
      "benefits": {
        "section-1": {
          "cards": {
            "card-1": {
              "description": "Преди <a class=\"link underline\" href=\"/articles/what-is-open-banking-your-ultimate-guide\">отвореното банкиране</a> традиционните банки имаха монопол върху данните на клиентите. Въпреки това европейският регламент PSD2 се появи, за да промени това. Влязъл в сила през 2018 г., той задължи банките да споделят данни с лицензирани доставчици от трети страни. Това става единствено със съгласието на клиентите. Споделянето на данни насърчи иновациите в плащанията, като ги направи по-бързи, по-гладки и по-сигурни.",
              "title": "Нова ера на плащанията"
            },
            "card-2": {
              "description": "Juniper Research прогнозира, че <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">до 2027 г. общата стойност на транзакциите с OB ще достигне 330 млрд. долара</a>. Това е увеличение от 57 млрд. долара през 2023 г., което представлява общ ръст от 479%.",
              "title": "Бързо развиваща се услуга"
            },
            "card-3": {
              "description": "Потребителите ценят иновациите и превъзходните платежни потоци. Със своята бързина и простота отвореното банкиране се превръща в предпочитан избор за мнозина.",
              "title": "По-иновативни"
            }
          },
          "title": "Той е нов и бързо развиващ се"
        },
        "section-2": {
          "cards": {
            "card-1": {
              "description": "Отвореното банкиране предлага по-ниски такси за транзакциите в сравнение с традиционните картови плащания. Плащанията се извършват от <a class=\"link underline\" href=\"/glossary/a2a-payments\">сметка към сметка</a>.",
              "title": "По-ниски такси"
            },
            "card-2": {
              "description": "Отворените банкови API премахват комисионите за плащане и повечето от оперативните разходи.",
              "title": "Намалени разходи и такси"
            },
            "card-3": {
              "description": "Тъй като не са включени картови мрежи, при плащанията чрез отворено банкиране се избягват обратните такси. Търговците могат да се сбогуват с големите такси за обработка.",
              "title": "Без връщане на плащане"
            },
            "card-4": {
              "description": "Всички търговци получават еднакви цени. Единствената възможна промяна е намаление в отговор на конкурентния натиск.",
              "title": "Разходи за търговци"
            }
          },
          "title": "Това е много печелившо"
        },
        "section-3": {
          "cards": {
            "card-1": {
              "description": "Сроковете за разплащане са по-бързи, а парите се появяват в сметката на търговеца почти веднага. Това може да ви помогне да управлявате по-добре паричните си потоци и счетоводството. Потребителите могат да плащат бързо, без да е необходимо дълго време за обработка. Тъй като времето за сетълмент е по-кратко, те могат да бюджетират по-ефективно.",
              "title": "По-бързи плащания"
            },
            "card-2": {
              "description": "Решенията за отворено банкиране могат да консолидират данните в една платформа. Тя предлага разнообразни бизнес инструменти - от информация за клиентите до решения за проверка.",
              "title": "Ефективност"
            },
            "card-3": {
              "description": "Потребителите плащат от защитения си банков интерфейс, без да се налага да въвеждат ръчно данни за картата. Това им спестява усилия и време, което води до подобряване на пътуването на клиентите.",
              "title": "По-добро потребителско изживяване "
            },
            "card-4": {
              "description": "Отвореното банкиране опростява <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">потребителското преживяване (UX)</a> при плащане, като премахва затрудненията, като например ръчното въвеждане на данни за картата, което води до по-високи конверсии.",
              "inserted-content": {
                "subtext": "*на базата на данни за транзакциите на завръщащи се потребители, взети от платформата на Noda през януари 2024 г.",
                "table": {
                  "tbody-1": {
                    "header": {
                      "col-1": "Германия",
                      "col-2": "До 89%"
                    }
                  },
                  "tbody-2": {
                    "header": {
                      "col-1": "Великобритания",
                      "col-2": "До 92%"
                    }
                  },
                  "tbody-3": {
                    "header": {
                      "col-1": "Холандия",
                      "col-2": "До 92%"
                    }
                  },
                  "thead": {
                    "col-1": "Финансова институция",
                    "col-2": "Процент на приемане, %"
                  }
                },
                "title": "Степен на приемане на транзакциите по отворено банкиране от завръщащите се потребители"
              },
              "show-more-btn": "Покажете статистиките",
              "title": "По-високи проценти на реализация"
            },
            "card-5": {
              "description": "Данните от отвореното банкиране могат да се използват за анализ на финансовите навици и поведение на клиентите. Въз основа на тези данни търговците могат да предлагат по-индивидуализирани преживявания.",
              "title": "Персонализация"
            }
          },
          "title": "Бързо и ефективно"
        },
        "section-4": {
          "cards": {
            "card-1": {
              "description": "Споделянето на данни може да става само с <a class=\"link underline\" href=\"/articles/open-banking-flow\">изричното съгласие на клиента</a>. Ако потребителите решат да спрат да споделят данните си, те могат да се откажат от отвореното банкиране по всяко време.",
              "title": "Контрол на финансовите данни"
            },
            "card-2": {
              "description": "Решенията за отворени банкови данни предлагат незабавна проверка на самоличността, източниците на богатство и други елементи, което може да ви помогне за бързото включване на нови клиенти.",
              "title": "Включване и KYC"
            },
            "card-3": {
              "description": "Отвореното банкиране се основава на <a class=\"link underline\" href=\"/glossary/api\">сигурни API</a>. Оторизацията на плащанията се извършва от доверената банка на клиента. Освен това отвореното банкиране е напълно регулирано от <a class=\"link underline\" href=\"/glossary/european-psd2\">европейската директива PSD2</a>, като силната автентификация на клиента (SCA) е законово изискване.",
              "title": "По-добра сигурност"
            }
          },
          "title": "Тя е 100% сигурна"
        }
      },
      "hero": {
        "subtitle": "Най-доброто решение",
        "text": "Предлагането на отворено банкиране като метод за плащане вече не е новост. Ако не го направите, това може да коства ценни клиенти на вашия бизнес. Ако все още не сте сигурни, прочетете за ползите от отвореното банкиране по-долу.",
        "title": "Защо отворено банкиране?"
      },
      "myths": {
        "description": "Подобно на всяка нова технология, отвореното банкиране често се разбира погрешно. Тези погрешни схващания могат да доведат до това търговците да избягват плащанията чрез отворено банкиране поради липса на знания.\n\nТук развенчаваме често срещаните митове.",
        "myth-10": {
          "content": "Както беше споменато по-рано, клиентите все повече предпочитат отвореното банкиране пред други методи за плащане. Според оценки на <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.statista.com/statistics/1228771/open-banking-users-worldwide/\">Statista</a> до края на 2024 г. броят на потребителите на отворено банкиране в световен мащаб ще достигне 132 милиона. Бързото възприемане на отвореното банкиране е ясен знак за доверието на потребителите. Плащанията чрез ОБ предлагат по-добър, по-интуитивен потребителски интерфейс, а потребителите оценяват по-добрия поток на плащане.",
          "title": "Мит 10. Клиентите не са свикнали с платежния поток на отвореното банкиране"
        },
        "myth-1": {
          "content": "В концепцията за отворено банкиране често се среща погрешно разбиране на думата \"отворен\". Отвореното банкиране не означава, че банките споделят открито данните на клиентите с всеки, който иска да получи достъп до тях. Всъщност доставчиците от трети страни трябва да преминат през <a class=\"link underline\" href=\"/articles/what-are-aisp-and-pisp-in-open-banking\">строго регулаторно лицензиране</a> от националните регулатори, ако искат да прилагат отворено банкиране. Например в европейската PSD2 доставчиците трябва да получат лиценз за AISP или PISP, за да имат достъп до информация за клиентите.",
          "title": "Мит 1. Отвореното банкиране означава, че всичко е \"отворено\""
        },
        "myth-2": {
          "content": "Отвореното банкиране се осъществява чрез сигурни API, които банките споделят с лицензирани доставчици от трети страни. Когато клиентът избере плащане чрез отворено банкиране, той автоматично се прехвърля към своя доверен банков интерфейс, където плащането се оторизира. Това пренасочване от приложение към приложение на API предотвратява потенциалната кражба на данни от киберпрестъпниците, особено в сравнение с практики като скрининг на екрани. Освен това, съгласно PSD2, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://finance.ec.europa.eu/publications/strong-customer-authentication-requirement-psd2-comes-force_en\">силната автентификация на клиента (SCA)</a> е законово изискване за плащанията чрез отворено банкиране. SCA е мярка за многофакторна автентификация, насочена към предотвратяване на измами, свързани с представянето на клиента за личност. ",
          "title": "Мит 2. Отвореното банкиране не е сигурно"
        },
        "myth-3": {
          "content": "Някои клиенти може погрешно да предположат, че когато дадат съгласието си за споделяне на данни, целият свят ще може да види какво се случва с техните финанси. Това просто не е вярно. Само оторизирани доставчици от трети страни могат да имат достъп до данните на клиентите. За да получат такъв лиценз, доставчиците трябва да го получат чрез национален регулаторен орган, като <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.fca.org.uk/consumers/account-information-payment-initiation-services\">FCA в Обединеното кралство</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.bafin.de/EN/Aufsicht/ZahlungsdienstePSD2/ZulassungspflichtigeZahlungsdienste/ZulassungspflichtigeZahlungsdienste_node_en.html\">BaFin в Германия</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://acpr.banque-france.fr/en/authorisation/banking-industry-procedures/licensing-authorisation-and-registration/payment-institution-and-account-information-service-provider\">ACPR във Франция</a>, и други съответни органи на съответната държава, за да се уверят, че доставчиците спазват правилата и обработват данните правилно. Освен това клиентите могат да оттеглят съгласието си по всяко време. ",
          "title": "Мит 3. Неразбиране на споделянето на данни"
        },
        "myth-4": {
          "content": "Съществува погрешно схващане, че плащанията чрез отворено банкиране работят само за сметки в големи банки. В действителност екосистемата на отвореното банкиране е голяма и включва и много по-малки финансови институции. По данни на <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbankingtracker.com/\">Open Banking Tracker</a> има 4394 свързани банки в 73 държави. Ние в Noda <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://coda.io/d/Noda-Supported-banks_dIVjZri07ne\">се свързваме с над 2000+ банки</a> в Обединеното кралство и ЕС.",
          "title": "Мит 4. Отвореното банкиране не подкрепя по-малките банки"
        },
        "myth-5": {
          "content": "Някои търговци могат да предположат, че опцията \"плащане по банков път\" може да отблъсне потребителите, които предпочитат да плащат с карта. Всъщност плащанията по банков път са много по-прости и по-сигурни, тъй като не е необходимо клиентите да въвеждат ръчно данните за картата си. Парите се превеждат от същата банкова сметка, която е свързана с картата, но преводът заобикаля картовата мрежа, което води до по-бърза обработка и по-ниски комисиони. Ето защо клиентите все повече приемат отвореното банкиране вместо картите. В Обединеното кралство например <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbanking.org.uk/news/open-banking-impact-report-october-2023/\">11% от потребителите</a> са активни потребители на този метод на плащане. ",
          "title": "Мит 5. Клиентите, които плащат с карта, ще се отдръпнат от отвореното банкиране"
        },
        "myth-6": {
          "content": "Конверсиите са основните показатели за плащанията. Ето защо е важно да ги постигнете правилно. Съществува мит, че картовите плащания водят до по-успешни трансакции, отколкото плащанията по отворено банкиране. В действителност <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">UX за отвореното банкиране е много по-прост</a>. Потребителите се пренасочват към интерфейса на своята банка и парите се прехвърлят директно от банковата им сметка. Това предотвратява риска от погрешно въведени данни за картата и спестява на клиентите време и усилия, което води до по-високи конверсии.",
          "title": "Мит 6. Конверсиите при картовите плащания са по-високи от тези при отвореното банкиране"
        },
        "myth-7": {
          "content": "Това отново е погрешно схващане. Както беше споменато по-горе, плащанията чрез отворено банкиране не изискват ръчно въвеждане на информация. Клиентите се <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">пренасочват към своя банков интерфейс</a>, където плащанията се оторизират. Оторизацията може да включва въвеждане на код за достъп, биометрична проверка, като сканиране на пръстов отпечатък или лицева идентификация, и код, изпратен до тяхното устройство. Това пътуване е много по-лесно и отнема по-малко време, отколкото въвеждането на дълги данни за картата.",
          "title": "Мит 7. Плащанията чрез отворено банкиране изискват повече данни за плащането"
        },
        "myth-8": {
          "content": "Някои търговци може да смятат, че дори клиентът да открие своята банка в списъка, интеграцията ще бъде изпълнена с триене и в крайна сметка транзакцията ще се провали. Можем да ви уверим, че интеграцията на API за отворено банкиране е безпроблемна, тъй като <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.stet.eu/en/psd2/\">тези API са стандартизирани</a> във всички държави и банки, включени в PSD2. Вижте сами как работи това с <a class=\"link underline\" rel=\"nofollow\" target=\"_blank\" href=\"https://noda.live/demo\">демонстрацията на транзакция</a> с отворено банкиране на Noda.",
          "title": "Мит 8. Интеграцията с банката на клиента ще се провали"
        },
        "myth-9": {
          "content": "Някои търговци може да смятат, че обработката на плащания чрез отворено банкиране е по-бавна. В действителност плащанията, извършвани чрез карти, включват посредници, които изискват по-дълго време за обработка. Плащанията чрез отворено банкиране се извършват от <a class=\"link underline\" href=\"/glossary/a2a-payments\">сметка към сметка</a>, така че не участват картови мрежи. Следователно плащанията са много по-бързи.",
          "title": "Мит 9. Плащанията чрез отворено банкиране отнемат повече време"
        },
        "title": "Често срещани митове\n\nза отвореното банкиране"
      }
    }
  },
  "de": {
    "ab-test": {
      "campaign-30": {
        "button-text-a": "Loslegen",
        "button-text-b": "Loslegen"
      }
    },
    "anti-bribery": {
      "definitions": {
        "associated-person-employees": "<b>Beteiligte Person</b> – Mitarbeiter, Lieferanten, Vertreter, Einzelpersonen oder Organisationen, die im Auftrag von Noda Dienstleistungen erbringen.",
        "bribe-a-financial": "<b>Bestechungsgeld</b> – ein finanzieller oder anderweitiger Vorteil, der ein Anreiz für eine unzulässige, rechtswidrige oder vertrauenswidrige Handlung darstellt.",
        "bribery-the-offering": "<b>Bestechung</b> – das Anbieten, Versprechen, Gewähren, Annehmen oder Fordern eines finanziellen oder anderweitigen Vorteils als Anreiz für eine unzulässige, rechtswidrige oder vertrauenswidrige Handlung.",
        "title": "Definitionen"
      },
      "employee-responsibilities": {
        "act-with-integrity": "aufrichtig handeln und ihre Geschäfte auf faire, ehrliche und transparente Weise führen;",
        "all-nodas-employees": "Alle Mitarbeiter von Noda müssen:",
        "avoid-using-their": "ihre Stellung im Unternehmen nicht zur Förderung persönlicher oder fremder Interessen, auch nicht derjenigen von Familienmitgliedern, nutzen; und",
        "comply-with-nodas": "sich an die ABC-Erklärung von Noda halten;",
        "implement-appropriate-due": "angemessene Due-Diligence-Verfahren bei der Auswahl von Lieferanten, Geschäftspartnern oder Vertretern anwenden, um das Bestechungsrisiko zu mindern und sicherzustellen, dass sie die Anforderungen des UK Bribery Act 2010 kennen;",
        "refuse-to-engage": "keine Geschäfte mit Personen oder Unternehmen abschließen, die sich nicht an die Grundsätze von Noda halten und möglicherweise den Ruf des Unternehmens schädigen könnten;",
        "report-any-instances": "die Rechtsabteilung von Noda über jeden Fall unterrichten, bei dem ihnen ein finanzieller oder sonstiger Vorteil angeboten wird, der den Tatbestand der Bestechung erfüllen könnte oder bei dem sie vermuten, dass sie eine Bewirtung oder ein Geschenk erhalten haben, die nicht den Normen entsprechen;",
        "report-to-noda": "die Rechtsabteilung von Noda über alle Fälle unterrichten, in denen ein Mitarbeiter einen finanziellen oder sonstigen Vorteil erhalten hat, der nicht gemäß den Vorgaben der ABC-Erklärung angezeigt wurde;",
        "title": "Verantwortlichkeit der Mitarbeiter",
        "uphold-nodas-principles": "die Grundsätze von Noda auch in schwierigen Situationen einhalten."
      },
      "key-prohibitions": {
        "bribing-a-public": "2. Die Bestechung eines öffentlichen Beamten ist in jedem Land ausdrücklich verboten. Hierzu gehört das: ",
        "engaging-in-bribery": "1. Die Beteiligung an Bestechung, sei es direkt oder über einen Dritten, ist in jedem Land ausdrücklich verboten. Bestechung wird definiert als:",
        "facilitation-payments-are": "3. Erleichterungszahlungen sind verboten, ausgenommen in Fällen, in denen ein echtes Risiko für das Leben oder das Wohlbefinden besteht.",
        "in-order-to": "mit dem Ziel, ein Geschäft zu gewinnen oder zu behalten oder einen anderen geschäftlichen Vorteil zu erlangen.",
        "offering-promising": "das Anbieten, Versprechen oder Gewähren, Fordern, Erbitten oder Annehmen von Wertgegenständen oder anderen Vorteilen;",
        "offering-promising-or": "das Anbieten, Versprechen oder Gewähren von Wertgegenständen oder anderen Vorteilen;",
        "political-donations-and": "4. Politische Spenden und Lobbyarbeit sind verboten.",
        "the-key-areas": "Die wichtigsten Bereiche, die in unserer ABC-Erklärung beschrieben werden, sind:",
        "title": "Wichtige Verbote und Anforderungen",
        "to-improperly-influence": "eine unzulässige Beeinflussung einer Geschäftsentscheidung oder einer anderen Handlung, Untätigkeit oder Entscheidung einer Person.",
        "to-influence-a": "das Beeinflussen eines Beamten in seiner Funktion;"
      },
      "last-update-at": "Zuletzt aktualisiert am 1. Juni 2024",
      "noda-is-dedicated": "Noda verpflichtet sich dazu, Bestechung und Korruption zu verhindern und nimmt eine Null-Toleranz-Haltung gegenüber allen Handlungen ein, die sowohl im Vereinigten Königreich als auch international gegen die einschlägigen Gesetze zur Bekämpfung von Bestechung und Korruption verstoßen könnten. Diese Verpflichtung beinhaltet die Einhaltung von Gesetzen wie dem UK Bribery Act 2010 und einschlägigen Gesetzen in anderen Gerichtsbarkeiten, in denen wir geschäftlich tätig sind.",
      "principles": {
        "by-any-individual": "von einzelnen Angestellten, Vertretern oder anderen beteiligten Personen oder Unternehmen, die im Namen von Noda handeln;",
        "facilitation-payments-will": "6. Erleichterungszahlungen werden auch dann nicht akzeptiert, wenn sie in bestimmten Ländern als übliche Praxis angesehen werden.",
        "in-any-form": "in jedweder Form, einschließlich in Form von Geschenken oder Unterhaltungsangeboten für den Ehepartner des Entscheidungsträgers oder andere Familienmitglieder;",
        "in-order-to-gain-commercial": "mit dem Ziel, einen wirtschaftlichen, vertraglichen oder behördlichen Vorteil für Noda zu erlangen, in einer Weise, die unethisch ist; oder",
        "in-order-to-gain-personal": "um einen persönlichen Vorteil, sei es in Form eines Geldbetrags oder in anderer Form, für die betreffende Person oder eine andere beteiligte Person zu erlangen.",
        "noda-is-dedicated": "1. Noda hat sich verpflichtet, seine Aktivitäten verantwortungsvoll zu betreiben, unabhängig vom Standort oder den beteiligten Parteien. Unser Schwerpunkt liegt auf ethischen und transparenten Praktiken, die unter allen Umständen mit Integrität gehandhabt werden.",
        "noda-maintains-a": "2. Gegenüber Bestechung und Korruption verfolgt Noda eine strikte Null-Toleranz-Politik. Wir lehnen es unmissverständlich ab, Bestechungsgelder anzubieten, in Aussicht zu stellen, zu zahlen, zu erbitten oder anzunehmen – sei es direkt oder über Dritte, als Mittel, um neue Geschäfte zu akquirieren, bestehende Geschäfte zu erhalten oder irgendeine Form von geschäftlichem Vorteil zu erlangen.",
        "noda-strictly-prohibits": "5. Noda untersagt das Anbieten, Gewähren, Fordern oder Annehmen von Bestechungsgeldern jeglicher Art, sei es in Form von Bargeld oder in anderer Form:",
        "noda-will-not": "7. Noda leistet keine direkten oder indirekten Beiträge an politische Parteien.",
        "title": "Prinzipien zur Bekämpfung von Bestechung und Korruption",
        "to-or-from-any": "an oder von einer natürlichen oder juristischen Person, ungeachtet dessen, ob es sich bei dieser Person um einen öffentlichen Beamten oder eine öffentliche Einrichtung, eine Privatperson oder ein Unternehmen handelt, und ungeachtet ihres Standorts;",
        "under-the-law": "4. Gemäß dem Gesetz kann Bestechung und korruptes Verhalten von verschiedenen Parteien begangen werden, die mit Noda verbunden sind. Dazu zählen Mitarbeiter, ernannte Vertreter, Direktoren, Personen, die im Namen von Noda handeln, sowie alle Personen oder Organisationen, die autorisiert sind, in deren Namen zu handeln.",
        "we-mandate-that": "3. Alle Mitarbeiter und beteiligten Personen sind dazu verpflichtet, alle einschlägigen Anti-Korruptionsgesetze, einschließlich des UK Bribery Act 2010 (Bribery Act), einzuhalten und die für unsere Geschäftstätigkeit geltenden Berufsvorschriften zu befolgen."
      },
      "steps-taken": {
        "accurate-records": {
          "text": "Viele Fälle von schwerer Bestechung und Korruption wurden mit einer mangelhaften Buchführung in Verbindung gebracht. Wir müssen bei Noda unbedingt auf eine genaue Buchführung, Aufzeichnungen und Finanzberichterstattung achten. Die Buchführung, Aufzeichnungen und die gesamte Finanzberichterstattung müssen transparent sein. Alle falschen, irreführenden oder ungenauen Aufzeichnungen können den Ruf und die Integrität von Noda erheblich gefährden.",
          "title": "2. Sorgfältige Buchführung und Aufzeichnungen"
        },
        "compliance-statement": "Diese ‚Erklärung zur Bekämpfung von Bestechung und Korruption‘ wird im Einklang mit den Verpflichtungen von Noda gemäß dem UK Bribery Act 2010 abgegeben.",
        "internal-control": {
          "text": "Noda betreibt ein effizientes System der internen Kontrolle und Transaktionsüberwachung. Nach der Ermittlung und dem Aufzeigen von Bestechungs- und Korruptionsrisiken im Rahmen des Risikobewertungsprozesses werden im Rahmen eines umfassenden Kontroll- und Überwachungsprogramms Verfahren entwickelt, um diese Risiken kontinuierlich zu mindern.",
          "title": "3. Effiziente Überwachung und interne Kontrolle"
        },
        "noda-implements": "Noda setzt die folgenden Maßnahmen um, um Bestechung und Korruption zu verhindern:",
        "risk-assessment": {
          "text": "Eine effektive Risikobewertung entscheidet über den Erfolg oder Misserfolg unserer ABC-Erklärung. Durch die Ermittlung von Risiken können wir bestimmte Bereiche identifizieren, in denen wir mit Bestechungs- und Korruptionsrisiken rechnen müssen. Dadurch lassen sich diese Risiken besser bewerten und abmildern, wodurch Noda geschützt wird.",
          "title": "1. Risikobewertung"
        },
        "title": "Maßnahmen zur Verhinderung von Bestechung und Korruption"
      },
      "subtitle": "Zweck der Erklärung",
      "the-anti-bribery": "Die Erklärung zur Bekämpfung von Bestechung und Korruption („ABC-Erklärung“) umfasst eine ausführliche Anleitung zur Verhinderung von Bestechung und zur Meldung von Bedenken und verdächtigen Aktivitäten.",
      "title": "Erklärung zur Bekämpfung von Bestechung und Korruption"
    },
    "articles": {
      "back-to-articles": "Zurück zu Artikel",
      "case-info": {
        "payer-location": "Standort des Zahlers",
        "product-used": "Verwendetes Produkt"
      },
      "defaultBanner": {
        "buttonText": "Demo buchen",
        "text": "Biete deinen Nutzern eine einfachere, kostengünstige Zahlungsmethode und steigere die Konversionsrate!",
        "title": "Erfahre mehr über Open Banking mit Noda"
      },
      "defaultBannerHero": {
        "buttonText": "Demo buchen",
        "text": "Füge 2000+ Banken für sofortige Ein- und Auszahlungen hinzu und skaliere weltweit mit Leichtigkeit!",
        "title": "Akzeptiere Online-Zahlungen mit Noda"
      },
      "main": {
        "banner": {
          "button": "Start mit Noda",
          "text": "Unsere Produkte machen das Zahlungserlebnis einfacher, schneller und zugänglicher",
          "title": "Zuverlässige Zahlungslösung für Ihr Unternehmen"
        },
        "title": "Artikel"
      },
      "single-article": {
        "tables-banner": {
          "button": "Versuchen Sie Noda",
          "title": "Testen Sie Noda - eine völlig neue Art der Online-Zahlungsannahme"
        }
      }
    },
    "bank-payouts": {
      "control-data": {
        "items": {
          "item-1": {
            "text-1": "Noda arbeitet eng mit Händlern und Banken zusammen, um die branchenspezifischen Komplexitäten sowohl bei C2B- als auch bei B2C-Zahlungsströmen zu verstehen. So können wir Ihnen eine umfassende Lösung anbieten, die auf Ihre geschäftlichen Anforderungen zugeschnitten ist.",
            "title-1": "Die Herausforderungen der Branche verstehen"
          },
          "item-2": {
            "text-2": "Noda verfügt über umfangreiche Erfahrungen mit Open-Banking in der EU und in Großbritannien und entwickelt erstklassige Auszahlungslösungen, die auf die individuellen Bedürfnisse Ihrer Kunden zugeschnitten sind.",
            "title-2": "Bankfachwissen"
          }
        },
        "text": "Machen Sie ausfallsichere Zahlungen mit Noda. Bezahlen Sie Ihre Partner, Lieferanten und Marktplatznutzer mit Leichtigkeit, indem Sie unsere fortschrittliche Technologie und Expertise nutzen.",
        "title": "Volle Kontrolle über Ihre B2C-Auszahlungen"
      },
      "netting-data": {
        "items": {
          "text-1": "Balance Netting sorgt für einen reibungslosen Transfer von Fonds ohne Verzögerungen und hilft, einen gesunden Cashflow für Ihr Unternehmen aufrechtzuerhalten.",
          "text-2": "Nutzen Sie das vorhandene Guthaben zur Auszahlung von Fonds, so dass keine zusätzlichen Überweisungen und Kosten anfallen.",
          "title-1": "Vermeiden Sie Bargeldlücken",
          "title-2": "Kosteneffizienz"
        },
        "subtitle": "Balance Netting",
        "text": "Verwalten Sie Ihr Einzahlungsguthaben nahtlos und nutzen Sie die Fonds zur Auszahlung. Nutzen Sie diese kosteneffiziente Auszahlungsmethode und die sofortige Verfügbarkeit der Fonds",
        "title": "Verwenden Sie Ihr Einzahlungsguthaben für Auszahlungen"
      },
      "payments-data": {
        "balance": "Aktueller Saldo",
        "text": "Schnelle und bequeme bankbasierte Auszahlungen für Händler",
        "title": "Bankauszahlungen",
        "title-colored": "für Swift-Transaktionen"
      },
      "recipient-data": {
        "subtitle": "Zufriedenstellendes Erlebnis",
        "text": "Die Bankauszahlungsoptionen von Noda bieten einen kostenlosen Empfang von Fonds für Privatpersonen, im Gegensatz zu einigen Karten- und Geldbörsensystemen, die für den gleichen Service Gebühren verlangen können. Dieser Vorteil ergibt sich aus der Verpflichtung der Banken, ihren Kunden kostenlose Bank-zu-Bank-Überweisungen anzubieten.",
        "title": "Kostenlos für Empfänger"
      },
      "routing-data": {
        "items": {
          "item-1": {
            "text-1": "Mit dem effizienten Routing von Noda erreichen Ihre Fonds ihr Ziel blitzschnell",
            "title-1": "Schnelle Bereitstellung von Fonds"
          },
          "item-2": {
            "text-2": "Minimieren Sie zusätzliche Banküberweisungen und die damit verbundenen Gebühren mit unserem fortschrittlichen Auszahlungsrouting",
            "title-2": "Reduzierte Kosten"
          }
        },
        "text": "Wir optimieren die Lieferung Ihrer Fonds, um maximale Geschwindigkeit und Kosteneffizienz zu gewährleisten und ineffiziente Bankwege zu vermeiden.",
        "title": "Routing"
      },
      "single-report-data": {
        "subtitle": "Geld mit Lichtgeschwindigkeit",
        "text": "Vergessen Sie verspätete Zahlungen. Wir verwenden FPS- und SEPA-Sofortzahlungsverfahren, um Geld in Echtzeit an Ihre Zahlungsempfänger zu überweisen.",
        "title": "Sofortige Bereitstellung von Fonds"
      },
      "title": "Bezahlen Sie mühelos Lieferanten, Wallet-Besitzer, Streamer und andere. Noda's Business-to-Client (B2C) Bankauszahlungen vereinfachen Massenzahlungen an Privatpersonen und gewährleisten schnelle und einfache Transaktionen"
    },
    "bank-sign": {
      "hero": "Ihre Kunden können sich ganz einfach mit ihrem Bankkonto bei Ihrer Website oder App anmelden. Unsere hochmoderne Technologie nutzt wichtige Bankinformationen und bietet Ihren Kunden ein nahtloses und sicheres Anmeldeerlebnis.",
      "payments-data": {
        "text": "Sichere Anmeldung per Mausklick mit Bankdaten",
        "title": "Anmeldung über die Bank"
      },
      "payouts-data": {
        "items": {
          "item-1": {
            "text-1": "Wenn sie sich für eine Anmeldung über Ihr Bankkonto entscheiden, geben Ihre Kunden Noda die Erlaubnis, auf ihre Daten zuzugreifen. Dies stellt sicher, dass die Informationen, die Sie bei der Anmeldung erhalten, vertrauenswürdig und verifiziert sind und sorgt für zusätzliche Transparenz.",
            "title-1": "Die zuverlässigsten Daten"
          },
          "item-2": {
            "text-2": "Wenn Ihre Kunden sich mit ihren Bankdaten anmelden, interagieren sie mit der vertrauten Benutzeroberfläche ihrer vertrauten Banking-App oder Website, wodurch das Risiko eines Kundenverlusts aufgrund von Schwierigkeiten bei der Registrierung ausgeschlossen wird.",
            "title-2": "Intuitive Benutzeroberfläche"
          }
        },
        "text": "Ihre Kunden stimmen zu, sich über ihre Bank-App oder die Webschnittstelle zu verbinden. Unsere Integrationen entsprechen den höchsten Bankstandards für Sicherheit und Compliance",
        "title": "Schnell und zuverlässig"
      },
      "recipient-data": {
        "subtitle": "Fortschrittliche Kundenakquise",
        "text": "Die nahtlose Anmeldung und die erste Zahlung verwandeln Benutzer mit wenigen Klicks in Kunden. Keine manuelle Dateneingabe erforderlich – alle erforderlichen Informationen und Zahlungsgenehmigungen werden sicher eingeholt, da die Kunden die entsprechende Zustimmung erteilen.",
        "title": "Pay & Go"
      },
      "risk-data": {
        "items": {
          "item-1": {
            "text-1": "Der Schutz von Fonds ist eine anspruchsvolle Aufgabe, und der Bankensektor ist für seine strengen Sicherheitsstandards bekannt. Deshalb bietet die Anmeldung über die Bankfunktion Ihrem Unternehmen die besten Sicherheitsmaßnahmen für den Kundenschutz",
            "title-1": "Robuste Sicherheit"
          },
          "item-2": {
            "text-2": "Mit dieser Funktion vergisst Ihr Kunde niemals seine Anmeldedaten, da der Zugriff auf sein Geld immer gesichert ist. So können Sie sicherstellen, dass Sie keine Kunden aufgrund von Problemen bei der Kontoanmeldung verlieren.",
            "title-2": "Kunden-Touchpoint"
          }
        },
        "text": "Die Möglichkeit eines unbefugten Zugriffs auf das Bankkonto ist aufgrund der strengen Sicherheitsvorkehrungen und der weiteren Strafverfolgung gering bis gar nicht gegeben. Im unwahrscheinlichen Fall einer Übernahme weiß der Kunde sofort von einem Angriff und kann schnell reagieren",
        "title": "Minimales Risiko einer Kontoübernahme"
      },
      "single-report-data": {
        "subtitle": "Hält sich vollständig an die gesetzlichen Standards",
        "text": "Mit den über Noda gesammelten Bankdaten können Sie die meisten Überwachungs-, Onboarding- und Identifizierungsanforderungen und -richtlinien legal erfüllen",
        "title": "Gesetzgebungskonforme Daten"
      },
      "title-1": "Sicher",
      "title-2": "Anmeldung über die Bank"
    },
    "banking": {
      "banking": "Erfahrung im Bankwesen",
      "banks-count": "2000+ banken",
      "c2b": "C2B Konto",
      "easy-onboarding-1": "Einfaches Onboarding",
      "easy-onboarding-2": "Mit einem Personal Manager",
      "experience": "Erleben Sie mühelose Transaktionen mit unserem hochmodernen Open Banking Service, der Ihr Unternehmen mit allen großen Banken in Großbritannien und der EU verbindet.",
      "experience-data": {
        "easy-to-apply": {
          "text": "Flexible Lösung für das Einsammeln von Fonds, mit der Möglichkeit, unser Noda C2B-Bankkonto zu nutzen oder aus unserem Netzwerk von vertrauenswürdigen Bankpartnern",
          "title": "Leicht anwendbar"
        },
        "enhance-customer-experience": {
          "text": "Genießen Sie kostengünstige oder gebührenfreie Einzüge mit einer Fülle von Optionen, die über unser Bankennetzwerk bereitgestellt werden.\n",
          "title": "Verbessern Sie das Kundenerlebnis"
        }
      },
      "features-to-integrations": "Von Funktionen zu Integrationen",
      "first-steps": "ERSTE SCHRITTE",
      "hero": "Verbessern Sie das Kundenerlebnis und vereinfachen Sie Ihren Transaktionsfluss mit der Leistungsfähigkeit und Sicherheit unserer offenen Banking-Plattform.",
      "hero-title-1": "Offenes Bankwesen",
      "hero-title-2": "mit Noda",
      "how-data": {
        "authorise-the-transaction": {
          "text": "Von der Neudefinition der Zukunft mit innovativen Startups bis hin zur Umgestaltung unserer Welt mit ikonischen Marken – Noda unterstützt Tausende von Unternehmen",
          "title": "Autorisieren der Transaktion"
        },
        "choose-your-bank": {
          "text": "Wählen Sie aus einer Auswahl der wichtigsten Banken in Ihrer Region",
          "title": "Wählen Sie Ihre Bank"
        },
        "payment-is-done": {
          "text": "Noda ist die treibende Kraft hinter nahtlosen Transaktionen für Tausende von Unternehmen, von bahnbrechenden Startups bis hin zu Branchenführern",
          "title": "Zahlung erfolgt"
        },
        "sign-into-your-account": {
          "text": "Noda unterstützt Tausende von renommierten Unternehmen, von Startups der nächsten Generation bis hin zu bahnbrechenden Marken, die die Welt verändern.",
          "title": "Melden Sie sich bei Ihrem Konto an"
        }
      },
      "hub-data": {
        "1": {
          "text": "Einfache und effiziente Erstattungsbearbeitung",
          "title": "Erstattungen"
        },
        "2": {
          "text": "Mehrere Benutzerrollen für bessere Kontrolle",
          "title": "Mehrere Rollen"
        },
        "3": {
          "text": "Sichere, schnelle und effiziente Verwaltung von Transaktionen",
          "title": "Transaktionen"
        },
        "4": {
          "text": "Detaillierte und anpassbare Finanzberichte",
          "title": "Berichte"
        }
      },
      "hub-description": "Mit Noda Hub können Sie sich mühelos einklinken, Transaktionspräferenzen konfigurieren, Transaktionen und Berichte überwachen und den Zahlungsverkehr analysieren – alles auf einer einzigen Plattform.",
      "info-data": {
        "subtitle": "Funktionen und Integrationen",
        "text": "Ermöglichen Sie Ihren Kunden die sichere Authentifizierung und Bezahlung innerhalb Ihres Ökosystems mit einer nahtlosen Integration von Anfang bis Ende.",
        "title": "Wie unsere Open Banking Lösung funktioniert"
      },
      "manage-everything": "Verwalten Sie alles, was Sie brauchen, an einem Ort",
      "management": "Management",
      "manager-guidance": "Genießen Sie ein müheloses Onboarding mit dem Beratungsprozess von Noda Hub und erhalten Sie persönliche Unterstützung von Ihrem persönlichen Berater.",
      "manager-help": "Verabschieden Sie sich vom mühsamen Selbst-Onboarding – Ihr persönlicher Berater ist da, um bei allen Hindernissen zu helfen.",
      "payments-data": {
        "text": "Schnelle, sichere und geregelte Banküberweisungen",
        "title": "Open Banking Zahlungen"
      },
      "payments-feature-description": "Optimieren Sie Ihre Zahlungen mit der Funktion Trusted Payments von Noda, die Transaktionen mit vertrauenswürdigen Zahlern absichert, bevor die Fonds überhaupt ankommen.",
      "special-features": "Besondere Merkmale",
      "trusted-payments-1": "Vertrauenswürdige Zahlungen",
      "trusted-payments-2": "um Ihren Checkout zu beschleunigen"
    },
    "banner": {
      "text1": "Stetiges Wachstum oder schneller Wandel?",
      "text2": "Sie wissen, wann es an der Zeit ist, Ihr Unternehmen weiterzuentwickeln.",
      "title": "Eine neue Art des Bezahlens – Alle Produkte von Noda erkunden"
    },
    "block-with-screen": {
      "detailed-and-customizable": "Detaillierte und anpassbare Finanzberichte",
      "easy-and-efficient": "Einfache und effiziente Erstattungsbearbeitung",
      "multi-roles": "Mehrere Rollen",
      "multiple-user": "Mehrere Benutzerrollen für bessere Kontrolle",
      "refunds": "Rückerstattungen",
      "reporting": "Berichterstattung",
      "reporting-v2": {
        "subtitle": "volle Transparenz",
        "text": "Mit unserer Verwaltungszentrale können Sie alle Provisionen verfolgen und eine klare und transparente Berichterstattung sicherstellen. Überwachen Sie mühelos Ein- und Auszahlungen, verschaffen Sie sich einen umfassenden Überblick und verwalten Sie Ihre Geschäfte mit Leichtigkeit.",
        "title": "Detaillierte Überwachung und Berichterstattung"
      },
      "secure-fast": "Sichere, schnelle und effiziente Verwaltung von Transaktionen",
      "tagTitle": "IHR GESCHÄFT MIT NODA ANKURBELN",
      "text": "Mit Noda Hub können Sie sich mühelos einklinken, Transaktionspräferenzen konfigurieren, Transaktionen und Berichte überwachen und den Zahlungsverkehr analysieren - alles auf einer einzigen Plattform.",
      "title": " — Verwalten Sie alles, was Sie brauchen, an einem Ort",
      "transactions": "Transaktionen"
    },
    "card-payments": {
      "active-subscriptions-title": "Aktive Abonnements",
      "available-funds": {
        "pending": "Ausstehend: 35,00 €",
        "title": "Verfügbare Fonds"
      },
      "controls": {
        "desktop": "Desktop",
        "diff-user": "Unterschiedlicher Benutzer",
        "uk": {
          "text-1": "UK",
          "text-2": "London"
        }
      },
      "hero-data": "Erleben Sie nahtlose und stressfreie Kartenzahlungen mit der hochmodernen Technologie und dem smarten Routing von Noda",
      "hood-data": {
        "text-1": "Noda stellt sicher, dass Ihre Online-Kartenzahlungen effizient und zuverlässig abgewickelt werden, wobei die Weiterleitung je nach geografischem Standort, Kartentyp und anderen Faktoren optimiert wird.",
        "text-2": "Steigern Sie Ihre Umsätze und Konversionen mit dem sorgfältig ausgearbeiteten Checkout-Prozess von Noda, der Reibungsverluste reduziert und die Zahlungsabwicklung für Kunden vereinfacht.",
        "text-3": "Verabschieden Sie sich von überhöhten Ausgaben für Kartenzahlungen – das smarte Routing von Noda sorgt dafür, dass Sie immer das beste Angebot erhalten.",
        "text-4": "Nach der Sammlung und sorgfältigen Analyse von Kundendaten sagt das KI-Modell von Noda potenzielle Risiken in Echtzeit voraus und blockiert verdächtige Transaktionen, wodurch Rückbuchungen und Betrug reduziert werden, ohne die Genehmigungsraten zu beeinträchtigen",
        "title-1": "Smartes Routing",
        "title-2": "Maximieren Sie Konversionen",
        "title-3": "Optimierung der Kosten",
        "title-4": "Risikovorhersage mit AI-Modell"
      },
      "how-data": {
        "items": {
          "text-1": "Das leistungsstarke KI-gesteuerte Risikoanalysemodell von Noda bewertet mehr als 50 Parameter, um intelligentere und sicherere Lösungen für Kartenzahlungen zu bieten, die Ihnen Sicherheit geben.",
          "text-2": "Nach einer sorgfältigen Analyse der Zahlung und der Erfassung der erforderlichen Daten prognostiziert das KI-Modell von Noda das potenzielle Risikoniveau in Echtzeit.",
          "text-3": "Das robuste KI-gestützte Risikoanalysemodell von Noda arbeitet mit unserem menschlichen Team zusammen, um über 50 Parameter zu bewerten und intelligentere und sicherere Lösungen für Kartenzahlungen zu bieten, die hohe Transaktionsraten gewährleisten.",
          "title-1": "Beobachtung",
          "title-2": "Risikoeinschätzung",
          "title-3": "Zahlungslösung"
        }
      },
      "info-data": {
        "subtitle": "Sicherheit geht vor",
        "text": "Schützen Sie Ihr Unternehmen und Ihre Kunden mit unseren KI-gestützten Risikoeinschätzungen und dynamischen Reaktionsmöglichkeiten für sichere und zuverlässige Kartenzahlungen.",
        "title": "Risikobewertung und Reaktion"
      },
      "key-features": {
        "text": "Verbessern Sie Ihre Kartenzahlungsabwicklung mit der KI-gestützten Routing- und Akzeptanz-Recovery-Technologie von Noda. Unsere fortschrittliche Software analysiert Transaktionen, leitet sie an die ideale Acquiring-Bank weiter und verbessert die Rate der akzeptierten Kartenzahlungen",
        "title": "Smartes KI-Routing und Akzeptanz-Recovery"
      },
      "monetization": {
        "subtitle": "Kontinuierliche Monetarisierung",
        "text": "Nehmen Sie Kartenzahlungen automatisch in regelmäßigen Abständen, z. B. monatlich oder jährlich, entgegen, ohne jedes Mal Details eingeben zu müssen.",
        "title-1": "Volle Unterstützung für ",
        "title-2": "wiederkehrende Zahlungen"
      },
      "payments-data": {
        "icon": "header/product-payments.svg",
        "text": "Mühelose Kartenzahlungen für Händler",
        "title": "Kartenzahlungen"
      },
      "preference-data-1": {
        "data": {
          "items": {
            "text-1": "Die Zahlung wird sofort in einer einzigen Kommunikation zwischen dem Servicing- und dem Emitting-Server autorisiert, wobei die Fonds sofort vom Konto des Kunden abgebucht werden. Diese Methode ist schneller und bietet ein optimiertes Kassenerlebnis, kann aber anfälliger für Betrug sein.",
            "text-2": "Die Zahlung wird in der ersten Nachricht zwischen den Servern autorisiert und in der zweiten Nachricht abgebucht. Das Geld des Kunden wird auf seiner Karte reserviert und erst nach der zweiten Mitteilung abgebucht. Dieser zweistufige Zahlungsprozess ist zwar sicherer, kann aber zu einer längeren Wartezeit an der Kasse führen.",
            "title-1": "Einzelne Nachricht",
            "title-2": "Doppelte Nachricht"
          }
        },
        "subtitle": "Richten Sie Ihre Einstellungen ein",
        "text": "Das maßgeschneiderte Kartenzahlungssystem von Noda bietet sowohl Einzel- als auch Doppelnachrichtensysteme, um Ihre geschäftlichen Anforderungen zu erfüllen.",
        "title": "Sofortige und verzögerte Abbuchungen"
      },
      "preference-data-2": {
        "data": {
          "items": {
            "text-1": "Schützen Sie Ihr Unternehmen durch Tokenisierung, die für mehr Sicherheit sorgt und das Risiko von Datenschutzverletzungen und Betrug einschränkt, während sie gleichzeitig die Kundenerfahrung verbessert.",
            "text-2": "Erlauben Sie Ihren Kunden, ihre Kartendaten sicher zu speichern und zu verwalten, um zukünftige Transaktionen zu vereinfachen, ohne dass sie ihre Daten erneut eingeben müssen.",
            "title-1": "Tokenisierung",
            "title-2": "Kartenverwaltung"
          }
        },
        "text": "Die Vereinfachung von sich wiederholenden Zahlungen steht im Mittelpunkt von Nodas Bemühungen, Transaktionen zu vereinfachen.",
        "title": "Schnellerer Checkout mit One-Click-Zahlungen"
      },
      "refunds-data": {
        "subtitle": "Support nach dem Kauf",
        "text": "Verbessern Sie die Erfahrung Ihrer Kunden mit nahtlosen Rückerstattungen sowohl über die API als auch über die Benutzeroberfläche",
        "title": "Einfache Erstattungen"
      },
      "single-report-data": {
        "subtitle": "Wissen durch Daten",
        "text": "Verfolgen und überwachen Sie den Zahlungsverkehr, analysieren Sie Zahlungsmuster und erstellen Sie umfassende Berichte über den Zahlungsverlauf und die Leistung in einem einzigen Dashboard.",
        "title": "Einheitliches Berichtssystem"
      },
      "subscription-data": {
        "date-1": "Fällig am 27. September",
        "date-2": "Fällig am 23. Oktober",
        "date-3": "Fällig am 31. Dezember",
        "title-1": "Netflix",
        "title-2": "Musik Premiumkonto",
        "title-3": "Bücherei-App"
      },
      "title-1": "für Ihr",
      "title-2": "Geschäftsbedürfnisse"
    },
    "card-payouts": {
      "card-payouts-title": {
        "1": "Kartenauszahlungen:",
        "2": "für effiziente Transaktionen"
      },
      "hero-data": "Begleichen Sie mühelos Zahlungen an Lieferanten, Wallet-Inhaber oder Streamer mit unseren einfachen und schnellen Kartenauszahlungen.",
      "netting-data": {
        "list": {
          "1": "Rationalisierter Abwicklungsprozess",
          "2": "Blitzschnelle Lieferung",
          "3": "KI-gesteuertes Transfer-Routing"
        },
        "subtitle": "Saldo-Netting",
        "text": "Erleben Sie blitzschnelle Auszahlungen auf Karten über unsere globalen und lokalisierten Kartenzahlungswege, die Ihren Zahlungsempfängern die Fonds in Echtzeit zukommen lassen.",
        "title": "Sofortige Bereitstellung von Fonds"
      },
      "payments-data": {
        "text": "Mühelose kartenbasierte Auszahlungen für Händler",
        "title": "Kartenauszahlungen"
      },
      "payouts-data": {
        "items": {
          "credit": {
            "text": "Dank der umfassenden Erfahrung von Noda in der globalen Kartenzahlungsbranche bieten wir erstklassige Lösungen für die Auszahlung von Karten, die genau auf Ihre Geschäftsanforderungen zugeschnitten sind.",
            "title": "Expertise im Zahlungsverkehr"
          },
          "group": {
            "text": "Bei Noda arbeiten wir mit Händlern und Kartenakquisiteuren zusammen, um die branchenspezifischen Komplexitäten innerhalb der B2C- und C2B-Zahlungsströme zu verstehen.",
            "title": "Die Herausforderungen der Branche verstehen"
          }
        },
        "text": "Rationalisieren Sie Massenauszahlungen an Einzelpersonen mit Noda. Bezahlen Sie mühelos Ihre Lieferanten, Marktplatznutzer und mehr",
        "title": "Schnellere B2C-Kartenauszahlungen mit Noda"
      },
      "routing-data": {
        "items": {
          "airline": {
            "text": "Mit dem effizienten Routing von Noda erreichen Ihre Fonds ihr Ziel blitzschnell",
            "title": "Schnelle Lieferung der Fonds"
          },
          "map": {
            "text": "Minimieren Sie zusätzliche Banküberweisungen und die damit verbundenen Gebühren mit unserem fortschrittlichen Auszahlungsrouting",
            "title": "Reduzierte Kosten"
          }
        },
        "text": "Wir optimieren die Lieferung Ihrer Fonds, um maximale Geschwindigkeit und Kosteneffizienz zu gewährleisten und ineffiziente Bankwege zu vermeiden.",
        "title": "Routing"
      },
      "transfers-data": {
        "items": {
          "approval": {
            "text": "Saldo-Netting sorgt für einen reibungslosen Transfer von Fonds ohne Verzögerungen und hilft, einen gesunden Cashflow für Ihr Unternehmen aufrechtzuerhalten.",
            "title": "Vermeiden Sie Bargeldlücken"
          },
          "wallet": {
            "text": "Nutzen Sie das vorhandene Guthaben zur Auszahlung von Fonds, so dass keine zusätzlichen Überweisungen und Kosten anfallen.",
            "title": "Kosteneffizienz"
          }
        },
        "subtitle": "Vermeiden Sie zusätzliche Transfers",
        "text": "Verwalten Sie Ihr Einzahlungsguthaben nahtlos und verwenden Sie die Fonds zur Auszahlung. Nutzen Sie diese kosteneffiziente Auszahlungsmethode und die sofortige Verfügbarkeit der Fonds",
        "title": "Verwenden Sie Ihr Einzahlungsguthaben für Auszahlungen"
      }
    },
    "checkout": {
      "ai-routing": {
        "text": "Verbessern Sie Ihre Kartenzahlungsabwicklung mit der KI-gestützten Routing- und Akzeptanz-Recovery-Technologie von Noda. Unsere fortschrittliche Software analysiert Transaktionen, leitet sie an die ideale Akzeptanzbank weiter und steigert die Akzeptanzrate von Kartenzahlungen.",
        "title": "Smartes KI-Routing und Akzeptanz-Recovery"
      },
      "checkout-hero-title": {
        "colored": "Zahlungs-Checkout",
        "default": "Nahtlos"
      },
      "convenience": {
        "text": "Die Rationalisierung von sich wiederholenden Zahlungen ist eine Priorität für Noda, um reibungslose Transaktionen zu gewährleisten. Kunden können ihre Kartendaten sicher speichern und verwalten, was zukünftige Transaktionen vereinfacht, ohne dass sie ihre Daten erneut eingeben müssen.",
        "title": "Schnellerer Checkout mit One-Click-Zahlungen",
        "title-1": "Bequemlichkeit vor allem"
      },
      "experience-list": {
        "brush": {
          "text": "Personalisieren Sie Ihre Zahlungsschnittstelle, damit sie zu Ihrem einzigartigen Branding, Ihren Farben und Ihrem Design passt.",
          "title": "Anpassung der Benutzeroberfläche"
        },
        "task": {
          "text": "Schnellerer und müheloser Checkout für Online-Zahlungen mit klarer Benutzerführung und leicht verständlicher Anleitung",
          "title": "Intuitive Benutzeroberfläche"
        }
      },
      "hero": "Erschließen Sie die Möglichkeiten nahtloser Zahlungen mit der benutzerfreundlichen Oberfläche von Noda Checkout und den umfassenden Funktionen für den Zahlungsverkehr.",
      "hood-data": {
        "amount": "Betrag",
        "bank": "Bank",
        "card-issuer": "Kartenherausgeber",
        "card-type": "Kartentyp",
        "country": "Land",
        "currency": "Währung",
        "date-time": "Datum & Uhrzeit",
        "geolocation": "Geolokalisierung",
        "metadata": "Metadaten",
        "store": "Geschäft"
      },
      "how-data": {
        "observation": {
          "text": "Das leistungsstarke KI-gesteuerte Risikoanalysemodell von Noda bewertet mehr als 50 Parameter, um intelligentere und sicherere Lösungen für Kartenzahlungen zu bieten, die Ihnen Sicherheit geben.",
          "title": "Beobachtung"
        },
        "payment-resolution": {
          "text": "Das robuste KI-gestützte Risikoanalysemodell von Noda arbeitet mit unserem menschlichen Team zusammen, um über 50 Parameter zu bewerten und intelligentere und sicherere Lösungen für Kartenzahlungen zu bieten, die hohe Transaktionsraten gewährleisten.",
          "title": "Zahlungslösung"
        },
        "risk-estimation": {
          "text": "Nach einer sorgfältigen Analyse der Zahlung und der Erfassung der erforderlichen Daten prognostiziert das KI-Modell von Noda das potenzielle Risikoniveau in Echtzeit.",
          "title": "Risikobewertung"
        }
      },
      "info-data": {
        "subtitle": "Sicherheit geht vor",
        "text": "Schützen Sie Ihr Unternehmen und Ihre Kunden mit unseren KI-gestützten Risikoeinschätzungen und dynamischen Reaktionsmöglichkeiten für sichere und zuverlässige Kartenzahlungen.",
        "title": "Risikobewertung und Reaktion"
      },
      "localised-checkout": {
        "text": "Ermöglichen Sie Ihren Kunden auf der ganzen Welt ein individuelles Zahlungserlebnis. Noda bietet fortschrittliche Lokalisierung für 10 Sprachen, Kompatibilität über verschiedene Geräte hinweg und für bestimmte Regionen optimierte Zahlungsmethoden",
        "title": "Lokalisierter Checkout weltweit"
      },
      "localization-list": {
        "chart": {
          "text": "Noda geht über die bloße sprachliche Anpassung hinaus, indem es die Zahlungsmethoden anpasst und die besten örtlichen Praktiken für jedes Land implementiert",
          "title": "Feinabgestimmte Lokalisierung"
        },
        "mobile": {
          "text": "Verbessern Sie das Kundenerlebnis durch einen optimierten Checkout-Prozess, der sich an jedes Gerät und jede Software anpassen lässt.",
          "title": "Bildschirm- und plattformübergreifend"
        }
      },
      "payment-methods": {
        "text": "Ob Banküberweisungen, Kredit- und Debitkarten oder mobile Wallets, Noda bietet alles. Mit Dutzenden von integrierten Zahlungsmethoden können Händler ihre Zahlungsströme optimieren und ihren Kunden die nötige Flexibilität bieten, um ihre Einkäufe abzuschließen.",
        "title": "Unbegrenzte Zahlungsmethoden"
      },
      "payments-data": {
        "text": "Optimierte Checkout-Erfahrung für Kunden",
        "title": "Checkout-Formular"
      },
      "personal-touch": {
        "text": "Noda erkennt und speichert auf intelligente Weise den optimalen Zahlungsablauf eines jeden Kunden, einschließlich der bevorzugten Zahlungsmethode, und ermöglicht so nahtlose und einfache Einkäufe für die Kunden.",
        "title": "Erfüllt die Bedürfnisse all Ihrer Kunden",
        "title-1": "Persönliche berührung"
      },
      "refunds-data": {
        "subtitle": "Support nach dem Kauf",
        "text": "Verbessern Sie die Erfahrung Ihrer Kunden mit nahtlosen Rückerstattungen sowohl über die API als auch über die Benutzeroberfläche",
        "title": "Problemlose Rückerstattungen"
      },
      "single-report-data": {
        "subtitle": "Wissen durch Daten",
        "text": "Verfolgen und überwachen Sie den Zahlungsverkehr, analysieren Sie Zahlungsmuster und erstellen Sie umfassende Berichte über den Zahlungsverlauf und die Leistung in einem einzigen Dashboard.",
        "title": "Einheitliches Berichtssystem"
      },
      "tailored-experience": {
        "text": "Der maßgeschneiderte Zahlungsprozess von Noda passt sich der Infrastruktur des Händlers an, was zu einem nahtlosen und vertrauten Zahlungserlebnis für Ihre Kunden führt.",
        "title": "Maßgeschneidertes Zahlungserlebnis für Ihre Kunden"
      }
    },
    "common": {
      "about": {
        "company": {
          "subtext": "Erfahren Sie mehr über unsere Geschichte und Führung",
          "subtitle": "Unternehmen"
        },
        "legal-privacy": {
          "subtext": "Überprüfen Sie unsere rechtliche Dokumentation",
          "subtitle": "Rechtliches & Datenschutz"
        },
        "mission": {
          "subtext": "Entdecken Sie Nodas Mission, Vision und was uns einzigartig macht",
          "subtitle": "Wer wir sind"
        },
        "partnership": {
          "subtext": "Werden Sie unser Partner",
          "subtitle": "Partnerschaft"
        },
        "risk-policies": {
          "subtext": "Machen Sie sich mit unserer Richtlinie zur Einhaltung von Risiken vertraut",
          "subtitle": "Risiko- und AML/CFT-Richtlinien"
        },
        "security": {
          "subtext": "Erfahren Sie mehr über die Sicherheitsbestrebungen und -maßnahmen von Noda",
          "subtitle": "Sicherheit und Datenverarbeitung"
        },
        "ux-approach": {
          "subtext": "Entdecken Sie, was UX für Noda bedeutet",
          "subtitle": "UX-Ansatz"
        },
        "white-label": {
          "footer": "White-Label-Partner",
          "subtext": "Erstellen Sie Ihre eigene Zahlungsplattform mit Noda",
          "title": "Für White-Label-Partner"
        },
        "why-open-banking": {
          "subtext": "Entlarven Sie die Mythen über Open Banking",
          "subtitle": "Warum Open Banking?"
        }
      },
      "automated-data": {
        "item-1": "Präzise: Verringerung des Fehlerrisikos",
        "item-2": "Effizient: Vermeidung von Verzögerungen",
        "item-3": "Sicher: Überprüfung von allem, was zählt"
      },
      "automated-payouts-text": "Durch die Automatisierung des Überprüfungs- und Validierungsprozesses trägt Noda dazu bei, dass alle Auszahlungen schnell, präzise und sicher verarbeitet werden, was sowohl für Händler als auch für Zahlungsempfänger ein müheloses Erlebnis darstellt.",
      "automated-payouts-title": "Automatisierte Überprüfung und Validierung von Auszahlungen",
      "banner-market": {
        "button": "Zum Marktplatz",
        "text": "Stetiges Wachstum oder schneller Wandel?<br/>Sie wissen, wann es an der Zeit ist, Ihr Unternehmen weiterzuentwickeln.",
        "title": "Eine neue Art des Bezahlens&nbsp;–<br />Alle Produkte von Noda erkunden"
      },
      "best-conditions-v2": {
        "additional": {
          "btn": "Contact Sales Team",
          "details": {
            "option-1": "Kostenlos für die ersten drei Monate für kleine und mittlere Unternehmen",
            "option-2": "Sofort Geld auf Ihrem Konto",
            "option-3": "Nahezu kein Betrugsrisiko",
            "option-4": "90 % Akzeptanzrate"
          },
          "offer": "Wenn Sie ein individuelles Preisangebot wünschen, wenden Sie sich bitte an unser Vertriebsteam",
          "subtitle": "Erleben Sie schnelle und sichere Zahlungen mit dem E-Commerce-Plan von Noda",
          "title": "Für alle Unternehmenstypen und -größen"
        },
        "btn": "keine Einrichtungsgebühren",
        "description": "Maximieren Sie Ihren Gewinn mit günstigen Preisen und",
        "subtitle": "Skalierbare Pläne für Ihre Geschäftsbedürfnisse",
        "title": "Beste Bedingungen für jedes Unternehmen"
      },
      "call-to-action": {
        "contact-btn": "Kontakt zum Vertrieb",
        "contact-team-btn": "Kontakt zu unser Team",
        "contact-team-btn-2": "Kontakt zu unserem Vertriebsteam",
        "explore": "Erkunden Sie die Dokumente",
        "get-notified": "Benachrichtigt werden",
        "get-started": "Loslegen",
        "learn-more": "Mehr erfahren",
        "read-less": "Weniger lesen",
        "read-more": "Mehr lesen",
        "sign-up": "Registrieren Sie sich in 10 Minuten",
        "start": "Start",
        "start-using-noda": "Loslegen",
        "try-noda": "Versuchen Sie Noda",
        "use-cases-btn": "Mehr über Open-Banking",
        "withdraw": "Auf Bankkonto abheben"
      },
      "contact": {
        "all-rights": " Noda. Alle Rechte vorbehalten",
        "careers": "Stellenangebote",
        "client-support": "Kundenbetreuung",
        "contact-us": "Kontaktieren Sie uns",
        "cookie": "Cookies-Richtlinie",
        "follow": "Folgen Sie uns",
        "hr": "Personal-Team",
        "marketing": "Marketing",
        "naudapay-limited": "NAUDAPAY LIMITED, (Firmennummer: 11741664) mit der eingetragenen Adresse: 162 Buckingham Palace Road, London, SW1W 9TR, UK ist ein zugelassenes Zahlungsinstitut und wird von der Financial Conduct Authority (FCA) (Referenznummer: 832969) gemäß der Richtlinie über Zahlungsdienste ((EU) 2015/2366) reguliert",
        "partnership": "Partnerschaft",
        "policy": "Datenschutzerklärung",
        "public-relations": "Public Relations",
        "support": "Unterstützung erhalten",
        "terms": "Nutzungsbedingungen"
      },
      "currency": {
        "subtitle": "Fähigkeiten",
        "text": "Erweitern Sie Ihr Geschäft international mit dem Angebot von Noda für Zahlungen in über 100 Weltwährungen.",
        "title": "Verschiedene Währungen"
      },
      "developers": {
        "bank-payouts-api": "API Bankauszahlungen",
        "card-payments-api": "API Kartenzahlungen",
        "card-payouts-api": "API Kartenauszahlungen",
        "login-to-hub": {
          "subtitle": "Volle Kontrolle über alle Funktionen",
          "title": "Anmeldung im Hub"
        },
        "noda-plugins": {
          "subtitle": "Plugins für ecom Plattformen",
          "title": "Noda Plugins"
        },
        "ob-payments-api": "API OB-Zahlungen",
        "open-banking-demo": {
          "subtitle": "Prüfen Sie, wie Noda-Produkte funktionieren",
          "title": "Noda Demo"
        },
        "pay-and-go": "Pay & Go",
        "tech-documentation": {
          "subtitle": "Volle Kontrolle über alle Funktionen",
          "title": "Technische Dokumentation"
        }
      },
      "discover-more-title": "Mehr Funktionen entdecken",
      "discover-title": "Mehr",
      "extensive-product-suite-v2": {
        "description": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt.",
        "description-v2": "Entdecken Sie mit dem Noda-Zahlungsdienst-Ökosystem neue Möglichkeiten für Ihr Unternehmen. Nehmen Sie mühelos Zahlungen entgegen und senden Sie Zahlungen an Ihre Empfänger. Verbessern Sie Ihre Geschäftsabläufe mit unseren benutzerfreundlichen Zahlungsdatendiensten und No-Code-Zahlungslösungen.",
        "subtitle": "Funktionen und Integrationen",
        "title": "Umfangreiche Produktsuite"
      },
      "features": {
        "info": {
          "1": {
            "text": "Schneller und einfacher Einrichtungsprozess. Automatisiertes Onboarding und API-Schlüsselverwaltung im Noda Hub verfügbar",
            "title": "Einfaches Onboarding"
          },
          "2": {
            "text": "Sichere, schnelle und effiziente Verwaltung von Transaktionen",
            "title": "Sichere Transaktionen"
          },
          "3": {
            "text": "Nahtlose Integration mit einem beliebigen Technologie-Stack Ihrer Wahl",
            "title": "Reibungslose Integration"
          },
          "4": {
            "text": "Maßgeschneidertes Onboarding-Erlebnis mit Ihrem persönlichen Kundenbetreuer",
            "title": "Persönlicher Manager"
          },
          "5": {
            "text": "Ausführliche Berichte und Analysen in Noda Hub verfügbar",
            "title": "Analysemöglichkeiten"
          },
          "6": {
            "text": "Einfache und rationelle Bearbeitung von Erstattungszahlungen",
            "title": "Erstattungen"
          },
          "7": {
            "text": "Mühelose Konnektivität mit führenden Banken in Großbritannien und der EU innerhalb des Ökosystems",
            "title": "Vertrauenswürdige Banken"
          },
          "8": {
            "text": "Support für eine Vielzahl von Benutzerrollen in Noda Hub",
            "title": "Mehrere Rollen"
          },
          "9": {
            "text": "Customer to Business (C2B) Konten sind für Händler verfügbar",
            "title": "C2B-Konten"
          },
          "10": {
            "text": "Erweiterte Sicherheitsfunktionen, einschließlich globaler und lokaler Blacklists",
            "title": "Blacklists"
          }
        },
        "subtitle": "Erfahren Sie mehr über die Abdeckung von Noda",
        "text": "Präsentation der zehn besten Merkmale, zugeschnitten auf Ihr Unternehmen",
        "title": "Wesentliche Merkmale"
      },
      "footer": {
        "features-release": "Wir veröffentlichen jedes Jahr Hunderte von Funktionen und Verbesserungen, damit Sie den Veränderungen in der Branche immer einen Schritt voraus sind und eine solide Basis für Ihr Unternehmen schaffen können",
        "how-to-integrate": "Wie Sie sich integrieren können",
        "lets-get-in-touch": "Kontaktieren Sie uns",
        "stay-connected": "Verbunden bleiben",
        "stay-connected-text": "Kontaktieren Sie unser Team, um mehr über Partnerschaft und Zusammenarbeit zu erfahren",
        "total-balance": "Gesamtbilanz",
        "ultimate-provider": "Der ultimative Open Banking-Anbieter"
      },
      "geo-v2": {
        "button": "Unterstützte Bankenliste anzeigen",
        "subtitle": "Standorte",
        "text": "Schalten Sie unsere weltweite Abdeckung frei, um eine hohe Akzeptanzquote in jedem Winkel der Welt zu gewährleisten.",
        "title": "Vollständige geografische Abdeckung",
        "title-v2": "Umfassende weltweite Abdeckung"
      },
      "get-started": "Loslegen",
      "header": {
        "about": "Über",
        "articles": "Artikel",
        "case-studies": "Fallstudien",
        "developers": "Entwickler",
        "events": "Veranstaltungen",
        "glossary": "Glossar",
        "marketplace": "Marktplätze",
        "newsroom": "Pressemitteilung",
        "other": "Sonstiges",
        "pricing": "Preisgestaltung",
        "products": "Produkte",
        "resources": "Ressourcen",
        "use-cases": "Anwendungsfälle"
      },
      "hero-v2": {
        "new": "Neu",
        "personal-onboarding-assistant": "Persönlicher Onboarding-Assistent für jedes Unternehmen"
      },
      "how-to-start": {
        "subtitle-1": "Einfache Onboarding",
        "text": "Noda bietet ein einfaches Onboarding mit der persönlichen Anleitung eines engagierten Managers. Unser Team ist hier, um bei allen Hindernissen zu helfen. Um Noda zu nutzen, füllen Sie einfach das Formular aus, und unsere Vertriebsmitarbeiter werden sich in Kürze mit Ihnen in Verbindung setzen.",
        "title-1": "Wie Sie beginnen"
      },
      "identification-text": "Noda bietet nahtlose KYC-Verfahren mit seiner hochmodernen Open-Banking-Technologie und erspart Ihren Kunden das lästige Einreichen von Dokumenten und Selfies.",
      "kyc-title": "Hochwertiges KYC bei Bedarf",
      "more-title": "Funktionen entdecken",
      "not-verified": "80% verifiziert",
      "offer-for-smbs": {
        "from": "Ab",
        "per-transaction": "pro Transaktion",
        "title": "Kostenlos für die ersten 3 Monate für kleine und mittlere Unternehmen"
      },
      "payee-identification-title": "Open-Banking Identifizierung des Zahlungsempfängers",
      "personal-manager": "Ihr persönlicher Berater",
      "post-payment-support": "Noda bietet umfassende Unterstützung nach der Zahlung, die sich auf Zusammenarbeit und Fortschritt konzentriert",
      "products": {
        "financial-data": {
          "know-your-whales": {
            "subtext": "Vorhersagbare Finanzinformationen für Händler",
            "subtext-2": "Finanzielle Einblicke und Prognosen für Händler",
            "subtitle": "Datenanrei&shy;cherung"
          },
          "sign-in-via-bank": {
            "subtext": "Sichere Anmeldung per Mausklick mit Bankdaten",
            "subtitle": "Anmeldung über die Bank"
          },
          "title": "Finanzielle Daten",
          "virtual-ibans": {
            "subtext": "Weltweite Überweisungen mit einer virtuellen IBAN",
            "subtitle": "Virtuelle IBANs"
          }
        },
        "noda-go": {
          "pay-and-go-hard": "Pay & Go Hard",
          "pay-and-go-light": "Pay & Go Light"
        },
        "pay-ins": {
          "card-payments": {
            "subtext": "Einfache Abwicklung von Kartenzahlungen für Händler",
            "subtitle": "Kartenzahlungen"
          },
          "checkout-form": {
            "subtext": "Optimierte Checkout-Erfahrung für Kunden",
            "subtitle": "Checkout-Formular"
          },
          "instant-payment-links": {
            "subtext": "Flexible Bezahlung über verschiedene Medientypen hinweg",
            "subtitle": "Sofortige Zahlung Links"
          },
          "merchant-of-record": {
            "subtext": "All-in-One-Lösung für die Abwicklung aller Zahlungen und rechtlichen Verpflichtungen",
            "subtitle": "Merchant of Record"
          },
          "no-code-payment": {
            "subtext": "Benutzerdefinierte Zahlungsseiten über AI-Builder",
            "subtitle": "Zahlungsseite Ohne Code"
          },
          "open-banking-payments": {
            "subtext": "Schnelle, sichere und regulierte Banküberweisungen",
            "subtitle": "Open Banking-Zahlungen"
          },
          "title": "Einzahlungen"
        },
        "pay-outs": {
          "bank-payouts": {
            "subtext": "Bequeme und schnelle bankbasierte Auszahlungen für Händler",
            "subtitle": "Bankauszah&shy;lungen"
          },
          "card-payouts": {
            "subtext": "Mühelose kartenbasierte Auszahlungen für Händler",
            "subtitle": "Kartenauszah&shy;lungen"
          },
          "title": "Auszahlungen"
        }
      },
      "resources": {
        "articles": "Artikel",
        "glossary": "Glossar"
      },
      "subscribe": {
        "title-1": "Erhalten Sie die neuesten Nachrichten von Noda",
        "title-2": "Bleiben Sie mit Noda auf dem Laufenden, indem Sie sich für unseren Newsletter anmelden"
      },
      "tech-friendly-v2": {
        "acceptance-rate": {
          "option-1": "Über zu 90 %",
          "option-2": "Akzeptanzrate"
        },
        "api-key-management": {
          "description": "Einfache API-Schlüsselverwaltung"
        },
        "description": "Noda bietet mit seiner API und seinen Front-End-Komponenten eine reibungslose Integration, die eine problemlose Einbindung in Ihre Plattform gewährleistet. Erleben Sie eine schnelle und effiziente Einrichtung und bieten Sie Ihren Kunden bessere Zahlungslösungen in Stunden, nicht Wochen.",
        "gateway": {
          "description": "Sicheres und zuverlässiges Gateway"
        },
        "subtitle": "Tech-freundlich",
        "tech-platforms-support": {
          "description": "Alle Arten von technischen Plattformen werden unterstützt"
        },
        "title": "Nahtlose Integration für besseren Zahlungsverkehr: Starten Sie in wenigen Stunden, nicht erst in Wochen"
      },
      "transaction-control": {
        "part-title-1": "Kontrolltransaktionen in unserem",
        "part-title-2": "Multifunktionales Armaturenbrett",
        "text-1": "Mit Noda Hub können Sie sich mühelos einklinken, Transaktionspräferenzen konfigurieren, Transaktionen und Berichte überwachen und den Zahlungsverkehr analysieren – alles auf einer einzigen Plattform.",
        "text-2": "Konsolidierte Funktionen für müheloses Zahlungsmanagement",
        "title-2": "Monitoring mit Sicherheit"
      },
      "use-cases": {
        "ecommerce": {
          "subtext": "Zahlungsgateway für E-Commerce",
          "subtitle": "E-Commerce"
        },
        "educational-platforms": {
          "subtext": "Zahlungsgateway für Bildungsplattformen",
          "subtitle": "Bildungsplattformen"
        },
        "marketplaces": {
          "subtext": "Zahlungsgateway für Marktplätze",
          "subtitle": "Marktplätze"
        },
        "online-gaming": {
          "subtext": "Zahlungsgateway für Online-Spiele",
          "subtitle": "Online-Spiele"
        },
        "retail": {
          "subtext": "Zahlungsgateway für den Einzelhandel",
          "subtitle": "Einzelhandel"
        },
        "saas": {
          "subtext": "Zahlungsgateway für SaaS",
          "subtitle": "SaaS"
        },
        "travel": {
          "subtext": "Zahlungslösungen für Reiseunternehmen",
          "subtitle": "Reise & Tourismus"
        }
      },
      "verified": "100% verifiziert"
    },
    "company": {
      "articles": {
        "title": "Das Neueste von Noda"
      },
      "hero": {
        "part-1": "Ihre Zahlungen, ",
        "part-2": "Unsere Priorität",
        "text": "Wir sind Noda - ein führender weltweiter Zahlungsanbieter - wir ermöglichen Online-Händlern eine ultimative neue Möglichkeit, Zahlungen online zu akzeptieren und direkte Bankzahlungen sofort als Alternative zu Karten zu erhalten, ohne Rückbuchungen"
      },
      "leadership": {
        "ceo": {
          "name": "Igor Loktev",
          "role": "CEO/Co-Founder",
          "text": "Igor bringt über 20 Jahre Erfahrung in den Bereichen IT und Finanzen in unser Team ein. Mit einem Master of Science in Informatik, einem Executive MBA und einem laufenden PhD-Studium in Quanteninformatik verfügt er über hervorragende Kenntnisse in den Bereichen Produktentwicklung, Datenanalyse und Systemoptimierung.\n\nIgor ist entschlossen, das Wachstum von Noda voranzutreiben und die Innovation im Fintech-Sektor voranzutreiben. Sein großes Interesse an Sport, Musik und dem dynamischen Gebiet der Informatik spielt ebenfalls eine wichtige Rolle in seinem beruflichen Ansatz."
        },
        "clo": {
          "name": "Ellina Sedleniece",
          "role": "Chief Legal Officer (CLO)",
          "text": "Ellina bringt einen reichen Erfahrungsschatz in das Team ein. Sie verfügt über 15 Jahre Erfahrung im juristischen Bereich mit den Schwerpunkten M&A, FinTech, Risikokapital, Datenschutz, Banken und Finanzen.\n\nSie engagiert sich für die Bereitstellung innovativer und ergebnisorientierter rechtlicher Lösungen, die das Unternehmenswachstum fördern, Risiken mindern und die Interessen des Unternehmens schützen.\n\nMit einer soliden Ausbildung an der Riga Graduate School of Law erwarb sie 2019 einen LL. M. in Internationalem und Europäischem Recht, gefolgt von einem LL. M. in Technologierecht im Jahr 2020. Ellina hat ihren Wohnsitz in Riga und kombiniert ihr umfassendes juristisches Fachwissen mit einer vorausschauenden Denkweise, um die Komplexität der heutigen globalen und technologischen Landschaft zu bewältigen.\n\nEllina bereichert ihr berufliches Fachwissen mit vielfältigen Interessen; sie erfreut sich an der Kunst des Klavierspiels, den Freuden des Reisens und der faszinierenden Welt des Lesens."
        },
        "coo": {
          "name": "Anastasija Tenca",
          "role": "Chief Operations Officer (COO)",
          "text": "Anastasija ist ein erfolgsorientierter Profi mit über 10 Jahren Erfahrung in den Bereichen Vertrieb, Marketing, Markenmanagement und Projektmanagement sowie Unternehmensverwaltung und -betrieb. Sie spielt eine entscheidende Rolle bei der Steuerung aller operativen Aspekte von Noda und widmet sich der Entwicklung und Umsetzung strategischer Geschäftsinitiativen.\n\nIhr Engagement bei Noda erstreckt sich auf die Ausarbeitung und Umsetzung von Geschäftsstrategien, die den Erfolg vorantreiben, den Aufbau robuster und dauerhafter Geschäftsbeziehungen, die Verfeinerung von Prozessen für maximale Effizienz und die Beaufsichtigung der finanziellen Aktivitäten des Unternehmens.\n\nAnastasijas vielseitiges Fachwissen und ihre strategische Herangehensweise an Geschäftsabläufe machen sie zu einer unschätzbaren Bereicherung für unser Team und zu einer wichtigen Architektin für Nodas kontinuierliches Wachstum und seine Innovation."
        },
        "cro-cco": {
          "name": "Lasma Gavarane",
          "role": "Chief Risk & Compliance Officer (CRO & CCO)/MLRO",
          "text": "Lasma verfügt über fast ein Jahrzehnt Erfahrung in der FinTech-Branche und ist auf die Bereiche Risiko und Compliance spezialisiert. Ihr beruflicher Werdegang wird durch einen doppelten Bildungshintergrund mit Bachelor-Abschlüssen in Business Management und Jura unterstützt.\n\nLasma ist nicht nur Mitglied der International Association of Certified Anti-Money Laundering Specialists (ACAMS), sondern besitzt auch die Zertifizierung „Advanced Certified Anti-Money Laundering Specialist – Risk Management“ (CAMS-RM), die sie als Expertin in der Risiko- und Compliance-Branche auszeichnet.\n\nSie interessiert sich auch dafür, wie technologische Fortschritte, z. B. im Bereich der NewGen-Technologie, einschließlich KI, verschiedene Aspekte des beruflichen Umfelds verbessern und innovieren und wie sie bei Noda angewendet und integriert werden können."
        },
        "cro": {
          "name": "Michael Bystrov",
          "role": "Chief Revenue Officer at Noda",
          "text": "Michael Bystrov, unser Chief Revenue Officer, steht an der Spitze von Nodas Strategien zur Umsatzgenerierung und verfügt über eine 18-jährige Erfahrung im Bereich Vertrieb und Marketing in verschiedenen internationalen Unternehmen. Seine Erfahrung reicht von der Leitung des regionalen Vertriebs von Apple bis hin zur Leitung von ATL- und BTL-Kampagnen für angesehene Marken wie Nestle, JTI und die Diageo Group.\n\nAusgestattet mit einem Master of Science in Finanzmanagement und einem Associate Degree in Marketing und Werbung hat Michael ein tiefes Verständnis für die Dynamik des Marktes. Sein Fachwissen war entscheidend bei der Vorbereitung von Werbeformaten für olympische Austragungsorte und bei der Einbindung in das Segment Regierungsbeziehungen (GR).\n\nAußerhalb seiner beruflichen Tätigkeit ist Michael ein begeisterter Reisender, was seine globale Geschäftsperspektive verbessert, und engagiert sich für den Walschutz, was sein Engagement für die Umwelt unterstreicht."
        },
        "cso": {
          "name": "Volodymyr Mykhailin",
          "role": "Chief Solutions Officer",
          "text": "Volodymyr verkörpert eine Mischung aus akademischer Exzellenz und professioneller Expertise mit einem Hintergrund in Computer Systems und Networks Engineering. Mit seiner umfangreichen Erfahrung in der IT-Branche ist er hervorragend darin, fortschrittliche technologische Lösungen in unsere Geschäftsprozesse zu integrieren, wodurch sowohl die betriebliche Effizienz als auch die Kundenzufriedenheit gesteigert wird.\n\nMit dem Ziel, technologische Innovationen voranzutreiben, führt Volodymyr unser Team bei der Entwicklung anspruchsvoller IT-Strategien und -Lösungen, die die Anforderungen des globalen Marktes übertreffen. Seine Führung stellt sicher, dass unser Unternehmen an der Spitze der Tech-Industrie bleibt.\n\nNeben seinen beruflichen Erfolgen bereichern Volodymyrs vielfältige Interessen, wie Bergwandern und Musik, seine Widerstandsfähigkeit und strategisches Denken, was sowohl seine Arbeit als auch sein persönliches Leben bereichert."
        },
        "cto": {
          "name": "Andrei Batseka",
          "role": "Chief Technical Officer (CTO)",
          "text": "Andrei bringt einen soliden 13-jährigen Hintergrund in Programmierung und Entwicklung in unser Team ein, der durch einen Bachelor-Abschluss in Informatik untermauert wird. Sein Fachwissen erstreckt sich über verschiedene Bereiche und macht ihn zu einem vielseitigen und kompetenten Mitglied unserer technischen Abteilung.\n\nBei Noda ist Andrei maßgeblich an der Entwicklung wichtiger technischer Initiativen und Innovationen beteiligt und bringt dabei in unsere Projekte sein tiefes Verständnis für Programmierung ein. Sein Engagement für kontinuierliches Lernen und dauerhafte Entwicklung zeigt sich in seinem großen Interesse an maschinellem Lernen und neuronalen Netzen, die er aktiv in seine Arbeit einbezieht.\n\nNeben seinen beruflichen Aktivitäten sind Andreis Leidenschaft für das Spielen verschiedener Musikinstrumente sowie seine Liebe zum Schwimmen und Radfahren Ausdruck seiner dynamischen und vielseitigen Persönlichkeit. Diese Hobbys bereichern nicht nur sein Leben, sondern inspirieren ihn auch zu einem kreativen und ganzheitlichen Ansatz bei seiner technischen Arbeit."
        },
        "cxd": {
          "name": "Vladislav Golovach",
          "role": "Chief Experience Designer (CXD)",
          "text": "Vladislav bringt in das Team von Noda 20 Jahre Erfahrung im Bereich Ergonomie und Benutzerfreundlichkeit ein. Er fühlt sich bei UX-Projekten wohl, die eine Herausforderung darstellen und tiefgreifende Forschung erfordern.\n\nSeine Karriere als Autor und Pionier des UI- und UX-Designs ist geprägt von seiner Fähigkeit, intuitive und elegante Benutzeroberflächen zu gestalten, komplizierte Ideen in zugängliche Systeme zu verwandeln und Nutzerforschung in umsetzbare Verbesserungen zu destillieren.\n\nVladislav lebt in Padua, Italien, und verbindet seine Liebe zum Design mit seiner Leidenschaft für die Schaffung sinnvoller Benutzererfahrungen."
        },
        "strategy-advisor": {
          "name": "Lasma Kuhtarska",
          "role": "Co-Founder, Strategy Advisor",
          "text": "Lasma Kuhtarska ist eine herausragende Fachkraft mit einem reichen Hintergrund in den Bereichen Finanzen und Unternehmensentwicklung. Im Jahr 2020 hat sie die Gründung von Noda konzipiert und vorangetrieben und ist damit die treibende Kraft hinter unserer innovativen Plattform. Als Mitbegründerin und Chief Strategy Officer spielt Lasma eine Schlüsselrolle bei der Gestaltung und Umsetzung bahnbrechender Strategien, die das Wachstum von Noda fördern.\n\nLasma absolvierte ihre Ausbildung an der renommierten Stockholm School of Economics und zusätzlich in Data Science for Business an der Harvard Business School. Vor der Gründung von Noda war Lasma bei der lettischen Zentralbank für Finanzanalysen zuständig und brachte ihre Fähigkeiten bei der SEB Group ein, einer der größten Banken in Schweden und den baltischen Staaten."
        },
        "title": "Führung\nvon Noda"
      },
      "noda-timeline": {
        "events": {
          "option-1": "Beta-Version unserer Open-Banking-Zahlungen live geschaltet",
          "option-2": "Erster Händler ging live",
          "option-3": "Beginn der Massenverteilung",
          "option-4": "Überwiegende Mehrheit der EU- und UK-Banken sind verbunden",
          "option-5": "B2C-Zahlungen eingeführt",
          "option-6": "Etablierte Unternehmen in Kanada, Australien, Brasilien",
          "option-7": "Neue Dienste eingeführt: AIS-Datendienste, KI-generierte Zahlungslinks",
          "option-8": "Lizenzen in Brasilien und Australien erworben, Zahlungen in Brasilien gestartet"
        },
        "month": {
          "1": "April, 2021",
          "2": "August, 2021",
          "3": "Dezember, 2021",
          "4": "Juli, 2022",
          "5": "Oktober, 2022",
          "6": "Mai, 2023",
          "7": "Dezember, 2023",
          "8": "Mai, 2024"
        },
        "subtitle": "Zeitleiste Noda",
        "title": "Noda wächst mit Ihrem Unternehmen"
      },
      "our-story": {
        "description1": "Noda ist DU. Wir versuchen, menschlich zu sein, bevor wir ein Zahlungsdienstleister sind. Da wir von Menschen für Menschen entwickelt wurden, bieten wir eine der besten Benutzererfahrungen, die derzeit auf dem Markt verfügbar sind.",
        "description2": "Die Add-ons von Noda sind voller Wärme, und sie sind wirklich so konzipiert, dass sie alle Kundenbedürfnisse auf die bequemste und zeitsparendste Weise abdecken. Niemand verbringt gerne viel Zeit damit, für Waren oder Dienstleistungen online zu bezahlen. Das Bezahlen an sich ist nicht die angenehmste aller Erfahrungen. Machen wir es zumindest weniger zeitaufwendig.",
        "description3": "Wir möchten, dass unsere Kunden Zeit mit ihren Freunden und ihrer Familie verbringen und die kostbaren Momente des Lebens genießen können, anstatt z. B. lange zu überlegen, wie sie das Geld für das Hotel oder den Mietwagen überweisen können oder wie sie die Ausgaben unter Freunden regeln können, um eine Reise zu bezahlen.",
        "subtitle": "Unsere Geschichte",
        "title": "Noda bist du"
      }
    },
    "contact-form-v2": {
      "about": "Über uns",
      "address": "NAUDAPAY LIMITED, Unternehmensnummer: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Erzählen Sie uns von Ihrem Unternehmen und unsere Zahlungsexperten helfen Ihnen, die perfekte Einrichtung für Ihre Anforderungen zu finden.",
      "form": {
        "btn": "Einreichen",
        "controls": {
          "comment": "Optional: Teilen Sie uns Ihr Geschäftsmodell und Ihre Zahlungsanforderungen mit. So können wir Ihre Lösung maßschneidern und den Einrichtungsprozess beschleunigen.",
          "company": "Name der Firma",
          "email": "Arbeit E-Mail",
          "first-name": "Vorname",
          "last-name": "Nachname",
          "phone": "Telefon Arbeit *",
          "select-country": "Länderauswahl",
          "website": "Produkt-Website"
        },
        "labels": {
          "business": "Erzählen Sie uns mehr über Ihr Unternehmen",
          "comment": "Beschreibung des Geschäftsmodells",
          "contact": "Geben Sie Ihre Kontaktinformationen ein",
          "details": "Ihre Kontaktinformationen"
        }
      },
      "header": "Kontaktieren Sie uns",
      "modal": {
        "back": "Geh zurück zum Markt",
        "description": "Wir werden uns in Kürze mit Ihnen in Verbindung setzen.",
        "explore": "Erleben Sie Noda",
        "header": "🙌 Sie sind fertig!"
      },
      "privacy": "Datenschutzrichtlinie",
      "rights": "Noda. Alle Rechte vorbehalten",
      "showcase": {
        "payment": "Wählen Sie die Zahlungslösungen aus, die Sie benötigen",
        "recommended": "Das könnte Sie auch interessieren",
        "related": "Verwandte Lösungen",
        "selected": "Ihre ausgewählten Produkte"
      },
      "terms": "Nutzungsbedingungen",
      "visit-website": "Vollständige Website besuchen"
    },
    "contact-form": {
      "about": "Über uns",
      "address": "NAUDAPAY LIMITED, Unternehmensnummer: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Füllen Sie bitte das Formular aus",
      "form": {
        "controls": {
          "comment": "Bitte erläutern Sie Ihr Geschäftsmodell. Skizzieren Sie kurz den Umfang Ihres Projekts. Geben Sie die wichtigsten Merkmale und Funktionen an, die Nodas Plattform erfüllen soll.",
          "company": "Name der Firma",
          "company-size": "Unternehmensgröße",
          "country": "Land",
          "email": "Arbeit E-Mail",
          "first-name": "Vorname",
          "last-name": "Nachname",
          "phone": "Telefon Arbeit",
          "volume": "Zahlungsvolumen",
          "website": "Website des Unternehmens"
        },
        "labels": {
          "business": "Geben Sie Ihre Geschäftsinformationen ein",
          "comment": "Beschreibung des Geschäftsmodells",
          "contact": "Geben Sie Ihre Kontaktinformationen ein",
          "details": "Geben Sie Ihre Details ein",
          "volume": "Teilen Sie uns Ihr Volumen mit"
        },
        "volume": {
          "option-1": "Weniger als $50.000",
          "option-2": "$50.000 bis $100.000",
          "option-3": "$100.000 bis $1.000.000",
          "option-4": "$1.000.000 bis $10.000.000",
          "option-5": "Mehr als $10.000.000"
        }
      },
      "header": "Kontaktieren Sie unser Vertriebsteam",
      "modal": {
        "back": "Geh zurück zum Markt",
        "description": "Vielen Dank für Ihre Kontaktaufnahme, wir werden Sie in Kürze kontaktieren.",
        "header": "Einreichung erhalten!"
      },
      "powered": "Angetrieben von",
      "privacy": "Datenschutzrichtlinie",
      "rights": "Noda. Alle Rechte vorbehalten",
      "showcase": {
        "recommended": "Das könnte Sie auch interessieren",
        "selected": "Ihre ausgewählten Produkte"
      },
      "terms": "Nutzungsbedingungen"
    },
    "contact-us": {
      "contact-us-hero": {
        "1": "Public Relations",
        "2": "Marketing",
        "3": "Kundenbetreuung",
        "4": "Karrieren",
        "5": "Partnerschaft",
        "6": "Verkaufsteam"
      },
      "contact-us-locations": {
        "london": {
          "text": "162 Buckingham Palace Road, London, SW1W 9TR, UK",
          "title": "London, UK"
        },
        "madrid": {
          "text": "Calle Huertas 11, 28012, Madrid, Spain",
          "title": "Madrid, Spanien"
        },
        "ontario": {
          "text": "1907 Baseline Road, Unit 104, Ottawa, Ontario, K2COC7, Canada",
          "title": "Ontario, Kanada"
        },
        "riga": {
          "text": "Riga, Pils iela 18-23, Latvija, LV-1050",
          "title": "Riga, Lettland"
        },
        "vilnius": {
          "text": "Lithuania, Vilnius, Žalgirio g.90-100, LT-09303",
          "title": "Vilnius, Litauen"
        }
      },
      "hero-text": "Nehmen Sie Kontakt mit uns auf und lassen Sie uns wissen, womit wir Ihnen helfen können – Noda ist immer für einen Dialog offen",
      "hero-title": "Unsere Standorte",
      "locations-text": "Noda ist ein globales Unternehmen mit einer Vielzahl von Standorten auf der ganzen Welt"
    },
    "cookies": {
      "last-update": "Zuletzt aktualisiert am <data>13. September 2024</data>",
      "section-1": {
        "list": {
          "item-1": "Notwendige Cookies dienen dazu, den Betrieb der Website zu gewährleisten. Die Verwendung dieser Cookies basiert auf dem berechtigten Interesse von Noda, den Betrieb der Website zu gewährleisten und Dienstleistungen anzubieten. Für die Verwendung dieser Cookies ist Ihre Zustimmung nicht erforderlich.",
          "item-2": "Präferenz- und Leistungs-Cookies ermöglichen die Ausführung bestimmter Funktionen, die Sie während Ihres Besuchs auf unserer Website nutzen möchten, z. B. die Verwendung von Nachrichten- und Kontaktformularen, die Registrierung, die Auswahl der Sprache und die Nutzung standortbezogener Funktionen. Diese Cookies können ohne Ihre Zustimmung eingesetzt werden.",
          "item-3": "Statistische Cookies werden zur Erfassung und Analyse von Informationen über Ihre Aktionen auf der Website und zur Verbesserung ihrer Funktionalität verwendet. Mit diesen Cookies können Informationen über die Anzahl der Besucher, die Absprungrate, die Quelle des Datenverkehrs und andere damit zusammenhängende Informationen gesammelt werden. Diese Cookies dürfen nur mit Ihrem Einverständnis eingesetzt werden.",
          "item-4": "Marketing-, Targeting- oder Werbe-Cookies werden dazu benötigt, Informationen über die von Ihnen besuchten Websites zu erfassen und die Besucher der Website für Marketingzwecke zu gliedern. Solche Cookies dienen auch dazu, den Besuchern relevante Werbung und Marketingkampagnen anzubieten. Diese Cookies dürfen nur mit Ihrer ausdrücklichen Zustimmung eingesetzt werden. Wenn Sie der Verwendung dieser Cookies nicht zustimmen, werden Sie in einigen Fällen weniger zielgerichtete Werbung sehen."
        },
        "text-1": "Ein Cookie ist ein kleiner Datensatz (Textdatei), den eine Website von Ihrem Browser auf Ihrem Gerät speichern lässt, damit Informationen über Sie gespeichert werden können, wie z. B. Ihre Spracheinstellung oder Ihre Anmeldeinformationen. Wir setzen diese Cookies selbst und nennen sie Erstanbieter-Cookies. Außerdem nutzen wir Cookies von Drittanbietern, d. h. Cookies von einer anderen Domain als der Domain der Website, die Sie besuchen. Im Einzelnen verwenden wir Cookies für die folgenden Zwecke:",
        "text-2": "Noda und seine Partner nutzen Cookies, um den Betrieb der Website zu gewährleisten, Ihre Aktivitäten auf der Website zu erfassen und zu analysieren. Die Cookies erfassen verschiedene Arten von Informationen wie die IP-Adresse, den Typ des verwendeten Geräts, den verwendeten Browser, die besuchten Websites oder andere Informationen.",
        "title": "1. Was sind Cookies?"
      },
      "section-2": {
        "title": "2. Notwendige Cookies"
      },
      "section-3": {
        "title": "3. Präferenz- und Leistungs-Cookies"
      },
      "section-4": {
        "title": "4. Statistische Cookies"
      },
      "section-5": {
        "title": "5. Marketing-, Targeting- oder Werbe-Cookies"
      },
      "section-6": {
        "text-1": "Wenn Sie die Verwendung von Cookies einschränken, blockieren oder löschen möchten, können Sie dies über die Einstellungen Ihres Browsers oder die Cookie-Einstellungen auf unserer Webseite tun. Wenn Sie die notwendigen und leistungsbezogenen Cookies löschen, funktionieren die Website oder einige ihrer Teile möglicherweise nicht mehr richtig.",
        "text-2": "Weitere allgemeine Informationen über Cookies und deren Verwaltung finden Sie unter <a href=\"https://www.aboutcookies.org/\" target=\"_blank\" rel=\"nofollow\">www.aboutcookies.org</a>.",
        "title": "6. Wie kann man Cookies einschränken und löschen?"
      },
      "table": {
        "head-1": "Cookies",
        "head-2": "Zweck",
        "head-3": "Anbieter",
        "head-4": "Lebenszeit"
      },
      "text": "Die von NaudaPay Limited (im Folgenden – Noda) erstellte und betriebene Website <a href=\"https://noda.live/\">www.noda.live</a> nutzt verschiedene Arten von Cookies für verschiedene Zwecke.",
      "title": "Cookie-Richtlinie"
    },
    "demo": {
      "breadcrumbs": {
        "demo": "Noda Demo",
        "home": "Heim",
        "pay-and-go": "Pay&Go",
        "payment-flow": "Zahlungsfluss"
      },
      "payment-flow": {
        "amount-label": "Sehen Sie sich an, wie Noda arbeitet, indem Sie für wohltätige Zwecke spenden",
        "amount-placeholder": "Ihr Betrag",
        "choose-country": "Wählen Sie Ihr Land",
        "countries": {
          "at": "Österreich",
          "be": "Belgien",
          "bg": "Bulgarien",
          "br": "Brasilien",
          "ca": "Kanada",
          "cz": "Tschechien",
          "de": "Deutschland",
          "dk": "Dänemark",
          "ee": "Estland",
          "es": "Spanien",
          "fi": "Finnland",
          "fr": "Frankreich",
          "gb": "Vereinigtes Königreich",
          "gr": "Griechenland",
          "hu": "Ungarn",
          "ie": "Irland",
          "it": "Italien",
          "lt": "Litauen",
          "lu": "Luxemburg",
          "lv": "Lettland",
          "nl": "Niederlande",
          "no": "Norwegen",
          "pl": "Polen",
          "pt": "Portugal",
          "ro": "Rumänien",
          "se": "Schweden",
          "si": "Slowenien"
        },
        "country-select-label": "Land",
        "donate": "Jetzt spenden",
        "funds": {
          "br": {
            "description": "Mit Ihrer Spende unterstützen Sie die weltweiten Bemühungen von Plant-for-the-Planet, Waldökosysteme wiederherzustellen, die Klimakrise zu bekämpfen und die Artenvielfalt zu schützen.",
            "title": "Plant-for-the-Planet"
          },
          "default": {
            "description": "Mit Ihrer Spende finanzieren Sie den Kampf von Caritas Europa gegen Armut und soziale Ausgrenzung und fördern die menschliche Entwicklung, soziale Gerechtigkeit und nachhaltige Sozialsysteme in ganz Europa und weltweit.",
            "title": "Caritas Europa"
          },
          "gb": {
            "description": "Mit Ihrer Spende finanzieren Sie die Forschung der British Heart Foundation zu Herz- und Kreislauferkrankungen und tragen so dazu bei, Risikofaktoren zu reduzieren und die Herzgesundheit zu verbessern.",
            "title": "British Heart Foundation"
          },
          "ro": {
            "description": "Mit Ihrer Spende unterstützen Sie die Aufgabe der Save a Heart Association, Leben zu retten und die Gesundheitslage zu verbessern, indem Sie lebenswichtige medizinische Versorgung bereitstellen, lebensrettende Behandlungen finanzieren und die Prävention von und das Bewusstsein für Herzkrankheiten in Rumänien und darüber hinaus fördern.",
            "title": "Save a Heart Association"
          }
        },
        "main-title": "Versuchen Sie Noda Payment",
        "result": {
          "button": "Kontakt zum Vertrieb",
          "cancel": "Zur Homepage",
          "subtitle": "{fund} hat Ihre Zahlung erhalten 🙌",
          "title": "Vielen Dank für Ihre Spende für wohltätige Zwecke mit Noda"
        }
      },
      "solutions": {
        "common": {
          "coming-soon": "Demnächst verfügbar",
          "no-docs-required": "Echte Dokumente sind für die Demo nicht erforderlich",
          "see-more": "Mehr anzeigen",
          "try-demo": "Demo testen",
          "with-verification": "Mit Identitätsüberprüfung",
          "without-verification": "Ohne Identitätsprüfung"
        },
        "description": "Erfahren Sie, wie Noda-Produkte Zahlungen vereinfachen und Ihr Umsatzwachstum beschleunigen.",
        "main-title": "Entdecken Sie die Lösungen von Noda",
        "pay-and-go": {
          "description": "Zahlung, KYC und Anmeldung. Alles in einem.",
          "hard": "Kunden müssen sich einer automatischen Non-Doc-Verifizierung über GBG unterziehen. Wenn die Non-Doc-KYC-Verifizierung fehlschlägt, wird ein Kunde aufgefordert, die Full-Doc-KYC-Verifizierung über Sumsub zu bestehen. ",
          "light": "Wenn für Ihr Produkt keine Identitätsüberprüfung des Kunden erforderlich ist, können Benutzer die sofortige Zahlung und Registrierung über „Pay & Go Light“ vornehmen."
        },
        "payment-flow": {
          "description": "Sichere Konto-zu-Konto-Direktzahlungen per Bank."
        }
      }
    },
    "documents-page": {
      "nav": {
        "cookies": {
          "subtitle-1": "Was sind Cookies?",
          "subtitle-2": "Notwendige Cookies",
          "subtitle-3": "Präferenz- und Leistungs-Cookies",
          "subtitle-4": "Statistische Cookies",
          "subtitle-5": "Marketing, Targeting oder Werbe-Cookies",
          "subtitle-6": "Wie kann man Cookies einschränken und löschen?",
          "title": "Cookie-Richtlinie"
        },
        "policy": {
          "subtitle-1": "Verantwortlichkeiten",
          "subtitle-2": "Wann wir Ihre Daten erfassen",
          "subtitle-3": "Daten, die wir erfassen, der Verwendungszweck, die Rechtsgrundlage und Aufbewahrungsfristen",
          "subtitle-4": "Empfänger und Quellen Ihrer Daten",
          "subtitle-5": "Internationaler Transfer Ihrer personenbezogenen Daten",
          "subtitle-6": "Ihre Rechte",
          "subtitle-7": "Kontaktinformationen",
          "subtitle-8": "Änderungen an der Datenschutzerklärung",
          "title": "Datenschutzerklärung"
        },
        "privacy-for-candidates": {
          "subtitle-1": "Wozu braucht Noda Ihre Daten?",
          "subtitle-2": "Wie behandelt Noda Ihre Daten?",
          "subtitle-3": "Quellen und Empfänger der Daten",
          "subtitle-4": "Internationaler Transfer",
          "subtitle-5": "Datenschutzrechte",
          "subtitle-6": "Kontaktinformationen",
          "title": "Datenschutzhinweis für Bewerber oder eine Zusammenarbeit"
        },
        "terms": {
          "subtitle-1": "Die Vereinbarung",
          "subtitle-2": "Unser Angebot",
          "subtitle-3": "Zugriff auf den Dienst und Mitteilung über verdächtige Aktivitäten",
          "subtitle-4": "Unser Zugriff auf Ihre Daten",
          "subtitle-5": "Kündigung und Aussetzung",
          "subtitle-6": "Entschädigung und Haftung",
          "subtitle-7": "Beschwerden",
          "subtitle-8": "Allgemeine Bestimmungen",
          "title": "Nutzungsbedin&shy;gungen"
        }
      },
      "title": "Rechtliche Dokumente"
    },
    "ecommerce": {
      "faq": {
        "currencies": {
          "content": "Noda unterstützt eine Vielzahl von Währungen weltweit, darunter EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON und SEK.",
          "title": "Welche Währungen sind verfügbar?"
        },
        "how-long": {
          "content": "Unser Onboarding kann bis zu einem Tag dauern. Das Support-Team von Noda hilft Ihnen bei allen Hindernissen, damit Sie schnell mit der Zahlungsabwicklung beginnen können.",
          "title": "Wie lange dauert es, bis ich mit Noda Zahlungen akzeptieren kann?"
        },
        "how-to-start": {
          "content": "Zunächst sollten Sie bei Noda angemeldet sein. Füllen Sie einfach das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Wir bieten ein einfaches Onboarding mit der persönlichen Betreuung durch einen engagierten Manager. Unser Prozessor lässt sich nahtlos in API- und Front-End-Komponenten integrieren, sodass eine nahtlose Einbindung in Ihre Plattform gewährleistet ist.",
          "title": "Wie kann ich mit Noda Online-Zahlungen annehmen?"
        },
        "needs": {
          "content": "Wenn Sie Noda nutzen möchten, füllen Sie das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Noda bietet ein einfaches Onboarding mit der Anleitung eines engagierten Managers, um sicherzustellen, dass Sie bei jedem Schritt des Weges unterstützt werden.",
          "title": "Was brauche ich für den Anfang?"
        },
        "subtitle": "Wissenswertes",
        "title": "FAQs",
        "types": {
          "content": "Noda bietet E-Commerce-Zahlungslösungen für alle Händlertypen und -größen, mit skalierbaren Plänen, die Ihr Geschäftswachstum unterstützen.",
          "title": "Welche Arten von Händlern unterstützt Noda?"
        }
      },
      "hero": {
        "text": "Steigern Sie Ihr E-Commerce-Geschäft. Unsere All-in-One-Zahlungsplattform legt den Schwerpunkt auf Kundenverständnis, Effizienz und Wachstum",
        "title-1": "Zahlungslösungen ",
        "title-2": "für E-Commerce:",
        "title-gradient-1": "Ihre Zahlungen ",
        "title-gradient-2": "sind unsere Priorität"
      },
      "how-does-it-work": {
        "content": "Noda ist eine weltweite E-Commerce-Zahlungsplattform und ein Anbieter von Open Banking. Vom Transaktionsmanagement bis zur Finanzanalyse - Noda hat alles für Sie. Unsere Plattform nutzt KI- und Machine-Learning-Technologien, um hochmoderne Payment-Gateway-Lösungen für E-Commerce-Unternehmen anzubieten.\n\nOpen Banking bedeutet, dass traditionelle Banken Daten mit lizenzierten Fintech-Unternehmen wie Noda austauschen, um Transaktionen zu rationalisieren. Unser Zahlungsökosystem verbindet alle führenden Banken in Großbritannien und der EU und ermöglicht mühelose E-Commerce-Zahlungsdienste.",
        "subtitle": "Technologien",
        "title": "Wie funktioniert es"
      },
      "how-to-start": {
        "content": "Noda bietet ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unser Team ist da, um Ihnen bei allen Problemen zu helfen. Um mit der Nutzung von Noda zu beginnen, füllen Sie einfach das Formular aus, und unsere Vertriebsmitarbeiter werden sich in Kürze mit Ihnen in Verbindung setzen.",
        "subtitle": "Einfaches Onboarding",
        "title": "Wie man anfängt"
      },
      "payments": {
        "text": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt",
        "title": "Toolset für E-Commerce"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Nutzen Sie unsere datengesteuerten Erkenntnisse. Die Tools von Noda bieten gebrauchsfertige Analysen des Kundenverhaltens, einschließlich Segmentierungs- und Prognosealgorithmen",
            "title": "KI-gestützte Analytik"
          },
          "banking": {
            "content": "Verbesserung des Kundenerlebnisses und Vereinfachung des Transaktionsflusses durch die Leistungsfähigkeit und Sicherheit von Open-Banking-Zahlungen",
            "title": "Offenes Banking"
          },
          "global-currencies": {
            "content": "Noda arbeitet mit einer Vielzahl von Währungen, um Ihre E-Commerce-Aktivitäten auf der ganzen Welt zu unterstützen",
            "title": "Globale Währungen"
          },
          "payment-processing": {
            "content": "Optimieren Sie Ein- und Auszahlungen mit Noda. Nutzen Sie eine intuitive Benutzeroberfläche, intelligentes Routing und eine Vielzahl von E-Commerce-Zahlungsmethoden.",
            "title": "E-Einkauf\n Zahlungsabwicklung"
          },
          "scalable-plans": {
            "content": "Wir bieten E-Commerce-Zahlungsdienste für alle Unternehmensgrößen an, mit skalierbaren Plänen, die Ihr Unternehmenswachstum fördern",
            "title": "Skalierbare Pläne"
          },
          "security": {
            "content": "Noda bietet sicheren E-Commerce-Zahlungsverkehr und gewährleistet PCI DSS-Konformität, Verschlüsselung und Betrugsprävention",
            "title": "Sicherheit"
          }
        },
        "subtitle": "Was wir anbieten",
        "title-1": "Top-Funktionen ",
        "title-2": "für E-Commerce"
      }
    },
    "educational-platforms": {
      "faq": {
        "countries": {
          "content": "Wir arbeiten mit 2000+ Banken in 28 Ländern zusammen, darunter die Niederlande, Portugal, Belgien, Deutschland, Polen, Bulgarien, Frankreich, Irland, Italien, Österreich, Spanien, Dänemark, Estland, das Vereinigte Königreich, Luxemburg, Rumänien, Litauen, Ungarn, Lettland, Finnland, Schweden, Norwegen, die Tschechische Republik, die Slowakei, Griechenland und Slowenien.",
          "title": "In welchen Ländern ist Noda tätig?"
        },
        "currencies": {
          "content": "Noda unterstützt eine Vielzahl von Währungen weltweit, darunter EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON und SEK.",
          "title": "Welche Währungen unterstützt Noda?"
        },
        "how-to-integrate": {
          "content": "Zunächst sollten Sie bei Noda angemeldet sein. Füllen Sie einfach das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Wir bieten Ihnen ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unser Prozessor lässt sich nahtlos in API- und Front-End-Komponenten integrieren, sodass eine nahtlose Einbindung in Ihre Bildungsplattform gewährleistet ist.",
          "title": "Wie kann ich Noda in meinen Zahlungsablauf integrieren?"
        },
        "subtitle": "IHRE FRAGEN BEANTWORTET",
        "title": "FAQs"
      },
      "hero": {
        "text": "Bilden Sie mit Leichtigkeit, während wir uns um die Zahlungen kümmern. Unser All-in-One-Online-Zahlungssystem für Bildungsplattformen legt den Schwerpunkt auf Kundenverständnis, Effizienz und Wachstum",
        "title-1": "Zahlungs-Gateway",
        "title-gradient-1": "für Bildung",
        "title-gradient-2": "Plattformen"
      },
      "how-does-it-work": {
        "content": "Ein Zahlungs-Gateway überträgt Finanzdaten zwischen Lernenden, Händlern und ihren Banken. Stellen Sie sich das Gateway als digitalen Dirigenten vor, der jede Phase der Zahlungsabwicklung im Bildungssektor genauestens steuert.\n\nNoda ist eine weltweite Zahlungsplattform und ein Anbieter von Open Banking. Vom sicheren Gateway über das Transaktionsmanagement bis hin zu Finanzanalysen - Noda hat alles für Sie im Angebot. Unsere Plattform nutzt KI- und Machine-Learning-Technologien, um hochmoderne Online-Zahlungslösungen für Bildungsunternehmen anzubieten.",
        "subtitle": "Technologien",
        "title": "Wie funktioniert das Payment Gateway für den Bildungsbereich?"
      },
      "how-to-start": {
        "content": "Noda bietet ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unsere Plattform lässt sich nahtlos in API- und Front-End-Komponenten integrieren, sodass eine nahtlose Einbindung in Ihre Schnittstelle gewährleistet ist. Um mit der Nutzung von Noda zu beginnen, füllen Sie das untenstehende Formular aus, und unsere Vertriebsmitarbeiter werden Sie in Kürze kontaktieren. Unser Team ist für Sie da und hilft Ihnen bei allen Hindernissen",
        "subtitle": "Einfaches Onboarding",
        "title": "Wie man anfängt"
      },
      "open-banking": {
        "content": "Open Banking bedeutet, dass traditionelle Banken Daten mit lizenzierten Fintech-Unternehmen wie Noda austauschen, um Transaktionen zu rationalisieren. Unser Ökosystem für den Zahlungsverkehr verbindet alle führenden Banken im Vereinigten Königreich und in der EU und ermöglicht mühelose Zahlungsdienste",
        "subtitle": "VIELE MÖGLICHKEITEN",
        "title": "Was ist Open Banking?"
      },
      "payments": {
        "text": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt",
        "title": "Toolset für Bildungsplattformen"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Nutzen Sie unsere datengesteuerten Erkenntnisse. Die Tools von Noda bieten gebrauchsfertige Analysen des Kundenverhaltens, einschließlich Segmentierungs- und Prognosealgorithmen",
            "title": "KI-gestützte Analytik"
          },
          "banking": {
            "content": "Verbessern Sie das Kundenerlebnis und vereinfachen Sie den Transaktionsfluss mit der Leistungsfähigkeit und Sicherheit von Open Banking Payments",
            "title": "Offenes Banking"
          },
          "global-currencies": {
            "content": "Noda arbeitet mit einer breiten Palette von Währungen, um Ihre Kunden auf der ganzen Welt zu unterstützen",
            "title": "Globale Währungen"
          },
          "payment-processing": {
            "content": "Optimieren Sie Ein- und Auszahlungen, nutzen Sie eine intuitive Benutzeroberfläche, intelligentes Routing und bieten Sie eine Vielzahl beliebter Zahlungsmethoden an",
            "title": "Zahlungsabwicklung für Bildungsplattformen"
          },
          "scalable-plans": {
            "content": "Wir bieten Zahlungslösungen für alle Unternehmensgrößen an, mit skalierbaren Plänen, die das Wachstum Ihrer Bildungsplattform fördern",
            "title": "Skalierbare Pläne"
          },
          "security": {
            "content": "Noda bietet sicheren Zahlungsverkehr und gewährleistet PCI DSS-Konformität, Verschlüsselung und Betrugsprävention",
            "title": "Sicherheit"
          }
        },
        "subtitle": "WAS WIR ANBIETEN",
        "title-1": "Top-Funktionen",
        "title-2": "für Bildungs&shy;plattformen"
      }
    },
    "financial": {
      "application-list": {
        "financial1": {
          "text": "Unterhaltung"
        },
        "financial2": {
          "text": "Handel"
        },
        "financial3": {
          "text": "Startups"
        },
        "financial4": {
          "text": "Marktplätze"
        },
        "financial5": {
          "text": "Dating"
        },
        "financial6": {
          "text": "E-Commerce"
        },
        "financial7": {
          "text": "Gaming"
        },
        "financial8": {
          "text": "Reise"
        }
      },
      "application": {
        "subtitle": "Daten-Anwendung",
        "text": "Data Enrichment von Noda kann die Zahlungsabwicklung für eine Vielzahl von Unternehmen rationalisieren, vom traditionellen E-Commerce bis hin zu komplexen Abonnement- und Top-up-Geschäftsmodellen.",
        "title": "Anpassungsfähig für zahlreiche Branchen"
      },
      "buttons": {
        "DE-row": {
          "berlin": "Berlin",
          "mobile": "Mobil"
        },
        "NL-row": {
          "amsterdam": "Amsterdam",
          "desktop": "Desktop"
        },
        "UK-row": {
          "desktop": "Desktop",
          "london": "London"
        }
      },
      "container-header-text": "Unsere Tools bieten einen umfassenden Einblick in die Bedürfnisse der Kunden, den Sie nutzen können, um Ihr Geschäft zu verbessern",
      "customer-segmentation": {
        "list": {
          "enhanced-engagement": "Verbessertes Kundenengagement",
          "marketing-insights": "Erweiterte Marketing-Einblicke",
          "ready-for-use": "Sofort einsatzbereit"
        },
        "subtitle": "Daten-Cluster",
        "text": "Personalisieren Sie das Erlebnis Ihrer Kunden mit unserer Kundensegmentierungsfunktion, die Benutzer in verschiedene Gruppen oder Cluster einteilt, um zielgenaue, hochwertige Empfehlungen zu liefern.",
        "title": "Kundensegmentierung"
      },
      "data-usage": {
        "info": {
          "monthly-value": "Monatlicher Wert",
          "predicted-lifetime": {
            "label": "Voraussichtlicher Lebenszeitwert",
            "value": "2 Monate"
          },
          "predicted-spendings": "Vorhergesagte Ausgaben"
        },
        "subtitle": "Datenverwendung",
        "text": "Data Enrichment von Noda nutzt fortschrittliche Analysen, um das Ausgabeverhalten Ihrer Kunden auf der Grundlage ihres Finanzverhaltens und von Umweltfaktoren vorherzusagen. Unsere Tools bieten einen umfassenden Einblick in die Bedürfnisse der Kunden, den Sie nutzen können, um Ihr Geschäft zu verbessern",
        "title": "Vorhersage-Algorithmen"
      },
      "diff-user": "Unterschiedlicher Benutzer",
      "financial-hero-title-1": "Datenanreicherung:",
      "financial-hero-title-2": "Open Banking nutzen",
      "financial-hero-title-3": "Benutzereinblicke mit",
      "financial-info": "2 Monate",
      "header-title": "Verstärken Sie Ihr Wachstum mit zusätzlichen Daten",
      "hero": "Erhalten Sie bereits nach der ersten Transaktion wertvolle Einblicke in die Nutzer. Sobald wir die Zustimmung des Benutzers erhalten, uns seine Transaktionen zu zeigen, ist der richtige Zeitpunkt gekommen, um verwertbare Signale zu erhalten.",
      "how-data": {
        "enrich-data": {
          "text": "Sobald der Nutzer uns seine Zustimmung gibt, werden wir die angereicherten Daten an Sie weiterleiten.",
          "title": "Daten anreichern"
        },
        "instant-consent": {
          "text": "Während der Zahlung oder Anmeldung erlaubt der Benutzer Noda, die Transaktionsdaten zu lesen.",
          "title": "Sofortige Einwilligung"
        },
        "payment-or-sign-in": {
          "text": "Initiieren Sie die Zahlung oder Anmeldung über Noda auf Ihrer Website.",
          "title": "Bezahlung oder Anmeldung"
        }
      },
      "info-data": {
        "subtitle": "Was Benutzer sehen",
        "text": "Mit der sicheren Datenverwaltung des Financial AI Toolset und der strikten Einhaltung der regulierten Bankstandards können Sie sich ganz beruhigt zurücklehnen.",
        "title": "Wie es funktioniert"
      },
      "key-features-title": "Wesentliche Merkmale",
      "payments-data": {
        "text": "Finanzielle Prognosen für Händler",
        "title": "Benutzer-Insights mit Noda erschließen"
      },
      "preferences-items": {
        "hood1": {
          "text": "Stellen Sie den Benutzer mit Open-Banking-Wissen in den Vordergrund.",
          "title": "Erstellen Sie personalisierte Lösungen"
        },
        "hood2": {
          "text": "Erhalten Sie ein Signal, wenn margenstarke Benutzer onboarden.",
          "title": "Engagement verbessern"
        },
        "hood3": {
          "text": "Verabschieden Sie sich von zu hohen Ausgaben für Kartenzahlungen.",
          "title": "Besseres Re-Marketing mit hohem Vertrauen"
        },
        "hood4": {
          "text": "Targetten Sie nur Benutzer mit hohem LTV-Potenzial.",
          "title": "Verbessern Sie Ihre Akquisitions&shy;strategie"
        }
      }
    },
    "gaming": {
      "case-study": {
        "subtitle": "Fallstudie",
        "text": "Im Februar 2023 schloss sich Wargaming, ein preisgekrönter Online-Spiele-Publisher, mit Noda zusammen, um sofortige Open-Banking-Zahlungen in Spielen einzuführen. Diese Partnerschaft ermöglichte den Spielern von Wargaming den Zugang zu verschiedenen Online-Zahlungsoptionen, einschließlich Konto-zu-Konto-Transaktionen (A2A)",
        "title": "Wargaming <br/>& Noda"
      },
      "faq": {
        "countries": {
          "content": "Wir arbeiten mit 2000+ Banken in 28 Ländern zusammen, darunter die Niederlande, Portugal, Belgien, Deutschland, Polen, Bulgarien, Frankreich, Irland, Italien, Österreich, Spanien, Dänemark, Estland, das Vereinigte Königreich, Luxemburg, Rumänien, Litauen, Ungarn, Lettland, Finnland, Schweden, Norwegen, die Tschechische Republik, die Slowakei, Griechenland und Slowenien.",
          "title": "In welchen Ländern ist Noda tätig?"
        },
        "currencies": {
          "content": "Noda unterstützt eine Vielzahl von Währungen weltweit, darunter EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON und SEK.",
          "title": "Welche Währungen unterstützt Noda?"
        },
        "integration": {
          "content": "Zunächst sollten Sie bei Noda angemeldet sein. Füllen Sie einfach das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Wir bieten ein einfaches Onboarding mit der persönlichen Betreuung durch einen engagierten Manager. Unser Prozessor lässt sich nahtlos in API- und Front-End-Komponenten integrieren, sodass eine nahtlose Einbindung in Ihre Plattform gewährleistet ist.",
          "title": "Wie kann ich Noda in meinen Zahlungsablauf integrieren?"
        },
        "subtitle": "Antworten auf Ihre Fragen",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verbessern Sie Ihr Glücksspielgeschäft mit den Zahlungen von Noda. Unsere All-in-One-Plattform legt den Schwerpunkt auf Kundenverständnis, Effizienz und Wachstum",
        "title-1": "Zahlungs-Gateway",
        "title-2": "für Online-Spiele mit Noda"
      },
      "how-does-it-work": {
        "subtitle": "Technologien",
        "text": "Ein Gaming-Zahlungsgateway dient als Mittelsmann, der die Daten zwischen dem Spieler, dem Händler und den Banken sicher überträgt. Stellen Sie sich einen digitalen Dirigenten vor, der jeden Schritt der Online-Gaming-Kreditkartenabwicklung akribisch leitet\n\nNoda ist eine weltweite Zahlungsplattform und ein Anbieter von Open Banking. Vom sicheren Gateway über das Transaktionsmanagement bis hin zur Finanzanalyse - Noda hat alles für Sie im Angebot. Unsere Plattform nutzt KI- und Machine-Learning-Technologien, um hochmoderne Lösungen anzubieten",
        "title": "Wie funktioniert ein Payment Gateway für Spiele?"
      },
      "how-to-start": {
        "subtitle": "Einfaches Onboarding",
        "text": "Noda bietet ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unser Team ist da, um bei allen Hindernissen zu helfen. Unser Prozessor lässt sich nahtlos in API- und Front-End-Komponenten integrieren, sodass eine nahtlose Einbindung in Ihre Plattform gewährleistet ist. Um Noda zu nutzen, füllen Sie einfach das untenstehende Formular aus, und unsere Vertriebsmitarbeiter werden sich in Kürze mit Ihnen in Verbindung setzen",
        "title": "Wie man anfängt"
      },
      "open-banking": {
        "subtitle": "Viele Möglichkeiten",
        "text": "Open Banking bedeutet, dass traditionelle Banken Daten mit lizenzierten Fintech-Unternehmen wie Noda austauschen, um Transaktionen zu rationalisieren. Unser Ökosystem für den Zahlungsverkehr verbindet alle führenden Banken im Vereinigten Königreich und in der EU und ermöglicht mühelose Zahlungsdienste",
        "title": "Was ist Open Banking?"
      },
      "payments": {
        "text": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt",
        "title": "Toolset für Online-Spiele"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Nutzen Sie unsere datengesteuerten Erkenntnisse. Die Tools von Noda bieten gebrauchsfertige Analysen des Kundenverhaltens, einschließlich Segmentierungs- und Prognosealgorithmen",
            "title": "KI-gestützte Analytik"
          },
          "banking": {
            "content": "Verbesserung des Kundenerlebnisses und Vereinfachung des Transaktionsflusses durch die Leistungsfähigkeit und Sicherheit von Open-Banking-Zahlungen",
            "title": "Offenes Banking"
          },
          "global-currencies": {
            "content": "Noda arbeitet mit einer Vielzahl von Währungen, um Ihre Online-Gaming-Kunden auf der ganzen Welt zu unterstützen",
            "title": "Globale Währungen"
          },
          "payment-processing": {
            "content": "Optimieren Sie Ein- und Auszahlungen, nutzen Sie intuitive UX, intelligentes Routing und bieten Sie eine Vielzahl beliebter Zahlungsmethoden an",
            "title": "Zahlungsabwicklung für Online-Spiele"
          },
          "scalable-plans": {
            "content": "Wir bieten Gaming-Zahlungslösungen für alle Unternehmensgrößen an, mit skalierbaren Plänen, die das Wachstum Ihres Unternehmens unterstützen",
            "title": "Skalierbare Pläne"
          },
          "security": {
            "content": "Noda bietet einen sicheren Online-Glücksspiel-Zahlungsweg, der PCI DSS-Konformität, Verschlüsselung und Betrugsprävention gewährleistet",
            "title": "Sicherheit"
          }
        },
        "subtitle": "Was wir bieten",
        "title-1": "Top-Funktionen",
        "title-2": "für Online-Gaming"
      }
    },
    "instant-payment-links": {
      "cx": {
        "subtitle": "Erfahrung ist wichtig",
        "text": "Treffen Sie Käufer auf einer sicheren Payment Page.<br/>Geben Sie ihnen die Möglichkeit, den Kauf über ihre bevorzugte Banking-App abzuschließen.",
        "title": "Sofortige Kundenerfahrung"
      },
      "funds": {
        "receive-money": "Erhalten Sie das Geld direkt auf Ihr Bankkonto – in Echtzeit.",
        "settle-payments": "Oder wickeln Sie Zahlungen über Noda vIBAN ab.",
        "subtitle": "Wählen Sie Ihren Flow",
        "title": "Gelder sofort verfügbar"
      },
      "hero": {
        "text": "Sichere, flexible Payment-Links, ohne das Kopfzerbrechen bei der Integration und beim Erstellen von Zahlungslinks",
        "title": "Sofort-Payment-Links"
      },
      "info": {
        "checkout-anchor": "mehrere Medien hinweg bezahlen,",
        "checkout-text-end": "online oder vor Ort.",
        "checkout-text-start": "Lassen Sie Ihre Kunden über ",
        "create-anchor": "Einfach und schnell",
        "create-text": "Zahlungslink erstellen, QR-Codes zum Bezahlen ",
        "fees-anchor": "erhalten Sie Geld in Echtzeit",
        "fees-text": "Reduzieren Sie Transaktionsgebühren und ",
        "title": "Payment-Link-Generator zur Steigerung Ihres täglichen Geschäfts"
      },
      "key-features": {
        "commerce": "Omnichannel-Commerce ohne Integrationen",
        "coverage": "Weite Geo-Abdeckung",
        "customer": "Super einfache Kundenerfahrung",
        "fees": "Niedrige Transaktionsgebühren",
        "no-code": "Kein Code, keine technische Erfahrung erforderlich",
        "security": "Sicherheit auf Bankniveau",
        "subtitle": "Die Macht von Zahlungslinks",
        "time": "5 Min. Zeit zur Einführung für Noda-Nutzer",
        "title": "Wesentliche Funktionen",
        "transparency": "Transparenz, einfache Verwaltung"
      },
      "product-block": {
        "text": "Sofortige Einrichtung. Sofortiges Teilen. Sofortiges Zahlungserlebnis. Die Welt ist dein Spielplatz. Der Name des Spiels ist \"einfach bezahlt werden\".",
        "title": "Sofortige Zahlung Links"
      },
      "setup": {
        "subtitle": "So funktioniert es",
        "text": "Einen Zahlungslink zu erstellen geht ganz schnell: Geben Sie den Preis und die Währung ein, fügen Sie die Zahlungsdetails hinzu und klicken Sie auf „Generieren“. Und fertig!",
        "title": "Sofortige Einrichtung"
      },
      "sharing": {
        "description": "Sie können den QR-Code für Zahlungen anzeigen, den Ihre Kunden dann über Printmedien, Außenwerbung, Computer- und Fernsehbildschirme scannen und bezahlen können.",
        "header": {
          "subtitle": "Beziehen Sie Ihre Zielgruppe mit ein",
          "text": "Senden Sie den Payment-Link an Ihre Kunden.<br/>Nutzen Sie dazu jede Plattform, auf der Sie Ihre Zielgruppe erreichen: Websites, E-Mails, Chatbots, soziale Netzwerke, Messenger usw.",
          "title": "Sofortiges Teilen"
        }
      },
      "use-cases": {
        "automotive": {
          "item-1": "Komplett- und Teilzahlungen",
          "item-2": "Einzahlungen und Ratenzahlungen",
          "item-3": "International, Zahlungen in mehreren Währungen",
          "item-4": "Kundenbetreuung",
          "title": "Automotive"
        },
        "e-commerce": {
          "item-1": "Omnichannel-Commerce",
          "item-2": "International, Zahlungen in mehreren Währungen",
          "item-3": "Optionen zum späteren Bezahlen",
          "item-4": "Social Commerce",
          "title": "E-Commerce"
        },
        "header": {
          "subtitle": "Wir bringen alles zusammen",
          "text": "Von online bis vor Ort, von hohen Beträgen bis zu Kleinstbeträgen, von international bis von Tür zu Tür. Bequemes Bezahlen ist nur einen Klick entfernt.",
          "title": "Anwendungsfälle & Branchen"
        },
        "retail": {
          "item-1": "Einzahlungen und Ratenzahlungen",
          "item-2": "Ein-Klick-Zahlungen für wiederkehrende Kunden",
          "item-3": "Omnichannel-Commerce",
          "item-4": "International, Zahlungen in mehreren Währungen",
          "title": "Einzelhandel mit hochpreisigen Produkten"
        },
        "sales": {
          "item-1": "Komplett- und Teilzahlungen",
          "item-2": "Social Commerce",
          "item-3": "Schnellstart für Kampagnen",
          "item-4": "Optionen zum späteren Bezahlen",
          "title": "Vor-Ort-Vertrieb"
        },
        "services": {
          "item-1": "Einzahlungen & Ratenzahlungen",
          "item-2": "Kundenbetreuung",
          "item-3": "Darlehen, Mikrokredite",
          "item-4": "Schnellstart für Kampagnen",
          "title": "Dienstleistungen"
        },
        "travel": {
          "item-1": "Einzahlungen und Ratenzahlungen",
          "item-2": "International, Zahlungen in mehreren Währungen",
          "item-3": "Ein-Klick-Zahlungen für wiederkehrende Kunden",
          "item-4": "Optionen zum späteren Bezahlen",
          "title": "Reisen und Gastgewerbe"
        }
      }
    },
    "letters-plugin": {
      "buttonTitle": "Alle anzeigen",
      "title": "Erfahren Sie mehr über Payment Plugins"
    },
    "main-v2": {
      "boost-your-business": {
        "connected-banks": "angeschlossene Banken mit über 30.000 Filialen",
        "countries-covered": "abgedeckte Länder",
        "description": "Das robuste Online-Zahlungssystem von Noda verbindet alle führenden Banken in Großbritannien und der EU und ermöglicht mühelose Transaktionen",
        "integrated-networks": "integrierte Netzwerke",
        "subtitle": "Entfesseln Sie die Kraft des Open Banking",
        "subtitleV2": "Entfesseln Sie die Kraft\n des Open Banking",
        "title": "Kurbeln Sie Ihr Geschäft mit Noda an"
      },
      "hero": {
        "online-payments": {
          "part-1": "Online-Zahlungen ",
          "part-2": "mit Noda. ",
          "part-3": "Ihre Zahlungen, unsere Priorität"
        },
        "text": "Verbessern Sie Ihr Geschäft mit unserer umfassenden Online-Payment-Platform. Steigern Sie Ihren Umsatz und sparen Sie durch optimierte Prozesse wertvolle Zeit. Unsere All-in-One-Lösungen legen den Schwerpunkt auf Kundenverständnis, effiziente Abläufe und Wachstum."
      },
      "reviews": {
        "title": "Was unsere Kunden sagen"
      },
      "what-is-noda": {
        "card-payments": {
          "button": "Kartenzahlungen erkunden",
          "description": "Noda legt großen Wert auf die Rationalisierung von sich wiederholenden Zahlungen mit dem Ziel einer reibungsloseren Abwicklung.",
          "subtitle": "Kartenzahlungen",
          "title": "Schnellere Kassenvorgänge mit One-Click-Zahlungen"
        },
        "checkout": {
          "button": "Checkout erkunden",
          "description": "Nutzen Sie mit der benutzerfreundlichen Oberfläche von Noda Checkout und den umfassenden Zahlungsfunktionen die Vorteile nahtloser Zahlungen",
          "subtitle": "Kasse",
          "title": "Einheitlicher Kassenvorgang für Ihre Zahlungen"
        },
        "delight-customers": {
          "description": "Profitieren Sie von kostengünstigen oder gebührenfreien Einzügen mit einer Fülle von Optionen, die über unsere Online-Zahlungsdienste bereitgestellt werden",
          "title": "Erfreuen Sie Ihre Kunden"
        },
        "easy-to-apply": {
          "description": "Flexible Lösung für den Einzug von Geldern, mit der Möglichkeit, unser Noda C2B-Bankkonto zu nutzen oder aus unserem Netzwerk von vertrauenswürdigen Bankpartnern auszuwählen",
          "title": "Leicht anwendbar"
        },
        "open-banking": {
          "button": "Mehr über Open-Banking",
          "description": "Nutzen Sie die Möglichkeiten von Open Banking und APIs, um Ihre Kundenerfahrung zu verbessern und die Online-Zahlungsabwicklung mit der sicheren und effizienten Lösung von Noda zu optimieren",
          "subtitle": "Open Banking",
          "title": "Optimieren Sie Ihre Zahlungen mit Noda"
        },
        "text": "Unsere umfassende Lösung für Online-Zahlungen optimiert Transaktionen für Unternehmen und Privatpersonen, egal ob Sie Geld von Kunden einziehen oder Geld an Freunde und Familie senden.",
        "title": "Was ist "
      }
    },
    "marketplace": {
      "cart": {
        "cta": "Start",
        "in-your-package": "In Ihrem Paket enthalten",
        "products": "Produkte",
        "recommended": "Folgendes könnte Sie auch interessieren"
      },
      "errors": {
        "email-pattern": "E-Mail-Format ist falsch",
        "oninvalid": "Der Wert ist ungültig",
        "required": "Der Wert ist erforderlich"
      },
      "filters": {
        "all": "Alle Produkte",
        "categories": "Kategorien",
        "header": "Filter"
      },
      "header": "Unsere Produkte",
      "hero": {
        "description": "Wählen Sie die passenden Zahlungstools für Ihr Unternehmen aus. Der Zahlungsdienstleistungsmarktplatz von Noda vereint Zahlungsabwicklung, Rechnungsstellung, Datenanreicherungsdienste und mehr -- bereit zur Kombination und Anpassung.",
        "description-2": "Bereit für einen frischen Blick auf Zahlungen? Beginnen Sie noch heute mit dem Aufbau Ihres Zahlungsstapels.",
        "title": "Zahlungsinstrumente über Banken und Grenzen hinweg"
      },
      "product": {
        "add-to-package": "Hinzufügen",
        "in-package": "Hinzugefügt",
        "read-more": "Mehr lesen",
        "remove": "Entfernen"
      },
      "request-a-product": {
        "cta": "Eine Anfrage einreichen",
        "description": "Sie finden nicht, wonach Sie suchen? Lassen Sie es uns wissen.",
        "form": {
          "back": "Geh zurück zum Markt",
          "labels": {
            "description": "Beschreiben Sie Ihre Idee",
            "email": "Ihre geschäftliche E-Mail-Adresse",
            "organization": "Ihre Organisation"
          },
          "recommended": "Folgendes könnte Sie auch interessieren",
          "success": {
            "description": "Wir werden Ihre Anfrage so schnell wie möglich bearbeiten. Schönen Tag!",
            "header": "Vielen Dank für Ihre Anfrage"
          }
        },
        "header": "Ein Produkt anfordern"
      }
    },
    "marketplaces": {
      "faq": {
        "countries": {
          "content": "Wir arbeiten mit 2000+ Banken in 28 Ländern zusammen, darunter die Niederlande, Portugal, Belgien, Deutschland, Polen, Bulgarien, Frankreich, Irland, Italien, Österreich, Spanien, Dänemark, Estland, das Vereinigte Königreich, Luxemburg, Rumänien, Litauen, Ungarn, Lettland, Finnland, Schweden, Norwegen, die Tschechische Republik, die Slowakei, Griechenland und Slowenien.",
          "title": "In welchen Ländern ist Noda tätig?"
        },
        "currencies": {
          "content": "Noda ist ein globaler Marktplatz-Zahlungsprozessor, der eine Vielzahl von Währungen unterstützt, darunter EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON und SEK.",
          "title": "Welche Währungen unterstützt Noda?"
        },
        "how-to-integrate": {
          "content": "Zunächst sollten Sie bei Noda angemeldet sein. Füllen Sie einfach das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Wir bieten Ihnen ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unser Marktplatz-Zahlungssystem lässt sich mit APIs und Front-End-Komponenten integrieren und fügt sich nahtlos in Ihre Plattform ein.",
          "title": "Wie kann ich Noda in meinen Zahlungsablauf integrieren?"
        },
        "subtitle": "IHRE FRAGEN BEANTWORTET",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verbessern Sie Ihren Marktplatz mit dem Zahlungs-Gateway von Noda. Konzentrieren Sie sich auf Ihre Inserate, während wir für sichere und nahtlose Transaktionen sorgen. Unsere All-in-One-Plattform legt den Schwerpunkt auf Kundenverständnis, Effizienz und Wachstum",
        "title-1": "Zahlungs-Gateway",
        "title-gradient-1": "für Marktplätze mit Noda"
      },
      "how-does-it-work": {
        "content": "Ein Zahlungs-Gateway überträgt sicher Finanzdaten zwischen Kunden, Händlern und Banken. Stellen Sie es sich als digitalen Dirigenten vor, der jede Phase der Zahlungsabwicklung leitet\n\nNoda ist eine weltweite Zahlungsplattform und ein Anbieter von Open Banking. Von sicheren Zahlungen auf Online-Marktplätzen bis hin zu Finanzanalysen bietet Noda alles, was Sie brauchen. Unsere Plattform nutzt KI- und Machine-Learning-Technologien, um modernste Lösungen anzubieten",
        "subtitle": "Technologien",
        "title": "Wie funktioniert das Marketplace Payment Gateway?"
      },
      "how-to-start": {
        "content": "Noda bietet ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unsere Marktplatz-Zahlungsplattform lässt sich nahtlos in APIs und Front-End-Komponenten integrieren und gewährleistet eine nahtlose Einbindung in Ihre Schnittstelle. Um mit der Nutzung von Noda zu beginnen, füllen Sie das untenstehende Formular aus, und unsere Vertriebsmitarbeiter werden sich in Kürze mit Ihnen in Verbindung setzen. Unser Team ist für Sie da und hilft Ihnen bei allen Hindernissen",
        "subtitle": "Einfaches Onboarding",
        "title": "Wie man anfängt"
      },
      "open-banking": {
        "content": "Open Banking bedeutet, dass traditionelle Banken Daten mit lizenzierten Fintech-Unternehmen wie Noda austauschen, um Transaktionen zu rationalisieren. Unser Zahlungsökosystem verbindet alle führenden Banken in Großbritannien und der EU und erleichtert mühelose Zahlungen für Marktplätze",
        "subtitle": "VIELE MÖGLICHKEITEN",
        "title": "Was ist Open Banking?"
      },
      "payments": {
        "text": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt",
        "title": "Toolset für Marktplätze"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Nutzen Sie unsere datengesteuerten Erkenntnisse. Die Tools von Noda bieten gebrauchsfertige Analysen des Kundenverhaltens, einschließlich Segmentierungs- und Prognosealgorithmen",
            "subtitle": "MODERNE TECHNOLOGIEN",
            "title": "KI-gestützte Analytik"
          },
          "banking": {
            "content": "Verbessern Sie die Benutzerfreundlichkeit (UX) und vereinfachen Sie den Transaktionsfluss mit der Leistungsfähigkeit und Sicherheit von Open Banking Payments",
            "title": "Offenes Banking"
          },
          "global-currencies": {
            "content": "Noda arbeitet mit mehreren Währungen, um Ihre Marktplatzkunden auf der ganzen Welt zu unterstützen",
            "title": "Globale Währungen"
          },
          "payment-processing": {
            "content": "Optimieren Sie Ein- und Auszahlungen, nutzen Sie intuitive UX, intelligentes Routing und bieten Sie eine Vielzahl beliebter Marktplatz-Zahlungsoptionen an",
            "subtitle": "ALLES FÜR IHR UNTERNEHMEN",
            "title": "Marktplatz Zahlungs&shy;abwicklung"
          },
          "scalable-plans": {
            "content": "Wir bieten Zahlungslösungen für Marktplätze jeder Größe, mit skalierbaren Plänen, die Ihr Wachstum unterstützen",
            "title": "Skalierbare Pläne"
          },
          "security": {
            "content": "Noda ist ein sicherer Marktplatz-Zahlungsanbieter, der PCI-DSS-Konformität, Verschlüsselung und Betrugsprävention gewährleistet",
            "title": "Sicherheit"
          }
        },
        "subtitle": "UNSERE ANGEBOTE",
        "title-1": "Top-Funktionen"
      }
    },
    "meta": {
      "about": {
        "aml-cft-policies": {
          "description": "Informieren Sie sich über unsere Grundsatzerklärung, den Rechtsrahmen, die Methoden und vieles mehr.",
          "title": "Nodas AML/CFT-Politik"
        },
        "company": {
          "description": "Entdecken Sie die Geschichte von Noda und finden Sie heraus, wie wir den Zahlungsverkehr in Ihrem Unternehmen verbessern können. Lernen Sie unser Team und unsere Produkte kennen.",
          "title": "Unternehmen | Noda"
        },
        "mission": {
          "description": "Erfahren Sie mehr über den Auftrag und die Vision von Noda, einschließlich der drei Wale unserer Kultur und der Geschichte, wer wir sind.",
          "title": "Nodas Mission und Vision"
        },
        "partnership": {
          "description": "Erkunden Sie unser Angebot an Partnerschaftsoptionen, darunter White-Label-, Reseller-, Franchise- und Agentenmöglichkeiten. Integrieren Sie unsere Open-Banking-Technologie.",
          "title": "Noda: Werden Sie Nodas Partner für Geschäftswachstum"
        },
        "risk-appetite-policy": {
          "description": "Informieren Sie sich über unsere Risikopolitik in Bezug auf Branchen, Aktivitäten und Gerichtsbarkeiten, die verboten oder eingeschränkt sind oder ein bestimmtes Verhalten erfordern.",
          "title": "Nodas Politik der Risikobereitschaft"
        },
        "security": {
          "description": "Die Sicherheit von Zahlungen und Daten sollte immer Priorität haben. Wir geben einen Überblick über unsere Sicherheitsmerkmale und unser Engagement für den Datenschutz.",
          "title": "Sicherheit und Datenverarbeitung | Noda"
        },
        "ux-approach": {
          "description": "Entdecken Sie unsere CX-Philosophie und unser Design-Manifest. Erfahren Sie mehr über unsere Designprinzipien und was unser Team antreibt, hervorragende Arbeit zu leisten.",
          "title": "Nodas Ansatz zur Kundenerfahrung (CX)"
        },
        "white-label": {
          "description": "Werden Sie ein White-Label-Partner von Noda und integrieren Sie Open Banking. Profitieren Sie von nahtlosen Zahlungen, aussagekräftigen Analysen und anpassbarem Branding.",
          "title": "Noda: Wachsen Sie mit Ihrem Geschäft als White-Label-Partner"
        },
        "why-open-banking": {
          "description": "Entdecken Sie, warum Open Banking den Zahlungsverkehr verändert. Erfahren Sie, wie Händler und Verbraucher davon profitieren und räumen Sie mit gängigen Mythen auf.",
          "title": "Warum Open Banking die Zukunft des Zahlungsverkehrs ist"
        }
      },
      "articles": {
        "description": "Entdecken Sie alles, was Sie über Open Banking und Online-Zahlungslösungen wissen müssen. Erfahren Sie mehr über digitale Zahlungen mit Nodas Fintech-Artikeln.",
        "title": "Artikel | Fintech, Open Banking, Digitaler Zahlungsverkehr | Noda"
      },
      "bank-payouts": {
        "description": "Vereinfachen Sie Massenzahlungen mit den fortschrittlichen Bankauszahlungslösungen von Noda. Genießen Sie schnelle, problemlose Transaktionen und Kosteneffizienz. Lesen Sie weiter, um mehr zu erfahren.",
        "title": "Rationalisierte Bankauszahlungen für schnelle, kosteneffiziente Transaktionen | Noda"
      },
      "bank-sign": {
        "description": "Verbessern Sie Ihr Kundenerlebnis mit der Noda-Anmeldung über ein Bankkonto. Sorgen Sie für erstklassige Sicherheit, gewinnen Sie mehr Kunden und greifen Sie auf zuverlässige Daten zu.",
        "title": "Nahtlose Anmeldung über Bank, sichere Zahlungen und Datenkonformität | Noda"
      },
      "card-payments": {
        "description": "Erleben Sie nahtlose Zahlungen mit der KI-gesteuerten Technologie von Noda. Optimiertes Routing, akzeptierte Kartenzahlungen und einfache Integration - maßgeschneidert für Ihr Unternehmenswachstum. Erfahren Sie mehr.",
        "title": "Verbesserte Online-Kartenzahlungen für den Geschäftserfolg | Noda"
      },
      "card-payouts": {
        "description": "Steigern Sie Ihr Geschäftswachstum mit den effizienten globalen Kartenauszahlungslösungen von Noda. Nahtlose API-Integration, sichere Transaktionen und maßgeschneidert für Ihre Bedürfnisse.",
        "title": "Switch, sichere und effiziente Lösungen für die Kartenauszahlung | Noda"
      },
      "checkout": {
        "description": "Verbessern Sie Ihren Checkout-Prozess für Zahlungen mit der fortschrittlichen, KI-gesteuerten Technologie von Noda. Optimieren Sie Ihren Checkout, sichern Sie Transaktionen und expandieren Sie weltweit.",
        "title": "Nahtlose und sichere Lösungen für den Checkout von Zahlungen | Noda"
      },
      "contact-form": {
        "description": "Entdecken Sie unsere integrierte Zahlungsplattform. Durchsuchen Sie den Service-Marktplatz von Noda, um Ihr perfektes Payment-Tech-Stack zusammenzustellen. Open Banking, Karten, Datenanreicherung, no-code.",
        "title": "Noda-Form"
      },
      "contact-us": {
        "description": "Verbessern Sie Ihr Geschäft mit der Leistungsfähigkeit von Open Banking. Sprechen Sie noch heute mit uns, um den Zahlungsverkehr mit unserer All-in-One-Plattform zu optimieren.",
        "title": "Kontaktieren Sie uns | Noda"
      },
      "demo": {
        "description": "Entdecken Sie die Lösungen von Noda. Sehen Sie, wie Noda-Produkte den Zahlungsverkehr vereinfachen und Ihr Umsatzwachstum beschleunigen.",
        "title": "Noda Demo"
      },
      "events": {
        "description": "Entdecken Sie Veranstaltungen und Konferenzen bei Noda. Buchen Sie jetzt Ihren Platz, um mit führenden Vertretern der Zahlungsindustrie in Kontakt zu treten, Einblicke zu gewinnen und sich beruflich weiterzuentwickeln!",
        "title": "Veranstaltungen: Netzwerken, lernen und wachsen mit Noda"
      },
      "financial-ai-toolset": {
        "description": "Entdecken Sie das Financial AI Toolset, eine Lösung, die Unternehmen mit aufschlussreichen KI-gesteuerten Finanzanalysen für datengestützte Entscheidungen ausstattet.",
        "title": "Finanzielles AI-Toolset: Erweitern Sie Ihr Geschäft mit datengesteuerter Analytik | Noda"
      },
      "glossary": {
        "description": "Entdecken Sie das ultimative Noda-Glossar für Fintech- und Open-Banking-Terminologie von A bis Z.",
        "title": "Open Banking Glossar | Noda"
      },
      "instant-payment-links": {
        "description": "Zahlungslink erstellen für nahtlose Transaktionen. Senden Sie Payment Links und erhalten Sie sofortige Zahlungen über die bevorzugte Bank.",
        "title": "Payment Links – Sofortige Zahlungen leicht gemacht | Noda"
      },
      "legal": {
        "cookies": {
          "description": "Die Noda-Cookie-Richtlinie erläutert, wie wir Cookies für Funktionalität, Analysen und Marketing verwenden. Erfahren Sie, wie Sie Ihre Einstellungen verwalten können.",
          "title": "Cookies-Politik"
        },
        "policy": {
          "description": "Entdecken Sie, wie Noda Ihre persönlichen Daten gemäß der DSGVO und anderen Vorschriften sammelt, verwendet und schützt. Ihre Privatsphäre hat für uns Priorität.",
          "title": "Datenschutzerklärung"
        },
        "privacy-notice-for-job-candidates-or-cooperation": {
          "description": "In dieser Mitteilung wird erläutert, wie Noda die personenbezogenen Daten von potenziellen Mitarbeitern, Praktikanten, die sich auf offene Stellen bei Noda beworben haben oder eingeladen wurden, sich auf offene Stellen bei Noda zu bewerben oder mit Noda als individuelle Auftragnehmer zusammenzuarbeiten, behandelt.",
          "title": "Datenschutzhinweis für Bewerber oder Zusammenarbeit | Noda"
        },
        "terms": {
          "description": "Diese Vereinbarung legt die Nutzungsbedingungen für Privatpersonen fest, die Zahlungen über Noda veranlassen. Informieren Sie sich über Ihre Rechte und die Datennutzung.",
          "title": "Nutzungsbedingungen"
        }
      },
      "main": {
        "description": "Nutzen Sie die Vorteile von APIs mit Nodas Online-Zahlungsplattform. Vereinfachen Sie Transaktionen und optimieren Sie Ihre Geschäftsabläufe mühelos.",
        "title": "Online-Zahlungen mit Noda | Sichere & Effiziente Payment Platform"
      },
      "marketplace": {
        "description": "Entdecken Sie unsere integrierte Zahlungsplattform. Durchsuchen Sie den Service-Marktplatz von Noda, um Ihr perfektes Payment-Tech-Stack zusammenzustellen. Open Banking, Karten, Datenanreicherung, no-code.",
        "title": "Marktplatz für Zahlungsdienste | Noda"
      },
      "mor": {
        "description": "Erschließen Sie den grenzenlosen Handel für Ihre digitalen Innovationen. Von Indie-Spielen bis zu Unternehmenssoftware.",
        "title": "Merchant of Record"
      },
      "newsroom": {
        "description": "Informieren Sie sich über die neuesten Nachrichten zu Noda. Lesen Sie die neuesten Artikel, Pressemitteilungen und Experteneinblicke zu den Open-Banking-Zahlungsdiensten von Noda.",
        "title": "Wir sind in den Nachrichten | Noda"
      },
      "no-code": {
        "description": "Steigern Sie Ihre Online-Verkäufe mit KI-gesteuerten, codelosen Zahlungsseiten. Erfahren Sie, wie Noda Ihren gesamten Transaktionsfluss unterstützen kann - von einem Händlerkonto bis zur täglichen Zahlungsabwicklung.",
        "title": "Benutzerdefinierte AI-gesteuerte Zahlungsseiten in wenigen Minuten erstellen | Noda"
      },
      "open-banking": {
        "description": "Verändern Sie Ihr Geschäft mit Noda's Open Banking Zahlungen. Verbessern Sie das Kundenerlebnis und gewährleisten Sie sichere Transaktionen. Testen Sie jetzt eine Demo.",
        "title": "Offene Banking-Plattform für sichere und nahtlose Transaktionen | Noda"
      },
      "plugins": {
        "description": "Machen Sie mit den Open-Banking-Plugins von Noda für die von Ihnen verwendete E-Commerce-Plattform bessere Geschäfte. Optimieren Sie Ihre Zahlungen durch einfache Bedienung, nahtlose Integration, Sicherheit und Effizienz von Open Banking.",
        "magento": {
          "description": "Entdecken Sie das Magento-Plugin von Noda. Erfahren Sie, wie Sie Noda als Magento-Zahlungsoption in Ihre E-Commerce-Website integrieren können.",
          "title": "Magento Payment Gateway mit Noda"
        },
        "opencart": {
          "description": "Entdecken Sie das OpenCart-Plugin von Noda. Erfahren Sie, wie Sie Noda als OpenCart-Zahlungsoption in Ihre E-Commerce-Website integrieren können.",
          "title": "OpenCart Payment Gateway mit Noda"
        },
        "prestashop": {
          "description": "Entdecken Sie das PrestaShop-Plugin von Noda. Erfahren Sie, wie Sie Noda als PrestaShop-Zahlungsoption in Ihre E-Commerce-Website integrieren können.",
          "title": "PrestaShop Zahlungs-Gateway mit Noda"
        },
        "title": "Kurbeln Sie Ihren Umsatz mit den Open-Banking-Plugins von Noda an",
        "woocommerce": {
          "description": "Entdecken Sie das WordPress-Plugin von Noda. Erfahren Sie, wie Sie Noda als WooCommerce-Zahlungsmethode für Ihr E-Commerce-Geschäft integrieren können.",
          "title": "WooCommerce Payment Gateway mit Noda"
        }
      },
      "pricing": {
        "description": "Noda bietet wettbewerbsfähige und kalkulierbare Preise für Ihr Unternehmen. Erweitern Sie Ihr Zahlungsverkehrsökosystem mit unserer umfassenden Open-Banking-Lösung.",
        "title": "Preisgestaltung | Noda"
      },
      "toc": {
        "title": "BEDINGUNGEN DER ZUSAMMENARBEIT"
      },
      "use-cases": {
        "ecommerce": {
          "description": "Entdecken Sie Nodas Zahlungs-Gateway für E-Commerce und rationalisieren Sie Online-Transaktionen. Starten Sie jetzt mit Noda.",
          "title": "E-Commerce-Zahlungslösungen: Erhöhen Sie Ihr Geschäft mit Noda"
        },
        "educational-platforms": {
          "description": "Entdecken Sie die Online-Zahlungssysteme von Noda für das Bildungswesen, um Transaktionen zu rationalisieren und Open Banking zu nutzen. Mehr erfahren...",
          "title": "Zahlungsgateway für Bildungsplattformen | Noda"
        },
        "marketplaces": {
          "description": "Entdecken Sie die Zahlungslösungen von Noda für den Online-Marktplatz, um Transaktionen zu rationalisieren und Open Banking zu nutzen. Mehr erfahren...",
          "title": "Payment Gateway für Marktplätze | Noda"
        },
        "online-gaming": {
          "description": "Entdecken Sie die Zahlungslösungen von Noda für den Glücksspielbereich, um Transaktionen zu rationalisieren und Open-Banking-Zahlungen zu nutzen. Mehr erfahren...",
          "title": "Zahlungs-Gateway für Online-Spiele | Noda"
        },
        "retail": {
          "description": "Entdecken Sie das Retail Payment Gateway von Noda, um Transaktionen zu rationalisieren und Open-Banking-Zahlungen zu nutzen. Mehr erfahren...",
          "title": "Payment Gateway für den Einzelhandel | Noda"
        },
        "saas": {
          "description": "Entdecken Sie das SaaS-Zahlungsgateway von Noda, um Transaktionen zu rationalisieren und Open-Banking-Zahlungen zu nutzen. Mehr erfahren...",
          "title": "Zahlungs-Gateway für SaaS | Noda"
        },
        "travel": {
          "description": "Entdecken Sie die Zahlungslösungen von Noda für das Reisegeschäft und die Online-Zahlungen von Streamlone. Mehr erfahren...",
          "title": "Reisezahlungslösungen: Steigern Sie Ihr Geschäft mit Noda"
        }
      }
    },
    "mission": {
      "hero": {
        "desc-1": "Unsere <b>Mission</b> ist es, das endgültige Finanzmanagement-Toolkit zu liefern, das das Internet des 21. Jahrhunderts verdient.",
        "desc-2": "Wir wollen die Überbleibsel der Altsysteme des letzten Jahrhunderts beseitigen, einschließlich Zeitverzögerungen, Datenverzerrungen durch endlose Zwischenhändler, manuelle Verarbeitung, menschliches Versagen und die inhärenten Verzerrungen eines cliquenartigen Finanzsystems.",
        "extended-text": "Wir wollen die Umgestaltung des Finanzsystems durch Open Banking vorantreiben.\nUnsere <b>Vision</b> ist, dass Zahlungen sofort und ohne zusätzliche Kosten zwischen Konten überall auf der Welt übertragen werden können. Wir sind der Meinung, dass die Analyse von Finanzdaten nicht auf Banken beschränkt sein sollte; stattdessen sollten Privatpersonen und Unternehmen die Kontrolle über ihre eigenen Daten haben.",
        "extended-title": "Globale finanzielle Transformation",
        "subtitle": "Worauf stehen wir?",
        "title": "Auftrag und Vision"
      },
      "products": {
        "subtitle": "Produkte",
        "text": "Wir bieten eine Vielzahl von Zahlungsprodukten, die sowohl für Online- als auch für persönliche Transaktionen geeignet sind, damit Ihre Kunden ein nahtloses Omnichannel-Zahlungserlebnis genießen können.",
        "title": "Was wir tun"
      },
      "secret": {
        "communication": {
          "text": "Wir sprechen über Dinge, teilen Ideen und diskutieren offen darüber, was gut funktioniert und was nicht. Für uns ist es wichtig, klar und offen über alles zu sprechen - von unseren Projekten bis hin zu unserer Vision. Bei Noda bleibt jeder auf dem Laufenden.",
          "title": "Kommunikation"
        },
        "empathy": {
          "text": "Aber es geht nicht nur um Technik - es geht um Sie. Wir sind hier, um zuzuhören, zu verstehen und unsere Kunden zu unterstützen. Egal, ob Sie schon seit Jahren im Geschäft sind oder gerade erst anfangen, bei Noda finden Sie eine einladende Atmosphäre, in der Ihre Bedürfnisse an erster Stelle stehen.",
          "title": "Einfühlungsvermögen"
        },
        "innovation": {
          "text": "Wir experimentieren ständig und probieren Ideen aus. Wir sind offen für neue Technologien wie Blockchain und KI. Wir möchten Ihnen innovative Lösungen bieten, die den Zahlungsverkehr angenehmer und einfacher machen. Und wir haben keine Angst davor, über den Tellerrand zu schauen.",
          "title": "Innovation"
        },
        "subtitle": "Mehr über uns",
        "title": "Unsere geheime Sauce"
      },
      "welcome": {
        "desc-1": "Wir entwickeln eine Plattform, die es Online-Unternehmen ermöglicht, eine breite Palette von Kundeninteraktionen zu verwalten, einschließlich Onboarding, Identitäts- und Vermögensüberprüfung, Risikobewertung, Weiterleitung, ein- und ausgehende Zahlungen und Analyse der Interaktionsleistung.",
        "desc-2": "Unsere Motivation ist es, unser Produkt und die Branche voranzubringen, und nicht, von unseren Kunden zu profitieren. Wir sind stolz darauf, zu sehen, wie unsere Produktlösungen den offenen Bankensektor in den Märkten, in denen wir tätig sind, zu gestalten beginnen.",
        "desc-3": "Wir sind Ihre Partner im Zahlungsverkehr -\nPioniere, Schöpfer und immer Verbündete.",
        "extended-subtitle": "Willkommen in der Zukunft der Finanztechnologie.",
        "extended-title": "Willkommen bei Noda",
        "title": "Wer wir sind"
      },
      "whales": {
        "exploration": {
          "text": "Wir lernen ständig dazu. Unsere Teammitglieder sind leidenschaftlich und enthusiastisch und streben nach Selbstverwirklichung und beruflicher Weiterentwicklung. Bei Noda unterstützen wir dieses Bestreben.",
          "title": "Erkundung"
        },
        "passion": {
          "text": "Bei Noda wird alles, was wir tun, von Leidenschaft angetrieben. Wir streben nach Spitzenleistungen, egal ob wir innovativ sind oder mit unseren Kunden zusammenarbeiten. Wir glauben, dass Leidenschaft Projekte in etwas Bemerkenswertes verwandelt und andere dazu inspiriert, mitzumachen.",
          "title": "Passion"
        },
        "responsibility": {
          "text": "Wir verschwenden keine Zeit mit Streitereien oder Schuldzuweisungen. Bei Noda arbeiten wir stets gemeinsam an konstruktiven Lösungen, respektieren uns gegenseitig und tragen gemeinsam die Verantwortung für Erfolge und Rückschläge.",
          "title": "Verantwortung"
        },
        "subtitle": "Noda-Kultur",
        "title": "Drei Wale\nunseres Noda-Kulturcodes"
      }
    },
    "modern-slavery": {
      "intro-1": "Der Modern Slavery Act 2015 (MSA) im Vereinigten Königreich richtet sich gegen die Sklaverei und fordert Organisationen dazu auf, moderne Sklaverei im Verlauf ihrer Aktivitäten aktiv zu verhindern.",
      "intro-2": "Noda engagiert sich für die Bekämpfung der Sklaverei und versucht, jegliche Verbindung zu Menschenhandel oder Sklaverei sowie deren Förderung oder Unterstützung im Rahmen seiner Geschäftstätigkeit zu verhindern. Mit dieser Erklärung unterstreichen wir die Einhaltung des MSA, betonen unsere Haltung gegen moderne Sklaverei und beschreiben die Schritte, die wir unternehmen, um die wirksame Umsetzung unseres Ansatzes zu gewährleisten.",
      "last-update-at": "Zuletzt aktualisiert am 1. Juni 2024",
      "note": "HINWEIS: Noda ist zwar derzeit nicht gesetzlich verpflichtet, diese Erklärung zu veröffentlichen, doch wir sind der Meinung, dass wir verantwortungsbewusst handeln sollten, noch bevor dies verpflichtend wird.",
      "sections": {
        "our-status": {
          "text-1": "Um sicherzustellen, dass wir uns nicht an Aktivitäten beteiligen, die im Widerspruch zu unserer Haltung zur modernen Sklaverei stehen, hat Noda verschiedene Kontrollen eingeführt. Nachstehend finden Sie einige dieser Maßnahmen.",
          "text-2": "Noda beauftragt verschiedene Anbieter, die bei Bedarf professionelle Dienstleistungen wie Beratungsdienste, Rechtsberatung und Buchhaltungsdienste anbieten. Ferner beschäftigen wir Anbieter, die Hard- und Software liefern, darunter Computerausstattung, Softwarelizenzen und Cloud-basierte Datenspeicherdienste. Der Großteil unserer Anbieter ist dort ansässig, wo auch unsere Büros sind, nämlich in Großbritannien und in der EU.",
          "text-3": "Als internetbasiertes Unternehmen für Zahlungstechnologien, das überwiegend Anbieter von Software und professionellen Dienstleistungen beauftragt, wird unser Risikoprofil in Bezug auf Menschenrechte und moderne Sklaverei als gering eingestuft. Alle Lieferanten müssen sich jedoch an unsere internen Richtlinien halten, die beispielsweise vorschreiben, dass alle Anbieter einer Überprüfung und Due-Diligence-Prüfung unterzogen werden, wobei das Ausmaß der Prüfung je nach Risikokategorie variiert.",
          "text-4": "Die Mehrheit der Händler, für die Noda Dienstleistungen erbringt, sind in Regionen mit geringem Risiko angesiedelt und unterliegen einer Due-Diligence-Prüfung, um ihren niedrigen Risikostatus zu bestätigen.",
          "text-5": "Noda sind keine Fälle von Sklaverei oder Menschenhandel in den Unternehmen der Gruppe oder in den Lieferketten bekannt. Während des letzten Geschäftsjahres wurden weder über interne Berichtswege, Audit-Prozesse, Whistleblowing-Kanäle noch auf anderem Wege potenzielle Probleme dieser Art identifiziert oder gemeldet. Außerdem hat Noda von keinem Unternehmen innerhalb der Noda-Gruppe Hinweise auf solche Probleme bei einem seiner konzerninternen Anbieter oder deren Lieferketten erhalten.",
          "text-6": "Wir haben uns dazu verpflichtet, alle international anerkannten Menschenrechte in Bezug auf unsere Mitarbeiter, die Gemeinschaften, in denen wir tätig sind, und die Gemeinschaften innerhalb unserer globalen Lieferketten zu wahren. Wenn Noda Kenntnis davon erhalten sollte, dass eine Partei, mit der wir eine Beziehung pflegen, in Menschenrechtsverletzungen oder Verstöße gegen die moderne Sklaverei verwickelt ist, beenden wir umgehend unsere Zusammenarbeit mit dieser Partei.",
          "text-7": "Wenn Sie Bedenken hinsichtlich der Menschenrechte oder der modernen Sklaverei haben, in die einer unserer Händler, Lieferanten oder andere Parteien verwickelt sind, können Sie diese über <a href=\"mailto:legal@noda.live\" target=\"_blank\">Legal@noda.live</a> an Noda melden. Wir versprechen Ihnen, dass wir solche Meldungen umgehend und gründlich prüfen werden.",
          "title": "Unser Status, unsere Geschäftstätigkeit und unsere Lieferkette"
        }
      },
      "subtitle": "Zweck der Erklärung",
      "title": "Erklärung zur modernen Sklaverei"
    },
    "mor": {
      "case": {
        "subtitle": "Fallstudie",
        "text": "Im Februar 2023 hat sich Wargaming, ein preisgekrönter Online-Spiele-Publisher, mit Noda zusammengeschlossen, um sofortige Open-Banking-Zahlungen in Spielen einzuführen. Diese Partnerschaft ermöglichte den Spielern von Wargaming den Zugang zu verschiedenen Online-Zahlungsoptionen, einschließlich Konto-zu-Konto-Transaktionen (A2A)",
        "title": "Wargaming & Noda"
      },
      "cure": {
        "additional": {
          "text1": "Berechnung von Umsatzsteuer, Mehrwertsteuer und GST",
          "text2": "Pünktliche Einreichungen bei Steuerbehörden weltweit",
          "text3": "Aktuelle Informationen zum Steuerrecht",
          "text4": "Detaillierte Aufzeichnungen für den „Fall der Fälle“"
        },
        "bold-text": "Das übernehmen wir:",
        "subtitle": "Ein Heilmittel gegen Kopfschmerzen bei Steuerangelegenheiten",
        "text": "Nie wieder Albträume wegen der Steuer. Mit unserem intelligenten System berechnen wir die Zahlen, reichen die Formulare ein und halten Sie in Ihren Zielmärkten auf dem Laufenden. Wir sind mit den sich ständig ändernden Steuergesetzen auf der ganzen Welt vertraut und räumen unnötige Hindernisse aus dem Weg, damit Sie Ihre Zielgruppe erreichen.",
        "title": "Ihr Partner für Globale Steuer-Compliance"
      },
      "custom": {
        "subtitle": "So funktioniert es",
        "text": "Wir bahnen Ihnen den Weg zu globalen Märkten, indem wir komplexe internationale Verkäufe in reibungslose Transaktionen umwandeln.",
        "title": "Wir kümmern uns um die lästigen Aufgaben hinter den Kulissen: Zahlungen, Steuern, Support"
      },
      "faq": {
        "offer": {
          "content": "Wir bieten einen mehrsprachigen Support rund um die Uhr, um Sie bei allen Problemen zu unterstützen – von Zahlungsproblemen bis hin zu Kontofragen. Unser Team ist jederzeit für Sie da und hilft Ihnen, die Komplexität des globalen digitalen Handels zu meistern.",
          "title": "Welche Art von Support bietet Noda?"
        },
        "payment-security": {
          "content": "Für Direktüberweisungen verwenden wir Open Banking, wodurch Kontoinhaber in Echtzeit verifiziert werden. Zusammen mit unserer fortschrittlichen Transaktionsüberwachung reduziert dieser Ansatz das Betrugsrisiko erheblich und sorgt gleichzeitig für ein reibungsloses Benutzererlebnis.",
          "title": "Wie handhabt Noda die Zahlungssicherheit und Betrugsprävention?"
        },
        "products": {
          "content": "Aber natürlich! Wir sind auf den grenzenlosen Handel spezialisiert. Über unsere Plattform können Sie Zahlungen in mehreren Währungen abwickeln, Zahlungsmethoden länderspezifisch anpassen und internationale Steuervorschriften einhalten, sodass Sie Kunden auf der ganzen Welt erreichen können.",
          "title": "Kann Noda mir beim internationalen Verkauf meiner Produkte helfen?"
        },
        "services": {
          "content": "Nicht unbedingt. Sie können unseren Dienst zwar mit Ihrer bestehenden Website nutzen, aber wir stellen Ihnen auch kostenlose Vertriebstools zur Verfügung. Hierzu gehört auch ein intuitiver, programmierfreier Website- und Shop-Builder, der Ihnen den Einstieg erleichtert, wenn Sie noch keine Website haben.",
          "title": "Brauche ich eine eigene Website, um die Dienste von Noda zu nutzen?"
        },
        "subtitle": "Wissenswertes",
        "tax-compliance": {
          "content": "Mit unserem intelligenten System werden Umsatzsteuer, Mehrwertsteuer und GST für Ihre Transaktionen weltweit automatisch berechnet, eingezogen und abgeführt. Wir sind stets auf dem Laufenden, was die sich ändernden Steuergesetze angeht, und pflegen ausführliche Aufzeichnungen, um sicherzustellen, dass Sie auf jedem Markt, in den Sie verkaufen, stets konform sind.",
          "title": "Wie hilft Noda bei der Einhaltung von Steuervorschriften?"
        },
        "title": "FAQ"
      },
      "geo": {
        "btn-text": "Liste der unterstützten Banken anzeigen"
      },
      "hero-data": {
        "subtitle": "merchant of record",
        "text1": "Erschließen Sie den grenzenlosen Handel für Ihre digitalen Innovationen.",
        "text2": "Von Indie-Spielen bis zu Unternehmenssoftware.",
        "title": "Konzentrieren Sie sich auf die nächste große Entwicklung – wir kümmern uns um die Komplexität!"
      },
      "squad": {
        "additional": {
          "text1": "Mehrsprachiger Support rund um die Uhr",
          "text2": "Smarte Insights für Ihre Geschäftsentscheidungen",
          "text3": "Starke Sicherheitsmaßnahmen zum Schutz Ihrer Umsätze",
          "text4": "Regelmäßige technische Updates für einen reibungslosen Betrieb"
        },
        "subtitle": "Beratung und Unterstützung",
        "text": "Unser Support ist immer für Sie da, wann immer Sie uns brauchen: bei Zahlungsproblemen zu später Stunde oder bei Fragen zu Ihrem Konto.\n\n Vom unabhängigen Creator bis zum erfolgreichen Studio – wir helfen Ihnen, auf den globalen Märkten erfolgreich zu sein. Unser Toolkit umfasst Folgendes:",
        "title": "Ihr rund um die Uhr verfügbares Backup-Team"
      }
    },
    "newsroom": {
      "title": "Pressemitteilung"
    },
    "no-code": {
      "features": {
        "custom-payment": "Benutzerdefinierte Zahlungsseiten im Handumdrehen",
        "instant": "Sofortige, sichere Transaktionen",
        "leverage-ai": "Nutzen Sie die KI, um mit wenigen Klicks komplette Zahlungsseiten mit Markenzeichen zu erstellen.",
        "real-time": "Zahlungen in Echtzeit, Autorisierung des Zahlers über die Bank, nahtlose Kundenerfahrung.",
        "sell-anything": "Alles ohne Website verkaufen",
        "tag-title": "KEY FEATURES",
        "text": "Verkaufen Sie digitale und physische Waren und Dienstleistungen ohne langwierige Entwicklung und Einrichtung.",
        "title": "Eine Abkürzung zur &shy;Steigerung Ihrer &shy;Online-Produktverkäufe",
        "turn-any": "Verwandeln Sie jeden Kanal in Ihren Online-Marktplatz. Überlassen Sie Noda den gesamten Zahlungsfluss."
      },
      "hero": {
        "text": "Erstellen Sie individuelle Zahlungserlebnisse mit KI in wenigen Minuten",
        "title": "Zahlungsseite\nOhne Code"
      },
      "how-it-works": {
        "ai-based": "AI-basierte Analyse",
        "authorize": "Autorisieren Sie sich direkt im Chat und navigieren Sie zur Seitenerstellungs&shy;funktion.",
        "enter-your": "Geben Sie Ihre Anfrage ein oder laden Sie eine bestehende Produktbeschreibung hoch. Geben Sie dem Chatbot einen Moment Zeit zur Bearbeitung.",
        "make-necessary": "Nehmen Sie die notwendigen Anpassungen vor, genehmigen Sie die Version, die Ihnen gefällt, und beginnen Sie mit dem Verkauf!",
        "payment-page": "Die Zahlungsseite ist fertig",
        "preview": "Vorschau",
        "tag-title": "wie es funktioniert",
        "text-first": "Erstellen Sie in wenigen Minuten benutzerdefinierte Zahlungsseiten über eine einfache KI-Chat-Schnittstelle.",
        "text-second": "Generieren Sie automatisch Text und Bilder auf der Grundlage Ihrer Produktdaten. Betten Sie Zahlungslinks und QR-Codes für eine voll funktionsfähige Zahlungsseite ein.",
        "the-bot": "Der Bot generiert eine vollständige Zahlungsseite auf der Grundlage Ihrer Eingaben: Bilder, Text, Zahlungsfunktionalität, QR-Code.",
        "title": "Intelligenter Zahlungsseiten-Builder",
        "user-friendly": "Benutzerfreundliche Schnittstelle"
      },
      "monetize": {
        "direct-sales": "Direktverkauf",
        "donations": "Spenden",
        "event-tickets": "Tickets für Veranstaltungen",
        "games": "Spiele & Spiele-Merch",
        "lean": "Erschließen Sie neue Geschäftsmodelle. Erstellen Sie individuelle Zahlungsseiten und beginnen Sie mit dem Verkauf, sobald Sie auf \"Speichern\" klicken.",
        "monetize": "Monetarisieren Sie alles",
        "online-courses": "Online-Kurse",
        "online-retail": "Online-Einzelhandel",
        "tips": "Tipps",
        "travel-packages": "Reisepakete"
      },
      "product-block": {
        "text": "Individuelle Zahlungsseiten in wenigen Minuten. Keine Entwicklung, kein Hin und Her mit Designern und Textern. Ein einfacher, schöner und zuverlässiger Weg für Ihre Kunden, über verschiedene Kanäle und Geschäftsmodelle zu bezahlen.",
        "title": "Zahlungsseite Ohne Code"
      },
      "sell": {
        "are-you": "Bauen Sie ein Online-Geschäft von Grund auf auf oder erkunden Sie neue Einnahmequellen für ein bestehendes Unternehmen?\n\nTreten Sie direkt mit Ihren Kunden in Kontakt, indem Sie Verkäufe über E-Mail, Messenger, soziale Medien, Livestreams – wirklich überall, wo Sie einen Link zur Zahlungsseite freigeben können – starten.",
        "launch": "Starten Sie Verkäufe mit Leichtigkeit: keine Website, keine Zahlungsintegration, kein Hin und Her mit Entwicklern und Designern.\n\nDie Noda-Zahlungsplattform unterstützt Ihren gesamten Transaktionsfluss – von der Bereitstellung eines Händlerkontos bis hin zur täglichen Zahlungsabwicklung.",
        "reach": "Erreichen Sie Ihre Kunden, wo immer sie sind",
        "secure": "Sichere Sofortzahlungen",
        "tag-title": "OHNE WEBSITE VERKAUFEN"
      }
    },
    "partners": {
      "available": {
        "list": {
          "item1": {
            "text": "Integrieren Sie unsere Technologie nahtlos in Ihre eigenen Lösungen als White-Label-Partner",
            "title": "White-Label"
          },
          "item2": {
            "text": "Laden Sie Unternehmen über Empfehlungslinks als Reseller-Partner ein",
            "title": "Wiederverkäufer"
          },
          "item3": {
            "text": "Unter unserem Markennamen als Franchisepartner tätig sein",
            "title": "Franchise"
          },
          "item4": {
            "text": "Als Agent erstklassige Kunden gewinnen",
            "title": "Agent"
          }
        },
        "subtitle": "vielfalt an Optionen",
        "title": "Verfügbare Partnerschaften"
      },
      "banking": {
        "item1": "Länder",
        "item2": "integrierte E-Com-Plattformen",
        "item3": "entwickelte digitale Produkte",
        "subtitle": "Wählen Sie Ihre perfekte Partnerschaft",
        "text": "Entdecken Sie eine Vielzahl von Partnerschaftsoptionen, die auf Ihre Bedürfnisse zugeschnitten sind. Ganz gleich, ob Sie unsere Technologie integrieren, andere Unternehmen empfehlen, unsere Marke nutzen oder mit hochwertigen Kunden in Kontakt treten möchten - wir haben den perfekten Partnerschaftsweg für Sie.",
        "title": "So funktioniert es"
      },
      "customisation": {
        "subtitle": "maßgeschneiderte Schnittstelle",
        "text": "Sie haben die Wahl, ob Sie Ihr eigenes Frontend entwickeln oder unsere integrierten Tools für Benutzeroberflächen (UIs) nutzen möchten. Gestalten Sie Ihr Design so, dass es Ihre Marke vollständig repräsentiert und die perfekte Reise ermöglicht.",
        "title": "Markenan&shy;passung"
      },
      "hero": {
        "subtitle": "bessere Zahlungen",
        "text": "Integrieren Sie mühelos Open Banking-Transaktionen, greifen Sie auf aussagekräftige Analysen zu und profitieren Sie von unserer intuitiven Benutzeroberfläche. Genießen Sie nahtlose API-Integration und transparentes Reporting, um den Erfolg Ihrer Händler zu steigern.",
        "title": "Helfen Sie Ihren Händlern mit Open Banking zu wachsen"
      },
      "reporting": {
        "subtitle": "volle Transparenz",
        "text": "Mit unserer Verwaltungszentrale können Sie alle Provisionen verfolgen und eine klare und transparente Berichterstattung sicherstellen. Überwachen Sie mühelos Ein- und Auszahlungen, verschaffen Sie sich einen umfassenden Überblick und verwalten Sie Ihre Geschäfte mit Leichtigkeit.",
        "title": "Detaillierte Überwachung und Berichterstattung"
      },
      "technology": {
        "subtitle": "macht der Technik",
        "text1": "Vor dem Open Banking hatten die traditionellen Banken ein Monopol auf die Kundendaten. Im Jahr 2018 verpflichtete die PSD2 der EU die Banken, mit Zustimmung der Kunden Informationen mit autorisierten Drittanbietern wie Noda zu teilen.",
        "text2": "Open Banking verwendet Anwendungsprogrammierschnittstellen (APIs) für die Softwarekommunikation zur Datenübertragung. Wenn sich Nutzer für eine Open-Banking-Zahlung entscheiden, werden sie zur Schnittstelle ihrer vertrauten Bank weitergeleitet.",
        "text3": "Immer mehr Verbraucher und Händler weltweit nutzen diese neue Technologie. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">Juniper Research</a> prognostiziert, dass der Gesamtwert von Open-Banking-Zahlungen von 57 Mrd. US-Dollar im Jahr 2023 auf 330 Mrd. US-Dollar im Jahr 2027 ansteigen wird. Was einst als innovativ galt, entwickelt sich schnell zu einer weit verbreiteten Zahlungsmethode.",
        "title": "Open Banking verändert die Zahlungssysteme"
      }
    },
    "plugins": {
      "back-to-plugins": "Zurück zu Plugins",
      "bigcommerce": {
        "benefits": {
          "list": {
            "text": "Unser WordPress-WooCommerce-Zahlungsplugin bietet Ihren Kunden eine reibungslose Benutzererfahrung. Dies führt zu höherer Kundenzufriedenheit und weniger Kaufabbrüchen.",
            "text-1": "Unser WordPress-WooCommerce-Zahlungsplugin bietet Ihren Kunden eine reibungslose Benutzererfahrung. Dies führt zu höherer Kundenzufriedenheit und weniger Kaufabbrüchen.",
            "title": "Intuitives UX",
            "title-1": "Intuitives UX"
          },
          "title": "Vorteile von Noda für WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Wie teste ich dieses Plugin?",
              "text": "Sie können den Testmodus des Plugins aktivieren, um damit Transaktionen zu simulieren."
            },
            "2": {
              "summary": "Unterstützt Ihr Plugin WooCommerce-Abonnements?",
              "text": "Sie können den Testmodus des Plugins aktivieren, um damit Transaktionen zu simulieren."
            },
            "3": {
              "summary": "Warum wird der Zahlungsanforderungsbutton auf meinem lokalen Rechner nicht angezeigt?",
              "text": "Sie können den Testmodus des Plugins aktivieren, um damit Transaktionen zu simulieren."
            }
          },
          "title": "Häufigste Fragen"
        },
        "hero": {
          "button": "Noda zu WooCommerce hinzufügen",
          "logo": "bigcommerce",
          "text": "Entdecken Sie das WordPress-Plugin von Noda, das Open-Banking-Zahlungen für WooCommerce ermöglicht. Installieren und integrieren Sie das Plugin in nur wenigen einfachen Schritten.",
          "title": "WordPress-WooCommerce-Zahlungsgateway mit Noda"
        },
        "how": {
          "text": "Händler, die das Plugin installieren, können auf ihrer Website eine Noda-Schaltfläche als Zahlungsmethode zur Verfügung stellen.",
          "title": "Wie es funktioniert?"
        },
        "inspiration": "Vielleicht suchen Sie auch nach",
        "integration": {
          "after": "Zur Integration sind nur ein paar Klicks erforderlich, und Sie brauchen keine Entwickler in Ihrem Team. Mit Noda können Händler mühelos Open-Banking-Zahlungen als eine ihrer WooCommerce-Zahlungsoptionen zur Verfügung stellen.",
          "before": "Um das WordPress-WooCommerce-Zahlungsplugin mit Noda einzurichten, sollten Händler diese einfachen Schritte befolgen:",
          "button": {
            "text": "Anleitung herunterladen"
          },
          "steps": {
            "1": "Installieren Sie die Archivdatei im Adminbereich von WooCommerce. Dadurch wird das Plugin für Ihre Website eingerichtet.",
            "2": "Fügen Sie API-Schlüssel hinzu, die nach Abschluss des Onboardings über Noda Hub verfügbar sind.",
            "3": "WeCommerce und Noda sind jetzt verbunden."
          },
          "title": "Nodas Integration mit WooCommerce"
        },
        "what-is-it": {
          "text": "WeCommerce ist eine Open-Source-Software für WordPress, mit der Unternehmen E-Commerce-Websites in der Programmiersprache PHP erstellen können. Noda bietet ein Plugin, das Open-Banking-Zahlungen als WordPress-WooCommerce-Zahlungsgateway ermöglicht.",
          "title": "Was ist das?"
        }
      },
      "details": "FAQ",
      "faq": {
        "development-skills": {
          "content": "Nein, unsere Plugins sind für eine einfache Installation konzipiert, die keine speziellen technischen Kenntnisse erfordert. Die Schritt-für-Schritt-Anleitungen führen Sie durch den einfachen Prozess. Sollten Sie auf Schwierigkeiten stoßen, steht Ihnen unser Support-Team gerne zur Verfügung.",
          "title": "Benötige ich Entwicklungskenntnisse, um diese Plugins zu installieren?"
        },
        "how-secure": {
          "content": "Alle Noda-Plugins erfüllen strenge Sicherheitsstandards und regulatorische Anforderungen für Open Banking. Transaktionen werden durch Multi-Faktor-Authentifizierung und Datenverschlüsselung gesichert, um sowohl Händler als auch Kunden zu schützen.",
          "title": "Wie sicher sind diese Zahlungs-Plugins?"
        },
        "plugins-compatible": {
          "content": "Noda-Plugins wurden speziell für Open-Banking-Zahlungen entwickelt und ermöglichen Ihren Kunden, direkt von ihrem Bankkonto zu bezahlen. Dies bietet mehr Sicherheit und geringere Transaktionskosten im Vergleich zu herkömmlichen Zahlungsmethoden.",
          "title": "Sind Noda-Plugins mit allen Zahlungsmethoden kompatibel?"
        },
        "subtitle": "FAQ",
        "title": "Häufig gestellte Fragen",
        "troubleshooting": {
          "content": "Unser Support-Team unterstützt Sie gerne bei der Installation, Konfiguration und Fehlerbehebung. Kontaktieren Sie uns einfach über die auf jeder Plugin-Seite aufgeführten Support-Kanäle. Wir helfen Ihnen gerne weiter.",
          "title": "Was ist, wenn ich Hilfe bei der Installation oder Fehlerbehebung benötige? "
        },
        "what-is-required": {
          "content": "Um ein Noda-Plugin nutzen zu können, müssen Sie ein Noda-Konto erstellen, den Onboarding-Prozess abschließen und API-Schlüssel anfordern. Die spezifischen Anforderungen für jede Plattform finden Sie auf den jeweiligen Plugin-Seiten.",
          "title": "Was wird zur Verwendung von Noda-Plugins benötigt? "
        }
      },
      "fqa": "FQA",
      "hero": {
        "button": "Kontaktieren Sie unser Team",
        "subtitle": "Integrieren Sie Noda in wenigen Minuten mit unseren vorgefertigten Plugins. Optimieren Sie Zahlungen mit vereinfachter Benutzererfahrung, nahtloser Integration und erhöhter Sicherheit durch Open Banking.",
        "title": "Nahtlose Open Banking-Zahlungen für Ihre E-Commerce-Plattform"
      },
      "info": {
        "bigcommerce": {
          "subtitle": "Demnächst verfügbar",
          "text": "Mit dem BigCommerce-Plugin von Noda können Sie ganz einfach Open-Banking-Zahlungen in Ihre BigCommerce-Website einbinden. Schnelle Installation für einen reibungslosen Zahlungsvorgang.",
          "title": "BigCommerce"
        },
        "magento": {
          "text": "Entdecken Sie das Magento-Plugin von Noda. Erfahren Sie, wie Sie Noda als Magento-Zahlungsoption in Ihre E-Commerce-Website einbinden und mit Open-Banking-Zahlungen bessere Geschäfte machen können.",
          "title": "Magento"
        },
        "opencart": {
          "text": "Erfahren Sie, wie Sie Noda als OpenCart-Zahlungsoption in Ihre E-Commerce-Website integrieren können. Vereinfachen Sie Ihre Zahlungen mit Open Banking.",
          "title": "OpenCart"
        },
        "prestashop": {
          "text": "Integrieren Sie Open-Banking-Zahlungen in das PrestaShop-Plugin von Noda. Bauen Sie Noda als PrestaShop-Zahlungsoption in Ihre E-Commerce-Website ein – die Einrichtung ist schnell und einfach.",
          "title": "PrestaShop"
        },
        "step-title": "Schritt",
        "woocommerce": {
          "text": "Entdecken Sie das WordPress-Plugin von Noda, das Open-Banking-Zahlungen für WooCommerce ermöglicht. Installieren und integrieren Sie das Plugin in wenigen einfachen Schritten.",
          "title": "WooCommerce"
        }
      },
      "integration": {
        "btn-request": "Integration anfordern",
        "btn-view": "API-Dokumentation",
        "description": "Wir erweitern unsere Plugins ständig – kontaktieren Sie uns für benutzerdefinierte Integrationen oder sehen Sie sich unsere API-Dokumente für Entwicklungsmöglichkeiten an.",
        "title": "Integration anfordern"
      },
      "magento": {
        "benefits": {
          "button": {
            "text": "Unser Team kontaktieren"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Unsere Magento-E-Commerce-Integration verschafft Ihren Kunden eine nahtlose Benutzererfahrung. Dies führt zu einer höheren Kundenzufriedenheit und weniger Warenkorbabbrüchen.",
              "title": "Benutzererfahrung (UX)"
            },
            "2": {
              "icon": "Karte",
              "text": "Händler können die Noda-Plugins ohne Entwicklerteam oder technische Kenntnisse installieren.",
              "title": "Nahtlose Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Die Open-Banking-Funktion gibt Kunden und Händlern Sicherheit. Die Multi-Faktor-Verifizierung ist gemäß der europäischen Verordnung gesetzlich vorgeschrieben.",
              "title": "Sicherheit"
            },
            "4": {
              "icon": "all_match",
              "text": "Die Magento-Zahlungsabwicklung mit Open Banking ist für Händler schneller und preisgünstiger und sorgt für einen schnelleren Kassenvorgang und Geldeingang.",
              "title": "Effizienz"
            }
          },
          "title": "Vorteile von Noda für Magento"
        },
        "hero": {
          "button": "Noda zu Magento hinzufügen",
          "logo": "magento",
          "text": "Entdecken Sie das Magento-Plugin von Noda. Erfahren Sie, wie Sie Noda als Magento-Zahlungsoption in Ihre E-Commerce-Website einbinden.",
          "title": "Magento-Zahlungs-Gateway mit Noda"
        },
        "how": {
          "text": "Händler, die das Plugin installieren, können Noda als eine ihrer Magento-Zahlungsmethoden anbieten, die Kunden beim Checkout verwenden können.",
          "title": "Wie es funktioniert?"
        },
        "inspiration": "Vielleicht suchen Sie auch nach",
        "integration": {
          "after": "Die Integration erfordert nur ein paar Klicks und keine besonderen technischen Kenntnisse. Mit Noda können Händler Open-Banking-Funktionen mühelos in eine Magento E-Commerce-Lösung integrieren.",
          "before": "Um die Magento-Integration mit Noda einzurichten, müssen Händler diese einfachen Schritte befolgen:",
          "steps": {
            "1": "Installieren Sie die Archivdatei im Adminbereich von Magento. Dadurch wird das Plugin für Ihre Website eingerichtet.",
            "2": "Fügen Sie API-Schlüssel hinzu, die nach Abschluss des Onboardings über Noda Hub verfügbar sind.",
            "3": "Magento und Noda sind jetzt verbunden."
          },
          "title": "Magento-Zahlungs-Gateway-Integration"
        },
        "meta": {
          "description": "Entdecken Sie das Magento-Plugin von Noda. Erfahren Sie, wie Sie Noda als Magento-Zahlungsoption in Ihre E-Commerce-Website einbinden.",
          "title": "Magento-Zahlungs-Gateway mit Noda"
        },
        "what-is-it": {
          "text": "Magento ist eine E-Commerce-Plattform, die auf Open-Source-Technologie in der Programmiersprache PHP basiert. Noda bietet ein Plugin, das Open-Banking-Zahlungen für E-Commerce-Websites ermöglicht.",
          "title": "Was ist das?"
        }
      },
      "opencart": {
        "benefits": {
          "button": {
            "text": "Unser Team kontaktieren"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Open-Banking-Zahlungen erleichtern Ihren Kunden das Einkaufserlebnis. Die führt zu weniger Kaufabbrüchen und mehr Kundenzufriedenheit.",
              "title": "Intuitives UX"
            },
            "2": {
              "icon": "Karte",
              "text": "Mit Noda können Händler das Plugin ohne Entwicklerteam installieren.",
              "title": "Einfache Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Die Open-Banking-Funktion gibt Kunden und Händlern Sicherheit. Die Multi-Faktor-Verifizierung ist in Europa vorgeschrieben.",
              "title": "Sicherheit"
            },
            "4": {
              "icon": "all_match",
              "text": "Die OpenCart-Zahlungsabwicklung mit Noda ist schneller und kostengünstiger für Händler und beschleunigt die Kaufabwicklung und den Geldeingang.",
              "title": "Effizienz"
            }
          },
          "title": "Vorteile von Noda für OpenCart"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Was sind die Voraussetzungen für den Einsatz des OpenCart-Plugins?",
              "text": "Um das OpenCart-Plugin von Noda erfolgreich zu integrieren, vergewissern Sie sich bitte, dass Sie mindestens über die PHP-Version 7.0.3 verfügen. Jede PHP-Version zwischen 7.0.3 und 8.2.x wird unterstützt. Sie benötigen außerdem eine WordPress-Version ab 3. Sie finden Ihre Version ganz einfach unten in Ihrem OpenCart-Adminbereich. Um das Noda-Plugin im Produktionsmodus zu verwenden, müssen Sie das Noda-Onboarding durchlaufen haben."
            },
            "2": {
              "summary": "Wie kann ich dieses Plugin in Noda integrieren?",
              "text": "Um das OpenCart-Plugin zu integrieren, installieren Sie die Archivdatei über den OpenCart-Adminbereich und fügen nach dem Onboarding die auf NodaHub verfügbaren API-Schlüssel hinzu."
            },
            "3": {
              "summary": "Wie kann ich dieses Plugin testen?",
              "text": "Um dieses Plugin zu testen, aktivieren Sie den Testmodus mit Hilfe der Sandbox-Tasten im Noda Hub. Damit können Sie einen Testlauf durchführen."
            }
          },
          "title": "Häufigste Fragen"
        },
        "hero": {
          "button": "Noda zu OpenCart hinzufügen",
          "logo": "opencart",
          "text": "Entdecken Sie das OpenCart-Plugin von Noda. Erfahren Sie, wie Sie Noda als OpenCart-Zahlungsoption in Ihre E-Commerce-Website einbinden.",
          "title": "OpenCart-Zahlungs-Gateway mit Noda"
        },
        "how": {
          "text": "Bei Händlern, die das Plugin installiert haben, sehen die Kunden an der Kasse auf der Website eine Noda-Schaltfläche als Zahlungsoption.",
          "title": "Wie es funktioniert?"
        },
        "inspiration": "Vielleicht suchen Sie auch nach",
        "integration": {
          "after": "Der gesamte Vorgang erfordert nur ein paar Klicks und keine technischen Kenntnisse. Mit dem OpenCart-Zahlungs-Plugin von Noda können Händler mühelos die Open-Banking-Funktion in die Palette ihrer Zahlungsmöglichkeiten aufnehmen.",
          "before": "Um die Integration des OpenCart-Zahlungsgateways einzurichten, sollten Händler diese einfachen Schritte befolgen:",
          "steps": {
            "1": "Installieren Sie die Archivdatei im Adminbereich von OpenCart. Dadurch wird das Plugin für Ihre Website eingerichtet.",
            "2": "Fügen Sie API-Schlüssel hinzu, die nach Abschluss des Onboardings über Noda Hub verfügbar sind.",
            "3": "OpenCart und Noda sind jetzt verbunden."
          },
          "title": "OpenCart-Integration mit Noda"
        },
        "meta": {
          "description": "Entdecken Sie das OpenCart-Plugin von Noda. Erfahren Sie, wie Sie Noda als OpenCart-Zahlungsoption in Ihre E-Commerce-Website einbinden.",
          "title": "OpenCart-Zahlungs-Gateway mit Noda"
        },
        "what-is-it": {
          "text": "OpenCart ist eine kostenlose, quelloffene E-Commerce-Plattform für den Online-Verkauf von Produkten. Sie basiert auf der Programmiersprache PHP und der Datenbank MySql. Das Noda-Plugin für E-Commerce-Websites ermöglicht es Händlern, Open-Banking-Zahlungen als eine ihrer OpenCart-Zahlungsmethoden anzubieten.",
          "title": "Was ist das?"
        }
      },
      "platforms": "Unterstützte E-Commerce-Plattformen",
      "pre-footer": {
        "button": "Kontaktieren Sie unser Team",
        "single-page-plugin": {
          "button": "Kontaktieren Sie unser Team",
          "subtitle": "Wie die Integration funktioniert",
          "text": "Nehmen Sie Kontakt zu uns auf, um mehr über die Zusammenarbeit mit Partnern zu erfahren.",
          "title": "Bereit zur Vernetzung?"
        },
        "subtitle": "Wie die Integration funktioniert",
        "text": "Nehmen Sie Kontakt zu uns auf, um mehr über die Zusammenarbeit mit Partnern zu erfahren.",
        "title": "Bereit zur Vernetzung?"
      },
      "prestashop": {
        "benefits": {
          "button": {
            "text": "Unser Team kontaktieren"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Mit Open-Banking-Zahlungen können Sie Ihren Kunden ein einfacheres Nutzererlebnis bieten. Damit erzielen Sie eine höhere Kundenzufriedenheit und weniger abgebrochene Warenkörbe.",
              "title": "Einfachheit"
            },
            "2": {
              "icon": "Karte",
              "text": "Händler können die Plugins von Noda ohne Entwicklerteam oder technische Kenntnisse installieren.",
              "title": "Nahtlose Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Die Open-Banking-Funktionspalette gewährleistet die Sicherheit für Kunden und Händler. Die Multi-Faktor-Verifizierung ist gemäß europäischer Verordnung gesetzlich vorgeschrieben.",
              "title": "Sicherheit"
            },
            "4": {
              "icon": "all_match",
              "text": "Open-Banking-Zahlungen sind für Händler schneller und günstiger und ermöglichen schnellere Checkouts und Geldeingänge.",
              "title": "Effizienz"
            }
          },
          "title": "Vorteile von Noda für PrestaShop"
        },
        "hero": {
          "button": "Noda zu PrestaShop",
          "logo": "prestashop",
          "text": "Entdecken Sie das PrestaShop-Plugin von Noda. Erfahren Sie, wie Sie Noda als PrestaShop-Zahlungsoption in Ihre E-Commerce-Website einbinden.",
          "title": "PrestaShop Payment Gateway mit Noda"
        },
        "how": {
          "text": "Bei Händlern, die das Plugin installiert haben, wird eine Noda-Schaltfläche auf ihrer Website angezeigt, wenn Kunden zur Kasse gehen.",
          "title": "Wie funktioniert es?"
        },
        "inspiration": "Vielleicht suchen Sie auch nach",
        "integration": {
          "after": "Die Integration ist mit wenigen Klicks erledigt und erfordert keine Entwickler in Ihrem Team. Mit dem PrestaShop-Zahlungsplugin von Noda können Händler ihre Zahlungsstrategie mit Open Banking mühelos auf ein höheres Niveau bringen.",
          "before": "Für die Integration von PrestaShop mit Noda müssen Händler diese einfachen Schritte befolgen:",
          "steps": {
            "1": "Installieren Sie die Archivdatei im PrestaShop-Adminbereich. Damit wird das Plugin für Ihre Website eingerichtet.",
            "2": "Fügen Sie API-Schlüssel hinzu, die nach Abschluss des Onboardings über Noda Hub verfügbar sind.",
            "3": "PrestaShop und Noda sind jetzt miteinander verbunden."
          },
          "title": "PrestaShop-Zahlungs-Gateway-Integration"
        },
        "what-is-it": {
          "text": "PrestaShop ist eine Open-Source-Plattform, über die Händler ihre eigenen E-Commerce-Websites in der Programmiersprache PHP erstellen und entwickeln können. Mit dem Plugin von Noda sind Händler in der Lage, die Open-Banking-Funktionspalette in ihre PrestaShop-Zahlungsmethoden aufzunehmen.",
          "title": "Was ist das?"
        }
      },
      "section": {
        "subtitle": "Machen Sie mit den Open-Banking-Plugins von Noda für die von Ihnen verwendete E-Commerce-Plattform bessere Geschäfte. Optimieren Sie Ihre Zahlungen durch einfache Bedienung, nahtlose Integration, Sicherheit und Effizienz von Open Banking.",
        "title": "Kurbeln Sie Ihren Umsatz mit den Open-Banking-Plugins von Noda an"
      },
      "soon": "Demnächst verfügbar",
      "woocommerce": {
        "benefits": {
          "button": {
            "text": "Unser Team kontaktieren"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Unser WooCommerce-Zahlungsplugin für WordPress verschafft Ihren Kunden eine nahtlose Benutzererfahrung. Dies führt zu einer höheren Kundenzufriedenheit und weniger Warenkorb-Abbrüchen.",
              "title": "Intuitives UX"
            },
            "2": {
              "icon": "Karte",
              "text": "Händler können die Plugins von Noda ohne Entwicklerteam oder technische Kenntnisse installieren.",
              "title": "Einfache Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Die Open-Banking-Zahlungen bieten Kunden und Händlern Sicherheit. Die Multi-Faktor-Verifizierung ist gemäß europäischer Verordnung gesetzlich vorgeschrieben.",
              "title": "Sicherheit"
            },
            "4": {
              "icon": "all_match",
              "text": "Die WooCommerce-Zahlungsabwicklung mit Open Banking ist für Händler schneller und kostengünstiger und ermöglicht schnellere Checkouts und Geldeingänge.",
              "title": "Effizienz"
            }
          },
          "title": "Vorteile von Noda für WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Was sind die Voraussetzungen für das WooCommerce-Plugin?",
              "text": "Um das WooCommerce-Plugin von Noda erfolgreich zu integrieren, müssen Sie mindestens die PHP-Version 7.0.3. installiert haben, ; dazu WordPress-Version 5.3 oder höher und WooCommerce-Version 4.5 oder höher, um die Kompatibilität zu gewährleisten. Um das Plugin im Produktionsmodus zu verwenden, müssen Sie das Noda-Onboarding durchlaufen haben."
            },
            "2": {
              "summary": "Wie kann ich dieses Plugin in Noda integrieren?",
              "text": "Um das WooCommerce-Plugin zu integrieren, installieren Sie die Archivdatei über den WooCommerce-Adminbereich und fügen nach dem Onboarding die auf NodaHub verfügbaren API-Schlüssel hinzu."
            },
            "3": {
              "summary": "Wie kann ich dieses Plugin testen?",
              "text": "Um dieses Plugin zu testen, aktivieren Sie den Testmodus mit Hilfe der Sandbox-Tasten im Noda Hub. Damit können Sie einen Testlauf durchführen."
            },
            "4": {
              "summary": "Unterstützt dieses Plugin WooCommerce-Abonnements?",
              "text": "Nein, dieses Plugin unterstützt keine WooCommerce-Abonnements."
            }
          },
          "title": "Häufigste Fragen"
        },
        "hero": {
          "button": "Noda zu WooCommerce",
          "logo": "woocommerce",
          "text": "Entdecken Sie das WordPress-Plugin von Noda. Informieren Sie sich, wie Sie Noda als WooCommerce-Zahlungsmethode für Ihr E-Commerce-Geschäft einbinden können.",
          "title": "WordPress-WooCommerce-Zahlungs-Gateway mit Noda"
        },
        "how": {
          "text": "Händler, die das Plugin installieren, können auf ihrer Website eine Noda-Schaltfläche als Zahlungsmethode hinzufügen.",
          "title": "Wie funktioniert es?"
        },
        "inspiration": "Vielleicht suchen Sie auch nach",
        "integration": {
          "after": "Die Integration ist mit wenigen Klicks erledigt und erfordert keine Entwickler in Ihrem Team. Mit Noda können Händler mühelos Open-Banking-Zahlungen als eine ihrer WooCommerce-Zahlungsoptionen anbieten.",
          "before": "Um das WordPress-WooCommerce-Zahlungsplugin mit Noda einzurichten, sollten Händler diese einfachen Schritte befolgen:",
          "steps": {
            "1": "Installieren Sie die Archivdatei im WooCommerce-Adminbereich. Damit wird das Plugin für Ihre Website eingerichtet.",
            "2": "Fügen Sie API-Schlüssel hinzu, die nach Abschluss des Onboardings über Noda Hub verfügbar sind.",
            "3": "WooCommerce und Noda sind jetzt verbunden."
          },
          "title": "Integration von Noda in WooCommerce"
        },
        "what-is-it": {
          "text": "WooCommerce ist eine Open-Source-Software für WordPress, mit der Unternehmen E-Commerce-Websites in der Programmiersprache PHP erstellen können. Noda bietet ein Plugin an, das Open-Banking-Zahlungen als WordPress-WooCommerce-Zahlungsgateway ermöglicht.",
          "title": "Was ist das?"
        }
      }
    },
    "policy": {
      "last-update": "Zuletzt aktualisiert am <data>12. August 2024</data>",
      "section-1": {
        "text-1": "Mit der Nutzung unseres Dienstes erklären Sie sich mit den allgemeinen Geschäftsbedingungen und dieser Datenschutzerklärung einverstanden.",
        "text-2": "Im Rahmen dieser Vereinbarung sind Sie verpflichtet, diese Datenschutzerklärung sorgfältig zu prüfen und die richtigen Daten über sich selbst anzugeben.",
        "text-3": "Es ist unsere Verantwortlichkeit, Ihnen möglichst verständliche und aktuelle Informationen darüber zu geben, wie wir Ihre Daten verarbeiten.",
        "title": "1. Verantwortlichkeiten"
      },
      "section-2": {
        "text": "Wir erfassen Ihre personenbezogenen Daten, wenn Sie beginnen, unseren Dienst oder unsere Website zu nutzen. Diese Daten erfassen wir, um Ihnen unseren Dienst zur Verfügung stellen zu können und für andere Zwecke, wie in Abschnitt 3 unten angegeben.",
        "title": "2. Wann wir Ihre Daten erfassen"
      },
      "section-3": {
        "header-1": "Zweck der Verwendung personenbezogener Daten",
        "header-2": "Kategorie des Datensubjekts",
        "header-3": "Personenbezogene Daten",
        "header-4": "Rechtsgrundlage",
        "header-5": "Aufbewahrungsfrist",
        "t-body-10": {
          "legal": "Einhaltung einer gesetzlichen Verpflichtung",
          "personal": "Ausweisdokumente, biometrische Bilder und andere biometrische Identifikationsdaten, Geldquellen, Informationen aus Compliance-Tools, Adressen, Rechnungen von Versorgungsunternehmen, Transaktionshistorie, Protokolldateien, Lebensläufe, Migrationsinformationen und -dokumente, politischer Status, Kontodaten, verwandte Websites, verwandte Unternehmensstruktur, Risikobewertung",
          "purpose": "Überwachung von Transaktionen und Einhaltung von Vorschriften",
          "subject": "Personen in Partnerstrukturen und Geschäftskunden, wirtschaftlich Berechtigte, Zahler der Händler",
          "term": "5 Jahre nach Beendigung der Zusammenarbeit"
        },
        "t-body-11": {
          "legal": "Berechtigte Interessen zur Entwicklung des Dienstes",
          "personal": "Vollständiger Name, E-Mail, IBAN, Transaktionsdaten, Protokolle, IP, Sitzungsdaten, Standort, Betriebssysteminformationen, Gerätetyp, Informationen über Anmeldungen, Statistiken über Ihre Nutzung des Dienstes",
          "purpose": "Entwicklung und Test des Dienstes und neuer Produkte",
          "subject": "Zahlende Personen (natürliche Personen), Mitarbeiter und einzelne Auftragnehmer von Noda, Repräsentanten von Beratern, Partnern und Händlern",
          "term": "Bis zu 5 Jahre nachdem die Daten überflüssig geworden sind"
        },
        "t-body-12": {
          "legal": "Einverständnis",
          "personal": "Vollständiger Name, Transaktionsliste, Geldbetrag, Währung, Zeitpunkt der Zahlungen/Datum, Kontostand, Händlername, interne Kennungen, IBAN, durchschnittlicher Umsatz des Zahlers sowie Cookies und andere Tracker. Weitere Informationen entnehmen Sie bitte unserer <a href=\"https://noda.live/about/legal-privacy/cookies\">Cookies-Richtlinie</a>.",
          "purpose": "Das Produkt DE (Data Enrichment) zur Entwicklung von Einblicken. Damit können wir und unsere Partner (einschließlich Händler) Ihnen relevante Dienste, ein besseres Benutzererlebnis und gezieltere Werbung sowie personalisierte Dienste anbieten.",
          "subject": "Zahlende Personen (natürliche Personen)",
          "term": "<p>Bis zu 5 Jahre.</p><p>Die Aufbewahrungsfrist für Cookies wird in der <a href=\"https://noda.live/about/legal-privacy/cookies\">Cookies-Richtlinie</a> festgehalten.</p>"
        },
        "t-body-13": {
          "legal": "<p>Berechtigtes Interesse an der Förderung der Dienstleistungen von Noda</p><p>Einverständnis</p>",
          "personal": "Vollständiger Name, E-Mail-Adresse, Kommunikation",
          "purpose": "Versand von Marketing-E-Mails",
          "subject": "Kontaktpersonen von Geschäftskunden und Partnern",
          "term": "Während der Zusammenarbeit und für 5 Jahre nach Beendigung der Zusammenarbeit (oder wenn keine Zusammenarbeit zustande kommt)"
        },
        "t-body-14": {
          "legal": "<p>Berechtigtes Interesse an der Förderung der Dienstleistungen von Noda</p><p>Einverständnis</p>",
          "personal": "Vollständiger Name, Daten aus sozialen Medien, Registrierungsnummer, Standort, Cookies und ähnliche Tracker (siehe die <a href=\"https://noda.live/about/legal-privacy/cookies\">Cookie-Richtlinie</a>), Fotos, E-Mail-Adresse",
          "purpose": "Durchführung von digitalen Kampagnen",
          "subject": "Kontaktpersonen von Geschäftskunden und Partnern",
          "term": "Während der Zusammenarbeit und für 5 Jahre nach Beendigung der Zusammenarbeit (oder wenn keine Zusammenarbeit zustande kommt)"
        },
        "t-body-15": {
          "legal": "Berechtigtes Interesse an der Förderung der Dienstleistungen von Noda",
          "personal": "Vollständiger Name, E-Mail-Adresse, Telefonnummer, Arbeitsstelle, Beschreibung der Kommunikation",
          "purpose": "Geschäftsentwicklung",
          "subject": "Kontaktpersonen von Partnern, potenziellen Partnern, Geschäftskunden und potenziellen Geschäftskunden",
          "term": "Während der Zusammenarbeit und für 5 Jahre nach Beendigung der Zusammenarbeit (oder wenn keine Zusammenarbeit zustande kommt)"
        },
        "t-body-16": {
          "legal": "Berechtigte Interessen an der Entwicklung des Dienstes in Übereinstimmung mit dem aktuellen Marktumfeld",
          "personal": "Vollständiger Name, Benutzername, E-Mail-Adresse, Geschlecht, Geografie, IP, Beschäftigungsstatus, Test- und Forschungsergebnisse, Videoaufzeichnungen",
          "purpose": "Recherche und Entwicklung eines besseren Benutzererlebnisses",
          "subject": "Forschungsteilnehmer, Tester",
          "term": "Bis zu 10 Jahre"
        },
        "t-body-17": {
          "legal": "<p>Berechtigtes Interesse zur Gewährleistung der Sicherheit und des Wettbewerbsvorteils von Noda</p><p>Einhaltung einer gesetzlichen Verpflichtung</p>",
          "personal": "Informationen über Ihr Gerät und andere technische Informationen: Ihre IP-Adresse, Zeitzone, Ihr Geostandort, der für den Zugriff auf den Dienst verwendete Browser/die verwendete Plattform",
          "purpose": "Gewährleistung von Sicherheit und Betrugserkennung",
          "subject": "Alle Benutzer unseres Dienstes, unserer Website und unserer Produkte",
          "term": "Bis zu 10 Jahre"
        },
        "t-body-18": {
          "legal": "Abschluss eines Vertrages",
          "personal": "Vorname, Nachname, E-Mail-Adresse, Telefonnummer",
          "purpose": "Abschließende Vereinbarungen",
          "subject": "Repräsentanten von Lieferanten und Kunden",
          "term": "Bis zu 10 Jahre nach der Beendigung"
        },
        "t-body-19": {
          "legal": "<p>Erfüllung eines Vertrages</p><p>Berechtigtes Interesse am Bezug von Einkommen</p>",
          "personal": "Vorname, Nachname, E-Mail-Adresse, Telefonnummer, Bank- und Zahlungsdaten, Informationen aus Rechnungen, Ausweisdaten, Vereinbarungen und Vollmachten",
          "purpose": "Begleichung von Rechnungen",
          "subject": "Repräsentanten von Lieferanten, Beratern und individuellen Dienstleistern",
          "term": "Bis zu 10 Jahre nach Begleichung der Rechnung"
        },
        "t-body-1": {
          "legal": "Abschluss und Erfüllung eines Vertrages",
          "personal": "Vollständiger Name, Geburtsdatum, Adresse, E-Mail-Adresse, Telefonnummer, Finanz- und Bankdaten (einschließlich, aber nicht beschränkt auf Bank- oder Zahlungskontoinformationen, Transaktionsdaten, Kredit- und Anlagedaten), Informationen über die Bank oder einen anderen Kontoanbieter und sonstige Daten, die uns vom Anbieter des Zahlungskontos zur Verfügung gestellt werden können.",
          "purpose": "Einleitung und Bearbeitung von Online-Zahlungen",
          "subject": "Zahlende Personen (natürliche Personen)",
          "term": "Während der Nutzung des Dienstes und bis zu 10 Jahre nach der Beendigung der Bereitstellung des Dienstes"
        },
        "t-body-20": {
          "legal": "Berechtigte Interessen zur Aufrechterhaltung des Geschäftsbetriebs",
          "personal": "Vorname, Nachname, E-Mail-Adresse, Telefonnummer",
          "purpose": "Inanspruchnahme von Dienstleistungen Dritter",
          "subject": "Repräsentanten von Lieferanten, Beratern und individuellen Dienstleistern",
          "term": "Bis zu 10 Jahre nach der Beendigung der Zusammenarbeit"
        },
        "t-body-21": {
          "legal": "<p>Berechtigte Interessen zur Aufrechterhaltung des Geschäftsbetriebs</p><p>Einhaltung einer gesetzlichen Verpflichtung</p>",
          "personal": "Vorname, Nachname, E-Mail-Adresse, Telefonnummer, Ausweisnummer, Adresse, Informationen über die Beziehung zu den betreffenden Unternehmen",
          "purpose": "Durchführung von Unternehmensgeschäften",
          "subject": "Repräsentanten und Mitarbeiter der relevanten und beteiligten Unternehmen",
          "term": "Während des Bestehens eines entsprechenden Unternehmens und für bis zu 10 bis 80 Jahre danach, je nach den örtlichen Bestimmungen"
        },
        "t-body-22": {
          "legal": "Berechtigte Interessen zum Schutz der Position von Noda",
          "personal": "Alle personenbezogenen Daten, die zur Beilegung des entsprechenden Konflikts oder Rechtsstreits erforderlich sind",
          "purpose": "Konfliktlösung",
          "subject": "Alle Datensubjekte",
          "term": "Während des Bestehens eines entsprechenden Konflikts und bis zu 10 Jahre nach dessen Beilegung"
        },
        "t-body-23": {
          "legal": "Einhaltung einer gesetzlichen Verpflichtung",
          "personal": "Alle personenbezogenen Daten, die in den archivierungspflichtigen Dokumenten enthalten sind",
          "purpose": "Archivierung und Speicherung von Dokumenten",
          "subject": "Alle Datensubjekte",
          "term": "Basierend auf den örtlichen Bestimmungen"
        },
        "t-body-2": {
          "legal": "Abschluss und Erfüllung eines Vertrages",
          "personal": "Vollständiger Name, E-Mail-Adresse, Telefonnummer, Kommunikation",
          "purpose": "Einleitung und Bearbeitung von Online-Zahlungen",
          "subject": "Repräsentanten von Geschäftskunden, die Noda-Zahlungsdienste nutzen",
          "term": "Während der Nutzung des Dienstes und bis zu 10 Jahre nach der Beendigung der Bereitstellung des Dienstes"
        },
        "t-body-3": {
          "legal": "<p>Abschluss und Erfüllung eines Vertrages</p><p>Berechtigtes Interesse seitens Noda zur Erfüllung der Anforderungen an die Infrastruktur der Kartenverarbeitung</p>",
          "personal": "Einzelheiten über die Transaktionen, Kartennummer, Ablaufdaten, Ort der Zahlung, Betrag der Transaktion, Häufigkeit der Transaktionen, gekaufte Dienstleistungen oder Waren, IP, E-Mail-Adresse, zusätzliche Informationen über den Kauf",
          "purpose": "Bereitstellung von Dienstleistungen zur Kartenverarbeitung",
          "subject": "Zahlende Personen (natürliche Personen)",
          "term": "Während der Nutzung des Dienstes und bis zu 10 Jahre nach der Beendigung der Bereitstellung des Dienstes"
        },
        "t-body-4": {
          "legal": "Abschluss und Erfüllung eines Vertrages",
          "personal": "Vollständiger Name, E-Mail-Adresse, vertretene Bank oder Zahlungsdienstleister",
          "purpose": "Bereitstellung von Dienstleistungen zur Kartenverarbeitung",
          "subject": "Vertreter von Partnern",
          "term": "Während der Nutzung des Dienstes und bis zu 10 Jahre nach der Beendigung der Bereitstellung des Dienstes"
        },
        "t-body-5": {
          "legal": "<p>Abschluss und Erfüllung eines Vertrages</p><p>Einhaltung einer gesetzlichen Verpflichtung</p>",
          "personal": "Kontoinformationen, E-Mail-Adresse und Compliance-Daten wie unten angegeben",
          "purpose": "Onboarding von Händlern",
          "subject": "Repräsentanten von Händlern, Personen, die mit der Unternehmensstruktur von Händlern verbunden sind",
          "term": "Während der Zusammenarbeit und bis zu 10 Jahre nach der Beendigung dieser"
        },
        "t-body-6": {
          "legal": "<p>Berechtigtes Interesse, den Benutzern die Möglichkeit zu geben, den Dienst zu nutzen</p><p>Einhaltung einer rechtlichen Verpflichtung</p>",
          "personal": "Vollständiger Name, Geburtsdatum, Adresse, E-Mail-Adresse, Telefonnummer, Informationen über Transaktionen, interne Referenznummer, IBAN, Informationen über den verwendeten Händler, Zahlungsdetails, Protokolldateien, Informationen über Abmeldelisten",
          "purpose": "Bereitstellung eines Kundendienstes",
          "subject": "Zahlende Personen (natürliche Personen)",
          "term": "Während der Kommunikation und bis zu 10 Jahre, nachdem ein Problem gelöst wurde"
        },
        "t-body-7": {
          "legal": "<p>Erfüllung eines Vertrages</p><p>Berechtigtes Interesse, den Kunden einen qualitativen Dienst bereitzustellen</p>",
          "personal": "Jegliche personenbezogenen Daten, die über Kommunikationskanäle, einschließlich eines Chatbots, bereitgestellt werden",
          "purpose": "Bereitstellung von Dienstleistungen zur Unterstützung von Unternehmen",
          "subject": "Repräsentanten von Geschäftskunden oder Partnern, die Noda-Zahlungsdienste nutzen oder mit Noda zusammenarbeiten",
          "term": "Während der Kommunikation und bis zu 10 Jahre, nachdem ein Problem gelöst wurde"
        },
        "t-body-8": {
          "legal": "Berechtigtes Interesse, den Kunden einen qualitativen Dienst bereitzustellen",
          "personal": "Vollständiger Name, E-Mail-Adresse, Telefonnummer",
          "purpose": "Benachrichtigung über Updates",
          "subject": "Repräsentanten und Kontaktpersonen von Geschäftskunden",
          "term": "Bis zu 10 Jahre nach der Übermittlung der Benachrichtigung"
        },
        "t-body-9": {
          "legal": "<p>Einhaltung einer gesetzlichen Verpflichtung<p></p>Berechtigtes Interesse am Aufbau von Partnerschaften mit anderen Unternehmen</p>",
          "personal": "Ausweisdokumente, biometrische Bilder und andere biometrische Identifikationsdaten, Geldquellen, Informationen aus Compliance-Tools, Adressen, Rechnungen von Versorgungsunternehmen, Transaktionshistorie, Protokolldateien, Lebensläufe, Migrationsinformationen und -dokumente, politischer Status, Kontodaten, verwandte Websites, verwandte Unternehmensstruktur, Risikobewertung, Informationen über Steuerzahlungen",
          "purpose": "Überprüfung der Einhaltung der Noda-Verpflichtungen, des Onboardings mit Partnern und der Einhaltung der Anforderungen der Partner, Überprüfung der Zahler von Händlern",
          "subject": "Personen innerhalb der Noda-Unternehmensstruktur, Personen in der Partnerstruktur und Geschäftskunden, wirtschaftlich Berechtigte, Zahler der Händler",
          "term": "Ab 5 und bis 10 Jahre nach Beendigung der Zusammenarbeit"
        },
        "text": "In Abhängigkeit davon, wie Sie sich für die Nutzung des Dienstes entscheiden oder ob Sie ein Abonnement abschließen oder nicht, können wir folgende Daten über Sie in Einklang mit der nachstehenden Beschreibung verwenden:",
        "text-bottom": "Ist die Bereitstellung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung oder zum Abschluss bzw. zur Erfüllung eines Vertrages erforderlich, stellen Sie uns jedoch die erforderlichen Informationen nicht zur Verfügung, haben wir das Recht, die Erbringung der entsprechenden Dienstleistung, den Abschluss eines Vertrages oder die Erfüllung eines Vertrages ohne negative Rechtsfolgen zu verweigern.",
        "title": "3. Daten, die wir erfassen, der Verwendungszweck, die Rechtsgrundlage und Aufbewahrungsfristen"
      },
      "section-4": {
        "list-1": {
          "item-1": "Anbietern von Zahlungskonten und ähnlichen Dienstleistungen (Banken, Kartenausstellern usw. – „<b>Partnern</b>“);",
          "item-2": "Drittparteien und Diensten, die Sie in Verbindung mit dem Dienst nutzen (z. B. E-Commerce-Seiten, über die Sie unseren Dienst nutzen, oder „<b>Händlern</b>“);",
          "item-3": "unseren bewährten Partnern für die Datenaggregation (lizenzierte Open-Banking-Plattformen);",
          "item-4": "unserer Unternehmensgruppe;",
          "item-5": "unseren Dienstleistern wie zum Beispiel Buchhaltungs-, Wirtschaftsprüfungs-, Datenspeicherungs- und -verarbeitungsdiensten, Anbietern von Online-Kommunikations- und Kollaborationsdiensten, Rechtsdienstleistern, Anbietern von AML- und Sanktionsprüfungsdiensten, Diensten zur Betrugsbekämpfung, Datenbanken für Unternehmensdaten, Anbietern von Buchhaltungsdiensten, Entwicklern und Testern, Anbietern von Marketingdiensten, sozialen Medien, E-Commerce-Plattformen und anderen;",
          "item-6": "Regulierungsbehörden, Aufsichtsbehörden, Gerichten und anderen autorisierten öffentlichen oder ähnlichen Einrichtungen (wie Bürgerbeauftragten, Finanzaufsichtsbehörden, Aufsichtsbehörden für Glücksspiele);"
        },
        "list-2": {
          "item-1": "Ihnen oder Ihrem Arbeitgeber;",
          "item-2": "Händlern;",
          "item-3": "E-Commerce-Plattformen, sozialen Medien und Suchmaschinen;",
          "item-4": "Regulierungsbehörden, Aufsichtsbehörden, Gerichten und anderen autorisierten öffentlichen oder ähnlichen Einrichtungen (wie Bürgerbeauftragten, Finanzaufsichtsbehörden, Aufsichtsbehörden für Glücksspiele);",
          "item-5": "Anbietern von AML- und Sanktionsprüfungsdiensten, Betrugsbekämpfungsdiensten;",
          "item-6": "Organisatoren von Veranstaltungen (wie Konferenzen, Seminare und andere);",
          "item-7": "Berufsverbänden;",
          "item-8": "Öffentlichen Registern und Anbietern von Compliance-Diensten."
        },
        "text-1": "Für den effektiven Betrieb unseres Dienstes müssen wir mit Dritten zusammenarbeiten und können dementsprechend Ihre Daten mit diesen austauschen:",
        "text-2": "Ihre personenbezogenen Daten erhalten wir auch von:",
        "title": "4. Empfänger und Quellen Ihrer Daten"
      },
      "section-5": {
        "text": "Soweit Noda Ihre personenbezogenen Daten in Länder außerhalb der EU oder des EWR überträgt, berufen wir uns auf die Garantien, die durch die anwendbaren Rechtsakte gegeben sind, zum Beispiel, wie es die EU-Datenschutzgrundverordnung (DSGVO) vorsieht: die Entscheidungen der Europäischen Kommission zur Angemessenheit (Artikel 45 der DSGVO), Standardvertragsklauseln und andere Garantien, die in den Artikeln 46 und 49 der DSGVO vorgesehen sind. Bei der Übermittlung personenbezogener Daten in die USA kann sich Noda auf den entsprechenden geltenden Rahmen für die Übermittlung personenbezogener Daten berufen. In Abhängigkeit von der betroffenen Noda-Einheit kann sich Noda in Einzelfällen auch auf das UK International Data Transfer Addendum zu den Standardvertragsklauseln der EU-Kommission berufen.",
        "title": "5. Internationaler Transfer Ihrer personenbezogenen Daten"
      },
      "section-6": {
        "list": {
          "item-1": "Sie haben das Recht zu erfahren, welche Art von Daten wir über Sie erfassen und wie wir diese verarbeiten. Wie wir Ihre personenbezogenen Daten verwenden, erfahren Sie auch in Abschnitt 3.",
          "item-2": "Sie haben das Recht auf Löschung bestimmter Daten. Hinweis: Auf einen solchen Antrag hin sind wir möglicherweise nicht mehr in der Lage, Ihnen unseren Dienst (ganz oder teilweise) zur Verfügung zu stellen.",
          "item-3": "Sie können die Verarbeitung Ihrer Daten einschränken, der Verarbeitung Ihrer personenbezogenen Daten widersprechen und Ihre Einwilligung widerrufen. Die Zulässigkeit der Verarbeitung, die auf Ihrem Einverständnis vor dem Widerruf basiert, bleibt davon unberührt.",
          "item-4": "Sie haben das Recht, uns keine personenbezogenen Daten zur Verfügung zu stellen. In einem solchen Fall sind wir möglicherweise nicht in der Lage, Ihnen unseren Dienst ganz oder teilweise zur Verfügung zu stellen."
        },
        "text-1": "In Bezug auf Ihre personenbezogenen Daten haben Sie die folgenden Rechte:",
        "text-2": "Falls Sie mit der Art und Weise, wie wir Ihre personenbezogenen Daten verarbeiten, nicht zufrieden sind, können Sie jederzeit eine Beschwerde bei uns einreichen, indem Sie sich schriftlich an <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> wenden. Sollten Sie der Ansicht sein, dass wir nicht in der Lage sind, Ihre Anfrage in Übereinstimmung mit dem geltenden Recht zu bearbeiten, können Sie Beschwerde bei einer zuständigen Aufsichtsbehörde einreichen. Wenn Sie innerhalb der EU ansässig sind, finden Sie die Liste der Aufsichtsbehörden <a href=\"https://www.edpb.europa.eu/about-edpb/about-edpb/members_en\" target=\"_blank\" rel=\"nofollow\">hier</a>.",
        "title": "6. Ihre Rechte"
      },
      "section-7": {
        "text-1": "Sollten Sie Fragen, Kommentare oder Beschwerden darüber haben, wie wir Ihre Daten verwenden, senden Sie diese bitte an <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "text-2": "Mit Ausnahme von NAUDAPAY LIMITED kann es andere Verantwortliche für Ihre personenbezogenen Daten geben, die in dieser Datenschutzerklärung beschrieben sind.",
        "text-3": "Für weitere Informationen kontaktieren Sie uns bitte unter <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "title": "7. Kontaktinformationen"
      },
      "section-8": {
        "text": "Wir können unsere Datenschutzerklärung gelegentlich ändern, um sie an Änderungen der geltenden Gesetze und Vorschriften oder an Änderungen in unseren Geschäftsabläufen anzupassen. Aus diesem Grund möchten wir Sie bitten, diese Seite von Zeit zu Zeit auf die neuesten Aktualisierungen hin zu überprüfen.",
        "title": "8. Änderungen an der Datenschutzerklärung"
      },
      "subtitle": "Über unsere Datennutzung und den Datenschutzbeauftragten",
      "text-1": "Bei Noda.live („wir“, „uns“, „unser“, „Noda“) legen wir großen Wert auf Ihre Privatsphäre und Datensicherheit. Wir möchten Ihnen verständliche Informationen darüber geben, wie wir Ihre Daten verwenden und wie Sie dies kontrollieren können. Wir empfehlen Ihnen daher dringend, diese Datenschutzerklärung sorgfältig zu lesen, bevor Sie die von uns angebotenen Dienste (zusammenfassend der „<b>Dienst</b>“) nutzen.",
      "text-2": "Bei weiteren Fragen oder Anliegen können Sie sich gerne an <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a> wenden. Wir helfen Ihnen gerne weiter.",
      "text-3": "Diese Datenschutzerklärung sowie die allgemeinen Geschäftsbedingungen bilden den gesamten Vertrag (im Folgenden die „<b>Vereinbarung</b>“) zwischen Ihnen und Noda.",
      "text-4": "Der Hauptverantwortliche für Ihre personenbezogenen Daten ist NAUDAPAY LIMITED, britische Registrierungsnummer: 11741664. In gesonderten Fällen können auch andere Unternehmen unserer Gruppe für Ihre personenbezogenen Daten, die in dieser Datenschutzerklärung beschrieben sind, verantwortlich sein. Weitere Informationen und Kontaktangaben finden Sie am Ende dieser Datenschutzerklärung.",
      "title": "Datenschutz&shy;erklärung"
    },
    "privacy-for-candidates": {
      "last-update": "Zuletzt aktualisiert am 1. Juni 2024",
      "section-1": {
        "text-1": "Ihre personenbezogenen Daten werden von Noda dazu verwendet, eine Person zu finden, die für eine derzeitige oder zukünftige offene Stelle bei Noda oder seinen Konzerngesellschaften geeignet ist, oder um Dienstleistungen zu beziehen, die Sie zur Verfügung stellen.",
        "text-2": "Falls Sie ein individueller Vertragspartner sind, können Ihre personenbezogenen Daten von Noda verwendet werden, um die Einhaltung der gesetzlichen Vorschriften zu überprüfen (z. B. hinsichtlich der Geldwäsche). Sollten Sie Noda die für eine solche Compliance-Prüfung erforderlichen personenbezogenen Daten nicht bereitstellen, kann Noda möglicherweise nicht mit Ihnen als Auftragnehmer zusammenarbeiten.",
        "text-3": "Wenn Noda Sie für einen Arbeitsplatz, ein Praktikum oder eine Zusammenarbeit in Betracht zieht, benötigt Noda Ihre personenbezogenen Daten, um Ihnen ein Stellen-, Praktikums- oder Arbeitsangebot zu unterbreiten.",
        "text-4": "Wenn Sie eine Anfrage oder eine Beschwerde einreichen oder es zu einem möglichen Rechtsstreit kommt, kann Noda Ihre personenbezogenen Daten verwenden, um das Problem zu lösen.",
        "title": "Wozu braucht Noda Ihre Daten?"
      },
      "section-2": {
        "text": "Dieser Abschnitt erläutert die für die genannten Zwecke verwendeten personenbezogenen Daten, die Rechtsgrundlagen für ihre Verwendung und deren Aufbewahrungsfristen.",
        "title": "Wie behandelt Noda Ihre Daten?"
      },
      "section-3": {
        "list": {
          "item-1": "Unternehmen der Noda-Gruppe",
          "item-2": "Anbieter von Datenspeicherdiensten",
          "item-3": "Anbieter für elektronische Kommunikationsdienste (z. B. E-Mail-Dienste)",
          "item-4": "Personalvermittler und ähnliche Dienstleistungsanbieter, einschließlich Personal- und Rekrutierungsplattformen",
          "item-5": "LinkedIn und ähnliche Plattformen für soziale Medien",
          "item-6": "Anbieter von Compliance-Dienstleistungen",
          "item-7": "Andere externe Dienstleister (z. B. Rechtsberater, Veranstaltungsorganisatoren und andere)",
          "item-8": "Aufsichtsbehörden, Vollzugsbehörden, Gerichte, Schlichtungsstellen und andere ähnliche öffentliche oder private Einrichtungen"
        },
        "text-1": "Noda bezieht Ihre personenbezogenen Daten von Ihnen, Ihren LinkedIn- und ähnlichen Profilen in sozialen Medien, Personalvermittlern und Empfehlungsgebern. Falls Sie als individueller Auftragnehmer agieren, kann Noda Ihre personenbezogenen Daten auch von verschiedenen Compliance-Dienstleistern erhalten.",
        "text-2": "Noda kann Ihre personenbezogenen Daten auch an die folgenden Empfänger weitergeben:",
        "title": "Quellen und Empfänger der Daten"
      },
      "section-4": {
        "text": "Im Allgemeinen überträgt Noda keine personenbezogenen Daten innerhalb des Einstellungsverfahrens außerhalb der Europäischen Union und des Europäischen Wirtschaftsraums. Allerdings kann es dazu kommen, wenn Sie oder die verweisenden Parteien außerhalb der genannten Gebiete ansässig sind. Darüber hinaus können derartige Transfers im Falle von Compliance-Prüfungen für einzelne Vertragspartner stattfinden. Wenn solche Übermittlungen stattfinden, berufen wir uns auf die Garantien, die durch die anwendbaren Rechtsakte gegeben sind, zum Beispiel, wie es die EU-Datenschutzgrundverordnung (DSGVO) vorsieht: die Entscheidungen der Europäischen Kommission zur Angemessenheit (Artikel 45 der DSGVO), Standardvertragsklauseln und andere Garantien, die in den Artikeln 46 und 49 der DSGVO vorgesehen sind. Bei der Übermittlung personenbezogener Daten in die USA kann sich Noda auf den entsprechenden geltenden Rahmen für die Übermittlung personenbezogener Daten berufen. In Abhängigkeit von der betroffenen Noda-Einheit kann sich Noda in Einzelfällen auch auf das UK International Data Transfer Addendum zu den Standardvertragsklauseln der EU-Kommission berufen.",
        "title": "Internationaler Transfer"
      },
      "section-5": {
        "list": {
          "item-1": "den Zugang zu Ihren personenbezogenen Daten oder die Ausstellung einer Kopie Ihrer personenbezogenen Daten;",
          "item-2": "die Korrektur Ihrer personenbezogenen Daten, wenn diese fehlerhaft sind;",
          "item-3": "die Löschung Ihrer personenbezogenen Daten, wenn das berechtigte Interesse von Noda nicht gegeben ist. Die Löschung der verwendeten Daten können Sie aufgrund der gesetzlichen Bestimmungen nicht beantragen;",
          "item-4": "Widerspruch gegen die Verwendung Ihrer personenbezogenen Daten einlegen, wenn diese auf berechtigten Interessen basiert;",
          "item-5": "die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten;",
          "item-6": "eine Beschwerde bei Noda über die unten angegebenen Kontaktinformationen. Wenn Noda Ihrer Bitte nicht nachkommt, haben Sie zudem die Möglichkeit, eine Beschwerde bei einer Datenschutzaufsichtsbehörde einzureichen."
        },
        "text": "Sie können Folgendes beantragen:",
        "title": "Datenschutzrechte"
      },
      "section-6": {
        "text-1": "Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten ist das Unternehmen Noda, mit dem Sie voraussichtlich eine Vereinbarung abschließen werden oder das einen Bewerber oder einen potenziellen Kooperationspartner sucht. Weitere Informationen erhalten Sie von Noda über die unten angegebene E-Mail-Adresse.",
        "text-2": "Bei Fragen oder Wünschen in Bezug auf Ihre personenbezogenen Daten wenden Sie sich bitte an die folgende E-Mail-Adresse: <a class=\"link highlighted\" href=\"mailto:dpo@noda.live\">dpo@noda.live</a>",
        "title": "Kontaktinformationen"
      },
      "subtitle": "Über die Bekanntmachung und Noda",
      "text-1": "Diese Bekanntmachung legt dar, wie Noda die personenbezogenen Daten von potenziellen Mitarbeitern, Praktikanten, die sich auf offene Stellen bei Noda beworben haben oder eingeladen wurden, sich auf offene Stellen bei Noda zu bewerben oder mit Noda als individuelle Auftragnehmer zusammenzuarbeiten, behandelt.",
      "text-2": "Noda ist der Datenverantwortliche für Ihre personenbezogenen Daten. Die entsprechenden Informationen und Kontaktangaben von Noda finden Sie am Ende dieser Bekanntmachung.",
      "title": "Datenschutzhinweis für Bewerber oder eine Zusammenarbeit"
    },
    "retail": {
      "faq": {
        "countries": {
          "content": "Wir arbeiten mit 2000+ Banken in 28 Ländern zusammen, darunter die Niederlande, Portugal, Belgien, Deutschland, Polen, Bulgarien, Frankreich, Irland, Italien, Österreich, Spanien, Dänemark, Estland, das Vereinigte Königreich, Luxemburg, Rumänien, Litauen, Ungarn, Lettland, Finnland, Schweden, Norwegen, die Tschechische Republik, die Slowakei, Griechenland und Slowenien.",
          "title": "In welchen Ländern ist Noda tätig?"
        },
        "currencies": {
          "content": "Noda unterstützt eine Vielzahl von Währungen weltweit, darunter EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON und SEK.",
          "title": "Welche Währungen unterstützt Noda?"
        },
        "integration": {
          "content": "Zunächst sollten Sie bei Noda angemeldet sein. Füllen Sie einfach das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Wir bieten Ihnen ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unser Zahlungssystem für den Einzelhandel lässt sich mit APIs und Front-End-Komponenten integrieren und fügt sich nahtlos in Ihren Einzelhandelsmarkt ein.",
          "title": "Wie kann ich Noda in meinen Zahlungsablauf integrieren?"
        },
        "subtitle": "Antworten auf Ihre Fragen",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verbessern Sie Ihr Einzelhandelsgeschäft mit dem Zahlungs-Gateway von Noda. Konzentrieren Sie sich auf die Strategie, während wir die Transaktionen rationalisieren. Unsere All-in-One-Plattform legt den Schwerpunkt auf Kundenverständnis, Effizienz und Wachstum",
        "title-1": "Zahlungs-Gateway",
        "title-2": "für den Einzelhandel mit Noda"
      },
      "how-does-it-work": {
        "subtitle": "Technologien",
        "text-1": "Ein Zahlungs-Gateway überträgt sicher Finanzdaten zwischen Kunden, Einzelhandelsgeschäften und Banken. Stellen Sie sich das Gateway wie einen digitalen Dirigenten vor, der jeden Schritt der Kreditkartenabwicklung leitet",
        "text-2": "Noda ist eine weltweite Zahlungsplattform und ein Anbieter von Open Banking. Von sicheren Gateways über Transaktionsmanagement bis hin zu Finanzanalysen - Noda hat alles für Sie. Unsere Plattform nutzt KI- und Machine-Learning-Technologien, um modernste Lösungen für den Einzelhandel anzubieten",
        "title": "Wie funktioniert das Retail Payment Gateway?"
      },
      "how-to-start": {
        "subtitle": "Einfaches Onboarding",
        "text": "Noda bietet ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unsere Plattform lässt sich nahtlos in APIs und Front-End-Komponenten integrieren, so dass eine nahtlose Einbindung in Ihre Einzelhandelsplattform gewährleistet ist. Um mit der Nutzung von Noda zu beginnen, füllen Sie das untenstehende Formular aus, und unsere Vertriebsmitarbeiter werden Sie in Kürze kontaktieren. Unser Team ist da, um Ihnen bei allen Hindernissen zu helfen",
        "title": "Wie man anfängt"
      },
      "open-banking": {
        "subtitle": "Viele Möglichkeiten",
        "text": "Open Banking bedeutet, dass traditionelle Banken Daten mit lizenzierten Fintech-Unternehmen wie Noda austauschen, um Transaktionen zu rationalisieren. Unser Ökosystem für den Zahlungsverkehr verbindet alle führenden Banken im Vereinigten Königreich und in der EU und ermöglicht eine mühelose Abwicklung von Massenzahlungen",
        "title": "Was ist Open Banking?"
      },
      "payment-processing": {
        "subtitle": "Beste Angebote",
        "text": "Optimieren Sie Ein- und Auszahlungen, nutzen Sie intuitive UX, intelligentes Routing und bieten Sie eine Vielzahl beliebter Zahlungsmethoden an",
        "title": "Verarbeitung von Massenzahlun&shy;gen"
      },
      "payments": {
        "text": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt",
        "title": "Toolset für den Einzelhandel"
      },
      "scalable-plans": {
        "subtitle": "Weitere Vorteile",
        "text": "Wir bieten Lösungen für den Einzelhandelszahlungsverkehr für alle Unternehmensgrößen, mit skalierbaren Plänen zur Unterstützung Ihres Geschäftswachstums",
        "title": "Skalierbare Pläne"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Nutzen Sie unsere datengesteuerten Erkenntnisse. Die Tools von Noda bieten gebrauchsfertige Analysen des Kundenverhaltens, einschließlich Segmentierungs- und Prognosealgorithmen",
            "title": "KI-gestützte Analytik"
          },
          "banking": {
            "content": "Verbesserung des Kundenerlebnisses und Vereinfachung des Transaktionsflusses durch die Leistungsfähigkeit und Sicherheit von Open-Banking-Zahlungen",
            "title": "Offenes Banking"
          },
          "global-currencies": {
            "content": "Noda arbeitet mit mehreren Währungen, um Ihre Kunden auf der ganzen Welt zu unterstützen",
            "title": "Globale Währungen"
          },
          "security": {
            "content": "Noda bietet ein sicheres Einzelhandels-Gateway, das PCI DSS-Konformität, Verschlüsselung und Betrugsprävention gewährleistet",
            "title": "Sicherheit"
          }
        },
        "subtitle": "Was wir bieten",
        "title": "Top-Funktionen für den Einzelhandel"
      }
    },
    "saas": {
      "faq": {
        "countries": {
          "content": "Wir arbeiten mit 2000+ Banken in 28 Ländern zusammen, darunter die Niederlande, Portugal, Belgien, Deutschland, Polen, Bulgarien, Frankreich, Irland, Italien, Österreich, Spanien, Dänemark, Estland, das Vereinigte Königreich, Luxemburg, Rumänien, Litauen, Ungarn, Lettland, Finnland, Schweden, Norwegen, die Tschechische Republik, die Slowakei, Griechenland und Slowenien.",
          "title": "In welchen Ländern ist Noda tätig?"
        },
        "currencies": {
          "content": "Noda unterstützt eine Vielzahl von Währungen weltweit, darunter EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON und SEK.",
          "title": "Welche Währungen unterstützt Noda?"
        },
        "how-to-integrate": {
          "content": "Zunächst sollten Sie bei Noda angemeldet sein. Füllen Sie einfach das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Wir bieten Ihnen ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unser SaaS-Zahlungssystem lässt sich problemlos mit API- und Front-End-Komponenten integrieren, sodass eine nahtlose Einbindung in Ihre Plattform gewährleistet ist",
          "title": "Wie kann ich Noda in meinen Zahlungsablauf integrieren?"
        },
        "subtitle": "Ihre Fragen beantwortet",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verbessern Sie Ihr Software-as-a-Service (SaaS)-Geschäft. Kümmern Sie sich um Ihre Kunden, während wir die SaaS-Zahlungen rationalisieren. Unsere All-in-One-Plattform legt den Schwerpunkt auf Kundenverständnis, Effizienz und Wachstum",
        "title-1": "Zahlungs-Gateway",
        "title-gradient-1": "für SaaS mit Noda"
      },
      "how-to-start": {
        "subtitle": "Einfaches Onboarding",
        "text": "Noda bietet ein einfaches Onboarding mit individueller Betreuung durch einen engagierten Manager. Unsere Plattform lässt sich nahtlos in API- und Front-End-Komponenten integrieren, so dass eine nahtlose Einbindung in Ihre Software gewährleistet ist. Um mit der Nutzung von Noda zu beginnen, füllen Sie das untenstehende Formular aus, und unsere Vertriebsmitarbeiter werden Sie in Kürze kontaktieren. Unser Team ist für Sie da und hilft Ihnen bei allen Hindernissen",
        "title": "Wie man anfängt"
      },
      "open-banking": {
        "subtitle": "Viele Möglichkeiten",
        "text": "Open Banking bedeutet, dass traditionelle Banken Daten mit lizenzierten Fintech-Unternehmen wie Noda austauschen, um Transaktionen zu rationalisieren. Unser Ökosystem für den Zahlungsverkehr verbindet alle führenden Banken in Großbritannien und der EU und ermöglicht mühelose SaaS-Zahlungsverarbeitungsdienste",
        "title": "Was ist Open Banking?"
      },
      "payments": {
        "text": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt",
        "title": "Toolset für SaaS"
      },
      "technologies": {
        "text-1": "Ein Zahlungs-Gateway überträgt sicher Finanzdaten zwischen Kunden, Händlern und Banken.\n      Stellen Sie es sich als digitalen Dirigenten vor, der jeden Schritt der SaaS-Kreditkartenverarbeitung leitet",
        "text-2": "Noda ist eine weltweite Zahlungsplattform und ein Anbieter von Open Banking. Von der sicheren Verarbeitung bis zum\n      Transaktionsmanagement und Finanzanalyse hat Noda alles im Angebot. Unsere Plattform nutzt KI\n      und Technologien des maschinellen Lernens, um modernste Lösungen anzubieten",
        "title": "technologieen",
        "title-1": "Wie funktioniert SaaS-Zahlung",
        "title-2": "Gateway-Arbeit?"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Nutzen Sie unsere datengesteuerten Erkenntnisse. Die Tools von Noda bieten gebrauchsfertige Analysen des Kundenverhaltens, einschließlich Segmentierungs- und Prognosealgorithmen",
            "title": "KI-gestützte Analytik"
          },
          "banking": {
            "content": "Verbesserung des Kundenerlebnisses und Vereinfachung des Transaktionsflusses durch die Leistungsfähigkeit und Sicherheit von Open-Banking-Zahlungen",
            "title": "Offenes Banking"
          },
          "global-currencies": {
            "content": "Noda arbeitet mit mehreren Währungen, um Ihre SaaS-Kunden auf der ganzen Welt zu unterstützen",
            "title": "Globale Währungen"
          },
          "payment-processing": {
            "content": "Optimieren Sie Ein- und Auszahlungen, nutzen Sie intuitive UX, intelligentes Routing und bieten Sie eine Vielzahl beliebter Zahlungsmethoden an",
            "title": "SaaS-Zahlungsabwicklung"
          },
          "scalable-plans": {
            "content": "Wir bieten SaaS-Zahlungslösungen für alle Unternehmensgrößen an, mit skalierbaren Plänen zur Unterstützung Ihres Unternehmenswachstums",
            "title": "Skalierbare Pläne"
          },
          "security": {
            "content": "Noda bietet ein sicheres Zahlungs-Gateway, das die Einhaltung des PCI DSS, Verschlüsselung und Betrugsprävention gewährleistet",
            "title": "Sicherheit"
          }
        },
        "subtitle": "unsere Angebote",
        "title": "Top-Funktionen"
      }
    },
    "security": {
      "faq": {
        "contact": {
          "complex-content": {
            "p1": "Sollten Sie Schwierigkeiten mit den Diensten von Noda haben, empfehlen wir Ihnen die folgenden Kanäle für den Support:",
            "p2": "<b>Skype/Telegramm-Gruppenchat:</b> Wir haben einen speziellen Gruppen-Chat eingerichtet, um eine nahtlose Kommunikation zu ermöglichen. Wenn Sie Fragen zur Integration haben oder auf technische Probleme stoßen, zögern Sie nicht, eine Nachricht an die Gruppe zu senden und uns zu markieren",
            "p3": "<b>Persönlicher Manager:</b> Bei Fragen, die nicht den technischen Support betreffen, können Sie Ihren persönlichen Manager direkt im Gruppenchat oder über eine private Nachricht kontaktieren.",
            "p4": "<b>E-Mail-Unterstützung:</b> Sowohl Händler als auch ihre Kunden können uns unter folgender Adresse erreichen",
            "p5": "Denken Sie daran: Wir sind immer bereit, Ihnen zu helfen!"
          },
          "title": "Ich habe ein Problem mit den Dienstleistungen von Noda; an wen kann ich mich wenden?"
        },
        "knowledge": {
          "complex-content": {
            "l1": "<b>Sicherheit auf Bankniveau:</b> Beim Open Banking kommen streng geprüfte Software und Sicherheitssysteme zum Einsatz. Die Verbraucher müssen ihre Bankanmeldedaten oder Passwörter nur an ihre eigene Bank weitergeben.",
            "l2": "<b>Regulierung:</b> Nur Apps und Websites, die von der britischen Financial Conduct Authority (FCA) oder gleichwertigen Institutionen in Europa reguliert werden, dürfen Open Banking nutzen.",
            "l3": "<b>Kontrolle über die Daten:</b> Die Kunden haben die Möglichkeit zu entscheiden, wann und wie lange sie ihre Daten weitergeben. Sie können diesen Zugang auch jederzeit über ihre Bank widerrufen.",
            "p1": "Bei der Entwicklung von Open Banking wurde besonderer Wert auf die Sicherheit gelegt, so dass es für Ihre Kunden absolut sicher ist. Hier sind einige der wichtigsten Sicherheitsmerkmale:"
          },
          "title": "Wie kann ich wissen, dass Open Banking sicher ist?"
        },
        "safe": {
          "content": "Ja, Noda ist vertrauenswürdig. Unzählige Endkunden setzen auf Noda, um sicher über ihre favorisierten Banken zu bezahlen, bei denen sie ihr Geld mit Vertrauen lagern. Noda teilt niemals Kundendaten ohne deren ausdrückliche Einwilligung. Zugleich setzen wir alles daran, die Daten unserer Kunden auf jedem Schritt des Weges zu schützen.",
          "title": "Wird Noda als sicherer Ort wahrgenommen?"
        },
        "secure": {
          "content": "Ja, Noda ist sicher. Wie bereits erwähnt, ist Noda nicht nur auf Sicherheit ausgelegt, sondern überwacht auch kontinuierlich seine Sicherheitsstufen. Wir verfolgen einen mehrschichtigen Ansatz, um das Risiko von Hackerangriffen und Datenlecks deutlich zu reduzieren. Wir verwenden beispielsweise führende Verschlüsselungsprotokolle, erstklassige Cloud-Infrastrukturanbieter, Multi-Faktor-Authentifizierung und führen rund um die Uhr eine umfassende Überwachung unserer Dienste durch.",
          "title": "Ist Noda sicher?"
        },
        "test": {
          "complex-content": {
            "l1-1": "Kontonummer",
            "l1-2": "Vollständiger Name",
            "l2-1": "Informationen zur Identität",
            "l2-2": "Kontostände",
            "l2-3": "Transaktionsverlauf für 90 Tage",
            "p1": "Noda fungiert sowohl als Payment Initiation Service Provider (PISP) als auch als Account Information Services Provider (AISP). Im ersten Fall bieten wir Ihren Kunden Payment Initiation Services (PIS) an. Das bedeutet im Wesentlichen, dass Noda den Zahlungsvorgang für Ihre Kunden erleichtert, indem wir Gelder direkt von ihrem/ihren verknüpften Zahlungskonto/-konten an den ausgewählten Begünstigten überweisen, wenn dieser ausdrücklich zustimmt. In diesem Fall greift Noda auf die folgenden Daten zu:",
            "p2": "Folglich können diese Daten als Eingabewerte für die internen Algorithmen von Noda verwendet und an Händler weitergegeben werden, um zu bestätigen, dass die Zahlung erfolgreich war.",
            "p3": "Im zweiten Fall ermöglicht der Kontoinformationsdienst (AIS) Noda den Zugriff auf und die Anzeige von Informationen über alle Online-Banking-Konten an einem Ort und die Analyse der Finanzdaten Ihrer Kunden nach deren Zustimmung. In diesem Fall hat Noda Zugang zu den folgenden Daten:",
            "p4": "Folglich können diese Daten verwendet werden, um die internen Algorithmen von Noda zu verbessern. Sie können auch in aggregierter Form an Händler weitergegeben werden - zum Beispiel als Scoring-Wert, der anzeigt, welcher Zahlungskategorie ein Nutzer zuzuordnen ist (von 1 bis 5)."
          },
          "title": "Auf welche Daten kann Noda zugreifen und sie weitergeben?"
        }
      },
      "hero": {
        "desc-1": "Die Sicherheit von Zahlungen und Daten sollte immer Priorität haben. Auf dieser Seite finden Sie detaillierte Informationen über unsere Sicherheitsmaßnahmen und unsere Vorgehensweise bei der Verarbeitung und Weitergabe Ihrer Daten.",
        "desc-2": "Wir geben einen Überblick über unsere Sicherheitsfunktionen und unser Engagement für den Datenschutz. Außerdem bieten wir Einblicke in unsere Lizenzierung und die Verwaltung von Daten über verschiedene Lizenzen hinweg.",
        "title": "Sicherheit und Datenverarbei&shy;tung"
      },
      "strategy": {
        "alert": {
          "text": "Unsere automatischen Alarmsysteme ermöglichen es uns, sofort auf Bedrohungen zu reagieren, die nachts, an Wochenenden, an Feiertagen oder während anderer arbeitsfreier Zeiten auftreten.",
          "title": "Automatisiertes Alarmsystem"
        },
        "bug-bounty": {
          "text": "<p class=\"paragraph\">Unser Bug Bounty Programm heißt alle Entwickler willkommen, die sich als Hacker identifizieren. Wenn Sie oder Ihre Kollegen Fehler, Unzulänglichkeiten oder Schwachstellen in unseren Sicherheitssystemen entdecken oder Vorschläge zur Verbesserung der Funktionalität der Noda-API-Endpunkte haben, können Sie an unserem Programm teilnehmen und eine Belohnung erhalten.</p><p class=\"paragraph\"> Um ein Problem zu melden oder einen Vorschlag zu machen, senden Sie einfach eine E-Mail an unser Sicherheitsteam unter <a class=\"link\" href=\"mailto:security@noda.live\">security@noda.live</a>.</p>",
          "title": "Bug Bounty Programm"
        },
        "certification": {
          "text": "<p class=\"paragraph\">Noda erwirbt regelmäßig relevante Zertifizierungen und unterhält aktuelle PCI DSS- und PCI SSLC-Lizenzen. Der Payment Card Industry Data Security Standard (PCI DSS) ist der Industriestandard, der darauf abzielt, den Betrug im Zahlungsverkehr durch verbesserte Datenschutzkontrollen zu reduzieren.</p><p class=\"paragraph\"> Der PCI Secure Software Lifecycle Standard (PCI SLLC) stellt sicher, dass Anbieter von Zahlungssoftware die Sicherheit während des gesamten Lebenszyklus der Softwareentwicklung berücksichtigen und Anwendungen produzieren, die von vornherein sicher und robust gegen Angriffe sind. Diese Lizenzen werden vom PCI Security Standards Council (PCI SSC) verwaltet.</p>",
          "title": "Zertifizierung"
        },
        "cloud": {
          "text": "<p class=\"paragraph\">Noda nutzt eine Cloud-Infrastruktur für die Erstellung seiner Anwendungen und Dienste. Moderne Cloud-Service-Anbieter gehören zu den sichersten der Welt und investieren Millionen von Dollar, um die höchsten Sicherheitsstandards zu gewährleisten. Außerdem verbessern und verfeinern sie ihre Systeme kontinuierlich, um sie noch undurchdringlicher und sicherer zu machen.</p><p class=\"paragraph\"> Die Zusammenarbeit mit bekannten globalen Anbietern von Cloud-Infrastrukturen ist der Schlüsselfaktor für den Aufbau des Informationssicherheitsprogramms von Noda.</p>",
          "title": "Nutzung von Cloud-Infrastruktur-Anbietern"
        },
        "encryption": {
          "text": "<p class=\"paragraph\">Noda verschlüsselt alle sensiblen Daten gleichzeitig auf zwei Ebenen. Wir verwenden das TLS-Protokoll (Transport Layer Security), wenn Informationen zwischen Netzwerkservern übertragen werden, und wir wenden den AES-Standard (Advanced Encryption Standard) an, wenn die Daten gespeichert werden.</p><p class=\"paragraph\"> Durch diesen zweistufigen Verschlüsselungsansatz können wir potenzielle Sicherheitsbedenken minimieren, da sensible Daten selbst in den seltenen Fällen verschlüsselt bleiben, in denen eine der Komponenten kompromittiert wird.</p>",
          "title": "Ansatz zur Datenverschlüsselung"
        },
        "mfa": {
          "text": "<p class=\"paragraph\">Wir bei Noda sind uns bewusst, dass ein Höchstmaß an Informationssicherheit nur erreicht werden kann, wenn wir uns sowohl auf externe als auch auf interne Umgebungen konzentrieren. Aus diesem Grund implementieren wir für unsere Mitarbeiter eine Multi-Faktor-Authentifizierung (MFA) für den Zugriff auf alle wichtigen internen Plattformen.</p><p class=\"paragraph\"> MFA fügt eine zusätzliche Authentifizierungsebene hinzu, die den unbefugten Zugriff auf Daten über interne Systeme verhindern hilft.</p>",
          "title": "MFA"
        },
        "monitoring": {
          "text": "<p class=\"paragraph\">Alle Komponenten der Noda-Produkte, einschließlich der Noda-API, werden kontinuierlich von unserem IT-Sicherheitsteam überwacht und geprüft.</p><p class=\"paragraph\"> Dieses Team besteht aus IT-Experten, die regelmäßig an Fachkonferenzen teilnehmen und sich in ihrem Bereich fortbilden.</p>",
          "title": "Überwachung durch das Informationssicherheitsteam"
        },
        "support": {
          "text": "Das Noda-Supportteam, das rund um die Uhr erreichbar ist, löst schnell Verbindungsprobleme für bestimmte Kunden und sammelt auch Vorschläge zur Verbesserung der Noda-Systeme. Wir sind immer da und bereit zu helfen.",
          "title": "24/7 Tech Support Team"
        },
        "text": "Die Strategie von Noda für den Aufbau eines Informationssicherheitsprogramms umfasst einen doppelten Ansatz. Erstens konzentrieren wir uns auf eine robuste Sicherheit für unsere eigenen Systeme und Server. Zum anderen implementieren wir einen mehrschichtigen Sicherheitsansatz, um sowohl für Ihre Daten als auch für die Daten Ihrer Kunden ein Höchstmaß an Sicherheit zu gewährleisten. Nachstehend finden Sie die wichtigsten Merkmale unseres Sicherheitsprogramms.",
        "title": "Noda Sicherheit"
      }
    },
    "tabs": {
      "banner": {
        "account-balances": "Kontostände",
        "account-number": "Kontonummer",
        "full-name": "Vollständiger Name",
        "identity-information": "Informationen zur Identität",
        "text": "Mit dem Einverständnis des Kunden kann Noda auf die folgenden Daten zugreifen und sie in seinen Algorithmen verwenden:",
        "title": "Arten von Daten, die Ihre Kunden mit Noda teilen können",
        "transaction-history": "Transaktionsverlauf für 90 Tage"
      },
      "tab-step-text": {
        "after-the-confirmation": "Nach der Bestätigung erhält Noda die Kontonummer des Nutzers sowie den Betrag und die Währung der Zahlung.",
        "after-the-consent": "Nach der Zustimmung kann Noda auf ihr Finanzkonto und einige ihrer Finanzdaten zugreifen.",
        "consequently-this-data": "Folglich können diese Daten als Eingabewerte für die internen Algorithmen von Noda verwendet und mit den Händlern geteilt werden, um zu bestätigen, dass die Zahlung erfolgreich war.",
        "consequently-this-data-form": "Folglich können diese Daten verwendet werden, um die internen Algorithmen von Noda zu verbessern. Sie können auch in aggregierter Form an Händler weitergegeben werden - zum Beispiel als Scoring-Wert, der anzeigt, welcher Zahlungskategorie ein Nutzer zuzuordnen ist (von 1 bis 5).",
        "the-buyer-initiates": "Der Käufer veranlasst die Zahlung und schließt die Authentifizierung durch die von ihm gewählte Bank ab.",
        "when-the-authentication": "Wenn die Authentifizierung durch die Bank abgeschlossen ist, fordert die Bank eine Transaktionsbestätigung an.",
        "when-the-authentication-consent": "Wenn die Authentifizierung durch die Bank abgeschlossen ist, bittet die Bank sie um ihre Zustimmung, dass Noda auf ihre Finanz- und Profildaten zugreifen darf."
      },
      "tab-title": {
        "automated-access": "Automatisierter Zugriff auf die IBAN eines Benutzers durch Autorisierung direkt durch die Bank",
        "insert-iban": "IBAN für manuelle Zahlung einfügen"
      },
      "tag-subtitle": "TECHNIK FREUNDLICH",
      "text": "Bei Noda kümmern wir uns um Ihre Kunden und verarbeiten ihre Daten mit größter Sorgfalt. So geschieht es, wenn Ihre Kunden eine Zahlung tätigen oder über unsere Dienste einsteigen.",
      "title": "Noda verwaltet<br/>die Daten Ihrer Kunden"
    },
    "terms": {
      "last-update": "Zuletzt aktualisiert am <data>23. August 2024</data>",
      "section-1": {
        "text-1": "Diese Nutzungsbedingungen bilden einen rechtsverbindlichen Vertrag zwischen den Nutzern („Sie“, „Nutzer“, „Kunde“) und Noda. Wir empfehlen Ihnen daher, das Dokument sorgfältig zu lesen. Diese Nutzungsbedingungen in Verbindung mit der Datenschutzerklärung stellen den gesamten Vertrag (im Folgenden die „Vereinbarung“) zwischen Ihnen und Noda dar. Alle nachfolgend beschriebenen Dienstleistungen sind die von Noda angebotenen Dienstleistungen und werden gemeinsam als „Dienst“ bezeichnet. Mit der Nutzung des Dienstes erkennen Sie die Bedingungen in diesem Vertrag an und erklären sich damit einverstanden. Diese Nutzungsbedingungen sind jederzeit auf unserer Website <a href=\"https://noda.live\">https://noda.live.</a> zugänglich.",
        "text-2": "Noda räumt Ihnen eine eingeschränkte, widerrufliche, nicht exklusive und nicht übertragbare Lizenz für den Zugriff auf den Dienst und dessen Nutzung für Ihren eigenen, individuellen Gebrauch ein. Dies unterliegt den anderen Bedingungen dieser Nutzungsbedingungen. Sämtliche hier nicht ausdrücklich gewährten Rechte, Titel und Interessen an dem Service bleiben Noda vorbehalten.",
        "text-3": "Die Vereinbarung wird auf unbestimmte Zeit geschlossen.",
        "text-4": "Wir behalten uns das Recht vor, gelegentlich Änderungen und Anpassungen an den Nutzungsbedingungen vorzunehmen. Falls Sie mit einer der Bestimmungen dieser Vereinbarung nicht einverstanden sind, raten wir Ihnen, die Nutzung des Dienstes einzustellen und diese Nutzungsbedingungen kostenlos zu kündigen.",
        "text-5": "Diese Nutzungsbedingungen wurden in englischer Sprache verfasst, und die Hauptkommunikation erfolgt in der Regel in englischer Sprache.",
        "text-6": "Während der Laufzeit dieses Vertrages haben Sie jederzeit das Recht, diese Nutzungsbedingungen auf Verlangen ausgehändigt zu bekommen.",
        "title": "1. Die Vereinbarung"
      },
      "section-2": {
        "list-1": {
          "item-1": "eine Referenz, mit der Sie jede Zahlungstransaktion und ggf. den Zahlungsempfänger identifizieren können;",
          "item-2": "den Betrag des Zahlungsvorgangs in der Währung, in der Ihr Zahlungskonto belastet wird bzw. in der Währung, die für den Zahlungsauftrag verwendet wird;",
          "item-3": "gegebenenfalls den Wechselkurs, der für den Zahlungsvorgang verwendet wurde, und den Betrag des Zahlungsvorgangs nach dieser Währungsumrechnung;",
          "item-4": "das Wertstellungsdatum der Abbuchung oder das Datum des Eingangs des Zahlungsauftrags."
        },
        "list-2": {
          "item-1": "der Dienst Ihren Anforderungen entsprechen wird;",
          "item-2": "der Dienst ununterbrochen, pünktlich, sicher oder fehlerfrei zur Verfügung stehen wird;",
          "item-3": "die Ergebnisse, die aus der Nutzung des Dienstes erzielt werden können, genau oder zuverlässig sind;",
          "item-4": "die Qualität von Produkten, Dienstleistungen, Informationen oder anderen Materialien, die Sie über den Service gekauft oder erhalten haben, Ihren Erwartungen entspricht; oder",
          "item-5": "dass mögliche Fehler in der Technologie korrigiert werden."
        },
        "text-1": {
          "line-1": "In diesem Vertrag zwischen Ihnen und uns fungiert Noda als Zahlungsauslösedienstleister („PISP“, Payment Initiation Service Provider) und Kontoinformationsdienstleister („AISP“, Account Information Service Provider) und wir stellen Ihnen Zahlungsauslösedienste („PIS“, Payment Initiation Services) und Kontoinformationsdienste („AIS“, Account Information Services) zur Verfügung. Das bedeutet vor allem, dass wir den Zahlungsvorgang für Sie erleichtern, indem wir nach Ihrer ausdrücklichen Zustimmung eine Transaktion direkt von Ihrem(n) verknüpften Zahlungskonto(en) an den ausgewählten Begünstigten veranlassen und Ihnen Informationen zu Ihrem(n) verknüpften Zahlungskonto(en) zur Verfügung stellen.",
          "line-2": "Nachdem Sie einen Anbieter für ein Zahlungskonto oder ein Bankkonto (beide im Folgenden als „Partner“ bezeichnet) ausgewählt haben, den Sie verlinken und/oder von dem Sie eine Zahlung vornehmen möchten, werden Sie auf dessen offizielle Seite weitergeleitet (entweder in der App oder in einem Browser), auf der Sie sich einer Verifizierung unterziehen müssen.",
          "line-3": "Als AISP geben wir Ihnen die Möglichkeit, Informationen über alle Ihre Online-Banking-Konten an einem Ort abzurufen und zu betrachten sowie Ihre Finanzdaten zu analysieren. So können Sie Ihre Ausgaben, Ersparnisse und Kredite effizienter nutzen und Ihre Geldströme besser verfolgen.",
          "line-4": "Noda stellt keine Bank- oder Zahlungskontodienste zur Verfügung. Ihr gewählter Anbieter für ein Zahlungskonto ist somit ausschließlich für die Ausführung von Zahlungen und etwaige Mängel in der Funktionalität seiner Dienste verantwortlich. Wenn wir jedoch der Ansicht sind, dass uns Genehmigungen fehlen oder die Bereitstellung unserer Dienste für Sie aus sonstigen Gründen ungesetzlich wäre, können wir beschließen, Ihnen den Dienst nicht zur Verfügung zu stellen.",
          "line-5": "Im Rahmen dieser Vereinbarung und in dem Umfang, in dem Sie uns dies gestatten, werden wir Ihre Zahlungskontoinformationen mit anderen Diensten und Dritten Ihrer Wahl teilen. Wenn dieser Partner Zugang zu Ihren Daten erhält, übernimmt er automatisch die Verantwortung dafür und die Daten werden Gegenstand Ihrer Vereinbarung mit dem entsprechenden Partner und dessen Datenschutzerklärung.",
          "line-6": "Wir haben nur dann Zugriff auf die von Ihnen verknüpften Zahlungskonten, wenn Sie Ihre Zustimmung dazu geben, und nur im Rahmen der von uns erbrachten Dienstleistung.",
          "line-7": "Sie können die folgenden Informationen verlangen, die regelmäßig, mindestens einmal im Monat, kostenlos zur Verfügung gestellt werden:"
        },
        "text-2": "Der Service wird „wie besehen“ und auf der Basis „wie verfügbar“ bereitgestellt. Wir übernehmen keine Garantie für Folgendes:",
        "text-3": "Die Zahlungsauslösung wird sofort übertragen, sobald Sie die Zahlung veranlasst haben. Nach der Autorisierung der Zahlung durch Ihre Bank können Sie diese nicht mehr stornieren. Der Geldbetrag verlässt Ihr Zahlungskonto in der Regel innerhalb von 2 (zwei) Stunden nach erfolgreicher Zahlungsauslösung, wobei dies auch mehr Zeit in Anspruch nehmen kann, je nachdem, wie lange Ihre Bank für die Ausführung des Zahlungsauftrags benötigt. Die erfolgreiche Auslösung des Zahlungsauftrags wird von uns bestätigt. Für die Ausführung des Auftrags ist jedoch Ihre Bank (nicht Noda) verantwortlich.",
        "title": "2. Unser Angebot"
      },
      "section-3": {
        "list": {
          "item-1": "Sie sind mindestens 18 Jahre alt, geschäftsfähig und berechtigt, einen Vertrag abzuschließen;",
          "item-10": "Sie dürfen den Dienst nicht zerlegen oder dekompilieren und ihn nicht für Zwecke verwenden, die nicht in dieser Vereinbarung genannt sind;",
          "item-11": "Sie dürfen den Dienst nicht zu dem Zweck nutzen, Produkte oder Dienstleistungen von Wettbewerbern zu vermitteln;",
          "item-12": "eine verbotene Nutzung führt zur sofortigen Beendigung Ihrer Lizenz für den Dienst.",
          "item-2": "Sie werden unseren Dienst nur als Einzelperson und ausschließlich für private Zwecke nutzen;",
          "item-3": "Sie werden unseren Dienst nicht für betrügerische Zwecke nutzen;",
          "item-4": "Sie werden unsere Dienste nicht für andere ungesetzliche Zwecke nutzen;",
          "item-5": "Sie erklären sich mit unserer <a href=\"https://noda.live/about/legal-privacy/policy\">Datenschutzerklärung</a> einverstanden;",
          "item-6": "Sie sind für die sichere Aufbewahrung Ihrer Anmeldedaten verantwortlich;",
          "item-7": "Sie sind nicht befugt, Ihre Anmeldeinformationen an Dritte weiterzugeben. Im Rahmen des geltenden Rechts sind Sie für alle Aufwendungen und angemessenen Anwaltskosten haftbar, die dadurch entstehen, dass Sie es versäumen, Ihre Anmeldedaten zu schützen und/oder Noda unverzüglich über die unbefugte Nutzung Ihres Zahlungskontos oder eines anderen Kontos oder die Kompromittierung Ihrer Zahlungskontodaten (oder eines anderen Kontos) oder Ihres Passworts zu informieren;",
          "item-8": "Sie werden keine falsche oder gestohlene Identität verwenden. Sie bestätigen und garantieren, dass alle Informationen, die Sie uns im Rahmen dieser Vereinbarung zur Verfügung stellen, wahrheitsgemäß und korrekt sind;",
          "item-9": "Sie dürfen die Rechte zur Nutzung des Dienstes nicht weiterverkaufen oder anderweitig übertragen;"
        },
        "text-1": "Mit der Nutzung der von uns angebotenen Dienste erklären Sie sich mit folgenden Bedingungen einverstanden:",
        "text-2": {
          "line-1": "Für den Fall, dass Sie Kenntnis von einem Verlust, einem Diebstahl, einer Unterschlagung oder einer unbefugten Nutzung unseres Dienstes oder eines Teils davon, von einem Betrug durch falsche Identität, einer nicht autorisierten oder nicht korrekt eingeleiteten oder ausgeführten Zahlungstransaktion oder einer autorisierten Überweisung infolge einer fehlerhaften Anwendung des Verifizierungsdienstes zum Abgleich von Namen und eindeutiger Kennung erhalten, nehmen Sie bitte so schnell wie möglich, spätestens jedoch innerhalb von 5 Werktagen, Kontakt mit uns auf. Dies können Sie unter <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> tun. Erwägen Sie bitte auch, die Polizei zu benachrichtigen, vor allem im Zusammenhang mit Betrug und anderen Transaktionen, die ohne Ihre Zustimmung in Ihrem Namen durchgeführt wurden. Bei solchen Vorfällen sind Sie auch dafür verantwortlich, Maßnahmen zu ergreifen, um Ihre Daten zu schützen.",
          "line-2": "Falls Sie uns eine nicht autorisierte oder falsch ausgeführte Transaktion nicht melden, sind Sie möglicherweise nicht zu einer Entschädigung für eine solche nicht autorisierte oder falsch ausgeführte Transaktion berechtigt.",
          "line-3": "Für den Fall, dass wir der Ansicht sind, dass ein tatsächlicher oder vermuteter Betrug oder eine ernsthafte Sicherheitsbedrohung vorliegt, kontaktieren wir Sie über die von Ihnen bei der Nutzung unseres Dienstes angegebenen Kontaktinformationen."
        },
        "title": "3. Zugriff auf den Dienst und Mitteilung über verdächtige Aktivitäten"
      },
      "section-4": {
        "text": {
          "line-1": "Um den Dienst in vollem Umfang nutzen zu können, müssen Sie die Banken oder andere Anbieter von Zahlungskonten auswählen, mit denen Sie eine Verbindung herstellen oder von denen Sie uns ermächtigen möchten, Zahlungen durchzuführen. Nachdem Sie einen Partner ausgewählt haben, leiten wir Sie auf dessen Webseite weiter, wo Sie durch einen sicheren Prozess geführt werden, um auf die Informationen Ihrer Zahlungskonten zuzugreifen (hier und an anderer Stelle in dieser Vereinbarung bezieht sich der Begriff „Zahlungskonto“ auf ein bei einem Partner eingerichtetes Konto). Dabei werden Sie um Ihre ausdrückliche Zustimmung gebeten, um uns den Zugriff auf Ihre Finanzdaten zu ermöglichen.",
          "line-2": "Für den Zugang zu unserem Dienst sollten Sie uns die in der Datenschutzerklärung genannten Informationen zur Verfügung stellen. Als eindeutige Kennung, mit der sichergestellt wird, dass ein Zahlungsauftrag ordnungsgemäß ausgelöst und ausgeführt wird, wird je nach Einzelfall Ihre E-Mail-Adresse oder IBAN oder Zahlungs-ID oder Kunden-ID oder Zahlungsreferenz verwendet. Sollten Sie uns eine falsche oder nicht korrekte Kennung übermitteln, können wir die Rückforderung der Gelder aus dem entsprechenden Zahlungsvorgang in Rechnung stellen.",
          "line-3": "Sie erklären sich damit einverstanden, dass Sie Noda eine nicht-exklusive, gebührenfreie Lizenz zur Nutzung der Informationen in Ihren Zahlungskonten für alle Zwecke erteilen, die in Verbindung mit dem Dienst stehen oder auf die in dieser Vereinbarung Bezug genommen wird. Dies beinhaltet das Recht, diese Informationen zu nutzen, zu modifizieren, anzuzeigen, zu verteilen und neues Material zu erstellen, das diese Informationen verwendet oder einbezieht, um Ihnen den Dienst zur Verfügung zu stellen. Wir sichern Ihnen zu, dass wir Ihre Daten nicht für andere Zwecke verwenden oder darauf zugreifen werden, es sei denn, dies ist gesetzlich vorgeschrieben. Zum Schutz Ihrer Daten und um Ihre Zustimmung stets auf dem neuesten Stand zu halten, werden wir Sie möglicherweise in regelmäßigen Abständen bitten, Ihre Einverständniserklärung zu erneuern.",
          "line-4": "Sie erklären sich damit einverstanden, dass wir, sofern wir Ihre Informationen in Bezug auf Ihre Zahlungskonten oder Ihre Informationen, die im Rahmen der Bereitstellung des Dienstes erforderlich sind, abrufen, als Ihr Vertreter und in Ihrem Namen und nicht im Auftrag oder im Namen eines Dritten handeln.",
          "line-5": "Mit der Nutzung des Dienstes erklären Sie, dass Sie der rechtmäßige Eigentümer der Daten auf Ihren Zahlungskonten sind und dass Sie die Befugnis haben, uns und/oder unsere Drittanbieter zu Ihrem Bevollmächtigten zu ernennen und uns eine beschränkte Vollmacht zu erteilen, in Ihrem Namen auf diese Daten zuzugreifen und sie abzurufen.",
          "line-6": "Für die Zwecke der Einhaltung unserer Vorschriften und um Ihnen den Dienst zur Verfügung zu stellen, bevollmächtigen Sie uns hiermit, direkt oder über einen Dritten Informationen und Dokumente einzuholen, diese zu überprüfen und aufzubewahren, die uns helfen, Ihre Identität und Ihre Zahlungskontoinformationen zu überprüfen. Bei der Registrierung für den Dienst und in der Folgezeit können wir Sie zur Bereitstellung und/oder Bestätigung von Informationen und Dokumenten auffordern, die es uns ermöglichen, Sie zu identifizieren."
        },
        "title": "4. Unser Zugriff auf Ihre Daten"
      },
      "section-5": {
        "list": {
          "item-1": "den sofortigen vorübergehenden oder dauerhaften Entzug Ihres Rechts auf Nutzung des Dienstes;",
          "item-2": "die Erteilung einer Warnung an Sie;",
          "item-3": "die Einleitung eines gerichtlichen Verfahrens gegen Sie zur Erstattung aller Kosten (einschließlich, aber nicht beschränkt auf angemessene Verwaltungs- und Rechtskosten), die sich aus dem Verstoß ergeben;",
          "item-4": "die Einleitung weiterer rechtlicher Schritte gegen Sie; und/oder",
          "item-5": "eine Weitergabe solcher Informationen an Strafverfolgungsbehörden zu verlangen, wenn wir dies für notwendig erachten."
        },
        "text-1": {
          "line-1": "Es steht Ihnen frei, die uns erteilte Einverständniserklärung jederzeit zu widerrufen. Kontaktieren Sie uns dazu unter <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live.</a>",
          "line-2": "Wir können nach eigenem Ermessen bewerten und feststellen, ob eine Verletzung dieser Vereinbarung durch Ihre Nutzung des Dienstes stattgefunden hat. Liegt ein solcher Verstoß vor, können wir Maßnahmen ergreifen, die wir für angemessen halten, einschließlich aller oder einiger der folgenden Maßnahmen:"
        },
        "text-2": {
          "line-1": "Die oben beschriebenen Reaktionen sind nicht beschränkt und wir sind berechtigt, jede andere Maßnahme zu ergreifen, die wir vernünftigerweise für angemessen halten und die nicht gegen das geltende Recht verstößt.",
          "line-2": "Wir haben außerdem das Recht, den Dienst jederzeit aus objektiv gerechtfertigten Gründen zu sperren, wenn die Sicherheit des Dienstes gefährdet ist oder der Verdacht auf eine unbefugte oder betrügerische Nutzung des Dienstes besteht.",
          "line-3": "Wir können Ihre Registrierung ablehnen oder eine bestehende Registrierung aus einem anderen Grund nach unserem alleinigen Ermessen löschen."
        },
        "title": "5. Kündigung und Aussetzung"
      },
      "section-6": {
        "text": {
          "line-1": "Sie erklären sich damit einverstanden, Noda und unsere verbundenen Unternehmen gegen alle Forderungen Dritter, Haftungsansprüche, Schäden, Ausgaben und Kosten (einschließlich, aber nicht beschränkt auf angemessene Anwaltskosten) zu schützen und vollständig zu entschädigen, die durch Ihre Nutzung des Dienstes, Ihren Verstoß gegen diesen Vertrag oder Ihre Verletzung oder die Verletzung von geistigem Eigentum oder anderen Rechten Dritter durch einen anderen Benutzer Ihres Kontos verursacht werden oder daraus entstehen.",
          "line-2": "Wir übernehmen keine Haftung gegenüber Ihnen für eine Nichterfüllung oder Verzögerung bei der Erfüllung einer unserer Verpflichtungen im Rahmen dieses Vertrags, wenn eine solche Nichterfüllung oder Verzögerung durch Sie oder durch ein Ereignis oder einen Umstand, der außerhalb unserer Kontrolle liegt, verursacht oder mitverursacht wurde, einschließlich der Bereitstellung eines falschen eindeutigen Identifikators.",
          "line-3": "NODA, SEINE LEITENDEN ANGESTELLTEN, DIREKTOREN, VERTRETER, TOCHTERGESELLSCHAFTEN, MITARBEITER, WERBETREIBENDEN ODER ANBIETER SIND IN KEINEM FALL HAFTBAR FÜR MITTELBARE, BEILÄUFIG ENTSTANDENE SCHÄDEN, FOLGESCHÄDEN ODER SCHADENSERSATZ MIT STRAFCHARAKTER, EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT AUF NUTZUNGSAUSFÄLLE, ENTGANGENE GEWINNE ODER DATENVERLUSTE, UNABHÄNGIG DAVON, OB ES SICH UM EINE VERTRAGSKLAGE, EINE KLAGE WEGEN UNERLAUBTER HANDLUNG (EINSCHLIESSLICH, ABER NICHT BESCHRÄNKT AUF FAHRLÄSSIGKEIT), EINE KLAGE NACH EIGENEM ERMESSEN ODER EINE ANDERWEITIGE KLAGE HANDELT, ODER FÜR SCHÄDEN, DIE INSGESAMT DEN BETRAG DER ZAHLUNG ÜBERSTEIGEN, DIE FEHLERHAFT ODER OHNE AUTORISIERUNG AUSGEFÜHRT WURDE UND ZUM VERLUST DER IM RAHMEN DER BETREFFENDEN ZAHLUNG ÜBERTRAGENEN BETRÄGE GEFÜHRT HAT.",
          "line-4": "Wir haften Ihnen gegenüber für die ordnungsgemäße Ausführung des Zahlungsvorgangs, es sei denn, wir können Ihnen und gegebenenfalls dem Zahlungsdienstleister des Zahlungsempfängers nachweisen, dass der Zahlungsdienstleister des Zahlungsempfängers den Betrag des Zahlungsvorgangs erhalten hat, und wir haben begründeten Anlass zu der Vermutung, dass Sie einen Betrug begangen haben."
        },
        "title": "6. Entschädigung und Haftung"
      },
      "section-7": {
        "text": {
          "line-1": "Bitte wenden Sie sich mit Ihren Anliegen und Beschwerden direkt an uns unter <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>, damit wir Ihnen nach besten Kräften helfen können. Für den Fall, dass Sie mit unserer Antwort oder mit dem gesamten angebotenen Dienst nicht zufrieden sind, können Sie sich mit Ihrer Beschwerde an den Financial Ombudsman Service wenden: <a target=\"_blank\" rel=\"nofollow\" href=\"https://www.financial-ombudsman.org.uk/\">https://www.financial-ombudsman.org.uk/</a>. Die für unsere Tätigkeit in Großbritannien zuständige Aufsichtsbehörde ist die Financial Conduct Authority: <a href=\"https://www.fca.org.uk/\" target=\"_blank\" rel=\"nofollow\">https://www.fca.org.uk/.",
          "line-2": "In anderen Ländern gibt es andere Aufsichtsbehörden und möglicherweise auch andere alternative Lösungen zur Streitbeilegung. Für weitere Informationen kontaktieren Sie uns bitte unter <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>.",
          "line-3": "Falls Ihre Beschwerde die Art und Weise betrifft, wie wir Ihre personenbezogenen Daten speichern oder verarbeiten, lesen Sie bitte unsere <a href=\"https://noda.live/about/legal-privacy/policy\">Datenschutzerklärung</a>."
        },
        "title": "7. Beschwerden"
      },
      "section-8": {
        "text": {
          "line-1": "Diese Vereinbarung fällt unter die Gesetze des Vereinigten Königreichs. Entscheidet ein Gericht, dass wir uns nicht auf einen Teil dieser Vereinbarung berufen können, bleibt der Rest der Vereinbarung weiterhin gültig, da jede der Bestimmungen dieser Vereinbarung separat gilt.",
          "line-2": "Sollte sich eine Bestimmung dieser Vereinbarung aus irgendeinem Grund als ungültig erweisen, so bleiben die übrigen Bestimmungen der Vereinbarung hiervon unberührt und behalten ihre volle Gültigkeit und Wirkung."
        },
        "title": "8. Allgemeine Bestimmungen"
      },
      "subtitle": "Angaben zum Unternehmen",
      "text-1": "Wir sind Naudapay Limited alias „Noda“ („Noda“, „Wir“, „Uns“, „Unser“), ein im Vereinigten Königreich unter der Firmennummer 11741664 eingetragenes Unternehmen mit Sitz in 162 Buckingham Palace Road, London, SW1W 9TR, UK. Die Website <a href=\"https://noda.live\">https://noda.live</a> und die über unsere Anwendungen und Lösungen verfügbaren Dienste betreiben wir unter unserer Marke Noda. Unser Kontaktbüro in der EU hat seinen Sitz in Spanien (Calle Huertas 11, 28012, Madrid, Spanien).",
      "text-2": "Naudapay Limited ist bei der Financial Conduct Authority im Rahmen der Payment Services Regulations 2017 für die Bereitstellung von Zahlungsdiensten registriert. Referenznummer. 832969.",
      "text-3": "Bitte zögern Sie nicht, uns bei Fragen oder Anliegen unter <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> zu kontaktieren. Außerdem erreichen Sie uns über unser Hilfe-Widget in der App.",
      "title": "Nutzungsbedin&shy;gungen"
    },
    "travel": {
      "faq": {
        "countries": {
          "content": "Wir arbeiten mit 2000+ Banken in 28 Ländern zusammen, darunter die Niederlande, Portugal, Belgien, Deutschland, Polen, Bulgarien, Frankreich, Irland, Italien, Österreich, Spanien, Dänemark, Estland, das Vereinigte Königreich, Luxemburg, Rumänien, Litauen, Ungarn, Lettland, Finnland, Schweden, Norwegen, die Tschechische Republik, die Slowakei, Griechenland und Slowenien.",
          "title": "In welchen Ländern ist Noda tätig?"
        },
        "currencies": {
          "content": "Noda unterstützt eine Vielzahl von Währungen weltweit, darunter EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON und SEK.",
          "title": "Welche Währungen unterstützt Noda?"
        },
        "easy-to-start": {
          "content": "Ja. Unser Support-Team ist da, um Ihnen bei allen Problemen zu helfen. Wir bieten eine reibungslose Integration, damit Sie schnell und einfach mit der Annahme von Zahlungen beginnen können.",
          "title": "Ist es einfach, mit Noda Online-Zahlungen zu akzeptieren?"
        },
        "how-to-integrate": {
          "content": "Zunächst sollten Sie bei Noda angemeldet sein. Füllen Sie einfach das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Wir bieten ein einfaches Onboarding mit der persönlichen Betreuung durch einen engagierten Manager. Unser Prozessor lässt sich nahtlos in API- und Front-End-Komponenten integrieren, sodass eine nahtlose Einbindung in Ihre Plattform gewährleistet ist.",
          "title": "Wie kann ich Noda in meinen Zahlungsablauf integrieren?"
        },
        "kind-of-travel-business": {
          "content": "Noda bietet Zahlungslösungen für die Reisebranche für alle Unternehmenstypen und -größen an, wobei skalierbare Pläne verfügbar sind, um Ihr Geschäftswachstum zu unterstützen.",
          "title": "Mit welchen Arten von Reiseunternehmen arbeiten Sie zusammen?"
        },
        "needs": {
          "content": "Wenn Sie Noda nutzen möchten, füllen Sie das Formular aus, und unser Vertriebsteam wird sich in Kürze mit Ihnen in Verbindung setzen. Noda bietet ein einfaches Onboarding mit der Anleitung eines engagierten Managers, um sicherzustellen, dass Sie bei jedem Schritt des Weges unterstützt werden.",
          "title": "Was brauche ich für den Anfang?"
        },
        "subtitle": "IHRE FRAGEN BEANTWORTET",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verbessern Sie Ihr Reisegeschäft. Unsere All-in-One-Zahlungsplattform legt den Schwerpunkt auf Kundenverständnis, Effizienz und Wachstum",
        "title-1": "Reisezahlung",
        "title-2": "Lösungen mit Noda:",
        "title-gradient-1": "Ihre Zahlungen",
        "title-gradient-2": "sind unsere Priorität"
      },
      "how-does-it-work": {
        "content": "Noda ist ein weltweites Reisezahlungssystem und Anbieter von Open Banking. Vom Transaktionsmanagement bis hin zu Finanzanalysen - Noda hat alles für Sie im Angebot. Unsere Plattform nutzt modernste KI- und Machine-Learning-Technologien.\n\nOpen Banking bedeutet, dass traditionelle Banken Daten mit lizenzierten Fintech-Unternehmen wie Noda teilen, um Transaktionen zu optimieren. Unser Ökosystem für den Zahlungsverkehr verbindet alle führenden Banken im Vereinigten Königreich und in der EU und ermöglicht mühelose Händlerdienste für Reisebüros.",
        "subtitle": "Technologien",
        "title": "Wie funktioniert es"
      },
      "how-to-start": {
        "content": "Noda bietet ein einfaches Onboarding mit persönlicher Betreuung durch einen engagierten Manager. Unser Team ist da, um Ihnen bei allen Problemen zu helfen. Um mit der Nutzung von Noda zu beginnen, füllen Sie einfach das Formular aus, und unsere Vertriebsmitarbeiter werden sich in Kürze mit Ihnen in Verbindung setzen.",
        "subtitle": "Einfaches Onboarding",
        "title": "Wie man anfängt"
      },
      "payments": {
        "text": "Erleben Sie die Effizienz von Soforttransaktionen, bei denen das Geld innerhalb von Minuten auf Ihrem Konto erscheint. Unsere benutzerfreundlichen und optimierten APIs bringen Ihre Produkte mühelos auf den Markt",
        "title": "Toolset für die Reisebranche"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Nutzen Sie unsere datengesteuerten Erkenntnisse. Die Tools von Noda bieten gebrauchsfertige Analysen des Kundenverhaltens, einschließlich Segmentierungs- und Prognosealgorithmen",
            "title": "KI-gestützte Analytik"
          },
          "banking": {
            "content": "Verbesserung des Kundenerlebnisses und Vereinfachung des Transaktionsflusses durch die Leistungsfähigkeit und Sicherheit von Open-Banking-Zahlungen",
            "title": "Offenes Bankwesen"
          },
          "global-currencies": {
            "content": "Noda arbeitet mit einer Vielzahl globaler Währungen, um Ihre Reiseaktivitäten auf der ganzen Welt zu unterstützen",
            "title": "Globale Währungen"
          },
          "payment-processing": {
            "content": "Optimieren Sie Ein- und Auszahlungen mit Noda. Nutzen Sie intuitive UX, intelligentes Routing und eine Vielzahl von Zahlungsmethoden",
            "title": "Zahlungsabwicklung\nfür die Reisebranche"
          },
          "scalable-plans": {
            "content": "Wir bieten Reisebranchelösungen für Unternehmen aller Größen mit skalierbaren Plänen, um Ihr Geschäftswachstum voranzutreiben",
            "title": "Skalierbare Pläne"
          },
          "security": {
            "content": "Noda bietet sichere Zahlungsgateways für Reiseveranstalter, die PCI DSS-Konformität, Verschlüsselung und Betrugsprävention gewährleisten",
            "title": "Sicherheit"
          }
        },
        "subtitle": "OFFENES BANKWESEN & ZAHLUNGEN",
        "title-1": "Top-Funktionen"
      }
    },
    "ux-approach": {
      "about-design": {
        "comments": {
          "business": {
            "name": "Valērijs Sičovs",
            "position": "Chief Business Development Officer",
            "text": "Noda ist ein führender europäischer Anbieter von Open-Banking-Lösungen und verfügt über umfangreiche Erfahrungen im Bereich verbraucherorientierter Zahlungstechnologien. Unsere Mehrwertlösungen verändern den Kurs der Zahlungsstrategien von Händlern, und wir sind uns alle einig, dass die Popularität von Open-Banking-Zahlungen in ganz Europa unbestreitbar ist.<br/>Wir haben eine hochmoderne Technologielösung, aber die enge Zusammenarbeit mit den Entwicklungs- und Designteams von Noda ermöglicht es uns, einen noch größeren Einfluss darauf zu nehmen, wie Händler von unserem gut gestalteten Benutzererlebnis und Zahlungsprozess profitieren können. Die Noda-Kasse mit all ihrer Eleganz macht selbst so eine historisch langweilige Sache wie Zahlungen zum Stand der Technik."
          },
          "compliance": {
            "name": "Lāsma Gavarāne",
            "position": "Chief Compliance Officer",
            "text": "Richtiges Design an sich ist wie ein Entwurf für Schönheit und Produktfunktionalität. Der Designansatz von Noda ist cool, denn es geht nicht nur darum, wie die Dinge aussehen, sondern wie sie nahtlos zusammenarbeiten. Es ist, als hätte man eine Superkraft, die alles mühelos und aufregend macht, und genau das wollen wir mit der Welt teilen!"
          },
          "experience": {
            "name": "Max Gulewicz",
            "position": "Chief Experience Officer",
            "text": "Zuerst dachte ich, dass großartiges Design hilft, bestimmte Probleme zu lösen; dann, dass großartiges Design auch zu 100 % den Bedürfnissen der Zielgruppe entsprechen muss; dann, dass wir auch die geschäftlichen KPIs unserer Kunden im Auge behalten müssen. Aber nach 25 Jahren intensiver Designarbeit ist mir klar geworden, dass man nicht nur lieben muss, was man tut, sondern auch ein wenig besessen sein muss, um ein großartiges Erlebnis zu gestalten, das den köstlichsten Nachgeschmack hinterlässt, vielleicht sogar etwas für das Design opfern muss, damit jemand anderes glücklich ist. Es ist unglaublich cool, sich als Schöpfer zu fühlen, aber noch besser ist es, zu verstehen und zu sehen, dass die eigenen Bemühungen nicht umsonst sind."
          },
          "hr": {
            "name": "Olga Ķerpe",
            "position": "HR Director",
            "text": "Für mich persönlich geht es bei einem großartigen Design vor allem um Ästhetik, Liebe zum Detail und Innovation. Und in unserem Noda-Design haben wir all das perfekt kombiniert. Wir arbeiten wirklich hart daran, immer den neuesten Trends zu folgen und die neuesten Tools und Funktionen zu verwenden. Ich würde auch sagen, dass diese Eigenschaften unseren Gesamtansatz widerspiegeln, und unser Team tut sein Bestes, um dies der FinTech-Welt visuell zu demonstrieren."
          },
          "project": {
            "name": "Egor Mahaniuk",
            "position": "Head of Project Management Office",
            "text": "Stellen Sie sich das vor: Noda ist wie ein schnittiger Sportwagen, der die Blicke auf sich zieht und eine aufregende Fahrt durch die digitale Landschaft bietet. Unsere Benutzerfreundlichkeit ist nicht nur intuitiv, sie ist praktisch telepathisch. Wir haben die Benutzeroberfläche so gestaltet, dass sie für Benutzer aller Erfahrungsstufen zugänglich ist. Aber warten Sie, das ist noch nicht alles! Skalierbarkeit und Flexibilität sind unser A und O. Dank unserer modularen Architektur sind Upgrades so schnell wie das Erscheinen neuer Technologien auf dem Markt, so dass wir immer auf dem neuesten Stand sind, ohne ins Schwitzen zu kommen. Die Benutzeroberfläche von Noda ist nicht einfach nur ein weiteres veraltetes Design, sondern ein Erlebnis, bei dem Sie sich fragen werden: \"Warum kann nicht alles so lustig und einfach sein\"?"
          },
          "solutions": {
            "name": "Volodymyr Mykhailin",
            "position": "Chief Solutions Officer",
            "text": "Wenn man über hochwertiges UX-Design nachdenkt, ist es wichtig, dass es auf den Verbraucher ausgerichtet ist und gleichzeitig Klarheit, Komfort und Effizienz garantiert. Noda hat diesen Grundsatz klar erkannt und setzt ihn aktiv in seinen Produkten um. Die Benutzer haben keine Probleme zu verstehen, wie das Produkt funktioniert; es entstehen keine Fragen darüber, was sie als Nächstes tun müssen und warum ein Ereignis eingetreten ist. Die Produkte sind so konzipiert, dass die Barrieren für die Interaktion zwischen Nutzern und Technologie minimiert werden. Wenn die Benutzer keine Zeit mit der Überwindung von Schnittstellenhürden oder der Suche nach benötigten Informationen verschwenden, steigen ihre Zufriedenheit und ihre Loyalität gegenüber dem Produkt. Ein solcher Designansatz verbessert nicht nur die Benutzererfahrung, sondern erhöht auch den Wettbewerbsvorteil des Unternehmens in seinem Marktsegment."
          }
        },
        "subtitle": "Teammitglieder über Design",
        "title": "Wir haben unser Team gebeten,<br/> mitzuteilen, was sie über Noda Design denken. "
      },
      "hero": {
        "subtitle": "Design-Manifest",
        "text": "Wir sind ein Team von erfahrenen Designern, Entwicklern und Forschern, die Open Banking in eine einfache, flüssige und zugängliche Möglichkeit verwandeln, Zahlungen zu tätigen und zu empfangen.",
        "title": "Kunde<br/>Erfahrung bei Noda"
      },
      "principles": {
        "ecosystem": {
          "text": "Sowohl Käufer als auch Händler müssen sich gegenseitig und dem System vertrauen. Wir haben die Mittel, um dieses Vertrauen zu verbessern.",
          "title": "Sicheres Ökosystem"
        },
        "interaction": {
          "text": "Wir glauben an die Schaffung einer Welt, in der fehlerhafte Zahlungen nicht mehr vorkommen.",
          "title": "Fehleranfällige Interaktion"
        },
        "seconds": {
          "text": "Zahlungen sind immer zu langsam, und wir sind wild entschlossen, sie schneller zu machen.",
          "title": "Sekunden Rasieren"
        },
        "solutions": {
          "text": "Die Zahlungsverkehrsbranche neigt dazu, stupide und langweilig zu sein. Wir hoffen, dass wir das ändern können.",
          "title": "Elegante Lösungen"
        },
        "subtitle": "Keller designen",
        "title": "Unsere Grundsätze"
      },
      "what-we-do": {
        "subtitle": "Und schließlich",
        "text-1": "Wir entwerfen und entwickeln eine ganze Reihe von Tools, Prozessen und Konventionen, die die nächste Generation des Zahlungsverkehrs vorantreiben werden.",
        "text-2": "Unter Verwendung agiler und forschungsorientierter Prozesse - bei gleichzeitiger Nutzung unserer umfassenden Erfahrung im E-Commerce und Zahlungsverkehr - entwickeln wir Händler-Tools, die die Reibungsverluste bei Zahlungen beseitigen.",
        "title": "Was wir tun"
      }
    },
    "wargaming": {
      "subtitle": "Fallstudie lesen",
      "text": "Wargaming, ein führender Herausgeber von Multi-Plattform-Spielen, arbeitet seit Februar 2023 mit Noda zusammen, und bietet seinen Spielern damit die Möglichkeit, Zahlungen für seine Spiele sofort und ohne Umwege zu tätigen. Mit dieser Zusammenarbeit können Spieler von Wargaming eine Vielzahl von Online-Zahlungsmethoden, darunter auch A2A-Transaktionen (Konto-zu-Konto) über die Open-Banking-Infrastruktur, nutzen.",
      "title": "Wie Wargaming mit Noda die Zahlungserfahrung verbessert"
    },
    "white-label": {
      "boost": {
        "tag-title": "IHR GESCHÄFT MIT NODA ANKURBELN",
        "text": "Unser Admin-Hub bietet eine vollständige Verfolgung aller Provisionen und gewährleistet eine transparente Berichterstattung. Überwachen Sie ganz einfach Ein- und Auszahlungen, sowohl für Händler als auch für Sie selbst. Übernehmen Sie die Kontrolle mit vollständiger Transparenz und verwalten Sie Ihr Geschäft mühelos.",
        "title": "Umfassendes Tracking & Reporting"
      },
      "hero": {
        "button": "Loslegen",
        "tag-title": "BESSERE ZAHLUNGEN",
        "text": "Nutzen Sie unsere Technologieplattform als White-Label-Partner. Integrieren Sie nahtlos Open Banking-Transaktionen, erhalten Sie verwertbare Analysen und nutzen Sie unsere intuitive Benutzeroberfläche. Wir bieten Integration über APIs, transparentes Reporting und Markenanpassung.",
        "title": "Erweitern Sie Ihr Geschäft mit Noda"
      },
      "how-it-works": {
        "a-way-to-keep": "Eine Möglichkeit, die Ausgabestrecken für Spieler zu erhalten, die langsame Banken benutzen (ohne Instant SEPA)",
        "accept-payments": "Akzeptieren Sie Zahlungen über Links oder QR-Codes, die über verschiedene Kanäle weitergegeben werden können.",
        "actionable": "Verwertbare Analysen",
        "actionable-analytics-from": "Verwertbare Analysen aus dem Transaktionsverlauf und zusätzlichen Daten, die von den Banken selbst geliefert werden",
        "ar": "AR über 90%",
        "buffet": "Buffet",
        "checkout": "Kasse",
        "dedicated": "Dedizierte und getrennte Konten für mehr Übersichtlichkeit",
        "easily-pay": "Einfaches Bezahlen und Bezahlt werden mit unserer fortschrittlichen Technologie und intelligentem Routing",
        "effortless": "Mühelose und raffinierte Zahlungserfahrung für Unternehmen aller Arten und Größen",
        "expansive": "Weitreichende Reichweite mit 2000+ Banken in 28 Ländern",
        "great": "Großartige Deckung",
        "instead-of-long": "Statt langer Formulare, die ausgefüllt werden müssen, zahlen die Nutzer die erste Einzahlung und sind sofort registriert",
        "intuitive": "Intuitive Benutzeroberfläche und umfangreiche Checkout-Funktionen",
        "know": "Datenanreicherung",
        "pay": "Bezahlen und gehen",
        "pay-by-link-qr": "Bezahlen per Link & QR",
        "payins": "Einzahlungen & Auszahlungen",
        "payment": "Zahlungsakzeptanzrate von nahezu 100 %, so dass Ihre Transaktionen immer genehmigt werden",
        "provides-players": "Bietet den Spielern die Möglichkeit, per Bank zu bezahlen, was die Konversion erhöht",
        "round-the-clock": "Unterstützung rund um die Uhr, wir sind für Sie da, wann immer Sie es brauchen",
        "segregated-accounts": "Getrennte Konten",
        "simple-payment-process": "Einfacher Zahlungsprozess",
        "support": "Unterstützung 24/7",
        "tag-title": "Wie es funktioniert",
        "title": "Integrieren Sie unsere Technologie",
        "trusted-payments": "Vertrauenswürdige Zahlungen",
        "valuable": "Wertvolle Erkenntnisse über das Finanzverhalten der Kunden, um fundierte Entscheidungen zu treffen"
      },
      "open-banking": {
        "tag-title": "DIE MACHT DES OPEN BANKING",
        "text-1": "Vor dem Open Banking kontrollierten die traditionellen Banken die Kundendaten. Die 2018 in Kraft getretene europäische PSD2-Verordnung änderte dies, indem sie von den Banken verlangte, Daten mit lizenzierten Drittanbietern wie Noda zu teilen, sofern die Kunden zustimmen.",
        "text-2": "Open Banking nutzt Anwendungsprogrammierschnittstellen (APIs), die als Softwarebrücke fungieren. Wenn ein Nutzer Open Banking auswählt, wird er zu seiner vertrauten Online-Banking-Schnittstelle weitergeleitet. Dadurch wird auch verhindert, dass Cyberkriminelle ihre Daten stehlen können.",
        "text-3": "Immer mehr Verbraucher und Händler auf der ganzen Welt entscheiden sich für diese neue Technologie. ",
        "text-4": " prognostiziert, dass der Gesamtwert der Open-Banking-Transaktionen von 57 Mrd. US-Dollar im Jahr 2023 auf 330 Mrd. US-Dollar im Jahr 2027 steigen wird. Open-Banking-Zahlungen sind nicht länger innovativ, sie werden zur neuen Norm.",
        "text-link": "Juniper Research",
        "title": "Die Einführung von Open Banking boomt"
      },
      "tailored-interface": {
        "tag-title": "MASSGESCHNEIDERTE SCHNITTSTELLE",
        "text": "Nutzen Sie unsere integrierten Anpassungswerkzeuge, um Ihre Benutzeroberflächen (UIs) zu personalisieren, oder erstellen Sie Ihr eigenes Frontend, um das Design vollständig zu kontrollieren. Mit unserer Plattform haben Sie die Wahl, das perfekte Erlebnis zu gestalten.",
        "title": "Maßgeschnei&shy;dert für Ihre Marke"
      }
    },
    "why-open-banking": {
      "benefits": {
        "section-1": {
          "cards": {
            "card-1": {
              "description": "Vor dem <a class=\"link underline\" href=\"https://noda.live/articles/what-is-open-banking-your-ultimate-guide\">Open Banking</a> hatten die traditionellen Banken ein Monopol auf die Kundendaten. Doch die europäische PSD2-Verordnung sollte dies ändern. Sie wurde 2018 in Kraft gesetzt und verpflichtete die Banken, Daten mit lizenzierten Drittanbietern zu teilen. Dies geschieht ausschließlich mit dem Einverständnis der Kunden. Die gemeinsame Nutzung von Daten förderte die Innovation im Zahlungsverkehr und machte ihn schneller, reibungsloser und sicherer.",
              "title": "Eine neue Ära des Zahlungsverkehrs"
            },
            "card-2": {
              "description": "Juniper Research prognostiziert, dass der Gesamtwert der OB-Transaktionen <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">bis 2027 330 Mrd. $ erreichen wird</a>. Das ist ein Anstieg von 57 Mrd. $ im Jahr 2023, ein Gesamtwachstum von 479 %.",
              "title": "Schnell wachsender Service"
            },
            "card-3": {
              "description": "Die Verbraucher legen Wert auf Innovation und hervorragende Zahlungsströme. Dank seiner Schnelligkeit und Einfachheit wird das offene Bankwesen für viele zur bevorzugten Wahl.",
              "title": "Innovativer"
            }
          },
          "title": "Es ist neu und wächst schnell"
        },
        "section-2": {
          "cards": {
            "card-1": {
              "description": "Open Banking bietet niedrigere Transaktionsgebühren als herkömmliche Kartenzahlungen. Die Zahlungen erfolgen von <a class=\"link underline\" href=\"https://noda.live/glossary/a2a-payments\">Konto zu Konto</a>.",
              "title": "Niedrigere Gebühren"
            },
            "card-2": {
              "description": "Durch offene Bank-APIs entfallen die Zahlungsprovisionen und der Großteil der Betriebskosten.",
              "title": "Reduzierte Kosten und Gebühren"
            },
            "card-3": {
              "description": "Da keine Kartennetze involviert sind, gibt es bei Open-Banking-Zahlungen auch keine Rückbuchungen. Die Händler können sich von den hohen Bearbeitungsgebühren verabschieden.",
              "title": "Keine Rückbuchung"
            },
            "card-4": {
              "description": "Alle Händler erhalten einheitliche Preise. Die einzige mögliche Änderung ist eine Senkung als Reaktion auf den Wettbewerbsdruck.",
              "title": "Kosten für Händler"
            }
          },
          "title": "Es ist sehr profitabel"
        },
        "section-3": {
          "cards": {
            "card-1": {
              "description": "Die Abrechnungszeiten sind kürzer, da das Geld fast sofort auf dem Konto des Händlers eingeht. Dies kann Ihnen helfen, Ihren Cashflow und Ihre Buchhaltung besser zu verwalten. Die Verbraucher können schnell und ohne lange Bearbeitungszeiten zahlen. Da die Abrechnungszeiten kürzer sind, können sie effizienter haushalten.",
              "title": "Schnellere Zahlungen"
            },
            "card-2": {
              "description": "Offene Banklösungen können Daten auf einer einzigen Plattform konsolidieren. Von Kundeneinblicken bis hin zu Verifizierungslösungen bietet sie vielfältige Geschäftswerkzeuge.",
              "title": "Effizienz"
            },
            "card-3": {
              "description": "Die Verbraucher zahlen über ihre sichere Bankschnittstelle, ohne die Kartendaten manuell eingeben zu müssen. Das spart ihnen Mühe und Zeit und führt zu einer verbesserten Kundenzufriedenheit.",
              "title": "Bessere Benutzererfahrung "
            },
            "card-4": {
              "description": "Open Banking vereinfacht die <a class=\"link underline\" href=\"https://noda.live/articles/open-banking-user-experience\">Nutzererfahrung (UX)</a> beim Bezahlen, indem es Reibungsverluste wie die manuelle Eingabe von Kartendaten aus dem Prozess eliminiert, was zu höheren Umsätzen führt.",
              "inserted-content": {
                "subtext": "*Basierend auf den Transaktionsdaten von wiederkehrenden Nutzern der Noda-Plattform im Januar 2024",
                "table": {
                  "tbody-1": {
                    "header": {
                      "col-1": "Deutschland",
                      "col-2": "Bis zu 89%"
                    }
                  },
                  "tbody-2": {
                    "header": {
                      "col-1": "Großbritannien",
                      "col-2": "Bis zu 92%"
                    }
                  },
                  "tbody-3": {
                    "header": {
                      "col-1": "Niederlande",
                      "col-2": "Bis zu 92%"
                    }
                  },
                  "thead": {
                    "col-1": "Finanzinstitut",
                    "col-2": "Annahmerate, %"
                  }
                },
                "title": "Akzeptanz von Open-Banking-Transaktionen bei wiederkehrenden Nutzern"
              },
              "show-more-btn": "Statistiken anzeigen",
              "title": "Höhere Konversionsraten"
            },
            "card-5": {
              "description": "Offene Bankdaten können genutzt werden, um die finanziellen Gewohnheiten und das Verhalten der Kunden zu analysieren. Auf der Grundlage dieser Erkenntnisse können die Händler maßgeschneiderte Angebote machen.",
              "title": "Personalisierung"
            }
          },
          "title": "Schnell und effektiv"
        },
        "section-4": {
          "cards": {
            "card-1": {
              "description": "Die gemeinsame Nutzung von Daten kann nur mit ausdrücklicher <a class=\"link underline\" href=\"https://noda.live/articles/open-banking-flow\">Zustimmung der Kunden erfolgen</a>. Wenn Verbraucher beschließen, ihre Daten nicht mehr weiterzugeben, können sie sich jederzeit vom Open Banking abmelden.",
              "title": "Kontrolle der Finanzdaten"
            },
            "card-2": {
              "description": "Open-Banking-Datenlösungen bieten eine sofortige Überprüfung der Identität, der Vermögensquellen und anderer Elemente, die Ihnen helfen können, neue Kunden schnell einzubinden.",
              "title": "Einarbeitung & KYC"
            },
            "card-3": {
              "description": "Open Banking basiert auf <a class=\"link underline\" href=\"https://noda.live/glossary/api\">sicheren APIs</a>. Die Autorisierung von Zahlungen erfolgt bei der Bank des Vertrauens des Kunden. Außerdem ist Open Banking im Rahmen der <a class=\"link underline\" href=\"https://noda.live/glossary/european-psd2\">europäischen PSD2</a> vollständig reguliert, wobei die starke Kundenauthentifizierung (SCA) eine gesetzliche Anforderung ist.",
              "title": "Bessere Sicherheit"
            }
          },
          "title": "Es ist 100% sicher"
        }
      },
      "hero": {
        "subtitle": "Die beste Entscheidung",
        "text": "Das Angebot von Open Banking als Zahlungsmethode ist keine Neuheit mehr. Wenn Sie dies nicht tun, kann Ihr Unternehmen wertvolle Kunden verlieren. Wenn Sie noch unsicher sind, lesen Sie unten über die Vorteile von Open Banking.",
        "title": "Warum Open Banking?"
      },
      "myths": {
        "description": "Wie jede neue Technologie wird auch Open Banking oft missverstanden. Diese Missverständnisse können dazu führen, dass Händler Open-Banking-Zahlungen aufgrund mangelnder Kenntnisse meiden.\n\nHier räumen wir mit gängigen Mythen auf.",
        "myth-10": {
          "content": "Wie bereits erwähnt, bevorzugen die Kunden zunehmend Open Banking gegenüber anderen Zahlungsmethoden. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.statista.com/statistics/1228771/open-banking-users-worldwide/\">Statista</a> schätzt, dass bis Ende 2024 die Zahl der Open-Banking-Nutzer weltweit 132 Millionen erreichen wird. Die schnelle Akzeptanz von Open Banking ist ein klares Zeichen für das Vertrauen der Verbraucher. OB-Zahlungen bieten eine bessere, intuitivere Benutzerfreundlichkeit, und die Verbraucher schätzen den besseren Zahlungsfluss.",
          "title": "Mythos 10. Die Kunden sind nicht an den offenen Zahlungsverkehr gewöhnt"
        },
        "myth-1": {
          "content": "Das Wort \"offen\" wird im Zusammenhang mit dem Konzept des Open Banking häufig missverstanden. Open Banking bedeutet nicht, dass Banken Kundendaten offen mit jedem teilen, der darauf zugreifen möchte. Vielmehr müssen sich Drittanbieter einer <a class=\"link underline\" href=\"https://noda.live/articles/what-are-aisp-and-pisp-in-open-banking\">strengen Lizenzierung durch</a> die nationalen Regulierungsbehörden unterziehen, wenn sie Open Banking umsetzen wollen. So müssen Anbieter im Rahmen der europäischen PSD2 entweder eine AISP- oder eine PISP-Lizenz erhalten, um auf Kundendaten zugreifen zu können.",
          "title": "Mythos 1: Offenes Banking bedeutet, dass alles \"offen\" ist"
        },
        "myth-2": {
          "content": "Open Banking wird durch sichere APIs ermöglicht, die von den Banken mit lizenzierten Drittanbietern geteilt werden. Wenn ein Kunde eine Open-Banking-Zahlung wählt, wird er automatisch zu seiner vertrauenswürdigen Bankschnittstelle weitergeleitet, wo die Zahlung autorisiert wird. Diese API-Umleitung von App zu App verhindert, dass Cyberkriminelle potenziell ihre Daten stehlen können, insbesondere im Vergleich zu Praktiken wie Screen Scrapping. Außerdem ist die starke <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://finance.ec.europa.eu/publications/strong-customer-authentication-requirement-psd2-comes-force_en\">Kundenauthentifizierung (Strong Customer Authentication, SCA)</a> im Rahmen der PSD2 eine gesetzliche Anforderung für Open-Banking-Zahlungen. SCA ist eine Multi-Faktor-Authentifizierungsmaßnahme zur Verhinderung von Betrug durch Identitätswechsel. ",
          "title": "Mythos 2: Open Banking ist nicht sicher"
        },
        "myth-3": {
          "content": "Manche Kunden gehen fälschlicherweise davon aus, dass die ganze Welt sehen kann, was mit ihren Finanzen passiert, wenn sie der gemeinsamen Nutzung von Daten zustimmen. Das ist einfach nicht wahr. Nur zugelassene Drittanbieter können auf Kundendaten zugreifen. Um eine solche Lizenz zu erhalten, müssen die Anbieter sie über eine nationale Aufsichtsbehörde wie die <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.fca.org.uk/consumers/account-information-payment-initiation-services\">FCA im Vereinigten Königreich</a>, die <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.bafin.de/EN/Aufsicht/ZahlungsdienstePSD2/ZulassungspflichtigeZahlungsdienste/ZulassungspflichtigeZahlungsdienste_node_en.html\">BaFin in Deutschland</a>, die <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://acpr.banque-france.fr/en/authorisation/banking-industry-procedures/licensing-authorisation-and-registration/payment-institution-and-account-information-service-provider\">ACPR in Frankreich</a> und andere zuständige Behörden des jeweiligen Landes einholen, um sicherzustellen, dass die Anbieter die Vorschriften einhalten und korrekt mit den Daten umgehen. Außerdem können die Kunden ihre Zustimmung jederzeit widerrufen. ",
          "title": "Mythos 3. Missverständnisse beim Datenaustausch"
        },
        "myth-4": {
          "content": "Es besteht der Irrglaube, dass Open-Banking-Zahlungen nur für Konten bei großen Banken funktionieren. In Wirklichkeit ist das Open-Banking-Ökosystem groß und umfasst auch viele kleinere Finanzinstitute. Laut <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbankingtracker.com/\">Open Banking Tracker</a> gibt es 4.394 angeschlossene Banken in 73 Ländern. Wir bei Noda <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://coda.io/d/Noda-Supported-banks_dIVjZri07ne\">sind mit über 2000+ Banken</a> in Großbritannien und der EU verbunden.",
          "title": "Mythos 4: Open Banking unterstützt kleinere Banken nicht"
        },
        "myth-5": {
          "content": "Einige Händler könnten annehmen, dass die Option \"Zahlung per Bank\" Verbraucher abschrecken könnte, die lieber mit Karte zahlen. In Wirklichkeit sind OB-Zahlungen viel einfacher und sicherer, da die Kunden ihre Kartendaten nicht manuell eingeben müssen. Das Geld wird von demselben Bankkonto überwiesen, das auch mit der Karte verknüpft ist, aber die Überweisung umgeht das Kartennetz, was zu einer schnelleren Bearbeitung und niedrigeren Provisionen führt. Aus diesem Grund ziehen die Kunden Open Banking zunehmend den Karten vor. Im Vereinigten Königreich beispielsweise sind <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbanking.org.uk/news/open-banking-impact-report-october-2023/\">11 % der Verbraucher</a> aktive Nutzer dieser Zahlungsmethode. ",
          "title": "Mythos 5: Kunden, die mit Karte zahlen, werden durch Open Banking abgeschreckt"
        },
        "myth-6": {
          "content": "Konversionen sind die Schlüsselkennzahlen für Zahlungen. Deshalb ist es wichtig, sie richtig zu machen. Es ist ein Mythos, dass Kartenzahlungen zu erfolgreicheren Transaktionen führen als Open-Banking-Zahlungen. In Wahrheit ist die <a class=\"link underline\" href=\"https://noda.live/articles/open-banking-user-experience\">UX für Open Banking viel einfacher</a>. Die Nutzer werden auf die Schnittstelle ihrer Bank weitergeleitet, und das Geld wird direkt von ihrem Bankkonto überwiesen. Dadurch wird das Risiko vermieden, dass Kartendaten falsch eingegeben werden, und die Kunden sparen Zeit und Mühe, was zu höheren Umsätzen führt.",
          "title": "Mythos 6: Die Umsätze bei Kartenzahlungen sind höher als beim Open Banking"
        },
        "myth-7": {
          "content": "Auch dies ist ein Irrglaube. Wie bereits erwähnt, ist bei Open-Banking-Zahlungen keine manuelle Eingabe von Informationen erforderlich. Die Kunden <a class=\"link underline\" href=\"https://noda.live/articles/open-banking-user-experience\">werden zu ihrer Bankschnittstelle weitergeleitet</a>, wo die Zahlungen autorisiert werden. Die Authentifizierung kann die Eingabe eines Passcodes, eine biometrische Verifizierung, wie z. B. einen Fingerabdruck-Scan oder eine Gesichtserkennung, und einen an das Gerät gesendeten Code umfassen. Dieser Weg ist viel einfacher und weniger zeitaufwändig als die Eingabe langwieriger Kartendaten.",
          "title": "Mythos 7: Für Open-Banking-Zahlungen sind mehr Zahlungsdetails erforderlich"
        },
        "myth-8": {
          "content": "Einige Händler denken vielleicht, dass die Integration voller Reibungsverluste ist und die Transaktion letztlich scheitert, selbst wenn ein Kunde seine Bank in der Liste findet. Wir können Ihnen versichern, dass die Integration von Open Banking APIs nahtlos funktioniert, da <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.stet.eu/en/psd2/\">diese APIs in allen PSD2-Ländern</a> und Banken standardisiert sind. Sehen Sie selbst, wie es funktioniert, mit <a class=\"link underline\" rel=\"nofollow\" href=\"https://noda.live/demo\">Nodas Demo</a> einer Open-Banking-Transaktion.",
          "title": "Mythos 8: Die Integration mit der Bank des Kunden wird scheitern"
        },
        "myth-9": {
          "content": "Einige Händler denken vielleicht, dass die Abwicklung von Open-Banking-Zahlungen langsamer ist. In Wirklichkeit sind bei Kartenzahlungen Zwischenhändler beteiligt, die eine längere Bearbeitungszeit verursachen. Open-Banking-Zahlungen erfolgen von <a class=\"link underline\" href=\"https://noda.live/glossary/a2a-payments\">Konto zu Konto</a>, so dass keine Kartennetze beteiligt sind. Daher sind die Zahlungen viel schneller.",
          "title": "Mythos 9: Open-Banking-Zahlungen dauern länger"
        },
        "title": "Verbreitete Mythen\n\nüber Open Banking"
      }
    }
  },
  "en": {
    "ab-test": {
      "campaign-30": {
        "button-text-a": "Get started",
        "button-text-b": "Get started"
      }
    },
    "anti-bribery": {
      "definitions": {
        "associated-person-employees": "<b>Associated person</b> — employees, suppliers, agents, individuals, or organisations performing services on behalf of Noda.",
        "bribe-a-financial": "<b>Bribe</b> — a financial or other advantage which is an inducement for an action which is improper, illegal or a breach of trust.",
        "bribery-the-offering": "<b>Bribery</b> — the offering, promising, giving, accepting, or soliciting of a financial or other advantage as an inducement for an action which is improper, illegal or a breach of trust.",
        "title": "Definitions"
      },
      "employee-responsibilities": {
        "act-with-integrity": "act with integrity and conduct business in a fair, honest, and transparent manner;",
        "all-nodas-employees": "All Noda’s employees must:",
        "avoid-using-their": "avoid using their position within the company to promote personal interests or those of others, including family members; and",
        "comply-with-nodas": "comply with Noda’s ABC Statement;",
        "implement-appropriate-due": "implement appropriate due diligence procedures when selecting suppliers, business partners, or agents to mitigate Bribery risks and ensure their awareness of the requirements of the UK Bribery Act 2010;",
        "refuse-to-engage": "refuse to engage in business with individuals or entities that do not adhere to Noda’s principles and could potentially damage the company’s reputation;",
        "report-any-instances": "report any instances to Noda’s Legal Department if offered a financial or other advantage that may constitute a Bribe, or if they suspect they have received hospitality or a gift outside the norm;",
        "report-to-noda": "report to Noda’s Legal Department any instances where a colleague has received a financial or other advantage that hasn’t been reported as mandated by the ABC Statement;",
        "title": "Employee Responsibilities",
        "uphold-nodas-principles": "uphold Noda’s principles even in challenging situations."
      },
      "key-prohibitions": {
        "bribing-a-public": "2. Bribing a Public Official in any country is expressly prohibited. This includes: ",
        "engaging-in-bribery": "1. Engaging in Bribery, whether directly or through a third party, is explicitly prohibited in any country. Bribery is defined as:",
        "facilitation-payments-are": "3. Facilitation payments are prohibited except in cases where there is a genuine risk to life or wellbeing.",
        "in-order-to": "in order to win or retain business or any other business advantage.",
        "offering-promising": "offering, promising, or giving, requesting, seeking, or accepting anything of value, or any other advantage;",
        "offering-promising-or": "offering, promising, or giving anything of value, or other advantage;",
        "political-donations-and": "4. Political donations and lobbying are prohibited.",
        "the-key-areas": "The key areas outlined in our ABC Statement include:",
        "title": "Key Prohibitions and Requirements",
        "to-improperly-influence": "to improperly influence a business decision or any other act, inaction, or decision by any person.",
        "to-influence-a": "to influence a Public Official in their role;"
      },
      "last-update-at": "Last Updated on June 1, 2024",
      "noda-is-dedicated": "Noda is dedicated to preventing bribery and corruption and adopts a zero-tolerance stance towards any actions that may contravene pertinent anti-bribery and corruption laws, both in the UK and internationally. This commitment encompasses adherence to legislation such as the UK Bribery Act 2010 and relevant laws in other jurisdictions where we conduct business operations.",
      "principles": {
        "by-any-individual": "by any individual employee, agent, or other associated person or company acting on behalf of Noda;",
        "facilitation-payments-will": "6. Facilitation payments will not be accepted, even if they are considered a customary practice in certain countries.",
        "in-any-form": "in any form, including gifts or entertainment provided to the decision maker's spouse or other family members;",
        "in-order-to-gain-commercial": "in order to gain any commercial, contractual, or regulatory advantage for Noda in a manner that is unethical; or",
        "in-order-to-gain-personal": "in order to gain any personal advantage, whether monetary or otherwise, for the individual or anyone associated with them.",
        "noda-is-dedicated": "1. Noda is dedicated to conducting its operations responsibly, regardless of location or the parties involved. We prioritize ethical and transparent practices, consistently acting with integrity in all circumstances.",
        "noda-maintains-a": "2. Noda maintains a strict zero-tolerance policy toward bribery and corruption. We unequivocally refrain from offering, promising, paying, soliciting, or accepting bribes – whether directly or through a third party – as a means to acquire new business, retain current business, or gain any form of business advantage.",
        "noda-strictly-prohibits": "5. Noda strictly prohibits the offering, giving, solicitation, or acceptance of any form of Bribe, whether in the form of cash or otherwise:",
        "noda-will-not": "7. Noda will not make any direct or indirect contributions to any political parties.",
        "title": "Anti-Bribery & Corruption Principles",
        "to-or-from-any": "to or from any individual or entity, regardless of whether they are a Public Official or Public Body, a private individual or company, and regardless of their location;",
        "under-the-law": "4. Under the law, bribery and corrupt behaviour can be committed by various parties associated with Noda, including employees, appointed representatives, directors, individuals acting on behalf of Noda, and any individuals or organizations authorized to act on their behalf.",
        "we-mandate-that": "3. We mandate that all employees and Associated persons fully comply with all relevant anti-bribery legislation, including the UK Bribery Act 2010 (Bribery Act), as well as adhere to professional regulations pertinent to our operations."
      },
      "steps-taken": {
        "accurate-records": {
          "text": "Many serious Bribery and corruption offenses have been linked to inaccurate record-keeping. It’s imperative that we uphold accurate books, records, and financial reporting within Noda. Our accounts, records, and overall financial reporting must be transparent. Any false, misleading, or inaccurate records could pose a significant risk to Noda’s reputation and integrity.",
          "title": "2. Accurate accounting and record-keeping"
        },
        "compliance-statement": "This ‘Anti-Bribery & Corruption Statement’ is made in compliance with Noda’s obligations under the UK Bribery Act 2010.",
        "internal-control": {
          "text": "Noda upholds an efficient system of internal control and transaction monitoring. After identifying and highlighting Bribery and corruption risks through the risk assessment process, procedures are developed within a comprehensive control and monitoring program to continuously mitigate these risks.",
          "title": "3. Effective monitoring and internal control"
        },
        "noda-implements": "Noda implements the following measures to help prevent Bribery and corruption:",
        "risk-assessment": {
          "text": "Effective risk assessment is fundamental to the success or failure of our ABC Statement. Identifying risks enables us to pinpoint specific areas where we may encounter Bribery and corruption risks. This allows for better evaluation and mitigation of these risks, thereby safeguarding Noda.",
          "title": "1. Risk assessment"
        },
        "title": "Steps Taken to Prevent Bribery or Corruption"
      },
      "subtitle": "Intention of the Statement",
      "the-anti-bribery": "The Anti-Bribery and Corruption Statement (‘ABC Statement’) delineates comprehensive guidelines on preventing bribery and reporting concerns and suspicious activities.",
      "title": "Anti-Bribery & Corruption Statement"
    },
    "articles": {
      "back-to-articles": "Back to Articles",
      "case-info": {
        "payer-location": "Payer Location",
        "product-used": "Product used"
      },
      "defaultBanner": {
        "buttonText": "Book a Demo",
        "text": "Offer your users a simpler, low-cost way to pay and boost conversions!",
        "title": "Learn More About Open Banking with Noda"
      },
      "defaultBannerHero": {
        "buttonText": "Book a Demo",
        "text": "Add 2000+ banks for instant Payins & Payouts and scale globally with ease!",
        "title": "Accept Online Payments with Noda"
      },
      "main": {
        "banner": {
          "button": "Start Using Noda",
          "text": "Our Products Make the Payments Experience Easier, Faster and More Accessible",
          "title": "Reliable Payment Solution for Your Business"
        },
        "title": "Articles"
      },
      "single-article": {
        "tables-banner": {
          "button": "Try Noda",
          "title": "Try Noda — an Ultimately New Way to Accept Payments Online"
        }
      }
    },
    "bank-payouts": {
      "control-data": {
        "items": {
          "item-1": {
            "text-1": "Noda works closely with merchants and banks to understand industry-specific complexities with both C2B and B2C cash flows. This enables us to deliver a comprehensive solution tailored to meet your business needs",
            "title-1": "Understanding industry challenges"
          },
          "item-2": {
            "text-2": "With a wealth of open-banking experience in the EU and UK, Noda creates top-tier bank payout solutions customised to the unique needs of your customers",
            "title-2": "Banking expertise"
          }
        },
        "text": "Make failsafe payments with Noda. Pay your partners, suppliers, and marketplace users with ease, leveraging our advanced technology and expertise",
        "title": "Full Control of Your B2C Payouts"
      },
      "netting-data": {
        "items": {
          "text-1": "Balance netting ensures smooth transfer of funds without delays, and helps to maintain a healthy cash flow for your business",
          "text-2": "Use the existing balance to pay out funds, eliminating the need for additional bank transfers and extra costs",
          "title-1": "Avoid cash gaps",
          "title-2": "Cost-efficiency"
        },
        "subtitle": "Balance Netting",
        "text": "Manage your pay-in balance seamlessly using the funds to pay out. Harness this cost-efficient payout method and the instant availability of the funds",
        "title": "Use Your Pay-In Balance to Make Payouts"
      },
      "payments-data": {
        "balance": "Current Balance",
        "text": "Fast and convenient bank-based payouts for merchants",
        "title": "Bank Payouts",
        "title-colored": "for Swift Transactions"
      },
      "recipient-data": {
        "subtitle": "Satisfying experience",
        "text": "Noda’s bank payout options offer free receipt of funds for individuals, unlike some card and wallet systems that may charge fees for the same service. This advantage is due to the banks’ obligation to provide bank-to-bank transfers free for their customers",
        "title": "Free for Recipient"
      },
      "routing-data": {
        "items": {
          "item-1": {
            "text-1": "With Noda’s efficient routing your funds will reach their destination at lightning speed",
            "title-1": "Swift funds delivery"
          },
          "item-2": {
            "text-2": "Minimise additional bank transfers and the associated fees with our advanced payout routing",
            "title-2": "Reduced costs"
          }
        },
        "text": "We optimise your funds delivery to guarantee maximum speed and cost-efficiency while avoiding inefficient banking routes",
        "title": "Routing"
      },
      "single-report-data": {
        "subtitle": "Money at the speed of light",
        "text": "Forget about delayed payments. We are using FPS and SEPA immediate payment schemes to transfer money to your payees in real-time",
        "title": "Instant Funds Delivery"
      },
      "title": "Effortlessly pay suppliers, wallet holders, streamers, and others. Noda’s business-to-client (B2C) bank payouts simplify mass payments to individuals, ensuring swift and easy transactions"
    },
    "bank-sign": {
      "hero": "Your clients can sign into your website or app with ease using their bank account. Our cutting-edge technology utilises crucial bank information, providing a seamless and secure sign-in experience for your customers",
      "payments-data": {
        "text": "Secure, one-click sign-in with bank credentials",
        "title": "Sign In Via Bank"
      },
      "payouts-data": {
        "items": {
          "item-1": {
            "text-1": "By choosing to sign via bank account, your customers grant consent for Noda to access their data. This ensures that the information you receive upon login is trusted and verified, providing extra transparency",
            "title-1": "Most reliable data"
          },
          "item-2": {
            "text-2": "When using their bank details to sign-in, your customers interact with the familiar interface of their trusted banking app or website.This eliminates the risk of customer loss due to registration difficulties",
            "title-2": "Intuitive UX"
          }
        },
        "text": "Your customers consent to connect via their bank app or web interface. Our integrations adhere to the highest banking standards for security and compliance",
        "title": "Fast & Reliable"
      },
      "recipient-data": {
        "subtitle": "Advanced customer acquisition",
        "text": "Seamless sign-in and initial payment convert users into customers within just a few clicks. No need for manual data entry - all required information and payment authorisation will be obtained securely as customers grant respective consent",
        "title": "Pay & Go"
      },
      "risk-data": {
        "items": {
          "item-1": {
            "text-1": "Safeguarding funds is a challenging task, and the banking industry is renowned for its strict security standards. This is why the sign-in via bank feature offers your business the top-notch safety measures for customer protection",
            "title-1": "Robust security"
          },
          "item-2": {
            "text-2": "With this feature, your customer will never forget their login credentials, as their access to their money is always secured. This ensures you won't lose clients due to account login issues",
            "title-2": "Client touchpoint"
          }
        },
        "text": "The possibility of unauthorised bank account access is slim to none, due to rigorous security and further prosecution. In the unlikely case of a takeover, the customer knows of an attack instantly and reacts fast",
        "title": "Minimal Risk of Account Takeover"
      },
      "single-report-data": {
        "subtitle": "Fully adheres to regulatory standards",
        "text": "With banking data gathered through Noda, you can legally fulfil most of the monitoring, onboarding, and identification requirements and policies",
        "title": "Legislation-Compliant Data"
      },
      "title-1": "Secure",
      "title-2": "Sign-in via Bank"
    },
    "banking": {
      "banking": "Banking Experience",
      "banks-count": "2000+ banks",
      "c2b": "C2B Account",
      "easy-onboarding-1": "Easy Onboarding",
      "easy-onboarding-2": "With a Personal Manager",
      "experience": "Experience effortless transactions with our cutting-edge open banking service, connecting your business to all the major banks across the UK and EU",
      "experience-data": {
        "easy-to-apply": {
          "text": "Flexible solution for collecting funds, with the option to use our Noda C2B bank account or to select from our network of trusted banking partners",
          "title": "Easy to apply"
        },
        "enhance-customer-experience": {
          "text": "Enjoy low-cost or zero-fee collections with an abundance of options delivered through our banking network\n",
          "title": "Enhance customer experience"
        }
      },
      "features-to-integrations": "from features to integrations",
      "first-steps": "FIRST STEPS",
      "hero": "Boost your customer experience and ease your transaction&nbsp;flow with power and security of our open banking platform",
      "hero-title-1": "Open Banking",
      "hero-title-2": "with Noda",
      "how-data": {
        "authorise-the-transaction": {
          "text": "From redefining the future with innovative startups to transforming our world with iconic brands, Noda empowers thousands of businesses",
          "title": "Authorise the transaction"
        },
        "choose-your-bank": {
          "text": "Pick from a selection of major banks in your area",
          "title": "Choose your bank"
        },
        "payment-is-done": {
          "text": "Noda is the driving force behind seamless transactions for thousands of businesses, from cutting-edge startups to industry leaders",
          "title": "Payment is done"
        },
        "sign-into-your-account": {
          "text": "Noda powers thousands of high-impact businesses, from next-generation startups to bellwether brands that change the world",
          "title": "Sign into your account"
        }
      },
      "hub-data": {
        "1": {
          "text": "Easy and efficient refund processing",
          "title": "Refunds"
        },
        "2": {
          "text": "Multiple user roles for better control",
          "title": "Multi Roles"
        },
        "3": {
          "text": "Secure, fast, and efficient transactions management",
          "title": "Transactions"
        },
        "4": {
          "text": "Detailed and customizable financial reporting",
          "title": "Reporting"
        }
      },
      "hub-description": "With Noda Hub, you can effortlessly onboard, configure transactional preferences, monitor transactions and reports, and analyse payment traffic, all within a single platform",
      "info-data": {
        "subtitle": "Features and integrations",
        "text": "Enable your clients to securely authenticate and pay within your ecosystem with a seamless integration from start to finish",
        "title": "How Our Open Banking Solution Works"
      },
      "manage-everything": "Manage Everything You Need in One Place",
      "management": "Management",
      "manager-guidance": "Enjoy an effortless onboarding with Noda Hub's guidance process and receive personalised support from your dedicated manager",
      "manager-help": "Say goodbye to the hassle of self-onboarding - your personal manager is here to help with any roadblocks",
      "payments-data": {
        "text": "Fast, secure, and regulated bank transfers",
        "title": "Open Banking Payments"
      },
      "payments-feature-description": "Streamline your payments with Noda's Trusted Payments feature, which secures transactions with trusted payers before the funds even arrive",
      "special-features": "Special Features",
      "trusted-payments-1": "Trusted Payments",
      "trusted-payments-2": "to Accelerate your Checkout"
    },
    "banner": {
      "text1": "Steady growth or rapid transformation?",
      "text2": "You know it when it’s time to take your business&nbsp;up a notch.",
      "title": "Fresh take on payments – Browse all Noda products"
    },
    "block-with-screen": {
      "detailed-and-customizable": "Detailed and customizable financial reporting",
      "easy-and-efficient": "Easy and efficient refund processing",
      "multi-roles": "Multi Roles",
      "multiple-user": "Multiple user roles for better control",
      "refunds": "Refunds",
      "reporting": "Reporting",
      "reporting-v2": {
        "subtitle": "full transparency",
        "text": "With our admin hub you can track all commissions, ensuring clear and transparent reporting. Effortlessly oversee payins and payouts, gaining full visibility and managing your operations with ease.",
        "title": "Detailed Monitoring & Reporting"
      },
      "secure-fast": "Secure, fast, and efficient transactions management",
      "tagTitle": "BOOST YOUR BUSINESS WITH NODA",
      "text": "With Noda Hub, you can effortlessly onboard, configure transactional preferences, monitor transactions and reports, and analyse payment traffic, all within a single platform",
      "title": " — Manage Everything You Need in One Place",
      "transactions": "Transactions"
    },
    "card-payments": {
      "active-subscriptions-title": "Active Subscriptions",
      "available-funds": {
        "pending": "Pending: €35.00",
        "title": "Available funds"
      },
      "controls": {
        "desktop": "Desktop",
        "diff-user": "Different user",
        "uk": {
          "text-1": "UK",
          "text-2": "London"
        }
      },
      "hero-data": "Experience seamless and stress-free card payments with Noda's cutting-edge technology and smart routing",
      "hood-data": {
        "text-1": "Noda ensures that your online card payments are processed efficiently and reliably, with optimised routing based on geographical location, card type, and other factors",
        "text-2": "Amplify your revenue and conversions with Noda's meticulously crafted checkout process that reduces friction and simplifies payment collection for customers",
        "text-3": "Say goodbye to overspending on card payments - Noda's smart routing ensures you're always getting the best deal",
        "text-4": "After collecting and carefully analysing customers’ data points, Noda's AI model predicts potential risk levels in real time and blocks suspicious transactions reducing chargebacks and fraud without compromising on authorisation rates",
        "title-1": "Smart Routing",
        "title-2": "Maximise conversions",
        "title-3": "Optimise costs",
        "title-4": "Risk prediction using AI model"
      },
      "how-data": {
        "items": {
          "text-1": "Noda's powerful AI-driven risk analysis model evaluates over 50 parameters to provide smarter and safer card payment solutions, ensuring your peace of mind",
          "text-2": "After carefully analysing the payment and collecting the necessary data, Noda's AI model predicts potential risk levels in real-time",
          "text-3": "Noda's robust AI-driven risk analysis model works in tandem with our human team to evaluate over 50 parameters and provide smarter and safer card payment solutions, ensuring high transaction rates",
          "title-1": "Observation",
          "title-2": "Risk Estimation",
          "title-3": "Payment Resolution"
        }
      },
      "info-data": {
        "subtitle": "Safety first",
        "text": "Safeguard your business and customers with our AI-powered risk estimation and dynamic reaction capabilities for secure and reliable card payments",
        "title": "Risk Assessment & Response"
      },
      "key-features": {
        "text": "Elevate your card payment processing with Noda's AI-powered routing and acceptance recovery technology. Our advanced software analyses transactions, directs them to the ideal acquiring bank and improves the rate of accepted card payments",
        "title": "Smart AI Routing & Acceptance Recovery"
      },
      "monetization": {
        "subtitle": "Continuous monetization",
        "text": "Take card payments automatically at regular intervals, such as monthly or annually, without entering details every time",
        "title-1": "Full Support of ",
        "title-2": "Recurring Payments"
      },
      "payments-data": {
        "icon": "header/product-payments.svg",
        "text": "Effortless card payments for merchants",
        "title": "Card Payments"
      },
      "preference-data-1": {
        "data": {
          "items": {
            "text-1": "The payment is authorised instantly in a single communication between the servicing and emitting servers, with funds being written off the client’s account immediately. This method is faster and provides a more streamlined checkout experience, but may be more prone to fraud",
            "text-2": "The payment is authorised in the first message between the servers, and charged in the second message. The client’s money is reserved on their card and only deducted after the second communication. While this two-step payment process is more secure, it may result in longer checkout experience",
            "title-1": "Single Message",
            "title-2": "Dual Message"
          }
        },
        "subtitle": "Set up your preferences",
        "text": "Noda’s tailored card payment experience offers both single and dual-message systems to meet your business needs",
        "title": "Instant and Delayed Charges"
      },
      "preference-data-2": {
        "data": {
          "items": {
            "text-1": "Safeguard your business by tokenisation, which provides higher security and limits the risk of data breaches and fraud, while also easing customer experience",
            "text-2": "Let your customers store and manage their card details securely, simplifying future transactions without the need to re-enter their information",
            "title-1": "Tokenization",
            "title-2": "Cards management"
          }
        },
        "text": "Streamlining repetitive payments is at the forefront of Noda’s focus to smoothen transactions",
        "title": "Faster Checkout with One-Click Payments"
      },
      "refunds-data": {
        "subtitle": "Post-purchase support",
        "text": "Enhance your customers' experience with seamless refunds both through the API and the user Interface",
        "title": "Simple Refunds"
      },
      "single-report-data": {
        "subtitle": "Knowledge powered by data",
        "text": "Track and monitor payment traffic, analyse payment patterns, and generate comprehensive payment history and performance reports within a single dashboard",
        "title": "Single Reporting System"
      },
      "subscription-data": {
        "date-1": "Due 27 Sep",
        "date-2": "Due 23 Oct",
        "date-3": "Due 31 Dec",
        "title-1": "Netflix",
        "title-2": "Music Premium",
        "title-3": "Book library application"
      },
      "title-1": "for Your",
      "title-2": "Business Needs"
    },
    "card-payouts": {
      "card-payouts-title": {
        "1": "Card Payouts:",
        "2": "for Efficient Transactions"
      },
      "hero-data": "Effortlessly settle payments to suppliers, wallet holders, or streamers our simple and swift card payouts",
      "netting-data": {
        "list": {
          "1": "Streamlined settlement process",
          "2": "Lightning-fast delivery",
          "3": "AI-driven transfer routing"
        },
        "subtitle": "Balance Netting",
        "text": "Experience lightning-speed payouts to cards through our global and localised card payment routes, delivering funds to your payees in real-time",
        "title": "Instant Funds Delivery"
      },
      "payments-data": {
        "text": "Effortless card-based payouts for merchants",
        "title": "Card Payouts"
      },
      "payouts-data": {
        "items": {
          "credit": {
            "text": "With Noda's vast experience in the global card payment industry, we provide top-of-the-line card payout solutions tailored to meet your business needs",
            "title": "Payments expertise"
          },
          "group": {
            "text": "At Noda, we collaborate with merchants and card acquirers to understand industry-specific complexities within B2C and C2B cash flows",
            "title": "Understanding industry challenges"
          }
        },
        "text": "Streamline mass payouts to individuals with Noda. Pay your suppliers, marketplace users, and more with ease",
        "title": "Faster B2C Card Payouts with Noda"
      },
      "routing-data": {
        "items": {
          "airline": {
            "text": "With Noda's efficient routing your funds will reach their destination at lightning speed",
            "title": "Swift funds delivery"
          },
          "map": {
            "text": "Minimise additional bank transfers and the associated fees with our advanced payout routing",
            "title": "Reduced costs"
          }
        },
        "text": "We optimise your funds delivery to guarantee maximum speed and cost-efficiency while avoiding inefficient banking routes",
        "title": "Routing"
      },
      "transfers-data": {
        "items": {
          "approval": {
            "text": "Balance netting ensures smooth transfer of funds without delays, and helps to maintain a healthy cash flow for your business",
            "title": "Avoid cash gaps"
          },
          "wallet": {
            "text": "Use the existing balance to pay out funds, eliminating the need for additional bank transfers and extra costs",
            "title": "Cost-efficiency"
          }
        },
        "subtitle": "Avoid extra transfers",
        "text": "Manage your pay-in balance seamlessly, using the funds to pay out. Harness this cost-efficient payout method and the instant availability of the funds",
        "title": "Use Your Pay-In Balance to Make Payouts"
      }
    },
    "checkout": {
      "ai-routing": {
        "text": "Elevate your card payment processing with Noda's AI-powered routing and acceptance recovery technology. Our advanced software analyses transactions, directs them to the ideal acquiring bank and enhances the acceptance rate of card payments",
        "title": "Smart AI Routing & Acceptance Recovery"
      },
      "checkout-hero-title": {
        "colored": "Payment Checkout",
        "default": "Seamless"
      },
      "convenience": {
        "text": "Streamlining repetitive payments is a priority for Noda's, ensuring smooth transactions. Customers can store and manage their card details securely, simplifying future transactions without the need to re-enter their information",
        "title": "Faster Checkout with One-Click Payments",
        "title-1": "Convenience above all"
      },
      "experience-list": {
        "brush": {
          "text": "Personalise your payment interface to match your unique branding, colour and design",
          "title": "UI Customisation"
        },
        "task": {
          "text": "Faster and effortless checkout for online payments with clear prompts and easy-to-understand guidance",
          "title": "Intuitive UX"
        }
      },
      "hero": "Unlock the power of seamless payments with Noda Checkout's easy-to-use interface and comprehensive set of payment checkout features",
      "hood-data": {
        "amount": "Amount",
        "bank": "Bank",
        "card-issuer": "Card issuer",
        "card-type": "Card type",
        "country": "Country",
        "currency": "Currency",
        "date-time": "Date & Time",
        "geolocation": "Geolocation",
        "metadata": "Metadata",
        "store": "Store"
      },
      "how-data": {
        "observation": {
          "text": "Noda's powerful AI-driven risk analysis model evaluates over 50 parameters to provide smarter and safer card payment solutions, ensuring your peace of mind",
          "title": "Observation"
        },
        "payment-resolution": {
          "text": "Noda's robust AI-driven risk analysis model works in tandem with our human team to evaluate over 50 parameters and provide smarter and safer card payment solutions, ensuring high transaction rates",
          "title": "Payment Resolution"
        },
        "risk-estimation": {
          "text": "After carefully analysing the payment and collecting the necessary data, Noda's AI model predicts potential risk levels in real-time",
          "title": "Risk Estimation"
        }
      },
      "info-data": {
        "subtitle": "Safety first",
        "text": "Safeguard your business and customers with our AI-powered risk estimation and dynamic reaction capabilities for safe and reliable card payments",
        "title": "Risk Assessment & Response"
      },
      "localised-checkout": {
        "text": "Enable customised payment experience for your clients globally. Noda offers advanced localisation for 10 languages, compatibility across devices, and payment methods optimised for specific regions",
        "title": "Localised Checkout Globally"
      },
      "localization-list": {
        "chart": {
          "text": "Noda goes beyond mere language adaptation by tailoring payment methods and implementing the best local practices for each country",
          "title": "Fine-tuned localisation"
        },
        "mobile": {
          "text": "Enhance customer experience by optimised checkout process adaptable to any device and software",
          "title": "Cross-screen and multi-platform"
        }
      },
      "payment-methods": {
        "text": "Whether it's bank transfers, credit and debit cards, or mobile wallets, Noda has it all. With dozens of integrated payment methods, merchants can optimise their payment flows and offer customers the flexibility they need to complete their purchases",
        "title": "Unlimited Payment Methods"
      },
      "payments-data": {
        "text": "Streamlined checkout experience for customers",
        "title": "Checkout Form"
      },
      "personal-touch": {
        "text": "Noda intelligently predicts and remembers each customer's optimal payment flow, including their preferred payment method, and enabling seamless and easy purchases for clients",
        "title": "Meets the Needs of All Your Clients",
        "title-1": "Personal touch"
      },
      "refunds-data": {
        "subtitle": "Post-purchase support",
        "text": "Enhance your customers' experience with seamless refunds both through the API and the user interface",
        "title": "Seamless Refunds"
      },
      "single-report-data": {
        "subtitle": "Knowledge powered by data",
        "text": "Track and monitor payment traffic, analyse payment patterns, and generate comprehensive payment history and performance reports within a single dashboard",
        "title": "Single Reporting System"
      },
      "tailored-experience": {
        "text": "Noda's customised payment process matches the merchant's infrastructure, which leads to a more seamless and familiar payment experience for your customers",
        "title": "Tailored Payment Experience for Your Customers"
      }
    },
    "common": {
      "about": {
        "company": {
          "subtext": "Learn about our history and leadership",
          "subtitle": "Company"
        },
        "legal-privacy": {
          "subtext": "Review our legal documentation",
          "subtitle": "Legal & Privacy"
        },
        "mission": {
          "subtext": "Discover Noda's mission, vision and what makes us unique",
          "subtitle": "Who We Are"
        },
        "partnership": {
          "subtext": "Become our partner",
          "subtitle": "Partnership"
        },
        "risk-policies": {
          "subtext": "Get familiar with our risk compliance policy",
          "subtitle": "Risk and AML/CFT Policies"
        },
        "security": {
          "subtext": "Learn about Noda’s security efforts and policies",
          "subtitle": "Security & Data Handling"
        },
        "ux-approach": {
          "subtext": "Explore what UX means for Noda",
          "subtitle": "UX Approach"
        },
        "white-label": {
          "footer": "White Label Partners",
          "subtext": "Build your own payment platform with Noda",
          "title": "For White Label Partners"
        },
        "why-open-banking": {
          "subtext": "Debunk the myths about Open Banking",
          "subtitle": "Why Open Banking?"
        }
      },
      "automated-data": {
        "item-1": "Accurate: reducing the risk of error",
        "item-2": "Efficient: eliminating delays",
        "item-3": "Secure: verifying all that matters"
      },
      "automated-payouts-text": "By automating the review and validation process, Noda helps to ensure that all payouts are processed quickly, accurately, and securely, providing an effortless experience for both merchants and payees",
      "automated-payouts-title": "Automated Payouts Review & Validation",
      "banner-market": {
        "button": "Go to marketplace",
        "text": "Steady growth or rapid transformation?<br/>You know it when it’s time to take your business&nbsp;up a notch.",
        "title": "Fresh take on payments&nbsp;–<br />Browse all Noda products"
      },
      "best-conditions-v2": {
        "additional": {
          "btn": "Contact Sales Team",
          "details": {
            "option-1": "Free for the first three months for SMBs",
            "option-2": "Instant money in your account",
            "option-3": "Near-zero fraud risks",
            "option-4": "90% acceptance rate"
          },
          "offer": "To get a personalised pricing offer please contact our sales team",
          "subtitle": "Experience fast and secure payments with Noda's e-commerce plan",
          "title": "For all company types and sizes"
        },
        "btn": "no setup fees",
        "description": "Maximise your profits with affordable pricing and",
        "subtitle": "Scalable Plans to Meet Your Business Needs",
        "title": "Best conditions for every business"
      },
      "call-to-action": {
        "contact-btn": "Contact Sales",
        "contact-team-btn": "Contact Our Team",
        "contact-team-btn-2": "Contact Our Sales Team",
        "explore": "Explore the Docs",
        "get-notified": "Get Notified",
        "get-started": "Get started",
        "learn-more": "Learn More",
        "read-less": "Read less",
        "read-more": "Read more",
        "sign-up": "Sign Up in 10 Minutes",
        "start": "Start",
        "start-using-noda": "Get started",
        "try-noda": "Try Noda",
        "use-cases-btn": "Learn About Open Banking",
        "withdraw": "Withdraw to Bank Account"
      },
      "contact": {
        "all-rights": " Noda. All Rights Reserved",
        "careers": "Careers",
        "client-support": "Client Support",
        "contact-us": "Contact Us",
        "cookie": "Cookies Policy",
        "follow": "Follow Us",
        "hr": "HR Team",
        "marketing": "Marketing",
        "naudapay-limited": "NAUDAPAY LIMITED, (Company Number: 11741664) with the registered address: 162 Buckingham Palace Road, London, SW1W 9TR, UK is an authorized Payment Institution and regulated by the Financial Conduct Authority (FCA) (Reference number: 832969) under the Payment Services Directive ((EU) 2015/2366)",
        "partnership": "Partnership",
        "policy": "Privacy Policy",
        "public-relations": "Public Relations",
        "support": "Get Support",
        "terms": "Terms of Use"
      },
      "currency": {
        "subtitle": "Capabilities",
        "text": "Expand your business internationally with Noda’s offering of payments in over 100 world currencies",
        "title": "Variety of Currencies"
      },
      "developers": {
        "bank-payouts-api": "Bank Payouts API",
        "card-payments-api": "Card Payments API",
        "card-payouts-api": "Card Payouts API",
        "login-to-hub": {
          "subtitle": "Full control of all features",
          "title": "Log In To Hub"
        },
        "noda-plugins": {
          "subtitle": "Plugins for ecom platforms",
          "title": "Noda Plugins"
        },
        "ob-payments-api": "OB Payments API",
        "open-banking-demo": {
          "subtitle": "Check how Noda products work",
          "title": "Noda Demo"
        },
        "pay-and-go": "Pay & Go",
        "tech-documentation": {
          "subtitle": "Full control of all features",
          "title": "Tech Documentation"
        }
      },
      "discover-more-title": "Discover More Features",
      "discover-title": "Discover",
      "extensive-product-suite-v2": {
        "description": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "description-v2": "Discover new opportunities for your business with the Noda payment service ecosystem. Receive and send payments with ease. Boost your operations with our easy-to-use payment data services and no-code payment solutions.",
        "subtitle": "Features and Integrations",
        "title": "Extensive Product Suite"
      },
      "features": {
        "info": {
          "1": {
            "text": "Speedy and simple setup process. Automated onboarding and API key management available within Noda Hub",
            "title": "Easy Onboarding"
          },
          "2": {
            "text": "Safe, fast, and efficient transaction management",
            "title": "Secure Transactions"
          },
          "3": {
            "text": "Seamless integration with any tech stack of your choosing",
            "title": "Smooth Integration"
          },
          "4": {
            "text": "Tailored onboarding experience with your personal account manager",
            "title": "Personal Manager"
          },
          "5": {
            "text": "In-depth reporting and analytics available within Noda Hub",
            "title": "Analytics"
          },
          "6": {
            "text": "Easy and streamlined processing of refund payments",
            "title": "Refunds"
          },
          "7": {
            "text": "Effortless connectivity with leading banks across the UK & EU within the ecosystem",
            "title": "Trusted Banks"
          },
          "8": {
            "text": "Support for a variety of user roles in Noda Hub",
            "title": "Multiple Roles"
          },
          "9": {
            "text": "Customer to Business (C2B) accounts are available for merchants",
            "title": "C2B Accounts"
          },
          "10": {
            "text": "Advanced security features including global and local blacklists",
            "title": "Blacklists"
          }
        },
        "subtitle": "Learn about Noda coverage",
        "text": "Presenting the top ten features tailored for your business",
        "title": "Key Features"
      },
      "footer": {
        "features-release": "We release hundreds of features and improvements every year to help you stay ahead of industry shifts and build a strong base for your business",
        "how-to-integrate": "How to integrate",
        "lets-get-in-touch": "Let's get in touch",
        "stay-connected": "Stay Connected",
        "stay-connected-text": "Contact our team to learn more about partnership and collaboration",
        "total-balance": "Total Balance",
        "ultimate-provider": "The Ultimate Open Banking Provider"
      },
      "geo-v2": {
        "button": "View List of Supported Banks",
        "subtitle": "Locations",
        "text": "Unlock our worldwide coverage, ensuring a high acceptance ratio in every corner of the world",
        "title": "Full Geographic Coverage",
        "title-v2": "Extensive Worldwide Coverage"
      },
      "get-started": "Get started",
      "header": {
        "about": "About",
        "articles": "Articles",
        "case-studies": "Case Studies",
        "developers": "Developers",
        "events": "Events",
        "glossary": "Glossary",
        "marketplace": "Marketplace",
        "newsroom": "Newsroom",
        "other": "Other",
        "pricing": "Pricing",
        "products": "Products",
        "resources": "Resources",
        "use-cases": "Use Cases"
      },
      "hero-v2": {
        "new": "New",
        "personal-onboarding-assistant": "Personal onboarding assistant for every company"
      },
      "how-to-start": {
        "subtitle-1": "Easy Onboarding",
        "text": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our platform smoothly integrates with APIs and front-end components, ensuring seamless merging into your retail platform. To start using Noda, fill out the form below, and our sales representatives will contact you shortly. Our team is here to help with any roadblocks",
        "title-1": "How to Start"
      },
      "identification-text": "Noda provides seamless KYC procedures using its cutting-edge open banking technology, sparing your customers the hassle of submitting documents and selfies",
      "kyc-title": "High-end KYC on demand",
      "more-title": "More Features",
      "not-verified": "80% Verified",
      "offer-for-smbs": {
        "from": "From",
        "per-transaction": "per transaction",
        "title": "Free for the first 3 months for SMBs"
      },
      "payee-identification-title": "Open-banking Payee Identification",
      "personal-manager": "Your personal manager",
      "post-payment-support": "Noda offers comprehensive post-payment support focussed on collaboration and progress",
      "products": {
        "financial-data": {
          "know-your-whales": {
            "subtext": "Predictive financial insights for merchants",
            "subtext-2": "Financial insights and forecasts for merchants",
            "subtitle": "Data Enrichment"
          },
          "sign-in-via-bank": {
            "subtext": "Secure, one-click sign in with bank credentials",
            "subtitle": "Sign in via Bank"
          },
          "title": "Financial Data",
          "virtual-ibans": {
            "subtext": "Global bank transfers with a virtual IBAN",
            "subtitle": "Virtual IBANs"
          }
        },
        "noda-go": {
          "pay-and-go-hard": "Pay & Go Hard",
          "pay-and-go-light": "Pay & Go Light"
        },
        "pay-ins": {
          "card-payments": {
            "subtext": "Easy card payments processing for merchants",
            "subtitle": "Card Payments"
          },
          "checkout-form": {
            "subtext": "Streamlined checkout experience for customers",
            "subtitle": "Checkout Form"
          },
          "instant-payment-links": {
            "subtext": "Flexible payment across various media types",
            "subtitle": "Instant Payment Links"
          },
          "merchant-of-record": {
            "subtext": "All-in-one solution for handling all payments and legal liabilities",
            "subtitle": "Merchant of Record"
          },
          "no-code-payment": {
            "subtext": "Custom payment pages via AI builder",
            "subtitle": "No-code Payment Page"
          },
          "open-banking-payments": {
            "subtext": "Fast, secure, and regulated bank transfers",
            "subtitle": "Open Banking Payments"
          },
          "title": "Pay-ins"
        },
        "pay-outs": {
          "bank-payouts": {
            "subtext": "Convenient and fast bank-based payouts for merchants",
            "subtitle": "Bank Payouts"
          },
          "card-payouts": {
            "subtext": "Effortless card-based payouts for merchants",
            "subtitle": "Card Payouts"
          },
          "title": "Pay-outs"
        }
      },
      "resources": {
        "articles": "Articles",
        "glossary": "Glossary"
      },
      "subscribe": {
        "title-1": "Get latest from Noda",
        "title-2": "Stay updated with Noda by signing up for our newsletter"
      },
      "tech-friendly-v2": {
        "acceptance-rate": {
          "option-1": "Above 90%",
          "option-2": "acceptance rate"
        },
        "api-key-management": {
          "description": "Easy API key management"
        },
        "description": "Noda offers frictionless integration with its API and front-end components, ensuring smooth merging into your platform. Experience quick and efficient set-up and start offering better payment solutions to your customers in a matter of hours, not weeks.",
        "gateway": {
          "description": "Secure and reliable gateway"
        },
        "subtitle": "Tech Friendly",
        "tech-platforms-support": {
          "description": "All types of tech platforms supported"
        },
        "title": "Seamless Integration for Better Payments: Launch in Hours, Not&nbsp;Weeks"
      },
      "transaction-control": {
        "part-title-1": "Control Transactions in Our",
        "part-title-2": "Multi-Functional Dashboard",
        "text-1": "With Noda Hub, you can effortlessly onboard, configure transactional preferences, monitor transactions and reports, and analyse payment traffic, all within a single platform",
        "text-2": "Consolidated features for effortless payment management",
        "title-2": "Monitor with confidence"
      },
      "use-cases": {
        "ecommerce": {
          "subtext": "Payment gateway for e-commerce",
          "subtitle": "E-Commerce"
        },
        "educational-platforms": {
          "subtext": "Payment gateway for educational platforms",
          "subtitle": "Educational Platforms"
        },
        "marketplaces": {
          "subtext": "Payment gateway for marketplaces",
          "subtitle": "Marketplaces"
        },
        "online-gaming": {
          "subtext": "Payment gateway for online gaming",
          "subtitle": "Online Gaming"
        },
        "retail": {
          "subtext": "Payment gateway for retail",
          "subtitle": "Retail"
        },
        "saas": {
          "subtext": "Payment gateway for SaaS",
          "subtitle": "SaaS"
        },
        "travel": {
          "subtext": "Payment solutions for travel businesses",
          "subtitle": "Travel & Tourism"
        }
      },
      "verified": "100% Verified"
    },
    "company": {
      "articles": {
        "title": "Latest from Noda"
      },
      "hero": {
        "part-1": "Your Payments, ",
        "part-2": "Our Priority",
        "text": "We are Noda — a leading worldwide payment provider — we enable an ultimate new way for online merchants to accept payments online, and receive direct bank payments instantly as an alternative to cards, with no chargebacks"
      },
      "leadership": {
        "ceo": {
          "name": "Igor Loktev",
          "role": "CEO/Co-Founder",
          "text": "Igor brings over 20 years of experience in IT and finance to our team. With an MSc in Computing Science, an Executive MBA, and ongoing PhD studies in Quantum Computing, he excels in product engineering, data analysis, and systems optimization.\n\nIgor is committed to driving Noda's growth and spearheading innovation in the fintech sector.\n\nHis keen interests in sports, music, and the dynamic field of computing science also play a vital role in his professional approach."
        },
        "clo": {
          "name": "Ellina Sedleniece",
          "role": "Chief Legal Officer (CLO)",
          "text": "Ellina comes to the team with a wealth of experience, boasting 15 years in the legal field with a focus on M&A, FinTech, Venture Capital, Data Protection, Banking, and Finance.\n\nShe is committed to delivering innovative and results-driven legal solutions designed to foster business growth, mitigate risks, and safeguard the company's interests.\n\nWith a strong educational foundation from the Riga Graduate School of Law, she earned an LLM in International and European Law in 2019, followed by an LLM in Technology Law in 2020. Based in Riga, Ellina's approach combines her comprehensive legal expertise with a forward-thinking mindset to navigate the complexities of today's global and technological landscape.\n\nEllina enriches her professional expertise with diverse interests; she delights in the art of piano playing, the joys of travel, and the immersive world of reading."
        },
        "coo": {
          "name": "Anastasija Tenca",
          "role": "Chief Operations Officer (COO)",
          "text": "Anastasija is a success-driven professional, with over 10 years of experience in the realms of sales, marketing, brand management, and project management, alongside company administration and operations.\n\nShe plays a critical role in steering all operational facets of Noda, dedicating herself to the development and execution of strategic business initiatives. Her involvement at Noda extends to crafting and implementing business strategies that drive success, building robust and lasting business relationships, refining processes for maximum efficiency, and overseeing the organization's financial activities.\n\nAnastasija's multifaceted expertise and her strategic approach to business operations make her an invaluable asset to our team and a key architect of Noda's continued growth and innovation."
        },
        "cro-cco": {
          "name": "Lasma Gavarane",
          "role": "Chief Risk & Compliance Officer (CRO & CCO)/MLRO",
          "text": "Lasma brings almost a decade of experience in the FinTech industry, specializing in Risk & Compliance. Her professional journey is supported by a dual educational background, with bachelor's degrees in Business Management and Law.\n\nLasma is not only a member of the International Association of Certified Anti-Money Laundering Specialists (ACAMS) but also holds the 'Advanced Certified Anti-Money Laundering Specialist - Risk Management' certification (CAMS-RM), positioning her as an expert in the Risk & Compliance industry.\n\nHer interest extends to understand how advancements in technology, such as those in the NewGen realm, including AI, can enhance and innovate various aspects of professional environments and how it can be applied and integrated within Noda."
        },
        "cro": {
          "name": "Michael Bystrov",
          "role": "Chief Revenue Officer at Noda",
          "text": "At the forefront of Noda's revenue generation strategies, Michael Bystrov, our Chief Revenue Officer, brings an extensive 18-year background in Sales and Marketing from various international companies. His experience spans from managing Apple's regional distribution to leading ATL and BTL campaigns for esteemed brands such as Nestle, JTI, and Diageo Group.\n\nArmed with an MSc in Financial Management and an Associate degree in Marketing and Advertising, Michael has a profound grasp of market dynamics. His expertise was instrumental in preparing advertising formats for Olympic venues and in engaging with the Government Relations (GR) segment.\n\nOutside of his professional realm, Michael is an avid traveler, enhancing his global business perspective, and is dedicated to whale conservation, demonstrating his commitment to environmental causes."
        },
        "cso": {
          "name": "Volodymyr Mykhailin",
          "role": "Chief Solutions Officer",
          "text": "Volodymyr embodies a blend of academic excellence and professional expertise with a background in Computer Systems and Networks Engineering. With his extensive experience in the IT sector, he excels at integrating advanced technological solutions into our business processes, thereby enhancing both operational efficiency and client satisfaction.\n\nDedicated to advancing technological innovation, Volodymyr leads our team in developing sophisticated IT strategies and solutions that exceed the demands of the global market. His leadership ensures our company remains at the forefront of the tech industry.\n\nIn addition to his professional achievements, Volodymyr’s diverse interests, such as mountain hiking and music, foster resilience and strategic thinking, which enrich both his work and personal life."
        },
        "cto": {
          "name": "Andrei Batseka",
          "role": "Chief Technical Officer (CTO)",
          "text": "Andrei contributes a robust 13-year background in programming and development to our team, underpinned by a Bachelor’s degree in Computer Science. His expertise spans various domains, making him a versatile and skilled member of our tech department.\n\nAt Noda, Andrei is pivotal in driving key tech initiatives and innovations, bringing his deep understanding of programming to the forefront of our projects. His commitment to continuous learning and development is evident in his keen interest in machine learning and neural networks, which he actively integrates into his work.\n\nIn addition to his professional pursuits, Andrei's passion for playing various musical instruments, along with his love for swimming and cycling, reflects his dynamic and well-rounded personality. These hobbies not only enrich his life but also inspire a creative and holistic approach to his technical work."
        },
        "cxd": {
          "name": "Vladislav Golovach",
          "role": "Chief Experience Designer (CXD)",
          "text": "Vladislav brings a seasoned 20-year expertise in ergonomics and usability to Noda's team, thriving on UX projects that challenge and require deep research.\n\nHis career as an author and pioneer in UI and UX design is marked by his ability to craft interfaces that are both intuitive and elegant, transform intricate ideas into accessible systems, and distill user research into actionable improvements.\n\nBased in Padua, Italy, Vladislav combines his love for design with a passion for creating meaningful user experiences."
        },
        "strategy-advisor": {
          "name": "Lasma Kuhtarska",
          "role": "Co-Founder, Strategy Advisor",
          "text": "Lasma Kuhtarska is a distinguished professional with a rich background in finance and business development. In 2018, she conceptualized and pioneered the creation of Noda, serving as the driving force behind our innovative platform. As the Co-founder and Chief Strategy Officer, Lasma plays a key role in shaping and implementing groundbreaking strategies that foster Noda's growth.\n\nLasma obtained her education at the renowned Stockholm School of Economics and further specialized in Data Science for Business at Harvard Business School. Before co-founding Noda, she held roles in financial analysis at the Central Bank of her home country and also lent her expertise to SEB Group, a prominent banking institution operating in Sweden and the Baltic region."
        },
        "title": "Noda\nLeadership"
      },
      "noda-timeline": {
        "events": {
          "option-1": "Beta-version of our open banking payments launched live",
          "option-2": "First merchant went live",
          "option-3": "Mass distribution started",
          "option-4": "Connected overwhelming majority of the EU & UK banks",
          "option-5": "B2C payments launched",
          "option-6": "Established companies in Canada, Australia, Brazil",
          "option-7": "New services launched: AIS Data Services, AI-generated Payment Links",
          "option-8": "Acquired licenсes in Brazil and Australia, launched payments in Brazil"
        },
        "month": {
          "1": "April, 2021",
          "2": "August, 2021",
          "3": "December, 2021",
          "4": "July, 2022",
          "5": "October, 2022",
          "6": "May, 2023",
          "7": "December, 2023",
          "8": "May, 2024"
        },
        "subtitle": "Noda timeline",
        "title": "Noda Grows with Your Business"
      },
      "our-story": {
        "description1": "Noda is YOU. We try to be human before being a payment service provider. Being designed by humans for humans, we provide one of the best user experiences currently available on the market.",
        "description2": "Noda’s add-ons are full of warmth, and they are truly designed to cover all client needs in the most convenient and time-saving way. No one likes to spend ages trying to pay for goods or services online. Paying in itself is not the most pleasant of experiences. Let’s make it, at least, less time-consuming.",
        "description3": "We’d like our consumers to spend time with their friends and family, enjoying the precious moments in life, rather than, for example, spending ages planning how to transfer money for the hotel or rented car, or to settle expenses between friends in order to pay for a trip.",
        "subtitle": "Our story",
        "title": "Noda is You"
      }
    },
    "contact-form-v2": {
      "about": "About Us",
      "address": "NAUDAPAY LIMITED, Company number: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Tell us about your business, and our payment experts will help you find the perfect setup for your needs.",
      "form": {
        "btn": "Submit",
        "controls": {
          "comment": "Optional: Share your business model and payment needs. This helps us tailor your solution and speed up the setup process.",
          "company": "Company name",
          "email": "Work email",
          "first-name": "First name",
          "last-name": "Last name",
          "phone": "Work phone *",
          "select-country": "Select country",
          "website": "Product website"
        },
        "labels": {
          "business": "Tell us more about your business",
          "comment": "Business Model Description",
          "contact": "Enter Your Contact Info",
          "details": "Your contact information"
        }
      },
      "header": "Contact us",
      "modal": {
        "back": "Go back to the market",
        "description": "We will connect with you soon.",
        "explore": "Explore Noda",
        "header": "🙌 You're all set!"
      },
      "privacy": "Privacy Policy",
      "rights": "Noda. All rights reserved",
      "showcase": {
        "payment": "Select payment solutions you need",
        "recommended": "You might also be interested",
        "related": "Related solutions",
        "selected": "Your selected products"
      },
      "terms": "Terms of Use",
      "visit-website": "Visit full website"
    },
    "contact-form": {
      "about": "About Us",
      "address": "NAUDAPAY LIMITED, Company number: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Fill in the form, please",
      "form": {
        "controls": {
          "comment": "Please explain your business model. Briefly outline the scope of your project. Include the key features and functions you want Noda's platform to serve.",
          "company": "Company name",
          "company-size": "Company size",
          "country": "Country",
          "email": "Work email",
          "first-name": "First name",
          "last-name": "Last name",
          "phone": "Work phone",
          "volume": "Payments volume",
          "website": "Company website"
        },
        "labels": {
          "business": "Enter Your Business Info",
          "comment": "Business Model Description",
          "contact": "Enter Your Contact Info",
          "details": "Enter Your Details",
          "volume": "Let Us Know Your Volume"
        },
        "volume": {
          "option-1": "Less than $50,000",
          "option-2": "$50,000 to $100,000",
          "option-3": "$100,000 to $1,000,000",
          "option-4": "$1,000,000 to $10,000,000",
          "option-5": "More than $10,000,000"
        }
      },
      "header": "Contact our sales team",
      "modal": {
        "back": "Go back to the market",
        "description": "Thank you for reaching out, we will contact you shortly.",
        "header": "Submission received!"
      },
      "powered": "Powered by",
      "privacy": "Privacy Policy",
      "rights": "Noda. All rights reserved",
      "showcase": {
        "recommended": "You might also be interested",
        "selected": "Your selected products"
      },
      "terms": "Terms of Use"
    },
    "contact-us": {
      "contact-us-hero": {
        "1": "Public Relations",
        "2": "Marketing",
        "3": "Client Support",
        "4": "Careers",
        "5": "Partnership",
        "6": "Sales Team"
      },
      "contact-us-locations": {
        "london": {
          "text": "162 Buckingham Palace Road, London, SW1W 9TR, UK",
          "title": "London, UK"
        },
        "madrid": {
          "text": "Calle Huertas 11, 28012, Madrid, Spain",
          "title": "Madrid, Spain"
        },
        "ontario": {
          "text": "1907 Baseline Road, Unit 104, Ottawa, Ontario, K2COC7, Canada",
          "title": "Ontario, Canada"
        },
        "riga": {
          "text": "Riga, Pils iela 18-23, Latvija, LV-1050",
          "title": "Riga, Latvia"
        },
        "vilnius": {
          "text": "Lithuania, Vilnius, Žalgirio g.90-100, LT-09303",
          "title": "Vilnius, Lithuania"
        }
      },
      "hero-text": "Get in touch and let us know what we can help you with — Noda is always open for dialogue",
      "hero-title": "Our Locations",
      "locations-text": "Noda is a global company with a variety of locations around the world"
    },
    "cookies": {
      "last-update": "Last Updated on <data>September 13, 2024</data>",
      "section-1": {
        "list": {
          "item-1": "Necessary cookies are used to ensure the operation of the website. These cookies are used based on the legitimate interest of Noda to ensure operation of the website and provide services. The use of these cookies does not require your consent.",
          "item-2": "Preference and performance cookies help to perform certain functionalities that you wish to use while you are on our website, for example, related to using messaging and contact forms, getting registered, choosing language and using location-related functionalities. The use of these cookies does not require your consent.",
          "item-3": "Statistical cookies are used to collect and analyse information about your actions on the website and to improve its functionality. These cookies help provide information on metrics the number of visitors, bounce rate, traffic source and other related information. The use of these cookies requires consent.",
          "item-4": "Marketing, targeting or promotional cookies are used to gather information about the websites you visit and segment the visitors of the website for marketing purposes. These cookies are also used to provide visitors with relevant ads and marketing campaigns. The use of these cookies requires your consent. If you do not allow these cookies, in some cases you will experience less targeted advertising."
        },
        "text-1": "A cookie is a small piece of data (text file) that a website — when visited by a user — asks your browser to store on your device in order to remember information about you, such as your language preference or login information. Those cookies are set by us and called first-party cookies. We also use third-party cookies — which are cookies from a domain different than the domain of the website you are visiting. More specifically, we use cookies for the following purposes:",
        "text-2": "Cookies are received by Noda and its partners to ensure the operation of the website, collect and analyse your activities on the website. Cookies may collect different types of information such as the IP address, the type of device used, the browser used, the websites visited or other information.",
        "title": "1. What are Cookies?"
      },
      "section-2": {
        "title": "2. Necessary Cookies"
      },
      "section-3": {
        "title": "3. Preference and Performance Cookies"
      },
      "section-4": {
        "title": "4. Statistical Cookies"
      },
      "section-5": {
        "title": "5. Marketing, Targeting or Promotional Cookies"
      },
      "section-6": {
        "text-1": "If you want to restrict, block or delete cookies, this option is provided by changing the settings of your browser or cookie settings at our webpage. If you delete the necessary and performance cookies, the website or some of its parts will not function.",
        "text-2": "For more general information about cookies and how to manage them, please read the information at <a href=\"https://www.aboutcookies.org/\" target=\"_blank\" rel=\"nofollow\">www.aboutcookies.org</a>.",
        "title": "6. How to Restrict and Delete Cookies?"
      },
      "table": {
        "head-1": "Cookies",
        "head-2": "Purpose",
        "head-3": "Provider",
        "head-4": "Lifespan"
      },
      "text": "The website created and maintained by NaudaPay Limited (hereinafter — Noda) <a href=\"https://noda.live/\">www.noda.live</a> uses different types of cookies for multiple purposes.",
      "title": "Cookies Policy"
    },
    "demo": {
      "breadcrumbs": {
        "demo": "Noda Demo",
        "home": "Home",
        "pay-and-go": "Pay&Go",
        "payment-flow": "Payment Flow"
      },
      "payment-flow": {
        "amount-label": "Check out how Noda works by donating to charity",
        "amount-placeholder": "Your amount",
        "choose-country": "Choose your country",
        "countries": {
          "at": "Austria",
          "be": "Belgium",
          "bg": "Bulgaria",
          "br": "Brazil",
          "ca": "Canada",
          "cz": "Czechia",
          "de": "Germany",
          "dk": "Denmark",
          "ee": "Estonia",
          "es": "Spain",
          "fi": "Finland",
          "fr": "France",
          "gb": "United Kingdom",
          "gr": "Greece",
          "hu": "Hungary",
          "ie": "Ireland",
          "it": "Italy",
          "lt": "Lithuania",
          "lu": "Luxembourg",
          "lv": "Latvia",
          "nl": "Netherlands",
          "no": "Norway",
          "pl": "Poland",
          "pt": "Portugal",
          "ro": "Romania",
          "se": "Sweden",
          "si": "Slovenia"
        },
        "country-select-label": "Country",
        "donate": "Donate now",
        "funds": {
          "br": {
            "description": "Your donation will fund Plant-for-the-Planet's global efforts to restore forest ecosystems, addressing the climate crisis and protecting biodiversity.",
            "title": "Plant-for-the-Planet"
          },
          "default": {
            "description": "Your donation will fund Caritas Europa’s fight against poverty and social exclusion, promoting human development, social justice, and sustainable social systems across Europe and globally.",
            "title": "Caritas Europa"
          },
          "gb": {
            "description": "Your donation will fund the British Heart Foundation's research into heart and circulatory diseases, helping to reduce risk factors and improve heart health.",
            "title": "British Heart Foundation"
          },
          "ro": {
            "description": "Your donation will support Save a Heart Association’s mission to save lives and improve health outcomes by providing critical medical care, funding life-saving treatments, and promoting heart disease prevention and awareness in Romania and beyond.",
            "title": "Save a Heart Association"
          }
        },
        "main-title": "Try Noda Payment",
        "result": {
          "button": "Contact Sales",
          "cancel": "Go to homepage",
          "subtitle": "{fund} received your payment 🙌",
          "title": "Thank you for your donation to charity with Noda"
        }
      },
      "solutions": {
        "common": {
          "coming-soon": "Coming soon",
          "no-docs-required": "Real documents are not required for demo",
          "see-more": "See more",
          "try-demo": "Try Demo",
          "with-verification": "With Identity Verification",
          "without-verification": "Without Identity Verification"
        },
        "description": "See how Noda Products simplify payments and accelerate your revenue growth.",
        "main-title": "Explore Noda solutions",
        "pay-and-go": {
          "description": "Payment, KYC, and sign up. All-in-one.",
          "hard": "Customers will be required to undergo automatic non-doc verification via GBG. If non-doc KYC verification fails, a customer will be asked to pass full-doc KYC via Sumsub. ",
          "light": "If your product does not require customer identity verification, users can make instant payment and registration via Pay & Go Light."
        },
        "payment-flow": {
          "description": "Secure Account-to-Account direct payments via Bank."
        }
      }
    },
    "documents-page": {
      "nav": {
        "cookies": {
          "subtitle-1": "What are Cookies?",
          "subtitle-2": "Necessary Cookies",
          "subtitle-3": "Preference and Performance Cookies",
          "subtitle-4": "Statistical Cookies",
          "subtitle-5": "Marketing, Targeting or Promotional Cookies",
          "subtitle-6": "How to Restrict and Delete Cookies?",
          "title": "Cookies Policy"
        },
        "policy": {
          "subtitle-1": "Responsibilities",
          "subtitle-2": "When do We Collect Your Data",
          "subtitle-3": "Data We Collect, Purposes, Legal Basis and Retention Terms ",
          "subtitle-4": "Recipients and Sources of Your Data",
          "subtitle-5": "International Transfers of Your Personal Data",
          "subtitle-6": "Your Rights",
          "subtitle-7": "Contact Details",
          "subtitle-8": "Changes to the Privacy Policy",
          "title": "Privacy Policy"
        },
        "privacy-for-candidates": {
          "subtitle-1": "Why does Noda need your Data?",
          "subtitle-2": "How does Noda Treat your Data?",
          "subtitle-3": "Sources and Recipients of Data",
          "subtitle-4": "International Transfers",
          "subtitle-5": "Data Protection Rights",
          "subtitle-6": "Contact Information",
          "title": "Privacy Notice for Job Candidates&nbsp;or Cooperation"
        },
        "terms": {
          "subtitle-1": "The Agreement",
          "subtitle-2": "Service We Provide",
          "subtitle-3": "Access to the Service and Communication on Suspicious Activities",
          "subtitle-4": "Our Access to Your Data",
          "subtitle-5": "Termination and Suspension",
          "subtitle-6": "Indemnification and Liability",
          "subtitle-7": "Complaints",
          "subtitle-8": "General Provisions",
          "title": "Terms of Use"
        }
      },
      "title": "Legal Docs"
    },
    "ecommerce": {
      "faq": {
        "currencies": {
          "content": "Noda supports a variety of global currencies, including EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON and SEK.",
          "title": "Which currencies are available?"
        },
        "how-long": {
          "content": "Our onboarding can be as quick as one day. Noda’s support team is here to help with any roadblocks, ensuring you can start accepting payments swiftly.",
          "title": "How long does it take to start accepting payments with Noda?"
        },
        "how-to-start": {
          "content": "First, you should be onboarded with Noda. Simply fill out the form, and our sales team will contact you shortly. We offer easy onboarding with the personalised guidance of a dedicated manager. Our processor smoothly integrates with API and front-end components, ensuring seamless merging into your platform.",
          "title": "How to start accepting payments online with Noda?"
        },
        "needs": {
          "content": "To start using Noda, fill out the form, and our sales team will contact you shortly. Noda offers easy onboarding with the guidance of a dedicated manager to ensure you are supported every step of the way.",
          "title": "What is needed from me to get started?"
        },
        "subtitle": "Need to know",
        "title": "FAQs",
        "types": {
          "content": "Noda offers e-commerce payment solutions for all merchant types and sizes, with scalable plans available to support your business growth.",
          "title": "What types of merchants does Noda support?"
        }
      },
      "hero": {
        "text": "Elevate your e-commerce business. Our all-in-one payments platform prioritises customer understanding, efficiency, and growth",
        "title-1": "Payment Solutions ",
        "title-2": "for E-Commerce:",
        "title-gradient-1": "Your Payments ",
        "title-gradient-2": "are Our Priority"
      },
      "how-does-it-work": {
        "content": "Noda is a worldwide e-commerce payment platform and open banking provider. From transaction management to financial analytics, Noda has got you covered. Our platform uses AI and machine-learning technologies to provide state-of-the-art payment gateway solutions for e-commerce business.\n\nOpen banking means traditional banks share data with licensed fintech companies, like Noda, to streamline transactions. Our payment ecosystem connects all leading banks across the UK and EU, facilitating effortless e-commerce payment services.",
        "subtitle": "Technologies",
        "title": "How Does it Work"
      },
      "how-to-start": {
        "content": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our team is here to help with any roadblocks. To start using Noda, simply fill out the form, and our sales representatives will contact you shortly.",
        "subtitle": "Easy Onboarding",
        "title": "How to Start"
      },
      "payments": {
        "text": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "title": "Toolset for E-Commerce"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Leverage our data-driven insights. Noda’s tools offer ready-to-use analytics of client behaviour, including segmentation and forecasting algorithms",
            "title": "AI-Powered Analytics"
          },
          "banking": {
            "content": "Enhance customers’ experience and ease transaction&nbsp;flow with the power and security of open&nbsp;banking payments",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda works with a variety of currencies to support your e-commerce operations around the world",
            "title": "Global Currencies"
          },
          "payment-processing": {
            "content": "Streamline pay-ins and pay-outs with Noda. Leverage intuitive UX, smart routing and a variety of e-commerce payment methods",
            "title": "E-Commerce\nPayment Processing"
          },
          "scalable-plans": {
            "content": "We offer e-commerce payment services for all company sizes, with scalable plans available to fuel your business growth",
            "title": "Scalable Plans"
          },
          "security": {
            "content": "Noda provides secure e-commerce payment getaway, ensuring PCI DSS compliance, encryption and fraud prevention",
            "title": "Security"
          }
        },
        "subtitle": "What we offer",
        "title-1": "Top Features ",
        "title-2": "for E-Commerce"
      }
    },
    "educational-platforms": {
      "faq": {
        "countries": {
          "content": "We work with 2000+ banks across 28 countries, including the Netherlands, Portugal, Belgium, Germany, Poland, Bulgaria, France, Ireland, Italy, Austria, Spain, Denmark, Estonia, the UK, Luxembourg, Romania, Lithuania, Hungary, Latvia, Finland, Sweden, Norway, Czech Republic, Slovakia, Greece and Slovenia.",
          "title": "What countries does Noda work in?"
        },
        "currencies": {
          "content": "Noda supports a variety of global currencies, including EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON and SEK.",
          "title": "What currencies does Noda support?"
        },
        "how-to-integrate": {
          "content": "First, you should be onboarded with Noda. Simply fill out the form, and our sales team will contact you shortly. We offer easy onboarding with the personalised guidance of a dedicated manager. Our processor smoothly integrates with API and front-end components, ensuring seamless merging into your educational platform.",
          "title": "How can I integrate Noda into my payment workflow?"
        },
        "subtitle": "YOUR QUESTIONS ANSWERED",
        "title": "FAQs"
      },
      "hero": {
        "text": "Educate with ease while we take care of the payments. Our all-in-one online payment system for educational platforms prioritises customer understanding, efficiency, and growth",
        "title-1": "Payment Gateway",
        "title-gradient-1": "for Educational",
        "title-gradient-2": "Platforms"
      },
      "how-does-it-work": {
        "content": "A payment gateway transfers financial data between learners, merchants, and their banks. Think of it as a digital condu­ctor, meticu­lously guiding each stage of the payment processing in the education sector.\n\nNoda is a worldwide payment platform and open banking provider. From secure gateway to transaction management and financial analytics, Noda has got you covered. Our platform uses AI and machine-learning technologies to provide state-of-the-art online payment solutions for education businesses.",
        "subtitle": "Technologies",
        "title": "How Does Education Payment Gateway Work?"
      },
      "how-to-start": {
        "content": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our platform smoothly integrates with API and front-end components, ensuring seamless merging into your interface. To start using Noda, fill out the form below, and our sales representatives will contact you shortly. Our team is here to help with any roadblocks",
        "subtitle": "Easy Onboarding",
        "title": "How to Start"
      },
      "open-banking": {
        "content": "Open banking means traditional banks share data with licensed fintech companies, like Noda, to streamline transactions. Our payment ecosystem connects all leading banks across the UK and EU, facilitating effortless payment services",
        "subtitle": "A LOT OF POSSIBILITIES",
        "title": "What is Open Banking?"
      },
      "payments": {
        "text": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "title": "Toolset for Educational Platforms"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Leverage our data-driven insights. Noda’s tools offer ready-to-use analytics of client behaviour, including segmentation and forecasting algorithms",
            "title": "AI-Powered Analytics"
          },
          "banking": {
            "content": "Enhance customers’ experience and simplify transaction flow with the power and security of open banking payments",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda works with a wide range of currencies to support your clients around the world",
            "title": "Global Currencies"
          },
          "payment-processing": {
            "content": "Streamline pay-ins and pay-outs, leverage intuitive UX, smart routing and offer a variety of popular payment methods",
            "title": "Payment Processing for Educational Platforms"
          },
          "scalable-plans": {
            "content": "We offer payment solutions for all company sizes, with scalable plans available to fuel the growth of your educational platform",
            "title": "Scalable Plans"
          },
          "security": {
            "content": "Noda provides secure payment getaway, ensuring PCI DSS compliance, encryption and fraud prevention",
            "title": "Security"
          }
        },
        "subtitle": "WHAT WE OFFER",
        "title-1": "Top Features",
        "title-2": "for Educational Platforms"
      }
    },
    "financial": {
      "application-list": {
        "financial1": {
          "text": "Entertainment"
        },
        "financial2": {
          "text": "Retail"
        },
        "financial3": {
          "text": "Startups"
        },
        "financial4": {
          "text": "Marketplaces"
        },
        "financial5": {
          "text": "Dating"
        },
        "financial6": {
          "text": "E-Commerce"
        },
        "financial7": {
          "text": "Gaming"
        },
        "financial8": {
          "text": "Travel"
        }
      },
      "application": {
        "subtitle": "Data Application",
        "text": "Noda's Data Enrichment can streamline payment processing for a wide range of businesses, from traditional e-commerce to complex subscription and top-up business models",
        "title": "Adaptable Across Numerous Industries"
      },
      "buttons": {
        "DE-row": {
          "berlin": "Berlin",
          "mobile": "Mobile"
        },
        "NL-row": {
          "amsterdam": "Amsterdam",
          "desktop": "Desktop"
        },
        "UK-row": {
          "desktop": "Desktop",
          "london": "London"
        }
      },
      "container-header-text": "Our tools offer a comprehensive insight into clients' needs that you can use to elevate your business",
      "customer-segmentation": {
        "list": {
          "enhanced-engagement": "Enhanced customer engagement",
          "marketing-insights": "Advanced marketing insights",
          "ready-for-use": "Ready for immediate use"
        },
        "subtitle": "Data clusters",
        "text": "Personalise your clients' experience with our customer segmentation feature, which categorises users into distinct groups, or clusters, to deliver precision-targeted high-value recommendations",
        "title": "Customer Segmentation"
      },
      "data-usage": {
        "info": {
          "monthly-value": "Monthly value",
          "predicted-lifetime": {
            "label": "Predicted lifetime value",
            "value": "2 months"
          },
          "predicted-spendings": "Predicted spendings"
        },
        "subtitle": "Data Usage",
        "text": "Noda's Data Enrichment leverages advanced analytics to predict your customers' spending patterns based on their financial behaviour and environmental factors. Our tools offer a comprehensive insight into clients' needs that you can use to elevate your business",
        "title": "Forecasting Algorithms"
      },
      "diff-user": "Different user",
      "financial-hero-title-1": "Data Enrichment:",
      "financial-hero-title-2": "Unlock Open Banking",
      "financial-hero-title-3": "User Insights with Noda",
      "financial-info": "2 months",
      "header-title": "Empower Your Growth With Extra Data",
      "hero": "Get valuable user insight right after the first transaction has been made. Once we receive user consent to show us his transactions — it is the right time to get actionable signals.",
      "how-data": {
        "enrich-data": {
          "text": "Once the user gives us consent we will transmit the enriched data to you.",
          "title": "Enrich Data"
        },
        "instant-consent": {
          "text": "During the payment or sign-in, the users allows Noda to read the transaction data.",
          "title": "Instant Consent"
        },
        "payment-or-sign-in": {
          "text": "Initiate Payment or Sign-in through Noda on your website.",
          "title": "Payment or Sign In"
        }
      },
      "info-data": {
        "subtitle": "What Users See",
        "text": "We ensure your peace of mind with Financial AI Toolset's secure data management, strict compliance with regulated banking standards.",
        "title": "How It Works"
      },
      "key-features-title": "Key Features",
      "payments-data": {
        "text": "Forecasting financial insights for merchants",
        "title": "Unlocking User Insights with Noda"
      },
      "preferences-items": {
        "hood1": {
          "text": "Place the user at the forefront with Open Banking knowledge.",
          "title": "Build personalised solutions"
        },
        "hood2": {
          "text": "Get a signal when high-margin users onboard.",
          "title": "Enhance engagement"
        },
        "hood3": {
          "text": "Say goodbye to overspending on card payments.",
          "title": "Do better re-marketing with high confidence"
        },
        "hood4": {
          "text": "Target only users with high LTV potential.",
          "title": "Improve your acquisition strategy"
        }
      }
    },
    "gaming": {
      "case-study": {
        "subtitle": "Case Study",
        "text": "In February 2023, Wargaming, an award-winning online game publisher, teamed up with Noda to introduce instant open banking payments in gaming. This partnership allowed Wargaming's players to access diverse online payment options, including account-to-account (A2A) transactions",
        "title": "Wargaming <br/>& Noda"
      },
      "faq": {
        "countries": {
          "content": "We work with 2000+ banks across 28 countries, including the Netherlands, Portugal, Belgium, Germany, Poland, Bulgaria, France, Ireland, Italy, Austria, Spain, Denmark, Estonia, the UK, Luxembourg, Romania, Lithuania, Hungary, Latvia, Finland, Sweden, Norway, Czech Republic, Slovakia, Greece and Slovenia.",
          "title": "What countries does Noda work in?"
        },
        "currencies": {
          "content": "Noda supports a variety of global currencies, including EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON and SEK.",
          "title": "What currencies does Noda support?"
        },
        "integration": {
          "content": "First, you should be onboarded with Noda. Simply fill out the form, and our sales team will contact you shortly. We offer easy onboarding with the personalised guidance of a dedicated manager. Our processor smoothly integrates with API and front-end components, ensuring seamless merging into your platform.",
          "title": "How can I integrate Noda into my payment workflow?"
        },
        "subtitle": "Your questions answered",
        "title": "FAQs"
      },
      "hero": {
        "text": "Elevate your gaming business&nbsp;with Noda’s payments. Our all-in-one platform prioritises customer understanding, efficiency, and growth",
        "title-1": "Payment Gateway",
        "title-2": "for Online Gaming with Noda"
      },
      "how-does-it-work": {
        "subtitle": "Technologies",
        "text": "A gaming payment gateway serves as a middleman, securely transmitting data between the gamer, merchant, and banks. Think of a digital conductor, meticulously guiding every step of online gaming credit card processing\n\nNoda is a worldwide payment platform and open banking&nbsp;provider. From secure gateway to transaction management and financial analytics, Noda has got you covered. Our platform uses AI and machine-learning technologies to provide state-of-the-art solutions",
        "title": "How Does Payment Gateway for Gaming Work?"
      },
      "how-to-start": {
        "subtitle": "Easy Onboarding",
        "text": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our team is here to help with any roadblocks. Our&nbsp;processor smoothly integrates with API and front-end components, ensuring seamless merging into your platform. To start using Noda, Simply fill out the form below, and our sales representatives will contact you shortly",
        "title": "How to Start"
      },
      "open-banking": {
        "subtitle": "A lot of possibilities",
        "text": "Open banking means traditional banks share data with licensed fintech companies, like Noda, to streamline transactions. Our payment ecosystem connects all leading banks across the UK and EU, facilitating effortless payment services",
        "title": "What is Open Banking?"
      },
      "payments": {
        "text": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "title": "Toolset for Online Gaming"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Leverage our data-driven insights. Noda’s tools offer ready-to-use analytics of client behaviour, including segmentation and forecasting algorithms",
            "title": "AI-Powered Analytics"
          },
          "banking": {
            "content": "Enhance customers’ experience and ease transaction&nbsp;flow with the power and security of open&nbsp;banking payments",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda works with a wide range of currencies to support your online gaming clients around the world",
            "title": "Global Currencies"
          },
          "payment-processing": {
            "content": "Streamline pay-ins and pay-outs, leverage intuitive UX, smart routing and offer a variety of popular payment methods",
            "title": "Online Gaming Payment Processing"
          },
          "scalable-plans": {
            "content": "We offer gaming payment solutions for all company sizes, with scalable plans available to fuel your business growth",
            "title": "Scalable Plans"
          },
          "security": {
            "content": "Noda provides a secure online gaming payment getaway, ensuring PCI DSS compliance, encryption and fraud prevention",
            "title": "Security"
          }
        },
        "subtitle": "What we offer",
        "title-1": "Top Features",
        "title-2": "for Online Gaming"
      }
    },
    "instant-payment-links": {
      "cx": {
        "subtitle": "experience is key",
        "text": "Meet buyers on a secure payment page.<br/>Allow them to complete the purchase using their preferred banking app.",
        "title": "Instant Customer Experience"
      },
      "funds": {
        "receive-money": "Receive money directly to your bank account in real time.",
        "settle-payments": "Or settle payments using Noda vIBAN.",
        "subtitle": "choose your flow",
        "title": "Instant Funds Availability"
      },
      "hero": {
        "text": "Secure, flexible payments minus headache of integration",
        "title": "Instant Payment Links"
      },
      "info": {
        "checkout-anchor": "various media types",
        "checkout-text-end": ", online or in-person",
        "checkout-text-start": "Let your customers checkout across ",
        "create-anchor": "on the fly",
        "create-text": "Create payment links, generate scannable payment QR codes ",
        "fees-anchor": "receive money in real-time",
        "fees-text": "Cut transaction fees and ",
        "title": "Payment Link Generator to Boost Your Daily Business"
      },
      "key-features": {
        "commerce": "Omnichannel Commerce Without Integrations",
        "coverage": "Wide Geo Coverage",
        "customer": "Super-Simple Customer Experience",
        "fees": "Low Transaction Fees",
        "no-code": "No Code, No Technical Experience Required",
        "security": "Bank-Level Security",
        "subtitle": "power of payment links",
        "time": "5 min Time-to-Market for Noda Users",
        "title": "Key Features",
        "transparency": "Transparency, Easy Management"
      },
      "product-block": {
        "text": "Instant set-up. Instant sharing. Instant payment experience. The world is your playground. The name of the game is “just get paid”.",
        "title": "Instant Payment Links"
      },
      "setup": {
        "subtitle": "how it works",
        "text": "Creating a payment link only takes a few moments: enter price & currency, add payment details and press Generate. You’re all set!",
        "title": "Instant Set-Up"
      },
      "sharing": {
        "description": "Display the payment QR code for your customers to scan and pay across printed media, outdoor ads, computer & TV screens.",
        "header": {
          "subtitle": "engage your audience",
          "text": "Send the payment link to your customers.<br/>Use any platform where you engage audiences: websites, emails, chatbots, social networks, messengers, etc.",
          "title": "Instant Sharing"
        }
      },
      "use-cases": {
        "automotive": {
          "item-1": "Full and split payments",
          "item-2": "Deposits and instalments",
          "item-3": "International, multi-currency payments",
          "item-4": "After-sales services",
          "title": "Automotive"
        },
        "e-commerce": {
          "item-1": "Omnichannel commerce",
          "item-2": "International, multi-currency payments",
          "item-3": "Pay-later options",
          "item-4": "Social commerce",
          "title": "E-commerce"
        },
        "header": {
          "subtitle": "connecting the dots",
          "text": "From online to in-person, high-ticket to micro-payments, international or door-to-door. Effortless payment experiences are just one link away.",
          "title": "Use Cases & Industries"
        },
        "retail": {
          "item-1": "Deposits and instalments",
          "item-2": "One-click payments for returning customers",
          "item-3": "Omnichannel commerce",
          "item-4": "International, multi-currency payments",
          "title": "High-Ticket Retail"
        },
        "sales": {
          "item-1": "Full and split payments",
          "item-2": "Social commerce",
          "item-3": "Quick-launch campaigns",
          "item-4": "Pay-later options",
          "title": "In-Person Sales"
        },
        "services": {
          "item-1": "Deposits & instalments",
          "item-2": "After-sales services",
          "item-3": "Loans, microcredit",
          "item-4": "Quick-launch campaigns",
          "title": "Services"
        },
        "travel": {
          "item-1": "Deposits and instalments",
          "item-2": "International, multi-currency payments",
          "item-3": "One-click payments for returning customers",
          "item-4": "Pay-later options",
          "title": "Travel & Hospitality"
        }
      }
    },
    "letters-plugin": {
      "buttonTitle": "View All",
      "title": "Learn More About Payment Plugins"
    },
    "main-v2": {
      "boost-your-business": {
        "connected-banks": "сonnected banks with 30,000+ branches",
        "countries-covered": "сountries covered",
        "description": "Noda’s robust online payment ecosystem connects all leading banks across the UK and EU, facilitating effortless transactions",
        "integrated-networks": "integrated networks",
        "subtitle": "Unleash the Power of Open Banking",
        "subtitleV2": "Unleash the Power\n of Open Banking",
        "title": "Boost your business with Noda"
      },
      "hero": {
        "online-payments": {
          "part-1": "Online Payments ",
          "part-2": "with Noda. ",
          "part-3": "Your Payments, Our Priority"
        },
        "text": "Elevate your business with our comprehensive online payment platform. Drive increased sales and save valuable time through streamlined processes. Our all-in-one solutions prioritise customer understanding, efficient operations, and growth."
      },
      "reviews": {
        "title": "What our customers are saying"
      },
      "what-is-noda": {
        "card-payments": {
          "button": "Learn More About Card Payments",
          "description": "Noda highly prioritizes streamlining repetitive payments for smoother processing",
          "subtitle": "Card Payments",
          "title": "Faster Checkout with One-Click Payments"
        },
        "checkout": {
          "button": "Learn More About Checkout",
          "description": "Unlock the power of seamless payments with Noda Checkout's easy-to-use interface and comprehensive set of payment features",
          "subtitle": "Checkout",
          "title": "Unified Checkout for Your Payments"
        },
        "delight-customers": {
          "description": "Enjoy low-cost or zero-fee collections with an abundance of options delivered through our online payments services",
          "title": "Delight customers"
        },
        "easy-to-apply": {
          "description": "Flexible solution for collecting funds, with the option to use our Noda C2B bank account or to select from our network of trusted banking partners",
          "title": "Easy to apply"
        },
        "open-banking": {
          "button": "Learn More About Open-Banking",
          "description": "Harness the power of open banking and APIs to elevate your customer experience and enhance the online payment processing with Noda's secure and efficient solution",
          "subtitle": "Open-Banking",
          "title": "Streamline Your Payments with Noda"
        },
        "text": "Our comprehensive online payments solution streamlines transactions for both businesses and individuals, whether you’re collecting funds from customers, or sending money to friends and family.",
        "title": "What is "
      }
    },
    "marketplace": {
      "cart": {
        "cta": "Start using",
        "in-your-package": "In your package",
        "products": "products",
        "recommended": "You might also be interested"
      },
      "errors": {
        "email-pattern": "Email format is incorrect",
        "oninvalid": "The value is invalid",
        "required": "The value is required"
      },
      "filters": {
        "all": "All products",
        "categories": "Categories",
        "header": "Filters"
      },
      "header": "Our products",
      "hero": {
        "description": "Pick the right payment tools for your business. Noda's payment service marketplace brings together payment processing, invoicing, data enrichment services and more - ready to combine and customise.",
        "description-2": "Ready for a fresh take on payments? Start building your payment stack today.",
        "title": "Payment Tools Across Banks and Borders"
      },
      "product": {
        "add-to-package": "Add",
        "in-package": "Added",
        "read-more": "Read more",
        "remove": "Remove"
      },
      "request-a-product": {
        "cta": "Submit a request",
        "description": "Can't find what you're looking for? Let us know.",
        "form": {
          "back": "Go back to the market",
          "labels": {
            "description": "Describe your idea",
            "email": "Your work email",
            "organization": "Your organization"
          },
          "recommended": "You might also be interested",
          "success": {
            "description": "We will process your request as fast as we can. Have a nice day!",
            "header": "Thank you for your request"
          }
        },
        "header": "Request a product"
      }
    },
    "marketplaces": {
      "faq": {
        "countries": {
          "content": "We work with 2000+ banks across 28 countries, including the Netherlands, Portugal, Belgium, Germany, Poland, Bulgaria, France, Ireland, Italy, Austria, Spain, Denmark, Estonia, the UK, Luxembourg, Romania, Lithuania, Hungary, Latvia, Finland, Sweden, Norway, Czech Republic, Slovakia, Greece and Slovenia.",
          "title": "What countries does Noda work in?"
        },
        "currencies": {
          "content": "Noda is a global marketplace payment processor that supports a variety of currencies, including EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON and SEK.",
          "title": "What currencies does Noda support?"
        },
        "how-to-integrate": {
          "content": "First, you should be onboarded with Noda. Simply fill out the form, and our sales team will contact you shortly. We offer easy onboarding with the personalised guidance of a dedicated manager. Our marketplace payments system integrates with APIs and front-end components, seamlessly merging into your platform.",
          "title": "How can I integrate Noda into my payment workflow?"
        },
        "subtitle": "YOUR QUESTIONS ANSWERED",
        "title": "FAQs"
      },
      "hero": {
        "text": "Elevate your marketplace with Noda’s payment gateway. Focus on listings while we ensure secure and seamless transactions. Our all-in-one platform prioritises customer understanding, efficiency, and growth",
        "title-1": "Payment Gateway",
        "title-gradient-1": "for Marketplaces with Noda"
      },
      "how-does-it-work": {
        "content": "A payment gateway securely transmits financial data between customers, merchants, and banks. Think of it as a digital conductor guiding each stage of payment processing\n\nNoda is a worldwide payment platform and open banking provider. From secure online marketplace payments to financial analytics, Noda has got you covered. Our platform uses AI and machine-learning technologies to provide state-of-the-art solutions",
        "subtitle": "Technologies",
        "title": "How Does Marketplace Payment Gateway Work?"
      },
      "how-to-start": {
        "content": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our marketplace payment platform smoothly integrates with APIs and front-end components, ensuring seamless merging into your interface. To start using Noda, fill out the form below, and our sales representatives will contact you shortly. Our team is here to help with any roadblocks",
        "subtitle": "Easy Onboarding",
        "title": "How to Start"
      },
      "open-banking": {
        "content": "Open banking means traditional banks share data with licensed fintech companies, like Noda, to streamline transactions. Our payment ecosystem connects all leading banks across the UK and EU, facilitating effortless payments for marketplaces",
        "subtitle": "A LOT OF POSSIBILITIES",
        "title": "What is Open Banking?"
      },
      "payments": {
        "text": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "title": "Toolset for Marketplaces"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Leverage our data-driven insights. Noda’s tools offer ready-to-use analytics of client behaviour, including segmentation and forecasting algorithms",
            "subtitle": "MODERN TECHNOLOGIES",
            "title": "AI-Powered Analytics"
          },
          "banking": {
            "content": "Enhance user experience (UX) and simplify transaction flow with the power and security of open banking payments",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda works with multiple currencies to support your marketplace clients around the world",
            "title": "Global Currencies"
          },
          "payment-processing": {
            "content": "Streamline pay-ins and pay-outs, leverage intuitive UX, smart routing and offer a variety of popular marketplace payment options",
            "subtitle": "EVERYTHING FOR YOUR BUSINESS",
            "title": "Marketplace Payment Processing"
          },
          "scalable-plans": {
            "content": "We offer payment solutions for marketplaces of all sizes, with scalable plans available to support your growth",
            "title": "Scalable Plans"
          },
          "security": {
            "content": "Noda is a secure marketplace payment provider, ensuring PCI DSS compliance, encryption and fraud prevention",
            "title": "Security"
          }
        },
        "subtitle": "OUR OFFERS",
        "title-1": "Top Features"
      }
    },
    "meta": {
      "about": {
        "aml-cft-policies": {
          "description": "Explore our policy statement, regulatory framework, methodologies, and much more.",
          "title": "Noda’s AML/CFT Policies"
        },
        "company": {
          "description": "Discover Noda's story and find out how we can enhance your business payments. Get to know our team and products.",
          "title": "Company | Noda"
        },
        "mission": {
          "description": "Learn about Noda's mission and vision, including the three whales of our culture and the story of who we are.",
          "title": "Noda's Mission and Vision"
        },
        "partnership": {
          "description": "Explore our range of partnership options, including white-label, reseller, franchise, and agent opportunities. Integrate our open banking technology.",
          "title": "Noda: Become Noda’s Partner in Business Growth"
        },
        "risk-appetite-policy": {
          "description": "Discover our risk policy on industries, activities and jurisdictions that are prohibited, restricted, or require specific conduct.",
          "title": "Noda’s Risk Appetite Policy"
        },
        "security": {
          "description": "Payment and data security should always be a priority. We provide an overview of our security features and our commitment to data privacy.",
          "title": "Security and Data Handling | Noda"
        },
        "ux-approach": {
          "description": "Discover our CX philosophy and design manifesto. Learn about our design principles and what’s driving our team to produce excellent work.",
          "title": "Noda's Approach to Customer Experience (CX)"
        },
        "white-label": {
          "description": "Become a white-label partner with Noda and integrate open banking. Leverage seamless payments, actionable analytics, and customisable branding.",
          "title": "Noda: Grow Your Business as a White-Label Partner"
        },
        "why-open-banking": {
          "description": "Discover why open banking is transforming payments. Learn how it benefits both merchants and consumers while debunking common myths.",
          "title": "Why Open Banking is the Future of Payments"
        }
      },
      "articles": {
        "description": "Discover everything you need to know about open banking and online payment solutions. Learn about digital payments with Noda's fintech articles.",
        "title": "Articles | Fintech, Open Banking, Digital Payments | Noda"
      },
      "bank-payouts": {
        "description": "Simplify mass payments with Noda's advanced bank payout solutions. Enjoy swift, hassle-free transactions and cost efficiency. Read on to discover more.",
        "title": "Streamlined Bank Payouts for Swift, Cost-Efficient Transactions | Noda"
      },
      "bank-sign": {
        "description": "Enhance your customer experience with Noda’s sign-in using a bank account. Ensure top-notch security, acquire more clients and access reliable data.",
        "title": "Seamless Sign-in via Bank, Secure Payments and Data Compliance | Noda"
      },
      "card-payments": {
        "description": "Experience seamless payments with Noda's AI-powered tech. Optimised routing, accepted card payments and easy integration - tailored for your business growth. Learn more.",
        "title": "Enhancing Online Card Payments for Business Success | Noda"
      },
      "card-payouts": {
        "description": "Boost your business growth with Noda's efficient global card payout solutions. Seamless API integration, secure transactions, and tailored for your needs.",
        "title": "Switch, Secure and Efficient Card Payout Solutions | Noda"
      },
      "checkout": {
        "description": "Elevate your payment checkout process with Noda's advanced, AI-driven technology. Optimize your checkout, secure transactions, and expand globally.",
        "title": "Seamless and Secure Solutions for Payment Checkout | Noda"
      },
      "contact-form": {
        "description": "Explore our integrated payment platform. Browse Noda's service marketplace to build your perfect payment tech stack. Open banking, cards, data enrichment, no-code.",
        "title": "Noda Form"
      },
      "contact-us": {
        "description": "Elevate your business with the power of open banking. Talk to us today to streamline payments with our all-in-one platform.",
        "title": "Contact Us | Noda"
      },
      "demo": {
        "description": "Explore Noda solutions. See how Noda Products simplify payments and accelerate your revenue growth.",
        "title": "Noda Demo"
      },
      "events": {
        "description": "Discover events and conferences at Noda. Book your spot now to connect with payment industry leaders, gain insights, and engage in professional growth opportunities!",
        "title": "Events: Network, Learn, and Grow with Noda"
      },
      "financial-ai-toolset": {
        "description": "Explore Financial AI Toolset, a solution empowering businesses with insightful AI-driven financial analytics for data-informed decisions.",
        "title": "Financial AI Toolset: Grow Your Business with Data-Driven Analytics | Noda"
      },
      "glossary": {
        "description": "Explore Noda's ultimate glossary for fintech and open banking terminology from A to Z.",
        "title": "Open Banking Glossary | Noda"
      },
      "instant-payment-links": {
        "description": "Create payment links in seconds for seamless online transactions. Send a payment link to a customer and accept payments instantly via their preferred bank.",
        "title": "Payment Links – Instant Payments Made Easy | Noda"
      },
      "legal": {
        "cookies": {
          "description": "Noda Cookies Policy explains how we use cookies for functionality, analytics, and marketing. Find out how to manage your preferences.",
          "title": "Cookies Policy"
        },
        "policy": {
          "description": "Discover how Noda collects, uses, and protects your personal data under GDPR and other regulations. Your privacy is our priority.",
          "title": "Privacy Policy"
        },
        "privacy-notice-for-job-candidates-or-cooperation": {
          "description": "This notice explains how Noda treats the personal data of potential employees, interns who applied or were invited to apply for open positions at Noda or to cooperate with Noda as individual contractors.",
          "title": "Privacy Notice for Job Candidates or Cooperation | Noda"
        },
        "terms": {
          "description": "This agreement outlines the terms of use for private individuals initiating payments via Noda. Learn about your rights and data use.",
          "title": "Terms of Use"
        }
      },
      "main": {
        "description": "Harness the power of APIs with Noda's online payment platform. Streamline transactions and elevate your business operations effortlessly.",
        "title": "Online Payments with Noda | Secure & Efficient Payment Platform"
      },
      "marketplace": {
        "description": "Explore our integrated payment platform. Browse Noda's service marketplace to build your perfect payment tech stack. Open banking, cards, data enrichment, no-code.",
        "title": "Payment Service Marketplace | Noda"
      },
      "mor": {
        "description": "Unlock borderless commerce for your digital innovations. From indie games to enterprise software.",
        "title": "Merchant of Record"
      },
      "newsroom": {
        "description": "Check out the latest news about Noda. Read the latest articles, press releases, and expert insights showcasing Noda's open banking payments services.",
        "title": "We're in the News | Noda"
      },
      "no-code": {
        "description": "Boost online sales with AI-driven, no-code payment pages. Learn how Noda can support your entire transaction flow - from a merchant account to day-to-day payment processing.",
        "title": "Create Custom AI-Powered Payment Pages in Minutes | Noda"
      },
      "open-banking": {
        "description": "Transform your business with Noda's open banking payments. Enhance customer experience and ensure secure transactions. Try a demo now.",
        "title": "Open Banking Platform for Secure and Seamless Transactions | Noda"
      },
      "plugins": {
        "description": "Elevate your business with Noda’s open banking plugins for the e-commerce platform you use. Streamline payments with simplified user experience, seamless integration, security and efficiency of open banking.",
        "magento": {
          "description": "Discover Noda’s Magento plugin. Learn how to integrate Noda as a Magento payment option on your e-commerce website.",
          "title": "Magento Payment Gateway with Noda"
        },
        "opencart": {
          "description": "Discover Noda’s OpenCart plugin. Learn how to integrate Noda as an OpenCart payment option on your e-commerce website.",
          "title": "OpenCart Payment Gateway with Noda"
        },
        "prestashop": {
          "description": "Discover Noda’s PrestaShop plugin. Learn how to integrate Noda as a PrestaShop payment option on your e-commerce website.",
          "title": "PrestaShop Payment Gateway with Noda"
        },
        "title": "Boost Your Sales with Noda’s Open Banking Plugins",
        "woocommerce": {
          "description": "Discover Noda’s WordPress plugin. Learn how to integrate Noda as a WooCommerce payment method for your e-commerce business.",
          "title": "WooCommerce Payment Gateway with Noda"
        }
      },
      "pricing": {
        "description": "Noda offers competitive and predictable pricing for your business. Enhance your payment ecosystem with our comprehensive open-banking solution.",
        "title": "Pricing | Noda"
      },
      "toc": {
        "title": "TERMS OF COOPERATION"
      },
      "use-cases": {
        "ecommerce": {
          "description": "Discover Noda’s payment gateway for e-commerce and streamline online transactions. Start using Noda now.",
          "title": "E-commerce Payment Solutions: Elevate Your Business with Noda"
        },
        "educational-platforms": {
          "description": "Discover Noda’s online payment systems for education to streamline transactions and leverage open banking. Learn more…",
          "title": "Payment Gateway for Educational Platforms | Noda"
        },
        "marketplaces": {
          "description": "Discover Noda’s online marketplace payment solutions to streamline transactions and leverage open banking. Learn more…",
          "title": "Payment Gateway for Marketplaces | Noda"
        },
        "online-gaming": {
          "description": "Discover Noda’s gaming payment solutions to streamline transactions and leverage open banking payments. Learn more…",
          "title": "Payment Gateway for Online Gaming | Noda"
        },
        "retail": {
          "description": "Discover Noda’s retail payment gateway to streamline transactions and leverage open banking payments. Learn more…",
          "title": "Payment Gateway for Retail | Noda"
        },
        "saas": {
          "description": "Discover Noda’s SaaS payment gateway to streamline transactions and leverage open banking payments. Learn more…",
          "title": "Payment Gateway for SaaS | Noda"
        },
        "travel": {
          "description": "Discover Noda's payment solutions for travel business and streamlone online payments. Learn more...",
          "title": "Travel Payment Solutions: Elevate Your Business with Noda"
        }
      }
    },
    "mission": {
      "hero": {
        "desc-1": "Our <b>mission</b> is to deliver the definitive financial management toolkit that the 21st-century internet deserves.",
        "desc-2": "We aim to eliminate the remnants of last century's legacy systems, including time delays, data distortions due to endless intermediaries, manual processing, human error, and the inherent biases of a cliquey financial system.",
        "extended-text": "We want to drive the transformation of the financial system through open banking.<br/>Our <b>vision</b> is for payments to move instantly between accounts anywhere in the world, without extra costs. We think that financial data analysis should not be limited to banks; instead individuals and businesses should have control over their own data.",
        "extended-title": "Global Financial Transformation",
        "subtitle": "What do we stand on",
        "title": "Mission and Vision"
      },
      "products": {
        "subtitle": "Products",
        "text": "We offer a variety of payment products that cater to both online and in-person transactions, so your customers can enjoy a seamless, omnichannel payment experience.",
        "title": "What We Do"
      },
      "secret": {
        "communication": {
          "text": "We talk things out, share ideas and openly discuss what works well and what doesn’t. Being clear and upfront about everything — from our projects to our vision — is important for us. At Noda, everyone stays in the loop.",
          "title": "Communication"
        },
        "empathy": {
          "text": "But it's not just about tech — it's about you. We're here to listen, understand, and support our clients. Whether you’ve been in business for years or just starting out, with Noda you’ll find a welcoming atmosphere where your needs come first.",
          "title": "Empathy"
        },
        "innovation": {
          "text": "We're constantly experimenting and trying out ideas. We embrace new tech such as blockchain and AI. We want to give you cutting-edge solutions that make payments more pleasant and easier. And we’re not afraid to think outside the box.",
          "title": "Innovation"
        },
        "subtitle": "More about us",
        "title": "Our Secret Sauce"
      },
      "welcome": {
        "desc-1": "We are developing a platform that empowers online businesses to manage a broad range of client interactions, including onboarding, identity and wealth verification, risk assessment, routing, incoming and outgoing payments, and interaction performance analysis.",
        "desc-2": "We are motivated by advancing our product and the industry rather than by profiting from our clients. We take pride in seeing how our product solutions begin to shape the open banking industry across the markets where we operate.",
        "desc-3": "We're your partners in payments —<br/>pioneers, creators, and always allies.",
        "extended-subtitle": "Welcome to the future of fintech.",
        "extended-title": "Welcome to Noda",
        "title": "Who We Are"
      },
      "whales": {
        "exploration": {
          "text": "We are always learning. Our team members are passionate and enthusiastic, eager for self-growth and professional development. At Noda, we support this drive.",
          "title": "Exploration"
        },
        "passion": {
          "text": "At Noda, passion fuels everything we do. We're driven by excellence, whether we're innovating or connecting with clients. We believe that passion turns projects into something remarkable and inspires others to join in.",
          "title": "Passion"
        },
        "responsibility": {
          "text": "We don’t waste time arguing or pointing fingers. At Noda, we always work together to find constructive solutions, respecting each other and sharing responsibility for both wins and setbacks.",
          "title": "Responsibility"
        },
        "subtitle": "Noda culture",
        "title": "Three Whales<br/>of Our Noda Culture Code"
      }
    },
    "modern-slavery": {
      "intro-1": "The Modern Slavery Act 2015 (MSA) in the UK targets combating slavery and calls upon organizations to actively prevent modern slavery in their activities.",
      "intro-2": "Noda is dedicated to combating slavery and to prevent any association with, promotion of, or support for human trafficking or slavery in its operations. This statement reaffirms our adherence to the MSA, emphasizes our stance against modern slavery, and delineates the steps we take to ensure the effective implementation of our approach.",
      "last-update-at": "Last Updated on June 1, 2024",
      "note": "PLEASE NOTE: Although Noda is currently not legally required to publish this statement, we believe in taking responsible actions even before they become obligatory.",
      "sections": {
        "our-status": {
          "text-1": "Noda has implemented various controls to ensure that we do not participate in any activities contradicting our stance on modern slavery. Below are some of these measures.",
          "text-2": "Noda uses several suppliers which provide professional services such as consultancy services, legal advice and accounting services if needed. Additionally, we engage suppliers providing hardware and software, encompassing computer equipment, software licenses, and cloud-based data storage services. Most of our suppliers are situated in locations where our offices operate, namely the UK and the EU.",
          "text-3": "As an internet-based payment technology company, with the majority of our suppliers comprising software and professional service providers, our human rights and modern slavery risk profile is assessed as low. Nonetheless, all suppliers must adhere to our internal policies, which inter alia mandate that all vendors undergo vetting and due diligence, with the level of scrutiny varying based on their risk categorization.",
          "text-4": "The majority of merchants Noda provides services to are situated in low-risk geographies, and they undergo due diligence to confirm their low-risk status.",
          "text-5": "Noda has no knowledge of any instances of slavery or human trafficking within its group businesses or supply chains. Throughout the last financial year, no potential issues of this nature have been identified or reported through internal reporting channels, audit processes, whistleblowing channels, or any other means. Additionally, Noda has not received any information from any entities within the Noda group suggesting the existence of such issues with any of its intra-group suppliers or their supply chains.",
          "text-6": "We are committed to upholding all internationally recognized human rights concerning our employees, the communities where we operate, and the communities within our global supply chains. Should Noda become aware that any party with whom we have a relationship is involved in human rights violations or modern slavery offenses, we will promptly terminate our association with that entity.",
          "text-7": "Concerns regarding human rights or modern slavery involving any of our merchants, suppliers, or other parties can be reported to Noda through <a href=\"mailto:legal@noda.live\" target=\"_blank\">Legal@noda.live</a>. We assure you that we will promptly and thoroughly investigate any such reports.",
          "title": "Our status, operations, and supply chain"
        }
      },
      "subtitle": "Intention of the Statement",
      "title": "Modern Slavery Statement"
    },
    "mor": {
      "case": {
        "subtitle": "Case Study",
        "text": "In February 2023, Wargaming, an award-winning online game publisher, teamed up with Noda to introduce instant open banking payments in gaming. This partnership allowed Wargaming's players to access diverse online payment options, including account-to-account (A2A) transactions",
        "title": "Wargaming & Noda"
      },
      "cure": {
        "additional": {
          "text1": "Sales tax, VAT, and GST calculations",
          "text2": "Timely filings with tax authorities worldwide",
          "text3": "Up-to-the-minute tax law updates",
          "text4": "Detailed record-keeping for those \"just in case\" moments"
        },
        "bold-text": "What we handle:",
        "subtitle": "A cure to tax headaches",
        "text": "No more tax-induced nightmares. Our smart system crunches the numbers, files the forms, and keeps you in the clear across your target markets. We stay on top of ever-changing tax laws across the globe, removing unnecessary barriers for you to reach your audiences.",
        "title": "Your Global Tax Compliance Ally"
      },
      "custom": {
        "subtitle": "how it works",
        "text": "Let us clear your path to global markets by transforming complex international sales into seamless transactions.",
        "title": "We’ll take care of the messy parts behind the scenes: payments, taxes, support"
      },
      "faq": {
        "offer": {
          "content": "We provide 24/7 support in multiple languages to assist with any issues, from payment problems to account questions. Our team is always available to help you navigate the complexities of global digital commerce.",
          "title": "What kind of support does Noda offer?"
        },
        "payment-security": {
          "content": "We use open banking for direct bank transfers, which verifies account holders in real-time. This approach, combined with our advanced transaction monitoring, significantly reduces fraud risk while maintaining a smooth user experience.",
          "title": "How does Noda handle payment security and fraud prevention?"
        },
        "products": {
          "content": "Absolutely! We specialise in enabling borderless commerce. Our platform handles multiple currencies, localises payment methods, and manages international tax compliance, making it easy for you to reach customers globally.",
          "title": "Can Noda help me sell my products internationally?"
        },
        "services": {
          "content": "Not necessarily. While you can use our services with your existing website, we also offer free-of-charge distribution tools, including an intuitive, no-code site and store builder to help you get started if you don't have a website yet.",
          "title": "Do I need my own website to use Noda's services?"
        },
        "subtitle": "Need to know",
        "tax-compliance": {
          "content": "Our smart system automatically calculates, collects, and remits sales tax, VAT, and GST for your transactions worldwide. We stay updated on changing tax laws and maintain detailed records, ensuring you're always compliant in every market you sell to.",
          "title": "How does Noda help with tax compliance?"
        },
        "title": "FAQs"
      },
      "geo": {
        "btn-text": "View List of Supported Banks"
      },
      "hero-data": {
        "subtitle": "merchant of record",
        "text1": "Unlock borderless commerce for your digital innovations.",
        "text2": "From indie games to enterprise software.",
        "title": "Focus on creating the next big thing — we handle the complexities!"
      },
      "squad": {
        "additional": {
          "text1": "Round-the-clock support in multiple languages",
          "text2": "Smart insights to guide your business decisions",
          "text3": "Strong security measures to protect your revenue",
          "text4": "Regular tech updates to keep your operations smooth"
        },
        "subtitle": "Guidance and support",
        "text": "Our support is here for you, ready to step in whenever you need us. Whether it’s a late-night payment hiccup, or a question about your account, we’re available.\n\n From solo creators to bustling studios, we're here to help you succeed in global markets. Our toolkit includes:",
        "title": "Your 24/7 Backup Squad"
      }
    },
    "newsroom": {
      "title": "Newsroom"
    },
    "no-code": {
      "features": {
        "custom-payment": "Custom payment pages on the fly",
        "instant": "Instant, secure transactions",
        "leverage-ai": "Leverage AI to build complete branded payment pages in a few clicks.",
        "real-time": "Real-time payments, payer authorization via bank, seamless customer experience.",
        "sell-anything": "Sell anything without a website",
        "tag-title": "KEY FEATURES",
        "text": "Sell digital and physical goods and services without the hassle of lengthy development and setup.",
        "title": "A shortcut to grow your\nproduct sales online",
        "turn-any": "Turn any channel into your online marketplace. Let Noda handle the entire payment flow."
      },
      "hero": {
        "text": "Create custom payment experiences with AI in minutes",
        "title": "No-code\nPayment Page"
      },
      "how-it-works": {
        "ai-based": "AI based analysis",
        "authorize": "Authorize directly in the chat and navigate to the page builder functionality.",
        "enter-your": "Enter your request or upload an existing product description. Give the chatbot a moment to process.",
        "make-necessary": "Make necessary adjustments, approve the version you like and start selling!",
        "payment-page": "Payment page is ready",
        "preview": "Preview",
        "tag-title": "how it works",
        "text-first": "Create custom payment pages in minutes using a simple AI chat interface.",
        "text-second": "Automatically generate text and images based on your product details. Embed payment links and QR codes for a fully functional payment page.",
        "the-bot": "The bot generates a full payment page based on your input: images, text, payment functionality, QR code.",
        "title": "Smart payment page builder",
        "user-friendly": "User friendly interface"
      },
      "monetize": {
        "direct-sales": "Direct sales",
        "donations": "Donations",
        "event-tickets": "Event tickets",
        "games": "Games & game merch",
        "lean": "Lean into new business models. Build custom payment pages and start selling as soon as you hit “Save”.",
        "monetize": "Monetize anything",
        "online-courses": "Online courses",
        "online-retail": "Online retail",
        "tips": "Tips",
        "travel-packages": "Travel packages"
      },
      "product-block": {
        "text": "Custom payment pages in minutes. No development, no back-and-forth with designers and copywriters. A simple, beautiful and reliable way for your customers to pay across various channels and business models.",
        "title": "No-code Payment Page"
      },
      "sell": {
        "are-you": "Are you building an online business from scratch or exploring new revenue streams for an existing venture?\n\nConnect directly with your customers by launching sales across email, messengers, social media, live streams – anywhere, really, where you can share a payment page link.",
        "launch": "Launch sales with ease: no website, no payment integration, no back-and-forth with developers and designers.\n\nThe Noda payment platform will support your entire transaction flow – from providing a merchant account to day-to-day payment processing.",
        "reach": "Reach your customers wherever they are",
        "secure": "Secure instant payments",
        "tag-title": "SELL WITHOUT A WEBSITE"
      }
    },
    "partners": {
      "available": {
        "list": {
          "item1": {
            "text": "Integrate our technology seamlessly into your own solutions as a white-label partner",
            "title": "White-Label"
          },
          "item2": {
            "text": "Invite businesses using referral links as a reseller partner",
            "title": "Reseller"
          },
          "item3": {
            "text": "Operate under our brand name as a franchise partner",
            "title": "Franchise"
          },
          "item4": {
            "text": "Bring in top-tier clients as an agent",
            "title": "Agent"
          }
        },
        "subtitle": "variety of options",
        "title": "Partnerships Available"
      },
      "banking": {
        "item1": "countries",
        "item2": "e-com platforms integrated",
        "item3": "digital products developed",
        "subtitle": "Choose Your Perfect Partnership",
        "text": "Explore a variety of partnership options tailored to your needs. Whether you want to integrate our technology, refer other businesses, leverage our brand, or connect with high-value clients, we have the perfect partnership path for you.",
        "title": "How it works"
      },
      "customisation": {
        "subtitle": "tailored interface",
        "text": "Whether you want to develop your own front-end to or use our build-in tools for user interfaces (UIs), the choice is yours. Shape your design to fully represent your brand and create the perfect journey.",
        "title": "Brand Customisation"
      },
      "hero": {
        "subtitle": "better payments",
        "text": "Integrate open banking transactions effortlessly, access actionable analytics, and benefit from our intuitive UX. Enjoy seamless API integration and transparent reporting to drive merchant success.",
        "title": "Help Your Merchants Grow with Open Banking"
      },
      "reporting": {
        "subtitle": "full transparency",
        "text": "With our admin hub you can track all commissions, ensuring clear and transparent reporting. Effortlessly oversee payins and payouts, gaining full visibility and managing your operations with ease.",
        "title": "Detailed Monitoring & Reporting"
      },
      "technology": {
        "subtitle": "power of technology",
        "text1": "Before open banking, traditional banks held a monopoly over customer data. In 2018, the EU’s PSD2 mandated banks to share information with authroised third-party providers, such as Noda, with customer consent.",
        "text2": "Open banking uses application programming interfaces (APIs) for software communication to transfer data. When users opt for an open banking payment, they are redirected to their trusted bank’s interface.",
        "text3": "An increasing number of consumers and merchants worldwide are embracing this emerging technology. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">Juniper Research</a> forecasts the total value of open banking payments to surge from $57bn in 2023 to $330bn by 2027. What was once considered innovative is quickly becoming a widely adopted payment method.",
        "title": "Open Banking Transforms Payment Systems"
      }
    },
    "plugins": {
      "back-to-plugins": "Back to Plugins",
      "bigcommerce": {
        "benefits": {
          "list": {
            "text": "Our WordPress WooCommerce payment plugin enable a seamless user experience for your customers. This results in more customer satisfaction and lower cart abandonment.",
            "text-1": "Our WordPress WooCommerce payment plugin enable a seamless user experience for your customers. This results in more customer satisfaction and lower cart abandonment.",
            "title": "Intuitive UX",
            "title-1": "Intuitive UX"
          },
          "title": "Benefits of Noda for WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "How do I test this plugin?",
              "text": "You can enable the plugin’s test mode, which allows you to simulate transactions."
            },
            "2": {
              "summary": "Does your plugin support WooCommerce Subscriptions?",
              "text": "You can enable the plugin’s test mode, which allows you to simulate transactions."
            },
            "3": {
              "summary": "Why isn’t the Payment Request button showing on my local machine?",
              "text": "You can enable the plugin’s test mode, which allows you to simulate transactions."
            }
          },
          "title": "Most Often Asked Questions"
        },
        "hero": {
          "button": "Add Noda to WooCommerce",
          "logo": "bigcommerce",
          "text": "Discover Noda’s WordPress plugin, which enables open banking payments for WooCommerce. Install and integrate the plugin in just a few simple steps.",
          "title": "WordPress WooCommerce Payment Gateway with Noda"
        },
        "how": {
          "text": "Merchants who Install the plugin can add a Noda button as a payment method on their website.",
          "title": "How it Works?"
        },
        "inspiration": "You May Also Looking For",
        "integration": {
          "after": "The integration takes just a few clicks and doesn’t require any developers on your team. With Noda, merchants can effortlessly add open banking payments as one of their WooCommerce payment options.",
          "before": "To set up the WordPress WooCommerce payment plugin with Noda, merchants should follow these simple steps:",
          "button": {
            "text": "Download Guide"
          },
          "steps": {
            "1": "Install the archive file in the admin panel of WooCommerce. This will set up the plugin for your website.",
            "2": "Add API keys, which are available through Noda Hub after completing onboarding.",
            "3": "WeCommerce and Noda are now connected."
          },
          "title": "Noda’s Integration with WooCommerce"
        },
        "what-is-it": {
          "text": "WeCommerce is open-source software built for WordPress, which enables businesses to create e-commerce websites in the PHP programming language. Noda offers a plugin that facilitates open banking payments as a WordPress WooCommerce payment gateway.",
          "title": "What is it?"
        }
      },
      "details": "FAQ",
      "faq": {
        "development-skills": {
          "content": "No, our plugins are designed for easy installation without requiring specialized technical skills. The step-by-step guides will walk you through the simple process. If you encounter any difficulties, our support team is ready to assist.",
          "title": "Do I need development skills to install these plugins?"
        },
        "how-secure": {
          "content": "All Noda plugins adhere to strict security standards and regulatory requirements for open banking. Transactions are secured with multi-factor authentication and data encryption to protect both merchants and customers.",
          "title": "How secure are these payment plugins?"
        },
        "plugins-compatible": {
          "content": "Noda plugins are specifically designed for open banking payments, allowing your customers to pay directly from their bank accounts. This provides enhanced security and lower transaction costs compared to traditional payment methods.",
          "title": "Are Noda plugins compatible with all payment methods?"
        },
        "subtitle": "FAQ",
        "title": "Most Often Asked Questions",
        "troubleshooting": {
          "content": "Our support team is available to assist with installation, configuration, and troubleshooting. Simply contact us through the support channels listed on each plugin page, and we'll be happy to help.",
          "title": "What if I need help with installation or troubleshooting? "
        },
        "what-is-required": {
          "content": "To use any Noda plugin, you'll need to create a Noda account, complete the onboarding process, and obtain API keys. The specific requirements for each platform are detailed on the individual plugin pages.",
          "title": "What is required to use Noda plugins? "
        }
      },
      "fqa": "fqa",
      "hero": {
        "button": "Contact Our Team",
        "subtitle": "Integrate Noda in minutes with our ready-made plugins. Streamline payments with simplified user experience, seamless integration, and enhanced security of open banking.",
        "title": "Seamless Open Banking Payments for Your E&#8209;commerce Platform"
      },
      "info": {
        "bigcommerce": {
          "subtitle": "Coming Soon",
          "text": "Noda’s BigCommerce plugin simplifies adding open banking payments to your BigCommerce website. Quick installation for a streamlined payment process.",
          "title": "BigCommerce"
        },
        "magento": {
          "text": "Discover Noda’s Magento plugin. Learn how to integrate Noda as a Magento payment option on your e-commerce website and elevate your business with open banking payments.",
          "title": "Magento"
        },
        "opencart": {
          "text": "Learn how to integrate Noda as an OpenCart payment option on your e-commerce website. Simplify your payments with open banking.",
          "title": "OpenCart"
        },
        "prestashop": {
          "text": "Integrate open banking payments with Noda’s PrestaShop plugin. Install Noda as a PrestaShop payment option on your e-commerce website with a quick and easy setup.",
          "title": "PrestaShop"
        },
        "step-title": "Step",
        "woocommerce": {
          "text": "Discover Noda’s WordPress plugin, which enables open banking payments for WooCommerce. Install and integrate the plugin in just a few simple steps.",
          "title": "WooCommerce"
        }
      },
      "integration": {
        "btn-request": "Request Integration",
        "btn-view": "View API Documentation",
        "description": "We're continually expanding our plugins—contact us for custom integrations or check our API docs for development options.",
        "title": "Request Integration"
      },
      "magento": {
        "benefits": {
          "button": {
            "text": "Contact Our Team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Our Magento e-commerce integration enables a seamless user experience for your customers. This results in more customer satisfaction and low cart abandonment.",
              "title": "User Experience (UX)"
            },
            "2": {
              "icon": "map",
              "text": "Merchants can install Noda’s plugins without a team of developers or any technical skills.",
              "title": "Seamless Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "The open banking functionality ensures security for customers and merchants. Multi-factor verification is a legal requirement under European regulation.",
              "title": "Security"
            },
            "4": {
              "icon": "all_match",
              "text": "Magento payment processing with open banking is quicker and more affordable for merchants, ensuring a faster checkout experience and fund receipt.",
              "title": "Efficiency"
            }
          },
          "title": "Benefits of Noda for Magento"
        },
        "hero": {
          "button": "Add Noda to Magento",
          "logo": "magento",
          "text": "Discover Noda’s Magento plugin. Learn how to integrate Noda as a Magento payment option on your e-commerce website.",
          "title": "Magento Payment Gateway with Noda"
        },
        "how": {
          "text": "Merchants who install the plugin can add Noda as one of their Magento payment methods for customers to use at checkout.",
          "title": "How it Works?"
        },
        "inspiration": "You May Also Looking For",
        "integration": {
          "after": "The integration takes just a few clicks and doesn’t require advanced technical skills. With Noda, merchants can effortlessly add open banking functionality as a Magento e-commerce solution.",
          "before": "To set up the Magento integration with Noda, merchants should follow these simple steps:",
          "steps": {
            "1": "Install the archive file in the admin panel of Magento. This will set up the plugin for your website.",
            "2": "Add API keys, which are available through Noda Hub after completing onboarding.",
            "3": "Magento and Noda are now connected."
          },
          "title": "Magento Payment Gateway Integration"
        },
        "meta": {
          "description": "Discover Noda’s Magento plugin. Learn how to integrate Noda as a Magento payment option on your e-commerce website.",
          "title": "Magento Payment Gateway with Noda"
        },
        "what-is-it": {
          "text": "Magento is an e-commerce platform built on open-source technology in PHP programming language. Noda offers a plugin that enables open banking payments for e-commerce websites.",
          "title": "What is it?"
        }
      },
      "opencart": {
        "benefits": {
          "button": {
            "text": "Contact Our Team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Open banking payments enable a simplified user experience for your customers, which results in less cart abandonment and more customer satisfaction.",
              "title": "Intuitive UX"
            },
            "2": {
              "icon": "map",
              "text": "With Noda, merchants can install the plugin without a team of developers.",
              "title": "Simple Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "The open banking functionality ensures security for customers and merchants. Multi-factor verification is a legal requirement in European regulation.",
              "title": "Security"
            },
            "4": {
              "icon": "all_match",
              "text": "OpenCart payment processing with Noda is quicker and more affordable for merchants, ensuring a faster checkout experience and fund receipt.",
              "title": "Efficiency"
            }
          },
          "title": "Benefits of Noda for OpenCart"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "What are the requirements of the OpenCart plugin?",
              "text": "To successfully integrate Noda’s OpenCart plugin, please ensure you have a minimum of 7.0.3 PHP version. Any version of PHP between 7.0.3 and 8.2.x is supported. You would also need a WordPress version of at least 3. You can easily find your version by checking the bottom of your OpenCart admin panel. To use Noda’s plugin in production mode, you must be onboarded with Noda."
            },
            "2": {
              "summary": "How do I integrate this plugin with Noda?",
              "text": "To integrate the OpenCart plugin, install the archive file from the OpenCart admin panel and add the API keys available on NodaHub after onboarding."
            },
            "3": {
              "summary": "How do I test this plugin?",
              "text": "To test this plugin, enable the test mode using the Sandbox keys in the Noda Hub. This will allow you to make a trial run."
            }
          },
          "title": "Most Often Asked Questions"
        },
        "hero": {
          "button": "Add Noda to OpenCart",
          "logo": "opencart",
          "text": "Discover Noda’s OpenCart plugin. Learn how to integrate Noda as an OpenCart payment option on your e-commerce website.",
          "title": "OpenCart Payment Gateway with Noda"
        },
        "how": {
          "text": "Merchants who have installed the plugin will have a Noda button appear on their website as a payment option for customers at the checkout.",
          "title": "How it Works?"
        },
        "inspiration": "You May Also Looking For",
        "integration": {
          "after": "The whole process takes just a few clicks and doesn’t require technical skills. With Noda’s OpenCart payment plugin, merchants can effortlessly add the open banking functionality to their payment arsenal.",
          "before": "To set up the OpenCart payment gateway integration, merchants should follow these simple steps:",
          "steps": {
            "1": "Install the archive file in the admin panel of OpenCart. This will set up the plugin for your website.",
            "2": "Add API keys, which are available through Noda Hub after completing onboarding.",
            "3": "OpenCart and Noda are now connected."
          },
          "title": "OpenCart Integration with Noda"
        },
        "meta": {
          "description": "Discover Noda’s OpenCart plugin. Learn how to integrate Noda as an OpenCart payment option on your e-commerce website.",
          "title": "OpenCart Payment Gateway with Noda"
        },
        "what-is-it": {
          "text": "OpenCart is a free, open-source e-commerce platform for selling products online. It’s based on the PHP programming language and MySql database. Noda’s plugin for e-commerce websites allows merchants to add open banking payments as one of their OpenCart payment methods.",
          "title": "What is it?"
        }
      },
      "platforms": "Supported E-commerce Platforms",
      "pre-footer": {
        "button": "Contact Our Team",
        "single-page-plugin": {
          "button": "Contact Our Team",
          "subtitle": "How to integrate",
          "text": "Contact us to learn more about working with partners.",
          "title": "Ready to get connected?"
        },
        "subtitle": "How to integrate",
        "text": "Contact our team to learn more about partnership and collaboration",
        "title": "Stay Connected"
      },
      "prestashop": {
        "benefits": {
          "button": {
            "text": "Contact Our Team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Open banking payments enable a simplified user experience for your customers. This results in more customer satisfaction and fewer abandoned carts.",
              "title": "Simplicity"
            },
            "2": {
              "icon": "map",
              "text": "Merchants can install Noda’s plugins without a team of developers or any technical skills.",
              "title": "Seamless Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "The open banking functionality ensures security for customers and merchants. Multi-factor verification is a legal requirement under European regulation.",
              "title": "Security"
            },
            "4": {
              "icon": "all_match",
              "text": "Open banking payments are quicker and more affordable for merchants, ensuring a faster checkout experience and fund receipt.",
              "title": "Efficiency"
            }
          },
          "title": "Benefits of Noda for PrestaShop"
        },
        "hero": {
          "button": "Add Noda to PrestaShop",
          "logo": "prestashop",
          "text": "Discover Noda’s PrestaShop plugin. Learn how to integrate Noda as a PrestaShop payment option on your e-commerce website.",
          "title": "PrestaShop Payment Gateway with Noda"
        },
        "how": {
          "text": "Merchants who have installed the plugin will have a Noda button appear on their website when customers are checking out.",
          "title": "How it Works?"
        },
        "inspiration": "You May Also Looking For",
        "integration": {
          "after": "The integration takes just a few clicks and doesn’t require having any developers on your team. With Noda’s PrestaShop payment plugin, merchants can effortlessly elevate their payment strategy with open banking.",
          "before": "To execute the PrestaShop integration with Noda, merchants should follow these simple steps:",
          "steps": {
            "1": "Install the archive file in the admin panel of PrestaShop. This will set up the plugin for your website.",
            "2": "Add API keys, which are available through Noda Hub after completing onboarding.",
            "3": "PrestaShop and Noda are now connected."
          },
          "title": "PrestaShop Payment Gateway Integration"
        },
        "what-is-it": {
          "text": "PrestaShop is an open-source platform that allows merchants to create and develop their own e-commerce websites in the PHP programming language. Noda’s plugin allows merchants to add the open banking functionality as one of their PrestaShop payment methods.",
          "title": "What is it?"
        }
      },
      "section": {
        "subtitle": "Elevate your business with Noda’s open banking plugins for the e-commerce platform you use. Streamline payments with simplified user experience, seamless integration, security and efficiency of open banking.",
        "title": "Boost Your Sales with Noda’s Open Banking Plugins"
      },
      "soon": "Coming soon",
      "woocommerce": {
        "benefits": {
          "button": {
            "text": "Contact Our Team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Our WordPress WooCommerce payment plugin enables a seamless user experience for your customers. This results in more customer satisfaction and lower cart abandonment.",
              "title": "Intuitive UX"
            },
            "2": {
              "icon": "map",
              "text": "Merchants can install Noda’s plugins without a team of developers or any technical skills.",
              "title": "Simple Integration"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "The open banking payments ensure security for customers and merchants. Multi-factor verification is a legal requirement under European regulation.",
              "title": "Security"
            },
            "4": {
              "icon": "all_match",
              "text": "WooCommerce payment processing with open banking is quicker and more affordable for merchants, ensuring a faster checkout experience and fund receipt.",
              "title": "Efficiency"
            }
          },
          "title": "Benefits of Noda for WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "What are the requirements of the WooCommerce plugin?",
              "text": "To successfully integrate Noda’s WooCommerce plugin, please ensure you have a minimum of 7.0.3. PHP version; a WordPress version of at least 5.3 and a WooCommerce version of 4.5 to ensure compatibility. To use the plugin in production mode, you must be onboarded with Noda."
            },
            "2": {
              "summary": "How do I integrate this plugin with Noda?",
              "text": "To integrate the WooCommerce plugin, install the archive file from the WooCommerce admin panel and add the API keys available on NodaHub after onboarding."
            },
            "3": {
              "summary": "How do I test this plugin?",
              "text": "To test this plugin, enable the test mode using the Sandbox keys in the Noda Hub. This will allow you to make a trial run."
            },
            "4": {
              "summary": "Does this plugin support WooCommerce Subscriptions?",
              "text": "No, this plugin does not support WooCommerce Subscriptions."
            }
          },
          "title": "Most Often Asked Questions"
        },
        "hero": {
          "button": "Add Noda to WooCommerce",
          "logo": "woocommerce",
          "text": "Discover Noda’s WordPress plugin. Learn how to integrate Noda as a WooCommerce payment method for your e-commerce business.",
          "title": "WordPress WooCommerce Payment Gateway with Noda"
        },
        "how": {
          "text": "Merchants who install the plugin can add a Noda button as a payment method on their website.",
          "title": "How it Works?"
        },
        "inspiration": "You May Also Looking For",
        "integration": {
          "after": "The integration takes just a few clicks and doesn’t require any developers on your team. With Noda, merchants can effortlessly add open banking payments as one of their WooCommerce payment options.",
          "before": "To set up the WordPress WooCommerce payment plugin with Noda, merchants should follow these simple steps:",
          "steps": {
            "1": "Install the archive file in the admin panel of WooCommerce. This will set up the plugin for your website.",
            "2": "Add API keys, which are available through Noda Hub after completing onboarding.",
            "3": "WooCommerce and Noda are now connected."
          },
          "title": "Noda’s Integration with WooCommerce"
        },
        "what-is-it": {
          "text": "WooCommerce is open-source software built for WordPress, which enables businesses to create e-commerce websites in the PHP programming language. Noda offers a plugin that facilitates open banking payments as a WordPress WooCommerce payment gateway.",
          "title": "What is it?"
        }
      }
    },
    "policy": {
      "last-update": "Last Updated on <data>August 12, 2024</data>",
      "section-1": {
        "text-1": "By using our Service You agree to the Terms of Use and this Privacy Policy.",
        "text-2": "Your responsibility under the Agreement between You and us is to carefully examine this Privacy Policy and provide the correct data about Yourself.",
        "text-3": "Our responsibility is to provide You with the most clear and up-to-date information on how we process Your data.",
        "title": "1. Responsibilities"
      },
      "section-2": {
        "text": "We start collecting Your personal data when You start using our Service or our website. We collect it for the purpose of being able to provide You with our Service and for other purposes as indicated in the Section 3 below.",
        "title": "2. When do We Collect Your Data"
      },
      "section-3": {
        "header-1": "Purpose of using personal data",
        "header-2": "Data subject category",
        "header-3": "Personal data",
        "header-4": "Legal basis",
        "header-5": "Retention term",
        "t-body-10": {
          "legal": "Compliance with a legal obligation",
          "personal": "ID documents, biometric pictures and other biometric identification data, source of funds, information from compliance tools, address, utility bills, transaction history, log files, CVs, migration information and documents, political status, bank account data, related websites, related corporate structure, risk score",
          "purpose": "Monitoring of transactions and compliance",
          "subject": "Persons in the structure of Partners and business clients, ultimate beneficial owners, payers of the merchants",
          "term": "5 years after cooperation termination"
        },
        "t-body-11": {
          "legal": "Legitimate interests to develop the Service",
          "personal": "Full name, email, IBAN, transaction data, logs, IP, session data, location, OS information, device type, information on logins, statistics on how You use the Service",
          "purpose": "Development and testing of the Service and new products",
          "subject": "Payers (natural persons), employees and individual contractors of Noda, representatives of consultants, Partners and merchants",
          "term": "Up to 5 years after the data has become unnecessary"
        },
        "t-body-12": {
          "legal": "Consent",
          "personal": "Full name, transactions list, amount of money, currency, time of payments/date, account balance, merchant name, internal identifiers, IBAN, average turnover of the payer as well as cookies and other trackers. For more information, please see our <a href=\"https://noda.live/about/legal-privacy/cookies\">Cookies policy</a>. ",
          "purpose": "DE (Data Enrichment) product for developing insights. This will help us and our partners (including merchants) to provide you with relevant services, a better user experience and more targeted ads as well as personalized services.",
          "subject": "Payers (natural persons)",
          "term": "<p>Up to 5 years.</p><p>Cookies retention term is set on the <a href=\"https://noda.live/about/legal-privacy/cookies\">Cookies policy</a>.</p>"
        },
        "t-body-13": {
          "legal": "<p>Legitimate interest to promote Noda’s services</p><p>Consent</p>",
          "personal": "Full name, email address, communication",
          "purpose": "Sending marketing emails",
          "subject": "Contact persons of business clients and partners",
          "term": "While cooperation is in force and for 5 years after the cooperation termination (or if there is not cooperation established)"
        },
        "t-body-14": {
          "legal": "<p>Legitimate interest to promote Noda’s services</p><p>Consent</p>",
          "personal": "Full name, social media data, registration number, location, cookies and similar trackers (please see the <a href=\"https://noda.live/about/legal-privacy/cookies\">cookie policy</a>), photo, email address,  ",
          "purpose": "Performing digital campaigns",
          "subject": "Contact persons of business clients and partners",
          "term": "While cooperation is in force and for 5 years after the cooperation termination (or if there is not cooperation established)"
        },
        "t-body-15": {
          "legal": "Legitimate interest to promote Noda’s services",
          "personal": "Full name, email, phone number, place of work, communication description",
          "purpose": "Business development",
          "subject": "Contact persons of Partners, potential partners, business clients and potential business clients",
          "term": "While cooperation is in force and for 5 years after the cooperation termination (or if there is not cooperation established)"
        },
        "t-body-16": {
          "legal": "Legitimate interests to develop the service in line with the state of market",
          "personal": "Full name, nickname, email, gender, geography, IP, employment status, test and research results, video records",
          "purpose": "Performing research and creating better user experience",
          "subject": "Research participants, testers",
          "term": "Up to 10 years"
        },
        "t-body-17": {
          "legal": "<p>Legitimate interest to ensure security and competitive advantage of Noda</p><p>Compliance with a legal obligation</p>",
          "personal": "Information about Your device and other technical information: Your IP address, time zone, geolocation, browser/platform used to access the Service",
          "purpose": "Ensuring security and fraud detection",
          "subject": "Any users of our Service, website and products",
          "term": "Up to 10 years"
        },
        "t-body-18": {
          "legal": "Entering in a contract",
          "personal": "Name, last name, email, phone",
          "purpose": "Concluding agreements",
          "subject": "Representatives of suppliers and clients",
          "term": "Up to 10 years after termination"
        },
        "t-body-19": {
          "legal": "<p>Performing of a contract</p><p>Legitimate interests to receive income</p>",
          "personal": "Name, last name, email, phone, banking and payment details, information from invoices, ID information, agreements and powers of attorney",
          "purpose": "Settling of invoices",
          "subject": "Representatives of suppliers, consultants and individual services providers",
          "term": "Up to 10 years after settling the invoice"
        },
        "t-body-1": {
          "legal": "Entering in a contract and performance of a contract",
          "personal": "Full name, date of birth, address, email, phone, financial and bank data (including but not limited to bank or payment account information, transaction data, loan and investment data), information on bank or another account provider, and other data that can be provided to us by payment account provider ",
          "purpose": "Initiating and processing online payment",
          "subject": "Payers (natural persons)",
          "term": "While the Service is used and up to 10 years after the termination of the Service provision"
        },
        "t-body-20": {
          "legal": "Legitimate interests to sustain business functioning",
          "personal": "Name, last name, email, phone",
          "purpose": "Using services of third parties",
          "subject": "Representatives of suppliers, consultants and individual services providers",
          "term": "Up to 10 years after termination of cooperation"
        },
        "t-body-21": {
          "legal": "<p>Legitimate interests to sustain business functioning</p><p>Compliance with a legal requirement</p>",
          "personal": "Name, last name, email, phone, ID code, address, information on the relation to the relevant companies",
          "purpose": "Performing of corporate deals",
          "subject": "Representatives and employees of relevant companies and involved companies",
          "term": "While a corresponding company exists and for up to 10-80 years after depending on the local requirements"
        },
        "t-body-22": {
          "legal": "Legitimate interests to protect the position of Noda",
          "personal": "Any personal data required for the resolution of the corresponding conflict or litigation",
          "purpose": "Conflict resolution",
          "subject": "Any data subjects",
          "term": "While a corresponding conflict exists and up to 10 years after its resolution"
        },
        "t-body-23": {
          "legal": "Compliance with a legal obligation",
          "personal": "Any personal data that is in the documents subject to archiving requirements",
          "purpose": "Archiving and storing documents",
          "subject": "Any data subjects",
          "term": "Based on the local requirements"
        },
        "t-body-2": {
          "legal": "Entering in a contract and performance of a contract",
          "personal": "Full name, email, phone number, communication",
          "purpose": "Initiating and processing online payment",
          "subject": "Representatives of business clients who use Noda payment services",
          "term": "While the Service is used and up to 10 years after the termination of the Service provision"
        },
        "t-body-3": {
          "legal": "<p>Entering in a contract and performance of a contract</p><p>Legitimate interest of Noda to comply with the card processing infrastructure requirements</p>",
          "personal": "Transaction details, card number, expiration data, place of payment, amount of transaction, frequency of transactions, services or goods purchased, IP, email, additional information about the purchase",
          "purpose": "Providing card processing services",
          "subject": "Payers (natural persons)",
          "term": "While the Service is used and up to 10 years after the termination of the Service provision"
        },
        "t-body-4": {
          "legal": "Entering in a contract and performance of a contract",
          "personal": "Full name, email, phone, bank or payment services provider represented",
          "purpose": "Providing card processing services",
          "subject": "Representatives of Partners",
          "term": "While the Service is used and up to 10 years after the termination of the Service provision"
        },
        "t-body-5": {
          "legal": "<p>Entering in a contract and performance of a contract</p><p>Compliance with a legal obligation</p>",
          "personal": "Bank account information, email and compliance data as indicated below",
          "purpose": "Onboarding of merchants",
          "subject": "Representatives of merchants, persons related to the corporate structure of merchants",
          "term": "While the cooperation is in force and up to 10 years after its termination"
        },
        "t-body-6": {
          "legal": "<p>Legitimate interest in providing end-users with a possibility to use the Service</p><p>Compliance with a legal obligation</p>",
          "personal": "Full name, date of birth, address, email, phone, information on transactions, internal reference number, IBAN, information on the used merchant, payment details, log files, information on opt-out lists",
          "purpose": "Provision of customer support service",
          "subject": "Payers (natural persons)",
          "term": "While the communication takes place and up to 10 years after an issue is resolved"
        },
        "t-body-7": {
          "legal": "<p>Performance of a contract</p><p>Legitimate interest in providing clients with a qualitative Service</p>",
          "personal": "Any personal data provided through communication channels, including chatbot",
          "purpose": "Providing business support services",
          "subject": "Representatives of business clients or Partners who use Noda payment services or cooperate with Noda",
          "term": "While the communication takes place and up to 10 years after an issue is resolved"
        },
        "t-body-8": {
          "legal": "Legitimate interest in providing clients with a qualitative Service",
          "personal": "Full name, email, phone",
          "purpose": "Notification on updates",
          "subject": "Representatives and contact persons of business clients",
          "term": "Up to 10 years after the notification has been sent"
        },
        "t-body-9": {
          "legal": "<p>Compliance with a legal obligation<p></p>Legitimate interest to establish partnerships with other businesses</p>",
          "personal": "ID documents, biometric pictures and other biometric identification data, source of funds, information from compliance tools, address, utility bills, transaction history, log files, CVs, migration information and documents, political status, bank account data, related websites, related corporate structure, risk score, information on tax payments",
          "purpose": "Compliance checks for compliance with Noda obligations, for onboarding with Partners and compliance with the requirements of the Partners, compliance checks for the payers of merchants ",
          "subject": "Persons in Noda corporate structure, persons in the structure of Partners and business clients, ultimate beneficial owners, payers of the merchants",
          "term": "From 5 to 10 years after cooperation termination"
        },
        "text": "Depending on how You decide to Use the Service or whether Your subscribe or not, we may use the following data about You in accordance with the description below:",
        "text-bottom": "Whether the provision of personal data is required to comply with a legal obligation or conclude/perform a contract, but You do not provide us with the required information, we have the right to refuse providing the corresponding Service, entering into a contract or perform a contract without any negative legal consequences.",
        "title": "3. Data We Collect, Purposes, Legal Basis and Retention Terms"
      },
      "section-4": {
        "list-1": {
          "item-1": "Payment account and similar services providers (banks, card issuers, etc. - \"<b>Partners</b>\"); ",
          "item-2": "Third parties and service You choose to use in connection with the Service (for example, e-commerce sites through which You use our Service, or “<b>merchants</b>”);",
          "item-3": "Our trusted data aggregation partners (licensed open banking platforms);",
          "item-4": "Our group companies;",
          "item-5": "Our services providers like accounting, auditors, data storage and processing services, online communication and collaboration services providers, legal services providers, AML and sanctions screening services providers, anti-fraud monitoring services, corporate data databases, accounting services providers, developers and testers, marketing services providers, social media, e-commerce platforms and others.",
          "item-6": "Regulators, supervisory authorities, courts and other authorized public or similar bodies (like ombudsmen, financial regulators, gambling regulators)."
        },
        "list-2": {
          "item-1": "You or your employer;",
          "item-2": "Merchants;",
          "item-3": "E-commerce platform, social media and search engines;",
          "item-4": "Regulators, supervisory authorities, courts and other authorized public or similar bodies (like ombudsmen, financial regulators, gambling regulators);",
          "item-5": "AML and sanctions screening services providers, anti-fraud monitoring services;",
          "item-6": "Event organizers (such as conferences, seminars and other);",
          "item-7": "Professional associations;",
          "item-8": "Public registers and compliance services providers."
        },
        "text-1": "To effectively run our Service, we must partner with third parties and, therefore, we may exchange Your data with:",
        "text-2": "We also receive your personal data from:",
        "title": "4. Recipients and Sources of Your Data"
      },
      "section-5": {
        "text": "Where Noda transfers Your personal data outside of the EU or EEA, we rely on the guarantees provided by the applicable legal acts, for example, as the EU General Data Protection Regulation (GDPR) provides: the adequacy decisions of the European Commission (Article 45 of the GDPR), standard contractual clauses and other safeguards provided by Articles 46 and 49 of the GDPR. If personal data is transferred to the US, Noda may rely on the corresponding personal data transfer framework in force. In certain cases, depending on the involved Noda entity, Noda might also rely on the UK International Data Transfer Addendum to the EU Commission Standard Contractual Clauses.",
        "title": "5. International Transfers of Your Personal Data"
      },
      "section-6": {
        "list": {
          "item-1": "The right to know what kind of data we collect about You and how do we process it. You can also read how we use Your personal data in the Section 3.",
          "item-2": "The right to request certain data to be erased. Please note that upon such a request we might not be further able to provide You with the Service (fully or partially).",
          "item-3": "Restrict processing of Your data, object to the processing of Your personal data and withdraw consent, where applicable without affecting the lawfulness of processing based on consent before its withdrawal.",
          "item-4": "The right not to provide any personal data to Us. In this case, we might not be able to provide our Service to You, fully or partially."
        },
        "text-1": "You have the following rights with regards to Your personal data:",
        "text-2": "If You are unhappy with how we process Your personal data, You can always submit a complaint to use by writing to <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>. If You consider that we are unable to handle Your request in accordance with the applicable law, You can lodge a complaint with a relevant supervisory authority. If You are located in the EU, the list of the supervisory authorities is accessible <a href=\"https://www.edpb.europa.eu/about-edpb/about-edpb/members_en\" target=\"_blank\" rel=\"nofollow\">here</a>. ",
        "title": "6. Your Rights"
      },
      "section-7": {
        "text-1": "If you have any questions, comments or complaints on how we use Your data, please send them to <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "text-2": "There can be other controllers of your personal data described in this Privacy Policy, except for NAUDAPAY LIMITED.",
        "text-3": "For more information, please contact us at <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "title": "7. Contact Details"
      },
      "section-8": {
        "text": "We may change the Privacy Policy, from time to time, in accordance with the changes in the applicable laws and regulations or changes in our business procedures. Thus, we suggest that You check this page for the newest updates, from time to time.",
        "title": "8. Changes to the Privacy Policy"
      },
      "subtitle": "About Our Data Usage and Controller",
      "text-1": "At Noda.live (\"we\", \"us\", \"our\", \"Noda\"), we respect Your privacy and data security. We aim to provide clear information on how we will use Your data and how You can control that. Therefore, we strongly suggest that You carefully read this Privacy Policy before using services provided by us (collectively, the \"<b>Service</b>\").",
      "text-2": "In case You have any further questions or concerns please feel free to reach out to <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>, we will be happy to address them.",
      "text-3": "This Privacy Policy, along with the Terms of Use shall constitute the entire Agreement (further - \"<b>Agreement</b>\") between You and Noda.",
      "text-4": "The main controller of your personal data is NAUDAPAY LIMITED, UK registration number: 11741664. In separate cases other companies from our group can also be controllers of Your personal data described in this Privacy Policy. Please look for additional information and contact details at the end of this Privacy Policy.",
      "title": "Privacy Policy"
    },
    "privacy-for-candidates": {
      "last-update": "Last Updated on June 1, 2024",
      "section-1": {
        "text-1": "Noda uses your personal data to find a person suitable for a currently or future open position at Noda or its group companies or to receive services that you provide.",
        "text-2": "If you are an individual contractor Noda can use your personal data to perform a compliance check depending on the requirements of the applicable law (for example, in the sphere of money-laundering). If you do not provide Noda with personal data required for such compliance checks, Noda might not be able to work with you as a contactor.",
        "text-3": "If Noda considers that you are a matching candidate for a job, internship or cooperation, Noda will need your personal data to provide you with a job, internship or cooperation offer.",
        "text-4": "In cases where you submit a request, complaint or there might be a potential dispute, Noda might use your personal data to resolve the issue.",
        "title": "Why does Noda need your Data?"
      },
      "section-2": {
        "text": "This section describes the personal data used for the said purposes, legal bases for using them and retention terms.",
        "title": "How does Noda Treat your Data?"
      },
      "section-3": {
        "list": {
          "item-1": "Noda group companies",
          "item-2": "Data storage services providers",
          "item-3": "Electronic communication services providers (such as email services)",
          "item-4": "Recruiters and similar services providers, including HR and recruitment platforms",
          "item-5": "LinkedIn and similar social media platforms",
          "item-6": "Compliance services providers",
          "item-7": "Other outsource services providers (such as legal consultants, event organizers and others)",
          "item-8": "Regulators, enforcement authorities, courts, arbitration organizations and other similar public or private entities"
        },
        "text-1": "Noda receives your Personal Data from you, your LinkedIn and similar social media profiles, recruiters and referring parties. In cases where you act as an individual contractor, Noda also can get your personal data from different compliance services providers.",
        "text-2": "Noda can also share your personal data with the following recipients:",
        "title": "Sources and Recipients of Data"
      },
      "section-4": {
        "text": "Noda does not generally transfer personal data outside of the European Union and European Economic Area within the recruitment process. However, it can happen where you or referencing parties are located outside of the said territories. Also, such transfers can take place in the event of compliance checks for individual contractors. Where such transfers happen, we rely on the guarantees provided by the applicable legal acts, for example, as the EU General Data Protection Regulation (GDPR) provides: the adequacy decisions of the European Commission (Article 45 of the GDPR), standard contractual clauses and other safeguards provided by Articles 46 and 49 of the GDPR. If personal data is transferred to the US, Noda may rely on the corresponding personal data transfer framework in force. In certain cases, depending on the involved Noda entity, Noda might also rely on the UK International Data Transfer Addendum to the EU Commission Standard Contractual Clauses.",
        "title": "International Transfers"
      },
      "section-5": {
        "list": {
          "item-1": "access to your personal data or issue a copy of your personal data;",
          "item-2": "correct your personal data, if there are any mistakes;",
          "item-3": "delete your personal data, where Noda’s legitimate interest is not in force. You cannot request to delete the data used due to the regulatory requirements;",
          "item-4": "object against the using of your personal data, where it is based on legitimate interests;",
          "item-5": "that the processing of your personal data is restricted;",
          "item-6": "submit a complaint to Noda by using the contact information provided below. If Noda does not comply with your request, you can also submit a complaint to a data protection supervisory authority."
        },
        "text": "You can request to:",
        "title": "Data Protection Rights"
      },
      "section-6": {
        "text-1": "The controller of your personal data is Noda entity that you are proposed to enter into an agreement with or that is looking for a job candidate or a potential cooperation partner. For more information, please contact Noda by using the email below.",
        "text-2": "If you have any questions or requests with regards to your personal data, please use the following contact information: <a class=\"link highlighted\" href=\"mailto:dpo@noda.live\">dpo@noda.live</a>",
        "title": "Contact Information"
      },
      "subtitle": "About the Notice and Noda",
      "text-1": "This notice explains how Noda treats the personal data of potential employees, interns who applied or were invited to apply for open positions at Noda or to cooperate with Noda as individual contractors.",
      "text-2": "Noda is the controller of your personal data. The information and contact details of Noda are available at the end of this notice.",
      "title": "Privacy Notice for Job Candidates or Cooperation"
    },
    "retail": {
      "faq": {
        "countries": {
          "content": "We work with 2000+ banks across 28 countries, including the Netherlands, Portugal, Belgium, Germany, Poland, Bulgaria, France, Ireland, Italy, Austria, Spain, Denmark, Estonia, the UK, Luxembourg, Romania, Lithuania, Hungary, Latvia, Finland, Sweden, Norway, Czech Republic, Slovakia, Greece and Slovenia.",
          "title": "What countries does Noda work in?"
        },
        "currencies": {
          "content": "Noda supports a variety of global currencies, including EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON and SEK.",
          "title": "What currencies does Noda support?"
        },
        "integration": {
          "content": "First, you should be onboarded with Noda. Simply fill out the form, and our sales team will contact you shortly. We offer easy onboarding with the personalised guidance of a dedicated manager. Our retail payments system integrates with APIs and front-end components, smoothly merging into your retail market space.",
          "title": "How can I integrate Noda into my payment workflow?"
        },
        "subtitle": "Your questions answered",
        "title": "FAQs"
      },
      "hero": {
        "text": "Elevate your retail business&nbsp;with Noda’s payment gateway. Focus on strategy while we streamline transactions. Our all-in-one platform prioritises customer understanding, efficiency, and growth",
        "title-1": "Payment Gateway",
        "title-2": "for Retail with Noda"
      },
      "how-does-it-work": {
        "subtitle": "Technologies",
        "text-1": "A payment&nbsp;gateway securely transmits financial data between customers, retail shops, and banks. Think of it as a digital conductor guiding each step of credit card processing",
        "text-2": "Noda is a worldwide payment platform and open banking provider. From secure gateways to transaction management and financial analytics, Noda has got you covered. Our platform uses AI and machine-learning technologies to provide state-of-the-art solutions for the retail industry",
        "title": "How Does Retail Payment Gateway Work?"
      },
      "how-to-start": {
        "subtitle": "Easy Onboarding",
        "text": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our platform smoothly integrates with APIs and front-end components, ensuring seamless merging into your retail platform. To start using Noda, fill out the form below, and our sales representatives will contact you shortly. Our team is here to help with any roadblocks",
        "title": "How to Start"
      },
      "open-banking": {
        "subtitle": "A lot of possibilities",
        "text": "Open banking means traditional banks share data with licensed fintech&nbsp;companies, like Noda, to streamline transactions. Our payment ecosystem connects all leading banks across the UK and EU, facilitating effortless retail payment processing services",
        "title": "What is Open Banking?"
      },
      "payment-processing": {
        "subtitle": "Best deals",
        "text": "Streamline pay-ins and pay-outs, leverage intuitive UX, smart routing and offer a variety of popular payment methods",
        "title": "Retail Payment Processing"
      },
      "payments": {
        "text": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "title": "Toolset for Retail"
      },
      "scalable-plans": {
        "subtitle": "More benefits",
        "text": "We offer retail payment solutions for all company sizes, with scalable plans available to support your business growth",
        "title": "Scalable Plans"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Leverage our data-driven insights. Noda’s tools offer ready-to-use analytics of client behaviour, including segmentation and forecasting algorithms",
            "title": "AI-Powered Analytics"
          },
          "banking": {
            "content": "Enhance customers’ experience and ease transaction&nbsp;flow with the power and security of open&nbsp;banking payments",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda works with multiple currencies to support your clients around the world",
            "title": "Global Currencies"
          },
          "security": {
            "content": "Noda provides a secure retail gateway, ensuring PCI DSS compliance, encryption and fraud prevention",
            "title": "Security"
          }
        },
        "subtitle": "What we offer",
        "title": "Top Features for Retail"
      }
    },
    "saas": {
      "faq": {
        "countries": {
          "content": "We work with 2000+ banks across 28 countries, including the Netherlands, Portugal, Belgium, Germany, Poland, Bulgaria, France, Ireland, Italy, Austria, Spain, Denmark, Estonia, the UK, Luxembourg, Romania, Lithuania, Hungary, Latvia, Finland, Sweden, Norway, Czech Republic, Slovakia, Greece and Slovenia.",
          "title": "What countries does Noda work in?"
        },
        "currencies": {
          "content": "Noda supports a variety of global currencies, including EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON and SEK.",
          "title": "What currencies does Noda support?"
        },
        "how-to-integrate": {
          "content": "First, you should be onboarded with Noda. Simply fill out the form, and our sales team will contact you shortly. We offer easy onboarding with the personalised guidance of a dedicated manager. Our SaaS payments system integrates with API and front-end components smoothly, ensuring seamless merging into your platform.",
          "title": "How can I integrate Noda into my payment workflow?"
        },
        "subtitle": "your questions answered",
        "title": "FAQs"
      },
      "hero": {
        "text": "Elevate your Software-as-a-Service (SaaS) business. Take care of clients while we streamline SaaS payments. Our all-in-one platform prioritises customer understanding, efficiency, and growth",
        "title-1": "Payment Gateway",
        "title-gradient-1": "for SaaS with Noda"
      },
      "how-to-start": {
        "subtitle": "Easy Onboarding",
        "text": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our platform smoothly integrates with API and front-end components, ensuring seamless merging into your software. To start using Noda, fill out the form below, and our sales representatives will contact you shortly. Our team is here to help with any roadblocks",
        "title": "How to Start"
      },
      "open-banking": {
        "subtitle": "A lot of possibilities",
        "text": "Open banking means traditional banks share data with licensed fintech companies, like Noda, to streamline transactions. Our payment ecosystem connects all leading banks across the UK and EU, facilitating effortless SaaS payment processing services",
        "title": "What is Open Banking?"
      },
      "payments": {
        "text": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "title": "Toolset for SaaS"
      },
      "technologies": {
        "text-1": "A payment gateway securely transmits financial data between clients, merchants, and banks.\n      Think of it as a digital conductor guiding each step of SaaS credit card processing",
        "text-2": "Noda is a worldwide payment platform and open banking provider. From secure processing to\n      transaction management and financial analytics, Noda has got you covered. Our platform uses AI\n      and machine-learning technologies to provide state-of-the-art solutions",
        "title": "technologies",
        "title-1": "How Does SaaS Payment",
        "title-2": "Gateway Work?"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Leverage our data-driven insights. Noda’s tools offer ready-to-use analytics of client behaviour, including segmentation and forecasting algorithms",
            "title": "AI-Powered Analytics"
          },
          "banking": {
            "content": "Enhance customers’ experience and ease transaction&nbsp;flow with the power and security of open&nbsp;banking payments",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda works with multiple currencies to support your SaaS clients around the world",
            "title": "Global Currencies"
          },
          "payment-processing": {
            "content": "Streamline pay-ins and pay-outs, leverage intuitive UX, smart routing and offer a variety of popular payment methods",
            "title": "SaaS Payment Processing"
          },
          "scalable-plans": {
            "content": "We offer SaaS payment solutions for all company sizes, with scalable plans available to support your business growth",
            "title": "Scalable Plans"
          },
          "security": {
            "content": "Noda provides a secure payment gateway, ensuring PCI DSS compliance, encryption and fraud prevention",
            "title": "Security"
          }
        },
        "subtitle": "our offers",
        "title": "Top Features"
      }
    },
    "security": {
      "faq": {
        "contact": {
          "complex-content": {
            "p1": "Should you experience any difficulties with Noda’s services, we suggest the following channels for support:",
            "p2": "<b>Skype/Telegram Group Chat:</b> We established a dedicated group chat to facilitate seamless communication. If you have questions about integration or encounter technical problems, don’t hesitate to send a message to the group and tag us at",
            "p3": "<b>Personal Manager:</b> For inquiries not related to technical support, feel free to contact your personal manager directly in the group chat or through a private message.",
            "p4": "<b>Email Support:</b> Both merchants and their customers can reach us at",
            "p5": "Remember, we’re always ready to assist you!"
          },
          "title": "I have an issue with Noda’s services; who can I contact?"
        },
        "knowledge": {
          "complex-content": {
            "l1": "<b>Bank-level security:</b> Open banking employs rigorously tested software and security systems. Consumers are never required to share their bank login details or passwords with anyone except their own bank.",
            "l2": "<b>Regulation:</b> Only apps and websites regulated by the UK’s Financial Conduct Authority (FCA) or equivalent institutions in Europe are permitted to use open banking.",
            "l3": "<b>Control over data:</b> Customers have the power to decide when and for how long they share their data. They can also revoke this access at any time through their banks.",
            "p1": "Open banking is designed with a strong focus on security, ensuring it’s completely safe for your customers. Here are some of its key security features:"
          },
          "title": "How do I know open banking is safe?"
        },
        "safe": {
          "content": "Yes, Noda is safe. Thousands of end consumers trust Noda to securely make payments through their preferred banks, where they confidently store their money. Noda never shares consumer data without their explicit consent. Simultaneously, we take every measure to ensure their data is protected at every step.",
          "title": "Is Noda safe?"
        },
        "secure": {
          "content": "Yes, Noda is secure. As previously mentioned, Noda is designed not only to be safe but also to continuously monitor its security levels. We employ a multi-layered approach to significantly reduce the risks of hacking and data breaches. For instance, we utilise leading encryption protocols, top-tier cloud infrastructure providers, multi-factor authentication, and conduct around-the-clock comprehensive monitoring of our services.",
          "title": "Is Noda secure?"
        },
        "test": {
          "complex-content": {
            "l1-1": "Account number",
            "l1-2": "Full name",
            "l2-1": "Identity information",
            "l2-2": "Account balances",
            "l2-3": "Transaction history for 90 days",
            "p1": "Noda serves both as a Payment Initiation Service Provider (PISP) and Account Information Services Provider (AISP). In the first case, we provide your client with Payment Initiation Services (PIS). What this essentially means is that Noda will facilitate the payment process for your clients by transferring funds directly from their linked payment account(s) to the chosen beneficiary upon their explicit consent. In this case, Noda accesses the following data:",
            "p2": "Consequently, this data can be used as input values for Noda’s internal algorithms, and it can be shared with merchants to confirm that the payment was successful.",
            "p3": "In the second case, the Account Information Service (AIS) enables Noda to access and view information about all online banking accounts in one place and analyses your clients’ financial information upon their consent. In this case, Noda has access to the following data:",
            "p4": "Consequently, this data can be used to improve Noda’s internal algorithms. It can also be shared with merchants in an aggregated form – for example, as a scoring value showing which payment category a user is identified with (from 1 to 5)."
          },
          "title": "What data can Noda access and share?"
        }
      },
      "hero": {
        "desc-1": "Payment and data security should always be a priority. On this page, you will find detailed information about our security measures and our approach to processing and sharing your data.",
        "desc-2": "We provide an overview of our security features and our commitment to data privacy. Additionally, we offer insights into our licensing and the management of data across different licenses.",
        "title": "Security & Data Handling"
      },
      "strategy": {
        "alert": {
          "text": "Our automated alert systems allow us to respond instantly to the threats occurring at night, on weekends, on public holidays, or during other non-working hours.",
          "title": "Automated Alerts System"
        },
        "bug-bounty": {
          "text": "<p class=\"paragraph\">Our bug bounty program welcomes any developers who identify as a hackers. If you or your colleagues discover any flaws, shortcomings, or vulnerabilities in our security systems or have suggestions to enhance the functionality of Noda API endpoints, you can participate in our program and receive a reward.</p><p class=\"paragraph\">To report an issue or make a suggestion, simply email our security team at <a class=\"link\" href=\"mailto:security@noda.live\">security@noda.live</a>.</p>",
          "title": "Bug Bounty Program"
        },
        "certification": {
          "text": "<p class=\"paragraph\">Noda regularly obtains relevant certifications and maintains up-to-date PCI DSS and PCI SSLC licenses. Payment Card Industry Data Security Standard (PCI DSS) is the industry benchmark aimed at reducing payment fraud by enhancing data protection controls.</p><p class=\"paragraph\">Meanwhile, the PCI Secure Software Lifecycle Standard (PCI SLLC) ensures that payment software vendors incorporate security throughout the software development lifecycle, producing applications that are secure by design and robust against attacks. These licenses are administered by the PCI Security Standards Council (PCI SSC).</p>",
          "title": "Certification"
        },
        "cloud": {
          "text": "<p class=\"paragraph\">Noda uses cloud infrastructure to build our applications and services. Modern cloud service providers are some of the most secure globally, investing millions of dollars to ensure the highest safety standards. Plus, they continuously upgrade and refine their systems to make them even more impenetrable and secure.</p/><p class=\"paragraph\">Working with well-known global providers of cloud infrastructure security is the key factor for building Noda’s information security programme.</p>",
          "title": "Use of Cloud Infrastructure Providers"
        },
        "encryption": {
          "text": "<p class=\"paragraph\">Noda encrypts all sensitive data simultaneously on two layers. We use the Transport Layer Security (TLS) protocol when information is transferred between network servers, and we apply the Advanced Encryption Standard (AES) when the data is stored.</p/><p class=\"paragraph\">Utilising this two-layered encryption approach enables us to minimise potential safety concerns as sensitive data remains encrypted even on those rare occasions when one of the components is compromised.</p>",
          "title": "Data Encryption Approach"
        },
        "mfa": {
          "text": "<p class=\"paragraph\">At Noda, we understand that achieving maximum information security requires focusing on both external and internal environments. That's why we implement Multi-Factor Authentication (MFA) for our employees to access all critical internal platforms.</p><p class=\"paragraph\">MFA adds an extra layer of authentication, which helps prevent unauthorised access to data through internal systems.</p>",
          "title": "MFA"
        },
        "monitoring": {
          "text": "<p class=\"paragraph\">All components of Noda’s products, including Noda API, are being continuously monitored and inspected by our IT security team.</p><p class=\"paragraph\">This team consists of IT experts who regularly attend professional conferences and engage in ongoing education within their field.</p>",
          "title": "Information Security Team Monitoring"
        },
        "support": {
          "text": "Noda's round-the-clock support team swiftly resolves connectivity issues for specific clients and also collects suggestions for improving Noda's systems. We are always here and ready to help.",
          "title": "24/7 Tech Support Team"
        },
        "text": "Noda’s strategy for building an information security program involves a dual approach. Firstly, we focus on robust security for our own systems and servers. Secondly, we implement a multilayered security approach to ensure the highest level of safety for both your data and the data of your clients. Find the key features of our security programme below.",
        "title": "Noda Security"
      }
    },
    "tabs": {
      "banner": {
        "account-balances": "Account balances",
        "account-number": "Account number",
        "full-name": "Full name",
        "identity-information": "Identity information",
        "text": "With the customer’s consent, Noda can access and utilise the following data in its algorithms:",
        "title": "Types of data your customers can share with Noda",
        "transaction-history": "Transaction history for 90 days"
      },
      "tab-step-text": {
        "after-the-confirmation": "After the confirmation, Noda receives the user’s account number as well as the amount and the currency of the payment.",
        "after-the-consent": "After the consent, Noda is able to access their financial account and some of their financial data.",
        "consequently-this-data": "Consequently, this data can be used as input values for Noda’s internal algorithms and it can be shared with merchants to confirm that the payment was successful.",
        "consequently-this-data-form": "Consequently, this data can be used to improve Noda’s internal algorithms. It can also be shared with merchants in an aggregated form — for example, as a scoring value showing which payment category a user is identified with (from 1 to 5).",
        "the-buyer-initiates": "The buyer initiates the payment and completes authentication by their chosen bank.",
        "when-the-authentication": "When the authentication by the bank is finalised, the bank requests transaction confirmation.",
        "when-the-authentication-consent": "When the authentication by the bank is finalised, the bank requests them to consent that Noda will access their financial and profile data."
      },
      "tab-title": {
        "automated-access": "Automated access to a user’s IBAN via authorisation directly by bank",
        "insert-iban": "Insert IBAN for manual payment"
      },
      "tag-subtitle": "TECH FRIENDLY",
      "text": "At Noda, we care about your customers and process their data with the utmost care. Here’s what happens when your customers make a payment or onboard via our services.",
      "title": "Noda Handles Your<br/>Customers’ Data"
    },
    "terms": {
      "last-update": "Last Updated on <data>August 23, 2024</data>",
      "section-1": {
        "text-1": "These Terms of Use shall serve as a legally binding contract between its Users (\"You\", \"User\", \"Customer\") and Noda, therefore, we suggest reading the document carefully. The Terms of Use, along with the Privacy Policy shall constitute the entire Agreement (further - \"Agreement\") between You and Noda. All the services described below are the services provided by Noda and shall be collectively referred to as the \"Service\". By using the Service, You acknowledge that You accept and agree to be bound by the terms in the Agreement. These Terms of Use are always accessible on our website <a href=\"https://noda.live\">https://noda.live.</a>",
        "text-2": "Noda grants You a limited, revocable, non-exclusive, non-transferable license to access and use the Service for Your own individual use, subject to the other terms of this Terms of Use. All rights, title, and interest in and to the Service not expressly granted herein are reserved by Noda.",
        "text-3": "The Agreement is concluded for an indefinite time.",
        "text-4": "We may, from time to time, make changes and adjustments to the Terms of Use. Should You not agree to any provisions of the Agreement, we suggest that You stop using the Service and terminate these Terms of Use free of charge.",
        "text-5": "These Terms of Use are prepared in English, and the main communication is usually performed in English language.",
        "text-6": "At any time while the Agreement is in force, You have a right to receive, on request, these Terms of Use.",
        "title": "1. The Agreement"
      },
      "section-2": {
        "list-1": {
          "item-1": "a reference enabling you to identify each payment transaction and, where appropriate, the payee;",
          "item-2": "the amount of the payment transaction in the currency in which your Payment Account is debited or in the currency used for the payment order;",
          "item-3": "where applicable, the exchange rate used in the payment transaction, and the amount of the payment transaction after that currency conversion;",
          "item-4": "the debit value date or the date of receipt of the payment order."
        },
        "list-2": {
          "item-1": "The Service will meet Your requirements;",
          "item-2": "The Service will be uninterrupted, timely, secure, or error-free;",
          "item-3": "The results that may be obtained from the use of the Service will be accurate or reliable;",
          "item-4": "The quality of any products, services, information, or other material purchased or obtained by You through the Service will meet Your expectations; or",
          "item-5": "Any errors in the technology will be corrected."
        },
        "text-1": {
          "line-1": "In the scope of this Agreement between You and us, Noda serves as a Payment Initiation Service Provider (\"PISP\") and Account Information Service Provider (“AISP”) and we will provide You with Payment Initiation Services (\"PIS\") and Account Information Services (“AIS”). What it essentially means, we will facilitate the payment process for You by initiating a transaction directly from Your linked Payment Account(s) to the chosen beneficiary, upon Your explicit consent and provide you with information on Your linked Payment Account(s).",
          "line-2": "After You select a Payment Account provider or a Bank account provider (both further individually referred to as a \"Partner\") You want to link and/or make a payment from, You will be redirected to its official page (either in the app or in a browser) where You will need to undergo a verification process.",
          "line-3": "As AISP we will enable You to access and view information about all Your online banking accounts in one place, and analyze Your financial information to help You spend, save, borrow, and track Your funds flows more efficiently.",
          "line-4": "Noda does not provide any banking and or payment account services. Thus, Your chosen Payment Account provider is solely responsible for the execution of payments and any flaws in the functionality of its services. Nevertheless, if we consider that we are lacking permissions or for any reason providing our services to You would be unlawful we may choose not to provide the Service to You.",
          "line-5": "Within the scope of this Agreement and within the boundaries You allow us to, we will share Your Payment Account information with other services and third parties of Your choice. Once such a partner gets access to Your information it automatically becomes responsible for it and the information becomes a subject to Your agreement with the corresponding partner and its privacy policy.",
          "line-6": "We will only have access to any of the Payment Accounts You link if You provide Your consent for it and only within the scope of the service we provide.",
          "line-7": "You may require the following information to be provided or made available periodically, at least once a month, free of charge:"
        },
        "text-2": "The Service shall be provided \"as is\" and on the \"as available\" basis. We do not make any warranty that: ",
        "text-3": "Once you have initiated the payment, the payment initiation will be transmitted immediately. Once you have authorized the payment with your bank you will not be able to cancel it. Funds will usually leave your payment account within 2 (two) hours of successful initiation, although it could be longer depending on how long your bank takes to execute the payment order. We will confirm the successful initiation of the payment order. But it is your bank (not Noda) who is responsible for executing it.",
        "title": "2. Service We Provide"
      },
      "section-3": {
        "list": {
          "item-1": "You are at least 18 years old and have the legal capacity and authority to enter into a contract",
          "item-10": "You may not decompile or disassemble the Service or use it, not in accordance with the purposes as per Agreement;",
          "item-11": "You may not access the Service with the purpose of facilitating competitor products or services;",
          "item-12": "Any forbidden use shall immediately terminate Your license to the Service.",
          "item-2": "You will only use the Service as an individual and purely for private purposes;",
          "item-3": "You will not use the Service for any fraudulent purpose;",
          "item-4": "You will not use the Services for any other unlawful purpose;",
          "item-5": "You agree to our <a href=\"https://noda.live/about/legal-privacy/policy\">Privacy Policy;</a>",
          "item-6": "You are responsible for keeping Your credentials safe and secure;",
          "item-7": "You may not disclose Your credentials to any third party. To the extent allowed by the applicable law, You shall be liable for any expenses and reasonable attorney's fees for Your failure to safeguard any credentials and/or promptly notify Noda about unauthorized use of Your Payment Account or any other account or compromising of Your Payment Account (or any other account) information or password;",
          "item-8": "You will not use a false or stolen identity. You represent and warrant that all the information provided by You within the scope of this Agreement is true and accurate;",
          "item-9": "You may not resell or otherwise transfer the rights to use the Service;"
        },
        "text-1": "By using our provided services You represent and consent that:",
        "text-2": {
          "line-1": "In case You become aware of the loss, theft, misappropriation or unauthorized use of our Service or any part of it, impersonation fraud, unauthorised or incorrectly initiated or executed payment transaction or of any authorised credit transfer made following an incorrect application of the name and unique identifier matching verification service, please contact us as soon as possible but not later than within 5 business days at <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>.  Also, please consider notifying the police, especially in case of impersonation fraud and other transaction made in your name without your authorization. In case of such events You are also liable and responsible for taking action for keeping Your information secure.",
          "line-2": "If You do not notify us on an unauthorized or incorrectly executed transaction, You might not be entitled to receive a redress for such unauthorized or incorrectly executed transaction.",
          "line-3": "In case we consider that there is an actual or suspected fraud or serious security threat, we will contact you by using the contact information provided by You while using our Service."
        },
        "title": "3. Access to the Service and Communication on Suspicious Activities"
      },
      "section-4": {
        "text": {
          "line-1": "To have full access to the Service, You must choose the banks or other Payment Account providers that You would like to connect or authorize us to make payments from. Once You choose a Partner, we will redirect You to its webpage where You will be taken through a secure process to access information from Your Payment Accounts (here and elsewhere in the Agreement \"Payment Account\" shall refer to an account created with a Partner). You will be asked to provide Your explicit consent to enable Us to access Your financial data.",
          "line-2": "In order to access the Service you should provide us with the information referred in the Privacy Policy. The unique identifier used to make sure that a payment order is properly initiated and executed is Your email or IBAN or ID of payment or customer ID or payment reference depending on each specific case. In case You provide us with an incorrect or wrong identifier, we might charge for recovering the funds involved in the corresponding payment transaction.",
          "line-3": "You consent that You grant Noda a non-exclusive, royalty-free licence to use the information in Your Payment Accounts for all purposes connected with the Service or referred to in these Agreement, with the right to use, modify, display, distribute and create new material using or incorporating such information to provide the Service to You. We guarantee that we shall not use or access Your data for any other purposes, unless otherwise prescribed by law. To keep Your data safe and Your consent up-to-date, we might periodically ask You to renew Your consent.",
          "line-4": "You agree that when we retrieve Your information relating to Your Payment Accounts or Your information required as part of the provision of the Service, We are doing so as Your representative and on Your behalf and not on behalf of or in the name of any third party.",
          "line-5": "By using the Service, You represent that You are the legal owner of the data in Your Payment Accounts and that You have the authority to appoint, and do expressly appoint us and/or our third-party providers as Your agent and grant a limited power of attorney to access and retrieve such data on Your behalf.",
          "line-6": "For our compliance purposes and in order to provide the Service to You, You hereby authorize us to, directly or through a third-party, obtain, verify, and keep a record of the information and documentation that helps us verify Your identity and Payment Account information. When You register for the Service and from time to time thereafter, we may require You to provide and/or confirm information and documents that will allow us to identify You. "
        },
        "title": "4. Our Access to Your Data"
      },
      "section-5": {
        "list": {
          "item-1": "immediate temporary or permanent withdrawal of Your right to use the Service;",
          "item-2": "issue of a warning to You;",
          "item-3": "initiate legal proceedings against You for reimbursement of all costs (including, but not limited to, reasonable administrative and legal costs) resulting from the breach;",
          "item-4": "take further legal action against You; and/or",
          "item-5": "request disclosure of such information to law enforcement authorities as we reasonably feel is necessary."
        },
        "text-1": {
          "line-1": "You are free to withdraw any consent given to Us at any time by contacting Us at <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live.</a>",
          "line-2": "We may evaluate and determine, in our discretion, whether there has been a breach of this Agreement through Your use of the Service. When such a breach has occurred, we may take such action as we deem appropriate, including all or any of the following actions:"
        },
        "text-2": {
          "line-1": "The responses described above are not limited and we may take any other action we reasonably deem appropriate and that doesn't go against the applicable law.",
          "line-2": "We also have the right to block the Service for objectively justified reasons relating to the security of the Service, the suspicion of unauthorised or fraudulent use of the Service at any time.",
          "line-3": "We may choose to reject Your registration or cancel an existing registration for any other reason at our sole discretion."
        },
        "title": "5. Termination and Suspension"
      },
      "section-6": {
        "text": {
          "line-1": "You agree to protect and fully compensate Noda and our affiliates from any and all third party claims, liability, damages, expenses and costs (including, but not limited to, reasonable solicitors' fees) caused by or arising from Your use of the Service, Your violation of this Agreement or Your infringement, or infringement by any other user of Your account, of any intellectual property or other right of anyone.",
          "line-2": "We will have no liability to You for any failure or delay in performing any of our obligations under this Agreement to the extent that such failure or delay is caused or contributed to by You or by an event or circumstance beyond our reasonable control, including in case of the provision of an incorrect unique identifier.",
          "line-3": "IN NO EVENT SHALL NODA, ITS OFFICER, DIRECTORS, AGENTS, AFFILIATES, EMPLOYEES, ADVERTISES, OR PROVIDERS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES INCLUDING, BUT NOT LIMITED TO, LOSS OF USE, LOSS OF PROFITS, OR LOSS OF DATA, WHETHER IN AN ACTION IN CONTRACT, TORT (INCLUDING BUT NOT LIMITED TO NEGLIGENCE), EQUITY OR OTHERWISE, OR FOR DAMAGES IN THE AGGREGATE EXCEEDING THE AMOUNT OF THE PAYMENT THAT WAS EXECUTED DEFECTIVELY OR WITHOUT AUTHORIZATION RESULTING IN THE LOSS OF THE AMOUNTS TRANSFERRED WITHIN THE RELEVANT PAYMENT.",
          "line-4": "We are liable to You for the correct execution of the payment transaction unless we can prove to You and, where relevant, to the payee's payment service provider, that the payee's payment service provider received the amount of the payment transaction and unless we have reasonable grounds for suspecting fraud committed by You."
        },
        "title": "6. Indemnification and Liability"
      },
      "section-7": {
        "text": {
          "line-1": "We kindly ask You to address Your concerns and complaints directly to Us via <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> and we will always assist You in our best effort. In case You end up being unhappy with our response or with the overall service provided, You have the right to take Your complaint to the Financial Ombudsman Service: <a target=\"_blank\" rel=\"nofollow\" href=\"https://www.financial-ombudsman.org.uk/\">https://www.financial-ombudsman.org.uk/</a>. The supervisory authority with regards to our activity in the UK is the Financial Conduct Authority: <a href=\"https://www.fca.org.uk/\" target=\"_blank\" rel=\"nofollow\">https://www.fca.org.uk/.",
          "line-2": "Other countries have other regulators and may have other alternative dispute resolution solutions. For more information, please contact us at <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>.",
          "line-3": "If Your complaint is about how we store or process Your personal information, please consult our <a href=\"https://noda.live/about/legal-privacy/policy\">Privacy Policy</a>."
        },
        "title": "7. Complaints"
      },
      "section-8": {
        "text": {
          "line-1": "This Agreement is governed by the laws of the United Kingdom. If a court decides that We cannot rely on a part of this Agreement, the rest of the Agreement will continue to apply, as each of the provisions of this Agreement operate separately.",
          "line-2": "If any provision of this Agreement is found to be invalid for any reason, the invalidity of that provision will not affect the remaining provisions of the Agreement, which will remain in full force and effect."
        },
        "title": "8. General Provisions"
      },
      "subtitle": "Company Details",
      "text-1": "We are Naudapay Limited aka \"Noda\" (\"Noda\", \"We\", \"Us\", \"Our\"), a company registered in the United Kingdom under the company number 11741664 and our registered office is at 162 Buckingham Palace Road, London, SW1W 9TR, UK. We operate the Website <a href=\"https://noda.live\">https://noda.live</a> and the services available through our applications and solutions under our Noda brand. The contact office in the EU is in Spain (Calle Huertas 11, 28012, Madrid, Spain).",
      "text-2": "Naudapay Limited is registered with the Financial Conduct Authority under the Payment Services Regulations 2017 for the provision of payment services. Reference no. 832969.",
      "text-3": "Please, feel free to reach out to Us at <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> if You have questions or inquiries. We can also be contacted in-app via our help widget. ",
      "title": "Terms of Use"
    },
    "travel": {
      "faq": {
        "countries": {
          "content": "We work with 2000+ banks across 28 countries, including the Netherlands, Portugal, Belgium, Germany, Poland, Bulgaria, France, Ireland, Italy, Austria, Spain, Denmark, Estonia, the UK, Luxembourg, Romania, Lithuania, Hungary, Latvia, Finland, Sweden, Norway, Czech Republic, Slovakia, Greece and Slovenia.",
          "title": "What countries does Noda work in?"
        },
        "currencies": {
          "content": "Noda supports a variety of global currencies, including EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON and SEK.",
          "title": "What currencies does Noda support?"
        },
        "easy-to-start": {
          "content": "Yes. Our support team is here to help with any roadblocks. We offer smooth integration, ensuring you can start accepting payments quickly and easily.",
          "title": "Is it easy to start accepting payments online with Noda?"
        },
        "how-to-integrate": {
          "content": "First, you should be onboarded with Noda. Simply fill out the form, and our sales team will contact you shortly. We offer easy onboarding with the personalised guidance of a dedicated manager. Our processor smoothly integrates with API and front-end components, ensuring seamless merging into your platform.",
          "title": "How can I integrate Noda into my payment workflow?"
        },
        "kind-of-travel-business": {
          "content": "Noda offers travel industry payment solutions for all company types and sizes, with scalable plans available to support your business growth.",
          "title": "What kinds of travel businesses do you work with?"
        },
        "needs": {
          "content": "To start using Noda, fill out the form, and our sales team will contact you shortly. Noda offers easy onboarding with the guidance of a dedicated manager to ensure you are supported every step of the way.",
          "title": "What is needed from me to get started?"
        },
        "subtitle": "YOUR QUESTIONS ANSWERED",
        "title": "FAQs"
      },
      "hero": {
        "text": "Elevate your travel business. Our all-in-one payments platform prioritises customer understanding, efficiency, and growth",
        "title-1": "Travel Payment",
        "title-2": "Solutions with Noda:",
        "title-gradient-1": "Your Payments",
        "title-gradient-2": "are Our Priority"
      },
      "how-does-it-work": {
        "content": "Noda is a worldwide travel payment system and open banking provider. From transaction management to financial analytics, Noda has got you covered. Our platform uses state-of-the-art AI and machine-learning technologies.\n\nOpen banking means traditional banks share data with licensed fintech companies, like Noda, to streamline transactions. Our payment ecosystem connects all leading banks across the UK and EU, facilitating effortless merchant services for travel agencies.",
        "subtitle": "Technologies",
        "title": "How Does it Work"
      },
      "how-to-start": {
        "content": "Noda offers easy onboarding with the personalised guidance of a dedicated manager. Our team is here to help with any roadblocks. To start using Noda, simply fill out the form, and our sales representatives will contact you shortly.",
        "subtitle": "Easy Onboarding",
        "title": "How to Start"
      },
      "payments": {
        "text": "Experience the efficiency of instant transactions, with funds swiftly reflecting in your account within minutes. Our user-friendly and streamlined APIs effortlessly bring your products to market",
        "title": "Toolset for Travel Industry"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Leverage our data-driven insights. Noda’s tools offer ready-to-use analytics of client behaviour, including segmentation and forecasting algorithms",
            "title": "AI-Powered Analytics"
          },
          "banking": {
            "content": "Enhance customers’ experience and ease transaction&nbsp;flow with the power and security of open&nbsp;banking payments",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda works with a variety of global currencies to support your travel operations around the world",
            "title": "Global Currencies"
          },
          "payment-processing": {
            "content": "Streamline pay-ins and pay-outs with Noda. Leverage intuitive UX, smart routing, and a variety of payment methods",
            "title": "Payment Processing\nfor Travel Industry"
          },
          "scalable-plans": {
            "content": "We offer travel industry solutions for all company sizes, with scalable plans available to fuel your business growth",
            "title": "Scalable Plans"
          },
          "security": {
            "content": "Noda provides secure payment gateways for travel businesses, ensuring PCI DSS compliance, encryption and fraud prevention",
            "title": "Security"
          }
        },
        "subtitle": "OPEN BANKING & PAYMENTS",
        "title-1": "Top Features"
      }
    },
    "ux-approach": {
      "about-design": {
        "comments": {
          "business": {
            "name": "Valērijs Sičovs",
            "position": "Chief Business Development Officer",
            "text": "Noda is a prominent European open-banking provider with a wealth of experience in consumer-driven payment technology. Our added-value solutions change the course of merchants' payment strategies, and we all can agree that the popularity of open banking payments across Europe is undeniable.<br/>We have a cutting-edge technology solution, but close cooperation with the Noda development & design teams allows us to make an even bigger impact on how merchants can benefit from our well-formed user experience and payment process. Noda checkout, with all its elegance, makes even such a historically boring thing like payments state of the art."
          },
          "compliance": {
            "name": "Lāsma Gavarāne",
            "position": "Chief Compliance Officer",
            "text": "Properly built design by itself is like a blueprint of beauty meeting product functionality. Noda’s design approach is cool because it’s not just about how things look but rather how they work seamlessly together. It’s like having a superpower that makes everything effortless and exciting, and that’s exactly what we want to share with the world!"
          },
          "experience": {
            "name": "Max Gulewicz",
            "position": "Chief Experience Officer",
            "text": "At first, I thought that great design helps to solve specific issues; then, that great design also has to 100% fit the needs of the end target audience; then, that we also have to take in mind the business KPIs of our customers. But after 25 years of intensive designing, I realised that to design a great experience, which leaves the most delicious aftertaste, you have to not only LOVE what you do but also be somewhat obsessed, maybe even sacrifice something for the design, for someone else’s happiness. It’s incredibly cool to feel like a creator, but even better is to understand and see that your efforts aren’t in vain."
          },
          "hr": {
            "name": "Olga Ķerpe",
            "position": "HR Director",
            "text": "Personally, for me, a great design is all about aesthetics, attention to detail and innovation. And in our Noda design, we have it all combined perfectly. We are working really hard to always follow the newest trends and use the latest tools and features. I’d also say that these characteristics reflect our overall approach, and our team is doing their best to visually demonstrate it to the FinTech world."
          },
          "project": {
            "name": "Egor Mahaniuk",
            "position": "Head of Project Management Office",
            "text": "Picture this: Noda is like a sleek sports car, designed to turn heads and deliver an exhilarating ride through the digital landscape. Our user experience isn’t just intuitive; it’s practically telepathic. We’ve sculpted an interface in a way that makes it accessible to users of all skill levels. But wait, there’s more! Scalability and flexibility are our bread and butter. With our modular architecture, upgrades are as fast as the appearance of new technologies on the market, ensuring we’re always at the cutting edge without breaking a sweat. Noda’s UX isn’t just another outdated design; it’s an experience that’ll leave you saying, 'Why can’t everything be this fun and easy'?"
          },
          "solutions": {
            "name": "Volodymyr Mykhailin",
            "position": "Chief Solutions Officer",
            "text": "When thinking about high-quality UX design, it’s important that it’s consumer-focused while guaranteeing clarity, convenience and efficiency. Noda sharply recognises this principle and actively introduces it into its products. Users don’t experience any issues understanding how the product works; no questions arise about what they need to do next and why an event has happened. Products are designed in a way that minimises barriers to interaction between users and technology. When users don’t waste time overcoming the interface hurdles or searching for required information, their satisfaction and loyalty to the product increase. Such an approach to design not only enhances user experience but also boosts the competitive advantage of the company within its market space."
          }
        },
        "subtitle": "Team members about design",
        "title": "We Asked Our Team to Share<br/> What They Think About Noda Design "
      },
      "hero": {
        "subtitle": "Design manifesto",
        "text": "We are a team of experienced designers, creators, and researchers transforming Open Banking into a simple, fluid and accessible way to make and receive payments.",
        "title": "Customer<br/>Experience at&nbsp;Noda"
      },
      "principles": {
        "ecosystem": {
          "text": "Both buyers and merchants have to trust each other and the system. We have the means to improve this trust.",
          "title": "Safe Ecosystem"
        },
        "interaction": {
          "text": "We believe in making a world where erroneous payments are non-existent.",
          "title": "Error-prone Interaction"
        },
        "seconds": {
          "text": "Payments are always too slow, and we are hell-bent on making them faster.",
          "title": "Shaving Seconds"
        },
        "solutions": {
          "text": "The payment industry is prone to be mind-numbingly boring and generally blank. We hope to change that.",
          "title": "Elegant Solutions"
        },
        "subtitle": "Design basement",
        "title": "Our Principles"
      },
      "what-we-do": {
        "subtitle": "And finally",
        "text-1": "We design and develop a whole set of tools, processes and conventions that will power the next generation of payments.",
        "text-2": "Using agile and research-focused processes — while fully utilising our profound experience in e-commerce and payments, we are building merchant tools that remove friction from payments.",
        "title": "What We Do"
      }
    },
    "wargaming": {
      "subtitle": "Read a Case Study",
      "text": "In February 2023, Wargaming, a leading multi-platform game publisher, partnered with Noda to launch instant open banking payments for their games. This collaboration provided Wargaming's players with a variety of online payment methods, including account-to-account (A2A) transactions powered by the open banking infrastructure.",
      "title": "How Wargaming Leverages Noda for Better Payment Experiences"
    },
    "white-label": {
      "boost": {
        "tag-title": "BOOST YOUR BUSINESS WITH NODA",
        "text": "Our admin hub offers full tracking of all commissions, ensuring transparent reporting. Easily monitor payins and payouts, both for merchants and yourself. Take control with complete visibility and manage your business effortlessly.",
        "title": "Comprehensive Tracking \n& Reporting"
      },
      "hero": {
        "button": "Get started",
        "tag-title": "BETTER PAYMENTS",
        "text": "Leverage our technology platform as a white-label partner. Seamlessly integrate open banking transactions, get actionable analytics, and harness our intuitive UX. We offer integration via APIs, transparent reporting, and brand customisation.",
        "title": "Grow Your Business with Noda"
      },
      "how-it-works": {
        "a-way-to-keep": "A way to keep spending streaks for players who use slow banks (without Instant SEPA)",
        "accept-payments": "Accept payments via links or QR codes that can be shared across different channels",
        "actionable": "Actionable Analytics",
        "actionable-analytics-from": "Actionable analytics from transaction history and extra data supplied by the banks themselves",
        "ar": "AR above 90%",
        "buffet": "Buffet",
        "checkout": "Checkout",
        "dedicated": "Dedicated and separate accounts for enhanced clarity",
        "easily-pay": "Easily pay and get paid with our advanced technology and smart routing",
        "effortless": "Effortless and refined payment experience for businesses of all types and sizes",
        "expansive": "Expansive reach with 2000+ banks spanning 28 countries",
        "great": "Great Coverage",
        "instead-of-long": "Instead of long forms to fill in, users pay the initial deposit and are instantly registered",
        "intuitive": "Intuitive interface and extensive checkout features",
        "know": "Data Enrichment",
        "pay": "Pay & Go",
        "pay-by-link-qr": "Pay by Link & QR",
        "payins": "Payins & Payouts",
        "payment": "Payment acceptance rate close to 100%, ensuring your transactions are always approved",
        "provides-players": "Provides players with the option to pay by bank boosting conversion",
        "round-the-clock": "Round-the-clock support, we are here to assist you whenever you need",
        "segregated-accounts": "Segregated Accounts",
        "simple-payment-process": "Simple Payment Process",
        "support": "Support 24/7",
        "tag-title": "How it works",
        "title": "Integrate Our Technology",
        "trusted-payments": "Trusted Payments",
        "valuable": "Valuable insights from customers' financial behaviour to make well-informed decisions"
      },
      "open-banking": {
        "tag-title": "POWER OF OPEN BANKING",
        "text-1": "Before open banking, traditional banks controlled customer data. The European PSD2 regulation, enforced in 2018, changed this by requiring banks to share data with licensed third-party providers, like Noda, with customer consent.",
        "text-2": "Open banking leverages application programming interfaces (APIs), which act as a software bridge. When a user selects open banking, they are transferred to their trusted online banking interface. This also prevents cybercriminals from potentially stealing their data.",
        "text-3": "More consumers and merchants globally are choosing this emerging technology. ",
        "text-4": " predicts the total value of open banking transactions to rise from $57bn in 2023 to $330bn by 2027. Open banking payments are no longer innovative; they’re becoming the new norm.",
        "text-link": "Juniper Research",
        "title": "Open Banking Adoption \nis Booming"
      },
      "tailored-interface": {
        "tag-title": "TAILORED INTERFACE",
        "text": "Leverage our built-in customisation tools to personalise your user interfaces (UIs), or create your own front end to fully control the design. With our platform, the choice is yours to tailor the perfect experience.",
        "title": "Customised for Your Brand"
      }
    },
    "why-open-banking": {
      "benefits": {
        "section-1": {
          "cards": {
            "card-1": {
              "description": "Before <a class=\"link underline\" href=\"/articles/what-is-open-banking-your-ultimate-guide\">open banking</a>, traditional banks held a monopoly over customer data. Yet European PSD2 regulation emerged to change this. Enforced in 2018, it mandated banks to share data with licensed third-party providers. This happens strictly with customer consent. The data sharing fostered innovation in payments, making them quicker, smoother and more secure.",
              "title": "A New Era of Payments"
            },
            "card-2": {
              "description": "Juniper Research forecasts the total value of OB transactions <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">to reach $330bn by 2027</a>. That’s up from $57bn in 2023, a total growth of 479%.",
              "title": "Fast-Growing Service"
            },
            "card-3": {
              "description": "Consumers value innovation and superior payment flows. With its speed and simplicity, open banking is becoming the preferred choice for many.",
              "title": "More Innovative"
            }
          },
          "title": "It’s New and Fast-Growing"
        },
        "section-2": {
          "cards": {
            "card-1": {
              "description": "Open banking offers lower transaction fees than traditional card payments. Payments occur directly (from <a class=\"link underline\" href=\"/glossary/a2a-payments\">account to account</a>)",
              "title": "Lower Fe­es"
            },
            "card-2": {
              "description": "Open banking APIs remove payment commissions and most of the operational costs.",
              "title": "Reduced Costs and Fees"
            },
            "card-3": {
              "description": "Again, since no card networks are involved, open banking payments cut out chargebacks. Merchants can say goodbye to those hefty processing fees.",
              "title": "No Chargeback"
            },
            "card-4": {
              "description": "All merchants receive uniform pricing. The only change possible is a decrease in response to competitive pressures.",
              "title": "Cost for Merchants"
            }
          },
          "title": "It’s Highly Profitable"
        },
        "section-3": {
          "cards": {
            "card-1": {
              "description": "Settlement times are quicker with money showing up at the merchant’s account almost instantly. This can help you to manage your cash flow and accounting better. Consumers can pay quickly, without long processing times. As the settlement times are shorter, they can budget more efficiently.",
              "title": "Faster Payments"
            },
            "card-2": {
              "description": "Open banking solutions can consolidate data into a single platform. From customer insights to verification solutions, it offers diverse business tools.",
              "title": "Efficiency"
            },
            "card-3": {
              "description": "Consumers pay from their secure banking interface without having to manually enter card details. This saves them effort and time, resulting in an improved customer journey.",
              "title": "Better User Experience "
            },
            "card-4": {
              "description": "Open banking makes the <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">payment user experience (UX) simpler</a> by eliminating frictions such as manually entering card details from the process, resulting in higher conversions.",
              "inserted-content": {
                "subtext": "*Based on the transaction data of returning users taken from Noda’s platform in January 2024",
                "table": {
                  "tbody-1": {
                    "header": {
                      "col-1": "Germany",
                      "col-2": "Up to 89%"
                    }
                  },
                  "tbody-2": {
                    "header": {
                      "col-1": "Great Britain",
                      "col-2": "Up to 92%"
                    }
                  },
                  "tbody-3": {
                    "header": {
                      "col-1": "Netherlands",
                      "col-2": "Up to 92%"
                    }
                  },
                  "thead": {
                    "col-1": "Financial Institution",
                    "col-2": "Acceptance Rate, %"
                  }
                },
                "title": "Acceptance rate of open banking transactions of returning users"
              },
              "show-more-btn": "Show Stats",
              "title": "Higher Conversion Rates"
            },
            "card-5": {
              "description": "Open banking data can be used to analyse customers' financial habits and behaviour. Based on these insights, merchants can offer more tailored experiences.",
              "title": "Personalisation"
            }
          },
          "title": "Fast and Effective"
        },
        "section-4": {
          "cards": {
            "card-1": {
              "description": "Data sharing can only happen with <a class=\"link underline\" href=\"/articles/open-banking-flow\">explicit customer consent</a>. If consumers decide to stop sharing their data, they can opt out from open banking anytime.",
              "title": "Control of Financial Data"
            },
            "card-2": {
              "description": "Open banking data solutions offer instant verification of identity, sources of wealth, and other elements, which can help you in onboarding new clients quickly.",
              "title": "Onboarding & KYC"
            },
            "card-3": {
              "description": "Open banking is based on <a class=\"link underline\" href=\"/glossary/api\">secure APIs</a>. Authorisation of payments happens with the customer’s trusted bank. Plus, open banking is fully regulated under <a class=\"link underline\" href=\"/glossary/european-psd2\">European PSD2</a> with Strong Customer Authentication (SCA) being a legal requirement.",
              "title": "Better Security"
            }
          },
          "title": "It’s 100% Secure"
        }
      },
      "hero": {
        "subtitle": "The best decision",
        "text": "Offering open banking as a payment method is not a novelty anymore. Not doing so can cost your business valuable clients. If you’re still unsure, read about the benefits of open banking below.",
        "title": "Why Open Banking?"
      },
      "myths": {
        "description": "Like any new technology, open banking is often misunderstood. These misconceptions can lead to merchants avoiding open banking payments due to lack of knowledge.\n\nHere, we bust common myths.",
        "myth-10": {
          "content": "As mentioned earlier, customers increasingly prefer open banking over other payment methods. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.statista.com/statistics/1228771/open-banking-users-worldwide/\">Statista</a> estimated that by end-2024, the number of open banking users worldwide will reach 132 million. The rapid adoption of open banking is a clear sign of consumer trust. OB payments offer better, more intuitive UX, and consumers value the superior payment flow.",
          "title": "Myth 10. Customers Aren’t Used to Open Banking Payment Flow"
        },
        "myth-1": {
          "content": "There is a common misunderstanding of the word ‘open’ in the concept of open banking. Open banking doesn’t mean that banks openly share customer data with whoever wants to access it. In fact, third-party providers must undergo through <a class=\"link underline\" href=\"/articles/what-are-aisp-and-pisp-in-open-banking\">rigorous regulatory licensing</a> with national regulators if they want to implement open banking. For example, in European PSD2, providers must obtain either AISP or PISP licence to access customer information.",
          "title": "Myth 1. Open Banking Means Everything is ‘Open’"
        },
        "myth-2": {
          "content": "Open banking is enabled by secure APIs shared by banks with licensed third-party providers. When a customer chooses an open banking payment they are automatically transferred to their trusted banking interface, where the payment is authorised. This API app-to-app redirection prevents cybercriminals from potentially stealing their data, especially when compared with practices such as screen scrapping. Plus, under PSD2, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://finance.ec.europa.eu/publications/strong-customer-authentication-requirement-psd2-comes-force_en\">Strong Customer Authentication (SCA)</a> is a legal requirement for open banking payments. SCA is a multi-factor authentication measure aimed at preventing impersonation fraud. ",
          "title": "Myth 2. Open Banking Isn’t Secure"
        },
        "myth-3": {
          "content": "Some customers may wrongly assume that when they consent to data sharing, the whole world will be able to see what’s happening in their finances. This is simply not true. Only authorised third-party providers can access customer data. To get such a license, providers must obtain it via a national regulator such as <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.fca.org.uk/consumers/account-information-payment-initiation-services\">FCA in the UK</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.bafin.de/EN/Aufsicht/ZahlungsdienstePSD2/ZulassungspflichtigeZahlungsdienste/ZulassungspflichtigeZahlungsdienste_node_en.html\">BaFin in Germany</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://acpr.banque-france.fr/en/authorisation/banking-industry-procedures/licensing-authorisation-and-registration/payment-institution-and-account-information-service-provider\">ACPR in France</a>, and other relevant authorities of the country in question to make sure that providers comply with the rules and handle data correctly. Plus, customers can withdraw their consent anytime. ",
          "title": "Myth 3. Misunderstanding Data Sharing"
        },
        "myth-4": {
          "content": "There is a misconception that open banking payments only work for accounts at major banks. In reality, the open banking ecosystem is large and includes many smaller financial institutions too. According to <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbankingtracker.com/\">Open Banking Tracker</a>, there are 4,394 connected banks across 73 countries. At Noda, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://coda.io/d/Noda-Supported-banks_dIVjZri07ne\">we connect to 2000+ banks</a> across the UK and EU.",
          "title": "Myth 4. Open Banking Doesn’t Support Smaller Banks"
        },
        "myth-5": {
          "content": "Some merchants may assume that the ‘pay-by-bank’ option may put off consumers who prefer paying by card. In fact, OB payments are much simpler and more secure, as customers do not need to enter their card details manually. The money is transferred from the same bank account that’s linked to a card, yet the transfer bypasses the card network, leading to faster processing and lower commissions. That’s why customers increasingly embrace open banking over cards. In the UK, for example, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbanking.org.uk/news/open-banking-impact-report-october-2023/\">11% of consumers</a> are active users of this payment method. ",
          "title": "Myth 5. Clients Paying by Card Will Be Put off by Open Banking"
        },
        "myth-6": {
          "content": "Conversions are the key metrics for payments. Therefore, it’s important to get them right. There is a myth that card payments lead to more successful transactions than open banking payments. In truth, the <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">UX for open banking is much simpler</a>. The users are redirected to their bank’s interface, and money is transferred directly from their bank account. This prevents the risk of mistyped card details and saves customers time and effort, leading to higher conversions.",
          "title": "Myth 6. Card Payment Conversions are Higher than Open Banking"
        },
        "myth-7": {
          "content": "Again, this is a misconception. As mentioned above, open banking payments don’t require manual information entry. Customers are <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">redirected to their banking interface</a>, where payments are authorised. The authentication may involve a passcode entry, a biometric verification, like a fingerprint scan or a face ID, and a code sent to their device. This journey is much easier and less time-consuming than entering lengthy card details.",
          "title": "Myth 7. Open Banking Payments Require More Payment Details"
        },
        "myth-8": {
          "content": "Some merchants may think that even if a client finds their bank in the list, the integration will be full of friction, and the transaction will ultimately fail. We can assure you that open banking API integration is seamless as <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.stet.eu/en/psd2/\">these APIs are standardised</a> across PSD2 countries and banks. See how it works for yourself with <a class=\"link underline\" rel=\"nofollow\" target=\"_blank\" href=\"https://noda.live/demo\">Noda’s demo</a> of an open banking transaction.",
          "title": "Myth 8. Integration with Client’s Bank Will Fail"
        },
        "myth-9": {
          "content": "Some merchants may think that open banking payment processing is slower. In reality, payments made through cards involve intermediaries that incur longer processing time. Open banking payments happen from <a class=\"link underline\" href=\"/glossary/a2a-payments\">account to account</a>, so no card networks are involved. Hence the payments are much quicker.",
          "title": "Myth 9. Open Banking Payments Take Longer"
        },
        "title": "Common Myths\n\nabout Open Banking"
      }
    }
  },
  "nl": {
    "ab-test": {
      "campaign-30": {
        "button-text-a": "Aan de slag",
        "button-text-b": "Aan de slag"
      }
    },
    "anti-bribery": {
      "definitions": {
        "associated-person-employees": "<b>Betrokken persoon</b>: medewerker, leverancier, vertegenwoordiger, individu of organisatie die diensten verleent namens Noda.",
        "bribe-a-financial": "<b>Smeergeld</b>: een financieel of ander voordeel ter stimulering van een actie die ongepast of onwettig is of die vertrouwen schendt.",
        "bribery-the-offering": "<b>Omkoping</b>: het aanbieden, beloven, geven, accepteren of aanvragen van een financieel of ander voordeel ter stimulering van een actie die ongepast of onwettig is of die vertrouwen schendt.",
        "title": "Definities"
      },
      "employee-responsibilities": {
        "act-with-integrity": "integer handelen en zakendoen op een eerlijke en transparante manier;",
        "all-nodas-employees": "Alle medewerkers van Noda moeten:",
        "avoid-using-their": "hun functie binnen het bedrijf niet misbruiken voor persoonlijke belangen of die van anderen, waaronder familieleden; en",
        "comply-with-nodas": "de ABC-verklaring van Noda naleven;",
        "implement-appropriate-due": "due diligence-procedures implementeren bij het kiezen van leveranciers, zakenpartners of vertegenwoordigers, om het risico op omkoping te beperken en ervoor te zorgen dat ze zich bewust zijn van de bepalingen van de Britse Bribery Act 2010;",
        "refuse-to-engage": "weigeren zaken te doen met personen of entiteiten die zich niet houden aan de beginselen van Noda en die de reputatie van ons bedrijf zouden kunnen schaden;",
        "report-any-instances": "voorvallen melden aan de juridische afdeling van Noda als een financieel of ander voordeel wordt aangeboden dat kan worden beschouwd als smeergeld, of als ze vermoeden dat ze ongeoorloofde gunsten hebben ontvangen of een geschenk hebben gekregen dat buiten de norm valt;",
        "report-to-noda": "melding maken aan de juridische afdeling van Noda van voorvallen waarin een collega een financieel of ander voordeel heeft ontvangen dat niet gemeld is, zoals verplicht is volgens de ABC-verklaring;",
        "title": "Verantwoordelijkheden van medewerkers",
        "uphold-nodas-principles": "de beginselen van Noda naleven, zelfs in lastige omstandigheden."
      },
      "key-prohibitions": {
        "bribing-a-public": "2. Het is streng verboden een overheidsfunctionaris om te kopen, in welk land dan ook. Dat omvat: ",
        "engaging-in-bribery": "1. Betrokken zijn bij omkoping, ofwel direct of via een externe partij, is streng verboden in elk land. Omkoping wordt gedefinieerd als:",
        "facilitation-payments-are": "3. Faciliterende betalingen zijn verboden, behalve in gevallen waarin iemands leven of welzijn in gevaar is.",
        "in-order-to": "om zaken of een ander zakelijk voordeel binnen te halen of te behouden.",
        "offering-promising": "iets waardevols of een ander voordeel aanbieden, beloven of geven, vragen, verzoeken of accepteren;",
        "offering-promising-or": "iets waardevols of een ander voordeel aanbieden, beloven of geven;",
        "political-donations-and": "4. Schenkingen aan politieke organisaties en lobbyen zijn verboden.",
        "the-key-areas": "De belangrijkste onderdelen van onze ABC-verklaring zijn:",
        "title": "De belangrijkste verboden en verplichtingen",
        "to-improperly-influence": "om een zakelijke beslissing of een andere handeling, passiviteit of beslissing door iemand anders op ongepaste manier te beïnvloeden.",
        "to-influence-a": "om een overheidsfunctionaris in zijn of haar functie te beïnvloeden;"
      },
      "last-update-at": "Laatst bijgewerkt op 1 juni 2024",
      "noda-is-dedicated": "Noda doet er alles aan omkoping en corruptie te voorkomen en hanteert een zero tolerance-beleid tegen acties die in strijd zijn met wetten inzake corruptie en omkoping, zowel in het VK als in andere landen. Deze toezegging heeft betrekking op de naleving van wetten zoals de Britse Bribery Act 2010 en vergelijkbare wetten in andere rechtsgebieden waarin we actief zijn.",
      "principles": {
        "by-any-individual": "door een individuele medewerker, vertegenwoordiger of andere betrokken persoon die of ander betrokken bedrijf dat namens Noda handelt;",
        "facilitation-payments-will": "6. Faciliterende betalingen worden niet geaccepteerd, ook al worden ze in bepaalde landen beschouwd als regulier.",
        "in-any-form": "in elke vorm, waaronder geschenken of amusement geboden aan de echtgenoot of echtgenote of een ander familielid van de besluitvormer;",
        "in-order-to-gain-commercial": "om op een onethische manier een commercieel, contractueel of regulatoir voordeel voor Noda te verkrijgen; of",
        "in-order-to-gain-personal": "om persoonlijk voordeel te verkrijgen voor het individu, of iemand die bij hem of haar betrokken is, in de vorm van geld of anderszins.",
        "noda-is-dedicated": "1. Noda doet er alles aan zijn zakelijke activiteiten uit te voeren op een verantwoordelijke manier, ongeacht waar de betrokken partijen gevestigd zijn. We staan voor ethisch, transparant en integer zakendoen in alle omstandigheden.",
        "noda-maintains-a": "2. Noda hanteert een streng zero tolerance-beleid op het gebied van omkoping en corruptie. We onthouden ons te allen tijde van het direct of indirect aanbieden, beloven, betalen, vragen of accepteren van smeergeld als middel om zaken te verkrijgen of te behouden, of om te profiteren van een zakelijk voordeel.",
        "noda-strictly-prohibits": "5. Noda verbiedt het aanbieden, geven, vragen of accepteren van elke vorm van smeergeld ten strengste, ongeacht of het gaat om contant geld of andere middelen:",
        "noda-will-not": "7. Noda doet geen directe of indirecte bijdragen aan politieke partijen.",
        "title": "Beginselen inzake anti-omkoping en corruptie",
        "to-or-from-any": "aan of van een individu of entiteit, ongeacht of het gaat om een overheidsfunctionaris of -instantie, een particulier of bedrijf en ongeacht het land waarin deze actief is;",
        "under-the-law": "4. Wettelijk gezien kan omkoping worden uitgevoerd en kan corrupt gedrag worden vertoond door verschillende partijen die betrokken zijn bij Noda, zoals medewerkers, aangewezen vertegenwoordigers, directeuren, individuen die namens Noda optreden en individuen of organisaties die namens hen mogen optreden.",
        "we-mandate-that": "3. Al onze medewerkers en betrokken personen zijn verplicht alle wetgeving inzake anti-omkoping na te leven, waaronder de Britse Bribery Act 2010 (Bribery Act) en zich te houden aan zakelijke richtlijnen die van toepassing zijn op onze zakelijke activiteiten."
      },
      "steps-taken": {
        "accurate-records": {
          "text": "Vele incidenten op het gebied van omkoping en corruptie zijn het gevolg van een onzorgvuldige boekhouding. Het is dan ook noodzakelijk dat we onze boeken, dossiers en financiële rapportages nauwkeurig opstellen en beheren binnen Noda. Onze accounts, dossiers en financiële rapporten moeten transparant zijn. Foutieve, misleidende of onnauwkeurige gegevens kunnen een ernstig risico vormen voor de reputatie en integriteit van Noda.",
          "title": "2. Nauwkeurige boekhouding"
        },
        "compliance-statement": "Deze 'Anti-Bribery & Corruption Statement' is opgesteld overeenkomstig de verplichtingen van Noda in het kader van de Britse Bribery Act 2010.",
        "internal-control": {
          "text": "Noda werkt met een doeltreffend systeem van interne controles en toezicht op transacties. Nadat risico's op het gebied van omkoping en corruptie in kaart gebracht zijn aan de hand van de risicobeoordeling, worden procedures ontwikkeld binnen de kaders van een uitgebreid controle- en toezichtprogramma. Daarmee worden deze risico's voortdurend in de gaten gehouden en zoveel mogelijk beperkt.",
          "title": "3. Effectief toezicht en effectieve controle"
        },
        "noda-implements": "Noda implementeert de volgende maatregelen om omkoping en corruptie te voorkomen:",
        "risk-assessment": {
          "text": "Een effectieve risicobeoordeling is essentieel voor het succes van onze ABC-verklaring. Door risico's in kaart te brengen, kunnen we precies nagaan waar we het risico lopen op omkoping en corruptie. Hierdoor kunnen we deze risico's beter evalueren en beperken. Dat komt de veiligheid van Noda ten goede.",
          "title": "1. Risicobeoordeling"
        },
        "title": "Stappen die we genomen hebben ter voorkoming van omkoping of corruptie"
      },
      "subtitle": "Intentie van de verklaring",
      "the-anti-bribery": "De Anti-Bribery and Corruption Statement ('ABC-verklaring') bevat uitgebreide richtlijnen op het gebied van het voorkomen van omkoping en verdachte activiteiten.",
      "title": "Verklaring inzake anti-omkoping en corruptie"
    },
    "articles": {
      "back-to-articles": "Terug naar Artikelen",
      "case-info": {
        "payer-location": "Betaler Locatie",
        "product-used": "Gebruikt product"
      },
      "defaultBanner": {
        "buttonText": "Boek een demo",
        "text": "Bied je gebruikers een eenvoudigere, voordelige manier om te betalen en stimuleer conversies!",
        "title": "Meer informatie over Open Banking met Noda"
      },
      "defaultBannerHero": {
        "buttonText": "Boek een demo",
        "text": "Voeg 2000+ banken toe voor directe Payins & Payouts en schaal wereldwijd met gemak!",
        "title": "Accepteer Online Betalingen met Noda"
      },
      "main": {
        "banner": {
          "button": "Start met Noda",
          "text": "Onze producten maken de betalingservaring eenvoudiger, sneller en toegankelijker",
          "title": "Betrouwbare betaaloplossing voor uw bedrijf"
        },
        "title": "Artikelen"
      },
      "single-article": {
        "tables-banner": {
          "button": "Probeer Noda",
          "title": "Probeer Noda - een ultiem nieuwe manier om online betalingen te accepteren"
        }
      }
    },
    "bank-payouts": {
      "control-data": {
        "items": {
          "item-1": {
            "text-1": "Noda werkt nauw samen met verkopers en banken om sectorspecifieke uitdagingen voor C2B en B2C geldstromen (de cashflow) te begrijpen. Hierdoor zijn wij in staat een totaaloplossing te bieden die is afgestemd op uw zakelijke behoeften",
            "title-1": "Wij begrijpen de uitdagingen in uw sector"
          },
          "item-2": {
            "text-2": "Met een schat aan ervaring op het gebied van Open Banking in de EU en het Verenigd Koninkrijk creëert Noda eersteklas oplossingen voor bankbetalingen die zijn afgestemd op de unieke behoeften van uw klanten",
            "title-2": "Bankexpertise"
          }
        },
        "text": "Betaal veilig en zeker met Noda. Betaal uw partners, leveranciers en marktplaatsgebruikers met onze geavanceerde technologie en expertise heel eenvoudig",
        "title": "Volledige controle over uw B2C betalingen"
      },
      "netting-data": {
        "items": {
          "text-1": "Saldering garandeert een soepele transfer van geld zonder vertraging en helpt zo een gezonde cashflow voor uw bedrijf te behouden",
          "text-2": "Gebruik het bestaande saldo voor betalingen, waardoor er geen extra bankoverschrijvingen en kosten ontstaan",
          "title-1": "Voorkom kastekorten",
          "title-2": "Kostenefficiënt"
        },
        "subtitle": "Saldering balans",
        "text": "Beheer uw inkomende balans naadloos met de uit te betalen bedragen. Maak gebruik van deze kostenefficiënte betalingsmethode en de onmiddellijk beschikbare middelen",
        "title": "Gebruik uw inkomende balans om betalingen te doen"
      },
      "payments-data": {
        "balance": "Huidige balans",
        "text": "Snelle en gemakkelijke op bankoverschrijvingen gebaseerde betalingen voor verkopers",
        "title": "Bankbetalingen",
        "title-colored": "voor snelle transacties"
      },
      "recipient-data": {
        "subtitle": "Bevredigende ervaring",
        "text": "Met de betalingsopties van Noda ontvangen consumenten hun geld zonder extra kosten, in tegenstelling tot sommige kaartsystemen en wallets die kosten in rekening brengen voor dezelfde service. Dit voordeel is te danken aan de verplichting van de banken om hun klanten gratis bank-naar-bankoverschrijvingen te bieden",
        "title": "Gratis voor ontvanger"
      },
      "routing-data": {
        "items": {
          "item-1": {
            "text-1": "Met de efficiënte routing van Noda bereikt uw geld razendsnel zijn bestemming",
            "title-1": "Snelle beschikbaarheid van geld"
          },
          "item-2": {
            "text-2": "Minimaliseer extra bankoverschrijvingen en de bijbehorende kosten met onze geavanceerde routing voor betalingen",
            "title-2": "Lagere kosten"
          }
        },
        "text": "Wij optimaliseren de verzending van uw geld om maximale snelheid en kostenefficiëntie te garanderen en tegelijkertijd inefficiënte bancaire routes te vermijden",
        "title": "Routing"
      },
      "single-report-data": {
        "subtitle": "Geld met de snelheid van het licht",
        "text": "Vergeet betalingen met vertraging. We gebruiken directe betalingssystemen van de FPS en SEPA om in realtime geld over te maken naar uw begunstigden",
        "title": "Geld is direct beschikbaar"
      },
      "title": "Betaal moeiteloos leveranciers, portefeuillehouders (wallets), streamers en anderen. Met de business-to-client (B2C) bankbetalingen van Noda worden bulkbetalingen aan individuen eenvoudiger waardoor transacties snel en gemakkelijk zijn"
    },
    "bank-sign": {
      "hero": "Uw klanten kunnen eenvoudig inloggen op uw website of app met hun eigen bankrekening. Onze geavanceerde technologie maakt gebruik van cruciale bankgegevens waardoor uw klanten probleemloos en veilig kunnen inloggen",
      "payments-data": {
        "text": "Veilig inloggen met één klik en bankgegevens",
        "title": "Aanmelden via bank"
      },
      "payouts-data": {
        "items": {
          "item-1": {
            "text-1": "Uw klanten geven Noda toestemming om toegang te krijgen tot hun gegevens door te kiezen voor inloggen via hun bankrekening. Dit garandeert dat de informatie die u ontvangt bij het inloggen vertrouwd en geverifieerd is, wat extra transparantie biedt",
            "title-1": "Meest betrouwbare data"
          },
          "item-2": {
            "text-2": "Wanneer uw klanten hun bankgegevens gebruiken om in te loggen, gebruiken ze de vertrouwde interface van de vertrouwde app of website van hun bank. Dit elimineert het risico op het verlies van klanten als gevolg van registratieproblemen",
            "title-2": "Intuïtieve UX"
          }
        },
        "text": "Uw klanten geven toestemming om verbinding te maken via de app of webinterface van hun bank. Onze integraties voldoen aan de strengste beveiligings- en nalevingsnormen van banken",
        "title": "Snel en betrouwbaar"
      },
      "recipient-data": {
        "subtitle": "Geavanceerde klantenwerving",
        "text": "Dankzij het naadloze inloggen en de initiële betaling worden gebruikers klanten in slechts een paar klikken. Een handmatige invoer van gegevens is niet nodig. Alle vereiste informatie en de betalingsautorisatie worden op een veilige manier verkregen wanneer klanten hun toestemming geven",
        "title": "Betalen & verder"
      },
      "risk-data": {
        "items": {
          "item-1": {
            "text-1": "Het veiligstellen van fondsen is een uitdagende taak en de bankensector staat bekend om zijn zeer strikte veiligheidsnormen. Daarom biedt de functie 'Inloggen via bank' uw bedrijf de beste veiligheidsmaatregelen voor het beschermen van uw klanten",
            "title-1": "Robuuste beveiliging"
          },
          "item-2": {
            "text-2": "Met deze functie vergeet uw klant nooit zijn/haar/hun inloggegevens, omdat de toegang tot zijn/haar/hun geld altijd beveiligd is. Dit garandeert dat u geen klanten verliest als gevolg van inlogproblemen met de account",
            "title-2": "Klantcontactpunt"
          }
        },
        "text": "Het risico op een ongeoorloofde toegang tot bankrekeningen is vrijwel nihil, vanwege de strenge beveiliging en verdere vervolging. In het onwaarschijnlijke geval van een overname van de account is de klant direct op de hoogte van een aanval en kan hij snel reageren",
        "title": "Minimaal risico op accountovername"
      },
      "single-report-data": {
        "subtitle": "Voldoet aan alle wettelijke normen",
        "text": "U kunt op juridische wijze voldoen aan de meeste vereisten en het beleid op het gebied van monitoring, onboarding en identificatie met de bankgegevens die via Noda worden verzameld",
        "title": "Data voldoet aan wet- en regelgeving"
      },
      "title-1": "Veilig",
      "title-2": "Inloggen via bank"
    },
    "banking": {
      "banking": "Bankervaring",
      "banks-count": "2000+ banken",
      "c2b": "C2B account",
      "easy-onboarding-1": "Eenvoudig onboarden",
      "easy-onboarding-2": "Met een persoonlijke manager",
      "experience": "Ervaar moeiteloze transacties met onze geavanceerde Open Banking service, die uw bedrijf verbindt met alle grote banken in het Verenigd Koninkrijk en de EU",
      "experience-data": {
        "easy-to-apply": {
          "text": "Flexibele oplossing voor het innen van geld, met de optie om onze Noda C2B bankrekening of één van onze vertrouwde bankpartners te gebruiken",
          "title": "Eenvoudig toe te passen"
        },
        "enhance-customer-experience": {
          "text": "Profiteer van innen tegen lage kosten of kosteloos innen met de verschillende opties die via ons netwerk van banken worden aangeboden\n",
          "title": "Verbeter de klantervaring"
        }
      },
      "features-to-integrations": "van functies tot integraties",
      "first-steps": "EERSTE STAPPEN",
      "hero": "Verbeter uw klantervaring en vereenvoudig uw transactiestromen met de kracht en veiligheid van ons Open Banking-platform",
      "hero-title-1": "Open Banking",
      "hero-title-2": "met Noda",
      "how-data": {
        "authorise-the-transaction": {
          "text": "Van het veranderen van de toekomst met innovatieve start-ups tot het transformeren van onze wereld met iconische merken, Noda ondersteunt duizenden bedrijven om een verschil te maken",
          "title": "Autoriseer de transactie"
        },
        "choose-your-bank": {
          "text": "Kies uit een selectie van de belangrijkste banken",
          "title": "Kies uw bank"
        },
        "payment-is-done": {
          "text": "Noda is de drijvende kracht achter naadloze transacties voor duizenden bedrijven, van vooruitstrevende start-ups tot marktleiders",
          "title": "De betaling is voltooid"
        },
        "sign-into-your-account": {
          "text": "Noda is de drijvende kracht achter duizenden bedrijven met een grote impact, van next generation start-ups tot trendsettende merken die de wereld veranderen",
          "title": "Log in op uw account"
        }
      },
      "hub-data": {
        "1": {
          "text": "Eenvoudige en efficiënte verwerking van terugbetalingen",
          "title": "Terugbetalingen"
        },
        "2": {
          "text": "Meerdere gebruikersrollen voor een betere controle",
          "title": "Meerdere toegewezen rollen"
        },
        "3": {
          "text": "Veilig, snel en efficiënt transactiebeheer",
          "title": "Transacties"
        },
        "4": {
          "text": "Gedetailleerde en gepersonaliseerde financiële rapportage",
          "title": "Rapportage"
        }
      },
      "hub-description": "Met Noda Hub kunt u probleem op één enkel platform onboarden, voorkeuren voor transacties configureren, transacties en rapporten monitoren en uw betalingsverkeer analyseren.",
      "info-data": {
        "subtitle": "Functies en integraties",
        "text": "Garandeer dat uw klanten veilig, met een naadloze integratie van begin tot eind, kunnen verifiëren en betalen binnen uw ecosysteem",
        "title": "Hoe onze Open Banking oplossing werkt"
      },
      "manage-everything": "Beheer alles wat u nodig heeft op één centrale plek",
      "management": "Management",
      "manager-guidance": "Geniet van een probleemloze onboarding met het begeleidingsproces van Noda Hub en ontvang persoonlijke ondersteuning van de speciaal aan u toegewezen manager",
      "manager-help": "Geen gedoe met zelf onboarden: uw Personal Manager staat voor u klaar om u te helpen met eventuele obstakels",
      "payments-data": {
        "text": "Snelle, veilige en gereguleerde bankoverschrijvingen",
        "title": "Open Banking betalingen"
      },
      "payments-feature-description": "Stroomlijn uw betalingen met de Trusted Payments-functie (vertrouwde betalingen) van Noda. Deze beveiligt transacties met vertrouwde betalers voordat het geld zelfs maar aankomt",
      "special-features": "Speciale functies",
      "trusted-payments-1": "Betrouwbare betalingen",
      "trusted-payments-2": "de kassa versnellen"
    },
    "banner": {
      "text1": "Geleidelijke groei of een snelle impuls?",
      "text2": "Jij weet het beste wanneer het tijd is om je bedrijf een boost te geven.",
      "title": "Een nieuwe kijk op betalen – Bekijk op je gemak alle producten van Noda"
    },
    "block-with-screen": {
      "detailed-and-customizable": "Gedetailleerde en aanpasbare financiële rapportage",
      "easy-and-efficient": "Eenvoudige en efficiënte verwerking van terugbetalingen",
      "multi-roles": "Meerdere rollen",
      "multiple-user": "Meerdere gebruikersrollen voor betere controle",
      "refunds": "Terugbetalingen",
      "reporting": "Rapportage",
      "reporting-v2": {
        "subtitle": "volledige transparantie",
        "text": "Met onze admin hub kun je alle commissies bijhouden, wat zorgt voor een duidelijke en transparante rapportage. Houd moeiteloos toezicht op betalingen en uitbetalingen, krijg volledig inzicht en beheer je activiteiten met gemak.",
        "title": "Gedetailleerde bewaking en rapportage"
      },
      "secure-fast": "Veilig, snel en efficiënt transactiebeheer",
      "tagTitle": "BOOST UW BEDRIJF MET NODA",
      "text": "Met Noda Hub kunt u moeiteloos onboarden, transactievoorkeuren configureren, transacties en rapporten monitoren en betalingsverkeer analyseren, allemaal binnen één enkel platform.",
      "title": " — Beheer alles wat je nodig hebt op één plek",
      "transactions": "Transacties"
    },
    "card-payments": {
      "active-subscriptions-title": "Actieve abonnementen",
      "available-funds": {
        "pending": "In behandeling: € 35,00",
        "title": "Beschikbaar saldo"
      },
      "controls": {
        "desktop": "Desktop",
        "diff-user": "Andere gebruiker",
        "uk": {
          "text-1": "VK",
          "text-2": "London"
        }
      },
      "hero-data": "Ervaar naadloze en stressvrije kaartbetalingen met de geavanceerde technologie en slimme routing van Noda",
      "hood-data": {
        "text-1": "Noda zorgt dat uw online kaartbetalingen efficiënt en betrouwbaar, met een geoptimaliseerde routing op basis van geografische locatie, kaarttype en andere factoren, worden verwerkt",
        "text-2": "Vergroot uw omzet en conversies met het zorgvuldig ontworpen betaalproces van Noda dat vertragingen vermindert en het innen van betalingen voor klanten vereenvoudigt",
        "text-3": "Nooit meer te hoge uitgaven voor kaartbetalingen: de slimme routing van Noda zorgt dat u altijd de beste deal krijgt",
        "text-4": "Na het verzamelen en zorgvuldig analyseren van de datapunten van klanten voorspelt het AI-model van Noda potentiële risiconiveaus in realtime en blokkeert het verdachte transacties, waardoor terugboekingen en fraude worden verminderd zonder afbreuk te doen aan de autorisatiepercentages",
        "title-1": "Slimme routing",
        "title-2": "Maximaliseer conversies",
        "title-3": "Optimaliseer kosten",
        "title-4": "Risicovoorspelling met behulp van AI-model"
      },
      "how-data": {
        "items": {
          "text-1": "Het krachtige AI-gestuurde risicoanalysemodel van Noda evalueert meer dan 50 parameters om slimmere en veiligere oplossingen voor kaartbetalingen te bieden, waardoor u meer gemoedsrust ervaart",
          "text-2": "Na de betaling zorgvuldig te hebben geanalyseerd en de benodigde data/gegevens te hebben verzameld, voorspelt het AI-model van Noda de potentiële risiconiveaus in realtime",
          "text-3": "Het robuuste AI-gestuurde risicoanalysemodel van Noda werkt samen met ons team om meer dan 50 parameters te evalueren en slimmere en veiligere oplossingen voor kaartbetalingen te bieden, waardoor een hoog percentage van transacties wordt gegarandeerd",
          "title-1": "Observatie",
          "title-2": "Risicoschatting",
          "title-3": "Betalingsafhandeling"
        }
      },
      "info-data": {
        "subtitle": "Veiligheid voorop",
        "text": "Bescherm uw bedrijf en klanten met onze AI-gestuurde risicoschatting en dynamische reactiemogelijkheden voor veilige en betrouwbare kaartbetalingen",
        "title": "Risicobeoordeling en reactie"
      },
      "key-features": {
        "text": "Verbeter de verwerking van uw kaartbetalingen met de AI-gestuurde routing en technologie van Noda voor het verbeteren van de acceptatie. Onze geavanceerde software analyseert transacties, stuurt ze door naar de optimale bank voor het verwerken van de transacties en verbetert het aantal geaccepteerde kaartbetalingen",
        "title": "Slimme AI-routing en betere acceptatie"
      },
      "monetization": {
        "subtitle": "Continue generatie van inkomsten",
        "text": "Voer regelmatig terugkerende kaartbetalingen automatisch uit, bijvoorbeeld maandelijks of jaarlijks, zonder elke keer de details in te voeren",
        "title-1": "Volledige ondersteuning voor ",
        "title-2": "terugkerende betalingen"
      },
      "payments-data": {
        "icon": "header/product-payments.svg",
        "text": "Moeiteloze kaartbetalingen voor verkopers",
        "title": "Kaartbetalingen"
      },
      "preference-data-1": {
        "data": {
          "items": {
            "text-1": "De betaling wordt onmiddellijk geautoriseerd in één enkele communicatie tussen de verwerkende en verzendende server. Hierbij wordt het geld onmiddellijk van de rekening van de klant afgeschreven. Deze methode is sneller en biedt een meer gestroomlijnde betaalervaring, maar is mogelijk gevoeliger voor fraude",
            "text-2": "De betaling wordt geautoriseerd via het eerste bericht tussen de servers en in rekening gebracht via het tweede bericht. Het geld van de klant wordt gereserveerd op zijn/haar/hun kaart en pas na de tweede communicatie (het tweede bericht) afgeschreven. Hoewel dit betalingsproces in twee stappen veiliger is, kan dit resulteren in een langere tijd voor het afrekenen",
            "title-1": "Enkel bericht",
            "title-2": "Dubbele bericht"
          }
        },
        "subtitle": "Stel uw voorkeuren in",
        "text": "De op maat gemaakte kaartbetaling van Noda biedt een systeem met enkele en dubbele berichten om aan uw zakelijke behoeften te voldoen",
        "title": "Directe en uitgestelde kosten"
      },
      "preference-data-2": {
        "data": {
          "items": {
            "text-1": "Bescherm uw bedrijf door middel van tokenisatie. Dit biedt een hogere veiligheidsniveau, beperkt het risico op datalekken en fraude en een betere klantervaring",
            "text-2": "Laat uw klanten hun kaartgegevens veilig opslaan en beheren, waardoor toekomstige transacties worden vereenvoudigd en ze niet hun gegevens opnieuw hoeven in te voeren",
            "title-1": "Tokenisatie (tokenization)",
            "title-2": "Kaartenbeheer"
          }
        },
        "text": "Het stroomlijnen van herhaalde betalingen staat voorop bij de focus van Noda om transacties soepeler te laten verlopen",
        "title": "Sneller afrekenen met betalingen in één klik"
      },
      "refunds-data": {
        "subtitle": "Ondersteuning na aankoop",
        "text": "Verbeter de ervaring van uw klanten met naadloze terugbetalingen via de API en de gebruikersinterface",
        "title": "Eenvoudige terugbetalingen"
      },
      "single-report-data": {
        "subtitle": "Meer kennis door data",
        "text": "Volg en monitor het betalingsverkeer, analyseer betaalpatronen en genereer uitgebreide rapporten met de betaalgeschiedenis en prestaties via één enkel dashboard",
        "title": "Eén rapportagesysteem"
      },
      "subscription-data": {
        "date-1": "Te betalen op 27 september",
        "date-2": "Te betalen op 23 oktober",
        "date-3": "Te betalen op 31 december",
        "title-1": "Netflix",
        "title-2": "Music Premium",
        "title-3": "Abonnement bibliotheek"
      },
      "title-1": "Voor uw",
      "title-2": "Bedrijfsbehoeften"
    },
    "card-payouts": {
      "card-payouts-title": {
        "1": "Kaartbetalingen:",
        "2": "voor efficiënte transacties"
      },
      "hero-data": "Betaal moeiteloos leveranciers, portefeuillehouders (wallets), streamers en anderen met onze snelle en eenvoudige kaartbetalingen.",
      "netting-data": {
        "list": {
          "1": "Gestroomlijnd afhandelingsproces",
          "2": "Razendsnelle beschikbaarheid",
          "3": "AI-gestuurde routing overboekingen"
        },
        "subtitle": "Saldering balans",
        "text": "Ervaar razendsnelle betalingen naar kaarten via onze wereldwijde en lokale routes voor kaartbetalingen, waardoor geld in realtime aan uw begunstigden wordt overgemaakt",
        "title": "Geld is direct beschikbaar"
      },
      "payments-data": {
        "text": "Eenvoudige uitbetalingen cards voor verkopers",
        "title": "Kaartbetalingen"
      },
      "payouts-data": {
        "items": {
          "credit": {
            "text": "Met uitgebreide ervaring in de wereldwijde betaalssector biedt Noda eersteklas oplossingen voor kaartbetalingen die zijn afgestemd op uw zakelijke behoeften",
            "title": "Betalingsexpertise"
          },
          "group": {
            "text": "Noda werkt nauw samen met verkopers en kaarthouders om sectorspecifieke uitdagingen voor B2C en C2B geldstromen te begrijpen.",
            "title": "Wij begrijpen de uitdagingen in uw sector"
          }
        },
        "text": "Stroomlijn bulkbetalingen aan individuen met Noda. Betaal uw leveranciers, marktplaatsgebruikers en anderen eenvoudig",
        "title": "Snellere B2C kaartbetalingen met Noda"
      },
      "routing-data": {
        "items": {
          "airline": {
            "text": "Met de efficiënte routing van Noda bereikt uw geld razendsnel zijn bestemming",
            "title": "Snelle beschikbaarheid van geld"
          },
          "map": {
            "text": "Minimaliseer extra bankoverschrijvingen en de bijbehorende kosten met onze geavanceerde routing voor betalingen",
            "title": "Lagere kosten"
          }
        },
        "text": "Wij optimaliseren de verzending van uw geld om maximale snelheid en kostenefficiëntie te garanderen en tegelijkertijd inefficiënte bancaire routes te vermijden",
        "title": "Routing"
      },
      "transfers-data": {
        "items": {
          "approval": {
            "text": "Saldering garandeert een soepele transfer, zonder vertraging, van geld en helpt zo een gezonde cashflow voor uw bedrijf te behouden",
            "title": "Voorkom kastekorten"
          },
          "wallet": {
            "text": "Gebruik het bestaande saldo voor betalingen, waardoor er geen extra bankoverschrijvingen en kosten ontstaan",
            "title": "Kostenefficiënt"
          }
        },
        "subtitle": "Vermijd extra overboekingen",
        "text": "Beheer uw inkomende balans naadloos met de uit te betalen bedragen. Maak gebruik van deze kostenefficiënte betalingsmethode en de onmiddellijk beschikbare middelen",
        "title": "Gebruik uw inkomende balans om betalingen te doen"
      }
    },
    "checkout": {
      "ai-routing": {
        "text": "Verbeter de verwerking van uw kaartbetalingen met de AI-gestuurde routing en technologie van Noda voor het verbeteren van de acceptatie. Onze geavanceerde software analyseert transacties, stuurt ze door naar de optimale bank voor het verwerken van de transacties en verbetert het aantal geaccepteerde kaartbetalingen",
        "title": "Slimme AI-routing en betere acceptatie"
      },
      "checkout-hero-title": {
        "colored": "Betaalproces",
        "default": "Probleemloos"
      },
      "convenience": {
        "text": "Het stroomlijnen van herhaalde betalingen is een prioriteit voor Noda om zo transacties soepeler te laten verlopen. Klanten kunnen hun kaartgegevens veilig opslaan en beheren, waardoor toekomstige transacties worden vereenvoudigd en ze hun gegevens niet opnieuw hoeven in te voeren",
        "title": "Sneller afrekenen met betalingen in één klik",
        "title-1": "Gemak boven alles"
      },
      "experience-list": {
        "brush": {
          "text": "Personaliseer uw betaalinterface zodat deze past bij uw eigen merkbeleving qua merk, kleuren en design",
          "title": "Gepersonaliseerde UI"
        },
        "task": {
          "text": "Sneller en moeiteloos online betalen met duidelijke tips en een eenvoudig te begrijpen leidraad",
          "title": "Intuïtieve UX"
        }
      },
      "hero": "Ontgrendel de kracht van naadloze betalingen met de gebruiksvriendelijke interface van het betaalproces van Noda en de uitgebreide reeks betaalfuncties",
      "hood-data": {
        "amount": "Bedrag",
        "bank": "Bank",
        "card-issuer": "Kaartuitgever",
        "card-type": "Kaarttype",
        "country": "Land",
        "currency": "Valuta",
        "date-time": "Datum & tijd",
        "geolocation": "Geolocatie",
        "metadata": "Metadata",
        "store": "Winkel"
      },
      "how-data": {
        "observation": {
          "text": "Het krachtige AI-gestuurde risicoanalysemodel van Noda evalueert meer dan 50 parameters om slimmere en veiligere oplossingen voor kaartbetalingen te bieden, waardoor u meer gemoedsrust ervaart",
          "title": "Observatie"
        },
        "payment-resolution": {
          "text": "Het solide AI-gestuurde risicoanalysemodel van Noda werkt samen met ons team om meer dan 50 parameters te evalueren en slimmere en veiligere oplossingen voor kaartbetalingen te bieden, waardoor een hoog percentage van transacties wordt gegarandeerd",
          "title": "Betalingsafhandeling"
        },
        "risk-estimation": {
          "text": "Na de betaling zorgvuldig te hebben geanalyseerd en de benodigde data/gegevens te hebben verzameld, voorspelt het AI-model van Noda de potentiële risiconiveaus in realtime",
          "title": "Risicoschatting"
        }
      },
      "info-data": {
        "subtitle": "Veiligheid voorop",
        "text": "Bescherm uw bedrijf en klanten met onze AI-gestuurde risicoschatting en dynamische reactiemogelijkheden voor veilige en betrouwbare kaartbetalingen",
        "title": "Risicobeoordeling en reactie"
      },
      "localised-checkout": {
        "text": "Maak een betaalproces op maat wereldwijd mogelijk voor uw klanten. Noda biedt geavanceerde lokalisatie voor 10 talen, compatibiliteit met verschillende apparaten en betaalmethoden die geoptimaliseerd zijn voor specifieke regio's",
        "title": "Gelokaliseerd betaalproces wereldwijd"
      },
      "localization-list": {
        "chart": {
          "text": "Noda gaat verder dan alleen het aanpassen van de taal door voor elk land betaalmethoden en processen te implementeren die het meest gangbaar zijn",
          "title": "Geoptimaliseerde lokalisatie"
        },
        "mobile": {
          "text": "Verbeter de klantervaring door een geoptimaliseerd betaalproces voor elk apparaat en elke software",
          "title": "Meerdere schermen en platforms"
        }
      },
      "payment-methods": {
        "text": "Of het nu gaat om bankoverschrijvingen, creditcards, betaalkaarten of wallets, Noda heeft het allemaal. Met tientallen geïntegreerde betaalmethoden kunnen verkopers hun betaalstromen optimaliseren en klanten de flexibiliteit bieden die ze nodig hebben om hun aankopen af te ronden",
        "title": "Onbeperkte betaalmethoden"
      },
      "payments-data": {
        "text": "Gestroomlijnde checkout voor klanten",
        "title": "Checkout-structuur"
      },
      "personal-touch": {
        "text": "Noda voorspelt en onthoudt op een intelligente wijze het optimale betaalproces van elke klant, inclusief de betaalmethode die hun voorkeur heeft, waardoor hun uiteindelijke klanten probleemloos en eenvoudig kunnen winkelen.",
        "title": "Voldoet aan de behoeften van al uw klanten",
        "title-1": "Persoonlijk contact"
      },
      "refunds-data": {
        "subtitle": "Ondersteuning na aankoop",
        "text": "Verbeter de ervaring van uw klanten met probleemloze terugbetalingen, zowel via de API als de gebruikersinterface",
        "title": "Probleemloze terugbetalingen"
      },
      "single-report-data": {
        "subtitle": "Meer kennis door data",
        "text": "Volg en monitor het betalingsverkeer, analyseer betaalpatronen en genereer uitgebreide rapporten met de betaalgeschiedenis en prestaties via één enkel dashboard",
        "title": "Eén rapportagesysteem"
      },
      "tailored-experience": {
        "text": "Het op maat gemaakte betaalproces van Noda sluit aan bij de infrastructuur van de verkoper waardoor uw klanten een meer naadloze en vertrouwde betaalervaring hebben",
        "title": "Een op maat gemaakte ervaring voor uw klanten"
      }
    },
    "common": {
      "about": {
        "company": {
          "subtext": "Leer meer over onze geschiedenis en leiderschap",
          "subtitle": "Bedrijf"
        },
        "legal-privacy": {
          "subtext": "Bekijk onze juridische documentatie",
          "subtitle": "Juridisch en privacy"
        },
        "mission": {
          "subtext": "Ontdek Noda's missie, visie en wat ons uniek maakt",
          "subtitle": "Wie we zijn"
        },
        "partnership": {
          "subtext": "Word onze partner",
          "subtitle": "Partnerschap"
        },
        "risk-policies": {
          "subtext": "Maak kennis met ons beleid voor risicocompliance",
          "subtitle": "Risico- en AML/CFT-beleid"
        },
        "security": {
          "subtext": "Leer over Noda's beveiligingsinspanningen en beleid",
          "subtitle": "Beveiliging en gegevensverwerking"
        },
        "ux-approach": {
          "subtext": "Ontdek wat UX betekent voor Noda",
          "subtitle": "UX-aanpak"
        },
        "white-label": {
          "footer": "White Label Partners",
          "subtext": "Bouw je eigen betaalplatform met Noda",
          "title": "Voor White Label Partners"
        },
        "why-open-banking": {
          "subtext": "Ontkracht de mythes over Open Banking",
          "subtitle": "Waarom Open Banking?"
        }
      },
      "automated-data": {
        "item-1": "Accuraat: verkleint de kans op fouten",
        "item-2": "Efficiënt: elimineert vertragingen",
        "item-3": "Veilig: verifiërt alles wat belangrijk is"
      },
      "automated-payouts-text": "Door het automatiseren van het beoordelings- en validatieproces helpt Noda om te garanderen dat alle betalingen snel, nauwkeurig en veilig worden verwerkt. Dit biedt een probleemloze ervaring voor zowel verkopers als begunstigden",
      "automated-payouts-title": "Geautomatiseerde beoordeling en validatie van betalingen",
      "banner-market": {
        "button": "Ga naar marktplaats",
        "text": "Geleidelijke groei of een snelle impuls?<br/>Jij weet het beste wanneer het tijd is om je bedrijf naar een hoger niveau te tillen.",
        "title": "Een nieuwe kijk op betalen&nbsp;– <br />Bekijk op uw gemak alle producten van Noda"
      },
      "best-conditions-v2": {
        "additional": {
          "btn": "Contact Sales Team",
          "details": {
            "option-1": "De eerste 3 maanden gratis voor het MKB",
            "option-2": "Geld direct op je rekening",
            "option-3": "Frauderisico is nihil",
            "option-4": "90% acceptatiegraad"
          },
          "offer": "Neem contact op met ons verkoopteam voor een offerte op maat",
          "subtitle": "Ervaar snelle en veilige betalingen met Noda's abonnement voor e-commerce",
          "title": "Voor bedrijven in alle soorten en maten"
        },
        "btn": "zonder opstartkosten",
        "description": "Maximaliseer je winst met betaalbare prijzen en",
        "subtitle": "Schaalbare abonnementen voor jouw zakelijke behoeften",
        "title": "De beste voorwaarden voor elk bedrijf"
      },
      "call-to-action": {
        "contact-btn": "Contact Verkoop",
        "contact-team-btn": "Contacteer Ons Team",
        "contact-team-btn-2": "Neem contact op met ons team",
        "explore": "Bekijk documentatie",
        "get-notified": "Krijg een melding",
        "get-started": "Aan de slag",
        "learn-more": "Meer info",
        "read-less": "Lees minder",
        "read-more": "Lees meer",
        "sign-up": "Aanmelden binnen 10 minuten",
        "start": "Start",
        "start-using-noda": "Aan de slag",
        "try-noda": "Probeer Noda",
        "use-cases-btn": "Meer Over Open Banking",
        "withdraw": "Opnemen op bankrekening"
      },
      "contact": {
        "all-rights": " Noda. Alle rechten voorbehouden",
        "careers": "Vacatures",
        "client-support": "Klantenservice",
        "contact-us": "Contact",
        "cookie": "Cookiebeleid",
        "follow": "Volg ons",
        "hr": "HR-team",
        "marketing": "Marketing",
        "naudapay-limited": "NAUDAPAY LIMITED, (ondernemingsnummer: 11741664) met het geregistreerde adres: 162 Buckingham Palace Road, London, SW1W 9TR, UK is een geautoriseerd betaaldienstverlener (Payment Institute) en gereguleerd door de Financial Conduct Authority (FCA) (Referentienummer: 832969) onder de Richtlijn Betalingsdiensten (Payment Services Directive (EU) 2015/2366)",
        "partnership": "Partnerschap",
        "policy": "Privacybeleid",
        "public-relations": "Public Relations",
        "support": "Vraag support aan",
        "terms": "Gebruiksvoorwaarden"
      },
      "currency": {
        "subtitle": "Mogelijkheden",
        "text": "Breid uw bedrijf internationaal uit met het aanbod van Noda voor betalingen in meer dan 100 wereldvaluta's.",
        "title": "Verscheidenheid aan valuta"
      },
      "developers": {
        "bank-payouts-api": "Bank Payout API",
        "card-payments-api": "Card Payment API",
        "card-payouts-api": "Card Payout API",
        "login-to-hub": {
          "subtitle": "Volledige controle over alle functies",
          "title": "Inloggen op de Hub"
        },
        "noda-plugins": {
          "subtitle": "Plug-ins voor e-commmerce",
          "title": "Noda plug-ins"
        },
        "ob-payments-api": "OB Payment API",
        "open-banking-demo": {
          "subtitle": "Bekijk hoe Noda producten werken",
          "title": "Noda Demo"
        },
        "pay-and-go": "Pay & Go",
        "tech-documentation": {
          "subtitle": "Volledige controle over alle functies",
          "title": "Technische documentatie"
        }
      },
      "discover-more-title": "Ontdek meer kenmerken",
      "discover-title": "Ontdek",
      "extensive-product-suite-v2": {
        "description": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Met onze gebruiksvriendelijke en gestroomlijnde API's breng je je producten moeiteloos op de markt",
        "description-v2": "Ontdek nieuwe kansen voor je bedrijf met het betaalservicesysteem van Noda. Ontvang en verstuur betalingen met het grootste gemak. Geef je omzet een boost met onze gebruiksvriendelijke dataservices en betaaloplossingen waarvoor je geen codes nodig hebt.",
        "subtitle": "Functies en integraties",
        "title": "Uitgebreide productoplossingen"
      },
      "features": {
        "info": {
          "1": {
            "text": "Snelle en eenvoudige set-up. Geautomatiseerde onboarding en API-key management beschikbaar via de Noda Hub",
            "title": "Eenvoudig onboarden"
          },
          "2": {
            "text": "Veilig, snel en efficiënt transactiebeheer",
            "title": "Veilige transacties"
          },
          "3": {
            "text": "Naadloze integratie met elke tech-stack naar keuze",
            "title": "Soepele integratie"
          },
          "4": {
            "text": "Onboarding op maat met uw Personal Account Manager",
            "title": "Personal Manager"
          },
          "5": {
            "text": "Gedetailleerde rapportage en analyses beschikbaar via de Noda Hub",
            "title": "Analyses"
          },
          "6": {
            "text": "Eenvoudige en gestroomlijnde verwerking van terugbetalingen",
            "title": "Terugbetalingen"
          },
          "7": {
            "text": "Probleemloze connectiviteit met toonaangevende banken in het VK en de EU binnen het ecosysteem",
            "title": "Vertrouwde banken"
          },
          "8": {
            "text": "Ondersteunt meerdere gebruikersrollen binnen de Noda Hub",
            "title": "Meerdere toegewezen rollen"
          },
          "9": {
            "text": "Customer to Business (C2B) accounts zijn beschikbaar voor verkopers",
            "title": "C2B accounts"
          },
          "10": {
            "text": "Geavanceerde beveiligingsfuncties, waaronder wereldwijde en lokale zwarte lijsten",
            "title": "Zwarte lijst"
          }
        },
        "subtitle": "Meer informatie over de dekking van Noda",
        "text": "De tien belangrijkste kenmerken die perfect zijn afgestemd op uw bedrijf",
        "title": "Belangrijkste kenmerken"
      },
      "footer": {
        "features-release": "We brengen elk jaar honderden nieuwe functies en verbeteringen uit om je te helpen om ontwikkelingen in de sector voor te blijven en een sterke basis voor je bedrijf te bouwen",
        "how-to-integrate": "Hoe te integreren",
        "lets-get-in-touch": "Neem contact met ons op",
        "stay-connected": "Blijf verbonden",
        "stay-connected-text": "Neem contact op met ons team voor meer informatie over partnerschap en samenwerking",
        "total-balance": "Totale balans",
        "ultimate-provider": "De Ultieme Open Banking Provider"
      },
      "geo-v2": {
        "button": "Ondersteunde bankenlijst bekijken",
        "subtitle": "Locaties",
        "text": "Profiteer van onze wereldwijde dekking en zorg dat je in elke uithoek van de wereld transacties kunt verwerken",
        "title": "Volledige geografische dekking",
        "title-v2": "Uitgebreide wereldwijde dekking"
      },
      "get-started": "Aan de slag",
      "header": {
        "about": "Over",
        "articles": "Artikelen",
        "case-studies": "Casestudies",
        "developers": "Developers",
        "events": "Evenementen",
        "glossary": "Woordenlijst",
        "marketplace": "Marktplaatsen",
        "newsroom": "Nieuwsredactie",
        "other": "Overig",
        "pricing": "Tarieven",
        "products": "Producten",
        "resources": "Bronnen",
        "use-cases": "Gebruiksscenario's"
      },
      "hero-v2": {
        "new": "Nieuw",
        "personal-onboarding-assistant": "Persoonlijke onboarding-assistent voor elke onderneming"
      },
      "how-to-start": {
        "subtitle-1": "Gemakkelijke Onboarding",
        "text": "Noda biedt gemakkelijke onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons team is hier om te helpen met eventuele obstakels. Om Noda te gebruiken, vul je gewoon het formulier in, en onze verkoopvertegenwoordigers zullen kort contact met je opnemen.",
        "title-1": "Hoe te beginnen"
      },
      "identification-text": "Noda biedt naadloze KYC (Know Your Customer) procedures met behulp van geavanceerde Open Banking-technologie, waardoor uw klanten geen gedoe hebben met het indienen van documenten en foto's/selfies",
      "kyc-title": "Hoogwaardige KYC (Know Your Customer) op aanvraag",
      "more-title": "Meer kenmerken",
      "not-verified": "80% geverifieerd",
      "offer-for-smbs": {
        "from": "Vanaf",
        "per-transaction": "per transactie",
        "title": "De eerste 3 maanden gratis voor het MKB"
      },
      "payee-identification-title": "Open Banking identificatie van de begunstigde",
      "personal-manager": "Uw persoonlijke leidinggevende",
      "post-payment-support": "Noda biedt uitgebreide ondersteuning na betaling, gericht op samenwerking en vooruitgang",
      "products": {
        "financial-data": {
          "know-your-whales": {
            "subtext": "Prognostische financiële inzichten voor verkopers",
            "subtext-2": "Prognostische financiële inzichten voor verkopers",
            "subtitle": "Gegevensver&shy;rijking"
          },
          "sign-in-via-bank": {
            "subtext": "Veilig inloggen met één klik en bankgegevens",
            "subtitle": "Inloggen via de bank"
          },
          "title": "Financiële data",
          "virtual-ibans": {
            "subtext": "Wereldwijde bankoverschrijvingen met een virtuele IBAN",
            "subtitle": "Virtuele IBAN's"
          }
        },
        "noda-go": {
          "pay-and-go-hard": "Pay & Go Hard",
          "pay-and-go-light": "Pay & Go Light"
        },
        "pay-ins": {
          "card-payments": {
            "subtext": "Eenvoudige verwerking van kaartbetalingen voor verkopers",
            "subtitle": "Kaartbetalingen"
          },
          "checkout-form": {
            "subtext": "Gestroomlijnde checkout voor klanten",
            "subtitle": "Checkout-structuur"
          },
          "instant-payment-links": {
            "subtext": "Flexibele betaling via verschillende mediatypen",
            "subtitle": "Directe Betalingslinks"
          },
          "merchant-of-record": {
            "subtext": "Alles-in-één oplossing voor het afhandelen van alle betalingen en wettelijke verplichtingen",
            "subtitle": "Merchant of Record"
          },
          "no-code-payment": {
            "subtext": "Aangepaste betaalpagina's via AI builder",
            "subtitle": "Betaalpagina Zonder Code"
          },
          "open-banking-payments": {
            "subtext": "Snelle, veilige en gereguleerde bankoverschrijvingen",
            "subtitle": "Open Banking betalingen"
          },
          "title": "Pay-ins"
        },
        "pay-outs": {
          "bank-payouts": {
            "subtext": "Handige en snelle uitbetalingen bank voor verkopers",
            "subtitle": "Bankbetalingen"
          },
          "card-payouts": {
            "subtext": "Eenvoudige uitbetalingen cards voor verkopers",
            "subtitle": "Kaartbetalingen"
          },
          "title": "Uitbetalingen"
        }
      },
      "resources": {
        "articles": "Artikelen",
        "glossary": "Woordenlijst"
      },
      "subscribe": {
        "title-1": "Ontvang het laatste nieuws van Noda",
        "title-2": "Blijf op de hoogte met Noda door je aan te melden voor onze nieuwsbrief"
      },
      "tech-friendly-v2": {
        "acceptance-rate": {
          "option-1": "Boven de 90%",
          "option-2": "acceptatiegraad"
        },
        "api-key-management": {
          "description": "Eenvoudig beheer van API-sleutels"
        },
        "description": "Noda biedt een probleemloze integratie met zijn API en front-end-componenten, waardoor een soepele integratie in je platform gegarandeerd is. Ervaar een snelle en efficiënte installatie en begin binnen enkele uren, in plaats van weken, met het aanbieden van betere betaaloplossingen aan je klanten.",
        "gateway": {
          "description": "Veilige en betrouwbare gateway"
        },
        "subtitle": "Tech-vriendelijk",
        "tech-platforms-support": {
          "description": "Alle soorten technologieplatforms worden ondersteund"
        },
        "title": "Naadloze integratie voor betere betalingen: begin binnen enkele uren, in plaats van weken"
      },
      "transaction-control": {
        "part-title-1": "Controletransacties in onze",
        "part-title-2": "Multifunctioneel dashboard",
        "text-1": "Met Noda Hub kunt u probleemloos op één enkel platform onboarden, voorkeuren voor transacties configureren, transacties en rapporten monitoren en uw betalingsverkeer analyseren.",
        "text-2": "Geconsolideerde functies voor een moeiteloos betalingsbeheer",
        "title-2": "Monitor met vertrouwen"
      },
      "use-cases": {
        "ecommerce": {
          "subtext": "Betalingsgateway voor e-commerce",
          "subtitle": "E-commerce"
        },
        "educational-platforms": {
          "subtext": "Betaalgateway voor educatieve platforms",
          "subtitle": "Educatieve platforms"
        },
        "marketplaces": {
          "subtext": "Betaalgateway voor marktplaatsen",
          "subtitle": "Marktplaatsen"
        },
        "online-gaming": {
          "subtext": "Betalingsgateway voor online gaming",
          "subtitle": "Online gamen"
        },
        "retail": {
          "subtext": "Betalingsgateway voor detailhandel",
          "subtitle": "Detailhandel"
        },
        "saas": {
          "subtext": "Betaalgateway voor SaaS",
          "subtitle": "SaaS"
        },
        "travel": {
          "subtext": "Betalingsoplossingen voor reisbedrijven",
          "subtitle": "Reizen & Toerisme"
        }
      },
      "verified": "100% geverifieerd"
    },
    "company": {
      "articles": {
        "title": "Nieuwste van Noda"
      },
      "hero": {
        "part-1": "Uw betalingen, ",
        "part-2": "Onze prioriteit",
        "text": "Wij zijn Noda - een toonaangevende wereldwijde betalingsprovider - wij maken een ultieme nieuwe manier mogelijk voor online verkopers om online betalingen te accepteren en direct bankbetalingen te ontvangen als alternatief voor kaarten, zonder terugboekingen"
      },
      "leadership": {
        "ceo": {
          "name": "Igor Loktev",
          "role": "CEO/Co-Founder",
          "text": "Igor brengt meer dan 20 jaar ervaring in IT en financiën naar ons team. Met een MSc in Computing Science, een Executive MBA en een nog gaande PhD studie in Quantum Computing blinkt hij uit in product engineering, data analyse en systeemoptimalisatie.\n\nIgor is vastbesloten om de groei van Noda te leiden en een voortrekkersrol te spelen op het gebied van innovatie in de fintech-sector.\n\nZijn grote interesse in sport, muziek en het dynamische gebied van Computing Science spelen een belangrijke rol in zijn professionele aanpak."
        },
        "clo": {
          "name": "Ellina Sedleniece",
          "role": "Chief Legal Officer (CLO)",
          "text": "Ellina versterkt het team met een schat aan ervaring. Zij heeft 15 jaar ervaring op juridisch gebied met een focus op M&A, FinTech, Venture Capital, Data Protection, Banking en Finance.\n\nZe is toegewijd aan het creëren van innovatieve en resultaatgerichte juridische oplossingen die zijn ontworpen om bedrijfsgroei te bevorderen, risico's te beperken en de belangen van het bedrijf veilig te stellen.\n\nMet een sterke educatieve achtergrond van de Riga Graduate School of Law, behaalde ze een LLM in International and European Law in 2019, gevolgd door een LLM in Technology Law in 2020. Ellina is gevestigd in Riga en combineert haar omvangrijke juridische expertise met een vooruitziende blik om te navigeren door de complexiteit van de huidige globale, technologische wereld.\n\nEllina verrijkt haar professionele expertise met diverse interesses. Ze geniet van de kunst van het pianospelen, het genot van reizen en de meeslepende wereld van lezen."
        },
        "coo": {
          "name": "Anastasija Tenca",
          "role": "Chief Operations Officer (COO)",
          "text": "Anastasija is een door succes gedreven professional met meer dan 10 jaar ervaring op het gebied van sales, marketing, brand en project management, naast bedrijfsadministratie en de operationele bedrijfsvoering. Ze speelt een cruciale rol in het aansturen van alle operationele facetten van Noda en zet zich in voor de ontwikkeling en uitvoering van strategische bedrijfsinitiatieven.\n\nHaar betrokkenheid bij Noda strekt zich uit tot het ontwikkelen en implementeren van bedrijfsstrategieën die succes boeken, het bouwen van sterke en duurzame zakelijke relaties, het verfijnen van processen voor maximale efficiëntie en het toezicht houden op de financiële activiteiten van de organisatie.\n\nAnastasija's veelzijdige expertise en haar strategische benadering van bedrijfsvoering maken haar van onschatbare waarde voor ons team en een belangrijke architect van de voortdurende groei en innovatie van Noda."
        },
        "cro-cco": {
          "name": "Lasma Gavarane",
          "role": "Chief Risk & Compliance Officer (CRO & CCO)/MLRO",
          "text": "Lasma heeft bijna tien jaar ervaring in de FinTech-sector en is gespecialiseerd in Risk & Compliance. Haar professionele loopbaan wordt gestaafd door een dubbele academische achtergrond, met bachelor diploma's in Business Management en Rechten.\n\nLasma is niet alleen lid van de International Association of Certified Anti-Money Laundering Specialists (ACAMS), maar heeft ook het 'Advanced Certified Anti-Money Laundering Specialist - Risk Management' certificaat (CAMS-RM), waarmee ze een expert is op het gebied van Risk & Compliance.\n\nHaar interesse strekt zich uit naar het begrijpen hoe technologische ontwikkelingen, zoals die in de NewGen-wereld (Nieuwe Generatie), inclusief AI, verschillende aspecten van professionele omgevingen kunnen verbeteren en innoveren en hoe deze kunnen worden toegepast en geïntegreerd binnen Noda."
        },
        "cro": {
          "name": "Michael Bystrov",
          "role": "Chief Revenue Officer at Noda",
          "text": "Michael Bystrov, onze Chief Revenue Officer, staat aan het hoofd van de strategieën van Noda voor het genereren van inkomsten en heeft een lange 18-jarige ervaring in Sales en Marketing bij verschillende internationale bedrijven. Zijn ervaring varieert van het managen van de regionale distributie van Apple tot het leiden van ATL- en BTL-campagnes voor gerenommeerde merken als Nestle, JTI en Diageo Group.\n\nMet een MSc in Financial Management en een Associate degree in Marketing & Advertising heeft Michael een grondige kennis van de marktdynamiek. Zijn expertise was van groot belang bij het voorbereiden van advertentieformules voor Olympische evenementen en in de samenwerking met overheidinstanties.\n\nBuiten zijn werk is Michael een fervent reiziger, wat zijn internationale perspectief voor zakendoen versterkt, en is hij toegewijd aan het behoud van walvissen, waaruit zijn betrokkenheid bij milieugerelateerde zaken blijkt."
        },
        "cso": {
          "name": "Volodymyr Mykhailin",
          "role": "Chief Solutions Officer",
          "text": "Volodymyr belichaamt een combinatie van academische excellentie en professionele expertise met een achtergrond in Computer Systemen en Netwerk Engineering. Met zijn uitgebreide ervaring in de IT-sector, blinkt hij uit in het integreren van geavanceerde technologische oplossingen in onze bedrijfsprocessen, waardoor zowel de operationele efficiëntie als de klanttevredenheid wordt verbeterd.\n\nToegewijd aan het bevorderen van technologische innovatie, leidt Volodymyr ons team in het ontwikkelen van geavanceerde IT-strategieën en oplossingen die de eisen van de wereldmarkt overtreffen. Zijn leiderschap zorgt ervoor dat ons bedrijf voorop blijft lopen in de tech-industrie.\n\nNaast zijn professionele prestaties, verrijken Volodymyr's diverse interesses, zoals bergwandelen en muziek, zijn veerkracht en strategisch denken, wat zowel zijn werk als persoonlijk leven verrijkt."
        },
        "cto": {
          "name": "Andrei Batseka",
          "role": "Chief Technical Officer (CTO)",
          "text": "Andrei voegt een gedegen programmeer- en ontwikkelingsachtergrond van 13 jaar toe aan ons team en heeft een bachelor diploma in Computer Science. Zijn expertise strekt zich uit over verschillende domeinen, waardoor hij een veelzijdig en bekwaam lid van ons Tech Department is.\n\n Bij Noda speelt Andrei een centrale rol in het aansturen van belangrijke technologische initiatieven en innovaties, waarbij hij zijn diepgaande kennis van programmeren naar onze projecten brengt. Zijn toewijding aan continu leren en ontwikkelen blijkt uit zijn grote belangstelling in machine learning en neurale netwerken, die hij actief in zijn werk integreert.\n\nNaast zijn professionele bezigheden is Andrei's passie voor het bespelen van verschillende muziekinstrumenten, in combinatie met zijn liefde voor zwemmen en fietsen, een weerspiegeling van zijn dynamische en veelzijdige persoonlijkheid. Deze hobbies verrijken niet alleen zijn leven, maar inspireren ook tot een creatieve en holistische benadering van zijn technische werk."
        },
        "cxd": {
          "name": "Vladislav Golovach",
          "role": "Chief Experience Designer (CXD)",
          "text": "Vladislav brengt 20 jaar ervaring in ergonomie en gebruiksvriendelijkheid mee naar het team van Noda. Hij houdt van UX-projecten die een uitdaging vormen en diepgaand onderzoek vereisen.\n\nZijn carrière als auteur en pionier op het gebied van UI- en UX-design wordt gekenmerkt door zijn vermogen om interfaces te ontwerpen die zowel intuïtief als elegant zijn. Hij zet ingewikkelde ideeën om in toegankelijke systemen en gebruikersonderzoek in bruikbare verbeteringen.\n\nVladislav woont in Padua, Italië en combineert zijn liefde voor design met een passie voor het creëren van zinvolle gebruikerservaringen."
        },
        "strategy-advisor": {
          "name": "Lasma Kuhtarska",
          "role": "Co-Founder, Strategy Advisor",
          "text": "Lasma Kuhtarska is een vooraanstaand professional met een indrukwekkende ervaring in finance en business development. In 2020 bedacht en ontwikkelde ze Noda en was ze de drijvende kracht achter ons innovatieve platform. Als co-founder en Chief Strategy Officer speelt Lasma een sleutelrol in het vormgeven en implementeren van baanbrekende strategieën die de groei van Noda stimuleren.\n\nLasma heeft haar opleiding gevolgd aan de prestigieuze Stockholm School of Economics en daarnaast in Data Science for Business aan de Harvard Business School. Voordat ze Noda oprichtte, beheerde Lasma financiële analyses bij de Centrale Bank van Letland en werkte ze bij de SEB Group, een van de grootste banken in Zweden en de Baltische staten."
        },
        "title": "Leiderschap\nvan Noda"
      },
      "noda-timeline": {
        "events": {
          "option-1": "Bètaversie van onze open banking-betalingen live",
          "option-2": "Eerste handelaar ging live",
          "option-3": "Massadistributie gestart",
          "option-4": "Verbonden overgrote meerderheid van de banken in de EU en het VK",
          "option-5": "B2C-betalingen gelanceerd",
          "option-6": "Gevestigde bedrijven in Canada, Australië, Brazilië",
          "option-7": "Nieuwe diensten gelanceerd: AIS Data Services, AI-gegenereerde betaallinks",
          "option-8": "Licenties verworven in Brazilië en Australië, betalingen gelanceerd in Brazilië"
        },
        "month": {
          "1": "April, 2021",
          "2": "Augustus, 2021",
          "3": "December, 2021",
          "4": "Juli, 2022",
          "5": "Oktober, 2022",
          "6": "Mei, 2023",
          "7": "December, 2023",
          "8": "Mei, 2024"
        },
        "subtitle": "Tijdlijn Noda",
        "title": "Noda groeit met uw bedrijf mee"
      },
      "our-story": {
        "description1": "Noda is JIJ. Wij proberen menselijk te zijn voordat we een betalingsdienstaanbieder zijn. Omdat we door mensen voor mensen zijn ontworpen, bieden we een van de beste gebruikerservaringen die momenteel op de markt beschikbaar zijn.",
        "description2": "De add-ons van Noda zitten vol warmte, en ze zijn echt ontworpen om aan alle behoeften van klanten te voldoen op de meest handige en tijdbesparende manier. Niemand vindt het leuk om een eeuwigheid bezig te zijn met het online betalen van goederen of diensten. Betalen op zich is al geen prettige ervaring. Laten we het in ieder geval minder tijdrovend maken.",
        "description3": "We willen graag dat onze consumenten tijd doorbrengen met hun vrienden en familie en genieten van de kostbare momenten in het leven, in plaats van bijvoorbeeld eeuwenlang te moeten plannen hoe ze geld moeten overmaken voor het hotel of de huurauto, of hoe ze uitgaven tussen vrienden moeten regelen om een reis te betalen.",
        "subtitle": "Ons verhaal",
        "title": "Noda ben jij"
      }
    },
    "contact-form-v2": {
      "about": "Over ons",
      "address": "NAUDAPAY LIMITED, Ondernemingsnummer: 11741664, 162 Buckingham Palace Road, Londen, SW1W 9TR, UK",
      "description": "Vertel ons over uw bedrijf en onze betalingsexperts helpen u graag de perfecte oplossing voor uw behoeften te vinden.",
      "form": {
        "btn": "Indienen",
        "controls": {
          "comment": "Optioneel: Deel uw bedrijfsmodel en betalingsbehoeften. Dit helpt ons uw oplossing op maat te maken en het installatieproces te versnellen.",
          "company": "Bedrijfsnaam",
          "email": "Werk e-mail",
          "first-name": "Voornaam",
          "last-name": "Achternaam",
          "phone": "Werktelefoon *",
          "select-country": "Selecteer land",
          "website": "Productwebsite"
        },
        "labels": {
          "business": "Vertel ons meer over uw bedrijf",
          "comment": "Beschrijving van het bedrijfsmodel",
          "contact": "Voer uw contactgegevens in",
          "details": "Uw contactgegevens"
        }
      },
      "header": "Neem contact met ons op",
      "modal": {
        "back": "Ga terug naar de markt",
        "description": "Wij nemen binnenkort contact met u op.",
        "explore": "Ontdek Noda",
        "header": "🙌 Je bent helemaal klaar!"
      },
      "privacy": "Privacybeleid",
      "rights": "Noda. Alle rechten voorbehouden",
      "showcase": {
        "payment": "Selecteer de betalingsoplossingen die u nodig hebt",
        "recommended": "Misschien bent u ook geïnteresseerd",
        "related": "Gerelateerde oplossingen",
        "selected": "Door jou geselecteerde producten"
      },
      "terms": "Gebruiksvoorwaarden",
      "visit-website": "Bezoek de volledige website"
    },
    "contact-form": {
      "about": "Over ons",
      "address": "NAUDAPAY LIMITED, Ondernemingsnummer: 11741664, 162 Buckingham Palace Road, Londen, SW1W 9TR, UK",
      "description": "Vul het formulier in, alstublieft",
      "form": {
        "controls": {
          "comment": "Leg je bedrijfsmodel uit. Schets kort de reikwijdte van uw project. Vermeld de belangrijkste kenmerken en functies die het platform van Noda moet ondersteunen.",
          "company": "Bedrijfsnaam",
          "company-size": "Bedrijfsgrootte",
          "country": "Land",
          "email": "Werk e-mail",
          "first-name": "Voornaam",
          "last-name": "Achternaam",
          "phone": "Werktelefoon",
          "volume": "Betalingsvolume",
          "website": "Bedrijfswebsite"
        },
        "labels": {
          "business": "Voer uw bedrijfsgegevens in",
          "comment": "Beschrijving van het bedrijfsmodel",
          "contact": "Voer uw contactgegevens in",
          "details": "Vul uw gegevens in",
          "volume": "Laat ons je volume weten"
        },
        "volume": {
          "option-1": "Minder dan $50.000",
          "option-2": "$50.000 tot $100.000",
          "option-3": "$100.000 tot $1.000.000",
          "option-4": "$1.000.000 tot $10.000.000",
          "option-5": "Meer dan $10.000.000"
        }
      },
      "header": "Neem contact op met ons verkoopteam",
      "modal": {
        "back": "Ga terug naar de markt",
        "description": "Bedankt voor je contact, we nemen binnenkort contact met je op.",
        "header": "Inzending ontvangen!"
      },
      "powered": "Aangedreven door",
      "privacy": "Privacybeleid",
      "rights": "Noda. Alle rechten voorbehouden",
      "showcase": {
        "recommended": "Misschien bent u ook geïnteresseerd",
        "selected": "Door jou geselecteerde producten"
      },
      "terms": "Gebruiksvoorwaarden"
    },
    "contact-us": {
      "contact-us-hero": {
        "1": "Public Relations",
        "2": "Marketing",
        "3": "Klantenservice",
        "4": "Carrières",
        "5": "Partnerschap",
        "6": "Verkoop"
      },
      "contact-us-locations": {
        "london": {
          "text": "162 Buckingham Palace Road, London, SW1W 9TR, UK",
          "title": "London, VK"
        },
        "madrid": {
          "text": "Calle Huertas 11, 28012, Madrid, Spanje",
          "title": "Madrid, Spanje"
        },
        "ontario": {
          "text": "1907 Baseline Road, Unit 104, Ottawa, Ontario, K2COC7, Canada",
          "title": "Ontario, Canada"
        },
        "riga": {
          "text": "Riga, Pils iela 18-23, Letland, LV-1050",
          "title": "Riga, Letland"
        },
        "vilnius": {
          "text": "Litouwen, Vilnius, Žalgirio g.90-100, LT-09303",
          "title": "Vilnius, Litouwen"
        }
      },
      "hero-text": "Neem contact met ons op en laat ons weten waarmee we u kunnen helpen. Noda staat altijd voor u klaar",
      "hero-title": "Onze locaties",
      "locations-text": "Noda is een internationaal bedrijf met verschillende locaties over de hele wereld"
    },
    "cookies": {
      "last-update": "Laatst bijgewerkt op <data>13 september 2024</data>",
      "section-1": {
        "list": {
          "item-1": "Noodzakelijke cookies worden gebruikt om de werking van de website te garanderen. Deze cookies worden gebruikt op basis van het legitieme belang van Noda om de werking van de website te garanderen en diensten te verlenen. Voor het gebruik van deze cookies is jouw toestemming niet nodig.",
          "item-2": "Voorkeur- en prestatiecookies helpen bij het uitvoeren van bepaalde functionaliteiten die je wilt gebruiken terwijl je op onze website bent, bijvoorbeeld met betrekking tot het gebruik van berichten- en contactformulieren, geregistreerd worden, taal kiezen en locatiegerelateerde functionaliteiten gebruiken. Voor het gebruik van deze cookies is jouw toestemming niet nodig.",
          "item-3": "Statistische cookies worden gebruikt om informatie over je activiteiten op de website te verzamelen en analyseren en om de werking van de website te verbeteren. Deze cookies helpen informatie te verstrekken over statistieken van het aantal bezoekers, bouncepercentage, waar bezoekers vandaan komen en andere gerelateerde informatie. Voor het gebruik van deze cookies is toestemming nodig.",
          "item-4": "Marketing-, targeting- of promotiecookies worden gebruikt om informatie te verzamelen over de websites die je bezoekt en om de bezoekers van de website voor marketingdoeleinden te segmenteren. Deze cookies worden ook gebruikt om bezoekers te voorzien van relevante advertenties en marketingcampagnes. Voor het gebruik van deze cookies is jouw toestemming nodig. Als je deze cookies niet toestaat, zul je in sommige gevallen minder gerichte reclame ervaren."
        },
        "text-1": "Een cookie is een klein stukje data (tekstbestand) dat een website — wanneer bezocht door een gebruiker — aan je browser vraagt om op te slaan op je apparaat om informatie over jou te onthouden, zoals je taalvoorkeur of inloggegevens. Deze cookies worden door ons ingesteld en worden first-party cookies genoemd. We gebruiken ook third-party cookies, dit zijn cookies van een ander domein dan het domein van de website die je bezoekt. Meer specifiek gebruiken we cookies voor de volgende doeleinden:",
        "text-2": "Cookies worden ontvangen door Noda en haar partners om de werking van de website te garanderen, jouw activiteiten op de website te verzamelen en te analyseren. Cookies kunnen verschillende soorten informatie verzamelen, zoals het IP-adres, het type apparaat dat wordt gebruikt, de gebruikte browser, de bezochte websites of andere informatie.",
        "title": "1. Wat zijn cookies?"
      },
      "section-2": {
        "title": "2. Noodzakelijke cookies"
      },
      "section-3": {
        "title": "3. Voorkeurs- en prestatiecookies"
      },
      "section-4": {
        "title": "4. Statistische cookies"
      },
      "section-5": {
        "title": "5. Marketing-, targeting- of promotiecookies"
      },
      "section-6": {
        "text-1": "Als je cookies wilt beperken, blokkeren of verwijderen, kun je dit doen door de instellingen van je browser of de cookie-instellingen op onze website te wijzigen. Als je de noodzakelijke en prestatiecookies verwijdert, werken de website of sommige onderdelen ervan niet.",
        "text-2": "Lees voor meer algemene informatie over cookies en hoe je deze kunt beheren de informatie op <a href=\"https://www.aboutcookies.org/\" target=\"_blank\" rel=\"nofollow\">www.aboutcookies.org</a>.",
        "title": "6. Hoe kan ik cookies beperken en verwijderen?"
      },
      "table": {
        "head-1": "Cookies",
        "head-2": "Doel",
        "head-3": "Aanbieder",
        "head-4": "Levensduur"
      },
      "text": "De website gemaakt en onderhouden door NaudaPay Limited (hierna: Noda) <a href=\"https://noda.live/\">www.noda.live</a> maakt gebruik van meerdere soorten cookies voor verschillende doeleinden.",
      "title": "Cookiebeleid"
    },
    "demo": {
      "breadcrumbs": {
        "demo": "Noda Demo",
        "home": "Thuis",
        "pay-and-go": "Pay&Go",
        "payment-flow": "Betalingsstroom"
      },
      "payment-flow": {
        "amount-label": "Ontdek hoe Noda werkt door te doneren aan een goed doel",
        "amount-placeholder": "Uw bedrag",
        "choose-country": "Kies uw land",
        "countries": {
          "at": "Oostenrijk",
          "be": "België",
          "bg": "Bulgarije",
          "br": "Brazilië",
          "ca": "Canada",
          "cz": "Tsjechië",
          "de": "Duitsland",
          "dk": "Denemarken",
          "ee": "Estland",
          "es": "Spanje",
          "fi": "Finland",
          "fr": "Frankrijk",
          "gb": "Verenigd Koninkrijk",
          "gr": "Griekenland",
          "hu": "Hongarije",
          "ie": "Ierland",
          "it": "Italië",
          "lt": "Litouwen",
          "lu": "Luxemburg",
          "lv": "Letland",
          "nl": "Nederland",
          "no": "Noorwegen",
          "pl": "Polen",
          "pt": "Portugal",
          "ro": "Roemenië",
          "se": "Zweden",
          "si": "Slovenië"
        },
        "country-select-label": "Land",
        "donate": "Doneer nu",
        "funds": {
          "br": {
            "description": "Met uw donatie financiert u de wereldwijde inspanningen van Plant-for-the-Planet om bosecosystemen te herstellen, de klimaatcrisis aan te pakken en de biodiversiteit te beschermen.",
            "title": "Plant-for-the-Planet"
          },
          "default": {
            "description": "Met uw donatie financiert u de strijd van Caritas Europa tegen armoede en sociale uitsluiting. Wij bevorderen menselijke ontwikkeling, sociale rechtvaardigheid en duurzame sociale systemen in heel Europa en wereldwijd.",
            "title": "Caritas Europa"
          },
          "gb": {
            "description": "Met uw donatie financiert u het onderzoek van de British Heart Foundation naar hart- en vaatziekten. Zo helpen we risicofactoren te verminderen en de gezondheid van het hart te verbeteren.",
            "title": "British Heart Foundation"
          },
          "ro": {
            "description": "Met jouw donatie steun je de missie van Save a Heart Association om levens te redden en gezondheidsresultaten te verbeteren door kritieke medische zorg te bieden, levensreddende behandelingen te financieren en hartaandoeningen in Roemenië en daarbuiten te voorkomen en onder de aandacht te brengen.",
            "title": "Save a Heart Association"
          }
        },
        "main-title": "Probeer Noda Betaling",
        "result": {
          "button": "Contact Verkoop",
          "cancel": "Ga naar de homepage",
          "subtitle": "{fund} heeft uw betaling ontvangen 🙌",
          "title": "Bedankt voor uw donatie aan het goede doel met Noda"
        }
      },
      "solutions": {
        "common": {
          "coming-soon": "Binnenkort beschikbaar",
          "no-docs-required": "Echte documenten zijn niet nodig voor demo",
          "see-more": "Bekijk meer",
          "try-demo": "Probeer demo",
          "with-verification": "Met identiteitsverificatie",
          "without-verification": "Zonder identiteitsverificatie"
        },
        "description": "Ontdek hoe Noda Products betalingen vereenvoudigt en uw omzetgroei versnelt.",
        "main-title": "Ontdek Noda-oplossingen",
        "pay-and-go": {
          "description": "Betaling, KYC en aanmelden. Alles-in-één.",
          "hard": "Klanten moeten automatische non-doc verificatie via GBG ondergaan. Als non-doc KYC verificatie mislukt, wordt een klant gevraagd om full-doc KYC via Sumsub te doorlopen. ",
          "light": "Als uw product geen identiteitsverificatie van de klant vereist, kunnen gebruikers direct betalen en registreren via Pay & Go Light."
        },
        "payment-flow": {
          "description": "Veilige rechtstreekse betalingen van rekening naar rekening via de bank."
        }
      }
    },
    "documents-page": {
      "nav": {
        "cookies": {
          "subtitle-1": "Wat zijn cookies?",
          "subtitle-2": "Noodzakelijke cookies",
          "subtitle-3": "Voorkeurs- en prestatiecookies",
          "subtitle-4": "Statistische cookies",
          "subtitle-5": "Marketing-, targeting- of promotiecookies",
          "subtitle-6": "Hoe kan ik cookies beperken en verwijderen?",
          "title": "Cookiebeleid"
        },
        "policy": {
          "subtitle-1": "Verantwoordelijkheden",
          "subtitle-2": "Wanneer verzamelen we je gegevens?",
          "subtitle-3": "Gegevens die we verzamelen, met welke doeleinden, de juridische basis en de bewaartermijnen",
          "subtitle-4": "Ontvangers en bronnen van jouw gegevens",
          "subtitle-5": "Internationale overdracht van jouw persoonsgegevens",
          "subtitle-6": "Jouw rechten",
          "subtitle-7": "Contactgegevens",
          "subtitle-8": "Wijzigingen aan het Privacybeleid",
          "title": "Privacybeleid"
        },
        "privacy-for-candidates": {
          "subtitle-1": "Waarvoor heeft Noda je gegevens nodig?",
          "subtitle-2": "Hoe gaat Noda om met mijn gegevens?",
          "subtitle-3": "Bronnen en ontvangers van gegevens",
          "subtitle-4": "Internationale overdrachten",
          "subtitle-5": "Rechten op het gebied van gegevensbescherming",
          "subtitle-6": "Contactgegevens",
          "title": "Privacyverklaring voor sollicitanten of samenwerking"
        },
        "terms": {
          "subtitle-1": "De overeenkomst",
          "subtitle-2": "Diensten die we leveren",
          "subtitle-3": "Toegang tot de service en communicatie over verdachte activiteiten",
          "subtitle-4": "Onze toegang tot je gegevens",
          "subtitle-5": "Beëindiging en opschorting",
          "subtitle-6": "Schadeloosstelling en aansprakelijkheid",
          "subtitle-7": "Klachten",
          "subtitle-8": "Algemene bepalingen",
          "title": "Gebruiksvoorwa&shy;arden"
        }
      },
      "title": "Juridische documenten"
    },
    "ecommerce": {
      "faq": {
        "currencies": {
          "content": "Noda ondersteunt verschillende wereldwijde valuta, waaronder EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON en SEK.",
          "title": "Welke valuta's zijn beschikbaar?"
        },
        "how-long": {
          "content": "Onze onboarding kan al binnen één dag plaatsvinden. Het ondersteuningsteam van Noda is er om je te helpen bij eventuele obstakels, zodat je snel betalingen kunt accepteren.",
          "title": "Hoe lang duurt het voordat ik betalingen kan accepteren met Noda?"
        },
        "how-to-start": {
          "content": "Eerst moet je aangemeld zijn bij Noda. Vul gewoon het formulier in en ons verkoopteam neemt binnenkort contact met je op. Wij bieden een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Onze processor integreert naadloos met API- en front-endcomponenten, waardoor een naadloze integratie in uw platform gegarandeerd is.",
          "title": "Hoe begin je met het online accepteren van betalingen met Noda?"
        },
        "needs": {
          "content": "Om te beginnen met Noda, vul het formulier in en ons verkoopteam zal binnenkort contact met je opnemen. Noda biedt een eenvoudige onboarding met de begeleiding van een toegewijde manager om ervoor te zorgen dat u bij elke stap wordt ondersteund.",
          "title": "Wat heb ik nodig om te beginnen?"
        },
        "subtitle": "Wat u moet weten",
        "title": "FAQs",
        "types": {
          "content": "Noda biedt e-commerce betaaloplossingen voor alle soorten en maten webwinkeliers, met schaalbare plannen om de groei van uw bedrijf te ondersteunen.",
          "title": "Welke soorten verkopers ondersteunt Noda?"
        }
      },
      "hero": {
        "text": "Verhoog uw e-commerce bedrijf. Ons alles-in-één betalingsplatform geeft prioriteit aan inzicht in de klant, efficiëntie en groei.",
        "title-1": "Betaaloplossingen ",
        "title-2": "voor e-commerce:",
        "title-gradient-1": "Uw betalingen ",
        "title-gradient-2": "zijn onze prioriteit"
      },
      "how-does-it-work": {
        "content": "Noda is een wereldwijd e-commerce betaalplatform en open banking provider. Van transactiebeheer tot financiële analyse, Noda heeft alles voor u in huis. Ons platform maakt gebruik van AI en machine-learning technologieën om state-of-the-art betaalgateway oplossingen te bieden voor e-commerce bedrijven.\n\nOpen banking betekent dat traditionele banken gegevens delen met gelicentieerde fintech-bedrijven, zoals Noda, om transacties te stroomlijnen. Ons betalingsecosysteem verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, waardoor e-commerce betalingsdiensten moeiteloos verlopen.",
        "subtitle": "Technologieën",
        "title": "Hoe werkt het"
      },
      "how-to-start": {
        "content": "Noda biedt een gemakkelijke onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons team is er om u te helpen bij eventuele wegversperringen. Om te beginnen met het gebruik van Noda, vul gewoon het formulier in en onze vertegenwoordigers zullen binnenkort contact met u opnemen.",
        "subtitle": "Eenvoudige onboarding",
        "title": "Hoe te beginnen"
      },
      "payments": {
        "text": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Onze gebruiksvriendelijke en gestroomlijnde API's brengen uw producten moeiteloos op de markt",
        "title": "Toolset voor e-commerce"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Maak gebruik van onze datagestuurde inzichten. De tools van Noda bieden kant-en-klare analyses van klantgedrag, inclusief segmentatie- en voorspellingsalgoritmen.",
            "title": "AI-gestuurde analyse"
          },
          "banking": {
            "content": "Verbeter de ervaring van klanten en versoepel de transactiestroom met de kracht en veiligheid van open banking-betalingen",
            "title": "Open Bankieren"
          },
          "global-currencies": {
            "content": "Noda werkt met verschillende valuta's om uw e-commerce activiteiten over de hele wereld te ondersteunen",
            "title": "Wereldwijde valuta"
          },
          "payment-processing": {
            "content": "Stroomlijn in- en uitbetalingen met Noda. Maak gebruik van intuïtieve UX, slimme routing en een verscheidenheid aan e-commerce betaalmethoden",
            "title": "E-commerce\nVerwerking van betalingen"
          },
          "scalable-plans": {
            "content": "We bieden e-commerce betaalservices voor alle bedrijfsgroottes, met schaalbare plannen om uw bedrijfsgroei te stimuleren",
            "title": "Schaalbare plannen"
          },
          "security": {
            "content": "Noda biedt veilige e-commerce betalingen en zorgt voor PCI DSS-compliance, versleuteling en fraudepreventie.",
            "title": "Beveiliging"
          }
        },
        "subtitle": "Wat wij bieden",
        "title-1": "Topfuncties ",
        "title-2": "voor e-commerce"
      }
    },
    "educational-platforms": {
      "faq": {
        "countries": {
          "content": "We werken samen met 2000+ banken in 28 landen, waaronder Nederland, Portugal, België, Duitsland, Polen, Bulgarije, Frankrijk, Ierland, Italië, Oostenrijk, Spanje, Denemarken, Estland, het Verenigd Koninkrijk, Luxemburg, Roemenië, Litouwen, Hongarije, Letland, Finland, Zweden, Noorwegen, Tsjechië, Slowakije, Griekenland en Slovenië.",
          "title": "In welke landen werkt Noda?"
        },
        "currencies": {
          "content": "Noda ondersteunt verschillende wereldwijde valuta, waaronder EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON en SEK.",
          "title": "Welke valuta ondersteunt Noda?"
        },
        "how-to-integrate": {
          "content": "Eerst moet je aangemeld zijn bij Noda. Vul gewoon het formulier in en ons verkoopteam neemt binnenkort contact met je op. Wij bieden een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Onze processor integreert naadloos met API- en front-endcomponenten, waardoor een naadloze integratie in uw onderwijsplatform gegarandeerd is.",
          "title": "Hoe kan ik Noda integreren in mijn betalingsworkflow?"
        },
        "subtitle": "UW VRAGEN BEANTWOORD",
        "title": "FAQs"
      },
      "hero": {
        "text": "Onderwijs met gemak terwijl wij voor de betalingen zorgen. Ons alles-in-één online betaalsysteem voor educatieve platforms geeft prioriteit aan inzicht in de klant, efficiëntie en groei",
        "title-1": "Betalingsgateway",
        "title-gradient-1": "voor Onderwijs",
        "title-gradient-2": "Platformen"
      },
      "how-does-it-work": {
        "content": "Een betalingsgateway draagt financiële gegevens over tussen leerlingen, handelaars en hun banken. Zie het als een digitale dirigent die elke fase van de betalingsverwerking in de onderwijssector nauwgezet begeleidt.\n\nNoda is een wereldwijd betaalplatform en open banking provider. Van beveiligde gateway tot transactiebeheer en financiële analyses, Noda heeft het voor je geregeld. Ons platform maakt gebruik van AI en machine-learning technologieën om state-of-the-art online betaaloplossingen te bieden voor onderwijsbedrijven.",
        "subtitle": "Technologieën",
        "title": "Hoe werkt de Education Payment Gateway?"
      },
      "how-to-start": {
        "content": "Noda biedt een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons platform integreert naadloos met API- en front-endcomponenten, zodat het naadloos in uw interface kan worden geïntegreerd. Om te beginnen met het gebruik van Noda, vul het onderstaande formulier in en onze vertegenwoordigers zullen binnenkort contact met u opnemen. Ons team is er om u te helpen bij eventuele wegversperringen",
        "subtitle": "Eenvoudige onboarding",
        "title": "Hoe te beginnen"
      },
      "open-banking": {
        "content": "Open banking betekent dat traditionele banken gegevens delen met erkende fintech-bedrijven, zoals Noda, om transacties te stroomlijnen. Ons betalingsecosysteem verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, waardoor betalingen moeiteloos verlopen",
        "subtitle": "VEEL MOGELIJKHEDEN",
        "title": "Wat is Open Banking?"
      },
      "payments": {
        "text": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Onze gebruiksvriendelijke en gestroomlijnde API's brengen uw producten moeiteloos op de markt",
        "title": "Toolset voor educatieve platforms"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Maak gebruik van onze datagestuurde inzichten. De tools van Noda bieden kant-en-klare analyses van klantgedrag, inclusief segmentatie- en voorspellingsalgoritmen",
            "title": "AI-gestuurde analyse"
          },
          "banking": {
            "content": "De ervaring van klanten verbeteren en de transactiestroom vereenvoudigen met de kracht en veiligheid van open banking-betalingen",
            "title": "Open Bankieren"
          },
          "global-currencies": {
            "content": "Noda werkt met een breed scala aan valuta's om uw klanten over de hele wereld te ondersteunen",
            "title": "Wereldwijde valuta's"
          },
          "payment-processing": {
            "content": "Stroomlijn in- en uitbetalingen, maak gebruik van intuïtieve UX, slimme routing en bied een verscheidenheid aan populaire betaalmethoden aan",
            "title": "Betalingsverwerking voor educatieve platforms"
          },
          "scalable-plans": {
            "content": "We bieden betaaloplossingen voor alle bedrijfsgroottes, met schaalbare plannen om de groei van je educatieve platform te stimuleren",
            "title": "Schaalbare plannen"
          },
          "security": {
            "content": "Noda biedt veilige betalingsmogelijkheden en zorgt voor PCI DSS-compliance, versleuteling en fraudepreventie",
            "title": "Beveiliging"
          }
        },
        "subtitle": "WAT WIJ BIEDEN",
        "title-1": "Topfuncties",
        "title-2": "voor educatieve platforms"
      }
    },
    "financial": {
      "application-list": {
        "financial1": {
          "text": "Entertainment"
        },
        "financial2": {
          "text": "Detailhandel"
        },
        "financial3": {
          "text": "Start-ups"
        },
        "financial4": {
          "text": "Marktplaatsen"
        },
        "financial5": {
          "text": "Dating"
        },
        "financial6": {
          "text": "E-commerce"
        },
        "financial7": {
          "text": "Gaming"
        },
        "financial8": {
          "text": "Tourisme"
        }
      },
      "application": {
        "subtitle": "Data toepassing",
        "text": "Noda's Data Enrichment kan de betalingsverwerking stroomlijnen voor heel veel verschillende bedrijven, van traditionele e-commerce tot complexe abonnements- en 'top-up'-bedrijfsmodellen",
        "title": "Aanpasbaar voor uiteenlopende industrieën"
      },
      "buttons": {
        "DE-row": {
          "berlin": "Berlijn",
          "mobile": "Mobiel"
        },
        "NL-row": {
          "amsterdam": "Amsterdam",
          "desktop": "Desktop"
        },
        "UK-row": {
          "desktop": "Desktop",
          "london": "London"
        }
      },
      "container-header-text": "Onze tools bieden uitgebreid inzicht in de behoeften van uw klanten die u kunt gebruiken om uw bedrijf naar een hoger niveau te tillen",
      "customer-segmentation": {
        "list": {
          "enhanced-engagement": "Hogere klantbetrokkenheid",
          "marketing-insights": "Geavanceerde marketinginzichten",
          "ready-for-use": "Direct klaar voor gebruik"
        },
        "subtitle": "Data clusters",
        "text": "Personaliseer de ervaring van uw klanten met onze functie voor klantsegmentatie die gebruikers in verschillende groepen of clusters categoriseert om zeer gerichte, waardevolle aanbevelingen te genereren",
        "title": "Klantsegmentatie"
      },
      "data-usage": {
        "info": {
          "monthly-value": "Maandelijkse waarde",
          "predicted-lifetime": {
            "label": "Voorspelde levensduurwaarde",
            "value": "2 maanden"
          },
          "predicted-spendings": "Voorspelde uitgaven"
        },
        "subtitle": "Gegevensgebruik",
        "text": "Noda's Data Enrichment maakt gebruik van geavanceerde analyses om de bestedingspatronen van uw klanten te voorspellen op basis van hun financiële gedrag en bepaalde omgevingsfactoren. Onze tools bieden uitgebreid inzicht in de behoeften van uw klanten die u kunt gebruiken om uw bedrijf naar een hoger niveau te tillen",
        "title": "Voorspellende algoritmen"
      },
      "diff-user": "Andere gebruiker",
      "financial-hero-title-1": "Gegevensverrijking:",
      "financial-hero-title-2": "Ontgrendel Open Banking",
      "financial-hero-title-3": "Gebruikersinzichten met",
      "financial-info": "2 maanden",
      "header-title": "Versterk uw groei met extra data",
      "hero": "Krijg waardevol inzicht in uw gebruikers direct nadat de eerste transactie is voltooid. Op het moment dat we toestemming krijgen van een gebruiker om zijn/haar/hun transacties in te zien, kunnen we bruikbare signalen vergaren.",
      "how-data": {
        "enrich-data": {
          "text": "Zodra de gebruiker ons toestemming geeft, sturen wij de verrijkte data naar u door.",
          "title": "Verrijkte data"
        },
        "instant-consent": {
          "text": "Tijdens het betalen of inloggen staan gebruikers toe dat Noda de transactiegegevens leest.",
          "title": "Directe toestemming"
        },
        "payment-or-sign-in": {
          "text": "Start met betalen of inloggen via Noda op uw website.",
          "title": "Betalen of inloggen"
        }
      },
      "info-data": {
        "subtitle": "Wat gebruikers zien",
        "text": "Wij bieden u gemoedsrust dankzij het veilige gegevensbeheer van de Financial AI Toolset en de strikte naleving van gereguleerde bankstandaarden.",
        "title": "Hoe het werkt"
      },
      "key-features-title": "Belangrijkste kenmerken",
      "payments-data": {
        "text": "Voorspellende financiële inzichten voor verkopers",
        "title": "Ontgrendel gebruikersinzichten met Noda"
      },
      "preferences-items": {
        "hood1": {
          "text": "Plaats de gebruiker centraal met de kennis van Open Banking.",
          "title": "Bouw gepersonaliseerde oplossingen"
        },
        "hood2": {
          "text": "Ontvang een signaal wanneer gebruikers met een hoge marge onboarden.",
          "title": "Verhoog betrokkenheid"
        },
        "hood3": {
          "text": "Nooit meer te hoge uitgaven met kaartbetalingen.",
          "title": "Voer met veel vertrouwen een betere remarketing uit"
        },
        "hood4": {
          "text": "Richt u alleen op gebruikers met een hoge LTV (lifetime value).",
          "title": "Verbeter uw acquisitiestrategie"
        }
      }
    },
    "gaming": {
      "case-study": {
        "subtitle": "Casestudy",
        "text": "In februari 2023 ging Wargaming, een bekroonde uitgever van online games, samenwerken met Noda om directe open bankbetalingen in games te introduceren. Door deze samenwerking kregen de spelers van Wargaming toegang tot diverse online betaalopties, waaronder account-to-account (A2A)-transacties.",
        "title": "Wargaming <br/>& Noda"
      },
      "faq": {
        "countries": {
          "content": "We werken samen met 2000+ banken in 28 landen, waaronder Nederland, Portugal, België, Duitsland, Polen, Bulgarije, Frankrijk, Ierland, Italië, Oostenrijk, Spanje, Denemarken, Estland, het Verenigd Koninkrijk, Luxemburg, Roemenië, Litouwen, Hongarije, Letland, Finland, Zweden, Noorwegen, Tsjechië, Slowakije, Griekenland en Slovenië.",
          "title": "In welke landen werkt Noda?"
        },
        "currencies": {
          "content": "Noda ondersteunt verschillende wereldwijde valuta, waaronder EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON en SEK.",
          "title": "Welke valuta ondersteunt Noda?"
        },
        "integration": {
          "content": "Eerst moet je aangemeld zijn bij Noda. Vul gewoon het formulier in en ons verkoopteam neemt binnenkort contact met je op. Wij bieden een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Onze processor integreert naadloos met API- en front-endcomponenten, waardoor een naadloze integratie in uw platform gegarandeerd is.",
          "title": "Hoe kan ik Noda integreren in mijn betalingsworkflow?"
        },
        "subtitle": "Uw vragen beantwoord",
        "title": "FAQs"
      },
      "hero": {
        "text": "Til uw gamingbedrijf naar een hoger niveau met Noda's betalingen. Ons alles-in-één platform geeft prioriteit aan klantbegrip, efficiëntie en groei",
        "title-1": "Betalings&shy;gateway",
        "title-2": "voor online gamen met Noda"
      },
      "how-does-it-work": {
        "subtitle": "Technologieën",
        "text": "Een betalingsgateway voor games fungeert als tussenpersoon die gegevens veilig doorstuurt tussen de gamer, verkoper en banken. Denk aan een digitale dirigent die nauwgezet elke stap van de creditcardverwerking bij online gaming begeleidt\n\nNoda is een wereldwijd betaalplatform en open banking provider. Van veilige gateway tot transactiebeheer en financiële analyses, Noda heeft alles voor je in huis. Ons platform maakt gebruik van AI en machine-learning technologieën om state-of-the-art oplossingen te bieden",
        "title": "Hoe werkt een betalings&shy;gateway voor gaming?"
      },
      "how-to-start": {
        "subtitle": "Eenvoudige onboarding",
        "text": "Noda biedt een gemakkelijke onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons team staat klaar om te helpen bij eventuele obstakels. Onze processor integreert naadloos met API- en front-endcomponenten, waardoor een naadloze integratie in uw platform gegarandeerd is. Om te beginnen met het gebruik van Noda, vul gewoon het onderstaande formulier in en onze vertegenwoordigers zullen binnenkort contact met u opnemen",
        "title": "Hoe te beginnen"
      },
      "open-banking": {
        "subtitle": "Veel mogelijkheden",
        "text": "Open banking betekent dat traditionele banken gegevens delen met erkende fintech-bedrijven, zoals Noda, om transacties te stroomlijnen. Ons betalingsecosysteem verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, waardoor betalingen moeiteloos verlopen",
        "title": "Wat is Open Banking?"
      },
      "payments": {
        "text": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Onze gebruiksvriendelijke en gestroomlijnde API's brengen uw producten moeiteloos op de markt",
        "title": "Gereedschapsset voor online gamen"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Maak gebruik van onze datagestuurde inzichten. De tools van Noda bieden kant-en-klare analyses van klantgedrag, inclusief segmentatie- en voorspellingsalgoritmen",
            "title": "AI-gestuurde analyse"
          },
          "banking": {
            "content": "Verbeter de ervaring van klanten en versoepel de transactiestroom met de kracht en veiligheid van open banking-betalingen",
            "title": "Open Bankieren"
          },
          "global-currencies": {
            "content": "Noda werkt met een breed scala aan valuta's om uw online gamingklanten over de hele wereld te ondersteunen",
            "title": "Wereldwijde valuta's"
          },
          "payment-processing": {
            "content": "Stroomlijn in- en uitbetalingen, maak gebruik van intuïtieve UX, slimme routing en bied een verscheidenheid aan populaire betaalmethoden aan",
            "title": "Online gaming betalingsverwerking"
          },
          "scalable-plans": {
            "content": "We bieden betaaloplossingen voor gaming voor alle bedrijfsgroottes, met schaalbare plannen om de groei van je bedrijf te stimuleren",
            "title": "Schaalbare plannen"
          },
          "security": {
            "content": "Noda biedt een veilige manier om online games te betalen, met PCI DSS-compliance, versleuteling en fraudepreventie",
            "title": "Beveiliging"
          }
        },
        "subtitle": "Wat wij bieden",
        "title-1": "Topfuncties",
        "title-2": "voor online gamen"
      }
    },
    "instant-payment-links": {
      "cx": {
        "subtitle": "ervaring is de sleutel",
        "text": "Ontmoet kopers op een beveiligde betalingspagina.<br/>Sta hen toe de aankoop te voltooien met hun favoriete bankapp.",
        "title": "Directe klantbeleving"
      },
      "funds": {
        "receive-money": "Ontvang geld in real time rechtstreeks op uw bankrekening.",
        "settle-payments": "Of regel betalingen met Noda vIBAN.",
        "subtitle": "kies uw flow",
        "title": "Geld is direct beschikbaar"
      },
      "hero": {
        "text": "Veilig flexibel betaallinks zonder de poespas van integraties",
        "title": "Betaallink"
      },
      "info": {
        "checkout-anchor": "verschillende media",
        "checkout-text-end": ", online of persoonlijk",
        "checkout-text-start": "Laat uw klanten afrekenen via ",
        "create-anchor": "wanneer u wilt",
        "create-text": "Betaallinks maken, genereer QR-codes ",
        "fees-anchor": "ontvang geld in real time",
        "fees-text": "Verlaag transactiekosten en ",
        "title": "Generator payment link om het u gemakkelijker te maken"
      },
      "key-features": {
        "commerce": "Omnichannel-handel zonder integraties",
        "coverage": "Brede geografische dekking",
        "customer": "Optimale klantbeleving",
        "fees": "Lage transactiekosten",
        "no-code": "Geen code, geen technische ervaring vereist",
        "security": "Beveiliging op bankniveau",
        "subtitle": "het voordeel van betaalverzoeken",
        "time": "5 min Time-to-Market voor gebruikers van Noda",
        "title": "Belangrijkste functies",
        "transparency": "Transparantie, eenvoudig beheer"
      },
      "product-block": {
        "text": "Directe installatie. Direct delen. Directe betalingservaring. De wereld is jouw speeltuin. De naam van het spel is \"gewoon betaald krijgen\".",
        "title": "Directe Betalingslinks"
      },
      "setup": {
        "subtitle": "hoe het werkt",
        "text": "Het maken van een betaalverzoek is een fluitje van een cent: voer de prijs en valuta in, voeg betalingsgegevens toe en druk op Genereren. En klaar!",
        "title": "Direct installeren"
      },
      "sharing": {
        "description": "Toon uw klanten de QR-code waarmee ze kunnen betalen via gedrukte media, buitenreclame, computer- en tv-schermen.",
        "header": {
          "subtitle": "maak uw doelgroep enthousiast",
          "text": "Stuur het betaalverzoek naar uw klanten.<br/>Gebruik elk platform waar u met uw doelgroep communiceert: websites, e-mails, chatbots, sociale netwerken, messengers, enz.",
          "title": "Direct delen"
        }
      },
      "use-cases": {
        "automotive": {
          "item-1": "Volledige en gesplitste betalingen",
          "item-2": "Stortingen en termijnen",
          "item-3": "Internationale betalingen, betalingen in meerdere valuta's",
          "item-4": "Nazorgdiensten",
          "title": "Auto-industrie"
        },
        "e-commerce": {
          "item-1": "Omnichannel-handel",
          "item-2": "Internationale betalingen, betalingen in meerdere valuta's",
          "item-3": "Opties voor later betalen",
          "item-4": "Sociale handel",
          "title": "Online winkelen"
        },
        "header": {
          "subtitle": "de verbanden leggen",
          "text": "Van online tot persoonlijk, van dure aankopen tot microbetalingen, internationaal of aan de deur. Met één klik ervaar je een moeiteloze betaalervaring.",
          "title": "Gebruiksscenario's en sectoren"
        },
        "retail": {
          "item-1": "Stortingen en termijnen",
          "item-2": "Een-klik-betalingen voor terugkerende klanten",
          "item-3": "Omnichannel-handel",
          "item-4": "Internationale betalingen, betalingen in meerdere valuta's",
          "title": "Detailhandel met hoge prijzen"
        },
        "sales": {
          "item-1": "Volledige en gesplitste betalingen",
          "item-2": "Sociale handel",
          "item-3": "Snelstartcampagnes",
          "item-4": "Opties voor later betalen",
          "title": "Verkoop op locatie"
        },
        "services": {
          "item-1": "Stortingen & termijnen",
          "item-2": "Nazorgdiensten",
          "item-3": "Leningen, microkrediet",
          "item-4": "Snelstartcampagnes",
          "title": "Diensten"
        },
        "travel": {
          "item-1": "Stortingen en termijnen",
          "item-2": "Internationale betalingen, betalingen in meerdere valuta's",
          "item-3": "Een-klik-betalingen voor terugkerende klanten",
          "item-4": "Opties voor later betalen",
          "title": "Reizen & Hospitality"
        }
      }
    },
    "letters-plugin": {
      "buttonTitle": "Bekijk alles",
      "title": "Meer informatie over betalingsplug-ins"
    },
    "main-v2": {
      "boost-your-business": {
        "connected-banks": "aangesloten banken met ruim 30.000 filialen",
        "countries-covered": "gedekte landen",
        "description": "Het krachtige ecosysteem voor online betalingen van Noda verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, zodat transacties onderling moeiteloos kunnen worden uitgevoerd",
        "integrated-networks": "geïntegreerde netwerken",
        "subtitle": "Ontdek de kracht van open banking",
        "subtitleV2": "Ontdek de kracht\n van open banking",
        "title": "Geef je business een boost met Noda"
      },
      "hero": {
        "online-payments": {
          "part-1": "Online betalingen ",
          "part-2": "met Noda. ",
          "part-3": "Jouw betalingen zijn voor ons topprioriteit"
        },
        "text": "Til je onderneming naar een hoger niveau met ons uitgebreide online betalingsplatform. Verhoog je omzet en bespaar kostbare tijd dankzij onze gestroomlijnde processen. Onze alles-in-één-oplossing is gericht op inzicht in je klanten, een efficiënte bedrijfsvoering en groei."
      },
      "reviews": {
        "title": "Dit zeggen onze klanten"
      },
      "what-is-noda": {
        "card-payments": {
          "button": "Ontdek kaartbetalingen",
          "description": "Noda richt zich met volledige overgave op het stroomlijnen van terugkerende betalingen, zodat deze soepel kunnen worden verwerkt",
          "subtitle": "Kaartbetalingen",
          "title": "Sneller betalen dankzij betalingen met één klik"
        },
        "checkout": {
          "button": "Explore Checkout",
          "description": "Profiteer optimaal van naadloze betalingen met de gebruiksvriendelijke interface van het betaalproces van Noda en de uitgebreide reeks betaalfuncties",
          "subtitle": "Afrekenen",
          "title": "Eén Afrekenpunt Voor je Betalingen"
        },
        "delight-customers": {
          "description": "Profiteer van lage of geen transactiekosten met een overvloed aan opties via onze online betalingsservice",
          "title": "Maak klanten blij"
        },
        "easy-to-apply": {
          "description": "Flexibele oplossing om geld te innen met de keuze voor onze Noda C2B-rekening of één van onze vertrouwde bankpartners",
          "title": "Eenvoudig te installeren"
        },
        "open-banking": {
          "button": "Meer Over Open Banking",
          "description": "Profiteer van de mogelijkheden van open banking en API's om de ervaring van je klanten en je online betalingsverwerking te verbeteren met de veilige en efficiënte oplossing van Noda",
          "subtitle": "Open-banking",
          "title": "Vereenvoudig je betalingsproces met Noda"
        },
        "text": "Onze complete oplossing voor online betalingen stroomlijnt transacties voor zowel bedrijven als particulieren, of je nu geld int van klanten of geld stuurt naar vrienden en familie.",
        "title": "Wat is "
      }
    },
    "marketplace": {
      "cart": {
        "cta": "Start",
        "in-your-package": "In je pakket",
        "products": "Producten",
        "recommended": "Je hebt mogelijk ook interesse"
      },
      "errors": {
        "email-pattern": "De indeling van de e-mail is onjuist",
        "oninvalid": "De waarde is ongeldig",
        "required": "De waarde is vereist"
      },
      "filters": {
        "all": "Alle producten",
        "categories": "Categorieën",
        "header": "Filters"
      },
      "header": "Onze producten",
      "hero": {
        "description": "Kies de beste betaalmethoden voor uw bedrijf. Noda's marktplaats voor betalingsdiensten biedt betalingsverwerking, facturering, data verrijkingsdiensten en meer -- klaar om te combineren en aan te passen.",
        "description-2": "Ben je klaar voor een frisse kijk op betalingen? Begin vandaag met het opbouwen van je betalingsstuk.",
        "title": "Betalingsmiddelen tussen banken en over grenzen"
      },
      "product": {
        "add-to-package": "Toevoegen",
        "in-package": "Toegevoegd",
        "read-more": "Lees meer",
        "remove": "Verwijderen"
      },
      "request-a-product": {
        "cta": "Een verzoek indienen",
        "description": "Kun je niet vinden wat je zoekt? Misschien kunnen we helpen.",
        "form": {
          "back": "Ga terug naar de markt",
          "labels": {
            "description": "Beschrijf je idee",
            "email": "Je zakelijke e-mailadres",
            "organization": "Je organisatie"
          },
          "recommended": "Je hebt mogelijk ook interesse",
          "success": {
            "description": "We zullen uw aanvraag zo snel mogelijk verwerken. Fijne dag!",
            "header": "Bedankt voor uw aanvraag"
          }
        },
        "header": "Vraag een product aan"
      }
    },
    "marketplaces": {
      "faq": {
        "countries": {
          "content": "We werken samen met 2000+ banken in 28 landen, waaronder Nederland, Portugal, België, Duitsland, Polen, Bulgarije, Frankrijk, Ierland, Italië, Oostenrijk, Spanje, Denemarken, Estland, het Verenigd Koninkrijk, Luxemburg, Roemenië, Litouwen, Hongarije, Letland, Finland, Zweden, Noorwegen, Tsjechië, Slowakije, Griekenland en Slovenië.",
          "title": "In welke landen werkt Noda?"
        },
        "currencies": {
          "content": "Noda is een betalingsverwerker voor de wereldwijde markt die verschillende valuta's ondersteunt, waaronder EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON en SEK.",
          "title": "Welke valuta ondersteunt Noda?"
        },
        "how-to-integrate": {
          "content": "Eerst moet je aangemeld zijn bij Noda. Vul gewoon het formulier in en ons verkoopteam neemt binnenkort contact met je op. Wij bieden een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons betalingssysteem voor de marktplaats integreert met API's en front-end componenten, zodat het naadloos in uw platform past.",
          "title": "Hoe kan ik Noda integreren in mijn betalingsworkflow?"
        },
        "subtitle": "UW VRAGEN BEANTWOORD",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verhoog je marktplaats met Noda's betalingsgateway. Concentreer je op aanbiedingen terwijl wij zorgen voor veilige en naadloze transacties. Ons alles-in-één platform geeft prioriteit aan inzicht in de klant, efficiëntie en groei",
        "title-1": "Betalingsgateway",
        "title-gradient-1": "voor marktplaatsen met Noda"
      },
      "how-does-it-work": {
        "content": "Een betaalgateway verzendt veilig financiële gegevens tussen klanten, winkeliers en banken. Zie het als een digitale dirigent die elke fase van de betalingsverwerking begeleidt\n\nNoda is een wereldwijd betaalplatform en open banking provider. Van veilige online marktplaatsbetalingen tot financiële analyses, bij Noda bent u aan het juiste adres. Ons platform maakt gebruik van AI en machine-learning technologieën om state-of-the-art oplossingen te bieden",
        "subtitle": "Technologieën",
        "title": "Hoe werkt Marketplace Payment Gateway?"
      },
      "how-to-start": {
        "content": "Noda biedt een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons betaalplatform voor de marktplaats integreert naadloos met API's en front-end componenten, zodat het naadloos in uw interface kan worden geïntegreerd. Om te beginnen met het gebruik van Noda, vul het onderstaande formulier in en onze vertegenwoordigers zullen binnenkort contact met u opnemen. Ons team is er om u te helpen bij eventuele wegversperringen",
        "subtitle": "Eenvoudige onboarding",
        "title": "Hoe te beginnen"
      },
      "open-banking": {
        "content": "Open banking betekent dat traditionele banken gegevens delen met gelicentieerde fintech bedrijven, zoals Noda, om transacties te stroomlijnen. Ons betalingsecosysteem verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, zodat marktplaatsen moeiteloos betalingen kunnen uitvoeren",
        "subtitle": "VEEL MOGELIJKHEDEN",
        "title": "Wat is Open Banking?"
      },
      "payments": {
        "text": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Onze gebruiksvriendelijke en gestroomlijnde API's brengen uw producten moeiteloos op de markt",
        "title": "Toolset voor marktplaatsen"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Maak gebruik van onze datagedreven inzichten. De tools van Noda bieden kant-en-klare analyses van klantgedrag, inclusief segmentatie- en prognosealgoritmen",
            "subtitle": "MODERNE TECHNOLOGIEËN",
            "title": "AI-gestuurde analyse"
          },
          "banking": {
            "content": "Verbeter de gebruikerservaring (UX) en vereenvoudig de transactiestroom met de kracht en veiligheid van open banking betalingen",
            "title": "Open Bankieren"
          },
          "global-currencies": {
            "content": "Noda werkt met meerdere valuta's om uw marktplaatsklanten over de hele wereld te ondersteunen",
            "title": "Wereldwijde valuta"
          },
          "payment-processing": {
            "content": "Stroomlijn betalingen en uitbetalingen, maak gebruik van intuïtieve UX, slimme routering en bied een verscheidenheid aan populaire marktplaatsbetalingsopties",
            "subtitle": "ALLES VOOR UW BEDRIJF",
            "title": "Marktplaats betalings&shy;verwerking"
          },
          "scalable-plans": {
            "content": "We bieden betaaloplossingen voor marktplaatsen van elke grootte, met schaalbare plannen om je groei te ondersteunen",
            "title": "Schaalbare plannen"
          },
          "security": {
            "content": "Noda is een veilige marktplaats voor betalingsdiensten, die PCI DSS-naleving, encryptie en fraudepreventie garandeert",
            "title": "Beveiliging"
          }
        },
        "subtitle": "ONZE AANBIEDINGEN",
        "title-1": "Topfuncties"
      }
    },
    "meta": {
      "about": {
        "aml-cft-policies": {
          "description": "Bekijk onze beleidsverklaring, regelgeving, methodologieën en nog veel meer.",
          "title": "Noda's AML/CFT-beleid"
        },
        "company": {
          "description": "Ontdek het verhaal van Noda en ontdek hoe wij uw zakelijke betalingen kunnen verbeteren. Maak kennis met ons team en onze producten.",
          "title": "Bedrijf | Noda"
        },
        "mission": {
          "description": "Leer meer over de missie en visie van Noda, inclusief de drie walvissen van onze cultuur en het verhaal van wie we zijn.",
          "title": "Missie en visie van Noda"
        },
        "partnership": {
          "description": "Verken onze verschillende samenwerkingsmogelijkheden, waaronder white-label, reseller, franchise en agentschappen. Integreer onze open banking-technologie.",
          "title": "Noda: Word Noda's partner in bedrijfsgroei"
        },
        "risk-appetite-policy": {
          "description": "Ontdek ons risicobeleid met betrekking tot sectoren, activiteiten en rechtsgebieden die verboden of beperkt zijn, of waarvoor specifiek gedrag vereist is.",
          "title": "Noda's risicobeleid"
        },
        "security": {
          "description": "De beveiliging van betalingen en gegevens moet altijd een prioriteit zijn. We geven een overzicht van onze beveiligingsfuncties en onze toewijding aan gegevensbescherming.",
          "title": "Beveiliging en gegevensverwerking | Noda"
        },
        "ux-approach": {
          "description": "Ontdek onze CX-filosofie en designmanifest. Leer meer over onze ontwerpprincipes en wat ons team drijft om uitstekend werk te leveren.",
          "title": "Noda's Aanpak van Klantbeleving (CX)"
        },
        "white-label": {
          "description": "Word white-label partner van Noda en integreer open banking. Maak gebruik van naadloze betalingen, bruikbare analyses en aanpasbare branding.",
          "title": "Noda: Laat uw bedrijf groeien als White-Label Partner"
        },
        "why-open-banking": {
          "description": "Ontdek waarom open bankieren betalingen verandert. Leer hoe het zowel handelaars als consumenten ten goede komt en ontkracht veelvoorkomende mythes.",
          "title": "Waarom Open Banking de toekomst van betalingen is"
        }
      },
      "articles": {
        "description": "Ontdek alles wat je moet weten over open banking en online betaaloplossingen. Leer meer over digitale betalingen met Noda's fintech artikelen.",
        "title": "Artikelen | Fintech, Open Bankieren, Digitale Betalingen | Noda"
      },
      "bank-payouts": {
        "description": "Vereenvoudig massabetalingen met de geavanceerde uitbetalingsoplossingen van Noda. Geniet van snelle, probleemloze transacties en kostenefficiëntie. Lees verder voor meer informatie.",
        "title": "Gestroomlijnde bankuitbetalingen voor snelle, kostenefficiënte transacties | Noda"
      },
      "bank-sign": {
        "description": "Verbeter uw klantervaring met Noda's sign-in met behulp van een bankrekening. Zorg voor optimale beveiliging, werf meer klanten en krijg toegang tot betrouwbare gegevens.",
        "title": "Naadloos aanmelden via bank, veilige betalingen en gegevensnaleving | Noda"
      },
      "card-payments": {
        "description": "Ervaar naadloze betalingen met de AI-technologie van Noda. Geoptimaliseerde routing, geaccepteerde kaartbetalingen en eenvoudige integratie - op maat gemaakt voor de groei van uw bedrijf. Meer informatie.",
        "title": "Online kaartbetalingen verbeteren voor zakelijk succes | Noda"
      },
      "card-payouts": {
        "description": "Boost de groei van uw bedrijf met de efficiënte wereldwijde uitbetalingsoplossingen voor kaarten van Noda. Naadloze API-integratie, veilige transacties en op maat gemaakt voor uw behoeften.",
        "title": "Switch, veilige en efficiënte betaaloplossingen | Noda"
      },
      "checkout": {
        "description": "Verbeter het betalingsproces met de geavanceerde, AI-gestuurde technologie van Noda. Optimaliseer je checkout, beveilig transacties en breid wereldwijd uit.",
        "title": "Naadloze en veilige oplossingen voor afrekenen | Noda"
      },
      "contact-form": {
        "description": "Ontdek ons geïntegreerde betaalplatform. Blader door Noda's dienstenmarktplaats om jouw perfecte betalingstechnologie te bouwen. Open bankieren, kaarten, gegevensverrijking, no-code.",
        "title": "Noda-formulier"
      },
      "contact-us": {
        "description": "Verhoog uw bedrijf met de kracht van open banking. Praat vandaag nog met ons om betalingen te stroomlijnen met ons alles-in-één platform.",
        "title": "Contacteer Ons | Noda"
      },
      "demo": {
        "description": "Ontdek de oplossingen van Noda. Bekijk hoe Noda producten betalingen vereenvoudigen en uw omzetgroei versnellen.",
        "title": "Noda Demo"
      },
      "events": {
        "description": "Ontdek evenementen en conferenties bij Noda. Reserveer nu uw plek om in contact te komen met leiders in de betalingssector, inzichten te verwerven en deel te nemen aan professionele groeimogelijkheden!",
        "title": "Evenementen: Netwerken, leren en groeien met Noda"
      },
      "financial-ai-toolset": {
        "description": "Ontdek de Financial AI Toolset, een oplossing die bedrijven inzicht geeft in AI-gestuurde financiële analyses voor beslissingen op basis van gegevens.",
        "title": "Financiële AI-toolset: Laat uw bedrijf groeien met gegevensgestuurde analyses | Noda"
      },
      "glossary": {
        "description": "Ontdek Noda's ultieme woordenlijst voor fintech en open banking terminologie van A tot Z.",
        "title": "Woordenlijst Open Bankieren | Noda"
      },
      "instant-payment-links": {
        "description": "Maak betaallinks in seconden voor naadloze transacties. Stuur een betaallink naar een klant en ontvang direct betalingen via hun de favoriete bank.",
        "title": "Betaallink – Betalingen gemakkelijk gemaakt  | Noda"
      },
      "legal": {
        "cookies": {
          "description": "Noda Cookies Policy legt uit hoe we cookies gebruiken voor functionaliteit, analyses en marketing. Ontdek hoe u uw voorkeuren kunt beheren.",
          "title": "Cookiebeleid"
        },
        "policy": {
          "description": "Ontdek hoe Noda uw persoonlijke gegevens verzamelt, gebruikt en beschermt onder de AVG en andere regelgeving. Uw privacy is onze prioriteit.",
          "title": "Privacybeleid"
        },
        "privacy-notice-for-job-candidates-or-cooperation": {
          "description": "Dit bericht legt uit hoe Noda omgaat met de persoonsgegevens van potentiële werknemers, stagiaires die hebben gesolliciteerd of zijn uitgenodigd om te solliciteren naar openstaande functies bij Noda of om samen te werken met Noda als individuele contractanten.",
          "title": "Privacyverklaring voor sollicitanten of samenwerking | Noda"
        },
        "terms": {
          "description": "Deze overeenkomst schetst de gebruiksvoorwaarden voor particulieren die betalingen via Noda initiëren. Kom meer te weten over uw rechten en datagebruik.",
          "title": "Gebruiksvoorwaarden"
        }
      },
      "main": {
        "description": "Maak gebruik van de kracht van API's met Noda's online betalingsplatform. Vereenvoudig transacties en optimaliseer moeiteloos uw bedrijfsprocessen.",
        "title": "Online Betalingen met Noda | Veilige & Efficiënte Betalingsplatform"
      },
      "marketplace": {
        "description": "Ontdek ons geïntegreerde betaalplatform. Blader door Noda's dienstenmarktplaats om jouw perfecte betalingstechnologie te bouwen. Open bankieren, kaarten, gegevensverrijking, no-code.",
        "title": "Marktplaats voor betalingsdiensten | Noda"
      },
      "mor": {
        "description": "Ontgrendel grenzeloze handel voor uw digitale innovaties. Van indiegames tot bedrijfssoftware.",
        "title": "Merchant of Record"
      },
      "newsroom": {
        "description": "Bekijk het laatste nieuws over Noda. Lees de nieuwste artikelen, persberichten en deskundige inzichten die Noda's open banking-betalingsservices laten zien.",
        "title": "We zijn in het nieuws | Noda"
      },
      "no-code": {
        "description": "Geef online verkopen een boost met AI-gestuurde betaalpagina's zonder code. Ontdek hoe Noda uw volledige transactieflow kan ondersteunen - van een merchant account tot de dagelijkse verwerking van betalingen.",
        "title": "Maak aangepaste AI-aangedreven betaalpagina's in enkele minuten | Noda"
      },
      "open-banking": {
        "description": "Transformeer uw bedrijf met open banking betalingen van Noda. Verbeter de klantervaring en zorg voor veilige transacties. Probeer nu een demo.",
        "title": "Open Bank Platform voor veilige en naadloze transacties | Noda"
      },
      "plugins": {
        "description": "Til uw bedrijf naar een hoger niveau met de open banking-plug-ins van Noda voor het e-commerceplatform dat u gebruikt. Stroomlijn betalingen met de vereenvoudigde gebruikerservaring, naadloze integratie, veiligheid en efficiëntie van open banking.",
        "magento": {
          "description": "Ontdek de Magento plugin van Noda. Leer hoe je Noda kunt integreren als Magento betaaloptie op je e-commerce website.",
          "title": "Magento betalingsgateway met Noda"
        },
        "opencart": {
          "description": "Ontdek de OpenCart plugin van Noda. Leer hoe je Noda kunt integreren als een OpenCart betaaloptie op jouw e-commerce website.",
          "title": "OpenCart betalingsgateway met Noda"
        },
        "prestashop": {
          "description": "Ontdek Noda's PrestaShop plugin. Leer hoe je Noda kunt integreren als PrestaShop betaaloptie op jouw e-commerce website.",
          "title": "PrestaShop betalingsgateway met Noda"
        },
        "title": "Vergroot uw omzet met de open banking-plug-ins van Noda",
        "woocommerce": {
          "description": "Ontdek de WordPress plugin van Noda. Leer hoe je Noda kunt integreren als een WooCommerce betaalmethode voor jouw e-commerce bedrijf.",
          "title": "WooCommerce betalingsgateway met Noda"
        }
      },
      "pricing": {
        "description": "Noda biedt concurrerende en voorspelbare prijzen voor uw bedrijf. Verbeter uw betalingsecosysteem met onze uitgebreide open-banking oplossing.",
        "title": "Prijzen | Noda"
      },
      "toc": {
        "title": "VOORWAARDEN VOOR SAMENWERKING"
      },
      "use-cases": {
        "ecommerce": {
          "description": "Ontdek Noda's betaalgateway voor e-commerce en stroomlijn online transacties. Begin nu met het gebruik van Noda.",
          "title": "Oplossingen voor e-commerce betalingen: Verbeter uw bedrijf met Noda"
        },
        "educational-platforms": {
          "description": "Ontdek de online betalingssystemen van Noda voor het onderwijs om transacties te stroomlijnen en open bankieren te benutten. Meer informatie...",
          "title": "Betaalgateway voor educatieve platforms | Noda"
        },
        "marketplaces": {
          "description": "Ontdek de online betaaloplossingen voor de marktplaats van Noda om transacties te stroomlijnen en open bankieren te stimuleren. Meer informatie...",
          "title": "Betaalgateway voor marktplaatsen | Noda"
        },
        "online-gaming": {
          "description": "Ontdek de betaaloplossingen voor kansspelen van Noda om transacties te stroomlijnen en open bankbetalingen te benutten. Meer informatie...",
          "title": "Betalingsgateway voor online gokken | Noda"
        },
        "retail": {
          "description": "Ontdek Noda's betaalgateway voor particulieren om transacties te stroomlijnen en open bankbetalingen te benutten. Meer informatie...",
          "title": "Betalingsgateway voor detailhandel | Noda"
        },
        "saas": {
          "description": "Ontdek de SaaS-betaalgateway van Noda om transacties te stroomlijnen en gebruik te maken van open banking-betalingen. Meer informatie...",
          "title": "Betalingsgateway voor SaaS | Noda"
        },
        "travel": {
          "description": "Ontdek de betaaloplossingen van Noda voor reisondernemingen en online betalingen via streamlone. Meer informatie...",
          "title": "Betaaloplossingen voor reizen: Verbeter uw bedrijf met Noda"
        }
      }
    },
    "mission": {
      "hero": {
        "desc-1": "Onze <b>missie</b> is het leveren van de definitieve toolkit voor financieel beheer die het internet van de 21e eeuw verdient.",
        "desc-2": "We willen de overblijfselen van de oude systemen uit de vorige eeuw elimineren, zoals vertragingen, gegevensverstoringen door eindeloze tussenpersonen, handmatige verwerking, menselijke fouten en de inherente vooroordelen van een kliekjesachtig financieel systeem.",
        "extended-text": "We willen de transformatie van het financiële systeem stimuleren door middel van open bankieren.\nOnze <b>visie</b> is dat betalingen onmiddellijk kunnen worden uitgevoerd tussen rekeningen waar ook ter wereld, zonder extra kosten. Wij vinden dat de analyse van financiële gegevens niet beperkt moet blijven tot banken, maar dat particulieren en bedrijven controle moeten hebben over hun eigen gegevens.",
        "extended-title": "Wereldwijde financiële transformatie",
        "subtitle": "Waar staan we voor",
        "title": "Missie en visie"
      },
      "products": {
        "subtitle": "Producten",
        "text": "We bieden verschillende betaalproducten voor zowel online als persoonlijke transacties, zodat uw klanten kunnen genieten van een naadloze omnichannel betaalervaring.",
        "title": "Wat we doen"
      },
      "secret": {
        "communication": {
          "text": "We praten dingen uit, delen ideeën en bespreken openlijk wat goed werkt en wat niet. Duidelijk en open zijn over alles - van onze projecten tot onze visie - is belangrijk voor ons. Bij Noda blijft iedereen op de hoogte.",
          "title": "Communicatie"
        },
        "empathy": {
          "text": "Maar het gaat niet alleen om technologie - het gaat ook om jou. Wij zijn er om naar onze klanten te luisteren, ze te begrijpen en ze te ondersteunen. Of je nu al jaren zaken doet of net begint, bij Noda vind je een gastvrije sfeer waar jouw behoeften op de eerste plaats komen.",
          "title": "Empathie"
        },
        "innovation": {
          "text": "We experimenteren voortdurend en proberen ideeën uit. We omarmen nieuwe technologieën zoals blockchain en AI. We willen je geavanceerde oplossingen bieden die betalingen aangenamer en gemakkelijker maken. En we zijn niet bang om buiten de gebaande paden te denken.",
          "title": "Innovatie"
        },
        "subtitle": "Meer over ons",
        "title": "Onze geheime saus"
      },
      "welcome": {
        "desc-1": "We ontwikkelen een platform waarmee online bedrijven een breed scala aan klantinteracties kunnen beheren, waaronder onboarding, verificatie van identiteit en vermogen, risicobeoordeling, routing, inkomende en uitgaande betalingen en analyse van interactieprestaties.",
        "desc-2": "We worden gemotiveerd door het verbeteren van ons product en de sector in plaats van te profiteren van onze klanten. We zijn er trots op te zien hoe onze productoplossingen vorm beginnen te geven aan de open banksector in de markten waarin we actief zijn.",
        "desc-3": "Wij zijn uw partners in betalingen -\npioniers, makers en altijd bondgenoten.",
        "extended-subtitle": "Welkom bij de toekomst van fintech.",
        "extended-title": "Welkom bij Noda",
        "title": "Wie we zijn"
      },
      "whales": {
        "exploration": {
          "text": "We leren altijd bij. Onze teamleden zijn gepassioneerd en enthousiast, enthousiast over zelfontplooiing en professionele ontwikkeling. Bij Noda ondersteunen we dit streven.",
          "title": "Verkenning"
        },
        "passion": {
          "text": "Bij Noda is passie de brandstof voor alles wat we doen. We worden gedreven door uitmuntendheid, of we nu innoveren of contact maken met klanten. Wij geloven dat passie projecten tot iets opmerkelijks maakt en anderen inspireert om mee te doen.",
          "title": "Passie"
        },
        "responsibility": {
          "text": "We verspillen geen tijd met ruziën of met de vinger wijzen. Bij Noda werken we altijd samen om constructieve oplossingen te vinden, waarbij we elkaar respecteren en verantwoordelijkheid delen voor zowel winst als tegenslag.",
          "title": "Verantwoordelijkheid"
        },
        "subtitle": "Noda cultuur",
        "title": "Drie walvissen\nvan onze Noda-cultuurcode"
      }
    },
    "modern-slavery": {
      "intro-1": "De Britse Modern Slavery Act 2015 (MSA) bestrijdt slavernij en roept bedrijven ter verantwoording die handelen op een manier die beschouwd kan worden als een moderne vorm van slavernij.",
      "intro-2": "Noda verzet zich uitdrukkelijk tegen slavernij en laat zich niet in met de facilitering of ondersteuning van mensenhandel of moderne slavernij. Deze verklaring is onze toezegging aan de MSA en we benadrukken hierin onze positie inzake moderne slavernij. De verklaring bevat ook de stappen die we nemen om onze visie in de praktijk te brengen.",
      "last-update-at": "Laatst bijgewerkt op 1 juni 2024",
      "note": "LET OP: Noda is momenteel niet verplicht deze verklaring te publiceren. Wij beschouwen het echter wel als een blijk van verantwoordelijk handelen, voordat dat verplicht wordt.",
      "sections": {
        "our-status": {
          "text-1": "Noda neemt verscheidene controlemaatregelen om ervoor te zorgen dat we niet deelnemen aan activiteiten die in strijd zijn met onze visie inzake moderne slavernij. Hieronder zetten we een aantal daarvan uiteen.",
          "text-2": "Noda ontvangt zakelijke diensten, zoals consultancy, juridisch advies en boekhoudservices van verschillende aanbieders. Daarnaast werken we met leveranciers die software en hardware, computerapparatuur, licenties en cloud-based dataopslag leveren. De meesten van hen bevinden zich in de landen waar onze kantoren gevestigd zijn, namelijk het VK en landen van de EU.",
          "text-3": "Omdat we ons als bedrijf bezighouden met online betalingsverkeer levert het merendeel van onze leveranciers software en zakelijke diensten. Daarom is ons risicoprofiel op het gebied van mensenrechten en moderne slavernij laag. Toch moeten al onze leveranciers in het kader van ons intern beleid getoetst worden en due diligence ondergaan. Hoe streng dat is, hangt af van hun risicocategorie.",
          "text-4": "De meerderheid van de verkopers aan wie Noda diensten levert, is gevestigd in landen met een laag risico. Zij ondergaan due diligence ter bevestiging van hun lagerisicostatus.",
          "text-5": "Er zijn bij ons geen voorvallen van mensenhandel of moderne slavernij bekend binnen ons bedrijf of onze toeleveringsketen. In het afgelopen boekjaar zijn er geen hieraan gerelateerde incidenten gerapporteerd via onze interne meldingskanalen, auditprocessen, klokkenluiderskanalen of andere methoden. Daarnaast heeft Noda niet van entiteiten binnen de Noda Group vernomen dat dergelijke incidenten zich hebben voorgedaan bij onze leveranciers of in hun toeleveringsketens.",
          "text-6": "We doen ons uiterste best om de wereldwijd erkende mensenrechten van onze medewerkers, de gemeenschappen waarin we actief zijn en die van onze wereldwijde toeleveringsketen te waarborgen. Mochten we vernemen dat een partij waarmee we zakendoen zich schuldig maakt aan de schending van mensenrechten of zich inlaat met moderne slavernij, dan beëindigen we onze zakelijke relatie met die partij direct.",
          "text-7": "Zorgen op het gebied van mensenrechten of moderne slavernij bij een van onze verkopers, leveranciers of ander partijen kunnen aan Noda worden gemeld via <a href=\"mailto:legal@noda.live\" target=\"_blank\">Legal@noda.live</a>. We zullen alle meldingen zorgvuldig en tijdig onderzoeken.",
          "title": "Onze status, activiteiten en toeleveringsketen"
        }
      },
      "subtitle": "Intentie van de verklaring",
      "title": "Verklaring moderne slavernij"
    },
    "mor": {
      "case": {
        "subtitle": "Casestudy",
        "text": "In februari 2023 ging Wargaming, een bekroonde uitgever van online games, samenwerken met Noda om directe open bankbetalingen in games te introduceren. Door deze samenwerking kregen de spelers van Wargaming toegang tot diverse online betaalopties, waaronder account-to-account (A2A)-transacties.",
        "title": "Wargaming en Noda"
      },
      "cure": {
        "additional": {
          "text1": "Omzetbelasting, btw en GST-berekeningen",
          "text2": "Tijdige aangifte bij de belastingdienst wereldwijd",
          "text3": "Actuele updates van de belastingwetgeving",
          "text4": "Gedetailleerd gegevens bijhouden voor die \"voor het geval dat\" momenten"
        },
        "bold-text": "Wat we doen:",
        "subtitle": "Een middel tegen belastinghoofdpijn",
        "text": "Geen last meer van fiscale nachtmerries. Ons slimme systeem maakt de cijfers inzichtelijk, dient de formulieren in en houdt je op de hoogte van je doelmarkten. We houden de steeds veranderende belastingwetten over de hele wereld bij, zodat je geen onnodige belemmeringen meer hebt om je doelgroepen te bereiken.",
        "title": "Uw Partner in Wereldwijde Belasting"
      },
      "custom": {
        "subtitle": "hoe het werkt",
        "text": "We maken je weg naar de wereldmarkt vrij door complexe internationale verkopen om te zetten in naadloze transacties.",
        "title": "We zorgen voor de vervelende dingen achter de schermen: betalingen, belastingen, ondersteuning"
      },
      "faq": {
        "offer": {
          "content": "Onze 24/7 ondersteuning in meerdere talen helpt je bij alle problemen, van betalingsproblemen tot vragen over je account. Ons team is beschikbaar om je te helpen bij het navigeren door de ingewikkelde wereldwijde digitale handel.",
          "title": "Welke ondersteuning biedt Noda?"
        },
        "payment-security": {
          "content": "We gebruiken open banking voor directe bankoverschrijvingen, die rekeninghouders in realtime verifiëren. Deze werkwijze, gecombineerd met onze geavanceerde transactiebewaking, verlaagt het risico op fraude aanzienlijk en zorgt tegelijkertijd voor een soepele gebruikerservaring.",
          "title": "Hoe gaat Noda om met betalingsbeveiliging en fraudebestrijding?"
        },
        "products": {
          "content": "Absoluut! We zijn gespecialiseerd in het aanbieden van handel zonder grenzen. Ons platform biedt betalingen in meerdere valuta's, lokaliseert betaalmethoden en beheert internationale belastingnaleving, waardoor het voor jou eenvoudig is om klanten wereldwijd te bereiken.",
          "title": "Kan Noda me helpen mijn producten internationaal te verkopen?"
        },
        "services": {
          "content": "Niet per se. Hoewel je onze diensten met je bestaande website kunt gebruiken, bieden we ook gratis distributietools, met inbegrip van een intuïtieve site- en winkelbouwer zonder code om je op weg te helpen als je nog geen website hebt.",
          "title": "Heb ik een eigen website nodig om gebruik te maken van de diensten van Noda?"
        },
        "subtitle": "Belangrijk om te weten",
        "tax-compliance": {
          "content": "Ons slimme systeem berekent, incasseert en betaalt automatisch de verkoopbelasting, btw en GST voor je transacties wereldwijd. Wij houden de veranderende belastingwetten in de gaten en zorgen voor een gedetailleerde administratie, zodat je altijd voldoet aan de regels op elke markt waaraan je verkoopt.",
          "title": "Hoe helpt Noda bij het naleven van de belastingwetgeving?"
        },
        "title": "FAQs"
      },
      "geo": {
        "btn-text": "Ondersteunde bankenlijst bekijken"
      },
      "hero-data": {
        "subtitle": "merchant of record",
        "text1": "Ontgrendel grenzeloze handel voor je digitale innovaties.",
        "text2": "Van indiegames tot zakelijke software.",
        "title": "Richt je op het maken van het volgende grote ding — wij zorgen voor de ingewikkeld&shy;heden!"
      },
      "squad": {
        "additional": {
          "text1": "24/7 ondersteuning in meerdere talen",
          "text2": "Slimme inzichten die je helpen bij het nemen van zakelijke beslissingen",
          "text3": "Stevige beveiligingsmaatregelen om je inkomsten te beschermen",
          "text4": "Regelmatige technische aanpassingen om je activiteiten soepel te laten verlopen"
        },
        "subtitle": "Begeleiding en ondersteuning",
        "text": "Ons ondersteuningsteam helpt je graag wanneer je ons nodig hebt. Of het nu gaat om een late betaling of een vraag over je account, wij staan voor je klaar.\n\nVan solomakers tot bloeiende studio's, we zijn er om je te helpen succesvol te zijn op de wereldmarkt. Onze toolkit omvat:",
        "title": "Je 24/7 back-upteam"
      }
    },
    "newsroom": {
      "title": "Nieuwsredactie"
    },
    "no-code": {
      "features": {
        "custom-payment": "Aangepaste betaalpagina's on the fly",
        "instant": "Directe, veilige transacties",
        "leverage-ai": "Maak gebruik van AI om in een paar klikken complete betaalpagina's met een eigen merk te maken.",
        "real-time": "Real-time betalingen, autorisatie van betaler via bank, naadloze klantervaring.",
        "sell-anything": "Alles verkopen zonder website",
        "tag-title": "BELANGRIJKSTE KENMERKEN",
        "text": "Verkoop digitale en fysieke goederen en diensten zonder het gedoe van langdurige ontwikkeling en installatie.",
        "title": "Een snelkoppeling om de online verkoop van je\nproducten te laten groeien",
        "turn-any": "Maak van elk kanaal jouw online marktplaats. Laat Noda de hele betalingsstroom afhandelen."
      },
      "hero": {
        "text": "Creëer binnen enkele minuten aangepaste betaalervaringen met AI",
        "title": "Betaalpagina\nZonder Code"
      },
      "how-it-works": {
        "ai-based": "AI-gebaseerde analyse",
        "authorize": "Autoriseer direct in de chat en navigeer naar de paginabouwerfunctie.",
        "enter-your": "Voer je verzoek in of upload een bestaande productbeschrijving. Geef de chatbot een moment om te verwerken.",
        "make-necessary": "Maak de nodige aanpassingen, keur de versie die je goed vindt goed en begin met de verkoop!",
        "payment-page": "Betaalpagina is klaar",
        "preview": "Voorbeeld",
        "tag-title": "hoe het werkt",
        "text-first": "Maak in enkele minuten aangepaste betaalpagina's met behulp van een eenvoudige AI-chatinterface.",
        "text-second": "Genereer automatisch tekst en afbeeldingen op basis van je productgegevens. Neem betaallinks en QR-codes op voor een volledig functionele betaalpagina.",
        "the-bot": "De bot genereert een volledige betaalpagina op basis van jouw invoer: afbeeldingen, tekst, betaalfunctionaliteit, QR-code.",
        "title": "Slimme paginabouwer voor betalingen",
        "user-friendly": "Gebruiksvriendelijke interface"
      },
      "monetize": {
        "direct-sales": "Directe verkoop",
        "donations": "Donaties",
        "event-tickets": "Tickets voor evenementen",
        "games": "Spellen en spelmerchandise",
        "lean": "Maak gebruik van nieuwe bedrijfsmodellen. Bouw aangepaste betaalpagina's en begin met verkopen zodra je op \"Opslaan\" drukt.",
        "monetize": "Verdien geld met alles",
        "online-courses": "Online cursussen",
        "online-retail": "Online detailhandel",
        "tips": "Tips",
        "travel-packages": "Reispakketten"
      },
      "product-block": {
        "text": "Aangepaste betaalpagina's binnen minuten. Geen ontwikkeling, geen heen-en-weer met ontwerpers en tekstschrijvers. Een eenvoudige, mooie en betrouwbare manier voor uw klanten om te betalen via verschillende kanalen en bedrijfsmodellen.",
        "title": "Betaalpagina Zonder Code"
      },
      "sell": {
        "are-you": "Ben je een online bedrijf aan het opbouwen of ben je op zoek naar nieuwe inkomstenbronnen voor een bestaande onderneming?\n\nMaak direct contact met je klanten door verkopen te lanceren via e-mail, messengers, sociale media, livestreams – eigenlijk overal waar je een link naar een betaalpagina kunt delen.",
        "launch": "Start verkoop met gemak: geen website, geen betalingsintegratie, geen heen-en-weer gedoe met ontwikkelaars en ontwerpers.\n\nHet Noda betaalplatform ondersteunt je volledige transactiestroom – van het verstrekken van een handelaarsrekening tot de dagelijkse verwerking van betalingen.",
        "reach": "Bereik uw klanten waar ze ook zijn",
        "secure": "Veilige directe betalingen",
        "tag-title": "VERKOPEN ZONDER WEBSITE"
      }
    },
    "partners": {
      "available": {
        "list": {
          "item1": {
            "text": "Integreer onze technologie naadloos in uw eigen oplossingen als white-label partner",
            "title": "White-Label"
          },
          "item2": {
            "text": "Bedrijven uitnodigen via verwijzingslinks als resellerpartner",
            "title": "Reseller"
          },
          "item3": {
            "text": "Onder onze merknaam opereren als franchisepartner",
            "title": "Franchise"
          },
          "item4": {
            "text": "Als agent topklanten binnenhalen",
            "title": "Agent"
          }
        },
        "subtitle": "verscheidenheid aan opties",
        "title": "Beschikbare partnerschappen"
      },
      "banking": {
        "item1": "Landen",
        "item2": "e-com platforms geïntegreerd",
        "item3": "digitale producten ontwikkeld",
        "subtitle": "Kies uw perfecte partnerschap",
        "text": "Verken een verscheidenheid aan partnerschapsopties op maat van uw behoeften. Of je nu onze technologie wilt integreren, andere bedrijven wilt doorverwijzen, ons merk wilt gebruiken of in contact wilt komen met waardevolle klanten, wij hebben het perfecte partnerschapstraject voor jou.",
        "title": "Hoe het werkt"
      },
      "customisation": {
        "subtitle": "interface op maat",
        "text": "Of je nu je eigen front-end wilt ontwikkelen of onze ingebouwde tools voor gebruikersinterfaces (UI's) wilt gebruiken, de keuze is aan jou. Geef je ontwerp vorm om je merk volledig te vertegenwoordigen en de perfecte reis te creëren.",
        "title": "Merkaanpassing"
      },
      "hero": {
        "subtitle": "betere betalingen",
        "text": "Integreer moeiteloos open banking transacties, krijg toegang tot bruikbare analyses en profiteer van onze intuïtieve UX. Geniet van naadloze API-integratie en transparante rapportage om het succes van merchants te vergroten.",
        "title": "Help uw klanten groeien met Open Banking"
      },
      "reporting": {
        "subtitle": "volledige transparantie",
        "text": "Met onze admin hub kun je alle commissies bijhouden, wat zorgt voor een duidelijke en transparante rapportage. Houd moeiteloos toezicht op betalingen en uitbetalingen, krijg volledig inzicht en beheer je activiteiten met gemak.",
        "title": "Gedetailleerde bewaking en rapportage"
      },
      "technology": {
        "subtitle": "kracht van technologie",
        "text1": "Vóór open bankieren hadden traditionele banken een monopolie op klantgegevens. In 2018 verplichtte de PSD2 van de EU banken om informatie te delen met geautoriseerde derde partijen, zoals Noda, met toestemming van de klant.",
        "text2": "Open banking gebruikt API's (Application Programming Interfaces) voor softwarecommunicatie om gegevens over te dragen. Wanneer gebruikers kiezen voor een open banking betaling, worden ze doorgestuurd naar de interface van hun vertrouwde bank.",
        "text3": "Wereldwijd omarmen steeds meer consumenten en winkeliers deze opkomende technologie. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">Juniper Research</a> voorspelt dat de totale waarde van open banking-betalingen zal stijgen van 57 miljard dollar in 2023 tot 330 miljard dollar in 2027. Wat ooit als innovatief werd beschouwd, wordt nu snel een algemeen geaccepteerde betaalmethode.",
        "title": "Open Banking verandert betalingssystemen"
      }
    },
    "plugins": {
      "back-to-plugins": "Terug naar Plugins",
      "bigcommerce": {
        "benefits": {
          "list": {
            "text": "Onze WordPress WooCommerce-betalingsplug-in zorgt biedt uw klanten een naadloze gebruikerservaring. Dit resulteert in meer klanttevredenheid en minder afgebroken bestellingen tijdens het afrekenen.",
            "text-1": "Onze WordPress WooCommerce-betalingsplug-in zorgt biedt uw klanten een naadloze gebruikerservaring. Dit resulteert in meer klanttevredenheid en minder afgebroken bestellingen tijdens het afrekenen.",
            "title": "Een intuïtieve gebruikersinterface",
            "title-1": "Een intuïtieve gebruikersinterface"
          },
          "title": "De voordelen van Noda voor WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Hoe test ik deze plugin?",
              "text": "U kunt de testmodus van de plug-in inschakelen, waarmee u transacties kunt simuleren."
            },
            "2": {
              "summary": "Ondersteunt jullie plug-in WooCommerce-abonnementen?",
              "text": "U kunt de testmodus van de plug-in inschakelen, waarmee u transacties kunt simuleren."
            },
            "3": {
              "summary": "Waarom wordt de knop 'Betalingsverzoek' niet weergegeven op mijn lokale computer?",
              "text": "U kunt de testmodus van de plug-in inschakelen, waarmee u transacties kunt simuleren."
            }
          },
          "title": "Meest gestelde vragen"
        },
        "hero": {
          "button": "Noda toevoegen aan WooCommerce",
          "logo": "bigcommerce",
          "text": "Ontdek de WordPress-plug-in van Noda, die open banking-betalingen mogelijk maakt voor WooCommerce. Installeer en integreer de plug-in met slechts een paar eenvoudige stappen.",
          "title": "WordPress WooCommerce-betalingsgateway met Noda"
        },
        "how": {
          "text": "Webwinkeliers die de plug-in installeren, kunnen een Noda-knop als betaalmethode aan hun website toevoegen.",
          "title": "Hoe het werkt?"
        },
        "inspiration": "U bent misschien ook op zoek naar",
        "integration": {
          "after": "De integratie is een kwestie van een paar klikken en vereist geen tussenkomst van een ontwikkelaar. Met Noda kunnen webwinkeliers moeiteloos open banking-betalingen toevoegen als een aanvullende WooCommerce-betaaloptie.",
          "before": "Om de WordPress WooCommerce-betalingsplug-in in te stellen met Noda, moeten webwinkeliers deze eenvoudige stappen volgen:",
          "button": {
            "text": "Handleiding downloaden"
          },
          "steps": {
            "1": "Installeer het archiefbestand vanuit het adminpaneel van WooCommerce. Hiermee wordt de plug-in ingesteld voor uw website.",
            "2": "Voeg API-sleutels toe, die na het voltooien van de onboarding beschikbaar zullen zijn via Noda Hub.",
            "3": "WeCommerce en Noda zijn aan elkaar gekoppeld."
          },
          "title": "Noda's integratie met WooCommerce"
        },
        "what-is-it": {
          "text": "WeCommerce is open-sourcesoftware voor WordPress waarmee bedrijven e-commercewebsites kunnen maken in de programmeertaal PHP. Noda biedt een plug-in die open banking-betalingen mogelijk maakt in de vorm van een WordPress WooCommerce-betalingsgateway.",
          "title": "Wat is het?"
        }
      },
      "details": "FAQ",
      "faq": {
        "development-skills": {
          "content": "Nee, onze plugins zijn ontworpen voor eenvoudige installatie zonder dat er gespecialiseerde technische vaardigheden nodig zijn. De stapsgewijze handleidingen leiden u door het eenvoudige proces. Als u problemen ondervindt, staat ons supportteam klaar om u te helpen.",
          "title": "Heb ik ontwikkelvaardigheden nodig om deze plug-ins te installeren?"
        },
        "how-secure": {
          "content": "Alle Noda-plugins voldoen aan strikte beveiligingsnormen en wettelijke vereisten voor open banking. Transacties worden beveiligd met multi-factor authenticatie en data-encryptie om zowel handelaren als klanten te beschermen.",
          "title": "Hoe veilig zijn deze betalingsplug-ins?"
        },
        "plugins-compatible": {
          "content": "Noda-plugins zijn speciaal ontworpen voor open banking-betalingen, zodat uw klanten rechtstreeks vanaf hun bankrekening kunnen betalen. Dit biedt verbeterde beveiliging en lagere transactiekosten vergeleken met traditionele betaalmethoden.",
          "title": "Zijn Noda-plug-ins compatibel met alle betaalmethoden?"
        },
        "subtitle": "FAQ",
        "title": "Meest gestelde vragen",
        "troubleshooting": {
          "content": "Ons supportteam staat klaar om te helpen met installatie, configuratie en probleemoplossing. Neem contact met ons op via de supportkanalen die op elke pluginpagina staan vermeld, en we helpen u graag verder.",
          "title": "Wat als ik hulp nodig heb bij de installatie of het oplossen van problemen? "
        },
        "what-is-required": {
          "content": "Om een Noda-plugin te gebruiken, moet u een Noda-account aanmaken, het onboardingproces voltooien en API-sleutels verkrijgen. De specifieke vereisten voor elk platform worden gedetailleerd beschreven op de individuele pluginpagina's.",
          "title": "Wat is er nodig om Noda-plug-ins te gebruiken? "
        }
      },
      "fqa": "veelgestelde vragen",
      "hero": {
        "button": "Neem contact op met ons team",
        "subtitle": "Integreer Noda in minuten met onze kant-en-klare plugins. Stroomlijn betalingen met vereenvoudigde gebruikerservaring, naadloze integratie en verbeterde beveiliging van open banking.",
        "title": "Naadloze Open Banking-betalingen voor uw e-commerce&shy;platform"
      },
      "info": {
        "bigcommerce": {
          "subtitle": "Binnenkort beschikbaar",
          "text": "De BigCommerce-plug-in van Noda maakt het eenvoudiger om open banking-betalingen toe te voegen aan uw BigCommercewebsite. Snelle installatie voor een gestroomlijnd betalingsproces.",
          "title": "BigCommerce"
        },
        "magento": {
          "text": "Ontdek de Magento-plug-in van Noda. Leer hoe u Noda kunt integreren als een Magento-betaaloptie op uw e-commercewebsite en til uw bedrijf naar een hoger niveau met open banking-betalingen.",
          "title": "Magento"
        },
        "opencart": {
          "text": "Leer hoe u Noda kunt integreren als een OpenCart-betalingsoptie op uw e-commercewebsite. Maak uw betalingen eenvoudiger met open banking.",
          "title": "OpenCart"
        },
        "prestashop": {
          "text": "Integreer open banking-betalingen met Noda's PrestaShop-plug-in. Installeer Noda als een PrestaShop-betalingsoptie op uw e-commercewebsite op een snelle en eenvoudige manier.",
          "title": "PrestaShop"
        },
        "step-title": "Stap",
        "woocommerce": {
          "text": "Ontdek de WordPress-plug-in van Noda, die open banking-betalingen mogelijk maakt voor WooCommerce. Installeer en integreer de plug-in met slechts een paar eenvoudige stappen.",
          "title": "WooCommerce"
        }
      },
      "integration": {
        "btn-request": "Integratie aanvragen",
        "btn-view": "API-documentatie",
        "description": "We breiden onze plug-ins voortdurend uit. Neem contact met ons op voor aangepaste integraties of raadpleeg onze API-documentatie voor ontwikkelingsopties.",
        "title": "Integratie aanvragen"
      },
      "magento": {
        "benefits": {
          "button": {
            "text": "Neem contact op met ons team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Onze Magento e-commerce-integratie biedt uw klanten een naadloze gebruikerservaring. Dit resulteert in meer klanttevredenheid en een laag aantal afgebroken bestellingen tijdens het afrekenen.",
              "title": "Gebruikerservaring (UX)"
            },
            "2": {
              "icon": "kaart",
              "text": "Webwinkekier kunnen de plug-ins van Noda installeren zonder tussenkomt van een ontwikkelaar en zonder technische vaardigheden.",
              "title": "Naadloze integratie"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "De open banking-functionaliteit zorgt voor veiligheid voor zowel klanten als webwinkeliers. Multifactorverificatie is een wettelijke vereiste volgende de Europese regelgeving.",
              "title": "Beveiliging"
            },
            "4": {
              "icon": "all_match",
              "text": "Magento-betalingsverwerking met open banking is sneller en voordeliger voor webwinkeliers en zorgt voor een sneller afrekenproces en ontvangst van geld.",
              "title": "Efficiëntie"
            }
          },
          "title": "Voordelen van Noda voor Magento"
        },
        "hero": {
          "button": "Noda toevoegen aan Magento",
          "logo": "magento",
          "text": "Ontdek de Magento-plugin van Noda. Leer hoe u Noda kunt integreren als Magento-betalingsoptie op uw e-commercewebsite.",
          "title": "Magento-betalingsgateway met Noda"
        },
        "how": {
          "text": "Webwinkeliers die de plug-in installeren, kunnen Noda toevoegen als een aanvullende Magento-betalingmethode die klanten bij het afrekenen kunnen gebruiken.",
          "title": "Hoe het werkt?"
        },
        "inspiration": "U bent misschien ook op zoek naar",
        "integration": {
          "after": "De integratie is een kwestie van een paar klikken en vereist geen gevorderde technische vaardigheden. Met Noda kunnen webwinkeliers moeiteloos de functionaliteit open banking toevoegen als Magento-e-commerce-oplossing.",
          "before": "Om de Magento-integratie met Noda op te zetten, moeten webwinkeliers deze eenvoudige stappen volgen:",
          "steps": {
            "1": "Installeer het archiefbestand vanuit het adminpaneel van WooCommerce. Hiermee wordt de plug-in ingesteld voor uw website.",
            "2": "Voeg API-sleutels toe, die na het voltooien van de onboarding beschikbaar zullen zijn via Noda Hub.",
            "3": "Magento en Noda zijn nu aan elkaar gekoppeld."
          },
          "title": "Integratie van de Magento-betalingsgateway"
        },
        "meta": {
          "description": "Ontdek de Magento-plugin van Noda. Leer hoe u Noda kunt integreren als Magento-betalingsoptie op uw e-commercewebsite.",
          "title": "Magento-betalingsgateway met Noda"
        },
        "what-is-it": {
          "text": "Magento is een e-commerceplatform gebaseerd op opensourcetechnologie in de programmeertaal PHP. Noda biedt een plug-in die open banking-betalingen mogelijk maakt voor e-commercewebsites.",
          "title": "Wat is het?"
        }
      },
      "opencart": {
        "benefits": {
          "button": {
            "text": "Neem contact op met ons team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Open banking-betalingen bieden uw klanten een vereenvoudigde gebruikerservaring, wat leidt tot minder afgebroken bestellingen tijdens het afrekenen en meer klanttevredenheid.",
              "title": "Een intuïtieve gebruikersinterface"
            },
            "2": {
              "icon": "kaart",
              "text": "Met Noda kunnen webwinkeliers de plug-in installeren zonder tussenkomst van een ontwikkelaar.",
              "title": "Eenvoudige integratie"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "De open banking-functionaliteit zorgt voor veiligheid voor zowel klanten als webwinkeliers. Multifactorverificatie is een wettelijke vereiste volgende de Europese regelgeving.",
              "title": "Beveiliging"
            },
            "4": {
              "icon": "all_match",
              "text": "De OpenCart-betalingsverwerking met Noda is sneller en voordeliger voor webwinkeliers en zorgt voor een sneller afrekenproces en ontvangst van geld.",
              "title": "Efficiëntie"
            }
          },
          "title": "Voordelen van Noda voor OpenCart"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Wat zijn de vereisten voor de OpenCart-plug-in?",
              "text": "Om de OpenCart-plugin van Noda goed te integreren heeft u minimaal de PHP-versie 7.0.3 nodig. Alle PHP-versies tussen 7.0.3 en 8.2.x worden ondersteund. U hebt ook minimaal versie 3 van WordPress nodig. Uw huidige versie vindt u onderaan uw OpenCart-adminpaneel. Om de plug-in van Noda in productiemodus te kunnen gebruiken, dient u het onboardingsproces van Noda te hebben voltooid."
            },
            "2": {
              "summary": "Hoe integreer ik deze plug-in met Noda?",
              "text": "Om de OpenCart plug-in te integreren, installeert u het archiefbestand vanuit het OpenCart-adminpaneel en voegt u de API-sleutels toe die u na de onboarding op NodaHub kunt vinden."
            },
            "3": {
              "summary": "Hoe test ik deze plug-in?",
              "text": "Om deze plug-in te testen, schakelt u de testmodus in met behulp van de Sandbox-sleutels in de Noda-hub. Hiermee kunt u een testrun uitvoeren."
            }
          },
          "title": "Meest gestelde vragen"
        },
        "hero": {
          "button": "Noda toevoegen aan OpenCart",
          "logo": "opencart",
          "text": "Ontdek de OpenCart-plug-in van Noda. Leer hoe u Noda kunt integreren als een OpenCart-betalingsoptie op uw e-commercewebsite.",
          "title": "OpenCart-betalingsgateway met Noda"
        },
        "how": {
          "text": "Webwinkeliers die de plug-in hebben geïnstalleerd, krijgen een Noda-knop op hun website die klanten bij het afrekenen als betaaloptie te zien krijgen.",
          "title": "Hoe het werkt?"
        },
        "inspiration": "Misschien bent u ook op zoek naar",
        "integration": {
          "after": "De hele proces is een kwestie van een paar klikken en vereist geen technische vaardigheden. Met de OpenCart-betalingsplug-in van Noda kunnen webwinkeliers eenvoudig open banking-functionaliteit toevoegen aan hun bestaande aanbod van betalingsmethoden.",
          "before": "Om de OpenCart-integratie met Noda op te zetten, moeten webwinkeliers deze eenvoudige stappen volgen:",
          "steps": {
            "1": "Installeer het archiefbestand vanuit het adminpaneel van OpenCart. Hiermee wordt de plug-in ingesteld voor uw website.",
            "2": "Voeg API-sleutels toe, die na het voltooien van de onboarding beschikbaar zullen zijn via Noda Hub.",
            "3": "OpenCart en Noda zijn nu aan elkaar gekoppeld."
          },
          "title": "OpenCart-integratie met Noda"
        },
        "meta": {
          "description": "Ontdek de OpenCart-plug-in van Noda. Leer hoe u Noda kunt integreren als een OpenCart-betalingsoptie op uw e-commercewebsite.",
          "title": "OpenCart-betalingsgateway met Noda"
        },
        "what-is-it": {
          "text": "OpenCart is een gratis opensource-e-commerceplatform voor het online verkopen van producten. Het is gebaseerd op de programmeertaal PHP en de database MySql. Met Noda's plug-in voor e-commercewebsites kunnen webwinkeliers open banking-betalingen toevoegen als een aanvullende OpenCart-betaalmethode.",
          "title": "Wat is het?"
        }
      },
      "platforms": "Ondersteunde e-commerceplatforms",
      "pre-footer": {
        "button": "Neem contact op met ons team",
        "single-page-plugin": {
          "button": "Neem contact op met ons team",
          "subtitle": "Hoe integreren werkt",
          "text": "Neem contact met ons op voor meer informatie over het samenwerken met partners.",
          "title": "Klaar om u aan te sluiten?"
        },
        "subtitle": "Hoe integreren werkt",
        "text": "Neem contact met ons op voor meer informatie over het samenwerken met partners.",
        "title": "Klaar om u aan te sluiten?"
      },
      "prestashop": {
        "benefits": {
          "button": {
            "text": "Neem contact op met ons team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Open banking-betalingen bieden uw klanten een vereenvoudigde gebruikerservaring. Dit leidt tot meer klanttevredenheid en minder afgebroken afrekeningen.",
              "title": "Eenvoud"
            },
            "2": {
              "icon": "kaart",
              "text": "Webwinkeliers kunnen de plug-ins van Noda installeren zonder tussenkomst van een team van ontwikkelaars en zonder technische vaardigheden.",
              "title": "Naadloze integratie"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "De open banking-functionaliteit zorgt voor veiligheid voor zowel klanten als webwinkeliers. Multifactorverificatie is wettelijk vereist volgens de Europese regelgeving.",
              "title": "Beveiliging"
            },
            "4": {
              "icon": "all_match",
              "text": "Open banking-betalingen zijn sneller en voordeliger voor webwinkeliers en versnellen het afrekenproces en de ontvangst van geld.",
              "title": "Efficiëntie"
            }
          },
          "title": "Voordelen van Noda voor PrestaShop"
        },
        "hero": {
          "button": "Noda naar PrestaShop",
          "logo": "prestashop",
          "text": "Ontdek de PrestaShop-plug-in van Noda. Leer hoe u Noda kunt integreren als een PrestaShop-betalingsoptie op uw e-commercewebsite.",
          "title": "PrestaShop betalingsgateway met Noda"
        },
        "how": {
          "text": "Webwinkeliers die de plug-in geïnstalleerd hebben, krijgen een Noda-knop op hun website die klanten bij het afrekenen te zien krijgen.",
          "title": "Hoe werkt het?"
        },
        "inspiration": "Misschien bent u ook op zoek naar",
        "integration": {
          "after": "De integratie is een kwestie van een paar klikken en u hoeft geen ontwikkelaars in uw team te hebben. Met de PrestaShop-betaalplug-in van Noda kunnen webwinkeliers hun betaalstrategie moeiteloos verbeteren met open banking.",
          "before": "Om de integratie van PrestaShop met Noda uit te voeren, moeten webwinkeliers de volgende eenvoudige stappen volgen:",
          "steps": {
            "1": "Installeer het archiefbestand in het adminpaneel van PrestaShop. Hiermee wordt de plug-in ingesteld voor uw website.",
            "2": "Voeg API-sleutels toe, die u na het voltooien van de onboarding beschikbaar zullen zijn via Noda Hub.",
            "3": "PrestaShop en Noda zijn nu aan elkaar gekoppeld."
          },
          "title": "Integratie van de PrestaShop-betalingsgateway"
        },
        "what-is-it": {
          "text": "PrestaShop is een opensourceplatform waarmee webwinkeliers hun eigen e-commercewebsites kunnen maken en ontwikkelen in de programmeertaal PHP. Met de plug-in van Noda kunnen webwinkeliers de open banking-functionaliteit toevoegen als PrestaShop-betaalmethode.",
          "title": "Wat is het?"
        }
      },
      "section": {
        "subtitle": "Til uw bedrijf naar een hoger niveau met de open banking-plug-ins van Noda voor het e-commerceplatform dat u gebruikt. Stroomlijn betalingen met de vereenvoudigde gebruikerservaring, naadloze integratie, veiligheid en efficiëntie van open banking.",
        "title": "Vergroot uw omzet met de open banking-plug-ins van Noda"
      },
      "soon": "Binnenkort beschikbaar",
      "woocommerce": {
        "benefits": {
          "button": {
            "text": "Neem contact op met ons team"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Onze WordPress WooCommerce-betalingsplug-in geeft uw klanten een naadloze gebruikerservaring. Dit leidt tot meer klanttevredenheid en een lager aantal afgebroken bestellingen bij het afrekenen.",
              "title": "Intuïtieve gebruikersinterface"
            },
            "2": {
              "icon": "kaart",
              "text": "Webwinkeliers kunnen de plug-ins van Noda installeren zonder tussenkomst van een team van ontwikkelaars en zonder technische vaardigheden.",
              "title": "Eenvoudige integratie"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "De open banking-betalingen garanderen veiligheid voor zowel klanten als webwinkeliers. Multifactorverificatie is wettelijk vereist volgens de Europese regelgeving.",
              "title": "Beveiliging"
            },
            "4": {
              "icon": "all_match",
              "text": "WooCommerce-betalingsverwerking met open banking is sneller en voordeliger voor webwinkeliers en versnelt het afrekenproces en de ontvangst van geld.",
              "title": "Efficiëntie"
            }
          },
          "title": "Voordelen van Noda voor WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Wat zijn de vereisten voor de WooCommerce-plug-in?",
              "text": "Om de WooCommerce-plug-in van Noda te integreren heeft u een PHP-versie van minimaal 7.0.3  nodig, een WordPress-versie van minimaal 5.3 en een WooCommerce-versie van 4.5 om compatibiliteit te garanderen. Om de plug-in in productiemodus te kunnen gebruiken, moet u het onboardingsproces bij Noda hebben voltooid."
            },
            "2": {
              "summary": "Hoe integreer ik deze plug-in met Noda?",
              "text": "Om de WooCommerce-plug-in te integreren, installeert u het archiefbestand vanuit het WooCommerce-adminpaneel en voegt u de API-sleutels toe die na de onboarding beschikbaar zullen zijn op NodaHub."
            },
            "3": {
              "summary": "Hoe test ik deze plug-in?",
              "text": "Om deze plug-in te testen, schakelt u de testmodus in met behulp van de Sandbox-sleutels in de Noda-hub. Hiermee kunt u een testrun uitvoeren."
            },
            "4": {
              "summary": "Biedt deze plug-in ondersteuning voor WooCommerce-abonnementen?",
              "text": "Nee, deze plug-in ondersteunt geen WooCommerce-abonnementen."
            }
          },
          "title": "Meest gestelde vragen"
        },
        "hero": {
          "button": "Noda naar WooCommerce",
          "logo": "woocommerce",
          "text": "Ontdek de WordPress-plug-in van Noda. Leer hoe u Noda kunt integreren als een WooCommerce-betalingsmethode voor uw e-commercebedrijf.",
          "title": "WordPress WooCommerce-betalingsgateway met Noda"
        },
        "how": {
          "text": "Webwinkeliers die de plug-in installeren, kunnen een Noda-knop als betaalmethode op hun website zetten.",
          "title": "Hoe werkt het?"
        },
        "inspiration": "Misschien bent u ook op zoek naar",
        "integration": {
          "after": "De integratie is een kwestie van een paar klikken en vereist geen tussenkomst van een ontwikkelaar. Met Noda kunnen webwinkeliers moeiteloos open banking betalingen toevoegen als een aanvullende WooCommerce-betaaloptie.",
          "before": "Om de WordPress WooCommerce-betalingsplug-in in te stellen met Noda, moeten webwinkeliers deze eenvoudige stappen volgen:",
          "steps": {
            "1": "Installeer het archiefbestand vanuit het adminpaneel van WooCommerce. Hiermee wordt de plug-in ingesteld voor uw website.",
            "2": "Voeg API-sleutels toe, die u na het voltooien van de onboarding beschikbaar zullen zijn via Noda Hub.",
            "3": "WooCommerce en Noda zijn nu aan elkaar gekoppeld."
          },
          "title": "Noda's integratie met WooCommerce"
        },
        "what-is-it": {
          "text": "WooCommerce is opensourcesoftware voor WordPress waarmee bedrijven e-commercewebsites kunnen maken in de programmeertaal PHP. Noda biedt een plug-in die open banking-betalingen mogelijk maakt in de vorm van een WordPress WooCommerce-betalingsgateway.",
          "title": "Wat is het?"
        }
      }
    },
    "policy": {
      "last-update": "Laatst bijgewerkt op <data>12 augustus 2024</data>",
      "section-1": {
        "text-1": "Door onze Dienst te gebruiken, stem je in met de Gebruiksvoorwaarden en dit Privacybeleid.",
        "text-2": "Jij bent er in het kader van de overeenkomst tussen jou en ons verantwoordelijk voor dit Privacybeleid zorgvuldig door te nemen en de juiste gegevens over jezelf te verstrekken.",
        "text-3": "Het is onze verantwoordelijkheid je zo duidelijk en actueel mogelijke informatie te verschaffen over hoe we je gegevens verwerken.",
        "title": "1. Verantwoordelijkheden"
      },
      "section-2": {
        "text": "We beginnen met het verzamelen van je gegevens als je onze Dienst of onze website begint te gebruiken. We verzamelen de gegevens met als doel je onze Dienst te kunnen aanbieden en voor andere doeleinden zoals beschreven in Paragraaf 3 hieronder.",
        "title": "2. Wanneer verzamelen we je gegevens?"
      },
      "section-3": {
        "header-1": "Doel van het gebruik van persoonsgegevens",
        "header-2": "Categorie betrokkene",
        "header-3": "Persoonsgegevens",
        "header-4": "Juridische basis",
        "header-5": "Bewaartermijn",
        "t-body-10": {
          "legal": "Naleving van een wettelijke verplichting",
          "personal": "Identiteitsbewijzen, biometrische afbeeldingen en andere biometrische identificatiegegevens, bron van het geld, informatie van tools die met naleving te maken hebben, adres, energierekening, transactiegeschiedenis, logbestanden, cv's, migratiegegevens en -documenten, politieke status, gegevens bankrekening, gerelateerde websites, gerelateerde bedrijfsstructuur, risicoscore",
          "purpose": "Het bijhouden van transacties en naleving",
          "subject": "Personen in de structuur van partners en zakelijke klanten, uiteindelijk belanghebbenden, betalers van de verkopers",
          "term": "5 jaar na beëindiging van de samenwerking"
        },
        "t-body-11": {
          "legal": "Legitiem belang om de dienst te leveren",
          "personal": "Volledige naam, e-mailadres, IBAN, transactiegegevens, logboeken, IP-adres, sessiegegevens, locatie, gegevens van besturingssysteem, type apparaat, inlogregistraties, statistieken over hoe je de Dienst gebruikt.",
          "purpose": "Ontwikkeling en testen van de Dienst en nieuwe producten",
          "subject": "Betalers (natuurlijke personen), medewerkers en individuele externe medewerkers van Noda, vertegenwoordigers van consultants, partners en verkopers",
          "term": "Tot 5 jaar nadat de gegevens niet meer nodig zijn"
        },
        "t-body-12": {
          "legal": "Toestemming",
          "personal": "Volledige naam, lijst met transacties, geldbedrag, valuta, tijdstip van betalingen/datum, rekeningsaldo, naam van de verkoper, interne identificatiecodes, IBAN, gemiddelde omzet van de betaler en cookies en andere trackers. Meer informatie hierover vind je in ons <a href=\"https://noda.live/about/legal-privacy/cookies\">Cookiebeleid</a>.",
          "purpose": "DE (Data Enrichment)-product om inzichten te ontwikkelen. Hiermee kunnen wij en onze partners (inclusief verkopers) je relevante diensten leveren, een betere gebruikerservaring voor je creëren en je gerichte advertenties en op maat gemaakte services bieden.",
          "subject": "Betalers (natuurlijke personen)",
          "term": "<p>Tot 5 jaar.</p><p>De bewaartermijn van cookies wordt ingesteld op basis van het <a href=\"https://noda.live/about/legal-privacy/cookies\">Cookiebeleid</a>.</p>"
        },
        "t-body-13": {
          "legal": "<p>Legitiem belang om de diensten van Noda te promoten</p><p>Toestemming</p>",
          "personal": "Volledige naam, e-mailadres, communicatie",
          "purpose": "Marketingmails versturen",
          "subject": "Contactpersonen van zakelijke klanten en partners",
          "term": "Terwijl de samenwerking van kracht is en gedurende 5 jaar na beëindiging ervan (of als er geen samenwerking tot stand is gekomen)"
        },
        "t-body-14": {
          "legal": "<p>Legitiem belang om de diensten van Noda te promoten</p><p>Toestemming</p>",
          "personal": "Volledige naam, socialemedia-account, registratienummer, locatie, cookies en vergelijkbare trackers (zie het <a href=\"https://noda.live/about/legal-privacy/cookies\">cookiebeleid</a>), foto, e-mailadres,",
          "purpose": "Digitale campagnes uitvoeren",
          "subject": "Contactpersonen van zakelijke klanten en partners",
          "term": "Terwijl de samenwerking van kracht is en gedurende 5 jaar na beëindiging ervan (of als er geen samenwerking tot stand is gekomen)"
        },
        "t-body-15": {
          "legal": "Legitiem belang om de diensten van Noda te promoten",
          "personal": "Volledige naam, e-mailadres, telefoonnummer, werklocatie, beschrijving van communicatie",
          "purpose": "Bedrijfsontwikkeling",
          "subject": "Contactpersonen van partners, potentiële partners, zakelijke klanten en potentiële zakelijke klanten",
          "term": "Terwijl de samenwerking van kracht is en gedurende 5 jaar na beëindiging ervan (of als er geen samenwerking tot stand is gekomen)"
        },
        "t-body-16": {
          "legal": "Legitieme belangen om deze dienst op basis van de huidige situatie van de markt verder te ontwikkelen",
          "personal": "Volledige naam, roepnaam, e-mailadres, geslacht, woonplaats, IP-adres, werkgelegenheidsstatus, test- en onderzoeksresultaten, video-opnames",
          "purpose": "Onderzoek uitvoeren en een betere gebruikerservaring creëren",
          "subject": "Deelnemers aan onderzoek, testers",
          "term": "Tot 10 jaar"
        },
        "t-body-17": {
          "legal": "<p>Legitieme belangen om de veiligheid en het concurrentievoordeel van Noda te waarborgen</p><p>Naleving van een wettelijke bepaling</p>",
          "personal": "Informatie over je apparaat en andere technische gegevens: je IP-adres, tijdzone, locatie, de browser of het platform van waaruit je de Dienst gebruikt",
          "purpose": "Het waarborgen van de veiligheid en het opsporen van fraude",
          "subject": "Gebruikers van onze Dienst, website en producten",
          "term": "Tot 10 jaar"
        },
        "t-body-18": {
          "legal": "Een contract sluiten",
          "personal": "Naam, achternaam, e-mailadres, telefoonnummer",
          "purpose": "Overeenkomsten sluiten",
          "subject": "Vertegenwoordigers van leveranciers en klanten",
          "term": "Tot 10 jaar na de beëindiging"
        },
        "t-body-19": {
          "legal": "<p>Opereren op basis van een contract</p><p>Legitieme belangen om inkomen te verdienen</p>",
          "personal": "Naam, achternaam, e-mailadres, telefoonnummer, bank- en betaalgegevens, informatie van facturen, nummer identiteitsbewijs, overeenkomsten en machtigingen",
          "purpose": "De betaling van facturen",
          "subject": "Vertegenwoordigers van leveranciers, consultants en individuele dienstverleners",
          "term": "Tot 10 jaar na de betaling van de factuur"
        },
        "t-body-1": {
          "legal": "Een contract sluiten en uitvoeren",
          "personal": "Volledige naam, geboortedatum, adres, e-mailadres, telefoonnummer, financiële en bankgegevens (waaronder, maar niet beperkt tot, bank- of rekeninggegevens, transactiegegevens, lening- en beleggingsgegevens), gegevens over een bank of andere aanbieders van rekeningen, en andere gegevens die de aanbieder van een betaalrekening ons kan verstrekken",
          "purpose": "Online betalingen opzetten en verwerken",
          "subject": "Betalers (natuurlijke personen)",
          "term": "Terwijl de Dienst wordt gebruikt en tot 10 jaar na de beëindiging van de levering ervan"
        },
        "t-body-20": {
          "legal": "Legitieme belangen om het bedrijf in leven te houden",
          "personal": "Naam, achternaam, e-mailadres, telefoonnummer",
          "purpose": "Diensten van derde partijen gebruiken",
          "subject": "Vertegenwoordigers van leveranciers, consultants en individuele dienstverleners",
          "term": "Tot 10 jaar na de beëindiging van de samenwerking"
        },
        "t-body-21": {
          "legal": "<p>Legitieme belangen om het bedrijf in leven te houden</p><p>Naleving van een wettelijke bepaling</p>",
          "personal": "Naam, achternaam, e-mailadres, nummer identiteitsbewijs, adres, informatie over de relatie tot de betreffende bedrijven",
          "purpose": "Uitvoeren van zakelijke deals",
          "subject": "Vertegenwoordigers en medewerkers van betrokken bedrijven",
          "term": "Als er een bedrijf bij betrokken is en tot 10-80 jaar daarna, afhankelijk van de lokale bepalingen"
        },
        "t-body-22": {
          "legal": "Legitieme belangen om de positie van Noda te beschermen",
          "personal": "Persoonsgegevens die nodig zijn voor de oplossing van een conflict of geschil",
          "purpose": "Afhandeling van een conflict",
          "subject": "Alle betrokkenen",
          "term": "Als er een conflict over is ontstaan en tot 10 jaar na de oplossing ervan"
        },
        "t-body-23": {
          "legal": "Naleving van een wettelijke verplichting",
          "personal": "Persoonsgegevens in de documenten waarvoor de verplichting deze te archiveren geldt",
          "purpose": "Archiveren en opslaan van documenten",
          "subject": "Alle betrokkenen",
          "term": "Op basis van lokale vereisten"
        },
        "t-body-2": {
          "legal": "Een contract sluiten en uitvoeren",
          "personal": "Volledige naam, e-mailadres, telefoonnummer, communicatie",
          "purpose": "Online betalingen opzetten en verwerken",
          "subject": "Vertegenwoordigers van zakelijke klanten die de betaaldiensten van Noda gebruiken",
          "term": "Terwijl de Dienst wordt gebruikt en tot 10 jaar na de beëindiging van de levering ervan"
        },
        "t-body-3": {
          "legal": "<p>Een contract sluiten en uitvoeren</p><p>Legitiem belang van Noda om te voldoen aan de bepalingen van de infrastructuur waarop kaartbetalingen worden verwerkt</p>",
          "personal": "Transactiegegevens, kaartnummer, vervaldatum, plaats van betaling, transactiebedrag, frequentie van transacties, gekochte diensten of producten, IP-adres, e-mailadres, aanvullende informatie over de aankoop",
          "purpose": "Diensten op het gebied van de verwerking van kaartbetalingen",
          "subject": "Betalers (natuurlijke personen)",
          "term": "Terwijl de Dienst wordt gebruikt en tot 10 jaar na de beëindiging van de levering ervan"
        },
        "t-body-4": {
          "legal": "Een contract sluiten en uitvoeren",
          "personal": "Volledige naam, e-mailadres, telefoonnummer, aanbieder van bank- of betaaldiensten die wordt vertegenwoordigd",
          "purpose": "Diensten op het gebied van de verwerking van kaartbetalingen",
          "subject": "Vertegenwoordigers van partners",
          "term": "Terwijl de Dienst wordt gebruikt en tot 10 jaar na de beëindiging van de levering ervan"
        },
        "t-body-5": {
          "legal": "<p>Een contract sluiten en uitvoeren</p><p>Naleving van een wettelijke bepaling</p>",
          "personal": "Gegevens bankrekening, e-mailadres en gegevens over compliance zoals hieronder aangegeven",
          "purpose": "Onboarding van verkopers",
          "subject": "Vertegenwoordigers van verkopers, personen die betrokken zijn bij de bedrijfsstructuur van verkopers",
          "term": "Terwijl de samenwerking van kracht is en tot 10 jaar na de beëindiging"
        },
        "t-body-6": {
          "legal": "<p>Legitiem belang om eindgebruikers de mogelijkheid te bieden de Dienst te gebruiken</p><p>Naleving van een wettelijke bepaling</p>",
          "personal": "Volledige naam, geboortedatum, adres, e-mailadres, telefoonnummer, transactiegegevens, intern referentienummer, IBAN, informatie over de gebruikte verkoper, gegevens van de betaling, logbestanden, informatie over opt-out-lijsten",
          "purpose": "Aanbieden van klantenservice",
          "subject": "Betalers (natuurlijke personen)",
          "term": "Wanneer de communicatie plaatsvindt en tot 10 jaar na de oplossing van een probleem"
        },
        "t-body-7": {
          "legal": "<p>De uitvoering van een contract</p><p>Legitiem belang om klanten een kwalitatief hoogwaardige dienst te leveren</p>",
          "personal": "Persoonsgegevens die zijn verstrekt via communicatiekanalen, waaronder een chatbot",
          "purpose": "Diensten op het gebied van zakelijke ondersteuning",
          "subject": "Vertegenwoordigers van zakelijke klanten of partners die de betaaldiensten van Noda gebruiken of samenwerken met Noda",
          "term": "Wanneer de communicatie plaatsvindt en tot 10 jaar na de oplossing van een probleem"
        },
        "t-body-8": {
          "legal": "Legitiem belang om klanten een kwalitatief hoogwaardige dienst te leveren",
          "personal": "Volledige naam, e-mailadres, telefoonnummer",
          "purpose": "De melding van updates",
          "subject": "Vertegenwoordigers en contactpersonen van zakelijke klanten",
          "term": "Tot 10 jaar nadat de melding is verstuurd"
        },
        "t-body-9": {
          "legal": "<p>Naleving van een wettelijke verplichting<p></p>Legitiem belang om een samenwerkingsverband aan te gaan met andere bedrijven</p>",
          "personal": "Identiteitsbewijzen, biometrische afbeeldingen en andere biometrische identificatiegegevens, bron van het geld, informatie van tools die met naleving te maken hebben, adres, energierekening, transactiegeschiedenis, logbestanden, cv's, migratiegegevens en -documenten, politieke status, gegevens bankrekening, gerelateerde websites, gerelateerde bedrijfsstructuur, risicoscore, gegevens over fiscale betalingen",
          "purpose": "Controles van het nakomen van de verplichtingen jegens Noda, voor de onboarding bij partners en het nakomen van de door de partners gestelde verplichtingen, controles van de naleving voor de betalers van verkopers",
          "subject": "Personen in de bedrijfsstructuur van Noda, personen in de structuur van partners en zakelijke klanten, uiteindelijk belanghebbenden, betalers van de verkopers",
          "term": "Van 5 tot 10 jaar na beëindiging van de samenwerking"
        },
        "text": "Afhankelijk van hoe je de Dienst gebruikt en of je er een abonnement op neemt of niet, kunnen we de volgende gegevens van je gebruiken op basis van de onderstaande beschrijving:",
        "text-bottom": "Indien het verstrekken van persoonsgegevens noodzakelijk is om te voldoen aan een wettelijke verplichting of om een overeenkomst te sluiten/uit te voeren, maar u ons de vereiste informatie niet verstrekt, hebben wij het recht om te weigeren de betreffende Dienst te verlenen, een overeenkomst te sluiten of een overeenkomst uit te voeren zonder dat dit negatieve juridische gevolgen heeft.",
        "title": "3. Gegevens die we verzamelen, met welke doeleinden, de juridische basis en de bewaartermijnen"
      },
      "section-4": {
        "list-1": {
          "item-1": "Aanbieders van betaalrekeningen en vergelijkbare diensten (banken, kaartmaatschappijen, enz. (\"<b>Partners</b>\"));",
          "item-2": "Derde partijen en diensten die jij besluit te gebruiken samen met de Dienst (bijvoorbeeld verkoopsites via welke je onze Dienst gebruikt of \"<b>Verkopers</b>\");",
          "item-3": "Onze betrouwbare partners op het gebied van de samenvoeging van gegevens (gelicentieerde Open Banking-platformen);",
          "item-4": "De bedrijven binnen onze groep;",
          "item-5": "Onze dienstverleners op het gebied van boekhouding, audits, gegevensopslag en -verwerking, online communicatie en samenwerking, juridische zaken, screening in het kader van de bestrijding van witwassen en sancties, diensten die fraude aan het licht moeten brengen, databases met bedrijfsgegevens, dienstverleners op het gebied van boekhouding, ontwikkelaars en testers, aanbieders van marketingdiensten, sociale media, e-mailplatformen en anderen.",
          "item-6": "Regelgevende instanties, toezichthoudende autoriteiten, rechtbanken en andere bevoegde openbare of vergelijkbare instanties (zoals de ombudsman, financiële wetsbepalers, toezichthouders op kansspelen);"
        },
        "list-2": {
          "item-1": "Jij of je werkgever;",
          "item-2": "Verkopers;",
          "item-3": "Platformen voor e-commerce, sociale media en zoekmachines;",
          "item-4": "Regelgevende instanties, toezichthoudende autoriteiten, rechtbanken en andere bevoegde openbare of vergelijkbare instanties (zoals de ombudsman, financiële wetsbepalers, toezichthouders op kansspelen);",
          "item-5": "Aanbieders van screeningsdiensten op het gebied van witwassen en sancties, diensten die fraude aan het licht proberen te brengen;",
          "item-6": "Evenementenbedrijven (zoals de organisatoren van congressen, seminars enz.);",
          "item-7": "Beroepsorganisaties;",
          "item-8": "Openbare registers en dienstverleners op het gebied van compliance."
        },
        "text-1": "Om onze Dienst op een effectieve manier te kunnen leveren, moeten we samenwerken met derde partijen, met wie we in sommige gevallen jouw gegevens moeten delen:",
        "text-2": "We krijgen je persoonsgegevens ook van:",
        "title": "4. Ontvangers en bronnen van jouw gegevens"
      },
      "section-5": {
        "text": "Wanneer Noda je persoonsgegevens overdraagt buiten de Europese Unie of de Europese Economische Ruimte, doen we een beroep op de garanties van de geldende juridische bepalingen, zoals de General Data Protection Regulation (GDPR) in de EU (de Algemene verordening gegevensbescherming in Nederland): beslissingen over geschiktheid van de Europese Commissie (Artikel 45 van de GDPR), standaardcontractbepalingen en andere veiligheidsmaatregelen opgelegd door de Artikelen 46 en 49 van de GDPR. Als persoonsgegevens worden overgedragen naar de VS, beroept Noda zich op het betreffende kader inzake de overdracht van persoonsgegevens. In bepaalde gevallen, afhankelijk van welke entiteit van Noda erbij betrokken is, kan Noda zich ook beroepen op het UK International Data Transfer Addendum van de standaardcontractbepalingen van de Europese Commissie.",
        "title": "5. Internationale overdracht van jouw persoonsgegevens"
      },
      "section-6": {
        "list": {
          "item-1": "Het recht om te weten welke gegevens we van je verzamelen en hoe we deze verwerken. Meer informatie hierover vind je in Paragraaf 3.",
          "item-2": "Het recht te verzoeken dat bepaalde gegevens worden gewist. Houd er rekening mee dat we je onze Dienst vanwege een dergelijk verzoek mogelijk niet meer (geheel of gedeeltelijk) kunnen leveren.",
          "item-3": "De verwerking van je persoonsgegevens beperken, niet instemmen met de verwerking ervan of je toestemming daarvoor intrekken, indien van toepassing zonder dat dit gevolgen heeft voor de rechtmatige verwerking ervan op basis van instemming die voorafgaand aan de intrekking is gegeven.",
          "item-4": "Het recht ons geen persoonsgegevens te verstrekken. In dit geval kunnen we je onze Dienst niet, of gedeeltelijk niet leveren."
        },
        "text-1": "Met betrekking tot je persoonsgegevens heb je de volgende rechten:",
        "text-2": "Als je ontevreden bent met de manier waarop we je persoonsgegevens verwerken, kun je een klacht indienen door te mailen naar <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>. Ben je van mening dat we je verzoek niet kunnen verwerken binnen de kaders van de geldende wet, dan kun je daarover een klacht indienen bij de betreffende toezichthoudende autoriteit. Bevind je je in de EU, dan zie je <a href=\"https://www.edpb.europa.eu/about-edpb/about-edpb/members_en\" target=\"_blank\" rel=\"nofollow\">hier</a> welke je moet hebben.",
        "title": "6. Jouw rechten"
      },
      "section-7": {
        "text-1": "Heb je vragen, opmerkingen of klachten over hoe we je persoonsgegevens gebruiken, richt deze dan aan <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "text-2": "Er kunnen naast NAUDAPAY LIMITED ook nog andere partijen zijn die je persoonsgegevens beheren zoals beschreven in dit Privacybeleid.",
        "text-3": "Mail ons voor meer informatie op <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "title": "7. Contactgegevens"
      },
      "section-8": {
        "text": "We kunnen het Privacybeleid van tijd tot tijd wijzigen op basis van veranderingen in wet- en regelgeving of wijzigingen in onze bedrijfsprocedures. Daarom raden we je aan af en toe op deze pagina te kijken of er updates zijn.",
        "title": "8. Wijzigingen aan het Privacybeleid"
      },
      "subtitle": "Over ons gebruik van je gegevens als beheerder",
      "text-1": "Bij Noda.live (\"wij\", \"ons\", \"onze\", \"Noda\"), respecteren we je privacy en zetten we ons in voor de beveiliging van je gegevens. We streven ernaar je zo duidelijk mogelijke informatie te verschaffen over hoe we je gegevens verwerken en hoe je dat kunt controleren. Daarom raden we je met klem aan dit Privacybeleid zorgvuldig door te nemen voordat je de door ons aangeboden diensten (gezamenlijk: \"<b>Dienst</b>\") gaat gebruiken.",
      "text-2": "Heb je verder nog vragen of twijfel je ergens over, stuur dan gerust een mail naar <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>. We staan je graag te woord.",
      "text-3": "Dit Privacybeleid vormt samen met de Gebruiksvoorwaarden de volledige overeenkomst (verder: \"<b>Overeenkomst</b>\") tussen jou en Noda.",
      "text-4": "De voornaamste beheerder van je persoonsgegevens is NAUDAPAY LIMITED, UK, geregistreerd onder nummer 11741664. In afzonderlijke gevallen kunnen andere bedrijven uit onze groep ook optreden als beheerder van je gegevens, zoals beschreven in ons Privacybeleid. Meer informatie en contactgegevens vind je onderaan dit Privacybeleid.",
      "title": "Privacybeleid"
    },
    "privacy-for-candidates": {
      "last-update": "Laatst bijgewerkt op 1 juni 2024",
      "section-1": {
        "text-1": "Noda gebruikt je persoonsgegevens om te zoeken naar iemand die momenteel of in de toekomst een geschikte kandidaat is voor een vacature binnen Noda of gelieerde bedrijven, of om diensten te ontvangen die jij aanbiedt.",
        "text-2": "Als je een individuele externe medewerker bent, mag Noda je persoonsgegevens gebruiken om te controleren of je de geldende wetgeving naleeft (bijvoorbeeld op het gebied van witwassen). Als je de gegevens die Noda daarvoor nodig heeft niet verstrekt, kan Noda mogelijk niet met je samenwerken.",
        "text-3": "Als Noda je een geschikte kandidaat voor een functie, stage of samenwerking vindt, zijn je persoonsgegevens nodig om je een aanbod te doen.",
        "text-4": "Wanneer je een verzoek of klacht indient of als je in een conflict verwikkeld raakt, mag Noda je persoonsgegevens gebruiken om deze situatie op te lossen.",
        "title": "Waarvoor heeft Noda je gegevens nodig?"
      },
      "section-2": {
        "text": "In dit gedeelte beschrijven we welke persoonsgegevens gebruikt worden voor de genoemde doeleinden, op welke juridische basis dat gebeurt en hoe lang we ze mogen bewaren.",
        "title": "Hoe gaat Noda om met mijn gegevens?"
      },
      "section-3": {
        "list": {
          "item-1": "Bedrijven binnen de Noda Group",
          "item-2": "Dienstverleners op het gebied van gegevensopslag",
          "item-3": "Dienstverleners op het gebied van elektronische communicatiediensten (zoals e-mailservices)",
          "item-4": "Recruiters en vergelijkbare dienstverleners, waaronder HR- en recruitmentplatformen",
          "item-5": "LinkedIn en vergelijkbare platformen",
          "item-6": "Dienstverleners op het gebied van compliance",
          "item-7": "Andere externe dienstverleners (zoals consultants of evenementenorganisaties)",
          "item-8": "Regelgevende entiteiten, autoriteiten op het gebied van wetshandhaving, rechtbanken, instellingen op het gebied van arbitrage en andere openbare of particuliere entiteiten."
        },
        "text-1": "Noda ontvangt je persoonsgegevens direct van jou, je LinkedIn-profiel en vergelijkbare platformen, recruiters en headhunters. Treed je op als individuele externe medewerker, dan kan Noda je persoonsgegevens opvragen bij verschillende dienstverleners op het gebied van compliance.",
        "text-2": "Noda mag je persoonsgegevens ook delen met de volgende ontvangers:",
        "title": "Bronnen en ontvangers van gegevens"
      },
      "section-4": {
        "text": "Noda draagt tijdens het wervingsproces doorgaans geen persoonsgegevens over buiten de Europese Unie en de Europese Economische Ruimte. Het kan echter voorkomen dat jij of andere betrokken partijen zich buiten deze gebieden bevinden. Dergelijke overdrachten kunnen bovendien ook plaatsvinden in het kader van nalevingsonderzoek onder afzonderlijke externe medewerkers. In een dergelijk geval doen we een beroep op de garanties van de geldende juridische bepalingen, zoals de General Data Protection Regulation (GDPR) in de EU (de Algemene verordening gegevensbescherming in Nederland): beslissingen over geschiktheid van de Europese Commissie (Artikel 45 van de GDPR), standaardcontractbepalingen en andere veiligheidsmaatregelen opgelegd door de Artikelen 46 en 49 van de GDPR. Als persoonsgegevens worden overgedragen naar de VS, beroept Noda zich op het betreffende kader inzake de overdracht van persoonsgegevens. In bepaalde gevallen, afhankelijk van welke entiteit van Noda erbij betrokken is, kan Noda zich ook beroepen op het UK International Data Transfer Addendum van de standaardcontractbepalingen van de Europese Commissie.",
        "title": "Internationale overdrachten"
      },
      "section-5": {
        "list": {
          "item-1": "je persoonsgegevens in te zien of er een exemplaar van te verstrekken;",
          "item-2": "je persoonsgegevens te wijzigen als deze fouten bevatten;",
          "item-3": "je persoonsgegevens te verwijderen in het geval het legitiem belang van Noda dat niet in de weg staat. Je mag ons niet vragen je gegevens te verwijderen op basis van wettelijke verplichtingen;",
          "item-4": "het gebruik van je persoonsgegevens te weigeren, mits op basis van een legitiem belang;",
          "item-5": "de verwerking van je persoonsgegevens te beperken;",
          "item-6": "een klacht in te dienen bij Noda via de hieronder vermelde contactgegevens. Als Noda je verzoek niet inwilligt, kun je ook een klacht indienen bij de betreffende Autoriteit Persoonsgegevens."
        },
        "text": "Je kunt ons vragen:",
        "title": "Rechten op het gebied van gegevensbescherming"
      },
      "section-6": {
        "text-1": "De beheerder van jouw persoonsgegevens is de entiteit van Noda waarmee je een overeenkomst aangaat, die een kandidaat werft of op zoek is naar een zakelijke partner. Neem voor meer informatie contact op met Noda via het hieronder vermelde e-mailadres.",
        "text-2": "Heb je vragen of verzoeken met betrekking tot je persoonsgegevens, mail ons dan op <a class=\"link highlighted\" href=\"mailto:dpo@noda.live\">dpo@noda.live</a>.",
        "title": "Contactgegevens"
      },
      "subtitle": "Over de Verklaring en Noda",
      "text-1": "In deze verklaring wordt beschreven hoe Noda omgaat met de persoonsgegevens van potentiële werknemers, stagiair(e)s die hebben gesolliciteerd of zijn uitgenodigd om te solliciteren naar openstaande functies bij Noda of om samen te werken met Noda als individuele externe medewerkers.",
      "text-2": "Noda beheert jouw persoonsgegevens. De informatie en contactgegevens van Noda vind je onderaan deze verklaring.",
      "title": "Privacyverklaring voor sollicitanten of samenwerking"
    },
    "retail": {
      "faq": {
        "countries": {
          "content": "We werken samen met 2000+ banken in 28 landen, waaronder Nederland, Portugal, België, Duitsland, Polen, Bulgarije, Frankrijk, Ierland, Italië, Oostenrijk, Spanje, Denemarken, Estland, het Verenigd Koninkrijk, Luxemburg, Roemenië, Litouwen, Hongarije, Letland, Finland, Zweden, Noorwegen, Tsjechië, Slowakije, Griekenland en Slovenië.",
          "title": "In welke landen werkt Noda?"
        },
        "currencies": {
          "content": "Noda ondersteunt verschillende wereldwijde valuta, waaronder EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON en SEK.",
          "title": "Welke valuta ondersteunt Noda?"
        },
        "integration": {
          "content": "Eerst moet je aangemeld zijn bij Noda. Vul gewoon het formulier in en ons verkoopteam neemt binnenkort contact met je op. Wij bieden een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons betalingssysteem voor de detailhandel integreert met API's en front-end componenten, zodat het naadloos opgaat in uw detailhandelsmarkt.",
          "title": "Hoe kan ik Noda integreren in mijn betalingsworkflow?"
        },
        "subtitle": "Uw vragen beantwoord",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verhoog uw detailhandel met Noda's betaalgateway. Focus op strategie terwijl wij transacties stroomlijnen. Ons alles-in-één platform geeft prioriteit aan inzicht in de klant, efficiëntie en groei",
        "title-1": "Betaling Gateway",
        "title-2": "voor Retail met Noda"
      },
      "how-does-it-work": {
        "subtitle": "Technologieën",
        "text-1": "Een betaalgateway verzendt veilig financiële gegevens tussen klanten, winkels en banken. Zie het als een digitale dirigent die elke stap van de creditcardverwerking begeleidt",
        "text-2": "Noda is een wereldwijd betaalplatform en open banking provider. Van veilige gateways tot transactiebeheer en financiële analyses, Noda heeft alles voor u in huis. Ons platform maakt gebruik van AI en machine-learning technologieën om state-of-the-art oplossingen te bieden voor de detailhandel.",
        "title": "Hoe werkt Retail Payment Gateway?"
      },
      "how-to-start": {
        "subtitle": "Eenvoudige onboarding",
        "text": "Noda biedt een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons platform integreert naadloos met API's en front-end componenten, zodat het naadloos aansluit op uw retailplatform. Om te beginnen met het gebruik van Noda, vul het onderstaande formulier in en onze vertegenwoordigers zullen binnenkort contact met u opnemen. Ons team is er om u te helpen bij eventuele wegversperringen",
        "title": "Hoe te beginnen"
      },
      "open-banking": {
        "subtitle": "Veel mogelijkheden",
        "text": "Open banking betekent dat traditionele banken gegevens delen met erkende fintech-bedrijven, zoals Noda, om transacties te stroomlijnen. Ons betalingsecosysteem verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, waardoor retailbetalingen moeiteloos kunnen worden verwerkt.",
        "title": "Wat is Open Banking?"
      },
      "payment-processing": {
        "subtitle": "Beste deals",
        "text": "Stroomlijn in- en uitbetalingen, maak gebruik van intuïtieve UX, slimme routing en bied een verscheidenheid aan populaire betaalmethoden aan",
        "title": "Verwerking van retailbetalingen"
      },
      "payments": {
        "text": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Onze gebruiksvriendelijke en gestroomlijnde API's brengen uw producten moeiteloos op de markt",
        "title": "Toolset voor de detailhandel"
      },
      "scalable-plans": {
        "subtitle": "Meer voordelen",
        "text": "We bieden betaaloplossingen voor de detailhandel voor bedrijven van alle groottes, met schaalbare plannen die beschikbaar zijn om de groei van je bedrijf te ondersteunen",
        "title": "Schaalbare plannen"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Maak gebruik van onze datagedreven inzichten. De tools van Noda bieden kant-en-klare analyses van klantgedrag, inclusief segmentatie- en prognosealgoritmen",
            "title": "AI-gestuurde analyse"
          },
          "banking": {
            "content": "Verbeter de ervaring van klanten en versoepel de transactiestroom met de kracht en veiligheid van open banking-betalingen",
            "title": "Open Bankieren"
          },
          "global-currencies": {
            "content": "Noda werkt met meerdere valuta's om uw klanten over de hele wereld te ondersteunen",
            "title": "Wereldwijde valuta's"
          },
          "security": {
            "content": "Noda biedt een veilige retailgateway, die zorgt voor PCI DSS-naleving, versleuteling en fraudepreventie",
            "title": "Beveiliging"
          }
        },
        "subtitle": "Wat wij bieden",
        "title": "Topfuncties voor de detailhandel"
      }
    },
    "saas": {
      "faq": {
        "countries": {
          "content": "We werken samen met 2000+ banken in 28 landen, waaronder Nederland, Portugal, België, Duitsland, Polen, Bulgarije, Frankrijk, Ierland, Italië, Oostenrijk, Spanje, Denemarken, Estland, het Verenigd Koninkrijk, Luxemburg, Roemenië, Litouwen, Hongarije, Letland, Finland, Zweden, Noorwegen, Tsjechië, Slowakije, Griekenland en Slovenië.",
          "title": "In welke landen werkt Noda?"
        },
        "currencies": {
          "content": "Noda ondersteunt verschillende wereldwijde valuta, waaronder EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON en SEK.",
          "title": "Welke valuta ondersteunt Noda?"
        },
        "how-to-integrate": {
          "content": "Eerst moet je aangemeld zijn bij Noda. Vul gewoon het formulier in en ons verkoopteam neemt binnenkort contact met je op. Wij bieden een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons SaaS-betalingssysteem integreert soepel met API- en front-endcomponenten, zodat het naadloos in je platform past",
          "title": "Hoe kan ik Noda integreren in mijn betalingsworkflow?"
        },
        "subtitle": "uw vragen beantwoord",
        "title": "FAQs"
      },
      "hero": {
        "text": "Verbeter je Software-as-a-Service (SaaS) bedrijf. Zorg voor klanten terwijl wij SaaS-betalingen stroomlijnen. Ons alles-in-één platform geeft prioriteit aan inzicht in de klant, efficiëntie en groei",
        "title-1": "Betalingsgateway",
        "title-gradient-1": "voor SaaS met Noda"
      },
      "how-to-start": {
        "subtitle": "Eenvoudige onboarding",
        "text": "Noda biedt een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons platform integreert naadloos met API- en front-endcomponenten, zodat het naadloos in uw software kan worden geïntegreerd. Om te beginnen met het gebruik van Noda, vul het onderstaande formulier in en onze vertegenwoordigers zullen binnenkort contact met u opnemen. Ons team is er om u te helpen bij eventuele wegversperringen",
        "title": "Hoe te beginnen"
      },
      "open-banking": {
        "subtitle": "Veel mogelijkheden",
        "text": "Open banking betekent dat traditionele banken gegevens delen met gelicentieerde fintech-bedrijven, zoals Noda, om transacties te stroomlijnen. Ons betalingsecosysteem verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, waardoor SaaS-betalingsdiensten moeiteloos kunnen worden verwerkt",
        "title": "Wat is Open Banking?"
      },
      "payments": {
        "text": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Onze gebruiksvriendelijke en gestroomlijnde API's brengen uw producten moeiteloos op de markt",
        "title": "Toolset voor SaaS"
      },
      "technologies": {
        "text-1": "Een betalingsgateway verzendt veilig financiële gegevens tussen klanten, winkeliers en banken.\n      Zie het als een digitale dirigent die elke stap van de SaaS creditcardverwerking begeleidt",
        "text-2": "Noda is een wereldwijd betaalplatform en aanbieder van open bankieren. Van veilige verwerking tot\n      transactiebeheer en financiële analyses, Noda heeft alles voor u in huis. Ons platform gebruikt AI\n      en machine-learning technologieën om state-of-the-art oplossingen te bieden",
        "title": "technologieën",
        "title-1": "Hoe werkt SaaS-betaling",
        "title-2": "Gateway werk?"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Maak gebruik van onze datagestuurde inzichten. De tools van Noda bieden kant-en-klare analyses van klantgedrag, inclusief segmentatie- en voorspellingsalgoritmen",
            "title": "AI-gestuurde analyse"
          },
          "banking": {
            "content": "Verbeter de ervaring van klanten en versoepel de transactiestroom met de kracht en veiligheid van open banking-betalingen",
            "title": "Open Bankieren"
          },
          "global-currencies": {
            "content": "Noda werkt met meerdere valuta's om jouw SaaS-klanten over de hele wereld te ondersteunen",
            "title": "Wereldwijde valuta's"
          },
          "payment-processing": {
            "content": "Stroomlijn in- en uitbetalingen, maak gebruik van intuïtieve UX, slimme routing en bied een verscheidenheid aan populaire betaalmethoden aan",
            "title": "SaaS betalingsverwerking"
          },
          "scalable-plans": {
            "content": "We bieden SaaS-betalingsoplossingen voor alle bedrijfsgroottes, met schaalbare plannen om de groei van je bedrijf te ondersteunen",
            "title": "Schaalbare plannen"
          },
          "security": {
            "content": "Noda biedt een veilige betalingsgateway, die zorgt voor PCI DSS-compliance, versleuteling en fraudepreventie",
            "title": "Beveiliging"
          }
        },
        "subtitle": "onze aanbiedingen",
        "title": "Topfuncties"
      }
    },
    "security": {
      "faq": {
        "contact": {
          "complex-content": {
            "p1": "Mocht je problemen ondervinden met de diensten van Noda, dan raden we je de volgende kanalen aan voor ondersteuning:",
            "p2": "<b>Skype/Telegram Groepschat:</b> We hebben een speciale groepschat opgezet om naadloze communicatie mogelijk te maken. Als u vragen hebt over integratie of technische problemen ondervindt, aarzel dan niet om een bericht naar de groep te sturen en tag ons op",
            "p3": "<b>Persoonlijke manager:</b> Voor vragen die geen betrekking hebben op technische ondersteuning, kun je rechtstreeks contact opnemen met je persoonlijke manager in de groepschat of via een privébericht.",
            "p4": "<b>Ondersteuning per e-mail:</b> Zowel winkeliers als hun klanten kunnen ons bereiken op",
            "p5": "Onthoud dat we altijd voor je klaarstaan!"
          },
          "title": "Ik heb een probleem met de diensten van Noda; met wie kan ik contact opnemen?"
        },
        "knowledge": {
          "complex-content": {
            "l1": "<b>Veiligheid op bankniveau:</b> Open banking maakt gebruik van streng geteste software en beveiligingssystemen. Consumenten zijn nooit verplicht om hun inloggegevens of wachtwoorden te delen met iemand anders dan hun eigen bank.",
            "l2": "<b>Regelgeving:</b> Alleen apps en websites die gereguleerd zijn door de Britse Financial Conduct Authority (FCA) of gelijkwaardige instellingen in Europa mogen open banking gebruiken.",
            "l3": "<b>Controle over gegevens:</b> Klanten hebben de macht om te beslissen wanneer en hoe lang ze hun gegevens delen. Ze kunnen deze toegang ook op elk moment weer intrekken via hun bank.",
            "p1": "Open banking is ontworpen met een sterke focus op beveiliging, zodat het volledig veilig is voor uw klanten. Hier zijn enkele van de belangrijkste beveiligingsfuncties:"
          },
          "title": "Hoe weet ik dat open bankieren veilig is?"
        },
        "safe": {
          "content": "Ja, Noda is betrouwbaar. Duizenden eindklanten vertrouwen erop dat Noda veilig betalingen uitvoert via hun gekozen banken, waar ze hun geld met vertrouwen bewaren. Noda deelt nooit klantgegevens zonder hun uitdrukkelijke goedkeuring. Daarnaast doen we er alles aan om hun gegevens op elk moment te beschermen.",
          "title": "Is Noda betrouwbaar?"
        },
        "secure": {
          "content": "Ja, Noda is veilig. Zoals eerder vermeld, is Noda niet alleen ontworpen om veilig te zijn, maar ook om continu zijn beveiligingsniveaus te monitoren. We gebruiken een gelaagde aanpak om de risico's van hacking en datalekken aanzienlijk te verminderen. Bijvoorbeeld, we gebruiken toonaangevende encryptieprotocollen, top-tier cloud infrastructuurproviders, multi-factor authenticatie, en voeren 24 uur per dag uitgebreide monitoring van onze diensten uit.",
          "title": "Is Noda veilig?"
        },
        "test": {
          "complex-content": {
            "l1-1": "Rekeningnummer",
            "l1-2": "Volledige naam",
            "l2-1": "Identiteitsgegevens",
            "l2-2": "Rekeningsaldi",
            "l2-3": "Transactiegeschiedenis van 90 dagen",
            "p1": "Noda is zowel een Payment Initiation Service Provider (PISP) als een Account Information Services Provider (AISP). In het eerste geval bieden we uw klant Payment Initiation Services (PIS). Wat dit in essentie betekent, is dat Noda het betalingsproces voor uw klanten faciliteert door geld direct over te maken van hun gekoppelde betaalrekening(en) naar de gekozen begunstigde na hun expliciete toestemming. In dit geval heeft Noda toegang tot de volgende gegevens:",
            "p2": "Bijgevolg kunnen deze gegevens worden gebruikt als invoerwaarden voor de interne algoritmen van Noda en kunnen ze worden gedeeld met handelaren om te bevestigen dat de betaling succesvol was.",
            "p3": "In het tweede geval stelt de Account Information Service (AIS) Noda in staat om informatie over alle online bankrekeningen op één plek in te zien en te raadplegen en de financiële informatie van uw klanten te analyseren als zij daarvoor toestemming geven. In dit geval heeft Noda toegang tot de volgende gegevens:",
            "p4": "Deze gegevens kunnen dus worden gebruikt om de interne algoritmen van Noda te verbeteren. Ze kunnen ook in geaggregeerde vorm worden gedeeld met winkeliers, bijvoorbeeld als een score die aangeeft met welke betaalcategorie een gebruiker wordt geïdentificeerd (van 1 tot 5)."
          },
          "title": "Welke gegevens kan Noda inzien en delen?"
        }
      },
      "hero": {
        "desc-1": "De beveiliging van betalingen en gegevens moet altijd een prioriteit zijn. Op deze pagina vindt u gedetailleerde informatie over onze veiligheidsmaatregelen en onze aanpak voor het verwerken en delen van uw gegevens.",
        "desc-2": "We geven een overzicht van onze beveiligingsfuncties en onze toewijding aan gegevensprivacy. Daarnaast bieden we inzicht in onze licenties en het beheer van gegevens in verschillende licenties.",
        "title": "Beveiliging en gegevensver&shy;werking"
      },
      "strategy": {
        "alert": {
          "text": "Met onze geautomatiseerde waarschuwingssystemen kunnen we direct reageren op bedreigingen die 's nachts, in het weekend, op feestdagen of tijdens andere niet-werkuren plaatsvinden.",
          "title": "Geautomatiseerd waarschuwingssysteem"
        },
        "bug-bounty": {
          "text": "<p class=\"paragraph\">Ons bug bounty programma verwelkomt alle ontwikkelaars die zich identificeren als hackers. Als u of uw collega's gebreken, tekortkomingen of kwetsbaarheden ontdekken in onze beveiligingssystemen of suggesties hebben om de functionaliteit van Noda API endpoints te verbeteren, kunt u deelnemen aan ons programma en een beloning ontvangen.</p><p class=\"paragraph\"> Om een probleem te melden of een suggestie te doen, stuurt u een e-mail naar ons beveiligingsteam op <a class=\"link\" href=\"mailto:security@noda.live\">security@noda.live</a>.</p>",
          "title": "Bug Bounty-programma"
        },
        "certification": {
          "text": "<p class=\"paragraph\">Noda behaalt regelmatig relevante certificeringen en houdt de PCI DSS en PCI SSLC licenties up-to-date. De Payment Card Industry Data Security Standard (PCI DSS) is de benchmark in de sector die gericht is op het terugdringen van betalingsfraude door de controle op gegevensbescherming te verbeteren.</p><p class=\"paragraph\"> Ondertussen zorgt de PCI Secure Software Lifecycle Standard (PCI SLLC) ervoor dat verkopers van betaalsoftware beveiliging inbouwen in de gehele levenscyclus van de softwareontwikkeling, waardoor toepassingen worden geproduceerd die veilig zijn door het ontwerp en robuust zijn tegen aanvallen. Deze licenties worden beheerd door de PCI Security Standards Council (PCI SSC).</p>",
          "title": "Certificering"
        },
        "cloud": {
          "text": "<p class=\"paragraph\">Noda gebruikt cloud-infrastructuur om onze applicaties en diensten te bouwen. Moderne leveranciers van clouddiensten behoren tot de best beveiligde ter wereld en investeren miljoenen dollars om de hoogste veiligheidsnormen te garanderen. Bovendien upgraden en verfijnen ze hun systemen voortdurend om ze nog ondoordringbaarder en veiliger te maken.</p><p class=\"paragraph\"> Het werken met bekende wereldwijde leveranciers van cloudinfrastructuurbeveiliging is de belangrijkste factor voor het opbouwen van Noda's informatiebeveiligingsprogramma.</p>",
          "title": "Gebruik van cloudinfrastructuurproviders"
        },
        "encryption": {
          "text": "<p class=\"paragraph\">Noda versleutelt alle gevoelige gegevens tegelijkertijd op twee lagen. We gebruiken het Transport Layer Security (TLS) protocol wanneer informatie wordt overgedragen tussen netwerkservers, en we passen de Advanced Encryption Standard (AES) toe wanneer de gegevens worden opgeslagen.</p><p class=\"paragraph\"> Door gebruik te maken van deze tweelaagse encryptiebenadering kunnen we potentiële veiligheidsrisico's minimaliseren, omdat gevoelige gegevens versleuteld blijven, zelfs in die zeldzame gevallen dat een van de componenten gecompromitteerd is.</p>",
          "title": "Aanpak voor gegevenscodering"
        },
        "mfa": {
          "text": "<p class=\"paragraph\">Bij Noda begrijpen we dat het bereiken van maximale informatiebeveiliging vraagt om aandacht voor zowel externe als interne omgevingen. Daarom implementeren we Multi-Factor Authenticatie (MFA) voor onze medewerkers om toegang te krijgen tot alle kritieke interne platforms.</p><p class=\"paragraph\"> MFA voegt een extra authenticatielaag toe, die ongeautoriseerde toegang tot gegevens via interne systemen helpt voorkomen.</p>",
          "title": "MFA"
        },
        "monitoring": {
          "text": "<p class=\"paragraph\">Alle onderdelen van de producten van Noda, inclusief de Noda API, worden voortdurend bewaakt en geïnspecteerd door ons IT-beveiligingsteam.</p><p class=\"paragraph\"> Dit team bestaat uit IT-experts die regelmatig professionele conferenties bijwonen en zich bezighouden met permanente educatie binnen hun vakgebied.</p>",
          "title": "Team Toezicht Informatiebeveiliging"
        },
        "support": {
          "text": "Noda's ondersteuningsteam lost 24 uur per dag connectiviteitsproblemen voor specifieke klanten snel op en verzamelt ook suggesties voor het verbeteren van Noda's systemen. We zijn er altijd en staan klaar om te helpen.",
          "title": "24/7 technische ondersteuning"
        },
        "text": "De strategie van Noda voor het opbouwen van een informatiebeveiligingsprogramma omvat een tweeledige aanpak. Ten eerste richten we ons op robuuste beveiliging van onze eigen systemen en servers. Ten tweede implementeren we een meerlaagse beveiligingsaanpak om het hoogste niveau van veiligheid te garanderen voor zowel uw gegevens als de gegevens van uw klanten. Hieronder vindt u de belangrijkste kenmerken van ons beveiligingsprogramma.",
        "title": "Noda Beveiliging"
      }
    },
    "tabs": {
      "banner": {
        "account-balances": "Rekeningsaldi",
        "account-number": "Rekeningnummer",
        "full-name": "Volledige naam",
        "identity-information": "Identiteitsgegevens",
        "text": "Met toestemming van de klant kan Noda de volgende gegevens in haar algoritmen gebruiken:",
        "title": "Soorten gegevens die uw klanten kunnen delen met Noda",
        "transaction-history": "Transactiegeschiedenis voor 90 dagen"
      },
      "tab-step-text": {
        "after-the-confirmation": "Na de bevestiging ontvangt Noda het rekeningnummer van de gebruiker en het bedrag en de valuta van de betaling.",
        "after-the-consent": "Na de toestemming heeft Noda toegang tot hun financiële rekening en sommige van hun financiële gegevens.",
        "consequently-this-data": "Bijgevolg kunnen deze gegevens worden gebruikt als invoerwaarden voor de interne algoritmen van Noda en kunnen ze worden gedeeld met handelaren om te bevestigen dat de betaling succesvol was.",
        "consequently-this-data-form": "Deze gegevens kunnen dus worden gebruikt om de interne algoritmen van Noda te verbeteren. Ze kunnen ook in geaggregeerde vorm worden gedeeld met winkeliers, bijvoorbeeld als een score die aangeeft met welke betaalcategorie een gebruiker wordt geïdentificeerd (van 1 tot 5).",
        "the-buyer-initiates": "De koper initieert de betaling en voltooit de verificatie door de bank van zijn keuze.",
        "when-the-authentication": "Wanneer de authenticatie door de bank is afgerond, vraagt de bank om een bevestiging van de transactie.",
        "when-the-authentication-consent": "Wanneer de authenticatie door de bank is afgerond, vraagt de bank hen om toestemming dat Noda toegang krijgt tot hun financiële en profielgegevens."
      },
      "tab-title": {
        "automated-access": "Geautomatiseerde toegang tot het IBAN van een gebruiker via autorisatie rechtstreeks door de bank",
        "insert-iban": "IBAN invoeren voor handmatige betaling"
      },
      "tag-subtitle": "TECH VRIENDELIJK",
      "text": "Bij Noda geven we om jouw klanten en verwerken we hun gegevens met de grootst mogelijke zorg. Dit is wat er gebeurt als jouw klanten een betaling doen of aan boord gaan via onze diensten.",
      "title": "Noda verwerkt<br/>de gegevens van uw klanten"
    },
    "terms": {
      "last-update": "Laatst bijgewerkt op <data>23 augustus 2024</data>",
      "section-1": {
        "text-1": "Deze Gebruiksvoorwaarden dienen als een juridisch bindend contract tussen de Gebruiker (\"Jij\", \"Gebruiker\", \"Klant\") en Noda, daarom raden wij je aan het document zorgvuldig door te lezen. De Gebruiksvoorwaarden vormen samen met het Privacybeleid de volledige overeenkomst (verder: \"Overeenkomst\") tussen jou en Noda. Alle diensten die hieronder worden beschreven zijn de diensten die worden geleverd door Noda en zullen gezamenlijk worden aangeduid als de \"Dienst\". Door gebruik te maken van de Dienst, erken je dat je akkoord gaat en gebonden bent aan de voorwaarden in de Overeenkomst. Je kunt deze Gebruiksvoorwaarden altijd inzien op onze website <a href=\"https://noda.live\">https://noda.live.</a>",
        "text-2": "Noda verleent jou een beperkte, herroepbare, niet-exclusieve, niet-overdraagbare licentie voor toegang tot en gebruik van de Dienst voor je eigen individuele gebruik, onderhevig aan de overige bepalingen van deze Gebruiksvoorwaarden. Alle rechten, aansprakelijkheden en belangen in en op de Dienst die hierin niet uitdrukkelijk worden verleend, zijn voorbehouden aan Noda.",
        "text-3": "De Overeenkomst wordt gesloten voor onbepaalde tijd.",
        "text-4": "Wij kunnen van tijd tot tijd wijzigingen en aanpassingen aanbrengen in de Gebruiksvoorwaarden. Indien je niet akkoord gaat met enige bepalingen van de Overeenkomst, stellen wij je voor het gebruik van de Dienst te staken en deze Gebruiksvoorwaarden kosteloos te beëindigen.",
        "text-5": "Deze Gebruiksvoorwaarden zijn opgesteld in het Engels en de belangrijkste communicatie vindt doorgaans plaats in het Engels.",
        "text-6": "Zolang de Overeenkomst van kracht is, heb je te allen tijde het recht om deze Gebruiksvoorwaarden op verzoek te ontvangen.",
        "title": "1. De overeenkomst"
      },
      "section-2": {
        "list-1": {
          "item-1": "een referentie waarmee je elke betalingstransactie en, indien van toepassing, de begunstigde kunt identificeren;",
          "item-2": "het bedrag van de betalingstransactie in de valuta waarin het geld is afgeschreven van je Betaalrekening of in de valuta die voor de betalingsopdracht is gebruikt;",
          "item-3": "indien van toepassing, de bij de betalingstransactie toegepaste wisselkoers en het bedrag van de betalingstransactie na die valutawissel;",
          "item-4": "de valutadatum van de afschrijving of de datum van ontvangst van de betalingsopdracht."
        },
        "list-2": {
          "item-1": "De Dienst voldoet aan je eisen;",
          "item-2": "De Dienst ononderbroken, tijdig, veilig of vrij van fouten blijft werken;",
          "item-3": "De resultaten die kunnen worden verkregen uit het gebruik van de Dienst nauwkeurig of betrouwbaar zullen zijn;",
          "item-4": "De kwaliteit van producten, diensten, informatie of ander materiaal dat je via de Dienst aanschaft of verkrijgt aan jouw verwachtingen voldoet; of",
          "item-5": "Eventuele technische fouten zullen worden gecorrigeerd."
        },
        "text-1": {
          "line-1": "In het kader van deze overeenkomst tussen jou en ons treedt Noda op als zowel een Payment Initiation Service Provider (PISP) als een Account Information Services Provider (AISP) en bieden we je Payment Initiation Services (PIS) en Account Information Services (AIS). Wat dit in essentie betekent, is dat we het betalingsproces voor je faciliteren door een transactie te initiëren direct vanuit je gekoppelde betaalrekening(en), op basis van je gekozen begunstigde na diens expliciete toestemming en dat we je de gegevens van deze transactie presenteren op je gekoppelde Betaalrekening(en).",
          "line-2": "Nadat je een aanbieder van betaalrekeningen of bankrekeningen (beide verder afzonderlijk aangeduid als een \"Partner\") hebt geselecteerd die je wilt koppelen en/of waarvan je een betaling wilt doen, dan word je doorgestuurd naar diens officiële pagina (in de app of in een browser) waarop je een verificatieproces moet doorlopen.",
          "line-3": "Als AISP geven we je toestemming de informatie over al je online bankrekeningen op één plek in te zien en te raadplegen en je financiële informatie te analyseren, zodat je een beter inzicht krijgt in hoe je je geld uitgeeft, spaart, leent en bijhoudt.",
          "line-4": "Noda levert geen bank- en betaalrekeningdiensten. Dus, de door jou gekozen aanbieder van betaalrekeningen is als enige verantwoordelijk voor de uitvoering van betalingen en eventuele gebreken in de functionaliteit van zijn diensten. Desalniettemin, als wij van mening zijn dat het ons ontbreekt aan toestemming of om welke reden dan ook het leveren van onze diensten aan jou onwettig zou zijn, kunnen wij ervoor kiezen om de Dienst niet aan je te leveren.",
          "line-5": "Binnen de reikwijdte van deze Overeenkomst en binnen de grenzen die jij ons toestaat, zullen wij de gegevens van je Betaalrekening delen met andere diensten en derden van jouw keuze. Zodra een dergelijke partner toegang krijgt tot je gegevens, wordt deze daar automatisch verantwoordelijk voor en valt de informatie onder jouw overeenkomst met de desbetreffende partner en diens privacybeleid.",
          "line-6": "Wij hebben alleen toegang tot de Betaalrekeningen die je koppelt als je daar toestemming voor geeft en zien deze eventueel alleen in in het kader van de Dienst die wij verlenen.",
          "line-7": "Je kunt eisen dat de volgende informatie periodiek, ten minste eenmaal per maand, kosteloos wordt verstrekt of beschikbaar wordt gesteld:"
        },
        "text-2": "De Dienst wordt geleverd \"zoals deze is\" en op basis van \"zoals beschikbaar\". Wij geven geen garantie dat:",
        "text-3": "Zodra je de betaling hebt geïnitieerd, de initiatie onmiddellijk wordt verzonden. Zodra je de betaling hebt geautoriseerd bij je bank, kun je deze niet meer annuleren. Het geld verlaat je betaalrekening meestal binnen 2 (twee) uur na de succesvolle initiatie, hoewel het langer kan duren, afhankelijk van hoe lang je bank nodig heeft om de betalingsopdracht uit te voeren. Wij bevestigen de succesvolle initiatie van de betalingsopdracht. Maar het is jouw bank (niet Noda) die verantwoordelijk is voor de uitvoering.",
        "title": "2. Diensten die we leveren"
      },
      "section-3": {
        "list": {
          "item-1": "Je minimaal 18 jaar oud bent en juridisch beschouwd de capaciteit en bevoegdheid hebt een overeenkomst aan te gaan",
          "item-10": "Je mag de Dienst niet decompileren of demonteren, of deze gebruiken anders dan in overeenstemming met de bepalingen in deze Overeenkomst;",
          "item-11": "Je mag de Dienst niet gebruiken met als doel concurrerende producten of diensten te leveren.",
          "item-12": "Elk verboden gebruik leidt direct tot de beëindiging van je licentie tot de Dienst.",
          "item-2": "Je de Dienst op individuele basis en alleen voor privédoeleinden gebruikt;",
          "item-3": "Je de Dienst niet voor het plegen van fraude gebruikt;",
          "item-4": "Je de Diensten niet voor andere onwettige doeleinden gebruikt;",
          "item-5": "Je instemt met ons <a href=\"https://noda.live/about/legal-privacy/policy\">Privacybeleid;</a>",
          "item-6": "Je verantwoordelijk bent voor het veilig bewaren van je inloggegevens;",
          "item-7": "Je mag je inloggegevens niet delen met derden. Voor zover toegestaan door de toepasselijke wetgeving, ben je aansprakelijk voor alle kosten en redelijke advocatenhonoraria voor je nalatigheid om je inloggegevens te beschermen en/of het tijdig inlichten van Noda over ongeoorloofd gebruik van je Betaalrekening of een andere rekening of het feit dat de gegevens of het wachtwoord van je Betaalrekening (of een andere rekening) in verkeerde handen terecht gekomen is.",
          "item-8": "Je mag geen valse of gestolen identiteit gebruiken. Je verklaart en garandeert dat alle informatie die je verstrekt in het kader van deze Overeenkomst waar en nauwkeurig is;",
          "item-9": "Je mag de rechten op het gebruik van de Dienst niet doorverkopen of anderszins overdragen;"
        },
        "text-1": "Door de door ons geleverde diensten te gebruiken, verklaar je en bevestig je dat je:",
        "text-2": {
          "line-1": "In het geval dat je je bewust wordt van verlies, diefstal, verduistering of onbevoegd gebruik van onze Dienst of een deel daarvan, fraude doordat iemand zich anders voordoet, ongeautoriseerde of onjuist geïnitieerde of uitgevoerde betalingstransacties of van een geautoriseerde overboeking die is uitgevoerd na een onjuiste toepassing van de verificatieservice voor het matchen van namen en unieke identificatoren, neem dan zo snel mogelijk, maar niet later dan binnen 5 werkdagen contact met ons op via <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>. Overweeg ook om de politie in te lichten, vooral in het geval van oplichting en andere transacties die zonder je toestemming in jouw naam zijn uitgevoerd. In het geval van dergelijke gebeurtenissen ben je ook aansprakelijk en verantwoordelijk voor het nemen van maatregelen om je gegevens te beveiligen.",
          "line-2": "Als je ons niet op de hoogte stelt van een ongeautoriseerde of onjuist uitgevoerde transactie, heb je mogelijk geen recht op een vergoeding voor een dergelijke ongeautoriseerde of onjuist uitgevoerde transactie.",
          "line-3": "In het geval dat wij van mening zijn dat er sprake is van een werkelijke of vermoede fraude of ernstige bedreiging van de veiligheid, zullen wij contact met je opnemen via de contactgegevens die je tijdens het gebruik van onze Dienst hebt verstrekt."
        },
        "title": "3. Toegang tot de service en communicatie over verdachte activiteiten"
      },
      "section-4": {
        "text": {
          "line-1": "Om volledige toegang tot de Dienst te hebben, moet je de banken of andere aanbieders van Betaalrekeningen kiezen waarmee je verbinding wilt maken of die je ons wilt machtigen om betalingen te verrichten. Zodra je een Partner hebt gekozen, leiden wij je door naar de webpagina van die Partner waar je door een beveiligd proces wordt geleid om toegang te krijgen tot informatie van je Betaalrekeningen (hier en elders in de Overeenkomst verwijst \"Betaalrekening\" naar een rekening die is aangemaakt bij een Partner). Je wordt gevraagd ons je uitdrukkelijke toestemming te geven om toegang te krijgen tot je financiële gegevens.",
          "line-2": "Om toegang te krijgen tot de Dienst dien je ons de informatie te verstrekken waarnaar wordt verwezen in het Privacybeleid. De unieke identificatie die wordt gebruikt om ervoor te zorgen dat een betalingsopdracht correct wordt geïnitieerd en uitgevoerd, is je e-mailadres of IBAN of Identificatiecode van betaling of klantnummer of betalingsreferentie, afhankelijk van elk specifiek geval. Als je ons een onjuiste of verkeerde identificatiecode verstrekt, kunnen wij kosten in rekening brengen voor het terugvorderen van de fondsen die betrokken zijn bij de betreffende betalingstransactie.",
          "line-3": "Je stemt ermee in dat je Noda een niet-exclusieve, royaltyvrije licentie verleent om de gegevens op je Betaalrekeningen te gebruiken voor alle doeleinden die verband houden met de Dienst of waarnaar in deze Overeenkomst wordt verwezen, met het recht om dergelijke informatie te gebruiken, te wijzigen, weer te geven, te distribueren en nieuw materiaal te creëren met behulp van of waarin dergelijke informatie is opgenomen om de Dienst aan jou te leveren. Wij garanderen dat wij je gegevens niet voor andere doeleinden zullen gebruiken of openen, tenzij de wet anders voorschrijft. Om je gegevens veilig en je toestemming up-to-date te houden, kunnen wij je periodiek vragen om je toestemming te vernieuwen.",
          "line-4": "Je stemt ermee in dat wanneer wij de gegevens op je betaalrekening of de informatie die nodig is als onderdeel van de levering van de Dienst opvragen, wij dit doen als jouw vertegenwoordiger en namens jou en niet namens of in naam van een derde.",
          "line-5": "Door gebruik te maken van de Dienst, verklaar je dat jij de wettige eigenaar bent van de gegevens op je betaalrekeningen en dat je de bevoegdheid hebt om ons en/of onze derden-aanbieders aan te wijzen als je vertegenwoordiger en een beperkte volmacht te verlenen om namens jou toegang te krijgen tot dergelijke gegevens en deze op te vragen, en dit ook uitdrukkelijk doet.",
          "line-6": "Voor onze nalevingsdoeleinden en om de Dienst aan jou te kunnen verlenen, machtig je ons hierbij om, rechtstreeks of via een derde, de informatie en documentatie te verkrijgen, te verifiëren en bij te houden die ons helpt om je identiteit en de gegevens op je betaalrekening te verifiëren. Wanneer je je registreert voor de Dienst en van tijd tot tijd daarna, kunnen wij je vragen om informatie en documenten te verstrekken en/of te bevestigen waarmee wij je kunnen identificeren."
        },
        "title": "4. Onze toegang tot je gegevens"
      },
      "section-5": {
        "list": {
          "item-1": "je recht om de Service te gebruiken tijdelijk of definitief in te trekken;",
          "item-2": "je een waarschuwing geven;",
          "item-3": "een gerechtelijke procedure tegen jou starten voor de vergoeding van alle kosten (inclusief, maar niet beperkt tot, redelijke administratieve en juridische kosten) als gevolg van de schending;",
          "item-4": "verdere juridische stappen tegen jou ondernemen; en/of",
          "item-5": "verzoeken om openbaarmaking van dergelijke informatie aan wetshandhavingsinstanties als wij dat redelijkerwijs noodzakelijk achten."
        },
        "text-1": {
          "line-1": "Het staat je te allen tijde vrij om een aan ons gegeven toestemming in te trekken door ons te mailen op <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live.</a>",
          "line-2": "Wij kunnen naar eigen goeddunken beoordelen en vaststellen of er sprake is van een schending van deze Overeenkomst door jouw gebruik van de Dienst. Wanneer een dergelijke schending heeft plaatsgevonden, kunnen wij de maatregelen nemen die wij passend achten, met inbegrip van alle of een van de volgende acties:"
        },
        "text-2": {
          "line-1": "De hierboven beschreven reacties zijn niet beperkt en we kunnen elke andere actie ondernemen die we redelijkerwijs passend achten en die niet in strijd is met de toepasselijke wetgeving.",
          "line-2": "We hebben ook het recht om de Dienst op elk moment te blokkeren om objectief gerechtvaardigde redenen met betrekking tot de veiligheid ervan, of het vermoeden van ongeautoriseerd of frauduleus gebruik ervan.",
          "line-3": "We kunnen ervoor kiezen om je registratie te weigeren of een bestaande registratie om een andere reden naar eigen goeddunken te beëindigen."
        },
        "title": "5. Beëindiging en opschorting"
      },
      "section-6": {
        "text": {
          "line-1": "Je gaat ermee akkoord om Noda en onze dochterondernemingen te beschermen tegen en volledig te compenseren voor alle claims van derden, aansprakelijkheid, schade, uitgaven en kosten (inclusief, maar niet beperkt tot, redelijke advocaatkosten) veroorzaakt door of voortvloeiend uit je gebruik van de Dienst, je schending van deze Overeenkomst of je inbreuk, of inbreuk door een andere gebruiker van je account, op enig intellectueel eigendomsrecht of ander recht van wie dan ook.",
          "line-2": "Wij zijn jegens jou niet aansprakelijk voor enige tekortkoming of vertraging in de nakoming van onze verplichtingen onder deze Overeenkomst, voor zover een dergelijke tekortkoming of vertraging is veroorzaakt of mede is veroorzaakt door jou of door een gebeurtenis of omstandigheid buiten onze redelijke controle, inclusief in het geval van het verstrekken van een onjuiste unieke identificatiecode.",
          "line-3": "IN GEEN GEVAL ZULLEN NODA, HAAR FUNCTIONARISSEN, DIRECTEUREN, AGENTEN, FILIALEN, WERKNEMERS, ADVERTEERDERS OF LEVERANCIERS AANSPRAKELIJK ZIJN VOOR ENIGE INDIRECTE, INCIDENTELE SCHADE, GEVOLGSCHADE OF SCHADEVERGOEDING MET EEN PUNITIEF KARAKTER, INCLUSIEF, MAAR NIET BEPERKT TOT, VERLIES VAN GEBRUIK, WINSTDERVING OF VERLIES VAN GEGEVENS, HETZIJ IN EEN CONTRACTUELE PROCEDURE, ONRECHTMATIGE DAAD (INCLUSIEF, MAAR NIET BEPERKT TOT NALATIGHEID), BILLIJKHEID OF ANDERSZINS, OF VOOR SCHADE IN HET TOTAAL HOGER DAN HET BEDRAG VAN DE BETALING DIE DEFECT OF ZONDER AUTORISATIE WERD UITGEVOERD, WAT RESULTEERDE IN HET VERLIES VAN DE BEDRAGEN DIE BINNEN DE BETREFFENDE BETALING WERDEN OVERGEDRAGEN.",
          "line-4": "Wij zijn aansprakelijk jegens jou voor de correcte uitvoering van de betalingstransactie, tenzij we aan jou en, indien relevant, aan de aanbieder van betalingsdiensten van de begunstigde kunnen bewijzen dat deze het bedrag van de betalingstransactie heeft ontvangen en tenzij we redelijke gronden hebben om te vermoeden dat jij fraude pleegt."
        },
        "title": "6. Schadeloosstelling en aansprakelijkheid"
      },
      "section-7": {
        "text": {
          "line-1": "Wij vragen je vriendelijk om je zorgen en klachten rechtstreeks aan ons te richten via <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> en wij zullen je altijd zo goed mogelijk helpen. Mocht je uiteindelijk niet tevreden zijn met ons antwoord of met de algehele dienstverlening, dan heb je het recht om je klacht voor te leggen aan de Britse Financial Ombudsman Service: <a target=\"_blank\" rel=\"nofollow\" href=\"https://www.financial-ombudsman.org.uk/\">https://www.financial-ombudsman.org.uk/</a>. De toezichthoudende autoriteit met betrekking tot onze activiteiten in het Verenigd Koninkrijk is de Financial Conduct Authority: <a href=\"https://www.fca.org.uk/\" target=\"_blank\" rel=\"nofollow\">https://www.fca.org.uk/.",
          "line-2": "Andere landen hebben andere regelgevende instanties en hebben mogelijk andere oplossingen voor alternatieve geschillenbeslechting. Neem voor meer informatie contact met ons op via <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>.",
          "line-3": "Als je klacht gaat over hoe wij jouw persoonsgegevens opslaan of verwerken, raadpleeg dan ons <a href=\"https://noda.live/about/legal-privacy/policy\">Privacybeleid</a>."
        },
        "title": "7. Klachten"
      },
      "section-8": {
        "text": {
          "line-1": "Op deze Overeenkomst is het recht van het Verenigd Koninkrijk van toepassing. Als een rechtbank beslist dat Wij ons niet kunnen beroepen op een deel van deze Overeenkomst, blijft de rest van de Overeenkomst van kracht, aangezien elk van de bepalingen van deze Overeenkomst afzonderlijk werkt.",
          "line-2": "Als een bepaling van deze Overeenkomst om welke reden dan ook ongeldig wordt bevonden, heeft de ongeldigheid van die bepaling geen invloed op de overige bepalingen van de Overeenkomst, die volledig van kracht blijven."
        },
        "title": "8. Algemene bepalingen"
      },
      "subtitle": "Bedrijfsgegevens",
      "text-1": "Wij zijn Naudapay Limited aka \"Noda\" (\"Noda\", \"Wij\", \"Ons\", \"Onze\"), een bedrijf geregistreerd in het Verenigd Koninkrijk onder het bedrijfsnummer 11741664 en ons hoofdkantoor is gevestigd op 162 Buckingham Palace Road, London, SW1W 9TR, UNITED KINGDOM. Wij beheren de Website <a href=\"https://noda.live\">https://noda.live</a> en de diensten die beschikbaar zijn via onze toepassingen en oplossingen onder onze merknaam Noda. Het contactkantoor in de EU is in Spanje (Calle Huertas 11, 28012, Madrid, Spanje).",
      "text-2": "Naudapay Limited is geregistreerd bij de Financial Conduct Authority onder de Payment Services Regulations 2017 voor het aanbieden van betaaldiensten. Referentie 832969.",
      "text-3": "Stuur gerust een mail naar <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> als je vragen hebt. Je kunt ook via de helpwidget in onze app contact met ons opnemen.",
      "title": "Gebruiksvoorwa&shy;arden"
    },
    "travel": {
      "faq": {
        "countries": {
          "content": "We werken samen met 2000+ banken in 28 landen, waaronder Nederland, Portugal, België, Duitsland, Polen, Bulgarije, Frankrijk, Ierland, Italië, Oostenrijk, Spanje, Denemarken, Estland, het Verenigd Koninkrijk, Luxemburg, Roemenië, Litouwen, Hongarije, Letland, Finland, Zweden, Noorwegen, Tsjechië, Slowakije, Griekenland en Slovenië.",
          "title": "In welke landen werkt Noda?"
        },
        "currencies": {
          "content": "Noda ondersteunt verschillende wereldwijde valuta, waaronder EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON en SEK.",
          "title": "Welke valuta ondersteunt Noda?"
        },
        "easy-to-start": {
          "content": "Ja. Ons supportteam is er om je te helpen bij eventuele obstakels. We bieden een soepele integratie, zodat je snel en gemakkelijk betalingen kunt accepteren.",
          "title": "Is het makkelijk om online betalingen te accepteren met Noda?"
        },
        "how-to-integrate": {
          "content": "Eerst moet je aangemeld zijn bij Noda. Vul gewoon het formulier in en ons verkoopteam neemt binnenkort contact met je op. Wij bieden een eenvoudige onboarding met de persoonlijke begeleiding van een toegewijde manager. Onze processor integreert naadloos met API- en front-endcomponenten, waardoor een naadloze integratie in uw platform gegarandeerd is.",
          "title": "Hoe kan ik Noda integreren in mijn betalingsworkflow?"
        },
        "kind-of-travel-business": {
          "content": "Noda biedt betaaloplossingen voor de reisbranche voor alle soorten en maten bedrijven, met schaalbare plannen om de groei van uw bedrijf te ondersteunen.",
          "title": "Met wat voor soort reisorganisaties werk je?"
        },
        "needs": {
          "content": "Om te beginnen met Noda, vul het formulier in en ons verkoopteam zal binnenkort contact met je opnemen. Noda biedt een eenvoudige onboarding met de begeleiding van een toegewijde manager om ervoor te zorgen dat u bij elke stap wordt ondersteund.",
          "title": "Wat heb ik nodig om te beginnen?"
        },
        "subtitle": "UW VRAGEN BEANTWOORD",
        "title": "FAQs"
      },
      "hero": {
        "text": "Breng uw reisbedrijf naar een hoger niveau. Ons alles-in-één betalingsplatform geeft prioriteit aan klantbegrip, efficiëntie en groei",
        "title-1": "Reisbetaling",
        "title-2": "Oplossingen met Noda:",
        "title-gradient-1": "Uw betalingen",
        "title-gradient-2": "zijn onze prioriteit"
      },
      "how-does-it-work": {
        "content": "Noda is een wereldwijd betalingssysteem voor reizen en een aanbieder van open bankieren. Van transactiebeheer tot financiële analyse, Noda heeft het voor je geregeld. Ons platform maakt gebruik van geavanceerde AI en machine-learning technologieën.\n\nOpen banking betekent dat traditionele banken gegevens delen met gelicentieerde fintech bedrijven, zoals Noda, om transacties te stroomlijnen. Ons betalingsecosysteem verbindt alle toonaangevende banken in het Verenigd Koninkrijk en de EU, waardoor reisbureaus moeiteloos merchant services kunnen afnemen.",
        "subtitle": "Technologieën",
        "title": "Hoe werkt het"
      },
      "how-to-start": {
        "content": "Noda biedt een gemakkelijke onboarding met de persoonlijke begeleiding van een toegewijde manager. Ons team is er om u te helpen bij eventuele wegversperringen. Om te beginnen met het gebruik van Noda, vul gewoon het formulier in en onze vertegenwoordigers zullen binnenkort contact met u opnemen.",
        "subtitle": "Eenvoudige onboarding",
        "title": "Hoe te beginnen"
      },
      "payments": {
        "text": "Ervaar de efficiëntie van directe transacties, waarbij het geld binnen enkele minuten op je rekening staat. Onze gebruiksvriendelijke en gestroomlijnde API's brengen uw producten moeiteloos op de markt",
        "title": "Toolset voor de reisbranche"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Maak gebruik van onze datagestuurde inzichten. De tools van Noda bieden kant-en-klare analyses van klantgedrag, inclusief segmentatie- en voorspellingsalgoritmen.",
            "title": "AI-gestuurde analyse"
          },
          "banking": {
            "content": "Verbeter de ervaring van klanten en versoepel de transactiestroom met de kracht en veiligheid van open banking-betalingen",
            "title": "Open Bankieren"
          },
          "global-currencies": {
            "content": "Noda werkt met verschillende wereldwijde valuta's om uw reisactiviteiten over de hele wereld te ondersteunen",
            "title": "Wereldwijde valuta's"
          },
          "payment-processing": {
            "content": "Stroomlijn in- en uitbetalingen met Noda. Maak gebruik van intuïtieve UX, slimme routing en verschillende betalingsmethoden",
            "title": "Verwerking van betalingen\nvoor reisindustrie"
          },
          "scalable-plans": {
            "content": "Wij bieden oplossingen voor de reisbranche voor alle bedrijfsgroottes, met schaalbare plannen om uw bedrijfsgroei te stimuleren",
            "title": "Schaalbare plannen"
          },
          "security": {
            "content": "Noda biedt veilige betalingsgateways voor reisbedrijven, die zorgen voor PCI DSS-compliance, versleuteling en fraudepreventie",
            "title": "Beveiliging"
          }
        },
        "subtitle": "OPEN BANKIEREN & BETALEN",
        "title-1": "Topfuncties"
      }
    },
    "ux-approach": {
      "about-design": {
        "comments": {
          "business": {
            "name": "Valērijs Sičovs",
            "position": "Chief Business Development Officer",
            "text": "Noda is een vooraanstaande Europese open-banking provider met een schat aan ervaring in consumentgestuurde betalingstechnologie. Onze oplossingen met toegevoegde waarde veranderen de koers van de betaalstrategieën van winkeliers en we kunnen het er allemaal over eens zijn dat de populariteit van open-banking betalingen in heel Europa onmiskenbaar is.<br/>We hebben een geavanceerde technologische oplossing, maar door de nauwe samenwerking met de ontwikkel- en ontwerpteams van Noda kunnen we een nog grotere impact hebben op de manier waarop winkeliers kunnen profiteren van onze goedgevormde gebruikerservaring en het betaalproces. Noda checkout, met al zijn elegantie, maakt zelfs zoiets historisch saais als betalingen state of the art."
          },
          "compliance": {
            "name": "Lāsma Gavarāne",
            "position": "Chief Compliance Officer",
            "text": "Een goed ontworpen ontwerp is als een blauwdruk van schoonheid en productfunctionaliteit. De ontwerpbenadering van Noda is cool omdat het er niet alleen om gaat hoe dingen eruit zien, maar eerder hoe ze naadloos samenwerken. Het is alsof je een superkracht hebt die alles moeiteloos en opwindend maakt, en dat is precies wat we met de wereld willen delen!"
          },
          "experience": {
            "name": "Max Gulewicz",
            "position": "Chief Experience Officer",
            "text": "Eerst dacht ik dat een goed ontwerp helpt om specifieke problemen op te lossen; vervolgens dat een goed ontwerp ook 100% moet aansluiten bij de behoeften van de uiteindelijke doelgroep; vervolgens dat we ook rekening moeten houden met de zakelijke KPI's van onze klanten. Maar na 25 jaar intensief ontwerpen realiseerde ik me dat om een geweldige ervaring te ontwerpen, die de heerlijkste nasmaak achterlaat, je niet alleen moet LIEVEN wat je doet, maar ook enigszins geobsedeerd moet zijn, misschien zelfs iets moet opofferen voor het ontwerp, voor het geluk van iemand anders. Het is ontzettend gaaf om je een schepper te voelen, maar nog beter is het om te begrijpen en te zien dat je inspanningen niet voor niets zijn."
          },
          "hr": {
            "name": "Olga Ķerpe",
            "position": "HR Director",
            "text": "Persoonlijk vind ik dat een goed ontwerp draait om esthetiek, aandacht voor detail en innovatie. En in ons Noda-ontwerp hebben we dit allemaal perfect gecombineerd. We werken er hard aan om altijd de nieuwste trends te volgen en de nieuwste tools en functies te gebruiken. Ik zou ook zeggen dat deze kenmerken onze algehele aanpak weerspiegelen, en ons team doet zijn best om dit visueel te laten zien aan de FinTech-wereld."
          },
          "project": {
            "name": "Egor Mahaniuk",
            "position": "Head of Project Management Office",
            "text": "Stel je dit eens voor: Noda is als een gestroomlijnde sportwagen, ontworpen om hoofden te doen omdraaien en een opwindende rit door het digitale landschap te leveren. Onze gebruikerservaring is niet alleen intuïtief, het is bijna telepathisch. We hebben een interface ontwikkeld die toegankelijk is voor gebruikers van elk niveau. Maar wacht, er is meer! Schaalbaarheid en flexibiliteit zijn ons brood en boter. Met onze modulaire architectuur gaan upgrades net zo snel als het verschijnen van nieuwe technologieën op de markt, zodat we altijd voorop lopen zonder ons in het zweet te werken. De UX van Noda is niet zomaar een verouderd ontwerp; het is een ervaring waarvan je zult zeggen: 'Waarom kan niet alles zo leuk en makkelijk zijn?"
          },
          "solutions": {
            "name": "Volodymyr Mykhailin",
            "position": "Chief Solutions Officer",
            "text": "Als je denkt aan UX-design van hoge kwaliteit, is het belangrijk dat het consumentgericht is en tegelijkertijd duidelijkheid, gemak en efficiëntie garandeert. Noda herkent dit principe en introduceert het actief in zijn producten. Gebruikers hebben geen problemen om te begrijpen hoe het product werkt; er ontstaan geen vragen over wat ze nu moeten doen en waarom een gebeurtenis heeft plaatsgevonden. Producten zijn zo ontworpen dat er zo min mogelijk barrières zijn voor de interactie tussen gebruikers en technologie. Wanneer gebruikers geen tijd verspillen aan het overwinnen van interfacehindernissen of het zoeken naar de benodigde informatie, nemen hun tevredenheid en loyaliteit aan het product toe. Een dergelijke ontwerpbenadering verbetert niet alleen de gebruikerservaring, maar versterkt ook het concurrentievoordeel van het bedrijf binnen zijn marktgebied."
          }
        },
        "subtitle": "Teamleden over ontwerp",
        "title": "We vroegen ons team om<br/> te delen wat ze denken over Noda Design "
      },
      "hero": {
        "subtitle": "Ontwerpmanifest",
        "text": "Wij zijn een team van ervaren ontwerpers, makers en onderzoekers die Open Banking omvormen tot een eenvoudige, vloeiende en toegankelijke manier om betalingen te verrichten en te ontvangen.",
        "title": "Ervaring met klant<br/>bij Noda"
      },
      "principles": {
        "ecosystem": {
          "text": "Zowel kopers als verkopers moeten elkaar en het systeem vertrouwen. Wij hebben de middelen om dit vertrouwen te verbeteren.",
          "title": "Veilig ecosysteem"
        },
        "interaction": {
          "text": "Wij geloven in een wereld zonder foutieve betalingen.",
          "title": "Foutgevoelige interactie"
        },
        "seconds": {
          "text": "Betalingen zijn altijd te traag en we zijn vastbesloten om ze sneller te maken.",
          "title": "Seconden scheren"
        },
        "solutions": {
          "text": "De betalingssector heeft de neiging om geestdodend saai en over het algemeen leeg te zijn. Wij hopen dat te veranderen.",
          "title": "Elegante Oplossingen"
        },
        "subtitle": "Ontwerp kelder",
        "title": "Onze principes"
      },
      "what-we-do": {
        "subtitle": "En tot slot",
        "text-1": "We ontwerpen en ontwikkelen een hele reeks tools, processen en conventies die de volgende generatie betalingen zullen aandrijven.",
        "text-2": "Met behulp van agile en onderzoeksgerichte processen - terwijl we onze diepgaande ervaring in e-commerce en betalingen ten volle benutten - bouwen we merchant tools die wrijving uit betalingen halen.",
        "title": "Wat We Doen"
      }
    },
    "wargaming": {
      "subtitle": "Lees een casestudy",
      "text": "In februari 2023 ging Wargaming, een toonaangevende uitgever van multiplatformgames, een samenwerking aan met Noda om directe open banking-betalingen voor hun games te lanceren. Dankzij dit samenwerkingsverband kregen spelers van Wargaming de mogelijkheid gebruik te maken van verschillende online betaalmethoden, waaronder account-to-account (A2A)-transacties, mogelijk gemaakt door de open banking-infrastructuur.",
      "title": "Hoe Wargaming dankzij Noda betere betaalervaringen biedt"
    },
    "white-label": {
      "boost": {
        "tag-title": "BOOST UW BEDRIJF MET NODA",
        "text": "Onze admin hub biedt volledige tracering van alle commissies en zorgt voor transparante rapportage. Controleer eenvoudig uitbetalingen en betalingen, zowel voor merchants als voor jezelf. Neem controle met volledige zichtbaarheid en beheer je bedrijf moeiteloos.",
        "title": "Uitgebreide tracering en rapportage"
      },
      "hero": {
        "button": "Aan de slag",
        "tag-title": "BETERE BETALINGEN",
        "text": "Maak gebruik van ons technologieplatform als white-label partner. Integreer naadloos open banktransacties, krijg bruikbare analyses en maak gebruik van onze intuïtieve UX. Wij bieden integratie via API's, transparante rapportage en merkaanpassing.",
        "title": "Laat uw bedrijf groeien met Noda"
      },
      "how-it-works": {
        "a-way-to-keep": "Een manier om bestedingsreeksen te behouden voor spelers die langzame banken gebruiken (zonder Instant SEPA)",
        "accept-payments": "Accepteer betalingen via links of QR-codes die kunnen worden gedeeld via verschillende kanalen",
        "actionable": "Bruikbare analyses",
        "actionable-analytics-from": "Actiegerichte analyses op basis van transactiegeschiedenis en extra gegevens die door de banken zelf worden aangeleverd",
        "ar": "AR boven 90%",
        "buffet": "Buffet",
        "checkout": "Kassa",
        "dedicated": "Speciale en aparte accounts voor meer duidelijkheid",
        "easily-pay": "Gemakkelijk betalen en betaald krijgen met onze geavanceerde technologie en slimme routing",
        "effortless": "Moeiteloze en verfijnde betalingservaring voor bedrijven van alle soorten en maten",
        "expansive": "Groot bereik met 2000+ banken in 28 landen",
        "great": "Geweldige dekking",
        "instead-of-long": "In plaats van lange formulieren in te vullen, betalen gebruikers de eerste aanbetaling en zijn ze direct geregistreerd",
        "intuitive": "Intuïtieve interface en uitgebreide afrekenfuncties",
        "know": "Gegevensverrijking",
        "pay": "Betalen & Gaan",
        "pay-by-link-qr": "Betalen via Link & QR",
        "payins": "Betalingen en uitbetalingen",
        "payment": "Accepteren van betalingen bijna 100%, zodat uw transacties altijd worden goedgekeurd",
        "provides-players": "Biedt spelers de optie om per bank te betalen, waardoor de conversie toeneemt",
        "round-the-clock": "24 uur per dag ondersteuning, we zijn er om je te helpen wanneer je maar wilt",
        "segregated-accounts": "Gescheiden rekeningen",
        "simple-payment-process": "Eenvoudig betalingsproces",
        "support": "24/7 ondersteuning",
        "tag-title": "Hoe het werkt",
        "title": "Integreer onze technologie",
        "trusted-payments": "Betrouwbare betalingen",
        "valuable": "Waardevolle inzichten uit het financiële gedrag van klanten om weloverwogen beslissingen te nemen"
      },
      "open-banking": {
        "tag-title": "DE KRACHT VAN OPEN BANKIEREN",
        "text-1": "Vóór open bankieren hadden traditionele banken de controle over klantgegevens. De Europese PSD2-verordening, die in 2018 van kracht werd, veranderde dit door banken te verplichten gegevens te delen met gelicentieerde derde partijen, zoals Noda, met toestemming van de klant.",
        "text-2": "Open bankieren maakt gebruik van API's (Application Programming Interfaces), die als een softwarebrug fungeren. Wanneer een gebruiker open banking selecteert, wordt hij doorgestuurd naar zijn vertrouwde interface voor online bankieren. Dit voorkomt ook dat cybercriminelen hun gegevens kunnen stelen.",
        "text-3": "Wereldwijd kiezen steeds meer consumenten en winkeliers voor deze opkomende technologie. ",
        "text-4": " voorspelt dat de totale waarde van open banktransacties zal stijgen van 57 miljard dollar in 2023 tot 330 miljard dollar in 2027. Open banking betalingen zijn niet langer innovatief; ze worden de nieuwe norm.",
        "text-link": "Juniper Research",
        "title": "Open Banking adoptie groeit"
      },
      "tailored-interface": {
        "tag-title": "INTERFACE OP MAAT",
        "text": "Maak gebruik van onze ingebouwde aanpassingshulpmiddelen om je gebruikersinterfaces (UI's) te personaliseren of creëer je eigen front-end om het ontwerp volledig te controleren. Met ons platform is de keuze aan jou om de perfecte ervaring op maat te maken.",
        "title": "Op maat gemaakt voor uw merk"
      }
    },
    "why-open-banking": {
      "benefits": {
        "section-1": {
          "cards": {
            "card-1": {
              "description": "Vóór <a class=\"link underline\" href=\"/articles/what-is-open-banking-your-ultimate-guide\">open bankieren</a> hadden traditionele banken een monopolie op klantgegevens. Maar de Europese PSD2-regelgeving kwam op om dit te veranderen. Deze werd in 2018 van kracht en verplicht banken om gegevens te delen met gelicentieerde derde partijen. Dit gebeurt uitsluitend met toestemming van de klant. Het delen van gegevens stimuleerde innovatie in betalingen, waardoor ze sneller, soepeler en veiliger werden.",
              "title": "Een nieuw tijdperk van betalingen"
            },
            "card-2": {
              "description": "Juniper Research voorspelt dat de totale waarde van OB-transacties zal <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">oplopen tot 330 miljard dollar in 2027</a>. Dat is een stijging ten opzichte van de 57 miljard dollar in 2023, een totale groei van 479%.",
              "title": "Snelgroeiende service"
            },
            "card-3": {
              "description": "Consumenten waarderen innovatie en superieure betalingsstromen. Met zijn snelheid en eenvoud is open banking voor velen de voorkeurskeuze aan het worden.",
              "title": "Meer Innovatief"
            }
          },
          "title": "Het is nieuw en snelgroeiend"
        },
        "section-2": {
          "cards": {
            "card-1": {
              "description": "Open banking biedt lagere transactiekosten dan traditionele kaartbetalingen. Betalingen gebeuren van <a class=\"link underline\" href=\"/glossary/a2a-payments\">rekening naar rekening</a>.",
              "title": "Lagere tarieven"
            },
            "card-2": {
              "description": "Open banking API's maken een einde aan betalingscommissies en de meeste operationele kosten.",
              "title": "Lagere kosten en vergoedingen"
            },
            "card-3": {
              "description": "Nogmaals, omdat er geen kaartnetwerken bij betrokken zijn, sluiten open bankbetalingen chargebacks uit. Handelaren kunnen afscheid nemen van die hoge verwerkingskosten.",
              "title": "Geen terugboeking"
            },
            "card-4": {
              "description": "Alle handelaren ontvangen uniforme prijzen. De enige verandering die mogelijk is, is een verlaging als reactie op concurrentiedruk.",
              "title": "Kosten voor handelaren"
            }
          },
          "title": "Het is zeer winstgevend"
        },
        "section-3": {
          "cards": {
            "card-1": {
              "description": "Er wordt sneller afgerekend en het geld staat vrijwel direct op de rekening van de winkelier. Hierdoor kunt u uw cashflow en boekhouding beter beheren. Consumenten kunnen snel betalen, zonder lange verwerkingstijden. Omdat de afwikkelingstijden korter zijn, kunnen ze efficiënter budgetteren.",
              "title": "Snellere betalingen"
            },
            "card-2": {
              "description": "Open banking oplossingen kunnen gegevens consolideren in één enkel platform. Van klantinzichten tot verificatieoplossingen, het biedt diverse zakelijke tools.",
              "title": "Efficiëntie"
            },
            "card-3": {
              "description": "Consumenten betalen via hun beveiligde bankinterface zonder handmatig kaartgegevens te hoeven invoeren. Dit bespaart hen moeite en tijd, wat resulteert in een verbeterd klanttraject.",
              "title": "Betere gebruikerservaring "
            },
            "card-4": {
              "description": "Open banking vereenvoudigt de <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">gebruikerservaring (UX)</a> van betalingen door fricties zoals het handmatig invoeren van kaartgegevens uit het proces te halen, wat resulteert in hogere conversies.",
              "inserted-content": {
                "subtext": "*Gebaseerd op de transactiegegevens van terugkerende gebruikers van het platform van Noda in januari 2024.",
                "table": {
                  "tbody-1": {
                    "header": {
                      "col-1": "Duitsland",
                      "col-2": "Tot 89%"
                    }
                  },
                  "tbody-2": {
                    "header": {
                      "col-1": "Groot-Brittannië",
                      "col-2": "Tot 92%"
                    }
                  },
                  "tbody-3": {
                    "header": {
                      "col-1": "Nederland",
                      "col-2": "Tot 92%"
                    }
                  },
                  "thead": {
                    "col-1": "Financiële instelling",
                    "col-2": "Acceptatie&shy;graad, %"
                  }
                },
                "title": "Acceptatiegraad van open banktransacties van terugkerende gebruikers"
              },
              "show-more-btn": "Statistieken weergeven",
              "title": "Hogere conversiepercentages"
            },
            "card-5": {
              "description": "Open banking-gegevens kunnen worden gebruikt om de financiële gewoonten en het gedrag van klanten te analyseren. Op basis van deze inzichten kunnen winkeliers ervaringen op maat aanbieden.",
              "title": "Personalisatie"
            }
          },
          "title": "Snel en effectief"
        },
        "section-4": {
          "cards": {
            "card-1": {
              "description": "Het delen van gegevens kan alleen gebeuren met <a class=\"link underline\" href=\"/articles/open-banking-flow\">expliciete toestemming van de klant</a>. Als consumenten besluiten om hun gegevens niet langer te delen, kunnen ze zich op elk moment afmelden voor open bankieren.",
              "title": "Controle van financiële gegevens"
            },
            "card-2": {
              "description": "Open banking data-oplossingen bieden directe verificatie van identiteit, bronnen van rijkdom en andere elementen, wat u kan helpen bij het snel aannemen van nieuwe klanten.",
              "title": "Onboarding & KYC"
            },
            "card-3": {
              "description": "Open banking is gebaseerd op <a class=\"link underline\" href=\"/glossary/api\">veilige API's</a>. Autorisatie van betalingen gebeurt bij de vertrouwde bank van de klant. Bovendien is open banking volledig gereguleerd onder de <a class=\"link underline\" href=\"/glossary/european-psd2\">Europese PSD2</a> met Strong Customer Authentication (SCA) als wettelijke vereiste.",
              "title": "Betere beveiliging"
            }
          },
          "title": "Het is 100% veilig"
        }
      },
      "hero": {
        "subtitle": "De beste beslissing",
        "text": "Open banking aanbieden als betaalmethode is geen nieuwigheid meer. Als u dit niet doet, kan dit uw bedrijf waardevolle klanten kosten. Als u nog twijfelt, lees dan hieronder over de voordelen van open bankieren.",
        "title": "Waarom Open Banking?"
      },
      "myths": {
        "description": "Zoals elke nieuwe technologie wordt ook open banking vaak verkeerd begrepen. Deze misvattingen kunnen ertoe leiden dat winkeliers open banking-betalingen vermijden vanwege een gebrek aan kennis.\n\nHier ontkrachten we veelvoorkomende mythes.",
        "myth-10": {
          "content": "Zoals eerder vermeld geven klanten steeds meer de voorkeur aan open bankieren boven andere betaalmethoden. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.statista.com/statistics/1228771/open-banking-users-worldwide/\">Statista</a> schat dat tegen eind 2024 het aantal gebruikers van open bankieren wereldwijd 132 miljoen zal bedragen. De snelle adoptie van open banking is een duidelijk teken van consumentenvertrouwen. OB-betalingen bieden een betere, intuïtievere UX en consumenten waarderen de superieure betalingsstroom.",
          "title": "Mythe 10. Klanten zijn niet gewend aan Open Banking-betaalstromen"
        },
        "myth-1": {
          "content": "Er is een veelvoorkomend misverstand over het woord 'open' in het concept van open bankieren. Open bankieren betekent niet dat banken openlijk klantgegevens delen met wie er maar toegang toe wil. Het is zelfs zo dat derde partij aanbieders een <a class=\"link underline\" href=\"/articles/what-are-aisp-and-pisp-in-open-banking\">strenge regelgeving moeten</a> ondergaan bij nationale regelgevende instanties als ze open bankieren willen implementeren. In de Europese PSD2 bijvoorbeeld moeten providers een AISP- of PISP-licentie krijgen om toegang te krijgen tot klantgegevens.",
          "title": "Mythe 1. Open Bankieren betekent dat alles 'open' is"
        },
        "myth-2": {
          "content": "Open banking wordt mogelijk gemaakt door veilige API's die door banken worden gedeeld met gelicentieerde externe aanbieders. Wanneer een klant kiest voor een open banking betaling, wordt hij automatisch doorgestuurd naar zijn vertrouwde bankinterface, waar de betaling wordt geautoriseerd. Deze API app-to-app omleiding voorkomt dat cybercriminelen hun gegevens kunnen stelen, vooral in vergelijking met praktijken zoals screen scrapping. Bovendien is <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://finance.ec.europa.eu/publications/strong-customer-authentication-requirement-psd2-comes-force_en\">Strong Customer Authentication (SCA)</a> onder PSD2 een wettelijke vereiste voor open bankbetalingen. SCA is een multifactor authenticatiemaatregel die bedoeld is om fraude door imitatie te voorkomen. ",
          "title": "Mythe 2. Open Banking is niet veilig"
        },
        "myth-3": {
          "content": "Sommige klanten gaan er ten onrechte van uit dat wanneer ze toestemming geven voor het delen van gegevens, de hele wereld kan zien wat er met hun financiën gebeurt. Dit is gewoon niet waar. Alleen geautoriseerde externe aanbieders hebben toegang tot klantgegevens. Om zo'n vergunning te krijgen, moeten aanbieders deze verkrijgen via een nationale toezichthouder zoals <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.fca.org.uk/consumers/account-information-payment-initiation-services\">FCA in het Verenigd Koninkrijk</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.bafin.de/EN/Aufsicht/ZahlungsdienstePSD2/ZulassungspflichtigeZahlungsdienste/ZulassungspflichtigeZahlungsdienste_node_en.html\">BaFin in Duitsland</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://acpr.banque-france.fr/en/authorisation/banking-industry-procedures/licensing-authorisation-and-registration/payment-institution-and-account-information-service-provider\">ACPR in Frankrijk</a> en andere relevante autoriteiten van het land in kwestie om er zeker van te zijn dat aanbieders zich aan de regels houden en op de juiste manier met gegevens omgaan. Bovendien kunnen klanten hun toestemming op elk moment intrekken. ",
          "title": "Mythe 3: Misverstand over het delen van gegevens"
        },
        "myth-4": {
          "content": "Er bestaat een misvatting dat open banking-betalingen alleen werken voor rekeningen bij grote banken. In werkelijkheid is het open banking ecosysteem groot en omvat het ook veel kleinere financiële instellingen. Volgens <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbankingtracker.com/\">Open Banking Tracker</a> zijn er 4.394 aangesloten banken in 73 landen. Bij Noda zijn we verbonden met <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://coda.io/d/Noda-Supported-banks_dIVjZri07ne\">meer dan 2000+ banken</a> in het Verenigd Koninkrijk en de EU.",
          "title": "Mythe 4. Open Banking ondersteunt kleinere banken niet"
        },
        "myth-5": {
          "content": "Sommige winkeliers gaan ervan uit dat de 'betalen per bank' optie consumenten afschrikt die liever per kaart betalen. In feite zijn OB-betalingen veel eenvoudiger en veiliger, omdat klanten hun kaartgegevens niet handmatig hoeven in te voeren. Het geld wordt overgemaakt vanaf dezelfde bankrekening die gekoppeld is aan een kaart, maar de overdracht omzeilt het kaartnetwerk, wat leidt tot snellere verwerking en lagere commissies. Daarom kiezen klanten steeds vaker voor open bankieren in plaats van kaarten. In het Verenigd Koninkrijk is bijvoorbeeld <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbanking.org.uk/news/open-banking-impact-report-october-2023/\">11% van de consumenten</a> actief gebruiker van deze betaalmethode. ",
          "title": "Mythe 5. Klanten die met een betaalkaart betalen, worden afgeschrikt door Open Banking"
        },
        "myth-6": {
          "content": "Conversies zijn de belangrijkste statistieken voor betalingen. Daarom is het belangrijk om ze goed te krijgen. Er bestaat een mythe dat kaartbetalingen tot meer succesvolle transacties leiden dan betalingen via open bankieren. In werkelijkheid is de <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">UX voor open banking veel eenvoudiger</a>. De gebruikers worden doorgestuurd naar de interface van hun bank en het geld wordt rechtstreeks van hun bankrekening overgemaakt. Dit voorkomt het risico van verkeerd getypte kaartgegevens en bespaart klanten tijd en moeite, wat leidt tot hogere conversies.",
          "title": "Mythe 6. Conversies van kaartbetalingen zijn hoger dan bij Open Banking"
        },
        "myth-7": {
          "content": "Ook dit is een misvatting. Zoals hierboven vermeld, vereisen open banking betalingen geen handmatige invoer van informatie. Klanten worden <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">doorgestuurd naar hun bankinterface</a>, waar de betalingen worden geautoriseerd. De authenticatie kan bestaan uit het invoeren van een wachtwoord, een biometrische verificatie, zoals een vingerafdrukscan of gezichtsidentificatie, en een code die naar hun apparaat wordt gestuurd. Dit proces is veel eenvoudiger en minder tijdrovend dan het invoeren van lange kaartgegevens.",
          "title": "Mythe 7. Open Banking-betalingen vereisen meer betalingsgegevens"
        },
        "myth-8": {
          "content": "Sommige winkeliers denken misschien dat zelfs als een klant hun bank in de lijst vindt, de integratie vol wrijving zal zitten en de transactie uiteindelijk zal mislukken. Wij kunnen je verzekeren dat open banking API-integratie naadloos verloopt, omdat <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.stet.eu/en/psd2/\">deze API's gestandaardiseerd</a> zijn voor alle PSD2-landen en banken. Bekijk zelf hoe het werkt met <a class=\"link underline\" rel=\"nofollow\" target=\"_blank\" href=\"https://noda.live/demo\">Noda's demo</a> van een open banking transactie.",
          "title": "Mythe 8. Integratie met de bank van de klant zal mislukken"
        },
        "myth-9": {
          "content": "Sommige winkeliers denken misschien dat open banking betalingen langzamer verwerkt. In werkelijkheid zijn er bij betalingen via kaarten tussenpersonen betrokken, waardoor de verwerkingstijd langer is. Open banking betalingen gebeuren van <a class=\"link underline\" href=\"/glossary/a2a-payments\">rekening tot rekening</a>, dus er zijn geen kaartnetwerken bij betrokken. De betalingen verlopen dus veel sneller.",
          "title": "Mythe 9. Open Banking-betalingen duren langer"
        },
        "title": "Veel voorkomende mythes\n\nover Open Bankieren"
      }
    }
  },
  "ro": {
    "ab-test": {
      "campaign-30": {
        "button-text-a": "Începe",
        "button-text-b": "Începe"
      }
    },
    "anti-bribery": {
      "definitions": {
        "associated-person-employees": "<b>Persoană asociată</b> - angajați, furnizori, agenți, persoane fizice sau organizații care prestează servicii în numele Noda.",
        "bribe-a-financial": "<b>Mită</b> - un avantaj financiar sau de altă natură care este un stimulent pentru o acțiune care este necorespunzătoare, ilegală sau o încălcare a încrederii.",
        "bribery-the-offering": "<b>Mituire</b> - oferirea, promisiunea, darea, acceptarea sau solicitarea unui avantaj financiar sau de altă natură ca stimulent pentru o acțiune care este necorespunzătoare, ilegală sau o încălcare a încrederii.",
        "title": "Definiții"
      },
      "employee-responsibilities": {
        "act-with-integrity": "să acționeze cu integritate și să desfășoare activitatea într-un mod corect, onest și transparent;",
        "all-nodas-employees": "Toți angajații Noda trebuie:",
        "avoid-using-their": "să evite să se folosească de poziția lor în cadrul societății pentru a promova interese personale sau ale altora, inclusiv ale membrilor familiei; și",
        "comply-with-nodas": "să respecte Declarația ABC a Noda;",
        "implement-appropriate-due": "să pună în aplicare proceduri adecvate de diligență necesară atunci când selectează furnizori, parteneri de afaceri sau agenți pentru a reduce riscurile de mită și să se asigure că aceștia sunt conștienți de cerințele Legii din 2010 privind corupția din Regatul Unit;",
        "refuse-to-engage": "să refuze să se implice în afaceri cu persoane sau entități care nu aderă la principiile Noda și care ar putea afecta reputația companiei;",
        "report-any-instances": "să raporteze Departamentului Juridic al Noda orice situație în care li se oferă un avantaj financiar sau de altă natură care poate constitui mită sau dacă suspectează că au primit ospitalitate sau un cadou în afara normei;",
        "report-to-noda": "să raporteze Departamentului juridic al Noda orice caz în care un coleg a primit un avantaj financiar sau de altă natură care nu a fost raportat în conformitate cu Declarația ABC;",
        "title": "Responsabilitățile angajaților",
        "uphold-nodas-principles": "să implementeze principiile Noda chiar și în situații dificile."
      },
      "key-prohibitions": {
        "bribing-a-public": "2. Mituirea unui funcționar public din orice țară este interzisă în mod expres. Aceasta include: ",
        "engaging-in-bribery": "1. Implicarea în mituire, fie direct, fie prin intermediul unei terțe părți, este interzisă în mod explicit în orice țară. Mita este definită ca:",
        "facilitation-payments-are": "3. Plățile de facilitare sunt interzise, cu excepția cazurilor în care există un risc real pentru viață sau bunăstare.",
        "in-order-to": "pentru a obține sau a menține afaceri sau orice alt avantaj comercial.",
        "offering-promising": "oferirea, promisiunea sau darea, solicitarea, cererea sau acceptarea de orice lucru de valoare sau orice alt avantaj;",
        "offering-promising-or": "oferirea, promisiunea sau darea oricărui lucru de valoare sau de alte avantaje;",
        "political-donations-and": "4. Donațiile politice și lobby-ul sunt interzise.",
        "the-key-areas": "Domeniile cheie subliniate în Declarația noastră ABC includ:",
        "title": "Principalele interdicții și cerințe",
        "to-improperly-influence": "pentru a influența în mod necorespunzător o decizie de afaceri sau orice alt act, inacțiune sau decizie a oricărei persoane.",
        "to-influence-a": "pentru a influența un funcționar public în rolul său;"
      },
      "last-update-at": "Ultima actualizare la 1 iunie 2024",
      "noda-is-dedicated": "Noda este dedicată prevenirii mitei și corupției și adoptă o poziție de toleranță zero față de orice acțiuni care ar putea contraveni legilor pertinente de combatere a mitei și corupției, atât în Regatul Unit, cât și la nivel internațional. Acest angajament cuprinde respectarea legislației, cum ar fi Legea privind mita din 2010 din Regatul Unit și a legilor relevante din alte jurisdicții în care desfășurăm operațiuni comerciale.",
      "principles": {
        "by-any-individual": "de către orice angajat individual, agent sau altă persoană asociată sau companie care acționează în numele Noda;",
        "facilitation-payments-will": "6. Plățile de facilitare nu vor fi acceptate, chiar dacă acestea sunt considerate o practică obișnuită în anumite țări.",
        "in-any-form": "sub orice formă, inclusiv cadouri sau distracții oferite soțului/soției sau altor membri ai familiei decidentului;",
        "in-order-to-gain-commercial": "pentru a obține avantaje comerciale, contractuale sau de reglementare pentru Noda într-un mod care nu este etic; sau",
        "in-order-to-gain-personal": "pentru a obține avantaje personale, monetare sau de altă natură, pentru persoana în cauză sau pentru orice altă persoană asociată cu aceasta.",
        "noda-is-dedicated": "1. Noda este dedicată desfășurării operațiunilor sale în mod responsabil, indiferent de locație sau de părțile implicate. Acordăm prioritate practicilor etice și transparente, acționând în mod constant cu integritate în toate circumstanțele.",
        "noda-maintains-a": "2. Noda menține o politică strictă cu zero toleranță față de mită și corupție. Ne abținem fără echivoc să oferim, să promitem, să plătim, să solicităm sau să acceptăm mită - direct sau prin intermediul unei terțe părți - ca mijloc de a obține noi afaceri, de a păstra afacerile curente sau de a obține orice formă de avantaj comercial.",
        "noda-strictly-prohibits": "5. Noda interzice cu strictețe oferirea, darea, solicitarea sau acceptarea oricărei forme de mită, sub formă de numerar sau în alt mod:",
        "noda-will-not": "7. Noda nu va face nicio contribuție directă sau indirectă la niciun partid politic.",
        "title": "Principiile de combatere a mitei și corupției",
        "to-or-from-any": "către sau de la orice persoană sau entitate, indiferent dacă este vorba despre un funcționar public sau un organism public, o persoană fizică sau o societate și indiferent de locația acestora;",
        "under-the-law": "4. În conformitate cu legea, mituirea și comportamentul corupt pot fi comise de diverse părți asociate cu Noda, inclusiv angajați, reprezentanți numiți, directori, persoane care acționează în numele Noda și orice persoane sau organizații autorizate să acționeze în numele acestora.",
        "we-mandate-that": "3. Solicităm ca toți angajații și persoanele asociate să respecte pe deplin toată legislația relevantă privind combaterea mitei, inclusiv Legea privind mita din 2010 din Regatul Unit (Bribery Act), precum și să adere la reglementările profesionale relevante pentru operațiunile noastre."
      },
      "steps-taken": {
        "accurate-records": {
          "text": "Multe infracțiuni grave de luare de mită și corupție au fost legate de ținerea inexactă a evidențelor. Este imperativ să menținem contabilitatea, înregistrările și rapoartele financiare exacte în cadrul Noda. Conturile, înregistrările și rapoartele noastre financiare generale trebuie să fie transparente. Orice înregistrare falsă, înșelătoare sau inexactă ar putea reprezenta un risc semnificativ pentru reputația și integritatea Noda.",
          "title": "2. Contabilitate și evidență exacte"
        },
        "compliance-statement": "Prezenta „Declarație privind combaterea mitei și a corupției” este întocmită în conformitate cu obligațiile Noda în temeiul Legii britanice privind mita din 2010.",
        "internal-control": {
          "text": "Noda menține un sistem eficient de control intern și de monitorizare a tranzacțiilor. După identificarea și evidențierea riscurilor de luare de mită și corupție prin procesul de evaluare a riscurilor, sunt elaborate proceduri în cadrul unui program cuprinzător de control și monitorizare pentru a diminua continuu aceste riscuri.",
          "title": "3. Monitorizare și control intern eficace"
        },
        "noda-implements": "Noda pune în aplicare următoarele măsuri pentru a ajuta la prevenirea mitei și corupției:",
        "risk-assessment": {
          "text": "Evaluarea eficientă a riscurilor este fundamentală pentru succesul sau eșecul Declarației noastre ABC. Identificarea riscurilor ne permite să identificăm domeniile specifice în care ne putem confrunta cu riscuri de mită și corupție. Acest lucru permite o mai bună evaluare și diminuare a acestor riscuri, protejând astfel Noda.",
          "title": "1. Evaluarea riscurilor"
        },
        "title": "Măsuri luate pentru prevenirea mitei sau corupției"
      },
      "subtitle": "Intenția declarației",
      "the-anti-bribery": "Declarația privind combaterea mitei și corupției („Declarația ABC”) definește îndrumări cuprinzătoare privind prevenirea mitei și raportarea îngrijorărilor și activităților suspecte.",
      "title": "Declarație privind combaterea mitei și corupției"
    },
    "articles": {
      "back-to-articles": "Înapoi la Articole",
      "case-info": {
        "payer-location": "Locația plătitorului",
        "product-used": "Produs folosit"
      },
      "defaultBanner": {
        "buttonText": "Rezervați o demonstrație",
        "text": "Oferiți-le utilizatorilor o modalitate mai simplă și ieftină de a plăti și de a spori conversiile!",
        "title": "Aflați mai multe despre Open Banking cu Noda"
      },
      "defaultBannerHero": {
        "buttonText": "Rezervați o demonstrație",
        "text": "Adăugați 2000+ bănci pentru plăți instantanee și plăți și scalați la nivel global cu ușurință!",
        "title": "Acceptă plăți online cu Noda"
      },
      "main": {
        "banner": {
          "button": "Începeți să utilizați Noda",
          "text": "Produsele noastre fac experiența plăților mai ușoară, mai rapidă și mai accesibilă",
          "title": "Soluție de plată fiabilă pentru afacerea dumneavoastră"
        },
        "title": "Articole"
      },
      "single-article": {
        "tables-banner": {
          "button": "Încercați Noda",
          "title": "Încercați Noda - o modalitate extrem de nouă de a accepta plăți online"
        }
      }
    },
    "bank-payouts": {
      "control-data": {
        "items": {
          "item-1": {
            "text-1": "Noda lucrează în strânsă colaborare cu comercianții și băncile pentru a înțelege complexitatea specifică domeniului în privința fluxurile financiare, atât C2B cât și B2C. Aceasta ne permite să livrăm o soluție integrală, adaptată necesităților afacerii dvs.",
            "title-1": "Înețelegerea provocărilor din domeniu"
          },
          "item-2": {
            "text-2": "Cu o bogată experiență în open-banking în UE și Marea Britanie, Noda creează soluții de plăți bancare de prim ordin, adaptate necesităților unice ale clienților dvs.",
            "title-2": "Expertiză în domeniul bancar"
          }
        },
        "text": "Efectuați plăți extrem de fiabile cu Noda. Plătiți-vă partenerii, furnizorii și utilizatorii pieței cu ușurință, folosind o tehnologie și o știință avansate",
        "title": "Control integral al plăților dvs. B2C"
      },
      "netting-data": {
        "items": {
          "text-1": "Compensările elementelor de bilanț asigură transferul armonizat al fondurilor fără întârzieri și contribuie la menținerea unui flux financiar sănătos pentru afacerea dvs.",
          "text-2": "Folosiți soldul existent pentru a plăti fonduri, eliminând necesitatea transferurilor bancare și costurilor suplimentare",
          "title-1": "Evitați lipsa de lichidități",
          "title-2": "Eficiența costurilor"
        },
        "subtitle": "Compensare sold",
        "text": "Gestionați-vă soldul conturilor de depuneri fără probleme, folosind fondurile pentru a face plăți. Valorificați această metodă de plată eficientă din punct de vedere al costurilor și disponibilitatea instantanee a fondurilor",
        "title": "Folosiți-vă soldurile conturilor de depuneri pentru a realiza plăți"
      },
      "payments-data": {
        "balance": "Soldul curent",
        "text": "Plăți prin bănci, rapide și convenabile, pentru comercianți",
        "title": "Plăți bancare",
        "title-colored": "pentru tranzacții prompte"
      },
      "recipient-data": {
        "subtitle": "Experiență mulțumitoare",
        "text": "Cu opțiunile de plăți bancare Noda, primirea fondurilor este gratuită pentru persoane fizice, spre deosebire de unele sisteme de carduri și portofele electronice care pot percepe taxe pentru același serviciu. Acest avantaj este câștigat prin obligația băncilor de a furniza transferuri inter-bancare gratuite pentru clienții lor",
        "title": "Gratuit pentru destinatar"
      },
      "routing-data": {
        "items": {
          "item-1": {
            "text-1": "Cu direcționarea eficientă Noda, fondurile dvs. vor ajunge la destinație cu viteza fulgerului",
            "title-1": "Livrare promptă a fondurilor"
          },
          "item-2": {
            "text-2": "Minimizați transferurile bancare suplimentare și taxele asociate acestora, folosind sistemul nostru modern de direcționare a plăților",
            "title-2": "Costuri reduse"
          }
        },
        "text": "Vă optimizăm livrarea de fonduri pentru a garanta viteza maximă și eficiența costurilor, evitând, în același timp, traseele bancare ineficiente",
        "title": "Direcționare"
      },
      "single-report-data": {
        "subtitle": "Bani cu viteza luminii",
        "text": "Uitați de plățile cu întârziere. Folosim programe de plată imediată FPS și SEPA pentru a transfera bani destinatarilor dvs. în timp real",
        "title": "Livrare instantanee de fonduri"
      },
      "title": "Plătiți fără efort furnizorii, deținători de portofele electronice, furnizorii de streaming și altele Plățile bancare Noda de tip comercial către client (B2C) simplifică plățile de masă către persoane private, asigurând tranzacții prompte și simple"
    },
    "bank-sign": {
      "hero": "Clienții se pot conecta cu ușurință la site-ul sau aplicația dvs., utilizând contul lor bancar. Tehnologia noastră de ultimă oră utilizează informații bancare esențiale, oferind o experiență de conectare armonioasă și sigură pentru clienții dvs.",
      "payments-data": {
        "text": "Conectare securizată, cu un singur clic, cu datele bancare",
        "title": "Conectare prin bancă"
      },
      "payouts-data": {
        "items": {
          "item-1": {
            "text-1": "Alegând să se conecteze prin intermediul contului bancar, clienții dvs. acceptă ca Noda să aibă acces la informațiile lor cu caracter personal. Acest lucru asigură fiabilitatea și siguranța informațiilor pe care le primiți la conectare, oferind o transparență suplimentară",
            "title-1": "Date cu fiabilitate maximă"
          },
          "item-2": {
            "text-2": "Atunci când utilizează parametrii bancari pentru a se conecta, clienții interacționează cu interfața obișnuită a aplicației lor bancare de încredere sau a site-ului web. Acest lucru elimină riscul de pierdere a clienților din cauza dificultăților de înregistrare",
            "title-2": "UX intuitiv"
          }
        },
        "text": "Clienții acceptă să se conecteze prin intermediul aplicației bancare sau al interfeței web. Sistemele noastre de integrare respectă cele mai înalte standarde bancare de securitate și conformitate",
        "title": "Rapid și fiabil"
      },
      "recipient-data": {
        "subtitle": "Achiziție avansată a clienților",
        "text": "Conectarea armonioasă și prima plată transformă utilizatorii în clienți cu doar câteva clicuri. Nu este nevoie de introducerea manuală a datelor - toate informațiile necesare și autorizația de plată vor fi obținute în mod securizat, atunci când clienții își dau acordul pentru aceasta",
        "title": "Plătiți și plecați"
      },
      "risk-data": {
        "items": {
          "item-1": {
            "text-1": "Protejarea fondurilor este o sarcină complexă, dar sectorul bancar este renumit pentru standardele sale stricte de securitate. Acesta este motivul pentru care funcția de conectare prin bancă oferă afacerii dvs. cele mai bune măsuri de siguranță pentru protejarea clienților",
            "title-1": "Securitate solidă"
          },
          "item-2": {
            "text-2": "Cu această caracteristică, clientul nu va uita niciodată datele de conectare, deoarece accesul la banii săi este întotdeauna securizat. Astfel sunteți siguri că nu veți pierde clienți din cauza problemelor de conectare la cont",
            "title-2": "Punct de contact client"
          }
        },
        "text": "Posibilitatea accesării neautorizate a contului bancar este redusă, datorită securității riguroase și a urmăririlor penale ulterioare. În cazul puțin probabil al unei preluări, clientul vede în mod instantaneu atacul și reacționează rapid",
        "title": "Risc minim de preluare a controlului asupra contului"
      },
      "single-report-data": {
        "subtitle": "Respectă integral standardele de reglementare",
        "text": "Cu datele bancare colectate prin Noda, puteți îndeplini majoritatea cerințelor și politicilor legale de monitorizare, înscriere și identificare",
        "title": "Date conforme legislației"
      },
      "title-1": "Sigur",
      "title-2": "Autentificare prin bancă"
    },
    "banking": {
      "banking": "Experiență bancară",
      "banks-count": "2000+ bănci",
      "c2b": "Cont C2B",
      "easy-onboarding-1": "Înscriere ușoară",
      "easy-onboarding-2": "Cu un manager personal",
      "experience": "Experimentați tranzacții fără efort folosind serviciul nostru de open-banking de ultimă generație care vă conectează afacerea cu toate băncile importante din Marea Britanie și UE",
      "experience-data": {
        "easy-to-apply": {
          "text": "Soluție flexibilă pentru colectarea fondurilor, cu posibilitatea de a utiliza contul bancar Noda C2B sau de a alege o bancă din rețeaua noastră de parteneri de încredere",
          "title": "Ușor de aplicat"
        },
        "enhance-customer-experience": {
          "text": "Bucurați-vă de colectări cu taxe reduse sau fără taxe, cu o multitudine de opțiuni puse la dispoziție prin rețeaua noastră bancară\n",
          "title": "Îmbunătățiți experiența clienților"
        }
      },
      "features-to-integrations": "de la caracteristici la integrări",
      "first-steps": "PRIMII PAȘI",
      "hero": "Îmbunătățiți experiența clienților și ușurați fluxul tranzacțiilor folosind puterea și securitatea platformei noastre de open banking",
      "hero-title-1": "Open Banking",
      "hero-title-2": "cu Noda",
      "how-data": {
        "authorise-the-transaction": {
          "text": "De la redefinirea viitorului cu start-up-uri inovatoare la transformarea lumii noastre cu mărci emblematice, Noda susține mii de afaceri",
          "title": "Autorizați tranzacția"
        },
        "choose-your-bank": {
          "text": "Alegeți dintr-o selecție de bănci importante din apropierea dvs.",
          "title": "Alegeți-vă banca"
        },
        "payment-is-done": {
          "text": "Noda este forța motrice din spatele tranzacțiilor armonioase pentru mii de companii, de la start-up-uri de ultimă generație la lideri din domeniu",
          "title": "Plata e efectuată"
        },
        "sign-into-your-account": {
          "text": "Noda susține mii de afaceri cu impact important, de la start-up-uri de ultimă generație la mărcile de prim rang care schimbă lumea",
          "title": "Intrați în cont"
        }
      },
      "hub-data": {
        "1": {
          "text": "Proces de rambursare ușor și eficient",
          "title": "Rambursări"
        },
        "2": {
          "text": "Roluri multiple de utilizator pentru un control mai bun",
          "title": "Roluri multiple"
        },
        "3": {
          "text": "Gestionarea sigură, rapidă și eficientă a tranzacțiilor",
          "title": "Tranzacții"
        },
        "4": {
          "text": "Raportare financiară detaliată și adaptabilă",
          "title": "Raportare"
        }
      },
      "hub-description": "Cu Noda Hub, puteți să vă înscrieți fără efort, să configurați preferințele de tranzacționare, să monitorizați tranzacțiile și rapoartele și să analizați traficul de plăți, toate acestea pe o singură platformă",
      "info-data": {
        "subtitle": "Funcții și integrări",
        "text": "Permiteți clienților să se autentifice și să plătească în siguranță în ecosistemul dvs., cu o integrare perfectă de la început până la sfârșit",
        "title": "Cum funcționează soluția noastră Open banking"
      },
      "manage-everything": "Gestionați totul într-un singur loc",
      "management": "Gestionare",
      "manager-guidance": "Bucurați-vă de o integrare fără efort cu procesul de ghidare Noda Hub și primiți asistență personalizată de la managerul special desemnat pentru dvs.",
      "manager-help": "Spuneți adio complicațiilor de la înscriere - managerul dvs. personal este aici pentru a vă ajuta să treceți de orice obstacol",
      "payments-data": {
        "text": "Transferuri bancare rapide, sigure și reglementate",
        "title": "Plăți Open Banking"
      },
      "payments-feature-description": "Eficientizați plățile cu ajutorul funcției Noda - Plăți de încredere, care securizează tranzacțiile cu plătitori de încredere înainte chiar ca fondurile să ajungă",
      "special-features": "Funcții speciale",
      "trusted-payments-1": "Plăți de încredere",
      "trusted-payments-2": "pentru a accelera checkout-ul"
    },
    "banner": {
      "text1": "Creștere constantă sau transformare rapidă?",
      "text2": "Știți când este timpul să vă duceți afacerea la un nivel superior.",
      "title": "O nouă abordare a plăților - Consultați toate produsele Noda"
    },
    "block-with-screen": {
      "detailed-and-customizable": "Raportare financiară detaliată și personalizabilă",
      "easy-and-efficient": "Procesare ușoară și eficientă a rambursărilor",
      "multi-roles": "Roluri multiple",
      "multiple-user": "Roluri de utilizator multiple pentru un control mai bun",
      "refunds": "Restituiri",
      "reporting": "Raportare",
      "reporting-v2": {
        "subtitle": "transparență totală",
        "text": "Cu hub-ul nostru de administrare puteți urmări toate comisioanele, asigurând o raportare clară și transparentă. Supravegheați fără efort plățile și plățile, obținând vizibilitate completă și gestionându-vă operațiunile cu ușurință.",
        "title": "Monitorizare detaliată și raportare"
      },
      "secure-fast": "Gestionarea sigură, rapidă și eficientă a tranzacțiilor",
      "tagTitle": "IMPULSIONEAZĂ-ȚI AFACEREA CU NODA",
      "text": "Cu Noda Hub, puteți să vă înscrieți fără efort, să configurați preferințele tranzacționale, să monitorizați tranzacțiile și rapoartele și să analizați traficul de plăți, toate într-o singură platformă",
      "title": " — Gestionați tot ce aveți nevoie într-un singur loc",
      "transactions": "Tranzacții"
    },
    "card-payments": {
      "active-subscriptions-title": "Abonamente active",
      "available-funds": {
        "pending": "În așteptare: 35 euro",
        "title": "Fonduri disponibile"
      },
      "controls": {
        "desktop": "Calculator",
        "diff-user": "Utilizator diferit",
        "uk": {
          "text-1": "Marea Britanie",
          "text-2": "Londra"
        }
      },
      "hero-data": "Bucurați-vă de plăți fără complicații și fără stres, cu tehnologia Noda de ultimă oră și direcționarea inteligentă",
      "hood-data": {
        "text-1": "Noda asigură procesarea eficientă și fiabilă a cardurilor de plată online cu direcționare optimizată bazată pe amplasamentul geografic, tipul de card și alți factori",
        "text-2": "Creșteți-vă venitul și conversiile cu procesul de plată meticulos elaborat care reduce fricțiunile și ușurează colectarea plăților de către clienți",
        "text-3": "Spuneți adio depășirii bugetului pe cardurile de plată - Direcționarea inteligentă de la Noda vă garantează mereu cea mai bună afacere",
        "text-4": "După colectarea și analiza atentă a punctelor de date ale clienților, modelul AI Noda prezice în timp real nivelurile de risc potențial și blochează tranzacțiile suspecte, reducând debitele și fraudele fără a compromite ratele de autorizare",
        "title-1": "Direcționare inteligentă",
        "title-2": "Maximizați conversiile",
        "title-3": "Optimizați costurile",
        "title-4": "Prezicerea riscurilor cu ajutorul unui model AI"
      },
      "how-data": {
        "items": {
          "text-1": "Puternicul model de analiză a riscurilor bazat pe IA evaluează peste 50 de parametri, oferindu-vă soluții mai inteligente și mai sigure de plată cu cardul și asigurându-vă liniștea.",
          "text-2": "După analizarea atentă a plății și colectarea datelor necesare, modelul de IA de la Noda prognozează nivelurile potențiale de risc în timp real",
          "text-3": "Modelul robust de analiză a riscurilor bazat pe IA funcționează în tandem cu echipa noastră umană pentru a evalua peste 50 de parametri și pentru a oferi soluții de plată cu cardul mai inteligente și mai sigure, asigurând un procent important de tranzacții",
          "title-1": "Observație",
          "title-2": "Estimarea riscurilor",
          "title-3": "Rezolvarea plății"
        }
      },
      "info-data": {
        "subtitle": "Siguranța pe primul loc",
        "text": "Protejați-vă afacerea și clienții folosind estimarea riscurilor bazată pe IA și capacitățile de reacție dinamică pentru plăți cu cardul sigure și fiabile",
        "title": "Evaluarea riscurilor și măsuri"
      },
      "key-features": {
        "text": "Ameliorați-vă procesul de plată cu cardul, folosind tehnologia Noda de direcționare, bazată pe IA, și de acceptare a recuperărilor. Calculatorul nostru evoluat analizează tranzacțiile, le direcționează spre banca ideală de achiziție și ameliorează procentul de acceptare a plăților cu cardul.",
        "title": "Direcționare inteligentă AI și acceptare recuperare"
      },
      "monetization": {
        "subtitle": "Monetizare continuă",
        "text": "Folosiți plata cu cardul în mod automat, la intervale regulate, precum lunar sau anual, fără introducerea de detalii de fiecare dată.",
        "title-1": "Asistență completă pentru ",
        "title-2": "plățile recurente"
      },
      "payments-data": {
        "icon": "header/product-payments.svg",
        "text": "Plăți cu cardul fără efort pentru comercianți",
        "title": "Plăți cu cardul"
      },
      "preference-data-1": {
        "data": {
          "items": {
            "text-1": "Plata este autorizată instantaneu, printr-o singură comunicare între serverele de mentenanță și cele de emitere, fondurile fiind anulate imediat din contul clientului. Această metodă este mai rapidă și oferă o experiență de procesare a plății mai simplificată, dar poate fi mai expusă la fraude",
            "text-2": "Plata este autorizată în primul mesaj între servere și efectuată în al doilea mesaj. Banii clientului sunt rezervați pe card și deduși numai după a doua comunicare. Acest proces de plată în două etape este mai sigur, dar poate avea o durată mai mare",
            "title-1": "Mesaj unic",
            "title-2": "Dublu mesaj"
          }
        },
        "subtitle": "Configurați-vă preferințele",
        "text": "Experiența personalizată de plată cu cardul de la Noda oferă atât sisteme de mesaje unice, cât și duale, pentru a satisface necesitățile activității dvs.",
        "title": "Taxe instantanee și programate"
      },
      "preference-data-2": {
        "data": {
          "items": {
            "text-1": "Protejați-vă afacerea prin jetonizare, procedeu care oferă o securitate mai mare și limitează riscul de breșe în sistemul de date și de fraudă, facilitând în același timp experiența clienților",
            "text-2": "Permiteți clienților să stocheze și să gestioneze în siguranță informațiile cardului, simplificând tranzacțiile viitoare fără necesitatea de a reintroduce informațiile",
            "title-1": "Jetonizare",
            "title-2": "Gestionare carduri"
          }
        },
        "text": "Simplificarea plăților repetitive este principala preocupare a companiei Noda privind simplificarea tranzacțiilor",
        "title": "Proces mai rapid de plăți, printr-un singur clic"
      },
      "refunds-data": {
        "subtitle": "Asistență post-achiziție",
        "text": "Îmbunătățiți experiența clienților cu rambursări fără probleme, folosind atât chei API cât și interfața utilizator",
        "title": "Rambursări simple"
      },
      "single-report-data": {
        "subtitle": "Știință bazată pe date",
        "text": "Urmăriți și monitorizați traficul de plăți, analizați modelele de plată și generați rapoarte cuprinzătoare privind istoricul plăților și performanța, într-un singur tablou de bord",
        "title": "Sistem unic de raportare"
      },
      "subscription-data": {
        "date-1": "Termen de plată: 27 septembrie",
        "date-2": "Termen de plată: 23 octombrie",
        "date-3": "Termen de plată: 31 decembrie",
        "title-1": "Netflix",
        "title-2": "Music Premium",
        "title-3": "Aplicație bibliotecă de cărți"
      },
      "title-1": "Pentru afacerea ta",
      "title-2": "nevoi de afaceri"
    },
    "card-payouts": {
      "card-payouts-title": {
        "1": "Plată cu cardul",
        "2": "pentru tranzacții eficiente"
      },
      "hero-data": "Stabiliți fără efort plăți către furnizori, deținătorii de portofele sau intermediari, folosind plățile noastre prompte cu cardul.",
      "netting-data": {
        "list": {
          "1": "Proces de decontare simplificat",
          "2": "Livrare extrem de rapidă",
          "3": "Direcționare transfer pilotată de IA"
        },
        "subtitle": "Compensare sold",
        "text": "Experimentați plățile către carduri cu viteza fulgerului, prin intermediul direcționărilor noastre globale și localizate de plată cu cardul, oferind fonduri beneficiarilor dvs. în timp real",
        "title": "Livrare instantanee de fonduri"
      },
      "payments-data": {
        "text": "Plăți cu cardul ușoare pentru comercianți",
        "title": "Plăți cu cardul"
      },
      "payouts-data": {
        "items": {
          "credit": {
            "text": "Cu vasta experiență a companiei Noda în domeniul global al plăților cu cardul, furnizăm soluții de plată de cea mai înaltă calitate și personalizate, astfel încât să răspundă necesităților afacerii dvs.",
            "title": "Expertiză în plăți"
          },
          "group": {
            "text": "La Noda, colaborăm cu comercianți și deținătorii de carduri pentru a înțelege complexitatea specifică domeniilor de fluxuri financiare B2C și C2B",
            "title": "Înțelegerea mizelor din domeniu"
          }
        },
        "text": "Uniformizați plățile în masă către persoane particulare, cu Noda Plătiți-vă, cu mai mare ușurință, furnizorii, utilizatorii de piețe și nu numai",
        "title": "Plăți B2C mai rapide, cu cardul, prin Noda"
      },
      "routing-data": {
        "items": {
          "airline": {
            "text": "Cu direcționarea eficientă a companiei Noda, fondurile dvs. vor ajunge la destinație cu viteza fulgerului",
            "title": "Livrare rapidă a fondurilor"
          },
          "map": {
            "text": "Minimizați transferurile bancare suplimentare și taxele asociate acestora, folosind direcționarea avansată a plăților",
            "title": "Costuri reduse"
          }
        },
        "text": "Optimizăm livrarea de fonduri pentru a garanta o viteză maximă și eficiența costurilor, evitând în același timp traseele bancare ineficiente",
        "title": "Direcționare"
      },
      "transfers-data": {
        "items": {
          "approval": {
            "text": "Compensarea balanței asigură transferul fără întârzieri al fondurilor și ajută la menținerea unui flux de numerar sănătos pentru afacerea dvs.",
            "title": "Evitați lipsa de lichidități"
          },
          "wallet": {
            "text": "Utilizați soldul existent pentru a plăti fonduri, eliminând necesitatea unor transferuri bancare suplimentare și a unor costuri suplimentare",
            "title": "Eficiența costurilor"
          }
        },
        "subtitle": "Evitați transferurile suplimentare",
        "text": "Gestionați-vă soldul fără probleme, folosind fondurile pentru a efectua plăți Profitați de această metodă de plată eficientă din punct de vedere al costurilor și de disponibilitatea imediată a fondurilor",
        "title": "Folosiți-vă soldul pentru a efectua plăți"
      }
    },
    "checkout": {
      "ai-routing": {
        "text": "Ameliorați-vă procesul de plată cu cardul, folosind tehnologia Noda de direcționare, bazată pe IA, și de acceptare a recuperărilor. Software-ul nostru avansat analizează tranzacțiile, le direcționează către banca ideală de destinație și îmbunătățește rata de acceptare a plăților cu cardul",
        "title": "Direcționare inteligentă IA și acceptare recuperare"
      },
      "checkout-hero-title": {
        "colored": "Procesare plată",
        "default": "Fără probleme"
      },
      "convenience": {
        "text": "Simplificarea plăților repetitive este o prioritate pentru Noda, aceasta asigurând tranzacții fără probleme. Clienții pot stoca și gestiona detaliile cardului în siguranță, simplificând tranzacțiile viitoare, nefiind necesară reintroducerea informațiilor",
        "title": "Plăți mai rapide, cu plata printr-un singur clic",
        "title-1": "Comoditate înainte de toate"
      },
      "experience-list": {
        "brush": {
          "text": "Personalizați-vă interfața de plată pentru a fi în concordanță cu marca unică, designul și culoarea dumneavoastră",
          "title": "Personalizare UI"
        },
        "task": {
          "text": "Proces de plată mai rapid și fără efort pentru plățile online, cu instrucțiuni clare și ușor de înțeles",
          "title": "UX intuitiv"
        }
      },
      "hero": "Deblocați puterea plăților fără probleme, folosind interfața de plată Noda, ușor de utilizat, și setul cuprinzător de funcții de plată",
      "hood-data": {
        "amount": "Sumă",
        "bank": "Bancă",
        "card-issuer": "Emitentul cardului",
        "card-type": "Tipul cardului",
        "country": "Țară",
        "currency": "Valută",
        "date-time": "Data și ora",
        "geolocation": "Geolocație",
        "metadata": "Metadate",
        "store": "Magazin"
      },
      "how-data": {
        "observation": {
          "text": "Puternicul model de analiză a riscurilor bazat pe IA evaluează peste 50 de parametri, pentru a oferi soluții de plată cu cardul mai inteligente și mai sigure, asigurându-vă liniștea.",
          "title": "Observație:"
        },
        "payment-resolution": {
          "text": "Modelul robust de analiză a riscurilor, bazat pe IA, funcționează în tandem cu echipa noastră umană pentru a evalua peste 50 de parametri și pentru a oferi soluții de plată cu cardul mai inteligente și mai sigure, asigurând rate ridicate de tranzacție",
          "title": "Obiectivul plății"
        },
        "risk-estimation": {
          "text": "După analizarea atentă a plății și colectarea datelor necesare, modelul de IA al companiei Noda prognozează nivelurile potențiale de risc, în timp real",
          "title": "Estimarea riscurilor"
        }
      },
      "info-data": {
        "subtitle": "Siguranța pe primul loc",
        "text": "Protejați-vă afacerea și clienții folosind estimarea riscurilor bazată pe IA și capacitățile de reacție dinamică, pentru plăți cu cardul sigure și fiabile",
        "title": "Evaluarea riscurilor și răspuns"
      },
      "localised-checkout": {
        "text": "Activați experiența de plată personalizată pentru clienți la nivel global. Noda oferă localizare avansată în 10 limbi, compatibilitate între dispozitive și metode de plată optimizate pentru anumite regiuni",
        "title": "Plată locală la nivel global"
      },
      "localization-list": {
        "chart": {
          "text": "Noda trece dincolo de simpla adaptare lingvistică, personalizând metodele de plată și implementând cele mai bune practici locale pentru fiecare țară",
          "title": "Localizare reglată fin"
        },
        "mobile": {
          "text": "Îmbunătățiți experiența clienților prin procesul optimizat de plăți, adaptabil la orice dispozitiv și software",
          "title": "Cross-screen și multi-platform"
        }
      },
      "payment-methods": {
        "text": "Fie că este vorba de transferuri bancare, carduri de credit sau de debit sau portofele mobile, Noda le are pe toate. Cu zeci de metode de plată integrate, comercianții își pot optimiza fluxurile de plată și pot oferi clienților flexibilitatea de care au nevoie pentru a-și finaliza achizițiile",
        "title": "Metode nelimitate de plată"
      },
      "payments-data": {
        "text": "Experiență de plată simplificată pentru clienți",
        "title": "Formular de finalizare a comenzii"
      },
      "personal-touch": {
        "text": "Noda prognozează și reamintește, în mod inteligent, fluxul optim de plată al fiecărui client, inclusiv metoda de plată preferată, și permite achiziții fără probleme și ușoare pentru clienți",
        "title": "Răspunde nevoilor tuturor clienților dumneavoastră",
        "title-1": "Atingere personală"
      },
      "refunds-data": {
        "subtitle": "Asistență post-achiziție",
        "text": "Îmbunătățiți experiența clienților cu rambursări fără probleme, atât prin API, cât și prin interfața cu utilizatorul",
        "title": "Rambursări fără probleme"
      },
      "single-report-data": {
        "subtitle": "Știință bazată pe date",
        "text": "Urmăriți și monitorizați traficul de plăți, analizați modelele de plată și generați rapoarte cuprinzătoare privind istoricul plăților și performanța, cu ajutorul unui singur tablou de bord",
        "title": "Sistem unic de raportare"
      },
      "tailored-experience": {
        "text": "Procesul personalizat de plată al companiei Noda este adaptat infrastructurii comerciantului, ceea ce duce la o experiență de plată mai ușoară și mai obișnuită pentru clienții dvs.",
        "title": "Experiență de plată personalizată pentru clienții dvs."
      }
    },
    "common": {
      "about": {
        "company": {
          "subtext": "Aflați mai multe despre istoria și conducerea noastră",
          "subtitle": "Compania"
        },
        "legal-privacy": {
          "subtext": "Revizuiți documentația noastră juridică",
          "subtitle": "Juridic și confidențialitate"
        },
        "mission": {
          "subtext": "Descoperiți misiunea, viziunea Noda și ceea ce ne face unici",
          "subtitle": "Cine suntem"
        },
        "partnership": {
          "subtext": "Deveniți partenerul nostru",
          "subtitle": "Parteneriat"
        },
        "risk-policies": {
          "subtext": "Familiarizați-vă cu politica noastră de respectare a riscurilor",
          "subtitle": "Politici de risc și AML/CFT"
        },
        "security": {
          "subtext": "Aflați mai multe despre eforturile și politicile de securitate ale Noda",
          "subtitle": "Securitatea și gestionarea datelor"
        },
        "ux-approach": {
          "subtext": "Explorați ce înseamnă UX pentru Noda",
          "subtitle": "Abordare UX"
        },
        "white-label": {
          "footer": "Parteneri White Label",
          "subtext": "Construiește-ți propria platformă de plăți cu Noda",
          "title": "Pentru partenerii White Label"
        },
        "why-open-banking": {
          "subtext": "Demitizați miturile despre Open Banking",
          "subtitle": "De ce Open Banking?"
        }
      },
      "automated-data": {
        "item-1": "Corect: reducerea riscului de eroare",
        "item-2": "Eficient: elimină întârzierile",
        "item-3": "Securizat: verificarea tuturor chestiunilor"
      },
      "automated-payouts-text": "Prin procesul de automatizare și validare, Noda contribuie la asigurarea procesării rapide, corecte și securizate  a plăților efectuate, furnizând o experiență fără efort atât pentru comercianți cât și pentru primitorii plăților.",
      "automated-payouts-title": "Verificarea și validarea automată a plăților efectuate",
      "banner-market": {
        "button": "Accesați marketplace",
        "text": "Creștere constantă sau transformare rapidă?<br/> Știți când este timpul să vă duceți afacerea la un nivel superior.",
        "title": "O nouă abordare a plăților&nbsp;–<br />Consultați toate produsele Noda"
      },
      "best-conditions-v2": {
        "additional": {
          "btn": "Contact Sales Team",
          "details": {
            "option-1": "Gratuit pentru primele trei luni pentru IMM-uri",
            "option-2": "Bani instant în contul dvs.",
            "option-3": "Riscuri de fraudă aproape zero",
            "option-4": "Rată de acceptare de 90%"
          },
          "offer": "Pentru a obține o ofertă de preț personalizată, vă rugăm să contactați echipa noastră de vânzări",
          "subtitle": "Experimentați plăți rapide și sigure cu planul de comerț electronic Noda",
          "title": "Pentru toate tipurile și mărimile de companii"
        },
        "btn": "fără comisioane de configurare",
        "description": "Maximizați-vă profiturile cu prețuri accesibile și",
        "subtitle": "Planuri scalabile pentru a vă satisface nevoile de afaceri",
        "title": "Cele mai bune condiții pentru fiecare afacere"
      },
      "call-to-action": {
        "contact-btn": "Contact Vânzări",
        "contact-team-btn": "Contactați-Ne",
        "contact-team-btn-2": "Contactați echipa noastră",
        "explore": "Răsfoiți documentele",
        "get-notified": "Primiți notificări",
        "get-started": "Începe",
        "learn-more": "Aflați mai multe",
        "read-less": "Citiți mai puțin",
        "read-more": "Citiți mai mult",
        "sign-up": "Deconectare în 10 minute",
        "start": "Pornire",
        "start-using-noda": "Începe",
        "try-noda": "Încercați Noda",
        "use-cases-btn": "Mai Multe Despre Open-Banking",
        "withdraw": "Retragere în contul bancar"
      },
      "contact": {
        "all-rights": " Noda. Toate drepturile rezervate",
        "careers": "Cariere",
        "client-support": "Asistență clienți",
        "contact-us": "Contactați-ne",
        "cookie": "Politica privind confidențialitatea",
        "follow": "Urmăriți-ne",
        "hr": "Echipa de resurse umane",
        "marketing": "Marketing",
        "naudapay-limited": "NAUDAPAY LIMITED, (Număr înreg. companie: 11741664), cu sediul înregistrat la adresa: 162 Buckingham Palace Road, London, SW1W 9TR, UK este o instituție de plată autorizată și reglementată de Autoritatea de Conduită Financiară (FCA) (număr de referință: 832969) în temeiul Directivei privind serviciile de plată ((UE) 2015/2366)",
        "partnership": "Parteneriat",
        "policy": "Politica de confidențialitate",
        "public-relations": "Relații publice",
        "support": "Solicitați asistență",
        "terms": "Termeni de utilizare"
      },
      "currency": {
        "subtitle": "Capacități",
        "text": "Extindeți-vă afacerea la nivel internațional cu oferta de plăți Noda în peste 100 de valute mondiale.",
        "title": "Variație de valute"
      },
      "developers": {
        "bank-payouts-api": "API plăți bancare",
        "card-payments-api": "API plăți cu cardul",
        "card-payouts-api": "API plăți cu cardul",
        "login-to-hub": {
          "subtitle": "Control deplin asupra tuturor caracteristicilor",
          "title": "Autentificare în Hub"
        },
        "noda-plugins": {
          "subtitle": "Plugin-uri pentru platforme ecom",
          "title": "Plugin-uri Noda"
        },
        "ob-payments-api": "API plăți OB",
        "open-banking-demo": {
          "subtitle": "Verificați cum funcționează produsele Noda",
          "title": "Noda Demo"
        },
        "pay-and-go": "Pay & Go",
        "tech-documentation": {
          "subtitle": "Control deplin asupra tuturor caracteristicilor",
          "title": "Documentație tehnică"
        }
      },
      "discover-more-title": "Descoperiți mai multe caracteristici",
      "discover-title": "Descoperiți",
      "extensive-product-suite-v2": {
        "description": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "description-v2": "Descoperiți noi oportunități pentru afacerea dvs. cu ecosistemul de servicii de plată Noda. Primiți și trimiteți plăți cu ușurință. Îmbunătățiți-vă operațiunile cu serviciile noastre de date de plată ușor de utilizat și cu soluțiile de plată fără cod.",
        "subtitle": "Caracteristici și integrări",
        "title": "Suită extinsă de produse"
      },
      "features": {
        "info": {
          "1": {
            "text": "Proces de configurare rapid și simplu. Înscriere și gestionare a cheilor API automatizate, disponibile în Noda Hub.",
            "title": "Înscriere ușoară"
          },
          "2": {
            "text": "Gestionarea sigură, rapidă și eficientă a tranzacției",
            "title": "Tranzacții securizate"
          },
          "3": {
            "text": "Integrare fără egal cu orice pachet tehnologic pe care îl alegeți",
            "title": "Integrare armonioasă"
          },
          "4": {
            "text": "Experiență de înregistrare personalizată cu managerul de cont personal",
            "title": "Manager personal"
          },
          "5": {
            "text": "Raportări în profunzime și analize disponibile în Noda Hub",
            "title": "Analize"
          },
          "6": {
            "text": "Procesare simplă și simplificată a plăților de rambursare",
            "title": "Rambursări"
          },
          "7": {
            "text": "Conectivitate fără efort cu băncile cele mai importante din Marea Britanie și UE în ecosistem",
            "title": "Bănci de încredere"
          },
          "8": {
            "text": "Asistență pentru o varietate de roluri de utilizatori în Noda Hub",
            "title": "Roluri multiple"
          },
          "9": {
            "text": "Conturi Client - Bancă (C2B) sunt disponibile pentru comercianți",
            "title": "Conturi C2B"
          },
          "10": {
            "text": "Funcții avansate de securitate, inclusiv liste negre locale și mondiale",
            "title": "Liste negre"
          }
        },
        "subtitle": "Informați-vă despre acoperirea Noda",
        "text": "Prezentarea celor mai importante zece caracteristici personalizate pentru afacerea dvs.",
        "title": "Caracteristici cheie"
      },
      "footer": {
        "features-release": "Lansăm sute de caracteristici și îmbunătățiri an de an pentru a vă ajuta să fiți cu un pas înaintea schimbărilor din industrie și să construiți o bază solidă pentru afacerea dvs",
        "how-to-integrate": "Realizarea integrării",
        "lets-get-in-touch": "Haideți să ne cunoaștem",
        "stay-connected": "Fiți mereu conectați",
        "stay-connected-text": "Contactați echipa noastră pentru a afla mai multe despre parteneriat și colaborare",
        "total-balance": "Total sold",
        "ultimate-provider": "Furnizorul esențial de servicii open banking"
      },
      "geo-v2": {
        "button": "Vezi lista de bănci acceptate",
        "subtitle": "Locații",
        "text": "Bucurați-vă de acoperirea noastră globală, asigurând o rată de acceptare ridicată în fiecare colț al lumii",
        "title": "Acoperire geografică integrală",
        "title-v2": "Acoperire globală extinsă"
      },
      "get-started": "Începe",
      "header": {
        "about": "Despre",
        "articles": "Articole",
        "case-studies": "Studii de caz",
        "developers": "Dezvoltatori",
        "events": "Evenimente",
        "glossary": "Glosar de termeni",
        "marketplace": "Piețe",
        "newsroom": "Sala de redacție",
        "other": "Altele",
        "pricing": "Tarife",
        "products": "Produse",
        "resources": "Resurse",
        "use-cases": "Cazuri de utilizare"
      },
      "hero-v2": {
        "new": "Nou",
        "personal-onboarding-assistant": "Asistent personal de implementare pentru fiecare companie"
      },
      "how-to-start": {
        "subtitle-1": "Îmbarcare Ușoară",
        "text": "Noda oferă o îmbarcare ușoară cu ghidarea personalizată a unui manager dedicat. Echipa noastră este aici pentru a ajuta cu orice obstacole. Pentru a începe să utilizați Noda, pur și simplu completați formularul, iar reprezentanții noștri de vânzări vă vor contacta în curând.",
        "title-1": "Cum să începeți"
      },
      "identification-text": "Noda furnizează proceduri KYC fără egal folosind tehnologia sa open-banking de vârf, scutind clienții de problemele de trimitere a documentelor și selfie-urilor.",
      "kyc-title": "Tehnologie de vârf de cunoaștere a clienților, la cerere",
      "more-title": "Mai multe caracteristici",
      "not-verified": "80% verificat",
      "offer-for-smbs": {
        "from": "De la",
        "per-transaction": "per tranzacție",
        "title": "Gratuit primele 3 luni pentru IMM-uri"
      },
      "payee-identification-title": "Identificare Open-banking a destinatarilor",
      "personal-manager": "Managerul dvs. personal",
      "post-payment-support": "Noda oferă asistență post-plată completă, focalizată pe colaborare și progres",
      "products": {
        "financial-data": {
          "know-your-whales": {
            "subtext": "Informații financiare predictive pentru comercianți",
            "subtext-2": "Informații financiare și previziuni pentru comercianți",
            "subtitle": "Îmbogățirea datelor"
          },
          "sign-in-via-bank": {
            "subtext": "Conectare securizată, cu un singur clic, cu datele bancare",
            "subtitle": "Conectare prin bancă"
          },
          "title": "Date financiare",
          "virtual-ibans": {
            "subtext": "Transferuri bancare globale cu IBAN virtual",
            "subtitle": "IBAN-uri virtuale"
          }
        },
        "noda-go": {
          "pay-and-go-hard": "Pay & Go Hard",
          "pay-and-go-light": "Pay & Go Light"
        },
        "pay-ins": {
          "card-payments": {
            "subtext": "Procesare ușoară a plăților cu cardul pentru comercianți",
            "subtitle": "Plăți cu cardul"
          },
          "checkout-form": {
            "subtext": "Experiență de plată simplificată pentru clienți",
            "subtitle": "Formular de finalizare a comenzii"
          },
          "instant-payment-links": {
            "subtext": "Plată flexibilă pentru diferite tipuri de suporturi",
            "subtitle": "Linkuri de plată instantanee"
          },
          "merchant-of-record": {
            "subtext": "Soluție all-in-one pentru gestionarea tuturor plăților și obligațiilor legale",
            "subtitle": "Merchant of Record"
          },
          "no-code-payment": {
            "subtext": "Pagini de plată personalizate prin AI Builder",
            "subtitle": "Pagină De Plată Fără Cod"
          },
          "open-banking-payments": {
            "subtext": "Transferuri bancare rapide, sigure și reglementate",
            "subtitle": "Plăți Open Banking"
          },
          "title": "Încasări"
        },
        "pay-outs": {
          "bank-payouts": {
            "subtext": "Plăți bancare convenabile și rapide pentru comercianți",
            "subtitle": "Plăți bancare"
          },
          "card-payouts": {
            "subtext": "Plăți cu cardul ușoare pentru comercianți",
            "subtitle": "Plăți cu cardul"
          },
          "title": "Plăți"
        }
      },
      "resources": {
        "articles": "Articole",
        "glossary": "Glosar de termeni"
      },
      "subscribe": {
        "title-1": "Obțineți ultimele noutăți de la Noda",
        "title-2": "Rămâneți la curent cu Noda abonându-vă la newsletter-ul nostru"
      },
      "tech-friendly-v2": {
        "acceptance-rate": {
          "option-1": "Peste 90%",
          "option-2": "rată de acceptare"
        },
        "api-key-management": {
          "description": "Gestionarea ușoară a cheilor API"
        },
        "description": "Noda oferă o integrare fără probleme cu API-ul său și cu componentele sale front-end, asigurând o integrare fără probleme în platforma dumneavoastră. Experimentați o configurare rapidă și eficientă și începeți să oferiți soluții de plată mai bune clienților dvs. în câteva ore, nu săptămâni.",
        "gateway": {
          "description": "Gateway sigur și fiabil"
        },
        "subtitle": "Avansat din punct de vedere tehnologic",
        "tech-platforms-support": {
          "description": "Sunt acceptate toate tipurile de platforme tehnice"
        },
        "title": "Integrare perfectă pentru plăți mai bune: lansare în câteva ore, nu&nbsp;săptămâni"
      },
      "transaction-control": {
        "part-title-1": "Tranzacții de control în societatea noastră",
        "part-title-2": "Tablou de bord multifuncțional",
        "text-1": "Cu Noda Hub vă puteți înregistra fără efort, configura preferințele privind tranzacțiile, monitoriza tranzacțiile și rapoartele și analiza fluxul de plăți, totul pe o singură platformă",
        "text-2": "Funcții combinate pentru gestionarea fără efort a plăților",
        "title-2": "Monitorizați cu încredere"
      },
      "use-cases": {
        "ecommerce": {
          "subtext": "Gateway de plată pentru comerț electronic",
          "subtitle": "Comerț Electronic"
        },
        "educational-platforms": {
          "subtext": "Gateway de plată pentru platforme educaționale",
          "subtitle": "Platforme educaționale"
        },
        "marketplaces": {
          "subtext": "Gateway de plată pentru piețe",
          "subtitle": "Piețe"
        },
        "online-gaming": {
          "subtext": "Gateway de plată pentru jocuri online",
          "subtitle": "Jocuri online"
        },
        "retail": {
          "subtext": "Gateway de plată pentru comerțul cu amănuntul",
          "subtitle": "Comerț cu Amănuntul"
        },
        "saas": {
          "subtext": "Gateway de plată pentru SaaS",
          "subtitle": "SaaS"
        },
        "travel": {
          "subtext": "Soluții de plată pentru afaceri de călătorie",
          "subtitle": "Călătorie și Turism"
        }
      },
      "verified": "100% verificat"
    },
    "company": {
      "articles": {
        "title": "Ultimele știri de la Noda"
      },
      "hero": {
        "part-1": "Plățile dvs, ",
        "part-2": "Prioritatea noastră",
        "text": "Suntem Noda - un furnizor de plăți lider la nivel mondial - oferim comercianților online o nouă modalitate de a accepta plăți online și de a primi instantaneu plăți bancare directe ca alternativă la carduri, fără returnări"
      },
      "leadership": {
        "ceo": {
          "name": "Igor Loktev",
          "role": "CEO/Co-Founder",
          "text": "Igor aduce echipei noastre peste 20 de ani de experiență în IT și finanțe. Cu o diplomă în informatică, un Executive MBA și studii de doctorat în curs de desfășurare în calcul cuantic, el excelează în ingineria produselor, analiza datelor și optimizarea sistemelor.\n\nIgor este dedicat creșterii Noda și promovării inovației în sectorul fintech.\n\nInteresul său pronunțat pentru sport, muzică și domeniul dinamic al informaticii joacă, de asemenea, un rol esențial în abordarea sa profesională."
        },
        "clo": {
          "name": "Ellina Sedleniece",
          "role": "Chief Legal Officer (CLO)",
          "text": "Ellina aduce în echipă o bogată experiență de 15 ani în domeniul juridic, concentrându-se pe fuziuni și achiziții, fintech, capital de risc, protecția datelor, banking și finanțe.\n\nEa este dedicată oferirii de soluții juridice inovatoare și orientate spre rezultat, concepute pentru a stimula creșterea afacerilor, a minimiza riscurile și a proteja interesele companiei. Cu o solidă fundamentare educativă obținută la Facultatea de Drept din Riga, Ellina a obținut un LLM în Drept Internațional și European în 2019, urmat de un LLM în Dreptul Tehnologiei în 2020.\n\nRezidentă în Riga, abordarea Ellinei combină expertiza sa juridică vastă cu o mentalitate orientată spre viitor, navigând cu succes prin complexitatea peisajului global și tehnologic actual. Interesele sale diverse, precum arta jocului la pian, plăcerile călătoriilor și lumea captivantă a lecturii, își găsesc, de asemenea, locul în abordarea sa profesională."
        },
        "coo": {
          "name": "Anastasija Tenca",
          "role": "Chief Operations Officer (COO)",
          "text": "Anastasija este un profesionist orientat către succes, cu peste 10 ani de experiență în domeniile vânzărilor, marketingului, managementului de marcă și managementului proiectelor, precum și în administrarea și operarea companiei.\n\nEa joacă un rol esențial în coordonarea tuturor aspectelor operaționale ale Noda, dedicându-se dezvoltării și implementării inițiativelor strategice de afaceri. Contribuția sa la Noda include dezvoltarea și implementarea strategiilor de afaceri care conduc la succes, construirea unor relații comerciale robuste și de lungă durată, rafinarea proceselor pentru eficiență maximă și supravegherea activităților financiare ale organizației.\n\nExpertiza diversă a Anastasijei și abordarea sa strategică în managementul operațiunilor de afaceri o fac o resursă valoroasă pentru echipa noastră și un arhitect principal al creșterii continue și inovației Noda."
        },
        "cro-cco": {
          "name": "Lasma Gavarane",
          "role": "Chief Risk & Compliance Officer (CRO & CCO)/MLRO",
          "text": "Lasma aduce aproape un deceniu de experiență în industria fintech, specializându-se în risc și conformitate. Cariera sa profesională este susținută de o dublă pregătire academică, cu diplome de licență în Managementul Afacerilor și Drept.\n\nLasma nu este doar membră a Asociației Internaționale a Specialiștilor Certificați în Prevenirea Spălării Banilor (ACAMS), dar deține și certificarea avansată de Specialist Certificat în Prevenirea Spălării Banilor - Managementul Riscului (CAMS-RM), ceea ce o poziționează ca expert în industria de risc și conformitate.\n\nInteresul ei profund pentru modul în care avansurile tehnologice, cum ar fi cele din domeniul NewGen, inclusiv IA, pot îmbunătăți și inova diferite aspecte ale mediilor profesionale și cum pot fi aplicate și integrate la Noda."
        },
        "cro": {
          "name": "Michael Bystrov",
          "role": "Chief Revenue Officer at Noda",
          "text": "La conducerea strategiilor Noda pentru generarea de venituri, Michael Bystrov, în rolul său de Director de Venituri, aduce o experiență vastă de 18 ani în domeniul vânzărilor și marketingului la diverse companii internaționale. Experiența sa variază de la gestionarea distribuției regionale a Apple la conducerea campaniilor ATL și BTL pentru mărci prestigioase precum Nestle, JTI și Grupul Diageo.\n\nEchipat cu un master în Management Financiar și un grad asociat în Marketing și Publicitate, Michael are o înțelegere profundă a dinamicii pieței. Expertiza sa a fost crucială în pregătirea formatelor publicitare pentru locațiile olimpice și în implicarea în segmentul de Relații Guvernamentale (GR).\n\nÎn afara domeniului său profesional, Michael este un călător pasionat, ceea ce îmbogățește perspectiva sa globală asupra afacerilor, și este dedicat conservării balenelor, demonstrând angajamentul său față de cauzele de mediu."
        },
        "cso": {
          "name": "Volodymyr Mykhailin",
          "role": "Chief Solutions Officer",
          "text": "Volodymyr îmbină excelența academică și expertiza profesională, având un background în Ingineria Sistemelor și Rețelelor de Calculatoare. Cu vasta sa experiență în sectorul IT, el excellează în integrarea soluțiilor tehnologice avansate în procesele noastre de afaceri, îmbunătățind astfel atât eficiența operațională cât și satisfacția clienților.\n\nDedicat avansării inovației tehnologice, Volodymyr conduce echipa noastră în dezvoltarea de strategii și soluții IT sofisticate care depășesc cerințele pieței globale. Lideriatul său asigură că compania noastră rămâne în avangarda industriei tech.\n\nÎn plus față de realizările sale profesionale, interesele diverse ale lui Volodymyr, cum ar fi drumețiile montane și muzica, cultivă reziliența și gândirea strategică, care îmbogățesc atât viața sa profesională cât și pe cea personală."
        },
        "cto": {
          "name": "Andrei Batseka",
          "role": "Chief Technical Officer (CTO)",
          "text": "Andrei aduce o experiență solidă de 13 ani în programare și dezvoltare în echipa noastră, susținută de o diplomă de licență în Informatică. Expertiza sa acoperă diverse domenii, făcându-l un membru versatil și calificat al departamentului nostru tehnic.\n\nLa Noda, Andrei joacă un rol central în conducerea inițiativelor tehnologice cheie și inovațiilor, aducându-și cunoștințele profunde de programare în prim-planul proiectelor noastre. Angajamentul său față de învățare continuă și dezvoltare este evident în interesul său mare pentru învățarea automată și rețelele neuronale, pe care le integrează activ în munca sa.\n\nPe lângă activitățile sale profesionale, pasiunea lui Andrei pentru a cânta la diverse instrumente muzicale, alături de dragostea sa pentru înot și ciclism, reflectă personalitatea sa dinamică și complexă. Aceste hobby-uri nu numai că îi îmbogățesc viața, dar și oferă inspirație pentru o abordare creativă și holistică în munca sa tehnică."
        },
        "cxd": {
          "name": "Vladislav Golovach",
          "role": "Chief Experience Designer (CXD)",
          "text": "Vladislav aduce echipei Noda o experiență de 20 de ani în ergonomie și utilitate, prosperând în proiecte UX care reprezintă provocații și necesită cercetări aprofundate.\n\nCariera sa de autor și pionier în designul UI și UX este marcată de capacitatea sa de a crea interfețe care sunt atât intuitive, cât și elegante, de a transforma ideile complicate în sisteme accesibile și de a distila cercetarea privind utilizatorii în îmbunătățiri practice.\n\nCu domiciliul în Padova, Italia, Vladislav combină dragostea sa pentru design cu pasiunea pentru a crea experiențe folositoare pentru utilizatori."
        },
        "strategy-advisor": {
          "name": "Lasma Kuhtarska",
          "role": "Co-Founder, Strategy Advisor",
          "text": "Lasma Kuhtarska este un profesionist distins, cu o experiență bogată în finanțe și dezvoltarea afacerilor. În 2020, ea a conceput și a avut un rol de pionierat în crearea companiei Noda, servind drept forța motrice din spatele platformei noastre inovatoare. În calitate de cofondator și director de strategie, Lasma joacă un rol cheie în modelarea și implementarea strategiilor inovatoare aflate la baza creșterii companiei Noda.\n\nÎn ceea ce privește formarea sa, Lasma a studiat la prestigioasa Facultate de Științe Economice din Stockholm și, în plus, a urmat cursurile în domeniul științei datelor pentru afaceri la Harvard Business School. Înainte de a deveni cofondator al Noda, Lasma a lucrat în domeniul analizei financiare la Banca Centrală a Letoniei și și-a valorificat abilitățile sale la SEB Group - una dintre cele mai mari bănci din Suedia și statele baltice."
        },
        "title": "Leadership\nNoda"
      },
      "noda-timeline": {
        "events": {
          "option-1": "Versiunea beta a sistemului nostru deschis de plăți bancare a fost lansată live",
          "option-2": "Primul comerciant a intrat în funcțiune",
          "option-3": "A început distribuția în masă",
          "option-4": "Majoritatea covârșitoare a băncilor din UE și Regatul Unit au fost conectate",
          "option-5": "Lansarea plăților B2C",
          "option-6": "Companii înființate în Canada, Australia, Brazilia",
          "option-7": "Noi servicii lansate: Servicii de date AIS, legături de plată generate de AI",
          "option-8": "Obținerea licențelor în Brazilia și Australia, lansarea plăților în Brazilia"
        },
        "month": {
          "1": "Aprilie, 2021",
          "2": "August, 2021",
          "3": "Decembrie, 2021",
          "4": "Iulie, 2022",
          "5": "Octombrie, 2022",
          "6": "Mai, 2023",
          "7": "Decembrie, 2023",
          "8": "Mai, 2024"
        },
        "subtitle": "Cronologia Noda",
        "title": "Noda crește odată cu afacerea dvs"
      },
      "our-story": {
        "description1": "Noda este TU. Încercăm să fim oameni înainte de a fi un furnizor de servicii de plată. Fiind proiectați de oameni pentru oameni, oferim una dintre cele mai bune experiențe de utilizare disponibile în prezent pe piață.",
        "description2": "Suplimentele Noda sunt pline de căldură și sunt cu adevărat concepute pentru a acoperi toate nevoile clienților în modul cel mai convenabil și cu economie de timp. Nimănui nu-i place să petreacă ore întregi încercând să plătească pentru bunuri sau servicii online. Plata în sine nu este cea mai plăcută dintre experiențe. Haideți să o facem, cel puțin, mai puțin consumatoare de timp.",
        "description3": "Ne-am dori ca consumatorii noștri să-și petreacă timpul cu prietenii și familia, bucurându-se de momentele prețioase ale vieții, mai degrabă decât, de exemplu, să petreacă o veșnicie planificând cum să transfere bani pentru hotel sau mașina închiriată, sau să deconteze cheltuielile între prieteni pentru a plăti o excursie.",
        "subtitle": "Povestea noastră",
        "title": "Noda ești tu"
      }
    },
    "contact-form-v2": {
      "about": "Despre noi",
      "address": "NAUDAPAY LIMITED, Company number: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Spuneți-ne despre afacerea dvs., iar experții noștri în plăți vă vor ajuta să găsiți configurația perfectă pentru nevoile dvs.",
      "form": {
        "btn": "Trimiteți",
        "controls": {
          "comment": "Opțional: Partajați modelul dvs. de afaceri și nevoile de plată. Acest lucru ne ajută să vă personalizăm soluția și să accelerăm procesul de configurare.",
          "company": "Numele companiei",
          "email": "E-mail de serviciu",
          "first-name": "Prenume",
          "last-name": "Nume de familie",
          "phone": "Număr de serviciu *",
          "select-country": "Selectați țara",
          "website": "Site-ul produsului"
        },
        "labels": {
          "business": "Spune-ne mai multe despre afacerea ta",
          "comment": "Descrierea modelului de afaceri",
          "contact": "Introduceți datele dvs. de contact",
          "details": "Informațiile dvs. de contact"
        }
      },
      "header": "Contactaţi-ne",
      "modal": {
        "back": "Întoarceți-vă la piață",
        "description": "Ne vom conecta cu tine în curând.",
        "explore": "Explorați Noda",
        "header": "🙌 Sunteți gata!"
      },
      "privacy": "Politica de confidențialitate",
      "rights": "Noda. Toate drepturile rezervate",
      "showcase": {
        "payment": "Selectați soluțiile de plată de care aveți nevoie",
        "recommended": "S-ar putea să te intereseze și tu",
        "related": "Soluții înrudite",
        "selected": "Produsele selectate de dumneavoastră"
      },
      "terms": "Termeni de utilizare",
      "visit-website": "Vizitați site-ul complet"
    },
    "contact-form": {
      "about": "Despre noi",
      "address": "NAUDAPAY LIMITED, Company number: 11741664, 162 Buckingham Palace Road, London, SW1W 9TR, UK",
      "description": "Completați formularul, vă rugăm",
      "form": {
        "controls": {
          "comment": "Vă rugăm să explicați modelul dvs. de afaceri. Prezentați pe scurt domeniul de aplicare al proiectului dumneavoastră. Includeți principalele caracteristici și funcții pe care doriți să le deservească platforma Noda.",
          "company": "Numele companiei",
          "company-size": "Dimensiunea companiei",
          "country": "Țara",
          "email": "E-mail de serviciu",
          "first-name": "Prenume",
          "last-name": "Nume de familie",
          "phone": "Număr de serviciu",
          "volume": "Volumul plăților",
          "website": "Site-ul companiei"
        },
        "labels": {
          "business": "Introduceți informații despre afacerea dvs",
          "comment": "Descrierea modelului de afaceri",
          "contact": "Introduceți datele dvs. de contact",
          "details": "Introduceți detaliile dvs",
          "volume": "Anunțați-ne volumul dvs"
        },
        "volume": {
          "option-1": "Mai puțin de 50.000 USD",
          "option-2": "50.000 USD până la 100.000 USD",
          "option-3": "100.000 USD până la 1.000.000 USD",
          "option-4": "1.000.000 USD până la 10.000.000 USD",
          "option-5": "Peste 10.000.000 USD"
        }
      },
      "header": "Contactați echipa noastră de vânzări",
      "modal": {
        "back": "Întoarceți-vă la piață",
        "description": "Vă mulțumim pentru contact, vă vom contacta în scurt timp.",
        "header": "Trimitere primită!"
      },
      "powered": "Powered by",
      "privacy": "Politica de confidențialitate",
      "rights": "Noda. Toate drepturile rezervate",
      "showcase": {
        "recommended": "S-ar putea să vă intereseze și",
        "selected": "Produsele selectate de dumneavoastră"
      },
      "terms": "Termeni de utilizare"
    },
    "contact-us": {
      "contact-us-hero": {
        "1": "Relații publice",
        "2": "Marketing",
        "3": "Asistență clienți",
        "4": "Cariere",
        "5": "Parteneriat",
        "6": "Echipa de vânzări"
      },
      "contact-us-locations": {
        "london": {
          "text": "162 Buckingham Palace Road, London, SW1W 9TR, UK",
          "title": "Londra, Marea Britanie"
        },
        "madrid": {
          "text": "Calle Huertas 11, 28012, Madrid, Spain",
          "title": "Madrid, Spania"
        },
        "ontario": {
          "text": "1907 Baseline Road, Unit 104, Ottawa, Ontario, K2COC7, Canada",
          "title": "Ontario, Canada"
        },
        "riga": {
          "text": "Riga, Pils iela 18-23, Latvija, LV-1050",
          "title": "Riga, Letonia"
        },
        "vilnius": {
          "text": "Lituania, Vilnius, Žalgirio g.90-100, LT-09303",
          "title": "Vilnius, Lituania"
        }
      },
      "hero-text": "Contactați-ne și spuneți-ne cu ce vă putem ajuta - Noda este întotdeauna deschis dialogului",
      "hero-title": "Locațiile noastre",
      "locations-text": "Noda este o companie internațională cu diferite locații în întreaga lume"
    },
    "cookies": {
      "last-update": "Ultima actualizare la <data>13 septembrie 2024</data>",
      "section-1": {
        "list": {
          "item-1": "Cookie-urile necesare sunt utilizate pentru a asigura funcționarea site-ului web. Aceste module cookie sunt utilizate pe baza interesului legitim al Noda de a asigura funcționarea site-ului web și de a furniza servicii. Utilizarea acestor module cookie nu necesită consimțământul dumneavoastră.",
          "item-2": "Cookie-urile de preferințe și de performanță ajută la desfășurarea anumitor funcționalități pe care doriți să le utilizați în timp ce vă aflați pe site-ul nostru, de exemplu, legate de utilizarea formularelor de mesagerie și de contact, înregistrarea, alegerea limbii și utilizarea funcționalităților legate de locație. Utilizarea acestor module cookie nu necesită consimțământul dumneavoastră.",
          "item-3": "Cookie-urile statistice sunt utilizate pentru a colecta și analiza informații despre acțiunile dvs. pe site-ul web și pentru a îmbunătăți funcționalitatea acestuia. Aceste module cookie ajută la furnizarea de informații privind metrica numărului de vizitatori, rata de respingere, sursa traficului și alte informații conexe. Utilizarea acestor module cookie necesită consimțământ.",
          "item-4": "Cookie-urile de marketing, de targetare sau promoționale sunt utilizate pentru a colecta informații despre site-urile web pe care le vizitați și pentru a segmenta vizitatorii site-ului web în scopuri de marketing. Aceste module cookie sunt, de asemenea, utilizate pentru a oferi vizitatorilor reclame și campanii de marketing relevante. Utilizarea acestor module cookie necesită consimțământul dvs. Dacă nu permiteți aceste module cookie, în unele cazuri veți avea parte de publicitate mai puțin targetată."
        },
        "text-1": "Un modul cookie este o mică bucată de date (fișier text) pe care un site web - atunci când este vizitat de un utilizator - solicită browserului dvs. să o stocheze pe dispozitivul dvs. pentru a reține informații despre dvs., cum ar fi limba preferată sau informațiile de conectare. Aceste module cookie sunt setate de noi și se numesc module cookie de primă parte. De asemenea, utilizăm module cookie de terță parte - care sunt module cookie de la un domeniu diferit de domeniul site-ului web pe care îl vizitați. Mai exact, utilizăm module cookie în următoarele scopuri:",
        "text-2": "Cookie-urile sunt primite de Noda și partenerii săi pentru a asigura funcționarea site-ului web, pentru a colecta și analiza activitățile dumneavoastră pe site. Cookie-urile pot colecta diferite tipuri de informații, cum ar fi adresa IP, tipul de dispozitiv utilizat, browserul utilizat, site-urile web vizitate sau alte informații.",
        "title": "1. Ce sunt modulele cookie?"
      },
      "section-2": {
        "title": "2. Cookie-uri necesare"
      },
      "section-3": {
        "title": "3. Cookie-uri de preferințe și de performanță"
      },
      "section-4": {
        "title": "4. Cookie-uri statistice"
      },
      "section-5": {
        "title": "5. Cookie-uri de marketing, de targetare sau promoționale"
      },
      "section-6": {
        "text-1": "Dacă doriți să restricționați, să blocați sau să ștergeți modulele cookie, această opțiune este oferită prin modificarea setărilor browserului dvs. sau a setărilor cookie de pe pagina noastră web. Dacă ștergeți modulele cookie necesare și de performanță, site-ul web sau unele dintre părțile sale nu vor funcționa.",
        "text-2": "Pentru mai multe informații generale despre cookie-uri și modul de gestionare a acestora, vă rugăm să citiți informațiile de pe <a href=\"https://www.aboutcookies.org/\" target=\"_blank\" rel=\"nofollow\">www.aboutcookies.org</a>.",
        "title": "6. Cum să restricționați și să ștergeți modulele cookie?"
      },
      "table": {
        "head-1": "Cookie-uri",
        "head-2": "Scop",
        "head-3": "Furnizor",
        "head-4": "Durata de viață"
      },
      "text": "Site-ul web creat și întreținut de NaudaPay Limited (în continuare - Noda) <a href=\"https://noda.live/\">www.noda.live</a> utilizează diferite tipuri de module cookie în scopuri multiple.",
      "title": "Politica privind cookie-urile"
    },
    "demo": {
      "breadcrumbs": {
        "demo": "Noda Demo",
        "home": "Acasă",
        "pay-and-go": "Pay&Go",
        "payment-flow": "Fluxul de plată"
      },
      "payment-flow": {
        "amount-label": "Vezi cum funcționează Noda donând către organizații de caritate",
        "amount-placeholder": "Suma ta",
        "choose-country": "Alege-ți țara",
        "countries": {
          "at": "Austria",
          "be": "Belgia",
          "bg": "Bulgaria",
          "br": "Brazilia",
          "ca": "Canada",
          "cz": "Cehia",
          "de": "Germania",
          "dk": "Danemarca",
          "ee": "Estonia",
          "es": "Spania",
          "fi": "Finlanda",
          "fr": "Franţa",
          "gb": "Regatul Unit",
          "gr": "Grecia",
          "hu": "Ungaria",
          "ie": "Irlanda",
          "it": "Italia",
          "lt": "Lituania",
          "lu": "Luxemburg",
          "lv": "Letonia",
          "nl": "Olanda",
          "no": "Norvegia",
          "pl": "Polonia",
          "pt": "Portugalia",
          "ro": "România",
          "se": "Suedia",
          "si": "Slovenia"
        },
        "country-select-label": "Ţară",
        "donate": "Donează acum",
        "funds": {
          "br": {
            "description": "Donația dvs. va finanța eforturile globale ale Plant-for-the-Planet de a restabili ecosistemele forestiere, de a aborda criza climatică și de a proteja biodiversitatea.",
            "title": "Plant-for-the-Planet"
          },
          "default": {
            "description": "Donația dumneavoastră va finanța lupta Caritas Europa împotriva sărăciei și excluziunii sociale, promovând dezvoltarea umană, justiția socială și sistemele sociale durabile în Europa și la nivel global.",
            "title": "Caritas Europa"
          },
          "gb": {
            "description": "Donația dumneavoastră va finanța cercetarea British Heart Foundation în bolile cardiace și circulatorii, contribuind la reducerea factorilor de risc și la îmbunătățirea sănătății inimii.",
            "title": "British Heart Foundation"
          },
          "ro": {
            "description": "Donația dumneavoastră va sprijini misiunea Asociației Salvează o Inimă de a salva vieți și de a îmbunătăți starea de sănătate prin furnizarea de asistență medicală critică, finanțarea tratamentelor vitale și promovarea prevenirii și conștientizării bolilor de inimă în România și nu numai.",
            "title": "Save a Heart Association"
          }
        },
        "main-title": "Încercați plata Noda",
        "result": {
          "button": "Contact Vânzări",
          "cancel": "Accesați pagina principală",
          "subtitle": "{fund} a primit plata 🙌",
          "title": "Vă mulțumim pentru donația dvs. către organizații de caritate cu Noda"
        }
      },
      "solutions": {
        "common": {
          "coming-soon": "În curând",
          "no-docs-required": "Documentele reale nu sunt necesare pentru demonstrație",
          "see-more": "Vezi mai multe",
          "try-demo": "Încearcă Demo",
          "with-verification": "Cu verificarea identității",
          "without-verification": "Fără verificarea identității"
        },
        "description": "Vedeți cum produsele Noda simplifică plățile și vă accelerează creșterea veniturilor.",
        "main-title": "Explorați soluțiile Noda",
        "pay-and-go": {
          "description": "Plată, KYC și înscriere. All-in-one.",
          "hard": "Clienților li se va cere să se supună verificării automate non-doc prin GBG. Dacă verificarea KYC non-doc nu reușește, unui client i se va cere să treacă KYC complet-doc prin Sumsub. ",
          "light": "Dacă produsul dvs. nu necesită verificarea identității clientului, utilizatorii pot efectua plată și înregistrare instantanee prin Pay & Go Light."
        },
        "payment-flow": {
          "description": "Plăți directe securizate de la cont la cont prin bancă."
        }
      }
    },
    "documents-page": {
      "nav": {
        "cookies": {
          "subtitle-1": "Ce sunt modulele cookie?",
          "subtitle-2": "Cookie-uri necesare",
          "subtitle-3": "Cookie-uri de preferințe și de performanță",
          "subtitle-4": "Cookie-uri statistice",
          "subtitle-5": "Cookie-uri de marketing, de targetare sau promoționale",
          "subtitle-6": "Cum să restricționați și să ștergeți modulele cookie?",
          "title": "Politica privind cookie-urile"
        },
        "policy": {
          "subtitle-1": "Responsabilități",
          "subtitle-2": "Când colectăm datele dumneavoastră",
          "subtitle-3": "Datele pe care le colectăm, scopurile, temeiul juridic și condițiile de păstrare",
          "subtitle-4": "Destinatarii și sursele datelor dvs.",
          "subtitle-5": "Transferuri internaționale ale datelor dvs. personale",
          "subtitle-6": "Drepturile dvs.",
          "subtitle-7": "Informații de contact",
          "subtitle-8": "Modificări aduse Politicii privind confidențialitatea",
          "title": "Politica privind confidențialitatea"
        },
        "privacy-for-candidates": {
          "subtitle-1": "De ce are nevoie Noda de datele dvs.?",
          "subtitle-2": "Cum gestionează Noda datele dvs.?",
          "subtitle-3": "Sursele și destinatarii datelor",
          "subtitle-4": "Transferuri internaționale",
          "subtitle-5": "Drepturile privind protecția datelor",
          "subtitle-6": "Informații de contact",
          "title": "Notificare privind confidențialitatea pentru candidații la un loc de muncă sau pentru cooperare"
        },
        "terms": {
          "subtitle-1": "Acordul",
          "subtitle-2": "Servicii pe care le oferim",
          "subtitle-3": "Accesul la Serviciu și comunicarea privind activitățile suspecte",
          "subtitle-4": "Accesul nostru la datele dumneavoastră",
          "subtitle-5": "Rezilierea și suspendarea",
          "subtitle-6": "Dreptul la compensație și răspundere",
          "subtitle-7": "Reclamații",
          "subtitle-8": "Dispoziții generale",
          "title": "Condiții de utilizare"
        }
      },
      "title": "Documente juridice"
    },
    "ecommerce": {
      "faq": {
        "currencies": {
          "content": "Noda acceptă o varietate de valute globale, inclusiv EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON și SEK.",
          "title": "Ce valute sunt disponibile?"
        },
        "how-long": {
          "content": "Procesul nostru de onboarding poate fi la fel de rapid ca o zi. Echipa de asistență Noda este aici pentru a vă ajuta cu orice blocaj, asigurându-vă că puteți începe să acceptați plăți rapid.",
          "title": "Cât timp durează să începi să accepti plăți cu Noda?"
        },
        "how-to-start": {
          "content": "În primul rând, trebuie să vă înregistrați la Noda. Trebuie doar să completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Oferim o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Procesorul nostru se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare fără probleme în platforma dvs.",
          "title": "Cum să începeți să acceptați plăți online cu Noda?"
        },
        "needs": {
          "content": "Pentru a începe să utilizați Noda, completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Noda oferă o integrare ușoară cu îndrumarea unui manager dedicat pentru a vă asigura că sunteți sprijinit la fiecare pas.",
          "title": "Ce este nevoie de la mine pentru a începe?"
        },
        "subtitle": "Trebuie să știți",
        "title": "FAQs",
        "types": {
          "content": "Noda oferă soluții de plată e-commerce pentru toate tipurile și dimensiunile de comercianți, cu planuri scalabile disponibile pentru a susține creșterea afacerii dumneavoastră.",
          "title": "Ce tipuri de comercianți acceptă Noda?"
        }
      },
      "hero": {
        "text": "Îmbunătățiți afacerea dvs. de comerț electronic. Platforma noastră de plăți all-in-one prioritizează înțelegerea clienților, eficiența și creșterea",
        "title-1": "Soluții de plată ",
        "title-2": "pentru E-Commerce:",
        "title-gradient-1": "Plățile dvs ",
        "title-gradient-2": "sunt prioritatea noastră"
      },
      "how-does-it-work": {
        "content": "Noda este o platformă mondială de plăți pentru comerțul electronic și un furnizor de servicii bancare deschise. De la gestionarea tranzacțiilor la analizele financiare, Noda vă acoperă. Platforma noastră utilizează tehnologii de inteligență artificială și învățare automată pentru a oferi soluții de gateway de plată de ultimă generație pentru afacerile de comerț electronic.\n\nOpen banking înseamnă că băncile tradiționale partajează date cu companii fintech licențiate, precum Noda, pentru a eficientiza tranzacțiile. Ecosistemul nostru de plăți conectează toate băncile importante din Regatul Unit și UE, facilitând servicii de plată fără efort pentru comerțul electronic.",
        "subtitle": "Tehnologii",
        "title": "Cum funcționează"
      },
      "how-to-start": {
        "content": "Noda oferă o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Echipa noastră este aici pentru a vă ajuta cu orice blocaj. Pentru a începe să utilizați Noda, trebuie doar să completați formularul, iar reprezentanții noștri de vânzări vă vor contacta în scurt timp.",
        "subtitle": "Integrare ușoară",
        "title": "Cum să începeți"
      },
      "payments": {
        "text": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "title": "Set de instrumente pentru comerțul electronic"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Profitați de cunoștințele noastre bazate pe date. Instrumentele Noda oferă analize gata de utilizare ale comportamentului clienților, inclusiv algoritmi de segmentare și prognoză",
            "title": "Analize bazate pe IA"
          },
          "banking": {
            "content": "Îmbunătățiți experiența clienților și ușurați fluxul de tranzacții cu puterea și securitatea plăților bancare deschise",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda lucrează cu o varietate de valute pentru a vă sprijini operațiunile de comerț electronic din întreaga lume",
            "title": "Monede globale"
          },
          "payment-processing": {
            "content": "Simplificați intrările și ieșirile de plată cu Noda. Folosiți UX intuitiv, rutare inteligentă și o varietate de metode de plată pentru comerțul electronic",
            "title": "Comerț electronic\nProcesarea plăților"
          },
          "scalable-plans": {
            "content": "Oferim servicii de plată e-commerce pentru toate dimensiunile de companii, cu planuri scalabile disponibile pentru a stimula creșterea afacerii dumneavoastră",
            "title": "Planuri scalabile"
          },
          "security": {
            "content": "Noda oferă o modalitate sigură de efectuare a plăților electronice, asigurând conformitatea cu PCI DSS, criptarea și prevenirea fraudelor",
            "title": "Securitate"
          }
        },
        "subtitle": "Ce oferim",
        "title-1": "Caracteristici de top ",
        "title-2": "pentru E-Commerce"
      }
    },
    "educational-platforms": {
      "faq": {
        "countries": {
          "content": "Lucrăm cu 2000+ de bănci din 28 de țări, inclusiv Olanda, Portugalia, Belgia, Germania, Polonia, Bulgaria, Franța, Irlanda, Italia, Austria, Spania, Danemarca, Estonia, Marea Britanie, Luxemburg, România, Lituania, Ungaria, Letonia, Finlanda, Suedia, Norvegia, Republica Cehă, Slovacia, Grecia și Slovenia.",
          "title": "În ce țări lucrează Noda?"
        },
        "currencies": {
          "content": "Noda acceptă o varietate de valute globale, inclusiv EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON și SEK.",
          "title": "Ce valute acceptă Noda?"
        },
        "how-to-integrate": {
          "content": "În primul rând, trebuie să vă înregistrați la Noda. Trebuie doar să completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Oferim o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Procesorul nostru se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare fără probleme în platforma dvs. educațională.",
          "title": "Cum pot integra Noda în fluxul meu de lucru de plată?"
        },
        "subtitle": "RĂSPUNSURI LA ÎNTREBĂRILE DVS.",
        "title": "FAQs"
      },
      "hero": {
        "text": "Educați cu ușurință, în timp ce noi ne ocupăm de plăți. Sistemul nostru de plată online all-in-one pentru platformele educaționale acordă prioritate înțelegerii clienților, eficienței și creșterii",
        "title-1": "Gateway de plată",
        "title-gradient-1": "pentru Educație",
        "title-gradient-2": "Platforme"
      },
      "how-does-it-work": {
        "content": "Un portal de plăți transferă date financiare între cursanți, comercianți și băncile acestora. Gândiți-vă la acesta ca la un dirijor digital, care ghidează meticulos fiecare etapă a procesării plăților în sectorul educației.\n\nNoda este o platformă de plăți și un furnizor de servicii bancare deschise la nivel mondial. De la gateway securizat la gestionarea tranzacțiilor și analiza financiară, Noda vă acoperă. Platforma noastră utilizează tehnologii AI și de învățare automată pentru a oferi soluții de plată online de ultimă generație pentru întreprinderile din domeniul educației.",
        "subtitle": "Tehnologii",
        "title": "Cum funcționează portalul de plăți pentru educație?"
      },
      "how-to-start": {
        "content": "Noda oferă o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Platforma noastră se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare perfectă în interfața dvs. Pentru a începe să utilizați Noda, completați formularul de mai jos, iar reprezentanții noștri de vânzări vă vor contacta în scurt timp. Echipa noastră este aici pentru a vă ajuta cu orice blocaj",
        "subtitle": "Integrare ușoară",
        "title": "Cum să începeți"
      },
      "open-banking": {
        "content": "Open banking înseamnă că băncile tradiționale partajează date cu companii fintech licențiate, precum Noda, pentru a simplifica tranzacțiile. Ecosistemul nostru de plăți conectează toate băncile importante din Regatul Unit și UE, facilitând serviciile de plată fără efort",
        "subtitle": "O MULȚIME DE POSIBILITĂȚI",
        "title": "Ce este Open Banking?"
      },
      "payments": {
        "text": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "title": "Set de instrumente pentru platforme educaționale"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Profitați de cunoștințele noastre bazate pe date. Instrumentele Noda oferă analize gata de utilizare ale comportamentului clienților, inclusiv algoritmi de segmentare și prognoză",
            "title": "Analize bazate pe inteligența artificială"
          },
          "banking": {
            "content": "Îmbunătățiți experiența clienților și simplificați fluxul de tranzacții cu puterea și securitatea plăților bancare deschise",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda lucrează cu o gamă largă de valute pentru a vă sprijini clienții din întreaga lume",
            "title": "Monede globale"
          },
          "payment-processing": {
            "content": "Simplificați plățile de intrare și de ieșire, utilizați UX intuitiv, rutare inteligentă și oferiți o varietate de metode de plată populare",
            "title": "Procesarea plăților pentru platformele educaționale"
          },
          "scalable-plans": {
            "content": "Oferim soluții de plată pentru companii de toate dimensiunile, cu planuri scalabile disponibile pentru a alimenta creșterea platformei dvs. educaționale",
            "title": "Planuri scalabile"
          },
          "security": {
            "content": "Noda oferă o modalitate sigură de efectuare a plăților, asigurând conformitatea cu PCI DSS, criptarea și prevenirea fraudelor",
            "title": "Securitate"
          }
        },
        "subtitle": "CE OFERIM",
        "title-1": "Caracteristici de top",
        "title-2": "pentru platformele educaționale"
      }
    },
    "financial": {
      "application-list": {
        "financial1": {
          "text": "Divertisment"
        },
        "financial2": {
          "text": "Vânzări cu amănuntul"
        },
        "financial3": {
          "text": "Întreprinderi nou-înființate"
        },
        "financial4": {
          "text": "Piețe"
        },
        "financial5": {
          "text": "Servicii de date"
        },
        "financial6": {
          "text": "Comerț electronic"
        },
        "financial7": {
          "text": "Jocuri de noroc"
        },
        "financial8": {
          "text": "Călătorie"
        }
      },
      "application": {
        "subtitle": "Aplicație date",
        "text": "Noda's Data Enrichment poate simplifica procesarea plății pentru o gamă largă de activități comerciale, de la tradiționalul comerț electronic la abonarea complexă și modelele complementare de afaceri",
        "title": "Adaptabil la numeroase domenii"
      },
      "buttons": {
        "DE-row": {
          "berlin": "Berlin",
          "mobile": "Mobil"
        },
        "NL-row": {
          "amsterdam": "Amsterdam",
          "desktop": "Calculator"
        },
        "UK-row": {
          "desktop": "Calculator",
          "london": "Londra"
        }
      },
      "container-header-text": "Instrumentul nostru oferă o informație completă privind necesitățile clienților pe care le puteți utiliza pentru a vă dezvolta afacerea",
      "customer-segmentation": {
        "list": {
          "enhanced-engagement": "Angajament client îmbunătățit",
          "marketing-insights": "Informații avansate de marketing",
          "ready-for-use": "Pentru utilizare imediată"
        },
        "subtitle": "Clustere de date",
        "text": "Personalizați experiența clienților cu funcția noastră de segmentare a clienților, care clasează clienții în grupuri diferite, sau clustere, pentru a vă livra recomandări valoroase, direcționate cu precizie",
        "title": "Segmentare clienți"
      },
      "data-usage": {
        "info": {
          "monthly-value": "Valoare lunară",
          "predicted-lifetime": {
            "label": "Valoare prevăzută pe durata vieții",
            "value": "2 luni"
          },
          "predicted-spendings": "Cheltuieli prevăzute"
        },
        "subtitle": "Utilizarea datelor",
        "text": "Levierul Noda's Data Enrichment folosește analize avansate pentru a prognoza modelele de consum ale clienților dumneavoastră, bazate pe comportamentul lor financiar și pe factorii de mediu. Instrumentul nostru oferă o informație completă privind necesitățile clienților, pe care le puteți utiliza pentru a vă dezvolta afacerea",
        "title": "Algoritmi de prognoză"
      },
      "diff-user": "Utilizator diferit",
      "financial-hero-title-1": "Îmbogățirea datelor:",
      "financial-hero-title-2": "Deblocați open-banking",
      "financial-hero-title-3": "Informații utilizator cu",
      "financial-info": "2 luni",
      "header-title": "Dați forță creșterii dumneavoastră cu date suplimentare",
      "hero": "Obțineți informații valoroase despre utilizator imediat după ce a fost făcută prima tranzacție. După ce primim consimțământul utilizatorului pentru a-i vizualiza tranzacțiile, este momentul potrivit pentru a obține semnale operative.",
      "how-data": {
        "enrich-data": {
          "text": "După ce utilizatorul ne dă acordul, vă transmitem datele îmbogățite.",
          "title": "Îmbogățire date"
        },
        "instant-consent": {
          "text": "În timpul plății sau conectării, utilizatorii autorizează Noda să citească informațiile privind tranzacția.",
          "title": "Acord instantaneu"
        },
        "payment-or-sign-in": {
          "text": "Inițiați plata sau conectați-vă la contul dvs. prin intermediul companiei Noda.",
          "title": "Plată sau înscriere"
        }
      },
      "info-data": {
        "subtitle": "Ce văd utilizatorii",
        "text": "Vă garantăm liniștea interioară cu gestionarea sigură a datelor prin intermediul instrumentului financiar IA",
        "title": "Cum funcționează"
      },
      "key-features-title": "Caracteristici cheie",
      "payments-data": {
        "text": "Prognozați informații financiare pentru comercianți",
        "title": "Deblocați informațiile pentru utilizatori cu Noda"
      },
      "preferences-items": {
        "hood1": {
          "text": "Plasați utilizatorul în primul rând cu informațiile obținute prin open-banking",
          "title": "Construiți soluții personalizate"
        },
        "hood2": {
          "text": "Obțineți o alertă când utilizatori cu marje mari se înregistrează.",
          "title": "Îmbunătățiți angajamentul"
        },
        "hood3": {
          "text": "Spuneți adio depășirii bugetului pe cardul de plăți.",
          "title": "Realizați un mai bun re-marketing, cu un nivel înalt de încredere"
        },
        "hood4": {
          "text": "Numai utilizatori țintă cu potențial LTV mare",
          "title": "Îmbogățiți-vă strategia de achiziții"
        }
      }
    },
    "gaming": {
      "case-study": {
        "subtitle": "Studiu de caz",
        "text": "În februarie 2023, Wargaming, un editor de jocuri online premiat, a făcut echipă cu Noda pentru a introduce plăți bancare deschise instantanee în jocuri. Acest parteneriat a permis jucătorilor Wargaming să acceseze diverse opțiuni de plată online, inclusiv tranzacții de la cont la cont (A2A)",
        "title": "Wargaming <br/>& Noda"
      },
      "faq": {
        "countries": {
          "content": "Lucrăm cu 2000+ de bănci din 28 de țări, inclusiv Olanda, Portugalia, Belgia, Germania, Polonia, Bulgaria, Franța, Irlanda, Italia, Austria, Spania, Danemarca, Estonia, Marea Britanie, Luxemburg, România, Lituania, Ungaria, Letonia, Finlanda, Suedia, Norvegia, Republica Cehă, Slovacia, Grecia și Slovenia.",
          "title": "În ce țări lucrează Noda?"
        },
        "currencies": {
          "content": "Noda acceptă o varietate de valute globale, inclusiv EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON și SEK.",
          "title": "Ce monede acceptă Noda?"
        },
        "integration": {
          "content": "În primul rând, trebuie să vă înregistrați la Noda. Trebuie doar să completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Oferim o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Procesorul nostru se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare fără probleme în platforma dvs.",
          "title": "Cum pot integra Noda în fluxul meu de plăți?"
        },
        "subtitle": "S-a răspuns la întrebările tale",
        "title": "FAQs"
      },
      "hero": {
        "text": "Îmbunătățiți-vă afacerea de gaming cu plățile Noda. Platforma noastră all-in-one prioritizează înțelegerea clientului, eficiența și creșterea",
        "title-1": "Gateway de plată",
        "title-2": "pentru jocuri online cu Noda"
      },
      "how-does-it-work": {
        "subtitle": "Tehnologii",
        "text": "Un gateway de plată pentru jocuri servește drept intermediar, transmițând în siguranță datele între jucător, comerciant și bănci. Gândiți-vă la un dirijor digital, care ghidează meticulos fiecare pas al procesării cardurilor de credit pentru jocurile online\n\nNoda este o platformă de plăți și un furnizor de servicii bancare deschise la nivel mondial. De la gateway securizat la gestionarea tranzacțiilor și analiza financiară, Noda vă acoperă. Platforma noastră utilizează tehnologii AI și de învățare automată pentru a oferi soluții de ultimă generație",
        "title": "Cum funcționează Gateway-ul de plată pentru jocuri?"
      },
      "how-to-start": {
        "subtitle": "Integrare ușoară",
        "text": "Noda oferă o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Echipa noastră este aici pentru a vă ajuta cu orice blocaj. Procesorul nostru se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare fără probleme în platforma dvs. Pentru a începe să utilizați Noda, trebuie doar să completați formularul de mai jos, iar reprezentanții noștri de vânzări vă vor contacta în scurt timp",
        "title": "Cum să începeți"
      },
      "open-banking": {
        "subtitle": "O mulțime de posibilități",
        "text": "Open banking înseamnă că băncile tradiționale partajează date cu companii fintech licențiate, precum Noda, pentru a simplifica tranzacțiile. Ecosistemul nostru de plăți conectează toate băncile importante din Regatul Unit și UE, facilitând serviciile de plată fără efort",
        "title": "Ce este Open Banking?"
      },
      "payments": {
        "text": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "title": "Set de instrumente pentru jocuri online"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Profitați de cunoștințele noastre bazate pe date. Instrumentele Noda oferă analize gata de utilizare ale comportamentului clienților, inclusiv algoritmi de segmentare și prognoză",
            "title": "Analize bazate pe inteligența artificială"
          },
          "banking": {
            "content": "Îmbunătățiți experiența clienților și ușurați fluxul de tranzacții cu puterea și securitatea plăților bancare deschise",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda lucrează cu o gamă largă de valute pentru a vă sprijini clienții de jocuri online din întreaga lume",
            "title": "Monede globale"
          },
          "payment-processing": {
            "content": "Simplificați plățile de intrare și de ieșire, utilizați UX intuitiv, rutare inteligentă și oferiți o varietate de metode de plată populare",
            "title": "Procesarea plăților pentru jocurile online"
          },
          "scalable-plans": {
            "content": "Oferim soluții de plată a jocurilor de noroc pentru companii de toate dimensiunile, cu planuri scalabile disponibile pentru a stimula creșterea afacerii dumneavoastră",
            "title": "Planuri scalabile"
          },
          "security": {
            "content": "Noda oferă o modalitate sigură de plată a jocurilor de noroc online, asigurând conformitatea PCI DSS, criptarea și prevenirea fraudelor",
            "title": "Securitate"
          }
        },
        "subtitle": "Ce oferim",
        "title-1": "Caracteristici de top",
        "title-2": "pentru jocuri online"
      }
    },
    "instant-payment-links": {
      "cx": {
        "subtitle": "experiența este cheia",
        "text": "Întâlniți cumpărătorii pe o pagină de plată securizată.<br/>Permiteți-le să finalizeze achiziția folosind aplicația lor bancară preferată.",
        "title": "Experiență instantanee a clientului"
      },
      "funds": {
        "receive-money": "Primiți bani direct în contul dvs. bancar în timp real.",
        "settle-payments": "Sau efectuați plăți folosind Noda vIBAN.",
        "subtitle": "alegeți-vă fluxul",
        "title": "Disponibilitate instantanee a fondurilor"
      },
      "hero": {
        "text": "Generare link de plata și flexibile fără bătăi de cap legate de integrare",
        "title": "Linkuri de plată instantanee"
      },
      "info": {
        "checkout-anchor": "diferite tipuri de media",
        "checkout-text-end": ", online sau în persoană",
        "checkout-text-start": "Permiteți clienților dvs. să finalizeze cumpărăturile în ",
        "create-anchor": "din zbor",
        "create-text": "Generare link de plata, generați coduri QR de plată scanabile ",
        "fees-anchor": "primiți bani în timp real",
        "fees-text": "Reduceți comisioanele de tranzacție și ",
        "title": "Generator payment link pentru a îmbunătăți afacerea dvs. zilnică"
      },
      "key-features": {
        "commerce": "Comerț omnicanal fără integrări",
        "coverage": "Acoperire geografică extinsă",
        "customer": "Experiență pentru clienți super-simplă",
        "fees": "Taxe reduse pentru tranzacții",
        "no-code": "Fără cod, Nu este necesară experiența tehnică",
        "security": "Securitate la nivel de bancă",
        "subtitle": "puterea linkurilor de plată",
        "time": "Introducere pe piață de 5 minute pentru utilizatorii Noda",
        "title": "Caracteristici cheie",
        "transparency": "Transparență, gestionare ușoară"
      },
      "product-block": {
        "text": "Configurare instantanee. Partajare instantanee. Experiență de plată instantanee. Lumea este terenul tău de joacă. Numele jocului este \"doar să fii plătit\".",
        "title": "Linkuri de plată instantanee"
      },
      "setup": {
        "subtitle": "cum funcționează",
        "text": "Crearea unui link de plată durează doar câteva momente: introduceți prețul și moneda, adăugați detaliile de plată și apăsați Generare. Sunteți gata!",
        "title": "Configurare instantanee"
      },
      "sharing": {
        "description": "Afișați codul QR de plată, care trebuie scanat de clienții dvs. pentru a efectua plata, pe suporturi tipărite, reclame în exterior, ecrane de computer și TV.",
        "header": {
          "subtitle": "implicați-vă publicul",
          "text": "Trimiteți linkul de plată clienților dumneavoastră.<br/>Folosiți orice platformă unde interacționați cu publicul: site-uri web, e-mailuri, chatboți, rețele sociale, servicii de mesagerie etc.",
          "title": "Partajare instantanee"
        }
      },
      "use-cases": {
        "automotive": {
          "item-1": "Plăți integrale și parțiale",
          "item-2": "Depozite și rate",
          "item-3": "Plăți internaționale, în mai multe valute",
          "item-4": "Servicii post-vânzare",
          "title": "Automobilistică"
        },
        "e-commerce": {
          "item-1": "Comerț omnicanal",
          "item-2": "Plăți internaționale, în mai multe valute",
          "item-3": "Opțiuni de plată ulterioară",
          "item-4": "Comerț social",
          "title": "Comerț electronic"
        },
        "header": {
          "subtitle": "conectarea punctelor",
          "text": "De la online la în persoană, de la sume mari la microplăți, internațional sau din ușă în ușă. Experiențele de plată fără efort sunt la doar un click distanță.",
          "title": "Cazuri de utilizare și industrii"
        },
        "retail": {
          "item-1": "Depozite și rate",
          "item-2": "Plăți cu un singur clic pentru clienții care revin",
          "item-3": "Comerț omnicanal",
          "item-4": "Plăți internaționale, în mai multe valute",
          "title": "Retail high-ticket"
        },
        "sales": {
          "item-1": "Plăți integrale și parțiale",
          "item-2": "Comerț social",
          "item-3": "Campanii de lansare rapidă",
          "item-4": "Opțiuni de plată ulterioară",
          "title": "Vânzări în persoană"
        },
        "services": {
          "item-1": "Depozite și rate",
          "item-2": "Servicii post-vânzare",
          "item-3": "Împrumuturi, microcredit",
          "item-4": "Campanii de lansare rapidă",
          "title": "Servicii"
        },
        "travel": {
          "item-1": "Depozite și rate",
          "item-2": "Plăți internaționale, în mai multe valute",
          "item-3": "Plăți cu un singur clic pentru clienții care revin",
          "item-4": "Opțiuni de plată ulterioară",
          "title": "Călătorii și Ospitalitate"
        }
      }
    },
    "letters-plugin": {
      "buttonTitle": "Vezi toate",
      "title": "Aflați mai multe despre pluginurile de plată"
    },
    "main-v2": {
      "boost-your-business": {
        "connected-banks": "bănci conectate, cu peste 30.000 de sucursale",
        "countries-covered": "țări acoperite",
        "description": "Ecosistemul robust de plăți online al Noda conectează toate băncile importante din Regatul Unit și UE, facilitând tranzacțiile fără efort",
        "integrated-networks": "rețele integrate",
        "subtitle": "Dezlănțuiți puterea serviciilor Open Banking",
        "subtitleV2": "Dezlănțuiți puterea\nserviciilor Open Banking",
        "title": "Creșteți-vă afacerea cu Noda"
      },
      "hero": {
        "online-payments": {
          "part-1": "Plăți online ",
          "part-2": "cu Noda. ",
          "part-3": "Plățile dvs., prioritatea noastră"
        },
        "text": "Transformați-vă afacerea cu ajutorul platformei noastre complete de plată online. Creșteți vânzările și economisiți timp prețios prin procese simplificate. Soluțiile noastre complete acordă prioritate înțelegerii clientului, operațiunilor eficiente și creșterii."
      },
      "reviews": {
        "title": "Ce spun clienții noștri"
      },
      "what-is-noda": {
        "card-payments": {
          "button": "Explorați plățile cu cardul",
          "description": "Noda acordă o prioritate deosebită simplificării plăților repetitive pentru o procesare mai ușoară",
          "subtitle": "Plățile cu cardul",
          "title": "Finalizarea mai rapidă a plății prin intermediul plăților cu un singur clic"
        },
        "checkout": {
          "button": "Exploreaza Checkout",
          "description": "Descoperiți puterea plăților unitare cu interfața ușor de utilizat din Finalizarea plății Noda și setul cuprinzător de funcții de plată",
          "subtitle": "Finalizarea plății",
          "title": "Serviciu de Finalizare a Plății Unificat Pentru Plățile dvs."
        },
        "delight-customers": {
          "description": "Bucurați-vă de colectări cu costuri reduse sau fără taxe, cu o multitudine de opțiuni oferite prin intermediul serviciilor noastre de plată online",
          "title": "Încântați-vă clienții"
        },
        "easy-to-apply": {
          "description": "Soluție flexibilă pentru colectarea fondurilor, cu opțiunea de a utiliza contul nostru bancar Noda C2B sau de a alege din rețeaua noastră de parteneri bancari de încredere",
          "title": "Ușor de implementat"
        },
        "open-banking": {
          "button": "Mai Multe Despre Open-Banking",
          "description": "Exploatați puterea serviciilor Open Banking și a API-urilor pentru a îmbunătăți experiența clienților dvs. și procesarea plăților online cu soluția sigură și eficientă oferită de Noda",
          "subtitle": "Open-Banking",
          "title": "Simplificați-vă plățile cu Noda"
        },
        "text": "Soluția noastră cuprinzătoare de plăți online simplifică tranzacțiile atât pentru întreprinderi, cât și pentru persoane fizice, indiferent dacă dvs. colectați fonduri de la clienți sau trimiteți bani prietenilor și familiei.",
        "title": "Ce este "
      }
    },
    "marketplace": {
      "cart": {
        "cta": "Pornire",
        "in-your-package": "În pachetul dvs.",
        "products": "Produse",
        "recommended": "S-ar putea să fiți interesat și de"
      },
      "errors": {
        "email-pattern": "Formatul de e-mail este incorect",
        "oninvalid": "Valoarea este nevalidă",
        "required": "Valoarea este necesară"
      },
      "filters": {
        "all": "Toate produsele",
        "categories": "Categorii",
        "header": "Filtre"
      },
      "header": "Produsele noastre",
      "hero": {
        "description": "Alegeți instrumentele de plată potrivite pentru afacerea dumneavoastră. Piața de servicii de plată Noda reunește procesarea plăților, facturarea, serviciile de îmbogățire a datelor și multe altele - gata de combinat și personalizat.",
        "description-2": "Pregătit pentru o nouă abordare a plăților? Începe să-ți construiești astăzi stiva de plăți.",
        "title": "Instrumente de Plată între Bănci și Frontiere"
      },
      "product": {
        "add-to-package": "Adăuga",
        "in-package": "Adăugat",
        "read-more": "Citește mai mult",
        "remove": "Elimina"
      },
      "request-a-product": {
        "cta": "Trimiteți o solicitare",
        "description": "Nu găsiți ceea ce căutați? Informați-ne.",
        "form": {
          "back": "Întoarceți-vă la piață",
          "labels": {
            "description": "Descrieți ideea dvs.",
            "email": "E-mailul dvs. de serviciu",
            "organization": "Organizația dvs."
          },
          "recommended": "S-ar putea să fiți interesat și de",
          "success": {
            "description": "Vom procesa cererea dvs. cât de repede putem. Să aveți o zi bună!",
            "header": "Vă mulțumim pentru cererea dvs"
          }
        },
        "header": "Solicitați un produs"
      }
    },
    "marketplaces": {
      "faq": {
        "countries": {
          "content": "Lucrăm cu 2000+ de bănci din 28 de țări, inclusiv Olanda, Portugalia, Belgia, Germania, Polonia, Bulgaria, Franța, Irlanda, Italia, Austria, Spania, Danemarca, Estonia, Marea Britanie, Luxemburg, România, Lituania, Ungaria, Letonia, Finlanda, Suedia, Norvegia, Republica Cehă, Slovacia, Grecia și Slovenia.",
          "title": "În ce țări lucrează Noda?"
        },
        "currencies": {
          "content": "Noda este un procesor de plăți pentru piața globală care acceptă o varietate de valute, inclusiv EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON și SEK.",
          "title": "Ce monede acceptă Noda?"
        },
        "how-to-integrate": {
          "content": "În primul rând, trebuie să vă înregistrați la Noda. Trebuie doar să completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Oferim o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Sistemul nostru de plăți de pe piață se integrează cu API-uri și componente front-end, integrându-se perfect în platforma dvs.",
          "title": "Cum pot integra Noda în fluxul meu de lucru de plată?"
        },
        "subtitle": "RĂSPUNS LA ÎNTREBĂRILE DVS",
        "title": "FAQs"
      },
      "hero": {
        "text": "Îmbunătățiți piața dvs. cu portalul de plăți Noda. Concentrați-vă pe anunțuri, în timp ce noi asigurăm tranzacții sigure și fără probleme. Platforma noastră all-in-one prioritizează înțelegerea clienților, eficiența și creșterea",
        "title-1": "Gateway de plată",
        "title-gradient-1": "pentru piețele cu Noda"
      },
      "how-does-it-work": {
        "content": "Un portal de plăți transmite în siguranță datele financiare între clienți, comercianți și bănci. Gândiți-vă la aceasta ca la un conductor digital care ghidează fiecare etapă a procesării plăților\n\nNoda este o platformă de plăți și un furnizor de servicii bancare deschise la nivel mondial. De la plăți securizate pe piețe online la analize financiare, Noda vă acoperă. Platforma noastră utilizează tehnologii de AI și machine-learning pentru a oferi soluții de ultimă generație",
        "subtitle": "Tehnologii",
        "title": "Cum funcționează Marketplace Payment Gateway?"
      },
      "how-to-start": {
        "content": "Noda oferă o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Platforma noastră de plată de pe piață se integrează fără probleme cu API-urile și componentele front-end, asigurând o îmbinare fără probleme în interfața dvs. Pentru a începe să utilizați Noda, completați formularul de mai jos, iar reprezentanții noștri de vânzări vă vor contacta în scurt timp. Echipa noastră este aici pentru a vă ajuta cu orice blocaj",
        "subtitle": "Integrare ușoară",
        "title": "Cum să începeți"
      },
      "open-banking": {
        "content": "Open banking înseamnă că băncile tradiționale partajează date cu companii fintech licențiate, precum Noda, pentru a simplifica tranzacțiile. Ecosistemul nostru de plăți conectează toate băncile importante din Regatul Unit și UE, facilitând plățile fără efort pentru piețe",
        "subtitle": "O MULȚIME DE POSIBILITĂȚI",
        "title": "Ce este Open Banking?"
      },
      "payments": {
        "text": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "title": "Set de instrumente pentru piețe"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Profitați de cunoștințele noastre bazate pe date. Instrumentele Noda oferă analize gata de utilizare ale comportamentului clienților, inclusiv algoritmi de segmentare și prognoză",
            "subtitle": "TEHNOLOGII MODERNE",
            "title": "Analize bazate pe IA"
          },
          "banking": {
            "content": "Îmbunătățiți experiența utilizatorului (UX) și simplificați fluxul de tranzacții cu puterea și securitatea plăților bancare deschise",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda funcționează cu mai multe valute pentru a vă sprijini clienții de pe piața din întreaga lume",
            "title": "Monede globale"
          },
          "payment-processing": {
            "content": "Simplificați plățile de intrare și de ieșire, utilizați UX intuitiv, rutare inteligentă și oferiți o varietate de opțiuni de plată populare pe piață",
            "subtitle": "TOTUL PENTRU AFACEREA DVS",
            "title": "Procesarea plăților pe piață"
          },
          "scalable-plans": {
            "content": "Oferim soluții de plată pentru piețe de toate dimensiunile, cu planuri scalabile disponibile pentru a vă susține creșterea",
            "title": "Planuri scalabile"
          },
          "security": {
            "content": "Noda este un furnizor de plăți sigure pe piață, asigurând conformitatea cu PCI DSS, criptarea și prevenirea fraudelor",
            "title": "Securitate"
          }
        },
        "subtitle": "OFERTELE NOASTRE",
        "title-1": "Caracteristici de top"
      }
    },
    "meta": {
      "about": {
        "aml-cft-policies": {
          "description": "Explorați declarația noastră de politică, cadrul de reglementare, metodologiile și multe altele.",
          "title": "Politicile AML/CFT ale lui Noda"
        },
        "company": {
          "description": "Descoperiți povestea Noda și aflați cum vă putem îmbunătăți plățile de afaceri. Faceți cunoștință cu echipa și produsele noastre.",
          "title": "Companie | Noda"
        },
        "mission": {
          "description": "Aflați despre misiunea și viziunea Noda, inclusiv despre cele trei balene ale culturii noastre și povestea a ceea ce suntem.",
          "title": "Misiunea și viziunea lui Noda"
        },
        "partnership": {
          "description": "Explorați gama noastră de opțiuni de parteneriat, inclusiv etichetă albă, revânzător, franciză și oportunități de agent. Integrați tehnologia noastră open banking.",
          "title": "Noda: Deveniți partenerul Noda în creșterea afacerii"
        },
        "risk-appetite-policy": {
          "description": "Descoperiți politica noastră de risc privind industriile, activitățile și jurisdicțiile care sunt interzise, restricționate sau care necesită un comportament specific.",
          "title": "Politica lui Noda privind apetitul pentru risc"
        },
        "security": {
          "description": "Securitatea plăților și a datelor ar trebui să fie întotdeauna o prioritate. Oferim o prezentare generală a caracteristicilor noastre de securitate și a angajamentului nostru față de confidențialitatea datelor.",
          "title": "Securitatea și manipularea datelor | Noda"
        },
        "ux-approach": {
          "description": "Descoperiți filozofia noastră CX și manifestul nostru de design. Aflați mai multe despre principiile noastre de proiectare și despre ceea ce determină echipa noastră să producă o muncă excelentă.",
          "title": "Abordarea Noda pentru Experiența Clientului (CX)"
        },
        "white-label": {
          "description": "Deveniți un partener white-label cu Noda și integrați serviciile bancare deschise. Beneficiați de plăți fără întreruperi, analize utile și branding personalizabil.",
          "title": "Noda: Creșteți-vă afacerea ca partener White-Label"
        },
        "why-open-banking": {
          "description": "Descoperiți de ce open banking transformă plățile. Aflați cum beneficiază atât comercianții, cât și consumatorii, demontând în același timp miturile comune.",
          "title": "De ce Open Banking este viitorul plăților"
        }
      },
      "articles": {
        "description": "Descoperiți tot ce trebuie să știți despre open banking și soluțiile de plată online. Aflați mai multe despre plățile digitale cu articolele Noda despre fintech.",
        "title": "Articole | Fintech, Open Banking, Plăți digitale | Noda"
      },
      "bank-payouts": {
        "description": "Simplificați plățile în masă cu soluțiile avansate de plată bancară Noda. Bucurați-vă de tranzacții rapide, fără complicații și de eficiența costurilor. Citiți mai departe pentru a afla mai multe.",
        "title": "Plăți bancare simplificate pentru tranzacții rapide și eficiente din punct de vedere al costurilor | Noda"
      },
      "bank-sign": {
        "description": "Îmbunătățiți experiența clienților dvs. cu autentificarea Noda folosind un cont bancar. Asigurați o securitate de top, dobândiți mai mulți clienți și accesați date fiabile.",
        "title": "Conectare fără întreruperi prin intermediul băncii, plăți securizate și conformitatea datelor | Noda"
      },
      "card-payments": {
        "description": "Experimentați plățile fără probleme cu tehnologia Noda bazată pe inteligență artificială. Rutare optimizată, plăți cu cardul acceptate și integrare ușoară - adaptate pentru creșterea afacerii dvs. Aflați mai multe.",
        "title": "Îmbunătățirea plăților online cu cardul pentru succesul afacerii | Noda"
      },
      "card-payouts": {
        "description": "Stimulați-vă creșterea afacerii cu soluțiile globale eficiente de plată cu cardul Noda. Integrare API fără probleme, tranzacții securizate și adaptate nevoilor dvs.",
        "title": "Soluții de plată cu cardul Switch, sigure și eficiente | Noda"
      },
      "checkout": {
        "description": "Îmbunătățiți procesul de verificare a plăților cu tehnologia avansată Noda, bazată pe inteligență artificială. Optimizați checkout-ul, securizați tranzacțiile și extindeți-vă la nivel global.",
        "title": "Soluții transparente și sigure pentru plata la checkout | Noda"
      },
      "contact-form": {
        "description": "Explorați platforma noastră integrată de plăți. Răsfoiți piața de servicii Noda pentru a vă construi pachetul tehnologic de plată perfect. Open banking, carduri, îmbogățirea datelor, no-code.",
        "title": "Forma Noda"
      },
      "contact-us": {
        "description": "Îmbunătățiți-vă afacerea cu puterea serviciilor bancare deschise. Discutați cu noi astăzi pentru a eficientiza plățile cu platforma noastră all-in-one.",
        "title": "Contactați-ne | Noda"
      },
      "demo": {
        "description": "Explorați soluțiile Noda. Vedeți cum produsele Noda simplifică plățile și vă accelerează creșterea veniturilor.",
        "title": "Noda Demo"
      },
      "events": {
        "description": "Descoperiți evenimentele și conferințele de la Noda. Rezervați-vă locul acum pentru a intra în contact cu liderii din industria plăților, pentru a obține informații și pentru a vă angaja în oportunități de creștere profesională!",
        "title": "Evenimente: Rețea, învățare și dezvoltare cu Noda"
      },
      "financial-ai-toolset": {
        "description": "Explorați Financial AI Toolset, o soluție care oferă întreprinderilor analize financiare perspicace bazate pe inteligență artificială pentru decizii bazate pe date.",
        "title": "Set de instrumente financiare AI: Creșteți-vă afacerea cu ajutorul analizelor bazate pe date | Noda"
      },
      "glossary": {
        "description": "Explorați glosarul final Noda pentru terminologia fintech și open banking de la A la Z.",
        "title": "Glosar Open Banking | Noda"
      },
      "instant-payment-links": {
        "description": "Generează link de plată rapid pentru tranzacții online. Trimite un link de plată și primește plata instant prin banca preferată.",
        "title": "Link de plată – Plăți instantanee simplificate | Noda"
      },
      "legal": {
        "cookies": {
          "description": "Politica de cookie-uri Noda explică modul în care folosim cookie-urile pentru funcționalitate, analiză și marketing. Aflați cum să vă gestionați preferințele.",
          "title": "Politica privind cookie-urile"
        },
        "policy": {
          "description": "Descoperiți cum Noda colectează, utilizează și vă protejează datele personale în conformitate cu GDPR și alte reglementări. Intimitatea ta este prioritatea noastră.",
          "title": "Politica de confidențialitate"
        },
        "privacy-notice-for-job-candidates-or-cooperation": {
          "description": "Această notificare explică modul în care Noda tratează datele cu caracter personal ale potențialilor angajați, stagiari care au aplicat sau au fost invitați să aplice pentru posturile deschise la Noda sau să coopereze cu Noda în calitate de contractori individuali.",
          "title": "Notificare privind confidențialitatea pentru candidații la un loc de muncă sau cooperare | Noda"
        },
        "terms": {
          "description": "Acest acord prezintă termenii de utilizare pentru persoanele fizice care inițiază plăți prin Noda. Aflați despre drepturile dvs. și utilizarea datelor.",
          "title": "Termeni de utilizare"
        }
      },
      "main": {
        "description": "Valorificați puterea API-urilor cu platforma de plăți online de la Noda. Simplificați tranzacțiile și optimizați fără efort operațiunile afacerii dumneavoastră.",
        "title": "Plăți Online cu Noda | Platforma de Plăți Sigură și Eficientă"
      },
      "marketplace": {
        "description": "Explorați platforma noastră integrată de plăți. Răsfoiți piața de servicii Noda pentru a vă construi pachetul tehnologic de plată perfect. Open banking, carduri, îmbogățirea datelor, no-code.",
        "title": "Piața serviciilor de plată | Noda"
      },
      "mor": {
        "description": "Deblocați comerțul fără frontiere pentru inovațiile dvs. digitale. De la jocuri indie la software pentru întreprinderi.",
        "title": "Merchant of Record"
      },
      "newsroom": {
        "description": "Consultați cele mai recente știri despre Noda. Citiți cele mai recente articole, comunicate de presă și informații experți care prezintă serviciile de plăți bancare deschise de la Noda.",
        "title": "Suntem în știri | Noda"
      },
      "no-code": {
        "description": "Stimulați vânzările online cu pagini de plată fără cod, bazate pe inteligență artificială. Aflați cum Noda vă poate sprijini întregul flux de tranzacții - de la un cont de comerciant la procesarea zilnică a plăților.",
        "title": "Creați pagini de plată personalizate bazate pe inteligență artificială în câteva minute | Noda"
      },
      "open-banking": {
        "description": "Transformați-vă afacerea cu plățile bancare deschise Noda. Îmbunătățiți experiența clienților și asigurați tranzacții sigure. Încercați o demonstrație acum.",
        "title": "Platformă bancară deschisă pentru tranzacții sigure și fără întreruperi | Noda"
      },
      "plugins": {
        "description": "Îmbunătățiți-vă afacerea cu pluginurile Open Banking de la Noda pentru platforma de comerț electronic pe care o utilizați. Plăți ușoare, cu o experiență simplificată pentru utilizator, integrare perfectă, securitatea și eficiență a sistemului de Open Banking.",
        "magento": {
          "description": "Descoperiți pluginul Noda pentru Magento. Aflați cum să integrați Noda ca opțiune de plată Magento pe site-ul dvs. de comerț electronic.",
          "title": "Gateway de plată Magento cu Noda"
        },
        "opencart": {
          "description": "Descoperiți pluginul Noda pentru OpenCart. Aflați cum să integrați Noda ca opțiune de plată OpenCart pe site-ul dvs. de comerț electronic.",
          "title": "Gateway de plată OpenCart cu Noda"
        },
        "prestashop": {
          "description": "Descoperiți pluginul PrestaShop Noda. Aflați cum să integrați Noda ca opțiune de plată PrestaShop pe site-ul dvs. de comerț electronic.",
          "title": "Gateway de plată PrestaShop cu Noda"
        },
        "title": "Impulsionați-vă vânzările cu pluginurile Open Banking de la Noda",
        "woocommerce": {
          "description": "Descoperiți Pluginul WordPress Noda. Aflați cum să integrați Noda ca metodă de plată WooCommerce pentru afacerea dvs. de comerț electronic.",
          "title": "Gateway de plată WooCommerce cu Noda"
        }
      },
      "pricing": {
        "description": "Noda oferă prețuri competitive și previzibile pentru afacerea dumneavoastră. Îmbunătățiți-vă ecosistemul de plăți cu soluția noastră completă de open-banking.",
        "title": "Stabilirea prețurilor | Noda"
      },
      "toc": {
        "title": "TERMENI DE COOPERARE"
      },
      "use-cases": {
        "ecommerce": {
          "description": "Descoperiți portalul de plăți Noda pentru comerțul electronic și eficientizați tranzacțiile online. Începeți să utilizați Noda acum.",
          "title": "Soluții de plată pentru comerț electronic: Ridicați-vă afacerea cu Noda"
        },
        "educational-platforms": {
          "description": "Descoperiți sistemele de plată online Noda pentru educație, pentru a eficientiza tranzacțiile și a valorifica sistemul bancar deschis. Aflați mai multe...",
          "title": "Gateway de plată pentru platforme educaționale | Noda"
        },
        "marketplaces": {
          "description": "Descoperiți soluțiile de plată de pe piața online Noda pentru a eficientiza tranzacțiile și a valorifica serviciile bancare deschise. Aflați mai multe...",
          "title": "Gateway de plată pentru piețe | Noda"
        },
        "online-gaming": {
          "description": "Descoperiți soluțiile Noda de plată a jocurilor de noroc pentru a simplifica tranzacțiile și a valorifica plățile bancare deschise. Aflați mai multe...",
          "title": "Gateway de plată pentru jocuri online | Noda"
        },
        "retail": {
          "description": "Descoperiți gateway-ul de plăți cu amănuntul Noda pentru a eficientiza tranzacțiile și a valorifica plățile bancare deschise. Aflați mai multe...",
          "title": "Gateway de plată pentru retail | Noda"
        },
        "saas": {
          "description": "Descoperiți gateway-ul de plată SaaS de la Noda pentru a eficientiza tranzacțiile și a valorifica plățile bancare deschise. Aflați mai multe...",
          "title": "Gateway de plată pentru SaaS | Noda"
        },
        "travel": {
          "description": "Descoperiți soluțiile de plată Noda pentru călătoriile de afaceri și plățile online streamlone. Aflați mai multe...",
          "title": "Soluții de plată pentru călătorii: Ridicați-vă afacerea cu Noda"
        }
      }
    },
    "mission": {
      "hero": {
        "desc-1": "<b>Misiunea noastră</b> este să oferim setul de instrumente de management financiar definitiv pe care internetul secolului 21 îl merită.",
        "desc-2": "Ne propunem să eliminăm rămășițele sistemelor moștenite din secolul trecut, inclusiv întârzierile, denaturările datelor datorate intermediarilor nesfârșiți, procesarea manuală, eroarea umană și prejudecățile inerente ale unui sistem financiar cu clientelă.",
        "extended-text": "Dorim să impulsionăm transformarea sistemului financiar prin intermediul serviciilor bancare deschise.\n<b>Viziunea</b> noastră este ca plățile să se deplaseze instantaneu între conturi oriunde în lume, fără costuri suplimentare. Considerăm că analiza datelor financiare nu ar trebui să fie limitată la bănci; în schimb, persoanele fizice și întreprinderile ar trebui să aibă control asupra propriilor date.",
        "extended-title": "Transformarea financiară globală",
        "subtitle": "Pe ce ne bazăm",
        "title": "Misiune și viziune"
      },
      "products": {
        "subtitle": "Produse",
        "text": "Oferim o varietate de produse de plată care se adresează atât tranzacțiilor online, cât și celor în persoană, astfel încât clienții dvs. să se poată bucura de o experiență de plată omnichannel, fără întreruperi.",
        "title": "Ce facem"
      },
      "secret": {
        "communication": {
          "text": "Discutăm lucrurile, ne împărtășim ideile și discutăm deschis despre ceea ce funcționează bine și ceea ce nu. Este important pentru noi să fim clari și deschiși în legătură cu totul - de la proiectele noastre la viziunea noastră. La Noda, toată lumea rămâne la curent.",
          "title": "Comunicare"
        },
        "empathy": {
          "text": "Dar nu este vorba doar despre tehnologie - este vorba despre tine. Suntem aici pentru a asculta, înțelege și sprijini clienții noștri. Fie că aveți o afacere de ani de zile sau sunteți la început de drum, la Noda veți găsi o atmosferă primitoare în care nevoile dvs. sunt pe primul loc.",
          "title": "Empatia"
        },
        "innovation": {
          "text": "Experimentăm și încercăm idei în mod constant. Acceptăm noile tehnologii, cum ar fi blockchain și AI. Dorim să vă oferim soluții de ultimă generație care să facă plățile mai plăcute și mai ușoare. Și nu ne este teamă să gândim în afara cutiei.",
          "title": "Inovație"
        },
        "subtitle": "Mai multe despre noi",
        "title": "Sosul nostru secret"
      },
      "welcome": {
        "desc-1": "Dezvoltăm o platformă care permite întreprinderilor online să gestioneze o gamă largă de interacțiuni cu clienții, inclusiv integrarea, verificarea identității și a averii, evaluarea riscurilor, rutarea, plățile primite și efectuate și analiza performanței interacțiunilor.",
        "desc-2": "Suntem motivați de progresul produsului nostru și al industriei, mai degrabă decât de profitul obținut de la clienții noștri. Suntem mândri să vedem cum soluțiile produselor noastre încep să modeleze industria bancară deschisă pe piețele pe care activăm.",
        "desc-3": "Suntem partenerii dumneavoastră în domeniul plăților -\npionieri, creatori și aliați permanenți.",
        "extended-subtitle": "Bine ați venit în viitorul tehnologiei financiare.",
        "extended-title": "Bine ați venit la Noda",
        "title": "Cine suntem"
      },
      "whales": {
        "exploration": {
          "text": "Învățăm mereu. Membrii echipei noastre sunt pasionați și entuziaști, dornici de auto-creștere și dezvoltare profesională. La Noda, susținem această dorință.",
          "title": "Explorare"
        },
        "passion": {
          "text": "La Noda, pasiunea alimentează tot ceea ce facem. Suntem conduși de excelență, fie că inovăm sau ne conectăm cu clienții. Credem că pasiunea transformă proiectele în ceva remarcabil și îi inspiră pe ceilalți să ni se alăture.",
          "title": "Pasiune"
        },
        "responsibility": {
          "text": "Nu pierdem timpul certându-ne sau arătând cu degetul. La Noda, lucrăm întotdeauna împreună pentru a găsi soluții constructive, respectându-ne reciproc și împărțind responsabilitatea atât pentru victorii, cât și pentru eșecuri.",
          "title": "Responsabilitate"
        },
        "subtitle": "Cultura Noda",
        "title": "Trei balene\ndin codul nostru cultural Noda"
      }
    },
    "modern-slavery": {
      "intro-1": "Legea Sclaviei Moderne din 2015 (MSA) din Regatul Unit vizează combaterea sclaviei și solicită organizațiilor să prevină activ sclavia modernă în activitățile lor.",
      "intro-2": "Noda este dedicată combaterii sclaviei și prevenirii oricărei asocieri cu, promovări sau susțineri a traficului de persoane sau sclaviei în operațiunile sale. Această declarație reafirmă aderarea noastră la MSA, subliniază poziția noastră împotriva sclaviei moderne și delimitează pașii pe care îi facem pentru a asigura implementarea eficientă a abordării noastre.",
      "last-update-at": "Ultima actualizare la 1 iunie 2024",
      "note": "VĂ RUGĂM SĂ REȚINEȚI: Deși Noda nu este în prezent obligată legal să publice această declarație, credem că trebuie să luăm măsuri responsabile chiar înainte ca acestea să devină obligatorii.",
      "sections": {
        "our-status": {
          "text-1": "Noda a implementat diverse controale pentru a se asigura că nu participăm la nicio activitate care contrazice poziția noastră privind sclavia modernă. Mai jos sunt enumerate câteva dintre aceste măsuri.",
          "text-2": "Noda folosește mai mulți furnizori care oferă servicii profesionale, cum ar fi servicii de consultanță, consultanță juridică și servicii de contabilitate, dacă este necesar. În plus, colaborăm cu furnizori care oferă hardware și software, incluzând echipamente de computere, licențe software și servicii de stocare a datelor în cloud. Majoritatea furnizorilor noștri sunt situați în locațiile unde au activitate birourile noastre, și anume în Regatul Unit și UE.",
          "text-3": "În calitate de companie de tehnologie de plăți bazate pe internet, cu majoritatea furnizorilor noștri compuși din furnizori de software și servicii profesionale, profilul nostru de risc în ceea ce privește drepturile omului și sclavia modernă este evaluat ca fiind scăzut. Cu toate acestea, toți furnizorii trebuie să adere la politicile noastre interne, care, printre altele, impun ca toți vânzătorii să fie supuși verificării și diligenței necesare, nivelul de control variind în funcție de categoria lor de risc.",
          "text-4": "Majoritatea comercianților cărora Noda le oferă servicii sunt situați în zone geografice cu risc scăzut și sunt supuși diligenței necesare pentru a confirma statutul lor de risc scăzut.",
          "text-5": "Noda are cunoștință de niciun caz de sclavie sau trafic de persoane în cadrul afacerilor sale sau a lanțurilor de aprovizionare. Pe parcursul ultimului an financiar, nu au fost identificate sau raportate potențiale probleme de această natură prin canalele interne de raportare, procesele de audit, canalele de avertizare sau prin orice alte mijloace. În plus, Noda nu a primit nicio informație de la nicio entitate din cadrul grupului Noda care să sugereze existența unor astfel de probleme cu vreunul dintre furnizorii săi din cadrul grupului sau din lanțurile lor de aprovizionare.",
          "text-6": "Ne angajăm să respectăm toate drepturile omului recunoscute internațional în ceea ce privește angajații noștri, comunitățile în care activăm și comunitățile din lanțurile noastre globale de aprovizionare. În cazul în care Noda află că orice parte cu care avem o relație este implicată în încălcări ale drepturilor omului sau infracțiuni de sclavie modernă, vom înceta imediat asocierea noastră cu acea entitate.",
          "text-7": "Îngrijorările legate de drepturile omului sau sclavia modernă care implică oricare dintre comercianții și furnizorii noștri sau alte părți ale noastre pot fi raportate către Noda la <a href=\"mailto:legal@noda.live\" target=\"_blank\">Legal@noda.live</a>. Vă asigurăm că vom investiga prompt și temeinic orice astfel de raportări.",
          "title": "Statutul, operațiunile și lanțul nostru de aprovizionare"
        }
      },
      "subtitle": "Intenția declarației",
      "title": "Declarație privind sclavia modernă"
    },
    "mor": {
      "case": {
        "subtitle": "Studiu de caz",
        "text": "În februarie 2023, Wargaming, un editor de jocuri online premiat, s-a alăturat Noda pentru a introduce plăți bancare instantanee deschise jocurilor. Acest parteneriat a permis jucătorilor de Wargaming să acceseze diverse opțiuni de plată online, inclusiv tranzacții de la cont la cont (A2A)",
        "title": "Wargaming și Noda"
      },
      "cure": {
        "additional": {
          "text1": "Calculul taxei de vânzare, TVA și GST",
          "text2": "Depuneri la timp la autoritățile fiscale din întreaga lume",
          "text3": "Ultimele actualizări ale legii fiscale",
          "text4": "Arhive în detaliu pentru momentele de genul „doar în caz că”"
        },
        "bold-text": "Ce gestionăm:",
        "subtitle": "Un leac pentru durerile de cap datorate taxelor",
        "text": "Fără coșmaruri cauzate de taxe! Sistemul nostru inteligent calculează cifrele, depune formularele și vă menține în siguranță pe piețele țintă. Rămânem la curent cu legile fiscale în continuă schimbare din întreaga lume, eliminând barierele inutile pentru ca dvs. să puteți ajunge la publicul dumneavoastră.",
        "title": "Aliatul dvs. global în scopul Conformității Fiscale"
      },
      "custom": {
        "subtitle": "cum funcționează",
        "text": "Permiteți-ne să vă netezim drumul spre piețele globale, transformând vânzările internaționale complexe în tranzacții fără probleme.",
        "title": "Ne vom ocupa noi de părțile încurcate din spatele scenei: plăți, impozite, asistență"
      },
      "faq": {
        "offer": {
          "content": "Oferim asistență 24/7 în mai multe limbi pentru a ajuta în orice problemă, de la probleme de plată la întrebări legate de cont. Echipa noastră este întotdeauna disponibilă pentru a vă ajuta să navigați prin complexitățile comerțului digital global.",
          "title": "Ce fel de asistență oferă Noda?"
        },
        "payment-security": {
          "content": "Folosim open banking pentru transferuri bancare directe, care verifică titularii de cont în timp real. Această abordare, combinată cu monitorizarea noastră avansată a tranzacțiilor, reduce semnificativ riscul de fraudă, menținând, în același timp, o experiență de utilizare fluidă.",
          "title": "Cum gestionează Noda securitatea plăților și prevenirea fraudelor?"
        },
        "products": {
          "content": "Categoric! Ne specializăm în facilitarea comerțului fără frontiere. Platforma noastră gestionează mai multe tipuri de monede, localizează metodele de plată și gestionează conformitatea fiscală internațională, făcând mai ușor accesul la clienții dvs. din întreaga lume.",
          "title": "Poate Noda să mă ajute să îmi vând produsele la nivel internațional?"
        },
        "services": {
          "content": "Nu neapărat. Deși puteți utiliza serviciile noastre cu site-ul dvs. existent, oferim și instrumente de distribuire gratuite, inclusiv un creator de site-uri și magazine intuitiv, fără cod, pentru a vă ajuta să începeți, dacă încă nu aveți un site web.",
          "title": "Am nevoie de propriul meu site web pentru a utiliza serviciile Noda?"
        },
        "subtitle": "Trebuie să știți",
        "tax-compliance": {
          "content": "Sistemul nostru inteligent calculează, colectează și remite automat taxele de vânzare, TVA și GST pentru tranzacțiile dvs. la nivel mondial. Suntem la curent cu legile fiscale în schimbare și menținem registre detaliate, asigurându-ne că sunteți întotdeauna în conformitate cu orice piață pe care vindeți.",
          "title": "Cum ajută Noda cu conformitatea fiscală?"
        },
        "title": "Întrebări frecvente"
      },
      "geo": {
        "btn-text": "Lista de bănci acceptate"
      },
      "hero-data": {
        "subtitle": "merchant of record",
        "text1": "Deblocați comerțul fără frontiere pentru inovațiile dvs. digitale.",
        "text2": "De la jocuri indie la software pentru întreprinderi.",
        "title": "Concentrați-vă pe crearea următorului dvs. proiect gigant - noi ne ocupăm de lucrurile complicate!"
      },
      "squad": {
        "additional": {
          "text1": "Asistență non-stop în mai multe limbi",
          "text2": "Sugestii inteligente pentru a îndruma deciziile tale în afaceri",
          "text3": "Măsuri puternice de securitate pentru a proteja veniturile dumneavoastră",
          "text4": "Actualizări regulate de tehnologie, care mențin operațiunile dvs. fără probleme"
        },
        "subtitle": "Orientare și asistență",
        "text": "Echipa noastră de asistență este aici pentru dumneavoastră, gata să intervină ori de câte ori aveți nevoie de noi. Fie că este vorba de o problemă cu o plată noaptea târziu sau de o întrebare despre contul dumneavoastră, noi suntem disponibili.\n\n De la creatori individuali la studiouri aglomerate, suntem aici pentru a vă ajuta să aveți succes pe piețele globale. Trusa noastră de instrumente de ajutor include:",
        "title": "Trupa ta de întăriri 24/7"
      }
    },
    "newsroom": {
      "title": "Sala de redacție"
    },
    "no-code": {
      "features": {
        "custom-payment": "Pagini de plată personalizate pe loc",
        "instant": "Tranzacții instantanee, sigure",
        "leverage-ai": "Folosiți inteligența artificială pentru a crea pagini complete de plată de marcă în câteva clicuri.",
        "real-time": "Plăți în timp real, autorizarea plătitorului prin intermediul băncii, experiență perfectă pentru client.",
        "sell-anything": "Vindeți orice fără un site web",
        "tag-title": "CARACTERISTICI CHEIE",
        "text": "Vindeți bunuri și servicii digitale și fizice fără a fi nevoit să vă chinuiți cu dezvoltarea și configurarea îndelungată.",
        "title": "O scurtătură pentru a vă crește vânzările\nde produse online",
        "turn-any": "Transformați orice canal în piața dvs. online. Lăsați Noda să gestioneze întregul flux de plăți."
      },
      "hero": {
        "text": "Creați experiențe de plată personalizate cu AI în câteva minute",
        "title": "Pagină De Plată\nFără Cod"
      },
      "how-it-works": {
        "ai-based": "Analiză bazată pe AI",
        "authorize": "Autorizați direct în chat și navigați la funcționalitatea de creare a paginii.",
        "enter-your": "Introduceți cererea dvs. sau încărcați o descriere existentă a produsului. Oferiți chatbot-ului un moment pentru procesare.",
        "make-necessary": "Faceți ajustările necesare, aprobați versiunea care vă place și începeți să vindeți!",
        "payment-page": "Pagina de plată este gata",
        "preview": "Previzualizare",
        "tag-title": "cum funcționează",
        "text-first": "Creați pagini de plată personalizate în câteva minute utilizând o interfață simplă de chat AI.",
        "text-second": "Generați automat text și imagini pe baza detaliilor produsului dvs. Integrați link-uri de plată și coduri QR pentru o pagină de plată complet funcțională.",
        "the-bot": "Robotul generează o pagină de plată completă pe baza datelor introduse de dvs.: imagini, text, funcționalitate de plată, cod QR.",
        "title": "Generator inteligent de pagini de plată",
        "user-friendly": "Interfață ușor de utilizat"
      },
      "monetize": {
        "direct-sales": "Vânzări directe",
        "donations": "Donații",
        "event-tickets": "Bilete la eveniment",
        "games": "Jocuri și articole pentru jocuri",
        "lean": "Intrați în noi modele de afaceri. Creați pagini de plată personalizate și începeți să vindeți imediat ce apăsați pe \"Salvare\".",
        "monetize": "Monetizați orice",
        "online-courses": "Cursuri online",
        "online-retail": "Comerț cu amănuntul online",
        "tips": "Sfaturi",
        "travel-packages": "Pachete de călătorie"
      },
      "product-block": {
        "text": "Pagini de plată personalizate în câteva minute. Fără dezvoltare, fără du-te-vino cu designeri și copywriteri. O modalitate simplă, frumoasă și de încredere pentru clienții dvs. de a plăti prin diverse canale și modele de afaceri.",
        "title": "Pagină De Plată Fără Cod"
      },
      "sell": {
        "are-you": "Construiți o afacere online de la zero sau explorați noi fluxuri de venituri pentru o afacere existentă?\n\nConectați-vă direct cu clienții dvs. prin lansarea vânzărilor prin e-mail, mesagerie, social media, transmisii live – oriunde, de fapt, unde puteți partaja un link către pagina de plată.",
        "launch": "Lansați vânzările cu ușurință: fără site web, fără integrare a plăților, fără discuții cu dezvoltatori și designeri.\n\nPlatforma de plată Noda vă va sprijini întregul flux de tranzacții – de la furnizarea unui cont de comerciant la procesarea zilnică a plăților.",
        "reach": "Ajungeți la clienții dvs. oriunde s-ar afla",
        "secure": "Plăți instantanee securizate",
        "tag-title": "VINDE FĂRĂ UN SITE WEB"
      }
    },
    "partners": {
      "available": {
        "list": {
          "item1": {
            "text": "Integrați fără probleme tehnologia noastră în propriile soluții ca partener white-label",
            "title": "Etichetă albă"
          },
          "item2": {
            "text": "Invitați companii folosind link-uri de recomandare ca partener reseller",
            "title": "Revânzător"
          },
          "item3": {
            "text": "Operați sub marca noastră ca partener de franciză",
            "title": "Franciză"
          },
          "item4": {
            "text": "Aduceți clienți de top ca agent",
            "title": "Agent"
          }
        },
        "subtitle": "varietate de opțiuni",
        "title": "Parteneriate disponibile"
      },
      "banking": {
        "item1": "țări",
        "item2": "platforme e-com integrate",
        "item3": "produse digitale dezvoltate",
        "subtitle": "Alege-ți parteneriatul perfect",
        "text": "Explorați o varietate de opțiuni de parteneriat adaptate nevoilor dumneavoastră. Fie că doriți să integrați tehnologia noastră, să recomandați alte afaceri, să valorificați marca noastră sau să vă conectați cu clienți de valoare ridicată, avem calea de parteneriat perfectă pentru dvs.",
        "title": "Cum funcționează"
      },
      "customisation": {
        "subtitle": "interfață personalizată",
        "text": "Indiferent dacă doriți să vă dezvoltați propriul front-end sau să utilizați instrumentele noastre integrate pentru interfețele utilizator (UIs), alegerea vă aparține. Modelează-ți designul pentru a-ți reprezenta pe deplin brandul și creează călătoria perfectă.",
        "title": "Personalizarea mărcii"
      },
      "hero": {
        "subtitle": "plăți mai bune",
        "text": "Integrați fără efort tranzacțiile bancare deschise, accesați analize acționabile și beneficiați de UX-ul nostru intuitiv. Bucurați-vă de integrarea API fără probleme și de raportarea transparentă pentru a stimula succesul comercianților.",
        "title": "Ajutați-vă comercianții să crească cu Open Banking"
      },
      "reporting": {
        "subtitle": "transparență totală",
        "text": "Cu hub-ul nostru de administrare puteți urmări toate comisioanele, asigurând o raportare clară și transparentă. Supravegheați fără efort plățile și plățile, obținând vizibilitate completă și gestionându-vă operațiunile cu ușurință.",
        "title": "Monitorizare detaliată și raportare"
      },
      "technology": {
        "subtitle": "puterea tehnologiei",
        "text1": "Înainte de open banking, băncile tradiționale dețineau monopolul asupra datelor clienților. În 2018, PSD2 din UE a impus băncilor să partajeze informații cu furnizori terți autorizați, precum Noda, cu consimțământul clienților.",
        "text2": "Serviciile bancare deschise utilizează interfețe de programare a aplicațiilor (API) pentru comunicarea software în vederea transferului de date. Atunci când utilizatorii optează pentru o plată de tip open banking, aceștia sunt redirecționați către interfața băncii lor de încredere.",
        "text3": "Un număr tot mai mare de consumatori și comercianți din întreaga lume adoptă această tehnologie emergentă. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">Juniper Research</a> preconizează că valoarea totală a plăților prin open banking va crește de la 57 de miliarde de dolari în 2023 la 330 de miliarde de dolari până în 2027. Ceea ce a fost considerat odată inovator devine rapid o metodă de plată adoptată pe scară largă.",
        "title": "Open Banking transformă sistemele de plată"
      }
    },
    "plugins": {
      "back-to-plugins": "Înapoi la Plugin-uri",
      "bigcommerce": {
        "benefits": {
          "list": {
            "text": "plugin-ul nostru de plată WooCommerce WordPress oferă o experiență de utilizator fără probleme clienților dvs. Astfel, clienții vor fi mai mulțumiți și vor abandona mai rar coșurile de cumpărături.",
            "text-1": "plugin-ul nostru de plată WooCommerce WordPress oferă o experiență de utilizator fără probleme clienților dvs. Astfel, clienții vor fi mai mulțumiți și vor abandona mai rar coșurile de cumpărături.",
            "title": "Experiență intuitivă pentru utilizator",
            "title-1": "Experiență intuitivă pentru utilizator"
          },
          "title": "Beneficiile oferite de Noda pentru WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Cum testez acest plugin?",
              "text": "Puteți activa modul de testare al plugin-ului, care vă permite să simulați tranzacții."
            },
            "2": {
              "summary": "Plugin-ul acceptă abonamente WooCommerce?",
              "text": "Puteți activa modul de testare al plugin-ului, care vă permite să simulați tranzacții."
            },
            "3": {
              "summary": "De ce nu apare butonul de solicitare a plății pe dispozitivul meu?",
              "text": "Puteți activa modul de testare al plugin-ului, care vă permite să simulați tranzacții."
            }
          },
          "title": "Răspunsuri la cele mai frecvente întrebări"
        },
        "hero": {
          "button": "Adăugați Noda la WooCommerce",
          "logo": "bigcommerce",
          "text": "Descoperiți plugin-ul WordPress de la Noda, care permite plăți Open Banking pentru WooCommerce. Instalați și integrați plugin-ul în doar câteva etape simple.",
          "title": "Portal de plată WordPress WooCommerce cu Noda"
        },
        "how": {
          "text": "Comercianții care instalează plugin-ul pot adăuga un buton Noda ca metodă de plată pe site-ul lor.",
          "title": "Cum funcționează?"
        },
        "inspiration": "Căutați, poate, de asemenea",
        "integration": {
          "after": "Integrarea se realizează cu doar câteva clicuri și nu aveți nevoie de programatori în echipă. Cu Noda, comercianții pot adăuga fără efort plăți open banking ca opțiune de plată WooCommerce.",
          "before": "Pentru a configura plugin-ul de plată WordPress WooCommerce cu Noda, comercianții trebuie să urmeze acești pași simpli:",
          "button": {
            "text": "Descărcare ghid"
          },
          "steps": {
            "1": "Instalați fișierul de arhivă în tabloul de gestionare WooCommerce În acest fel, plugin-ul pentru site-ul dvs. web va fi configurat.",
            "2": "Adăugați interfețe API, disponibile în Noda Hub după finalizarea înscrierii.",
            "3": "WeCommerce și Noda sunt acum conectate."
          },
          "title": "Integrarea Noda cu WooCommerce"
        },
        "what-is-it": {
          "text": "WeCommerce este un program informatic open-source construit pentru WordPress, care permite companiilor să creeze site-uri de comerț electronic cu limbajul de programare PHP. Noda oferă un plugin care facilitează plățile Open Banking ca portal de plată WordPress WooCommerce.",
          "title": "Ce este?"
        }
      },
      "details": "FAQ",
      "faq": {
        "development-skills": {
          "content": "Nu, pluginurile noastre sunt proiectate pentru o instalare ușoară, fără a necesita abilități tehnice specializate. Ghidurile pas cu pas vă vor ghida prin procesul simplu. Dacă întâmpinați dificultăți, echipa noastră de asistență este gata să vă asiste.",
          "title": "Am nevoie de abilități de dezvoltare pentru a instala aceste plugin-uri?"
        },
        "how-secure": {
          "content": "Toate pluginurile Noda respectă standardele stricte de securitate și cerințele de reglementare pentru open banking. Tranzacțiile sunt securizate cu autentificare multi-factor și criptare a datelor pentru a proteja atât comercianții, cât și clienții.",
          "title": "Cât de sigure sunt aceste pluginuri de plată?"
        },
        "plugins-compatible": {
          "content": "Pluginurile Noda sunt concepute special pentru plățile bancare deschise, permițând clienților să plătească direct din conturile lor bancare. Acest lucru oferă securitate sporită și costuri de tranzacție mai mici în comparație cu metodele tradiționale de plată.",
          "title": "Sunt pluginurile Noda compatibile cu toate metodele de plată?"
        },
        "subtitle": "FAQ",
        "title": "Cele mai frecvente întrebări",
        "troubleshooting": {
          "content": "Echipa noastră de asistență este disponibilă pentru a vă ajuta cu instalarea, configurarea și depanarea. Pur și simplu contactați-ne prin canalele de asistență enumerate pe fiecare pagină de plugin și vom fi bucuroși să vă ajutăm.",
          "title": "Ce se întâmplă dacă am nevoie de ajutor cu instalarea sau depanarea? "
        },
        "what-is-required": {
          "content": "Pentru a utiliza orice plugin Noda, va trebui să creați un cont Noda, să finalizați procesul de integrare și să obțineți chei API. Cerințele specifice pentru fiecare platformă sunt detaliate pe paginile individuale de plugin.",
          "title": "Ce este necesar pentru a utiliza pluginurile Noda? "
        }
      },
      "fqa": "fqa",
      "hero": {
        "button": "Contactați echipa noastră",
        "subtitle": "Integrați Noda în câteva minute cu pluginurile noastre gata făcute. Simplificați plățile cu o experiență simplificată a utilizatorului, o integrare perfectă și o securitate sporită a open banking-ului.",
        "title": "Plăți bancare deschise fără întreruperi pentru platforma dvs. de comerț electronic"
      },
      "info": {
        "bigcommerce": {
          "subtitle": "În curând",
          "text": "Pluginul BigCommerce de la Noda simplifică adăugarea plăților open banking la site-ul dvs. BigCommerce. Instalare rapidă pentru un proces de plată simplificat.",
          "title": "BigCommerce"
        },
        "magento": {
          "text": "Descoperiți pluginul Magento de la Noda. Aflați cum puteți integra Noda ca opțiune de plată Magento pe site-ul dvs. de comerț electronic și dezvolta afacerea cu plăți open banking.",
          "title": "Magento"
        },
        "opencart": {
          "text": "Aflați cum puteți integra Noda ca opțiune de plată OpenCart pe site-ul dvs. de comerț electronic. Simplificați-vă plățile cu servicii de open banking.",
          "title": "OpenCart"
        },
        "prestashop": {
          "text": "Integrați plățile open-banking cu plugin-ul PrestaShop de la Noda. Instalați Noda ca opțiune de plată PrestaShop pe site-ul dvs. de comerț electronic cu o configurare rapidă și ușoară.",
          "title": "PrestaShop"
        },
        "step-title": "Pasul",
        "woocommerce": {
          "text": "Descoperiți pluginul WordPress de la Noda, care permite plăți open banking pentru WooCommerce. Instalați și integrați plugin-ul în doar câțiva pași simpli.",
          "title": "WooCommerce"
        }
      },
      "integration": {
        "btn-request": "Solicitați integrarea",
        "btn-view": "Vezi documentația API",
        "description": "Ne extindem continuu pluginurile – contactați-ne pentru integrări personalizate sau consultați documentele noastre API pentru opțiuni de dezvoltare.",
        "title": "Solicitați integrarea"
      },
      "magento": {
        "benefits": {
          "button": {
            "text": "Contactați echipa noastră"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Integrarea noastră de comerț electronic Magento oferă o experiență de utilizator fără probleme clienților dvs. Astfel, clienții vor fi mai mulțumiți și vor abandona mai rar coșurile de cumpărături.",
              "title": "Experiență utilizator (UX)"
            },
            "2": {
              "icon": "hartă",
              "text": "Comercianții pot instala pluginurile Noda fără a avea nevoie de o echipă de programatori sau de abilități tehnice.",
              "title": "Integrare perfectă"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Funcționalitatea Open banking asigură securitatea clienților și comercianților. Verificarea cu mai mulți factori este o cerință legală în conformitate cu reglementările europene.",
              "title": "Securitate"
            },
            "4": {
              "icon": "all_match",
              "text": "Procesarea plăților Magento cu sistemul open banking este mai rapidă și mai accesibilă pentru comercianți, asigurându-se un proces de plată și de primire a fondurilor mai rapid.",
              "title": "Eficiență"
            }
          },
          "title": "Beneficiile utilizării Noda pentru Magento"
        },
        "hero": {
          "button": "Adăugați Noda la Magento",
          "logo": "magento",
          "text": "Descoperiți plugin-ul Magento de la Noda. Aflați cum puteți integra Noda ca opțiune de plată Magento pe site-ul dvs. de comerț electronic.",
          "title": "Portalul de plată Magento cu Noda"
        },
        "how": {
          "text": "Comercianții care instalează plugin-ul pot adăuga Noda ca una dintre metodele lor de plată Magento pe care clienții o pot utiliza.",
          "title": "Cum funcționează?"
        },
        "inspiration": "Căutați, poate, de asemenea",
        "integration": {
          "after": "Integrarea se efectuează cu numai câteva clicuri și nu necesită abilități tehnice avansate. Cu Noda, comercianții pot adăuga fără efort funcționalitatea open banking ca soluție de comerț electronic Magento.",
          "before": "Pentru a configura integrarea Magento cu Noda, comercianții trebuie să urmeze acești pași simpli:",
          "steps": {
            "1": "Instalați fișierul de arhivă în panoul de gestionare Magento. În acest fel, plugin-ul pentru site-ul dvs. web va fi configurat.",
            "2": "Adăugați interfețe API, disponibile în Noda Hub după finalizarea înscrierii.",
            "3": "Magento și Noda sunt acum conectate."
          },
          "title": "Integrarea portalului de plată Magento"
        },
        "meta": {
          "description": "Descoperiți plugin-ul Magento de la Noda. Aflați cum puteți integra Noda ca opțiune de plată Magento pe site-ul dvs. de comerț electronic.",
          "title": "Portalul de plată Magento cu Noda"
        },
        "what-is-it": {
          "text": "Magento este o platformă de comerț electronic construită cu tehnologia open-source în limbajul de programare PHP. Noda oferă un plugin care permite plăți open banking pentru site-urile de comerț electronic.",
          "title": "Ce este?"
        }
      },
      "opencart": {
        "benefits": {
          "button": {
            "text": "Contactați echipa noastră"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Plățile open banking permit o experiență de utilizator simplificată pentru clienții dvs., rezultând mai puține abandonuri ale coșului de cumpărături și mai multă satisfacție a clienților.",
              "title": "Experiență intuitivă pentru utilizator"
            },
            "2": {
              "icon": "hartă",
              "text": "Cu Noda, comercianții pot instala plugin-ul fără a avea nevoie de o echipă de programatori.",
              "title": "Integrare simplă"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Funcționalitatea Open banking asigură securitatea clienților și comercianților. Verificarea cu mai mulți factori este o cerință legală în conformitate cu reglementările europene.",
              "title": "Securitate"
            },
            "4": {
              "icon": "all_match",
              "text": "Procesarea plăților OpenCart cu Noda este mai rapidă și mai accesibilă pentru comercianți, asigurându-se un proces de plată și de primire a fondurilor mai rapid.",
              "title": "Eficiență"
            }
          },
          "title": "Beneficiile utilizării Noda pentru OpenCart"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Care sunt cerințele plugin-ului OpenCart?",
              "text": "Pentru a integra cu succes plugin-ul OpenCart de la Noda, asigurați-vă că aveți o versiune PHP de minim 7.0.3. Orice versiune PHP între 7.0.3 și 8,2.x este acceptată. Veți avea nevoie, de asemenea, de versiunea  WordPress 3 sau superioară. Puteți găsi cu ușurință versiunea dvs. în partea de jos a panoului de gestionare OpenCart. Pentru a utiliza plugin-ul Noda în modul normal de funcționare, trebuie să fiți înscriși pe Noda."
            },
            "2": {
              "summary": "Cum integrez acest plugin cu Noda?",
              "text": "Pentru a integra pluginul OpenCart, instalați fișierul de arhivă din panoul de gestionare OpenCart și adăugați interfețele API disponibile pe NodaHub după conectare."
            },
            "3": {
              "summary": "Cum testez acest plugin?",
              "text": "Pentru a testa acest plugin, activați modul testare utilizând modulul Sandbox din Noda Hub. Acest lucru vă va permite să testați funcționarea."
            }
          },
          "title": "Răspunsuri la cele mai frecvente întrebări"
        },
        "hero": {
          "button": "Adăugați Noda la OpenCart",
          "logo": "opencart",
          "text": "Descoperiți plugin-ul OpenCart de la Noda. Aflați cum puteți integra Noda ca opțiune de plată OpenCart pe site-ul dvs. de comerț electronic.",
          "title": "Portalul de plată OpenCart cu Noda"
        },
        "how": {
          "text": "Comercianții care au instalat plugin-ul vor avea un buton Noda pe site-ul lor ca opțiune de plată pentru clienți.",
          "title": "Cum funcționează?"
        },
        "inspiration": "Căutați, poate, de asemenea",
        "integration": {
          "after": "Întregul proces durează doar câteva clicuri și nu necesită abilități tehnice. Cu plugin-ul de plată OpenCart de la Noda, comercianții pot adăuga fără efort funcționalitatea open banking la arsenalul lor de plată.",
          "before": "Pentru a configura integrarea portalului de plată OpenCart, comercianții trebuie să urmeze acești pași simpli:",
          "steps": {
            "1": "Instalați fișierul de arhivă în panoul de gestionare OpenCart. În acest fel, plugin-ul pentru site-ul dvs. web va fi configurat.",
            "2": "Adăugați interfețe API, disponibile în Noda Hub după finalizarea înscrierii.",
            "3": "OpenCart și Noda sunt acum conectate."
          },
          "title": "Integrare OpenCart cu Noda"
        },
        "meta": {
          "description": "Descoperiți plugin-ul OpenCart de la Noda. Aflați cum puteți integra Noda ca opțiune de plată OpenCart pe site-ul dvs. de comerț electronic.",
          "title": "Portalul de plată OpenCart cu Noda"
        },
        "what-is-it": {
          "text": "OpenCart este o platformă gratuită, open-source de comerț electronic pentru vânzarea de produse online. Se bazează pe limbajul de programare PHP și pe baza de date MySQL. Plugin-ul Noda pentru site-urile de comerț electronic permite comercianților să adauge plăți open banking ca una dintre metodele de plată OpenCart.",
          "title": "Ce este?"
        }
      },
      "platforms": "Platforme de comerț electronic acceptate",
      "pre-footer": {
        "button": "Contactați echipa noastră",
        "single-page-plugin": {
          "button": "Contactați echipa noastră",
          "subtitle": "Cum se efectuează integrarea",
          "text": "Contactați-ne pentru a afla mai multe despre modul în care colaborăm cu partenerii.",
          "title": "Sunteți gata să vă conectați?"
        },
        "subtitle": "Cum se efectuează integrarea",
        "text": "Contactați-ne pentru a afla mai multe despre modul în care colaborăm cu partenerii",
        "title": "Sunteți gata să vă conectați?"
      },
      "prestashop": {
        "benefits": {
          "button": {
            "text": "Contactați echipa noastră"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Plățile open banking permit o experiență de utilizator simplificată pentru clienții dvs. Astfel, clienții vor fi mai mulțumiți și vor abandona mai rar coșul de cumpărături.",
              "title": "Simplitate"
            },
            "2": {
              "icon": "hartă",
              "text": "Comercianții pot instala plugin-urile Noda fără a avea nevoie de o echipă de programatori sau abilități tehnice.",
              "title": "Integrare perfectă"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Funcționalitatea open banking asigură securitatea clienților și comercianților. Verificarea cu mai mulți factori este o cerință legală în conformitate cu reglementările europene.",
              "title": "Securitate"
            },
            "4": {
              "icon": "all_match",
              "text": "Plățile open-banking sunt mai rapide și mai accesibile pentru comercianți, asigurându-se un proces de plată și de primire a fondurilor mai rapid.",
              "title": "Eficiență"
            }
          },
          "title": "Beneficiile Noda pentru PrestaShop"
        },
        "hero": {
          "button": "Noda către PrestaShop",
          "logo": "prestashop",
          "text": "Descoperiți plugin-ul PrestaShop de la Noda. Aflați cum puteți integra Noda ca opțiune de plată PrestaShop pe site-ul dvs. de comerț electronic.",
          "title": "Portal de plată PrestaShop cu Noda"
        },
        "how": {
          "text": "Pe site-ul comercianților care au instalat plugin-ul va apărea un buton Noda în etapa în care clienții plătesc.",
          "title": "Cum funcționează?"
        },
        "inspiration": "Căutați, poate, de asemenea",
        "integration": {
          "after": "Integrarea se realizează cu numai câteva clicuri și nu aveți nevoie de programatori în echipă. Cu plugin-ul de plată PrestaShop de la Noda, comercianții își pot îmbunătăți fără efort strategia de plată prin open banking.",
          "before": "Pentru a efectua integrarea PrestaShop cu Noda, comercianții trebuie să urmeze acești pași simpli:",
          "steps": {
            "1": "Instalați fișierul de arhivă în panoul de administrare al PrestaShop. În acest fel, plugin-ul pentru site-ul dvs. web va fi configurat.",
            "2": "Adăugați interfețe API, disponibile în Noda Hub după finalizarea înscrierii.",
            "3": "PrestaShop și Noda sunt acum conectate."
          },
          "title": "Integrarea portalului de plată PrestaShop"
        },
        "what-is-it": {
          "text": "PrestaShop este o platformă open-source care permite comercianților să creeze și să-și dezvolte site-urile de comerț electronic în limbajul de programare PHP. Plugin-ul Noda permite comercianților să adauge funcționalitatea open banking ca una dintre metodele lor de plată PrestaShop.",
          "title": "Ce este?"
        }
      },
      "section": {
        "subtitle": "Îmbunătățiți-vă afacerea cu pluginurile Open Banking de la Noda pentru platforma de comerț electronic pe care o utilizați. Plăți ușoare, cu o experiență simplificată pentru utilizator, integrare perfectă, securitatea și eficiență a sistemului de Open Banking.",
        "title": "Impulsionați-vă vânzările cu pluginurile Open Banking de la Noda"
      },
      "soon": "În curând",
      "woocommerce": {
        "benefits": {
          "button": {
            "text": "Contactați echipa noastră"
          },
          "list": {
            "1": {
              "icon": "airline_stops",
              "text": "Plugin-ul nostru de plată WooCommerce WordPress permite o experiență de utilizator fără probleme pentru clienți. Astfel, clienții vor fi mai mulțumiți și vor abandona mai rar coșul de cumpărături.",
              "title": "Experiență de utilizator intuitivă"
            },
            "2": {
              "icon": "hartă",
              "text": "Comercianții pot instala plugin-urile Noda fără a avea nevoie de o echipă de programatori sau abilități tehnice.",
              "title": "Integrare simplă"
            },
            "3": {
              "icon": "admin_panel_settings",
              "text": "Plățile open-banking asigură securitatea clienților și comercianților. Verificarea cu mai mulți factori este o cerință legală în conformitate cu reglementările europene.",
              "title": "Securitate"
            },
            "4": {
              "icon": "all_match",
              "text": "Procesarea plăților WooCommerce cu open banking este mai rapidă și mai accesibilă pentru comercianți, asigurându-se un proces de plată și de primire a fondurilor mai rapid",
              "title": "Eficiență"
            }
          },
          "title": "Beneficiile Noda pentru WooCommerce"
        },
        "faq": {
          "details": {
            "1": {
              "summary": "Care sunt cerințele pentru plugin-ul WooCommerce?",
              "text": "Pentru a integra cu succes pluginul WooCommerce de la Noda, asigurați-vă că aveți cel puțin versiunea PHP 7.0.3; WordPress, versiunea 5.3 sau superioară și WooCommerce, o versiune 4.5 pentru asigurarea compatibilității. Pentru a utiliza plugin-ul în modul normal de funcționare, trebuie să fiți înscriși pe Noda."
            },
            "2": {
              "summary": "Cum integrez acest plugin cu Noda?",
              "text": "Pentru a integra plugin-ul WooCommerce, instalați fișierul de arhivă din panoul de gestionare WooCommerce și adăugați interfețele API disponibile în NodaHub după înregistrare."
            },
            "3": {
              "summary": "Cum testez acest plugin?",
              "text": "Pentru a testa acest plugin, activați modul testare utilizând modulul Sandbox din Noda Hub. Acest lucru vă va permite să testați funcționarea."
            },
            "4": {
              "summary": "Acest modul acceptă abonamentele WooCommerce?",
              "text": "Nu, acest modul nu acceptă abonamentele WooCommerce."
            }
          },
          "title": "Răspunsuri la întrebări frecvente"
        },
        "hero": {
          "button": "Noda către WooCommerce",
          "logo": "woocommerce",
          "text": "Descoperiți pluginul WordPress de la Noda. Aflați cum puteți integra Noda ca metodă de plată WooCommerce pentru afacerea dvs. de comerț electronic.",
          "title": "Portalul de plată WordPress WooCommerce cu Noda"
        },
        "how": {
          "text": "Comercianții care instalează plugin-ul pot adăuga un buton Noda ca metodă de plată pe site-ul lor.",
          "title": "Cum funcționează?"
        },
        "inspiration": "Căutați, poate, de asemenea",
        "integration": {
          "after": "Integrarea se realizează cu doar câteva clicuri și nu aveți nevoie de programatori în echipă. Cu Noda, comercianții pot adăuga fără efort plăți open banking ca opțiune de plată WooCommerce.",
          "before": "Pentru a configura pluginul de plată WordPress WooCommerce cu Noda, comercianții trebuie să urmeze acești pași simpli:",
          "steps": {
            "1": "Instalați fișierul de arhivă în panoul de gestionare WooCommerce. În acest fel, plugin-ul pentru site-ul dvs. web va fi configurat.",
            "2": "Adăugați interfețe API, disponibile în Noda Hub după finalizarea înscrierii.",
            "3": "WooCommerce și Noda sunt acum conectate."
          },
          "title": "Integrarea Noda cu WooCommerce"
        },
        "what-is-it": {
          "text": "WooCommerce este un program informatic open-source construit pentru WordPress, care permite companiilor să creeze site-uri de comerț electronic cu limbajul de programare PHP. Noda oferă un plugin care facilitează plățile open banking ca portal de plată WordPress WooCommerce.",
          "title": "Ce este?"
        }
      }
    },
    "policy": {
      "last-update": "Ultima actualizare la <data>12 august 2024</data>",
      "section-1": {
        "text-1": "Prin utilizarea Serviciului nostru, sunteți de acord cu Condițiile serviciului și cu prezenta Politică privind confidențialitatea.",
        "text-2": "Responsabilitatea dvs. în temeiul Acordului dintre dvs. și noi este să examinați cu atenție această Politică privind confidențialitatea și să furnizați datele corecte despre dvs.",
        "text-3": "Responsabilitatea noastră este să vă furnizăm cele mai clare și actualizate informații cu privire la modul în care prelucrăm datele dumneavoastră.",
        "title": "1. Responsabilități"
      },
      "section-2": {
        "text": "Începem să colectăm datele dvs. cu caracter personal atunci când începeți să utilizați Serviciul sau site-ul nostru. Le colectăm în scopul de a vă putea furniza Serviciul nostru și în alte scopuri, după cum se indică în Secțiunea 3 de mai jos.",
        "title": "2. Când colectăm datele dumneavoastră"
      },
      "section-3": {
        "header-1": "Scopul utilizării datelor cu caracter personal",
        "header-2": "Categoria de persoane vizate",
        "header-3": "Date cu caracter personal",
        "header-4": "Temei juridic",
        "header-5": "Perioada de păstrare",
        "t-body-10": {
          "legal": "Conformitatea cu o obligație legală",
          "personal": "Documente de identitate, imagini biometrice și alte date biometrice de identificare, sursa fondurilor, informații din instrumentele de conformitate, adresă, facturi de utilități, istoricul tranzacțiilor, fișiere de jurnalizare, CV-uri, informații și documente privind migrația, statut politic, date privind conturile bancare, site-uri web conexe, structură corporativă conexă, scor de risc",
          "purpose": "Monitorizarea tranzacțiilor și a conformității",
          "subject": "Persoane din structura Partenerilor și clienților de afaceri, beneficiari efectivi finali, plătitori ai comercianților",
          "term": "5 ani de la încetarea cooperării"
        },
        "t-body-11": {
          "legal": "Interesele legitime de a dezvolta Serviciul",
          "personal": "Nume complet, e-mail, IBAN, date privind tranzacțiile, jurnale, IP, date privind sesiunea, locație, informații privind sistemul de operare, tip de dispozitiv, informații privind autentificările, statistici privind modul în care utilizați Serviciul",
          "purpose": "Dezvoltarea și testarea Serviciului și a noilor produse",
          "subject": "Plătitori (persoane fizice), angajați și contractanți individuali ai Noda, reprezentanți ai consultanților, Parteneri și comercianți",
          "term": "Până la 5 ani după ce datele au devenit inutile"
        },
        "t-body-12": {
          "legal": "Consimțământ",
          "personal": "Numele complet, lista tranzacțiilor, suma de bani, moneda, ora plăților/data, soldul contului, numele comerciantului, identificatori interni, IBAN, cifra de afaceri medie a plătitorului, precum și module cookie și alte module de urmărire. Pentru mai multe informații, vă rugăm să consultați <a href=\"https://noda.live/about/legal-privacy/cookies\">Politica privind modulele cookie</a>.",
          "purpose": "Produsul DE (Data Enrichment) pentru dezvoltarea percepțiilor. Acest lucru ne va ajuta pe noi și pe partenerii noștri (inclusiv comercianții) să vă oferim servicii relevante, o experiență de utilizare mai bună și reclame mai bine targetate, precum și servicii personalizate.",
          "subject": "Plătitori (persoane fizice)",
          "term": "<p>Până la 5 ani.</p><p>Termenul de păstrare al modulelor cookie este stabilit în <a href=\"https://noda.live/about/legal-privacy/cookies\">Politica privind modulele cookie</a>.</p>"
        },
        "t-body-13": {
          "legal": "<p>Interesul legitim de a promova serviciile Noda</p><p>Consimțământul</p>",
          "personal": "Nume complet, adresă de e-mail, comunicare",
          "purpose": "Trimiterea de e-mailuri de marketing",
          "subject": "Persoane de contact ale clienților și partenerilor de afaceri",
          "term": "Cât timp cooperarea este în vigoare și timp de 5 ani de la încetarea cooperării (sau dacă nu există o cooperare stabilită)"
        },
        "t-body-14": {
          "legal": "<p>Interesul legitim de a promova serviciile Noda</p><p>Consimțământul</p>",
          "personal": "Nume complet, date privind rețelele sociale, număr de înregistrare, locație, module cookie și module de urmărire similare (vă rugăm să consultați <a href=\"https://noda.live/about/legal-privacy/cookies\">Politica privind modulele cookie</a>), fotografie, adresă de e-mail,",
          "purpose": "Realizarea de campanii digitale",
          "subject": "Persoane de contact ale clienților și partenerilor de afaceri",
          "term": "Cât timp cooperarea este în vigoare și timp de 5 ani de la încetarea cooperării (sau dacă nu există o cooperare stabilită)"
        },
        "t-body-15": {
          "legal": "Interesul legitim de a promova serviciile Noda",
          "personal": "Nume complet, e-mail, număr de telefon, locul de muncă, descrierea comunicării",
          "purpose": "Dezvoltarea afacerii",
          "subject": "Persoane de contact ale Partenerilor, potențialilor parteneri, clienților de afaceri și potențialilor clienți de afaceri",
          "term": "Cât timp cooperarea este în vigoare și timp de 5 ani de la încetarea cooperării (sau dacă nu există o cooperare stabilită)"
        },
        "t-body-16": {
          "legal": "Interesele legitime de a dezvolta serviciul în conformitate cu starea pieței",
          "personal": "Nume complet, poreclă, e-mail, sex, locație geografică, IP, statut profesional, rezultate ale testelor și cercetărilor, înregistrări video",
          "purpose": "Efectuarea de cercetări și crearea unei experiențe mai bune pentru utilizatori",
          "subject": "Participanți la cercetare, testeri",
          "term": "Până la 10 ani"
        },
        "t-body-17": {
          "legal": "<p>Interes legitim de a asigura securitatea și avantajul competitiv al Noda</p><p>Conformitatea cu o obligație legală</p>",
          "personal": "Informații despre dispozitivul dvs. și alte informații tehnice: adresa dvs. IP, fusul orar, geolocația, browserul/platforma utilizată pentru a accesa Serviciul",
          "purpose": "Asigurarea securității și detectarea fraudelor",
          "subject": "Orice utilizator al Serviciului, site-ului și produselor noastre",
          "term": "Până la 10 ani"
        },
        "t-body-18": {
          "legal": "Semnarea unui contract",
          "personal": "Prenume, nume, e-mail, număr de telefon",
          "purpose": "Încheierea acordurilor",
          "subject": "Reprezentanți ai furnizorilor și clienților",
          "term": "Până la 10 ani de la încetarea contractului"
        },
        "t-body-19": {
          "legal": "<p>Executarea unui contract</p><p>Interese legitime de a obține venituri</p>",
          "personal": "Prenume, nume, e-mail, număr de telefon, detalii bancare și de plată, informații din facturi, informații privind identitatea, acorduri și împuterniciri",
          "purpose": "Achitarea facturilor",
          "subject": "Reprezentanți ai furnizorilor, consultanților și prestatorilor de servicii individuale",
          "term": "Până la 10 ani de la achitarea facturii"
        },
        "t-body-1": {
          "legal": "Încheierea unui contract și executarea unui contract",
          "personal": "Numele complet, data nașterii, adresa, adresa de e-mail, numărul de telefon, datele financiare și bancare (inclusiv, dar fără a se limita la, informații privind contul bancar sau contul de plăți, date privind tranzacțiile, date privind împrumuturile și investițiile), informații privind banca sau un alt furnizor de cont și alte date care ne pot fi furnizate de furnizorul contului de plăți",
          "purpose": "Inițierea și procesarea plăților online",
          "subject": "Plătitori (persoane fizice)",
          "term": "În timp ce Serviciul este utilizat și până la 10 ani după încetarea furnizării Serviciului"
        },
        "t-body-20": {
          "legal": "Interese legitime de a susține funcționarea afacerii",
          "personal": "Prenume, nume, e-mail, număr de telefon",
          "purpose": "Utilizarea serviciilor părților terțe",
          "subject": "Reprezentanți ai furnizorilor, consultanților și prestatorilor de servicii individuale",
          "term": "Până la 10 ani de la încetarea cooperării"
        },
        "t-body-21": {
          "legal": "<p>Interese legitime de a susține funcționarea afacerii</p><p>Conformitatea cu o cerință legală</p>",
          "personal": "Prenume, nume, e-mail, număr de telefon, cod ID, adresă, informații privind relația cu companiile relevante",
          "purpose": "Efectuarea de tranzacții corporative",
          "subject": "Reprezentanți și angajați ai companiilor relevante și ai companiilor implicate",
          "term": "Atât timp cât există o societate corespunzătoare și timp de până la 10-80 de ani ulterior, în funcție de cerințele locale"
        },
        "t-body-22": {
          "legal": "Interesele legitime de a proteja poziția companiei Noda",
          "personal": "Orice date cu caracter personal necesare pentru soluționarea conflictului sau litigiului respectiv",
          "purpose": "Rezolvarea conflictelor",
          "subject": "Orice persoane vizate",
          "term": "Atât timp cât există un conflict corespunzător și până la 10 ani după soluționarea acestuia"
        },
        "t-body-23": {
          "legal": "Conformitatea cu o obligație legală",
          "personal": "Orice date cu caracter personal care se află în documentele care fac obiectul cerințelor de arhivare",
          "purpose": "Arhivarea și stocarea documentelor",
          "subject": "Orice persoane vizate",
          "term": "În funcție de cerințele locale"
        },
        "t-body-2": {
          "legal": "Încheierea unui contract și executarea unui contract",
          "personal": "Nume complet, adresă de e-mail, număr de telefon, comunicare",
          "purpose": "Inițierea și procesarea plăților online",
          "subject": "Reprezentanți ai clienților comerciali care utilizează serviciile de plată Noda",
          "term": "În timp ce Serviciul este utilizat și până la 10 ani după încetarea furnizării Serviciului"
        },
        "t-body-3": {
          "legal": "<p>Încheierea unui contract și executarea unui contract</p><p> Interesul legitim al Noda de a respecta cerințele privind infrastructura de prelucrare a cardurilor</p>",
          "personal": "Detaliile tranzacției, numărul cardului, data de expirare, locul plății, valoarea tranzacției, frecvența tranzacțiilor, serviciile sau bunurile achiziționate, IP, e-mail, informații suplimentare despre achiziție",
          "purpose": "Furnizarea de servicii de procesare a cardurilor",
          "subject": "Plătitori (persoane fizice)",
          "term": "În timp ce Serviciul este utilizat și până la 10 ani după încetarea furnizării Serviciului"
        },
        "t-body-4": {
          "legal": "Încheierea unui contract și executarea unui contract",
          "personal": "Nume complet, e-mail, număr de telefon, banca sau furnizorul de servicii de plată reprezentat",
          "purpose": "Furnizarea de servicii de procesare a cardurilor",
          "subject": "Reprezentanți ai Partenerilor",
          "term": "În timp ce Serviciul este utilizat și până la 10 ani după încetarea furnizării Serviciului"
        },
        "t-body-5": {
          "legal": "<p>Încheierea unui contract și executarea unui contract</p><p>Conformitatea cu o obligație legală</p>",
          "personal": "Informații privind contul bancar, adresa de e-mail și date privind conformitatea, după cum se indică mai jos",
          "purpose": "Integrarea comercianților",
          "subject": "Reprezentanți ai comercianților, persoane legate de structura corporativă a comercianților",
          "term": "Cât timp cooperarea este în vigoare și până la 10 ani după încheierea acesteia"
        },
        "t-body-6": {
          "legal": "<p>Interesul legitim de a oferi utilizatorilor finali posibilitatea de a utiliza Serviciul</p><p>Conformitatea cu o obligație legală</p>",
          "personal": "Nume complet, data nașterii, adresă, e-mail, număr de telefon, informații privind tranzacțiile, număr de referință intern, IBAN, informații privind comerciantul utilizat, detalii privind plata, fișiere de jurnalizare, informații privind listele de retragere voluntară",
          "purpose": "Furnizarea de servicii de asistență pentru clienți",
          "subject": "Plătitori (persoane fizice)",
          "term": "În timp ce are loc comunicarea și până la 10 ani după rezolvarea unei probleme"
        },
        "t-body-7": {
          "legal": "<p>Executarea unui contract</p><p>Interes legitim de furnizare către clienți a unui Serviciu calitativ</p>",
          "personal": "Orice date cu caracter personal furnizate prin canale de comunicare, inclusiv chatbot",
          "purpose": "Furnizarea de servicii de asistență pentru afacere",
          "subject": "Reprezentanți ai clienților de afaceri sau ai Partenerilor care utilizează serviciile de plată Noda sau cooperează cu Noda",
          "term": "În timp ce are loc comunicarea și până la 10 ani după rezolvarea unei probleme"
        },
        "t-body-8": {
          "legal": "Interesul legitim de a furniza clienților un Serviciu calitativ",
          "personal": "Nume complet, e-mail, număr de telefon",
          "purpose": "Notificare privind actualizările",
          "subject": "Reprezentanți și persoane de contact ale clienților comerciali",
          "term": "Până la 10 ani de la trimiterea notificării"
        },
        "t-body-9": {
          "legal": "<p>Conformitatea cu o obligație legală1<p></p>Interes legitim pentru stabilirea de parteneriate cu alte întreprinderi</p>",
          "personal": "Documente de identitate, imagini biometrice și alte date biometrice de identificare, sursa fondurilor, informații din instrumentele de conformitate, adresă, facturi de utilități, istoricul tranzacțiilor, fișiere de jurnalizare, CV-uri, informații și documente privind migrația, statut politic, date privind conturile bancare, site-uri web conexe, structură corporativă conexă, scor de risc, informații privind plata impozitelor",
          "purpose": "Verificări de conformitate pentru respectarea obligațiilor Noda, pentru integrarea Partenerilor și respectarea cerințelor Partenerilor, verificări de conformitate pentru plătitorii comercianților",
          "subject": "Persoane din structura corporativă Noda, persoane din structura Partenerilor și clienților de afaceri, beneficiari finali, plătitori ai comercianților",
          "term": "De la 5 la 10 ani de la încetarea cooperării"
        },
        "text": "În funcție de modul în care decideți să utilizați Serviciul sau dacă vă abonați sau nu, putem utiliza următoarele date despre dvs. în conformitate cu descrierea de mai jos:",
        "text-bottom": "Indiferent dacă furnizarea datelor cu caracter personal este necesară pentru a respecta o obligație legală sau pentru a încheia/executa un contract, dar nu ne furnizați informațiile solicitate, avem dreptul de a refuza furnizarea Serviciului corespunzător, încheierea unui contract sau efectuarea unei contract fără consecințe juridice negative.",
        "title": "3. Datele pe care le colectăm, scopurile, temeiul juridic și condițiile de păstrare"
      },
      "section-4": {
        "list-1": {
          "item-1": "Furnizori de conturi de plăți și de servicii similare (bănci, emitenți de carduri etc. - „<b>Parteneri</b>”);",
          "item-2": "Părțile terțe și serviciile pe care alegeți să le utilizați în legătură cu Serviciul (de exemplu, site-urile de comerț electronic prin care utilizați Serviciul nostru sau „<b>comercianți</b>”);",
          "item-3": "Partenerii noștri de încredere pentru agregarea datelor (platforme de open banking licențiate);",
          "item-4": "Companiile grupului nostru;",
          "item-5": "Furnizorii noștri de servicii, cum ar fi contabilitatea, auditorii, serviciile de stocare și procesare a datelor, furnizorii de servicii de comunicare și colaborare online, furnizorii de servicii juridice, furnizori de servicii de detectare a sancțiunilor și de combatere a spălării banilor, serviciile de monitorizare antifraudă, bazele de date corporative, furnizorii de servicii contabile, dezvoltatorii și testerii, furnizorii de servicii de marketing, platformele de socializare, de comerț electronic și altele.",
          "item-6": "Autoritățile de reglementare, autoritățile de supraveghere, instanțele și alte organisme publice sau similare autorizate (cum ar fi ombudsmanii, autoritățile de reglementare financiară, autoritățile de reglementare a jocurilor de noroc);"
        },
        "list-2": {
          "item-1": "Dumneavoastră sau angajatorul dvs;",
          "item-2": "Comercianți;",
          "item-3": "Platforme de comerț electronic, rețele de socializare și motoare de căutare;",
          "item-4": "Autoritățile de reglementare, autoritățile de supraveghere, instanțele și alte organisme publice sau similare autorizate (cum ar fi ombudsmanii, autoritățile de reglementare financiară, autoritățile de reglementare a jocurilor de noroc);",
          "item-5": "Furnizori de servicii de depistare a sancțiunilor și de combatere a spălării banilor, servicii de monitorizare antifraudă;",
          "item-6": "Organizatori de evenimente (cum ar fi conferințe, seminarii și altele);",
          "item-7": "Asociații profesionale;",
          "item-8": "Registre publice și furnizori de servicii de conformitate."
        },
        "text-1": "Pentru a gestiona eficient Serviciul nostru, trebuie să colaborăm cu terțe părți și, prin urmare, este posibil să facem schimb de date cu acestea:",
        "text-2": "De asemenea, primim datele dumneavoastră cu caracter personal de la:",
        "title": "4. Destinatarii și sursele datelor dvs."
      },
      "section-5": {
        "text": "În cazul în care Noda transferă datele dvs. cu caracter personal în afara UE sau SEE, ne bazăm pe garanțiile oferite de actele juridice aplicabile, de exemplu, așa cum prevede Regulamentul general al UE privind protecția datelor (RGPD): deciziile de adecvare ale Comisiei Europene (articolul 45 din RGPD), clauzele contractuale standard și alte garanții prevăzute de articolele 46 și 49 din RGPD. În cazul în care datele cu caracter personal sunt transferate în SUA, Noda se poate baza pe cadrul corespunzător de transfer al datelor cu caracter personal în vigoare. În anumite cazuri, în funcție de entitatea Noda implicată, Noda s-ar putea baza, de asemenea, pe actul adițional privind transferul internațional de date din Regatul Unit la clauzele contractuale standard ale Comisiei Europene.",
        "title": "5. Transferuri internaționale ale datelor dvs. cu caracter personal"
      },
      "section-6": {
        "list": {
          "item-1": "Dreptul de a ști ce fel de date colectăm despre dumneavoastră și cum le prelucrăm. De asemenea, puteți citi cum utilizăm datele dvs. cu caracter personal în Secțiunea 3.",
          "item-2": "Dreptul de a solicita ca anumite date să fie șterse. Vă rugăm să rețineți că, în cazul unei astfel de cereri, este posibil să nu vă mai putem furniza Serviciul (integral sau parțial).",
          "item-3": "Să restricționați prelucrarea datelor dumneavoastră, să vă opuneți prelucrării datelor dumneavoastră cu caracter personal și să vă retrageți consimțământul, după caz, fără a afecta legalitatea prelucrării bazate pe consimțământ înainte de retragerea acestuia.",
          "item-4": "Dreptul de a nu ne furniza niciun fel de date cu caracter personal. În acest caz, este posibil să nu fim în măsură să vă furnizăm Serviciul nostru, integral sau parțial."
        },
        "text-1": "Aveți următoarele drepturi cu privire la datele dumneavoastră cu caracter personal:",
        "text-2": "Dacă sunteți nemulțumit de modul în care prelucrăm datele dvs. cu caracter personal, puteți depune oricând o plângere în scris la <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>. În cazul în care considerați că nu suntem în măsură să tratăm solicitarea dumneavoastră în conformitate cu legislația aplicabilă, puteți depune o plângere la o autoritate de supraveghere relevantă. Dacă vă aflați în UE, lista autorităților de supraveghere este accesibilă <a href=\"https://www.edpb.europa.eu/about-edpb/about-edpb/members_en\" target=\"_blank\" rel=\"nofollow\">aici</a>.",
        "title": "6. Drepturile dumneavoastră"
      },
      "section-7": {
        "text-1": "Dacă aveți întrebări, comentarii sau reclamații cu privire la modul în care utilizăm datele dumneavoastră, vă rugăm să le trimiteți la <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "text-2": "Pot exista alți operatori ai datelor dvs. cu caracter personal descrise în prezenta Politică privind confidențialitatea, cu excepția NAUDAPAY LIMITED.",
        "text-3": "Pentru mai multe informații, vă rugăm să ne contactați la <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>.",
        "title": "7. Informații de contact"
      },
      "section-8": {
        "text": "Putem modifica periodic Politica privind confidențialitatea, în conformitate cu modificările legilor și reglementărilor aplicabile sau cu modificările procedurilor noastre de afaceri. Prin urmare, vă sugerăm să verificați ocazional această pagină pentru cele mai noi actualizări.",
        "title": "8. Modificări aduse Politicii privind confidențialitatea"
      },
      "subtitle": "Despre utilizarea și operatorul nostru de date",
      "text-1": "La Noda.live („noi”, „nostru”, „Noda”), vă respectăm confidențialitatea și securitatea datelor. Scopul nostru este să oferim informații clare cu privire la modul în care vom utiliza datele dumneavoastră și cum puteți controla acest lucru. Prin urmare, vă sugerăm insistent să citiți cu atenție această Politică privind confidențialitatea înainte de a utiliza serviciile furnizate de noi (denumite în mod colectiv, „<b>Serviciul</b>”).",
      "text-2": "În cazul în care aveți întrebări sau nelămuriri suplimentare, vă rugăm să nu ezitați să contactați <a href=\"mailto:dpo@noda.live\" target=\"_blank\">dpo@noda.live</a>. Vom fi încântați să vă ajutăm.",
      "text-3": "Prezenta Politică privind confidențialitatea, împreună cu Condițiile serviciului, constituie întregul Acord (denumit în continuare „<b>Acord</b>”) dintre dumneavoastră și Noda.",
      "text-4": "Principalul operator al datelor dumneavoastră cu caracter personal este NAUDAPAY LIMITED, număr de înregistrare în Regatul Unit: 11741664. În cazuri separate, alte companii din grupul nostru pot fi, de asemenea, operatori ai datelor dvs. cu caracter personal descrise în prezenta Politică privind confidențialitatea. Vă rugăm să căutați informații suplimentare și detalii de contact la sfârșitul acestei Politici privind confidențialitatea.",
      "title": "Politica privind confidențialitatea"
    },
    "privacy-for-candidates": {
      "last-update": "Ultima actualizare la 1 iunie 2024",
      "section-1": {
        "text-1": "Noda utilizează datele dvs. cu caracter personal pentru a găsi o persoană potrivită pentru un post vacant în prezent sau în viitor la Noda sau la companiile din grupul său sau pentru a primi serviciile pe care le furnizați.",
        "text-2": "Dacă sunteți un contractant individual, Noda poate utiliza datele dvs. cu caracter personal pentru a efectua o verificare a conformității în funcție de cerințele legislației aplicabile (de exemplu, în ceea ce privește spălarea banilor). În cazul în care nu furnizați companiei Noda datele dvs. cu caracter personal necesare pentru astfel de verificări de conformitate, este posibil ca Noda să nu poată lucra cu dumneavoastră în calitate de contractant.",
        "text-3": "În cazul în care Noda consideră că sunteți un candidat potrivit pentru un loc de muncă, un stagiu sau o cooperare, Noda va avea nevoie de datele dvs. cu caracter personal pentru a vă face o ofertă de loc de muncă, stagiu sau cooperare.",
        "text-4": "În cazurile în care trimiteți o cerere, o plângere sau ar putea exista un potențial litigiu, Noda ar putea utiliza datele dvs. cu caracter personal pentru a rezolva problema.",
        "title": "De ce are nevoie Noda de datele dvs.?"
      },
      "section-2": {
        "text": "Această secțiune descrie datele cu caracter personal utilizate în scopurile menționate, temeiul juridic pentru utilizarea acestora și termenele de păstrare.",
        "title": "Cum gestionează Noda datele dumneavoastră?"
      },
      "section-3": {
        "list": {
          "item-1": "Companiile grupului Noda",
          "item-2": "Furnizori de servicii de stocare a datelor",
          "item-3": "Furnizori de servicii de comunicații electronice (cum ar fi serviciile de e-mail)",
          "item-4": "Recrutori și furnizori de servicii similare, inclusiv platforme de resurse umane și de recrutare",
          "item-5": "LinkedIn și platforme similare de socializare",
          "item-6": "Furnizori de servicii de conformitate",
          "item-7": "Alți furnizori de servicii externalizate (cum ar fi consultanți juridici, organizatori de evenimente și alții)",
          "item-8": "Autoritățile de reglementare, autoritățile de aplicare a legii, instanțele, organizațiile de arbitraj și alte entități publice sau private similare"
        },
        "text-1": "Noda primește datele dvs. cu caracter personal de la dvs., de la profilul LinkedIn și de la profilurile dvs. similare din rețelele de socializare, de la recrutori și de la părțile care fac referire la dvs. În cazurile în care acționați în calitate de contractant individual, Noda poate obține, de asemenea, datele dvs. cu caracter personal de la diferiți furnizori de servicii de conformitate.",
        "text-2": "Noda poate, de asemenea, să împărtășească datele dumneavoastră cu caracter personal cu următorii destinatari:",
        "title": "Sursele și destinatarii datelor"
      },
      "section-4": {
        "text": "În general, Noda nu transferă date cu caracter personal în afara Uniunii Europene și a Spațiului Economic European în cadrul procesului de recrutare. Cu toate acestea, acest lucru se poate întâmpla în cazul în care dumneavoastră sau părțile care fac referire la dumneavoastră sunteți situat/sunt situate în afara teritoriilor menționate. De asemenea, astfel de transferuri pot avea loc în cazul verificărilor de conformitate pentru contractanții individuali. În cazul în care au loc astfel de transferuri, ne bazăm pe garanțiile oferite de actele juridice aplicabile, de exemplu, așa cum prevede Regulamentul general al UE privind protecția datelor (RGPD): deciziile de adecvare ale Comisiei Europene (articolul 45 din RGPD), clauzele contractuale standard și alte garanții prevăzute de articolele 46 și 49 din RGPD. În cazul în care datele cu caracter personal sunt transferate în SUA, Noda se poate baza pe cadrul corespunzător de transfer al datelor cu caracter personal în vigoare. În anumite cazuri, în funcție de entitatea Noda implicată, Noda s-ar putea baza, de asemenea, pe actul adițional privind transferul internațional de date din Regatul Unit la clauzele contractuale standard ale Comisiei Europene.",
        "title": "Transferuri internaționale"
      },
      "section-5": {
        "list": {
          "item-1": "accesul la datele dvs. cu caracter personal sau eliberarea unei copii a datelor dvs. cu caracter personal;",
          "item-2": "corectarea datelor dvs. cu caracter personal, dacă există erori;",
          "item-3": "ștergerea datelor dvs. cu caracter personal, în cazul în care interesul legitim al Noda nu este în vigoare. Nu puteți solicita ștergerea datelor utilizate ca urmare a cerințelor de reglementare;",
          "item-4": "să vă opuneți utilizării datelor dvs. cu caracter personal, în cazul în care aceasta se bazează pe interese legitime;",
          "item-5": "restricționarea prelucrării datelor dumneavoastră cu caracter personal;",
          "item-6": "trimiteți o plângere către Noda folosind informațiile de contact furnizate mai jos. În cazul în care Noda nu se conformează solicitării dumneavoastră, puteți depune o plângere și la o autoritate de supraveghere a protecției datelor."
        },
        "text": "Puteți solicita:",
        "title": "Drepturile privind protecția datelor"
      },
      "section-6": {
        "text-1": "Operatorul datelor dvs. cu caracter personal este entitatea Noda cu care vi se propune să încheiați un acord sau care caută un candidat pentru un loc de muncă sau un potențial partener de cooperare. Pentru mai multe informații, vă rugăm să contactați Noda folosind adresa de e-mail de mai jos.",
        "text-2": "Dacă aveți întrebări sau solicitări cu privire la datele dumneavoastră cu caracter personal, vă rugăm să utilizați următoarele informații de contact: <a class=\"link highlighted\" href=\"mailto:dpo@noda.live\">dpo@noda.live</a>",
        "title": "Informații de contact"
      },
      "subtitle": "Despre notificare și Noda",
      "text-1": "Această notificare explică modul în care Noda gestionează datele cu caracter personal ale potențialilor angajați, stagiari care au aplicat sau au fost invitați să aplice pentru posturile deschise la Noda sau să coopereze cu Noda în calitate de contractori individuali.",
      "text-2": "Noda este operatorul datelor dvs. cu caracter personal. Informațiile și datele de contact ale Noda sunt disponibile la sfârșitul prezentei notificări.",
      "title": "Notificare privind confidențialitatea pentru candidații la un loc de muncă sau pentru cooperare"
    },
    "retail": {
      "faq": {
        "countries": {
          "content": "Lucrăm cu 2000+ de bănci din 28 de țări, inclusiv Olanda, Portugalia, Belgia, Germania, Polonia, Bulgaria, Franța, Irlanda, Italia, Austria, Spania, Danemarca, Estonia, Marea Britanie, Luxemburg, România, Lituania, Ungaria, Letonia, Finlanda, Suedia, Norvegia, Republica Cehă, Slovacia, Grecia și Slovenia.",
          "title": "În ce țări lucrează Noda?"
        },
        "currencies": {
          "content": "Noda acceptă o varietate de valute globale, inclusiv EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON și SEK.",
          "title": "Ce monede acceptă Noda?"
        },
        "integration": {
          "content": "În primul rând, trebuie să vă înregistrați la Noda. Trebuie doar să completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Oferim o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Sistemul nostru de plăți cu amănuntul se integrează cu API-uri și componente front-end, integrându-se fără probleme în spațiul dvs. de piață cu amănuntul.",
          "title": "Cum pot integra Noda în fluxul meu de lucru de plată?"
        },
        "subtitle": "S-a răspuns la întrebările tale",
        "title": "FAQs"
      },
      "hero": {
        "text": "Îmbunătățiți afacerea dvs. cu amănuntul cu gateway-ul de plată Noda. Concentrați-vă pe strategie, în timp ce noi simplificăm tranzacțiile. Platforma noastră all-in-one prioritizează înțelegerea clientului, eficiența și creșterea",
        "title-1": "Gateway de plată",
        "title-2": "pentru retail cu Noda"
      },
      "how-does-it-work": {
        "subtitle": "Tehnologii",
        "text-1": "Un portal de plăți transmite în siguranță datele financiare între clienți, magazine și bănci. Gândiți-vă la aceasta ca la un conductor digital care ghidează fiecare etapă a procesării cardurilor de credit",
        "text-2": "Noda este o platformă mondială de plăți și un furnizor de servicii bancare deschise. De la gateway-uri securizate la gestionarea tranzacțiilor și analize financiare, Noda vă acoperă. Platforma noastră utilizează tehnologii AI și de învățare automată pentru a oferi soluții de ultimă generație pentru industria de retail",
        "title": "Cum funcționează Gateway-ul de plăți cu amănuntul?"
      },
      "how-to-start": {
        "subtitle": "Integrare ușoară",
        "text": "Noda oferă o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Platforma noastră se integrează fără probleme cu API-urile și componentele front-end, asigurând o îmbinare perfectă cu platforma dvs. de retail. Pentru a începe să utilizați Noda, completați formularul de mai jos, iar reprezentanții noștri de vânzări vă vor contacta în scurt timp. Echipa noastră este aici pentru a vă ajuta cu orice blocaj",
        "title": "Cum să începeți"
      },
      "open-banking": {
        "subtitle": "O mulțime de posibilități",
        "text": "Open banking înseamnă că băncile tradiționale partajează date cu companii fintech licențiate, precum Noda, pentru a simplifica tranzacțiile. Ecosistemul nostru de plăți conectează toate băncile importante din Regatul Unit și UE, facilitând servicii de procesare a plăților cu amănuntul fără efort",
        "title": "Ce este Open Banking?"
      },
      "payment-processing": {
        "subtitle": "Cele mai bune oferte",
        "text": "Simplificați plățile de intrare și de ieșire, utilizați UX intuitiv, rutare inteligentă și oferiți o varietate de metode de plată populare",
        "title": "Procesarea plăților cu amănuntul"
      },
      "payments": {
        "text": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "title": "Set de instrumente pentru comerțul cu amănuntul"
      },
      "scalable-plans": {
        "subtitle": "Mai multe beneficii",
        "text": "Oferim soluții de plată cu amănuntul pentru companii de toate dimensiunile, cu planuri scalabile disponibile pentru a sprijini creșterea afacerii dumneavoastră",
        "title": "Planuri scalabile"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Profitați de cunoștințele noastre bazate pe date. Instrumentele Noda oferă analize gata de utilizare ale comportamentului clienților, inclusiv algoritmi de segmentare și prognoză",
            "title": "Analize bazate pe inteligența artificială"
          },
          "banking": {
            "content": "Îmbunătățiți experiența clienților și ușurați fluxul de tranzacții cu puterea și securitatea plăților bancare deschise",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda funcționează cu mai multe valute pentru a vă sprijini clienții din întreaga lume",
            "title": "Monede globale"
          },
          "security": {
            "content": "Noda oferă un gateway securizat pentru comerțul cu amănuntul, asigurând conformitatea cu PCI DSS, criptarea și prevenirea fraudelor",
            "title": "Securitate"
          }
        },
        "subtitle": "Ce oferim",
        "title": "Funcții de top pentru retail"
      }
    },
    "saas": {
      "faq": {
        "countries": {
          "content": "Lucrăm cu 2000+ de bănci din 28 de țări, inclusiv Olanda, Portugalia, Belgia, Germania, Polonia, Bulgaria, Franța, Irlanda, Italia, Austria, Spania, Danemarca, Estonia, Marea Britanie, Luxemburg, România, Lituania, Ungaria, Letonia, Finlanda, Suedia, Norvegia, Republica Cehă, Slovacia, Grecia și Slovenia.",
          "title": "În ce țări lucrează Noda?"
        },
        "currencies": {
          "content": "Noda acceptă o varietate de valute globale, inclusiv EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON și SEK.",
          "title": "Ce monede acceptă Noda?"
        },
        "how-to-integrate": {
          "content": "În primul rând, trebuie să vă înregistrați la Noda. Trebuie doar să completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Oferim onboarding ușor, cu îndrumarea personalizată a unui manager dedicat. Sistemul nostru de plăți SaaS se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare fără probleme în platforma dvs",
          "title": "Cum pot integra Noda în fluxul meu de lucru de plată?"
        },
        "subtitle": "răspunsuri la întrebările dvs.",
        "title": "FAQs"
      },
      "hero": {
        "text": "Îmbunătățiți-vă afacerea Software-as-a-Service (SaaS). Aveți grijă de clienți în timp ce noi simplificăm plățile SaaS. Platforma noastră all-in-one prioritizează înțelegerea clienților, eficiența și creșterea",
        "title-1": "Gateway de plată",
        "title-gradient-1": "pentru SaaS cu Noda"
      },
      "how-to-start": {
        "subtitle": "Integrare ușoară",
        "text": "Noda oferă o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Platforma noastră se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare perfectă în software-ul dvs. Pentru a începe să utilizați Noda, completați formularul de mai jos, iar reprezentanții noștri de vânzări vă vor contacta în scurt timp. Echipa noastră este aici pentru a vă ajuta cu orice blocaj",
        "title": "Cum să începeți"
      },
      "open-banking": {
        "subtitle": "O mulțime de posibilități",
        "text": "Open banking înseamnă că băncile tradiționale partajează date cu companii fintech licențiate, precum Noda, pentru a simplifica tranzacțiile. Ecosistemul nostru de plăți conectează toate băncile importante din Regatul Unit și UE, facilitând servicii de procesare a plăților SaaS fără efort",
        "title": "Ce este Open Banking?"
      },
      "payments": {
        "text": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "title": "Set de instrumente pentru SaaS"
      },
      "technologies": {
        "text-1": "Un gateway de plată transmite în siguranță datele financiare între clienți, comercianți și bănci.\n      Gândiți-vă la aceasta ca la un conductor digital care ghidează fiecare pas al procesării cardurilor de credit SaaS",
        "text-2": "Noda este o platformă de plăți la nivel mondial și un furnizor de servicii bancare deschise. De la procesarea securizată la\n      gestionarea tranzacțiilor și analiza financiară, Noda vă acoperă. Platforma noastră utilizează tehnologiile AI\n      și tehnologii de învățare automată pentru a oferi soluții de ultimă generație",
        "title": "tehnologii",
        "title-1": "Cum se face plata SaaS",
        "title-2": "Gateway Work?"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Profitați de cunoștințele noastre bazate pe date. Instrumentele Noda oferă analize gata de utilizare ale comportamentului clienților, inclusiv algoritmi de segmentare și prognoză",
            "title": "Analize bazate pe inteligența artificială"
          },
          "banking": {
            "content": "Îmbunătățiți experiența clienților și ușurați fluxul de tranzacții cu puterea și securitatea plăților bancare deschise",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda funcționează cu mai multe valute pentru a vă sprijini clienții SaaS din întreaga lume",
            "title": "Monede globale"
          },
          "payment-processing": {
            "content": "Simplificați plățile de intrare și de ieșire, utilizați UX intuitiv, rutare inteligentă și oferiți o varietate de metode de plată populare",
            "title": "Procesarea plăților SaaS"
          },
          "scalable-plans": {
            "content": "Oferim soluții de plată SaaS pentru companii de toate dimensiunile, cu planuri scalabile disponibile pentru a susține creșterea afacerii dumneavoastră",
            "title": "Planuri scalabile"
          },
          "security": {
            "content": "Noda oferă un gateway de plată securizat, asigurând conformitatea cu PCI DSS, criptarea și prevenirea fraudelor",
            "title": "Securitate"
          }
        },
        "subtitle": "ofertele noastre",
        "title": "Caracteristici de top"
      }
    },
    "security": {
      "faq": {
        "contact": {
          "complex-content": {
            "p1": "Dacă întâmpinați dificultăți cu serviciile Noda, vă sugerăm următoarele canale de asistență:",
            "p2": "<b>Chat de grup Skype/Telegram:</b> Am creat un chat de grup dedicat pentru a facilita comunicarea fără probleme. Dacă aveți întrebări despre integrare sau întâmpinați probleme tehnice, nu ezitați să trimiteți un mesaj grupului și să ne etichetați la",
            "p3": "<b>Manager personal:</b> Pentru întrebări care nu au legătură cu asistența tehnică, nu ezitați să contactați managerul dvs. personal direct în chat-ul de grup sau printr-un mesaj privat.",
            "p4": "<b>Asistență prin e-mail:</b> Atât comercianții, cât și clienții lor ne pot contacta la",
            "p5": "Nu uitați, suntem întotdeauna gata să vă ajutăm!"
          },
          "title": "Am o problemă cu serviciile Noda; pe cine pot contacta?"
        },
        "knowledge": {
          "complex-content": {
            "l1": "<b>Securitate la nivel bancar:</b> Serviciile bancare deschise utilizează software și sisteme de securitate riguros testate. Consumatorilor nu li se cere niciodată să împărtășească datele de conectare sau parolele lor bancare nimănui, cu excepția propriei bănci.",
            "l2": "<b>Reglementare:</b> Numai aplicațiile și site-urile web reglementate de Autoritatea de conduită financiară din Regatul Unit (FCA) sau de instituții echivalente din Europa au permisiunea de a utiliza serviciile bancare deschise.",
            "l3": "<b>Controlul asupra datelor:</b> Clienții au puterea de a decide când și pentru cât timp împărtășesc datele lor. De asemenea, ei pot revoca acest acces în orice moment prin intermediul băncilor lor.",
            "p1": "Serviciile bancare deschise sunt concepute cu un accent puternic pe securitate, asigurând siguranța deplină a clienților dvs. Iată câteva dintre principalele sale caracteristici de securitate:"
          },
          "title": "De unde știu că serviciile bancare deschise sunt sigure?"
        },
        "safe": {
          "content": "Da, Noda este sigură. Mii de consumatori finali au încredere în Noda pentru a efectua plăți în siguranță prin băncile lor preferate, unde își păstrează banii cu încredere. Noda nu partajează niciodată datele consumatorilor fără consimțământul lor explicit. În același timp, luăm toate măsurile pentru a ne asigura că datele lor sunt protejate la fiecare pas.",
          "title": "Noda este sigur?"
        },
        "secure": {
          "content": "Da, Noda este în siguranță. După cum sa menționat anterior, Noda este conceput nu numai pentru a fi în siguranță, ci și pentru a-și monitoriza în mod continuu nivelurile de securitate. Folosim o abordare pe mai multe straturi pentru a reduce semnificativ riscurile de hacking și de încălcare a datelor. De exemplu, utilizăm protocoale de criptare de top, furnizori de infrastructură cloud de top, autentificare multi-factor și efectuăm o monitorizare completă non-stop a serviciilor noastre.",
          "title": "Este Noda în siguranță?"
        },
        "test": {
          "complex-content": {
            "l1-1": "Numărul contului",
            "l1-2": "Numele complet",
            "l2-1": "Informații de identitate",
            "l2-2": "Soldurile conturilor",
            "l2-3": "Istoricul tranzacțiilor pentru 90 de zile",
            "p1": "Noda servește atât ca furnizor de servicii de inițiere a plății (PISP), cât și ca furnizor de servicii de informare privind conturile (AISP). În primul caz, oferim clientului dvs. servicii de inițiere a plății (PIS). În esență, acest lucru înseamnă că Noda va facilita procesul de plată pentru clienții dvs. prin transferul de fonduri direct din contul (conturile) de plăți legat(e) de aceștia către beneficiarul ales, cu consimțământul explicit al acestora. În acest caz, Noda accesează următoarele date:",
            "p2": "Prin urmare, aceste date pot fi utilizate ca valori de intrare pentru algoritmii interni ai Noda și pot fi partajate cu comercianții pentru a confirma că plata a fost efectuată cu succes.",
            "p3": "În cel de-al doilea caz, Serviciul de informații despre conturi (AIS) permite Noda să acceseze și să vizualizeze într-un singur loc informații despre toate conturile bancare online și să analizeze informațiile financiare ale clienților dvs. cu acordul acestora. În acest caz, Noda are acces la următoarele date:",
            "p4": "În consecință, aceste date pot fi utilizate pentru a îmbunătăți algoritmii interni ai Noda. De asemenea, acestea pot fi împărtășite comercianților într-o formă agregată - de exemplu, ca o valoare de scoring care arată cu ce categorie de plată este identificat un utilizator (de la 1 la 5)."
          },
          "title": "Ce date poate accesa și partaja Noda?"
        }
      },
      "hero": {
        "desc-1": "Securitatea plăților și a datelor ar trebui să fie întotdeauna o prioritate. Pe această pagină, veți găsi informații detaliate despre măsurile noastre de securitate și abordarea noastră privind prelucrarea și partajarea datelor dumneavoastră.",
        "desc-2": "Oferim o prezentare generală a caracteristicilor noastre de securitate și a angajamentului nostru față de confidențialitatea datelor. În plus, oferim informații despre licențierea noastră și gestionarea datelor în cadrul diferitelor licențe.",
        "title": "Securitatea și gestionarea datelor"
      },
      "strategy": {
        "alert": {
          "text": "Sistemele noastre automate de alertă ne permit să răspundem instantaneu la amenințările care apar noaptea, la sfârșit de săptămână, în zilele de sărbătoare legală sau în timpul altor ore nelucrătoare.",
          "title": "Sistem de alertă automatizat"
        },
        "bug-bounty": {
          "text": "<p class=\"paragraph\">Programul nostru bug bounty primește orice dezvoltator care se identifică ca hacker. Dacă dvs. sau colegii dvs. descoperiți defecte, deficiențe sau vulnerabilități în sistemele noastre de securitate sau aveți sugestii de îmbunătățire a funcționalității punctelor finale ale Noda API, puteți participa la programul nostru și primi o recompensă.</p><p class=\"paragraph\"> Pentru a raporta o problemă sau a face o sugestie, trimiteți pur și simplu un e-mail echipei noastre de securitate la <a class=\"link\" href=\"mailto:security@noda.live\">security@noda.live</a>.</p>",
          "title": "Programul Bug Bounty"
        },
        "certification": {
          "text": "<p class=\"paragraph\">Noda obține în mod regulat certificări relevante și menține la zi licențele PCI DSS și PCI SSLC. Standardul de securitate a datelor din industria cardurilor de plată (PCI DSS) este standardul de referință al industriei care vizează reducerea fraudei la plată prin îmbunătățirea controalelor de protecție a datelor.</p><p class=\"paragraph\"> Între timp, standardul PCI Secure Software Lifecycle Standard (PCI SLLC) garantează că furnizorii de software de plată integrează securitatea pe tot parcursul ciclului de viață al dezvoltării software-ului, producând aplicații care sunt sigure prin concepție și robuste împotriva atacurilor. Aceste licențe sunt administrate de PCI Security Standards Council (PCI SSC).</p>",
          "title": "Certificare"
        },
        "cloud": {
          "text": "<p class=\"paragraph\">Noda utilizează infrastructura cloud pentru a construi aplicațiile și serviciile noastre. Furnizorii moderni de servicii cloud sunt unii dintre cei mai siguri la nivel global, investind milioane de dolari pentru a asigura cele mai înalte standarde de siguranță. În plus, aceștia își actualizează și își perfecționează continuu sistemele pentru a le face și mai impenetrabile și mai sigure.</p><p class=\"paragraph\"> Colaborarea cu furnizori globali cunoscuți de securitate a infrastructurii cloud este factorul cheie pentru construirea programului de securitate a informațiilor Noda.</p>",
          "title": "Utilizarea furnizorilor de infrastructură cloud"
        },
        "encryption": {
          "text": "<p class=\"paragraph\">Noda criptează simultan toate datele sensibile pe două niveluri. Utilizăm protocolul TLS (Transport Layer Security) atunci când informațiile sunt transferate între serverele rețelei și aplicăm AES (Advanced Encryption Standard) atunci când datele sunt stocate.</p><p class=\"paragraph\"> Utilizarea acestei abordări de criptare pe două niveluri ne permite să minimizăm potențialele probleme de siguranță, deoarece datele sensibile rămân criptate chiar și în rarele ocazii în care una dintre componente este compromisă.</p>",
          "title": "Abordarea criptării datelor"
        },
        "mfa": {
          "text": "<p class=\"paragraph\">La Noda, înțelegem că obținerea unei securități maxime a informațiilor necesită concentrarea atât asupra mediului extern, cât și asupra celui intern. De aceea, implementăm autentificarea multifactorială (MFA) pentru ca angajații noștri să poată accesa toate platformele interne critice.</p><p class=\"paragraph\"> MFA adaugă un nivel suplimentar de autentificare, care ajută la prevenirea accesului neautorizat la date prin intermediul sistemelor interne.</p>",
          "title": "MFA"
        },
        "monitoring": {
          "text": "<p class=\"paragraph\">Toate componentele produselor Noda, inclusiv Noda API, sunt monitorizate și inspectate în permanență de către echipa noastră de securitate IT.</p><p class=\"paragraph\"> Această echipă este formată din experți IT care participă în mod regulat la conferințe profesionale și se implică în formarea continuă în domeniul lor.</p>",
          "title": "Monitorizarea echipei de securitate a informațiilor"
        },
        "support": {
          "text": "Echipa de asistență Noda, disponibilă non-stop, rezolvă rapid problemele de conectivitate pentru anumiți clienți și, de asemenea, colectează sugestii pentru îmbunătățirea sistemelor Noda. Suntem întotdeauna aici și gata să vă ajutăm.",
          "title": "Echipa de suport tehnic 24/7"
        },
        "text": "Strategia Noda pentru construirea unui program de securitate a informațiilor implică o abordare dublă. În primul rând, ne concentrăm pe o securitate robustă pentru propriile noastre sisteme și servere. În al doilea rând, implementăm o abordare de securitate pe mai multe niveluri pentru a asigura cel mai înalt nivel de siguranță atât pentru datele dumneavoastră, cât și pentru datele clienților dumneavoastră. Găsiți mai jos principalele caracteristici ale programului nostru de securitate.",
        "title": "Noda Securitate"
      }
    },
    "tabs": {
      "banner": {
        "account-balances": "Soldurile conturilor",
        "account-number": "Numărul contului",
        "full-name": "Numele și prenumele",
        "identity-information": "Informații privind identitatea",
        "text": "Cu acordul clientului, Noda poate accesa și utiliza următoarele date în algoritmii săi:",
        "title": "Tipuri de date pe care clienții dvs. le pot partaja cu Noda",
        "transaction-history": "Istoricul tranzacțiilor pentru 90 de zile"
      },
      "tab-step-text": {
        "after-the-confirmation": "După confirmare, Noda primește numărul de cont al utilizatorului, precum și suma și moneda plății.",
        "after-the-consent": "După obținerea consimțământului, Noda poate accesa contul lor financiar și unele dintre datele lor financiare.",
        "consequently-this-data": "Prin urmare, aceste date pot fi utilizate ca valori de intrare pentru algoritmii interni ai Noda și pot fi partajate cu comercianții pentru a confirma că plata a fost efectuată cu succes.",
        "consequently-this-data-form": "Prin urmare, aceste date pot fi utilizate pentru a îmbunătăți algoritmii interni ai Noda. Datele pot fi, de asemenea, partajate cu comercianții într-o formă agregată - de exemplu, sub forma unei valori de scoring care arată cu ce categorie de plată este identificat un utilizator (de la 1 la 5).",
        "the-buyer-initiates": "Cumpărătorul inițiază plata și finalizează autentificarea de către banca aleasă.",
        "when-the-authentication": "Atunci când autentificarea de către bancă este finalizată, banca solicită confirmarea tranzacției.",
        "when-the-authentication-consent": "Atunci când autentificarea de către bancă este finalizată, banca le solicită acordul ca Noda să le acceseze datele financiare și de profil."
      },
      "tab-title": {
        "automated-access": "Acces automatizat la IBAN-ul unui utilizator prin autorizare directă de către bancă",
        "insert-iban": "Introduceți IBAN pentru plata manuală"
      },
      "tag-subtitle": "PRIETENOS CU TEHNOLOGIA",
      "text": "La Noda, ne pasă de clienții dvs. și le procesăm datele cu cea mai mare atenție. Iată ce se întâmplă atunci când clienții dvs. efectuează o plată sau se îmbarcă prin intermediul serviciilor noastre.",
      "title": "Noda gestionează<br/>datele clienților dvs."
    },
    "terms": {
      "last-update": "Ultima actualizare la <data>23 august 2024</data>",
      "section-1": {
        "text-1": "Aceste Condiții de utilizare vor servi ca un contract obligatoriu din punct de vedere juridic între utilizatorii săi („Dumneavoastră”, „Utilizator”, „Client”) și Noda, prin urmare, vă sugerăm să citiți documentul cu atenție. Condițiile de utilizare, împreună cu Politica privind confidențialitatea, vor constitui întregul Acord (în continuare - „Acordul”) dintre dumneavoastră și Noda. Toate serviciile descrise mai jos sunt servicii furnizate de Noda și vor fi denumite în mod colectiv „Serviciul”. Prin utilizarea Serviciului, recunoașteți că acceptați și sunteți de acord să respectați condițiile din Acord. Aceste Condiții de utilizare sunt întotdeauna accesibile pe site-ul nostru <a href=\"https://noda.live\">https://noda.live.</a>",
        "text-2": "Noda vă acordă o licență limitată, revocabilă, neexclusivă, netransferabilă de a accesa și utiliza Serviciul pentru uzul dumneavoastră individual, sub rezerva celorlalte condiții din aceste Condiții de utilizare. Toate drepturile, titlurile și interesele în și pentru Serviciu care nu sunt acordate în mod expres prin prezenta sunt rezervate de Noda.",
        "text-3": "Acordul este încheiat pentru o perioadă nedeterminată.",
        "text-4": "Putem, din când în când, să efectuăm modificări și ajustări ale Condițiilor de utilizare. În cazul în care nu sunteți de acord cu oricare dintre prevederile Acordului, vă sugerăm să nu mai utilizați Serviciul și să reziliați gratuit aceste Condiții de utilizare.",
        "text-5": "Aceste Condiții de utilizare sunt redactate în limba engleză, iar comunicarea principală se realizează de obicei în limba engleză.",
        "text-6": "În orice moment pe durata aplicării Acordului, aveți dreptul de a primi, la cerere, aceste Condiții de utilizare.",
        "title": "1. Acordul"
      },
      "section-2": {
        "list-1": {
          "item-1": "o referință care vă permite să identificați fiecare operațiune de plată și, după caz, beneficiarul plății;",
          "item-2": "valoarea operațiunii de plată în moneda în care contul dvs. de plăți este debitat sau în moneda utilizată pentru ordinul de plată;",
          "item-3": "după caz, cursul de schimb utilizat în operațiunea de plată și valoarea operațiunii de plată după această conversie monetară;",
          "item-4": "data valorii debitului sau data primirii ordinului de plată."
        },
        "list-2": {
          "item-1": "Serviciul va satisface cerințele dumneavoastră;",
          "item-2": "Serviciul va fi neîntrerupt, prompt, sigur sau fără erori;",
          "item-3": "Rezultatele care pot fi obținute din utilizarea Serviciului vor fi exacte sau de încredere;",
          "item-4": "Calitatea oricăror produse, servicii, informații sau altor materiale achiziționate sau obținute de dvs. prin intermediul Serviciului va corespunde așteptărilor dvs.; sau",
          "item-5": "Orice erori de tehnologie vor fi corectate."
        },
        "text-1": {
          "line-1": "În cadrul prezentului Acord încheiat între dumneavoastră și noi, Noda acționează în calitate de furnizor de servicii de informare cu privire la conturi („PISP”) și prestator de servicii de informare cu privire la conturi („AISP”) și vă vom furniza servicii de inițiere a plății („PIS”) și servicii de informare cu privire la conturi („AIS”). În esență, acest lucru înseamnă că vom facilita procesul de plată pentru dumneavoastră prin inițierea unei tranzacții direct din contul (conturile) de plată legat(e) de dumneavoastră către beneficiarul ales, pe baza consimțământului dumneavoastră explicit și vă vom furniza informații privind contul (conturile) de plată legat(e) de dumneavoastră.",
          "line-2": "După ce selectați un furnizor de cont de plăți sau un furnizor de cont bancar (ambele denumite individual „Partener”) la care doriți să vă conectați și/sau să efectuați o plată, veți fi redirecționat către pagina oficială a acestuia (fie în aplicație, fie într-un browser), unde va trebui să parcurgeți un proces de verificare.",
          "line-3": "În calitate de furnizor de servicii de informare cu privire la conturi (AISP), vă vom permite să accesați și să vizualizați informații despre toate conturile dvs. bancare online într-un singur loc și să analizați informațiile dvs. financiare pentru a vă ajuta să cheltuiți, să economisiți, să împrumutați și să urmăriți mai eficient fluxurile dvs. de fonduri.",
          "line-4": "Noda nu furnizează servicii bancare sau de cont de plăți. Astfel, furnizorul contului de plăți ales de dvs. este singurul responsabil pentru executarea plăților și pentru orice erori în funcționalitatea serviciilor sale. Cu toate acestea, în cazul în care considerăm că ne lipsesc autorizațiile sau din orice motiv furnizarea serviciilor noastre către dumneavoastră ar fi ilegală, putem alege să nu vă furnizăm Serviciul.",
          "line-5": "În cadrul sferei de aplicare a prezentului Acord și în limitele pe care ni le permiteți, vom partaja informațiile din contul dvs. de plăți cu alte servicii și terțe părți la alegerea dvs. Odată ce un astfel de partener are acces la informațiile Dumneavoastră, acesta devine automat responsabil pentru acestea, iar informațiile fac obiectul acordului Dumneavoastră cu partenerul respectiv și al politicii sale de confidențialitate.",
          "line-6": "Vom avea acces la oricare dintre conturile de plăți pe care le conectați numai dacă vă dați acordul în acest sens și numai în cadrul serviciilor pe care le furnizăm.",
          "line-7": "Puteți solicita ca următoarele informații să fie furnizate sau puse la dispoziție periodic, cel puțin o dată pe lună, în mod gratuit:"
        },
        "text-2": "Serviciul va fi furnizat „așa cum este” și „în funcție de disponibilitate”. Nu oferim nicio garanție că:",
        "text-3": "Odată ce ați inițiat plata, inițierea plății va fi transmisă imediat. Odată ce ați autorizat plata cu banca dumneavoastră, nu o veți mai putea anula. De obicei, fondurile vor părăsi contul dvs. de plăți în termen de 2 (două) ore de la inițierea cu succes a ordinului de plată, deși ar putea dura mai mult, în funcție de timpul necesar băncii dvs. pentru a executa ordinul de plată. Vom confirma inițierea cu succes a ordinului de plată. Dar banca dvs. (nu Noda) este responsabilă de executarea acestuia.",
        "title": "2. Servicii pe care le oferim"
      },
      "section-3": {
        "list": {
          "item-1": "Aveți cel puțin 18 ani și aveți capacitatea legală și autoritatea de a încheia un contract",
          "item-10": "Nu aveți dreptul să decompilați sau să dezasamblați Serviciul sau să îl utilizați altfel decât în conformitate cu scopurile prevăzute în Acord;",
          "item-11": "Nu puteți accesa Serviciul cu scopul de a facilita produse sau servicii concurente;",
          "item-12": "Orice utilizare interzisă va duce la încetarea imediată a licenței dumneavoastră pentru Serviciu.",
          "item-2": "Veți utiliza Serviciul numai în calitate de persoană fizică și doar în scopuri private;",
          "item-3": "Nu veți utiliza Serviciul în niciun scop fraudulos;",
          "item-4": "Nu veți utiliza Serviciile în niciun alt scop ilegal;",
          "item-5": "Sunteți de acord cu <a href=\"https://noda.live/about/legal-privacy/policy\">Politica privind confidențialitatea;</a>",
          "item-6": "Sunteți responsabil pentru păstrarea informațiilor dvs. de autentificare în siguranță și securizate;",
          "item-7": "Nu puteți dezvălui informațiile dvs. de autentificare niciunei terțe părți. În măsura permisă de legea aplicabilă, veți fi răspunzător pentru orice cheltuieli și onorarii rezonabile ale avocaților pentru eșecul dumneavoastră de a proteja orice informații de autentificare și/sau de a notifica imediat Noda cu privire la utilizarea neautorizată a contului dumneavoastră de plăți sau a oricărui alt cont sau compromiterea informațiilor sau parolei contului dumneavoastră de plăți (sau a oricărui alt cont);",
          "item-8": "Nu veți utiliza o identitate falsă sau furată. Declarați și garantați că toate informațiile furnizate de dvs. în cadrul prezentului Acord sunt adevărate și exacte;",
          "item-9": "Nu puteți revinde sau transfera în alt mod drepturile de utilizare a Serviciului;"
        },
        "text-1": "Prin utilizarea serviciilor oferite de noi declarați și consimțiți că:",
        "text-2": {
          "line-1": "În cazul în care luați cunoștință de pierderea, furtul, însușirea ilegală sau utilizarea neautorizată a Serviciului nostru sau a oricărei părți a acestuia, de o fraudă de uzurpare a identității, de o tranzacție de plată neautorizată sau inițiată sau executată incorect sau de orice transfer de credit autorizat efectuat în urma aplicării incorecte a serviciului de verificare a concordanței dintre nume și identificatorul unic, vă rugăm să ne contactați cât mai curând posibil, dar nu mai târziu de 5 zile lucrătoare, la adresa <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>. De asemenea, vă rugăm să luați în considerare notificarea poliției, în special în cazul fraudelor de uzurpare a identității și al altor tranzacții efectuate în numele dvs. fără autorizația dvs. În cazul unor astfel de evenimente, sunteți, de asemenea, răspunzător și responsabil să luați măsuri pentru a vă păstra informațiile în siguranță.",
          "line-2": "Dacă nu ne notificați cu privire la o tranzacție neautorizată sau executată incorect, este posibil să nu aveți dreptul de a primi o despăgubire pentru o astfel de tranzacție neautorizată sau executată incorect.",
          "line-3": "În cazul în care considerăm că există o fraudă efectivă sau o suspiciune de fraudă sau o amenințare gravă la adresa securității, vă vom contacta utilizând informațiile de contact furnizate de dvs. în timpul utilizării Serviciului nostru."
        },
        "title": "3. Accesul la Serviciu și comunicarea privind activitățile suspecte"
      },
      "section-4": {
        "text": {
          "line-1": "Pentru a avea acces deplin la Serviciu, trebuie să alegeți băncile sau alți furnizori de Conturi de plăți de la care doriți să vă conectați sau să ne autorizați să efectuăm plăți. Odată ce ați ales un Partener, vă vom redirecționa către pagina web a acestuia, unde veți parcurge un proces securizat de accesare a informațiilor din Conturile dvs. de plăți (aici și în alte părți ale Acordului, „Cont de plăți” se referă la un cont creat la un Partener). Vi se va cere să vă dați consimțământul explicit pentru a ne permite să vă accesăm datele financiare.",
          "line-2": "Pentru a accesa Serviciul, trebuie să ne furnizați informațiile menționate în Politica privind confidențialitatea. Identificatorul unic utilizat pentru a ne asigura că un ordin de plată este inițiat și executat în mod corespunzător este adresa dvs. de e-mail sau IBAN-ul sau ID-ul de plată sau ID-ul de client sau referința de plată, în funcție de fiecare caz în parte. În cazul în care ne furnizați un identificator incorect sau greșit, am putea percepe taxe pentru recuperarea fondurilor implicate în tranzacția de plată corespunzătoare.",
          "line-3": "Sunteți de acord să acordați companiei Noda o licență neexclusivă, fără redevențe, de utilizare a informațiilor din conturile dvs. de plăți în toate scopurile legate de Serviciu sau menționate în prezentul Acord, cu dreptul de a utiliza, modifica, afișa, distribui și crea noi materiale utilizând sau încorporând astfel de informații pentru a vă furniza Serviciul. Vă garantăm că nu vom utiliza sau accesa datele dumneavoastră în niciun alt scop, cu excepția cazului în care legea prevede altfel. Pentru a menține datele dumneavoastră în siguranță și consimțământul dumneavoastră actualizat, este posibil să vă solicităm periodic să vă reînnoiți consimțământul.",
          "line-4": "Sunteți de acord că atunci când colectăm informațiile dvs. referitoare la conturile dvs. de plăți sau informațiile dvs. necesare ca parte a furnizării Serviciului, o facem în calitate de reprezentant al dvs. și în numele dvs. și nu în numele sau în beneficiul unei terțe părți.",
          "line-5": "Prin utilizarea Serviciului, declarați că sunteți proprietarul legal al datelor din Conturile dvs. de plăți și că aveți autoritatea de a ne numi și ne numiți în mod expres pe noi și/sau pe furnizorii noștri terți drept agentul dvs. și ne acordați o împuternicire limitată pentru a accesa și colecta astfel de date în numele dvs.",
          "line-6": "În scopul conformității noastre și pentru a vă furniza Serviciul, ne autorizați prin prezenta să obținem, să verificăm și să păstrăm, direct sau prin intermediul unei terțe părți, o evidență a informațiilor și a documentelor care ne ajută să vă verificăm identitatea și informațiile contului de plată. Atunci când vă înregistrați pentru Serviciu și ulterior din când în când, vă putem solicita să furnizați și/sau să confirmați informații și documente care ne vor permite să vă identificăm."
        },
        "title": "4. Accesul nostru la datele dumneavoastră"
      },
      "section-5": {
        "list": {
          "item-1": "retragerea imediată, temporară sau permanentă, a dreptului dumneavoastră de a utiliza Serviciul;",
          "item-2": "emiterea unui avertisment pentru dvs.;",
          "item-3": "să inițiem proceduri judiciare împotriva dumneavoastră pentru rambursarea tuturor costurilor (inclusiv, dar fără a se limita la, costuri administrative și juridice rezonabile) rezultate din încălcare;",
          "item-4": "să întreprindem alte acțiuni legale împotriva dumneavoastră; și/sau",
          "item-5": "să dispunem dezvăluirea unor astfel de informații autorităților de aplicare a legii, după cum considerăm în mod rezonabil că este necesar."
        },
        "text-1": {
          "line-1": "Sunteți liber să retrageți în orice moment orice consimțământ pe care ni l-ați dat, contactându-ne la adresa <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live.</a>",
          "line-2": "Putem evalua și determina, la discreția noastră, dacă a avut loc o încălcare a prezentului Acord prin utilizarea de către dvs. a Serviciului. Atunci când a avut loc o astfel de încălcare, putem lua măsurile pe care le considerăm adecvate, inclusiv toate sau oricare dintre următoarele măsuri:"
        },
        "text-2": {
          "line-1": "Răspunsurile descrise mai sus nu sunt limitate și putem lua orice altă măsură pe care o considerăm adecvată în mod rezonabil și care nu contravine legislației aplicabile.",
          "line-2": "De asemenea, avem dreptul de a bloca Serviciul din motive justificate în mod obiectiv legate de securitatea Serviciului, suspiciunea de utilizare neautorizată sau frauduloasă a Serviciului în orice moment.",
          "line-3": "Putem alege să respingem înregistrarea dvs. sau să anulăm o înregistrare existentă din orice alt motiv, la discreția noastră."
        },
        "title": "5. Rezilierea și suspendarea"
      },
      "section-6": {
        "text": {
          "line-1": "Sunteți de acord să protejați și să despăgubiți pe deplin Noda și afiliații noștri de orice pretenții, răspundere, daune, cheltuieli și costuri ale terților (inclusiv, dar fără a se limita la, onorariile rezonabile ale avocaților) cauzate de sau care rezultă din utilizarea de către dvs. a Serviciului, încălcarea de către dvs. a prezentului Acord sau încălcarea de către dvs., sau încălcarea de către orice alt utilizator al contului dvs., a oricărei proprietăți intelectuale sau a altui drept al oricărei persoane.",
          "line-2": "Nu vom avea nicio răspundere față de dvs. pentru orice eșec sau întârziere în îndeplinirea oricăreia dintre obligațiile noastre în temeiul prezentului Acord, în măsura în care un astfel de eșec sau o astfel de întârziere este cauzat(ă) de dvs. sau în care la acesta/aceasta ați contribuit dvs. sau un eveniment sau o circumstanță în afara controlului nostru rezonabil, inclusiv în cazul furnizării unui identificator unic incorect.",
          "line-3": "ÎN NICIUN CAZ NODA, OFICIALII, DIRECTORII, AGENȚII, AFILIAȚII, ANGAJAȚII, AGENȚII DE PUBLICITATE SAU FURNIZORII SĂI NU VOR FI RĂSPUNZĂTORI PENTRU ORICE DAUNE INDIRECTE, ACCIDENTALE, DERIVATE SAU PUNITIVE, INCLUSIV, DAR FĂRĂ A SE LIMITA LA, INCAPACITATEA DE UTILIZARE, PIERDERI DE PROFIT SAU PIERDERI DE DATE, FIE ÎNTR-O ACȚIUNE CONTRACTUALĂ, DELICTUALĂ (INCLUSIV, DAR FĂRĂ A SE LIMITA LA NEGLIJENȚĂ), ÎN ECHITATE SAU ÎN ALT MOD, FIE PENTRU DAUNE CARE DEPĂȘESC VALOAREA TOTALĂ A PLĂȚII CARE A FOST EXECUTATĂ ÎN MOD DEFECTUOS SAU FĂRĂ AUTORIZAȚIE, REZULTÂND ÎN PIERDEREA SUMELOR TRANSFERATE ÎN CADRUL PLĂȚII RESPECTIVE.",
          "line-4": "Suntem răspunzători față de dumneavoastră pentru executarea corectă a operațiunii de plată, cu excepția cazului în care vă putem dovedi dumneavoastră și, după caz, prestatorului de servicii de plată al beneficiarului plății, că prestatorul de servicii de plată al beneficiarului plății a primit suma operațiunii de plată și cu excepția cazului în care avem motive întemeiate să suspectăm o fraudă comisă de dumneavoastră."
        },
        "title": "6. Dreptul la compensație și răspundere"
      },
      "section-7": {
        "text": {
          "line-1": "Vă rugăm să vă adresați îngrijorările și plângerile direct nouă la <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>, iar noi vom depune efortul necesar pentru a vă ajuta. În cazul în care sunteți nemulțumit de răspunsul nostru sau de serviciul general furnizat, aveți dreptul să vă înaintați plângerea către Serviciul Ombudsmanului Financiar: <a target=\"_blank\" rel=\"nofollow\" href=\"https://www.financial-ombudsman.org.uk/\">https://www.financial-ombudsman.org.uk/</a>. Autoritatea de supraveghere în ceea ce privește activitatea noastră în Regatul Unit este Financial Conduct Authority: <a href=\"https://www.fca.org.uk/\" target=\"_blank\" rel=\"nofollow\">https://www.fca.org.uk/.",
          "line-2": "Alte țări au alte autorități de reglementare și pot avea alte soluții alternative de soluționare a litigiilor. Pentru mai multe informații, vă rugăm să ne contactați la <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a>.",
          "line-3": "Dacă plângerea dvs. se referă la modul în care stocăm sau prelucrăm informațiile dvs. personale, vă rugăm să consultați <a href=\"https://noda.live/about/legal-privacy/policy\">Politica privind confidențialitatea</a>."
        },
        "title": "7. Reclamații"
      },
      "section-8": {
        "text": {
          "line-1": "Prezentul Acord este reglementat de legislația Regatului Unit. În cazul în care o instanță decide că nu ne putem baza pe o parte a prezentului Acord, restul Acordului va continua să se aplice, deoarece fiecare dintre dispozițiile prezentului Acord se aplică separat.",
          "line-2": "În cazul în care o dispoziție a prezentului Acord se dovedește a fi invalidă din orice motiv, invaliditatea respectivei dispoziții nu va afecta celelalte dispoziții ale Acordului, care vor rămâne în vigoare și cu efect deplin."
        },
        "title": "8. Dispoziții generale"
      },
      "subtitle": "Date companie",
      "text-1": "Suntem Naudapay Limited cunoscută și sub numele de „Noda” („Noda”, „Noi”, „Al nostru”), o societate înregistrată în Regatul Unit cu numărul 11741664 și cu sediul social la 162 Buckingham Palace Road, Londra, SW1W 9TR, Regatul Unit. Operăm site-ul <a href=\"https://noda.live\">https://noda.live</a> și serviciile disponibile prin intermediul aplicațiilor și soluțiilor noastre sub marca Noda. Biroul de contact în UE este în Spania (Calle Huertas 11, 28012, Madrid, Spania).",
      "text-2": "Naudapay Limited este înregistrată la Financial Conduct Authority în conformitate cu Regulamentul privind serviciile de plată din 2017 pentru furnizarea de servicii de plată. Nr. de referință 832969.",
      "text-3": "Vă rugăm, nu ezitați să ne contactați la <a href=\"mailto:support@noda.live\" target=\"_blank\">support@noda.live</a> dacă aveți întrebări sau nelămuriri. De asemenea, putem fi contactați în aplicație prin widget-ul nostru de ajutor.",
      "title": "Condiții de utilizare"
    },
    "travel": {
      "faq": {
        "countries": {
          "content": "Lucrăm cu 2000+ de bănci din 28 de țări, inclusiv Olanda, Portugalia, Belgia, Germania, Polonia, Bulgaria, Franța, Irlanda, Italia, Austria, Spania, Danemarca, Estonia, Marea Britanie, Luxemburg, România, Lituania, Ungaria, Letonia, Finlanda, Suedia, Norvegia, Republica Cehă, Slovacia, Grecia și Slovenia.",
          "title": "În ce țări lucrează Noda?"
        },
        "currencies": {
          "content": "Noda acceptă o varietate de valute globale, inclusiv EUR, GBP, CAD, NOK, PLN, HUF, BGN, RON și SEK.",
          "title": "Ce valute acceptă Noda?"
        },
        "easy-to-start": {
          "content": "Da. Echipa noastră de asistență este aici pentru a vă ajuta cu orice blocaj. Oferim o integrare ușoară, asigurându-vă că puteți începe să acceptați plăți rapid și ușor.",
          "title": "Este ușor să începeți să acceptați plăți online cu Noda?"
        },
        "how-to-integrate": {
          "content": "În primul rând, trebuie să vă înregistrați la Noda. Trebuie doar să completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Oferim o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Procesorul nostru se integrează fără probleme cu componentele API și front-end, asigurând o îmbinare fără probleme în platforma dvs.",
          "title": "Cum pot integra Noda în fluxul meu de plăți?"
        },
        "kind-of-travel-business": {
          "content": "Noda oferă soluții de plată pentru industria de turism pentru toate tipurile și dimensiunile de companii, cu planuri scalabile disponibile pentru a sprijini creșterea afacerii dumneavoastră.",
          "title": "Cu ce tipuri de afaceri de turism lucrați?"
        },
        "needs": {
          "content": "Pentru a începe să utilizați Noda, completați formularul, iar echipa noastră de vânzări vă va contacta în scurt timp. Noda oferă o integrare ușoară cu îndrumarea unui manager dedicat pentru a vă asigura că sunteți sprijinit la fiecare pas.",
          "title": "Ce este nevoie de la mine pentru a începe?"
        },
        "subtitle": "RĂSPUNS LA ÎNTREBĂRILE DVS",
        "title": "FAQs"
      },
      "hero": {
        "text": "Îmbunătățiți afacerea dvs. de turism. Platforma noastră de plăți all-in-one prioritizează înțelegerea clienților, eficiența și creșterea",
        "title-1": "Plata pentru călătorie",
        "title-2": "Soluții cu Noda:",
        "title-gradient-1": "Plățile dvs",
        "title-gradient-2": "sunt prioritatea noastră"
      },
      "how-does-it-work": {
        "content": "Noda este un sistem mondial de plată a călătoriilor și un furnizor de servicii bancare deschise. De la gestionarea tranzacțiilor la analizele financiare, Noda vă acoperă. Platforma noastră utilizează tehnologii AI și de învățare automată de ultimă oră.\n\nOpen banking înseamnă că băncile tradiționale partajează date cu companii fintech licențiate, precum Noda, pentru a eficientiza tranzacțiile. Ecosistemul nostru de plăți conectează toate băncile importante din Regatul Unit și UE, facilitând servicii comerciale fără efort pentru agențiile de turism.",
        "subtitle": "Tehnologii",
        "title": "Cum funcționează"
      },
      "how-to-start": {
        "content": "Noda oferă o integrare ușoară cu îndrumarea personalizată a unui manager dedicat. Echipa noastră este aici pentru a vă ajuta cu orice blocaj. Pentru a începe să utilizați Noda, trebuie doar să completați formularul, iar reprezentanții noștri de vânzări vă vor contacta în scurt timp.",
        "subtitle": "Integrare ușoară",
        "title": "Cum să începeți"
      },
      "payments": {
        "text": "Experimentați eficiența tranzacțiilor instantanee, fondurile reflectându-se rapid în contul dvs. în câteva minute. API-urile noastre ușor de utilizat și simplificate vă aduc produsele pe piață fără efort",
        "title": "Set de instrumente pentru domeniul turismului"
      },
      "top-features": {
        "cards": {
          "ai": {
            "content": "Profitați de cunoștințele noastre bazate pe date. Instrumentele Noda oferă analize gata de utilizare ale comportamentului clienților, inclusiv algoritmi de segmentare și prognoză",
            "title": "Analize bazate pe inteligența artificială"
          },
          "banking": {
            "content": "Îmbunătățiți experiența clienților și ușurați fluxul de tranzacții cu puterea și securitatea plăților bancare deschise",
            "title": "Open Banking"
          },
          "global-currencies": {
            "content": "Noda lucrează cu o varietate de valute globale pentru a vă sprijini operațiunile de călătorie din întreaga lume",
            "title": "Monede globale"
          },
          "payment-processing": {
            "content": "Simplificați intrările și ieșirile de plată cu Noda. Folosiți UX intuitiv, rutare inteligentă și o varietate de metode de plată",
            "title": "Procesarea plăților\npentru industria de turism"
          },
          "scalable-plans": {
            "content": "Oferim soluții pentru industria de turism pentru companii de toate dimensiunile, cu planuri scalabile disponibile pentru a stimula creșterea afacerii dumneavoastră",
            "title": "Planuri scalabile"
          },
          "security": {
            "content": "Noda oferă gateway-uri de plată securizate pentru companiile de turism, asigurând conformitatea PCI DSS, criptarea și prevenirea fraudelor",
            "title": "Securitate"
          }
        },
        "subtitle": "OPEN BANKING & PLATILE",
        "title-1": "Caracteristici de top"
      }
    },
    "ux-approach": {
      "about-design": {
        "comments": {
          "business": {
            "name": "Valērijs Sičovs",
            "position": "Chief Business Development Officer",
            "text": "Noda este un important furnizor european de servicii bancare deschise, cu o bogată experiență în tehnologia de plată orientată către consumatori. Soluțiile noastre cu valoare adăugată schimbă cursul strategiilor de plată ale comercianților și putem fi cu toții de acord că popularitatea plăților de tip open banking în Europa este incontestabilă.<br/>Avem o soluție tehnologică de ultimă oră, dar cooperarea strânsă cu echipele de dezvoltare și design Noda ne permite să avem un impact și mai mare asupra modului în care comercianții pot beneficia de experiența noastră bine formată pentru utilizatori și de procesul de plată. Noda checkout, cu toată eleganța sa, face chiar și un lucru plictisitor din punct de vedere istoric, cum ar fi plățile, de ultimă oră."
          },
          "compliance": {
            "name": "Lāsma Gavarāne",
            "position": "Chief Compliance Officer",
            "text": "Un design bine construit în sine este ca o schiță a frumuseții care întâlnește funcționalitatea produsului. Abordarea designului Noda este grozavă pentru că nu se referă doar la modul în care arată lucrurile, ci mai degrabă la modul în care acestea funcționează perfect împreună. Este ca și cum ai avea o superputere care face totul fără efort și interesant, iar asta este exact ceea ce vrem să împărtășim cu lumea!"
          },
          "experience": {
            "name": "Max Gulewicz",
            "position": "Chief Experience Officer",
            "text": "La început, am crezut că un design grozav ajută la rezolvarea unor probleme specifice; apoi, că un design grozav trebuie, de asemenea, să se potrivească 100% nevoilor publicului țintă final; apoi, că trebuie, de asemenea, să avem în vedere KPI-urile de afaceri ale clienților noștri. Dar, după 25 de ani de proiectare intensivă, mi-am dat seama că, pentru a proiecta o experiență extraordinară, care să lase cel mai delicios gust, trebuie nu numai să iubești ceea ce faci, ci și să fii oarecum obsedat, poate chiar să sacrifici ceva pentru design, pentru fericirea altcuiva. Este incredibil de cool să te simți creator, dar și mai bine este să înțelegi și să vezi că eforturile tale nu sunt în zadar."
          },
          "hr": {
            "name": "Olga Ķerpe",
            "position": "HR Director",
            "text": "Personal, pentru mine, un design deosebit înseamnă estetică, atenție la detalii și inovație. Iar în designul Noda, avem toate acestea combinate perfect. Ne străduim foarte mult să urmăm mereu cele mai noi tendințe și să folosim cele mai noi instrumente și caracteristici. Aș mai spune că aceste caracteristici reflectă abordarea noastră generală, iar echipa noastră face tot posibilul pentru a o demonstra vizual lumii FinTech."
          },
          "project": {
            "name": "Egor Mahaniuk",
            "position": "Head of Project Management Office",
            "text": "Imaginați-vă asta: Noda este ca o mașină sport elegantă, proiectată să întoarcă privirile și să ofere o călătorie antrenantă prin peisajul digital. Experiența noastră de utilizare nu este doar intuitivă; este practic telepatică. Am sculptat o interfață într-un mod care o face accesibilă utilizatorilor de toate nivelurile de calificare. Dar așteptați, mai e ceva! Scalabilitatea și flexibilitatea sunt pâinea și untul nostru. Cu arhitectura noastră modulară, actualizările sunt la fel de rapide ca și apariția noilor tehnologii pe piață, asigurându-ne că suntem întotdeauna la vârful de lance, fără să transpirăm. UX-ul Noda nu este doar un alt design învechit; este o experiență care vă va face să spuneți: \"De ce nu poate fi totul atât de distractiv și ușor?"
          },
          "solutions": {
            "name": "Volodymyr Mykhailin",
            "position": "Chief Solutions Officer",
            "text": "Atunci când ne gândim la un design UX de înaltă calitate, este important ca acesta să fie orientat către consumator, garantând în același timp claritate, confort și eficiență. Noda recunoaște cu claritate acest principiu și îl introduce în mod activ în produsele sale. Utilizatorii nu întâmpină probleme de înțelegere a modului în care funcționează produsul; nu apar întrebări cu privire la ce trebuie să facă în continuare și de ce s-a întâmplat un eveniment. Produsele sunt concepute astfel încât să reducă la minimum barierele în calea interacțiunii dintre utilizatori și tehnologie. Atunci când utilizatorii nu pierd timp depășind obstacolele interfeței sau căutând informațiile necesare, satisfacția și loialitatea lor față de produs cresc. O astfel de abordare a proiectării nu numai că îmbunătățește experiența utilizatorului, dar sporește și avantajul competitiv al companiei în cadrul spațiului său de piață."
          }
        },
        "subtitle": "Membrii echipei despre design",
        "title": "Am rugat echipa noastră să împărtășească<br/> ce crede despre Noda Design "
      },
      "hero": {
        "subtitle": "Manifest de design",
        "text": "Suntem o echipă de designeri, creatori și cercetători experimentați care transformă Open Banking într-o modalitate simplă, fluidă și accesibilă de a face și primi plăți.",
        "title": "Clientul<br/>Experiență la Noda"
      },
      "principles": {
        "ecosystem": {
          "text": "Atât cumpărătorii, cât și comercianții trebuie să aibă încredere între ei și în sistem. Noi avem mijloacele de a îmbunătăți această încredere.",
          "title": "Ecosistem sigur"
        },
        "interaction": {
          "text": "Credem în crearea unei lumi în care plățile eronate sunt inexistente.",
          "title": "Interacțiune predispusă la erori"
        },
        "seconds": {
          "text": "Plățile sunt întotdeauna prea lente, iar noi suntem hotărâți să le facem mai rapide.",
          "title": "Secunde de bărbierit"
        },
        "solutions": {
          "text": "Industria plăților are tendința de a fi plictisitoare și, în general, goală. Noi sperăm să schimbăm asta.",
          "title": "Soluții Elegante"
        },
        "subtitle": "Subsol de design",
        "title": "Principiile noastre"
      },
      "what-we-do": {
        "subtitle": "Și în cele din urmă",
        "text-1": "Concepem și dezvoltăm un întreg set de instrumente, procese și convenții care vor alimenta următoarea generație de plăți.",
        "text-2": "Utilizând procese agile și axate pe cercetare - în timp ce folosim pe deplin experiența noastră profundă în domeniul comerțului electronic și al plăților, construim instrumente pentru comercianți care elimină fricțiunea din plăți.",
        "title": "Ce Facem"
      }
    },
    "wargaming": {
      "subtitle": "Citiți un studiu de caz",
      "text": "În februarie 2023, Wargaming, un editor de jocuri pe platforme multiple de top, a colaborat cu Noda pentru a lansa plăți instantanee prin open banking pentru jocurile lor. Această colaborare a oferit jucătorilor Wargaming o varietate de metode de plată online, inclusiv tranzacții de la cont-la-cont (A2A) susținute de infrastructura open banking.",
      "title": "Modul în care Wargaming utilizează Noda pentru experiențe de plată mai bune"
    },
    "white-label": {
      "boost": {
        "tag-title": "STIMULEAZĂ-ȚI AFACEREA CU NODA",
        "text": "Centrul nostru de administrare oferă urmărirea completă a tuturor comisioanelor, asigurând o raportare transparentă. Monitorizați cu ușurință plățile și încasările, atât pentru comercianți, cât și pentru dvs. Preia controlul cu vizibilitate completă și gestionează-ți afacerea fără efort.",
        "title": "Urmărire și raportare cuprinzătoare"
      },
      "hero": {
        "button": "Începe",
        "tag-title": "PLĂȚI MAI BUNE",
        "text": "Profitați de platforma noastră tehnologică în calitate de partener white-label. Integrați fără probleme tranzacțiile bancare deschise, obțineți analize acționabile și exploatați UX-ul nostru intuitiv. Oferim integrare prin API-uri, raportare transparentă și personalizarea mărcii.",
        "title": "Creșteți-vă afacerea cu Noda"
      },
      "how-it-works": {
        "a-way-to-keep": "O modalitate de a menține șirurile de cheltuieli pentru jucătorii care utilizează bănci lente (fără Instant SEPA)",
        "accept-payments": "Acceptați plăți prin link-uri sau coduri QR care pot fi partajate pe diferite canale",
        "actionable": "Analize acționabile",
        "actionable-analytics-from": "Analize acționabile din istoricul tranzacțiilor și date suplimentare furnizate chiar de bănci",
        "ar": "AR peste 90%",
        "buffet": "Bufet",
        "checkout": "Casă",
        "dedicated": "Conturi dedicate și separate pentru o claritate sporită",
        "easily-pay": "Plătiți cu ușurință și primiți plata cu tehnologia noastră avansată și rutarea inteligentă",
        "effortless": "Experiență de plată fără efort și rafinată pentru întreprinderi de toate tipurile și dimensiunile",
        "expansive": "Acoperire extinsă cu 2000+ de bănci în 28 de țări",
        "great": "Acoperire excelentă",
        "instead-of-long": "În locul formularelor lungi de completat, utilizatorii plătesc depozitul inițial și sunt înregistrați instantaneu",
        "intuitive": "Interfață intuitivă și funcții extinse de plată",
        "know": "Îmbogățirea datelor",
        "pay": "Plătiți și plecați",
        "pay-by-link-qr": "Plata prin link și QR",
        "payins": "Plăți și plăți",
        "payment": "Rata de acceptare a plăților aproape de 100%, asigurând că tranzacțiile dvs. sunt întotdeauna aprobate",
        "provides-players": "Oferă jucătorilor opțiunea de a plăti prin bancă, stimulând conversia",
        "round-the-clock": "Suport non-stop, suntem aici pentru a vă asista oricând aveți nevoie",
        "segregated-accounts": "Conturi segregate",
        "simple-payment-process": "Proces simplu de plată",
        "support": "Asistență 24/7",
        "tag-title": "Cum funcționează",
        "title": "Integrați tehnologia noastră",
        "trusted-payments": "Plăți de încredere",
        "valuable": "Informații valoroase din comportamentul financiar al clienților pentru a lua decizii în cunoștință de cauză"
      },
      "open-banking": {
        "tag-title": "PUTEREA OPEN BANKING",
        "text-1": "Înainte de open banking, băncile tradiționale controlau datele clienților. Regulamentul european PSD2, pus în aplicare în 2018, a schimbat acest lucru, cerând băncilor să partajeze date cu furnizori terți licențiați, precum Noda, cu consimțământul clienților.",
        "text-2": "Serviciile bancare deschise utilizează interfețe de programare a aplicațiilor (API), care acționează ca o punte software. Atunci când un utilizator selectează open banking, acesta este transferat la interfața sa bancară online de încredere. Acest lucru împiedică, de asemenea, infractorii cibernetici să le fure datele.",
        "text-3": "Tot mai mulți consumatori și comercianți din întreaga lume aleg această tehnologie emergentă. ",
        "text-4": " preconizează că valoarea totală a tranzacțiilor bancare deschise va crește de la 57 de miliarde de dolari în 2023 la 330 de miliarde de dolari până în 2027. Plățile bancare deschise nu mai sunt inovatoare; ele devin noua normă.",
        "text-link": "Juniper Research",
        "title": "Adopția Open Banking este în plină expansiune"
      },
      "tailored-interface": {
        "tag-title": "INTERFAȚĂ PERSONALIZATĂ",
        "text": "Folosiți instrumentele noastre de personalizare încorporate pentru a vă personaliza interfețele utilizator (UI) sau creați propriul front-end pentru a controla complet designul. Cu platforma noastră, alegerea vă aparține pentru a personaliza experiența perfectă.",
        "title": "Personalizat pentru marca dvs"
      }
    },
    "why-open-banking": {
      "benefits": {
        "section-1": {
          "cards": {
            "card-1": {
              "description": "Înainte de <a class=\"link underline\" href=\"/articles/what-is-open-banking-your-ultimate-guide\">open banking</a>, băncile tradiționale dețineau monopolul asupra datelor clienților. Totuși, regulamentul european PSD2 a apărut pentru a schimba acest lucru. Intrată în vigoare în 2018, aceasta a obligat băncile să partajeze date cu furnizori terțiari licențiați. Acest lucru se întâmplă strict cu consimțământul clientului. Schimbul de date a încurajat inovarea în domeniul plăților, făcându-le mai rapide, mai fluide și mai sigure.",
              "title": "O nouă eră a plăților"
            },
            "card-2": {
              "description": "Juniper Research preconizează că valoarea totală a tranzacțiilor OB va <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.juniperresearch.com/research/fintech-payments/banking/open-banking-market-research-report/\">ajunge la 330 de miliarde de dolari până în 2027</a>. Aceasta este o creștere de la 57 de miliarde de dolari în 2023, o creștere totală de 479%.",
              "title": "Serviciu cu creștere rapidă"
            },
            "card-3": {
              "description": "Consumatorii apreciază inovarea și fluxurile de plăți superioare. Datorită vitezei și simplității sale, sistemul bancar deschis devine alegerea preferată pentru mulți.",
              "title": "Mai inovatoare"
            }
          },
          "title": "Este nou și în creștere rapidă"
        },
        "section-2": {
          "cards": {
            "card-1": {
              "description": "Serviciile bancare deschise oferă comisioane de tranzacționare mai mici decât plățile tradiționale cu cardul. Plățile se efectuează de <a class=\"link underline\" href=\"/glossary/a2a-payments\">la cont la cont</a>.",
              "title": "Taxe mai mici"
            },
            "card-2": {
              "description": "API-urile bancare deschise elimină comisioanele de plată și majoritatea costurilor operaționale.",
              "title": "Costuri și taxe reduse"
            },
            "card-3": {
              "description": "Din nou, din moment ce nu sunt implicate rețele de carduri, plățile prin bancă deschisă elimină returnările. Comercianții își pot lua adio de la acele taxe de procesare mari.",
              "title": "Fără rambursare"
            },
            "card-4": {
              "description": "Toți comercianții beneficiază de prețuri uniforme. Singura modificare posibilă este o scădere ca răspuns la presiunile concurenței.",
              "title": "Costuri pentru comercianți"
            }
          },
          "title": "Este foarte profitabil"
        },
        "section-3": {
          "cards": {
            "card-1": {
              "description": "Timpii de decontare sunt mai rapizi, banii apărând în contul comerciantului aproape instantaneu. Acest lucru vă poate ajuta să vă gestionați mai bine fluxul de numerar și contabilitatea. Consumatorii pot plăti rapid, fără timpi lungi de procesare. Având în vedere că timpii de decontare sunt mai scurți, aceștia își pot face bugetul mai eficient.",
              "title": "Plăți mai rapide"
            },
            "card-2": {
              "description": "Soluțiile bancare deschise pot consolida datele într-o singură platformă. De la informații despre clienți la soluții de verificare, acestea oferă diverse instrumente de afaceri.",
              "title": "Eficiență"
            },
            "card-3": {
              "description": "Consumatorii plătesc din interfața lor bancară securizată, fără a fi nevoiți să introducă manual detaliile cardului. Acest lucru le economisește efort și timp, ducând la o călătorie îmbunătățită a clientului.",
              "title": "Experiență mai bună pentru utilizatori "
            },
            "card-4": {
              "description": "Serviciile bancare deschise simplifică <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">experiența utilizatorului (UX)</a> în ceea ce privește plățile, eliminând fricțiunile precum introducerea manuală a detaliilor cardului din proces, ceea ce duce la conversii mai mari.",
              "inserted-content": {
                "subtext": "*Bazat pe datele de tranzacție ale utilizatorilor care se întorc, preluate de pe platforma Noda în ianuarie 2024",
                "table": {
                  "tbody-1": {
                    "header": {
                      "col-1": "Germania",
                      "col-2": "Până la 89%"
                    }
                  },
                  "tbody-2": {
                    "header": {
                      "col-1": "Marea Britanie",
                      "col-2": "Până la 92%"
                    }
                  },
                  "tbody-3": {
                    "header": {
                      "col-1": "Olanda",
                      "col-2": "Până la 92%"
                    }
                  },
                  "thead": {
                    "col-1": "Instituție financiară",
                    "col-2": "Rata de acceptare, %"
                  }
                },
                "title": "Rata de acceptare a tranzacțiilor bancare deschise de către utilizatorii care revin"
              },
              "show-more-btn": "Arată statisticile",
              "title": "Rate de conversie mai mari"
            },
            "card-5": {
              "description": "Datele bancare deschise pot fi utilizate pentru a analiza obiceiurile și comportamentul financiar al clienților. Pe baza acestor informații, comercianții pot oferi experiențe mai personalizate.",
              "title": "Personalizare"
            }
          },
          "title": "Rapid și eficient"
        },
        "section-4": {
          "cards": {
            "card-1": {
              "description": "Schimbul de date poate avea loc numai cu <a class=\"link underline\" href=\"/articles/open-banking-flow\">acordul explicit al clientului</a>. Dacă consumatorii decid să nu își mai partajeze datele, pot renunța oricând la serviciile bancare deschise.",
              "title": "Controlul datelor financiare"
            },
            "card-2": {
              "description": "Soluțiile de date bancare deschise oferă o verificare instantanee a identității, a surselor de avere și a altor elemente, ceea ce vă poate ajuta în integrarea rapidă a noilor clienți.",
              "title": "Onboarding și KYC"
            },
            "card-3": {
              "description": "Serviciile bancare deschise se bazează pe <a class=\"link underline\" href=\"/glossary/api\">API-uri securizate</a>. Autorizarea plăților are loc la banca de încredere a clientului. În plus, activitatea bancară deschisă este pe deplin reglementată în cadrul directivei <a class=\"link underline\" href=\"/glossary/european-psd2\">europene PSD2</a>, autentificarea puternică a clienților (SCA) fiind o cerință legală.",
              "title": "Securitate mai bună"
            }
          },
          "title": "Este 100% sigur"
        }
      },
      "hero": {
        "subtitle": "Cea mai bună decizie",
        "text": "Oferirea de servicii bancare deschise ca metodă de plată nu mai este o noutate. A nu face acest lucru vă poate costa clienți valoroși. Dacă încă nu sunteți sigur, citiți mai jos despre beneficiile serviciilor bancare deschise.",
        "title": "De ce Open Banking?"
      },
      "myths": {
        "description": "Ca orice tehnologie nouă, sistemul bancar deschis este adesea înțeles greșit. Aceste concepții greșite pot determina comercianții să evite plățile prin open banking din cauza lipsei de cunoștințe.\n\nAici, desființăm miturile comune.",
        "myth-10": {
          "content": "După cum s-a menționat anterior, clienții preferă din ce în ce mai mult open banking în detrimentul altor metode de plată. <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.statista.com/statistics/1228771/open-banking-users-worldwide/\">Statista</a> a estimat că, până la sfârșitul anului 2024, numărul de utilizatori de servicii bancare deschise la nivel mondial va ajunge la 132 de milioane. Adoptarea rapidă a băncilor deschise este un semn clar al încrederii consumatorilor. Plățile OB oferă un UX mai bun și mai intuitiv, iar consumatorii apreciază fluxul de plăți superior.",
          "title": "Mitul 10. Clienții nu sunt obișnuiți cu fluxul de plăți Open Banking"
        },
        "myth-1": {
          "content": "Există o neînțelegere frecventă a cuvântului \"deschis\" în conceptul de bancă deschisă. Open banking nu înseamnă că băncile partajează în mod deschis datele clienților cu oricine dorește să le acceseze. De fapt, furnizorii terți trebuie să treacă printr-o procedură riguroasă de <a class=\"link underline\" href=\"/articles/what-are-aisp-and-pisp-in-open-banking\">acordare a licențelor</a> de reglementare cu autoritățile naționale de reglementare dacă doresc să pună în aplicare serviciile bancare deschise. De exemplu, în cadrul directivei europene PSD2, furnizorii trebuie să obțină o licență AISP sau PISP pentru a accesa informațiile despre clienți.",
          "title": "Mitul 1. Open Banking înseamnă că totul este \"deschis\""
        },
        "myth-2": {
          "content": "Serviciile bancare deschise sunt activate prin API-uri securizate partajate de bănci cu furnizori terți licențiați. Atunci când un client alege o plată de tip open banking, acesta este transferat automat la interfața sa bancară de încredere, unde plata este autorizată. Această redirecționare API de la aplicație la aplicație îi împiedică pe infractorii cibernetici să le fure datele, mai ales în comparație cu practici precum screen scrapping. În plus, în conformitate cu PSD2, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://finance.ec.europa.eu/publications/strong-customer-authentication-requirement-psd2-comes-force_en\">autentificarea puternică a clientului (SCA)</a> este o cerință legală pentru plățile de tip open banking. SCA este o măsură de autentificare multifactorială menită să prevină frauda prin impostură. ",
          "title": "Mitul 2. Open Banking nu este sigur"
        },
        "myth-3": {
          "content": "Unii clienți pot presupune în mod eronat că, atunci când își dau acordul pentru partajarea datelor, întreaga lume va putea vedea ce se întâmplă cu finanțele lor. Acest lucru pur și simplu nu este adevărat. Numai furnizorii terți autorizați pot accesa datele clienților. Pentru a obține o astfel de licență, furnizorii trebuie să o obțină prin intermediul unei autorități naționale de reglementare, cum ar fi <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.fca.org.uk/consumers/account-information-payment-initiation-services\">FCA în Regatul Unit</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.bafin.de/EN/Aufsicht/ZahlungsdienstePSD2/ZulassungspflichtigeZahlungsdienste/ZulassungspflichtigeZahlungsdienste_node_en.html\">BaFin în Germania</a>, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://acpr.banque-france.fr/en/authorisation/banking-industry-procedures/licensing-authorisation-and-registration/payment-institution-and-account-information-service-provider\">ACPR în Franța</a> și alte autorități relevante din țara în cauză, pentru a se asigura că furnizorii respectă normele și gestionează corect datele. În plus, clienții își pot retrage consimțământul oricând. ",
          "title": "Mitul 3. Înțelegerea greșită a partajării datelor"
        },
        "myth-4": {
          "content": "Există o concepție greșită conform căreia plățile prin sistemul bancar deschis funcționează numai pentru conturile deschise la marile bănci. În realitate, ecosistemul bancar deschis este mare și include și multe instituții financiare mai mici. Conform <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbankingtracker.com/\">Open Banking Tracker</a>, există 4.394 de bănci conectate în 73 de țări. La Noda, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://coda.io/d/Noda-Supported-banks_dIVjZri07ne\">ne conectăm la peste 2000+ de bănci</a> din Regatul Unit și UE.",
          "title": "Mitul 4. Open Banking nu sprijină băncile mai mici"
        },
        "myth-5": {
          "content": "Unii comercianți pot presupune că opțiunea \"plată prin bancă\" poate descuraja consumatorii care preferă să plătească cu cardul. De fapt, plățile OB sunt mult mai simple și mai sigure, deoarece clienții nu trebuie să își introducă manual datele cardului. Banii sunt transferați din același cont bancar care este legat de un card, însă transferul ocolește rețeaua de carduri, ceea ce duce la o procesare mai rapidă și comisioane mai mici. Acesta este motivul pentru care clienții preferă din ce în ce mai mult serviciile bancare deschise în detrimentul cardurilor. În Regatul Unit, de exemplu, <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.openbanking.org.uk/news/open-banking-impact-report-october-2023/\">11% dintre consumatori</a> sunt utilizatori activi ai acestei metode de plată. ",
          "title": "Mitul 5. Clienții care plătesc cu cardul vor fi descurajați de Open Banking"
        },
        "myth-6": {
          "content": "Conversiile sunt parametrii cheie pentru plăți. Prin urmare, este important ca acestea să fie corecte. Există un mit conform căruia plățile cu cardul conduc la tranzacții mai reușite decât plățile prin sistemul bancar deschis. În realitate, <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">UX-ul pentru open banking este mult mai simplu</a>. Utilizatorii sunt redirecționați către interfața băncii lor, iar banii sunt transferați direct din contul lor bancar. Acest lucru previne riscul introducerii eronate a detaliilor cardului și scutește clienții de timp și efort, ceea ce duce la conversii mai mari.",
          "title": "Mitul 6. Conversia plăților cu cardul este mai mare decât cea a serviciilor bancare deschise"
        },
        "myth-7": {
          "content": "Din nou, aceasta este o concepție greșită. După cum s-a menționat mai sus, plățile prin sistemul bancar deschis nu necesită introducerea manuală a informațiilor. Clienții sunt redirecționați <a class=\"link underline\" href=\"/articles/open-banking-user-experience\">către interfața lor bancară</a>, unde plățile sunt autorizate. Autentificarea poate implica introducerea unui cod de acces, o verificare biometrică, cum ar fi scanarea amprentei digitale sau identificarea facială, și un cod trimis pe dispozitivul lor. Această procedură este mult mai ușoară și consumă mai puțin timp decât introducerea detaliilor lungi ale cardului.",
          "title": "Mitul 7. Plățile Open Banking necesită mai multe detalii de plată"
        },
        "myth-8": {
          "content": "Unii comercianți ar putea crede că, chiar dacă un client își găsește banca în listă, integrarea va fi plină de fricțiuni, iar tranzacția va eșua în cele din urmă. Vă putem asigura că integrarea API-urilor bancare deschise este fără probleme, deoarece aceste <a class=\"link underline\" target=\"_blank\" rel=\"nofollow\" href=\"https://www.stet.eu/en/psd2/\">API-uri sunt standardizate</a> în toate țările și băncile PSD2. Vedeți cum funcționează pentru dvs. cu <a class=\"link underline\" rel=\"nofollow\" target=\"_blank\" href=\"https://noda.live/demo\">demonstrația Noda</a> a unei tranzacții bancare deschise.",
          "title": "Mitul 8. Integrarea cu banca clientului va eșua"
        },
        "myth-9": {
          "content": "Unii comercianți ar putea crede că procesarea plăților prin open banking este mai lentă. În realitate, plățile efectuate prin carduri implică intermediari care necesită un timp de procesare mai lung. Plățile prin sistemul bancar deschis se efectuează de <a class=\"link underline\" href=\"/glossary/a2a-payments\">la cont la cont</a>, astfel încât nu sunt implicate rețelele de carduri. Prin urmare, plățile sunt mult mai rapide.",
          "title": "Mitul 9. Plățile Open Banking durează mai mult"
        },
        "title": "Mituri comune\n\ndespre Open Banking"
      }
    }
  }
} as const;